/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 156);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(7);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(22);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMProperty = __webpack_require__(24);
var ReactDOMComponentFlags = __webpack_require__(98);

var invariant = __webpack_require__(0);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Q; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getClusterBySchool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return googleMapStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return processGeoJSON; });
/* unused harmony export googleMiniMapStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
var Q=__WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(window.location.search);function getClusterBySchool(id,data){return data.clusters.find(function(obj){return obj.schools.find(function(obj){return parseInt(obj.uid,10)===parseInt(id,10);});});}function getCluster(id,data){return data.clusters.find(function(obj){return parseInt(obj.uid,10)===parseInt(id,10);});}var format=function format(number,decimals){decimals=typeof decimals!=='undefined'?decimals:2;if(number==='NA'||typeof number==='undefined'||isNaN(number)){return'-';}var f=void 0;if(number%1===0||decimals===0){f=Object(__WEBPACK_IMPORTED_MODULE_0_d3__["format"])(',d');}else{f=Object(__WEBPACK_IMPORTED_MODULE_0_d3__["format"])(',.'+decimals+'f');}return f(number);};function processGeoJSON(geometry,callback,thisArg){if(geometry instanceof window.google.maps.LatLng){callback.call(thisArg,geometry);}else if(geometry instanceof window.google.maps.Data.Point){callback.call(thisArg,geometry.get());}else{geometry.getArray().forEach(function(g){processGeoJSON(g,callback,thisArg);});}}var googleMapStyles=[{featureType:'water',elementType:'geometry',stylers:[{color:'#e9e9e9'},{lightness:17}]},{featureType:'landscape',elementType:'geometry',stylers:[{color:'#f5f5f5'},{lightness:20}]},{featureType:'road.highway',elementType:'geometry.fill',stylers:[{color:'#ffffff'},{lightness:17}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#ffffff'},{lightness:29},{weight:0.2}]},{featureType:'road.arterial',elementType:'geometry',stylers:[{color:'#ffffff'},{lightness:18}]},{featureType:'road.local',elementType:'geometry',stylers:[{color:'#ffffff'},{lightness:16}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#f5f5f5'},{lightness:21}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#dedede'},{lightness:21}]},{elementType:'labels.text.stroke',stylers:[{visibility:'on'},{color:'#ffffff'},{lightness:16}]},{elementType:'labels.text.fill',stylers:[{saturation:36},{color:'#333333'},{lightness:40}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{featureType:'transit',elementType:'geometry',stylers:[{color:'#f2f2f2'},{lightness:19}]},{featureType:'administrative',elementType:'geometry.fill',stylers:[{color:'#fefefe'},{lightness:20}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#fefefe'},{lightness:17},{weight:1.2}]}];var googleMiniMapStyles=[{featureType:'all',elementType:'all',stylers:[{visibility:'off'}]}];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// https://d3js.org Version 4.9.1. Copyright 2017 Mike Bostock.
(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
}(this, (function (exports) { 'use strict';

var version = "4.9.1";

var ascending = function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
};

var bisector = function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
};

function ascendingComparator(f) {
  return function(d, x) {
    return ascending(f(d), x);
  };
}

var ascendingBisect = bisector(ascending);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;

var pairs = function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
};

function pair(a, b) {
  return [a, b];
}

var cross = function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = pair;

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
};

var descending = function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
};

var number = function(x) {
  return x === null ? NaN : +x;
};

var variance = function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
};

var deviation = function(array, f) {
  var v = variance(array, f);
  return v ? Math.sqrt(v) : v;
};

var extent = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
};

var array = Array.prototype;

var slice = array.slice;
var map = array.map;

var constant = function(x) {
  return function() {
    return x;
  };
};

var identity = function(x) {
  return x;
};

var sequence = function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
};

var e10 = Math.sqrt(50);
var e5 = Math.sqrt(10);
var e2 = Math.sqrt(2);

var ticks = function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
};

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

var sturges = function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
};

var histogram = function() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = tickStep(x0, x1, tz);
      tz = sequence(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisectRight(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
};

var threshold = function(values, p, valueof) {
  if (valueof == null) valueof = number;
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
};

var freedmanDiaconis = function(values, min, max) {
  values = map.call(values, number).sort(ascending);
  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
};

var scott = function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
};

var max = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
};

var mean = function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
};

var median = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = number(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = number(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return threshold(numbers.sort(ascending), 0.5);
};

var merge = function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
};

var min = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
};

var permute = function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
};

var scan = function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = ascending;

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
};

var shuffle = function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
};

var sum = function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
};

var transpose = function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
};

function length(d) {
  return d.length;
}

var zip = function() {
  return transpose(arguments);
};

var slice$1 = Array.prototype.slice;

var identity$1 = function(x) {
  return x;
};

var top = 1;
var right = 2;
var bottom = 3;
var left = 4;
var epsilon = 1e-6;

function translateX(x) {
  return "translate(" + (x + 0.5) + ",0)";
}

function translateY(y) {
  return "translate(0," + (y + 0.5) + ")";
}

function center(scale) {
  var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
  if (scale.round()) offset = Math.round(offset);
  return function(d) {
    return scale(d) + offset;
  };
}

function entering() {
  return !this.__axis;
}

function axis(orient, scale) {
  var tickArguments = [],
      tickValues = null,
      tickFormat = null,
      tickSizeInner = 6,
      tickSizeOuter = 6,
      tickPadding = 3,
      k = orient === top || orient === left ? -1 : 1,
      x = orient === left || orient === right ? "x" : "y",
      transform = orient === top || orient === bottom ? translateX : translateY;

  function axis(context) {
    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$1) : tickFormat,
        spacing = Math.max(tickSizeInner, 0) + tickPadding,
        range = scale.range(),
        range0 = range[0] + 0.5,
        range1 = range[range.length - 1] + 0.5,
        position = (scale.bandwidth ? center : identity$1)(scale.copy()),
        selection = context.selection ? context.selection() : context,
        path = selection.selectAll(".domain").data([null]),
        tick = selection.selectAll(".tick").data(values, scale).order(),
        tickExit = tick.exit(),
        tickEnter = tick.enter().append("g").attr("class", "tick"),
        line = tick.select("line"),
        text = tick.select("text");

    path = path.merge(path.enter().insert("path", ".tick")
        .attr("class", "domain")
        .attr("stroke", "#000"));

    tick = tick.merge(tickEnter);

    line = line.merge(tickEnter.append("line")
        .attr("stroke", "#000")
        .attr(x + "2", k * tickSizeInner));

    text = text.merge(tickEnter.append("text")
        .attr("fill", "#000")
        .attr(x, k * spacing)
        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));

    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line = line.transition(context);
      text = text.transition(context);

      tickExit = tickExit.transition(context)
          .attr("opacity", epsilon)
          .attr("transform", function(d) { return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform"); });

      tickEnter
          .attr("opacity", epsilon)
          .attr("transform", function(d) { var p = this.parentNode.__axis; return transform(p && isFinite(p = p(d)) ? p : position(d)); });
    }

    tickExit.remove();

    path
        .attr("d", orient === left || orient == right
            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);

    tick
        .attr("opacity", 1)
        .attr("transform", function(d) { return transform(position(d)); });

    line
        .attr(x + "2", k * tickSizeInner);

    text
        .attr(x, k * spacing)
        .text(format);

    selection.filter(entering)
        .attr("fill", "none")
        .attr("font-size", 10)
        .attr("font-family", "sans-serif")
        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");

    selection
        .each(function() { this.__axis = position; });
  }

  axis.scale = function(_) {
    return arguments.length ? (scale = _, axis) : scale;
  };

  axis.ticks = function() {
    return tickArguments = slice$1.call(arguments), axis;
  };

  axis.tickArguments = function(_) {
    return arguments.length ? (tickArguments = _ == null ? [] : slice$1.call(_), axis) : tickArguments.slice();
  };

  axis.tickValues = function(_) {
    return arguments.length ? (tickValues = _ == null ? null : slice$1.call(_), axis) : tickValues && tickValues.slice();
  };

  axis.tickFormat = function(_) {
    return arguments.length ? (tickFormat = _, axis) : tickFormat;
  };

  axis.tickSize = function(_) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
  };

  axis.tickSizeInner = function(_) {
    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
  };

  axis.tickSizeOuter = function(_) {
    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
  };

  axis.tickPadding = function(_) {
    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
  };

  return axis;
}

function axisTop(scale) {
  return axis(top, scale);
}

function axisRight(scale) {
  return axis(right, scale);
}

function axisBottom(scale) {
  return axis(bottom, scale);
}

function axisLeft(scale) {
  return axis(left, scale);
}

var noop = {value: function() {}};

function dispatch() {
  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
    _[t] = [];
  }
  return new Dispatch(_);
}

function Dispatch(_) {
  this._ = _;
}

function parseTypenames(typenames, types) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    return {type: t, name: name};
  });
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function(typename, callback) {
    var _ = this._,
        T = parseTypenames(typename + "", _),
        t,
        i = -1,
        n = T.length;

    // If no callback was specified, return the callback of the given type and name.
    if (arguments.length < 2) {
      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
      return;
    }

    // If a type was specified, set the callback for the given type and name.
    // Otherwise, if a null callback was specified, remove callbacks of the given name.
    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
    while (++i < n) {
      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
    }

    return this;
  },
  copy: function() {
    var copy = {}, _ = this._;
    for (var t in _) copy[t] = _[t].slice();
    return new Dispatch(copy);
  },
  call: function(type, that) {
    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  },
  apply: function(type, that, args) {
    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
  }
};

function get(type, name) {
  for (var i = 0, n = type.length, c; i < n; ++i) {
    if ((c = type[i]).name === name) {
      return c.value;
    }
  }
}

function set(type, name, callback) {
  for (var i = 0, n = type.length; i < n; ++i) {
    if (type[i].name === name) {
      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
      break;
    }
  }
  if (callback != null) type.push({name: name, value: callback});
  return type;
}

var xhtml = "http://www.w3.org/1999/xhtml";

var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

var namespace = function(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
};

function creatorInherit(name) {
  return function() {
    var document = this.ownerDocument,
        uri = this.namespaceURI;
    return uri === xhtml && document.documentElement.namespaceURI === xhtml
        ? document.createElement(name)
        : document.createElementNS(uri, name);
  };
}

function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}

var creator = function(name) {
  var fullname = namespace(name);
  return (fullname.local
      ? creatorFixed
      : creatorInherit)(fullname);
};

var nextId = 0;

function local$1() {
  return new Local;
}

function Local() {
  this._ = "@" + (++nextId).toString(36);
}

Local.prototype = local$1.prototype = {
  constructor: Local,
  get: function(node) {
    var id = this._;
    while (!(id in node)) if (!(node = node.parentNode)) return;
    return node[id];
  },
  set: function(node, value) {
    return node[this._] = value;
  },
  remove: function(node) {
    return this._ in node && delete node[this._];
  },
  toString: function() {
    return this._;
  }
};

var matcher = function(selector) {
  return function() {
    return this.matches(selector);
  };
};

if (typeof document !== "undefined") {
  var element = document.documentElement;
  if (!element.matches) {
    var vendorMatches = element.webkitMatchesSelector
        || element.msMatchesSelector
        || element.mozMatchesSelector
        || element.oMatchesSelector;
    matcher = function(selector) {
      return function() {
        return vendorMatches.call(this, selector);
      };
    };
  }
}

var matcher$1 = matcher;

var filterEvents = {};

exports.event = null;

if (typeof document !== "undefined") {
  var element$1 = document.documentElement;
  if (!("onmouseenter" in element$1)) {
    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
  }
}

function filterContextListener(listener, index, group) {
  listener = contextListener(listener, index, group);
  return function(event) {
    var related = event.relatedTarget;
    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
      listener.call(this, event);
    }
  };
}

function contextListener(listener, index, group) {
  return function(event1) {
    var event0 = exports.event; // Events can be reentrant (e.g., focus).
    exports.event = event1;
    try {
      listener.call(this, this.__data__, index, group);
    } finally {
      exports.event = event0;
    }
  };
}

function parseTypenames$1(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return {type: t, name: name};
  });
}

function onRemove(typename) {
  return function() {
    var on = this.__on;
    if (!on) return;
    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
      } else {
        on[++i] = o;
      }
    }
    if (++i) on.length = i;
    else delete this.__on;
  };
}

function onAdd(typename, value, capture) {
  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
  return function(d, i, group) {
    var on = this.__on, o, listener = wrap(value, i, group);
    if (on) for (var j = 0, m = on.length; j < m; ++j) {
      if ((o = on[j]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.capture);
        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, capture);
    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
    if (!on) this.__on = [o];
    else on.push(o);
  };
}

var selection_on = function(typename, value, capture) {
  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;

  if (arguments.length < 2) {
    var on = this.node().__on;
    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
      for (i = 0, o = on[j]; i < n; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }

  on = value ? onAdd : onRemove;
  if (capture == null) capture = false;
  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
  return this;
};

function customEvent(event1, listener, that, args) {
  var event0 = exports.event;
  event1.sourceEvent = exports.event;
  exports.event = event1;
  try {
    return listener.apply(that, args);
  } finally {
    exports.event = event0;
  }
}

var sourceEvent = function() {
  var current = exports.event, source;
  while (source = current.sourceEvent) current = source;
  return current;
};

var point = function(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint) {
    var point = svg.createSVGPoint();
    point.x = event.clientX, point.y = event.clientY;
    point = point.matrixTransform(node.getScreenCTM().inverse());
    return [point.x, point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
};

var mouse = function(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
};

function none() {}

var selector = function(selector) {
  return selector == null ? none : function() {
    return this.querySelector(selector);
  };
};

var selection_select = function(select) {
  if (typeof select !== "function") select = selector(select);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }

  return new Selection(subgroups, this._parents);
};

function empty$1() {
  return [];
}

var selectorAll = function(selector) {
  return selector == null ? empty$1 : function() {
    return this.querySelectorAll(selector);
  };
};

var selection_selectAll = function(select) {
  if (typeof select !== "function") select = selectorAll(select);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        subgroups.push(select.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }

  return new Selection(subgroups, parents);
};

var selection_filter = function(match) {
  if (typeof match !== "function") match = matcher$1(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Selection(subgroups, this._parents);
};

var sparse = function(update) {
  return new Array(update.length);
};

var selection_enter = function() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
};

function EnterNode(parent, datum) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum;
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
  querySelector: function(selector) { return this._parent.querySelector(selector); },
  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
};

var constant$1 = function(x) {
  return function() {
    return x;
  };
};

var keyPrefix = "$"; // Protect against keys like “__proto__”.

function bindIndex(parent, group, enter, update, exit, data) {
  var i = 0,
      node,
      groupLength = group.length,
      dataLength = data.length;

  // Put any non-null nodes that fit into update.
  // Put any null nodes into enter.
  // Put any remaining data into enter.
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Put any non-null nodes that don’t fit into exit.
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}

function bindKey(parent, group, enter, update, exit, data, key) {
  var i,
      node,
      nodeByKeyValue = {},
      groupLength = group.length,
      dataLength = data.length,
      keyValues = new Array(groupLength),
      keyValue;

  // Compute the key for each node.
  // If multiple nodes have the same key, the duplicates are added to exit.
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
      if (keyValue in nodeByKeyValue) {
        exit[i] = node;
      } else {
        nodeByKeyValue[keyValue] = node;
      }
    }
  }

  // Compute the key for each datum.
  // If there a node associated with this key, join and add it to update.
  // If there is not (or the key is a duplicate), add it to enter.
  for (i = 0; i < dataLength; ++i) {
    keyValue = keyPrefix + key.call(parent, data[i], i, data);
    if (node = nodeByKeyValue[keyValue]) {
      update[i] = node;
      node.__data__ = data[i];
      nodeByKeyValue[keyValue] = null;
    } else {
      enter[i] = new EnterNode(parent, data[i]);
    }
  }

  // Add any remaining nodes that were not bound to data to exit.
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
      exit[i] = node;
    }
  }
}

var selection_data = function(value, key) {
  if (!value) {
    data = new Array(this.size()), j = -1;
    this.each(function(d) { data[++j] = d; });
    return data;
  }

  var bind = key ? bindKey : bindIndex,
      parents = this._parents,
      groups = this._groups;

  if (typeof value !== "function") value = constant$1(value);

  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
    var parent = parents[j],
        group = groups[j],
        groupLength = group.length,
        data = value.call(parent, parent && parent.__data__, j, parents),
        dataLength = data.length,
        enterGroup = enter[j] = new Array(dataLength),
        updateGroup = update[j] = new Array(dataLength),
        exitGroup = exit[j] = new Array(groupLength);

    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);

    // Now connect the enter nodes to their following update node, such that
    // appendChild can insert the materialized enter node before this node,
    // rather than at the end of the parent node.
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
        previous._next = next || null;
      }
    }
  }

  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
};

var selection_exit = function() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
};

var selection_merge = function(selection) {

  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Selection(merges, this._parents);
};

var selection_order = function() {

  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
      if (node = group[i]) {
        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }

  return this;
};

var selection_sort = function(compare) {
  if (!compare) compare = ascending$1;

  function compareNode(a, b) {
    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
  }

  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }

  return new Selection(sortgroups, this._parents).order();
};

function ascending$1(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

var selection_call = function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
};

var selection_nodes = function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
};

var selection_node = function() {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }

  return null;
};

var selection_size = function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
};

var selection_empty = function() {
  return !this.node();
};

var selection_each = function(callback) {

  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }

  return this;
};

function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}

function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}

function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}

function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}

var selection_attr = function(name, value) {
  var fullname = namespace(name);

  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local
        ? node.getAttributeNS(fullname.space, fullname.local)
        : node.getAttribute(fullname);
  }

  return this.each((value == null
      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
      ? (fullname.local ? attrFunctionNS : attrFunction)
      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
};

var defaultView = function(node) {
  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
      || (node.document && node) // node is a Window
      || node.defaultView; // node is a Document
};

function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}

function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}

var selection_style = function(name, value, priority) {
  return arguments.length > 1
      ? this.each((value == null
            ? styleRemove : typeof value === "function"
            ? styleFunction
            : styleConstant)(name, value, priority == null ? "" : priority))
      : styleValue(this.node(), name);
};

function styleValue(node, name) {
  return node.style.getPropertyValue(name)
      || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}

function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}

function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}

function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}

var selection_property = function(name, value) {
  return arguments.length > 1
      ? this.each((value == null
          ? propertyRemove : typeof value === "function"
          ? propertyFunction
          : propertyConstant)(name, value))
      : this.node()[name];
};

function classArray(string) {
  return string.trim().split(/^|\s+/);
}

function classList(node) {
  return node.classList || new ClassList(node);
}

function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}

ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};

function classedAdd(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.add(names[i]);
}

function classedRemove(node, names) {
  var list = classList(node), i = -1, n = names.length;
  while (++i < n) list.remove(names[i]);
}

function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}

function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}

function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}

var selection_classed = function(name, value) {
  var names = classArray(name + "");

  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n = names.length;
    while (++i < n) if (!list.contains(names[i])) return false;
    return true;
  }

  return this.each((typeof value === "function"
      ? classedFunction : value
      ? classedTrue
      : classedFalse)(names, value));
};

function textRemove() {
  this.textContent = "";
}

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}

var selection_text = function(value) {
  return arguments.length
      ? this.each(value == null
          ? textRemove : (typeof value === "function"
          ? textFunction
          : textConstant)(value))
      : this.node().textContent;
};

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}

function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}

var selection_html = function(value) {
  return arguments.length
      ? this.each(value == null
          ? htmlRemove : (typeof value === "function"
          ? htmlFunction
          : htmlConstant)(value))
      : this.node().innerHTML;
};

function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

var selection_raise = function() {
  return this.each(raise);
};

function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

var selection_lower = function() {
  return this.each(lower);
};

var selection_append = function(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
};

function constantNull() {
  return null;
}

var selection_insert = function(name, before) {
  var create = typeof name === "function" ? name : creator(name),
      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
  });
};

function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

var selection_remove = function() {
  return this.each(remove);
};

var selection_datum = function(value) {
  return arguments.length
      ? this.property("__data__", value)
      : this.node().__data__;
};

function dispatchEvent(node, type, params) {
  var window = defaultView(node),
      event = window.CustomEvent;

  if (typeof event === "function") {
    event = new event(type, params);
  } else {
    event = window.document.createEvent("Event");
    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type, false, false);
  }

  node.dispatchEvent(event);
}

function dispatchConstant(type, params) {
  return function() {
    return dispatchEvent(this, type, params);
  };
}

function dispatchFunction(type, params) {
  return function() {
    return dispatchEvent(this, type, params.apply(this, arguments));
  };
}

var selection_dispatch = function(type, params) {
  return this.each((typeof params === "function"
      ? dispatchFunction
      : dispatchConstant)(type, params));
};

var root = [null];

function Selection(groups, parents) {
  this._groups = groups;
  this._parents = parents;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
};

var select = function(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
};

var selectAll = function(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : selector], root);
};

var touch = function(node, touches, identifier) {
  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;

  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
    if ((touch = touches[i]).identifier === identifier) {
      return point(node, touch);
    }
  }

  return null;
};

var touches = function(node, touches) {
  if (touches == null) touches = sourceEvent().touches;

  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
    points[i] = point(node, touches[i]);
  }

  return points;
};

function nopropagation() {
  exports.event.stopImmediatePropagation();
}

var noevent = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

var dragDisable = function(view) {
  var root = view.document.documentElement,
      selection$$1 = select(view).on("dragstart.drag", noevent, true);
  if ("onselectstart" in root) {
    selection$$1.on("selectstart.drag", noevent, true);
  } else {
    root.__noselect = root.style.MozUserSelect;
    root.style.MozUserSelect = "none";
  }
};

function yesdrag(view, noclick) {
  var root = view.document.documentElement,
      selection$$1 = select(view).on("dragstart.drag", null);
  if (noclick) {
    selection$$1.on("click.drag", noevent, true);
    setTimeout(function() { selection$$1.on("click.drag", null); }, 0);
  }
  if ("onselectstart" in root) {
    selection$$1.on("selectstart.drag", null);
  } else {
    root.style.MozUserSelect = root.__noselect;
    delete root.__noselect;
  }
}

var constant$2 = function(x) {
  return function() {
    return x;
  };
};

function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
  this.target = target;
  this.type = type;
  this.subject = subject;
  this.identifier = id;
  this.active = active;
  this.x = x;
  this.y = y;
  this.dx = dx;
  this.dy = dy;
  this._ = dispatch;
}

DragEvent.prototype.on = function() {
  var value = this._.on.apply(this._, arguments);
  return value === this._ ? this : value;
};

// Ignore right-click, since that should open the context menu.
function defaultFilter$1() {
  return !exports.event.button;
}

function defaultContainer() {
  return this.parentNode;
}

function defaultSubject(d) {
  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
}

var drag = function() {
  var filter = defaultFilter$1,
      container = defaultContainer,
      subject = defaultSubject,
      gestures = {},
      listeners = dispatch("start", "drag", "end"),
      active = 0,
      mousedownx,
      mousedowny,
      mousemoving,
      touchending,
      clickDistance2 = 0;

  function drag(selection$$1) {
    selection$$1
        .on("mousedown.drag", mousedowned)
        .on("touchstart.drag", touchstarted)
        .on("touchmove.drag", touchmoved)
        .on("touchend.drag touchcancel.drag", touchended)
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
    if (!gesture) return;
    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
    dragDisable(exports.event.view);
    nopropagation();
    mousemoving = false;
    mousedownx = exports.event.clientX;
    mousedowny = exports.event.clientY;
    gesture("start");
  }

  function mousemoved() {
    noevent();
    if (!mousemoving) {
      var dx = exports.event.clientX - mousedownx, dy = exports.event.clientY - mousedowny;
      mousemoving = dx * dx + dy * dy > clickDistance2;
    }
    gestures.mouse("drag");
  }

  function mouseupped() {
    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
    yesdrag(exports.event.view, mousemoving);
    noevent();
    gestures.mouse("end");
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var touches$$1 = exports.event.changedTouches,
        c = container.apply(this, arguments),
        n = touches$$1.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = beforestart(touches$$1[i].identifier, c, touch, this, arguments)) {
        nopropagation();
        gesture("start");
      }
    }
  }

  function touchmoved() {
    var touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, gesture;

    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches$$1[i].identifier]) {
        noevent();
        gesture("drag");
      }
    }
  }

  function touchended() {
    var touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, gesture;

    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
    for (i = 0; i < n; ++i) {
      if (gesture = gestures[touches$$1[i].identifier]) {
        nopropagation();
        gesture("end");
      }
    }
  }

  function beforestart(id, container, point, that, args) {
    var p = point(container, id), s, dx, dy,
        sublisteners = listeners.copy();

    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
      dx = s.x - p[0] || 0;
      dy = s.y - p[1] || 0;
      return true;
    })) return;

    return function gesture(type) {
      var p0 = p, n;
      switch (type) {
        case "start": gestures[id] = gesture, n = active++; break;
        case "end": delete gestures[id], --active; // nobreak
        case "drag": p = point(container, id), n = active; break;
      }
      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
    };
  }

  drag.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$2(!!_), drag) : filter;
  };

  drag.container = function(_) {
    return arguments.length ? (container = typeof _ === "function" ? _ : constant$2(_), drag) : container;
  };

  drag.subject = function(_) {
    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$2(_), drag) : subject;
  };

  drag.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? drag : value;
  };

  drag.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
  };

  return drag;
};

var define = function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
};

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*";
var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
var reHex3 = /^#([0-9a-f]{3})$/;
var reHex6 = /^#([0-9a-f]{6})$/;
var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

var Kn = 18;
var Xn = 0.950470;
var Yn = 1;
var Zn = 1.088830;
var t0 = 4 / 29;
var t1 = 6 / 29;
var t2 = 3 * t1 * t1;
var t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * deg2rad;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

define(Lab, lab, extend(Color, {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new Rgb(
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * rad2deg;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hcl, hcl, extend(Color, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));

var A = -0.14861;
var B = +1.78277;
var C = -0.29227;
var D = -0.90649;
var E = +1.97294;
var ED = E * D;
var EB = E * B;
var BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

var basis$1 = function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
};

var basisClosed = function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
};

var constant$3 = function(x) {
  return function() {
    return x;
  };
};

function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$3(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : constant$3(isNaN(a) ? b : a);
}

var interpolateRgb = ((function rgbGamma(y) {
  var color$$1 = gamma(y);

  function rgb$$1(start, end) {
    var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
        g = color$$1(start.g, end.g),
        b = color$$1(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb$$1.gamma = rgbGamma;

  return rgb$$1;
}))(1);

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color$$1;
    for (i = 0; i < n; ++i) {
      color$$1 = rgb(colors[i]);
      r[i] = color$$1.r || 0;
      g[i] = color$$1.g || 0;
      b[i] = color$$1.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color$$1.opacity = 1;
    return function(t) {
      color$$1.r = r(t);
      color$$1.g = g(t);
      color$$1.b = b(t);
      return color$$1 + "";
    };
  };
}

var rgbBasis = rgbSpline(basis$1);
var rgbBasisClosed = rgbSpline(basisClosed);

var array$1 = function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolateValue(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
};

var date = function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
};

var reinterpolate = function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
};

var object = function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolateValue(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
};

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
var reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

var interpolateString = function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: reinterpolate(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
};

var interpolateValue = function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$3(b)
      : (t === "number" ? reinterpolate
      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
      : b instanceof color ? interpolateRgb
      : b instanceof Date ? date
      : Array.isArray(b) ? array$1
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : reinterpolate)(a, b);
};

var interpolateRound = function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
};

var degrees = 180 / Math.PI;

var identity$2 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

var decompose = function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
};

var cssNode;
var cssRoot;
var cssView;
var svgNode;

function parseCss(value) {
  if (value === "none") return identity$2;
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return identity$2;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
  value = value.matrix;
  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
}

function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: reinterpolate(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: reinterpolate(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: reinterpolate(xa, xb)}, {i: i - 2, x: reinterpolate(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");

var rho = Math.SQRT2;
var rho2 = 2;
var rho4 = 4;
var epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
var interpolateZoom = function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    };
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    };
  }

  i.duration = S * 1000;

  return i;
};

function hsl$1(hue$$1) {
  return function(start, end) {
    var h = hue$$1((start = hsl(start)).h, (end = hsl(end)).h),
        s = nogamma(start.s, end.s),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hsl$2 = hsl$1(hue);
var hslLong = hsl$1(nogamma);

function lab$1(start, end) {
  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
      a = nogamma(start.a, end.a),
      b = nogamma(start.b, end.b),
      opacity = nogamma(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

function hcl$1(hue$$1) {
  return function(start, end) {
    var h = hue$$1((start = hcl(start)).h, (end = hcl(end)).h),
        c = nogamma(start.c, end.c),
        l = nogamma(start.l, end.l),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

var hcl$2 = hcl$1(hue);
var hclLong = hcl$1(nogamma);

function cubehelix$1(hue$$1) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix$$1(start, end) {
      var h = hue$$1((start = cubehelix(start)).h, (end = cubehelix(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix$$1.gamma = cubehelixGamma;

    return cubehelix$$1;
  })(1);
}

var cubehelix$2 = cubehelix$1(hue);
var cubehelixLong = cubehelix$1(nogamma);

var quantize = function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
};

var frame = 0;
var timeout = 0;
var interval = 0;
var pokeDelay = 1000;
var taskHead;
var taskTail;
var clockLast = 0;
var clockNow = 0;
var clockSkew = 0;
var clock = typeof performance === "object" && performance.now ? performance : Date;
var setFrame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow;
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, delay);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clockNow, interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}

var timeout$1 = function(callback, delay, time) {
  var t = new Timer;
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
};

var interval$1 = function(callback, delay, time) {
  var t = new Timer, total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? now() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
};

var emptyOn = dispatch("start", "end", "interrupt");
var emptyTween = [];

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

var schedule = function(node, name, id, index, group, timing) {
  var schedules = node.__transition;
  if (!schedules) node.__transition = {};
  else if (id in schedules) return;
  create(node, id, {
    name: name,
    index: index, // For context during callback.
    group: group, // For context during callback.
    on: emptyOn,
    tween: emptyTween,
    time: timing.time,
    delay: timing.delay,
    duration: timing.duration,
    ease: timing.ease,
    timer: null,
    state: CREATED
  });
};

function init(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
  return schedule;
}

function set$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
  return schedule;
}

function get$1(node, id) {
  var schedule = node.__transition;
  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
  return schedule;
}

function create(node, id, self) {
  var schedules = node.__transition,
      tween;

  // Initialize the self timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  schedules[id] = self;
  self.timer = timer(schedule, 0, self.time);

  function schedule(elapsed) {
    self.state = SCHEDULED;
    self.timer.restart(start, self.delay, self.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (self.delay <= elapsed) start(elapsed - self.delay);
  }

  function start(elapsed) {
    var i, j, n, o;

    // If the state is not SCHEDULED, then we previously errored on start.
    if (self.state !== SCHEDULED) return stop();

    for (i in schedules) {
      o = schedules[i];
      if (o.name !== self.name) continue;

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (o.state === STARTED) return timeout$1(start);

      // Interrupt the active transition, if any.
      // Dispatch the interrupt event.
      if (o.state === RUNNING) {
        o.state = ENDED;
        o.timer.stop();
        o.on.call("interrupt", node, node.__data__, o.index, o.group);
        delete schedules[i];
      }

      // Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!
      else if (+i < id) {
        o.state = ENDED;
        o.timer.stop();
        delete schedules[i];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    timeout$1(function() {
      if (self.state === STARTED) {
        self.state = RUNNING;
        self.timer.restart(tick, self.delay, self.time);
        tick(elapsed);
      }
    });

    // Dispatch the start event.
    // Note this must be done before the tween are initialized.
    self.state = STARTING;
    self.on.call("start", node, node.__data__, self.index, self.group);
    if (self.state !== STARTING) return; // interrupted
    self.state = STARTED;

    // Initialize the tween, deleting null tween.
    tween = new Array(n = self.tween.length);
    for (i = 0, j = -1; i < n; ++i) {
      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
        tween[++j] = o;
      }
    }
    tween.length = j + 1;
  }

  function tick(elapsed) {
    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
        i = -1,
        n = tween.length;

    while (++i < n) {
      tween[i].call(null, t);
    }

    // Dispatch the end event.
    if (self.state === ENDING) {
      self.on.call("end", node, node.__data__, self.index, self.group);
      stop();
    }
  }

  function stop() {
    self.state = ENDED;
    self.timer.stop();
    delete schedules[id];
    for (var i in schedules) return; // eslint-disable-line no-unused-vars
    delete node.__transition;
  }
}

var interrupt = function(node, name) {
  var schedules = node.__transition,
      schedule,
      active,
      empty = true,
      i;

  if (!schedules) return;

  name = name == null ? null : name + "";

  for (i in schedules) {
    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
    active = schedule.state > STARTING && schedule.state < ENDING;
    schedule.state = ENDED;
    schedule.timer.stop();
    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
    delete schedules[i];
  }

  if (empty) delete node.__transition;
};

var selection_interrupt = function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
};

function tweenRemove(id, name) {
  var tween0, tween1;
  return function() {
    var schedule = set$1(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = tween0 = tween;
      for (var i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1 = tween1.slice();
          tween1.splice(i, 1);
          break;
        }
      }
    }

    schedule.tween = tween1;
  };
}

function tweenFunction(id, name, value) {
  var tween0, tween1;
  if (typeof value !== "function") throw new Error;
  return function() {
    var schedule = set$1(this, id),
        tween = schedule.tween;

    // If this node shared tween with the previous node,
    // just assign the updated shared tween and we’re done!
    // Otherwise, copy-on-write.
    if (tween !== tween0) {
      tween1 = (tween0 = tween).slice();
      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
        if (tween1[i].name === name) {
          tween1[i] = t;
          break;
        }
      }
      if (i === n) tween1.push(t);
    }

    schedule.tween = tween1;
  };
}

var transition_tween = function(name, value) {
  var id = this._id;

  name += "";

  if (arguments.length < 2) {
    var tween = get$1(this.node(), id).tween;
    for (var i = 0, n = tween.length, t; i < n; ++i) {
      if ((t = tween[i]).name === name) {
        return t.value;
      }
    }
    return null;
  }

  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
};

function tweenValue(transition, name, value) {
  var id = transition._id;

  transition.each(function() {
    var schedule = set$1(this, id);
    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
  });

  return function(node) {
    return get$1(node, id).value[name];
  };
}

var interpolate$$1 = function(a, b) {
  var c;
  return (typeof b === "number" ? reinterpolate
      : b instanceof color ? interpolateRgb
      : (c = color(b)) ? (b = c, interpolateRgb)
      : interpolateString)(a, b);
};

function attrRemove$1(name) {
  return function() {
    this.removeAttribute(name);
  };
}

function attrRemoveNS$1(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}

function attrConstant$1(name, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function attrConstantNS$1(fullname, interpolate$$1, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value1);
  };
}

function attrFunction$1(name, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttribute(name);
    value0 = this.getAttribute(name);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

function attrFunctionNS$1(fullname, interpolate$$1, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0, value1 = value(this);
    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
    value0 = this.getAttributeNS(fullname.space, fullname.local);
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
  };
}

var transition_attr = function(name, value) {
  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$$1;
  return this.attrTween(name, typeof value === "function"
      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value + ""));
};

function attrTweenNS(fullname, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttributeNS(fullname.space, fullname.local, i(t));
    };
  }
  tween._value = value;
  return tween;
}

function attrTween(name, value) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.setAttribute(name, i(t));
    };
  }
  tween._value = value;
  return tween;
}

var transition_attrTween = function(name, value) {
  var key = "attr." + name;
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  var fullname = namespace(name);
  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
};

function delayFunction(id, value) {
  return function() {
    init(this, id).delay = +value.apply(this, arguments);
  };
}

function delayConstant(id, value) {
  return value = +value, function() {
    init(this, id).delay = value;
  };
}

var transition_delay = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? delayFunction
          : delayConstant)(id, value))
      : get$1(this.node(), id).delay;
};

function durationFunction(id, value) {
  return function() {
    set$1(this, id).duration = +value.apply(this, arguments);
  };
}

function durationConstant(id, value) {
  return value = +value, function() {
    set$1(this, id).duration = value;
  };
}

var transition_duration = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each((typeof value === "function"
          ? durationFunction
          : durationConstant)(id, value))
      : get$1(this.node(), id).duration;
};

function easeConstant(id, value) {
  if (typeof value !== "function") throw new Error;
  return function() {
    set$1(this, id).ease = value;
  };
}

var transition_ease = function(value) {
  var id = this._id;

  return arguments.length
      ? this.each(easeConstant(id, value))
      : get$1(this.node(), id).ease;
};

var transition_filter = function(match) {
  if (typeof match !== "function") match = matcher$1(match);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }

  return new Transition(subgroups, this._parents, this._name, this._id);
};

var transition_merge = function(transition) {
  if (transition._id !== this._id) throw new Error;

  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
      if (node = group0[i] || group1[i]) {
        merge[i] = node;
      }
    }
  }

  for (; j < m0; ++j) {
    merges[j] = groups0[j];
  }

  return new Transition(merges, this._parents, this._name, this._id);
};

function start(name) {
  return (name + "").trim().split(/^|\s+/).every(function(t) {
    var i = t.indexOf(".");
    if (i >= 0) t = t.slice(0, i);
    return !t || t === "start";
  });
}

function onFunction(id, name, listener) {
  var on0, on1, sit = start(name) ? init : set$1;
  return function() {
    var schedule = sit(this, id),
        on = schedule.on;

    // If this node shared a dispatch with the previous node,
    // just assign the updated shared dispatch and we’re done!
    // Otherwise, copy-on-write.
    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);

    schedule.on = on1;
  };
}

var transition_on = function(name, listener) {
  var id = this._id;

  return arguments.length < 2
      ? get$1(this.node(), id).on.on(name)
      : this.each(onFunction(id, name, listener));
};

function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

var transition_remove = function() {
  return this.on("end.remove", removeFunction(this._id));
};

var transition_select = function(select$$1) {
  var name = this._name,
      id = this._id;

  if (typeof select$$1 !== "function") select$$1 = selector(select$$1);

  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
      if ((node = group[i]) && (subnode = select$$1.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
      }
    }
  }

  return new Transition(subgroups, this._parents, name, id);
};

var transition_selectAll = function(select$$1) {
  var name = this._name,
      id = this._id;

  if (typeof select$$1 !== "function") select$$1 = selectorAll(select$$1);

  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        for (var children = select$$1.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
          if (child = children[k]) {
            schedule(child, name, id, k, children, inherit);
          }
        }
        subgroups.push(children);
        parents.push(node);
      }
    }
  }

  return new Transition(subgroups, parents, name, id);
};

var Selection$1 = selection.prototype.constructor;

var transition_selection = function() {
  return new Selection$1(this._groups, this._parents);
};

function styleRemove$1(name, interpolate$$2) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value10 = value1);
  };
}

function styleRemoveEnd(name) {
  return function() {
    this.style.removeProperty(name);
  };
}

function styleConstant$1(name, interpolate$$2, value1) {
  var value00,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name);
    return value0 === value1 ? null
        : value0 === value00 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value1);
  };
}

function styleFunction$1(name, interpolate$$2, value) {
  var value00,
      value10,
      interpolate0;
  return function() {
    var value0 = styleValue(this, name),
        value1 = value(this);
    if (value1 == null) value1 = (this.style.removeProperty(name), styleValue(this, name));
    return value0 === value1 ? null
        : value0 === value00 && value1 === value10 ? interpolate0
        : interpolate0 = interpolate$$2(value00 = value0, value10 = value1);
  };
}

var transition_style = function(name, value, priority) {
  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$$1;
  return value == null ? this
          .styleTween(name, styleRemove$1(name, i))
          .on("end.style." + name, styleRemoveEnd(name))
      : this.styleTween(name, typeof value === "function"
          ? styleFunction$1(name, i, tweenValue(this, "style." + name, value))
          : styleConstant$1(name, i, value + ""), priority);
};

function styleTween(name, value, priority) {
  function tween() {
    var node = this, i = value.apply(node, arguments);
    return i && function(t) {
      node.style.setProperty(name, i(t), priority);
    };
  }
  tween._value = value;
  return tween;
}

var transition_styleTween = function(name, value, priority) {
  var key = "style." + (name += "");
  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
  if (value == null) return this.tween(key, null);
  if (typeof value !== "function") throw new Error;
  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
};

function textConstant$1(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction$1(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

var transition_text = function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction$1(tweenValue(this, "text", value))
      : textConstant$1(value == null ? "" : value + ""));
};

var transition_transition = function() {
  var name = this._name,
      id0 = this._id,
      id1 = newId();

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        var inherit = get$1(node, id0);
        schedule(node, name, id1, i, group, {
          time: inherit.time + inherit.delay + inherit.duration,
          delay: 0,
          duration: inherit.duration,
          ease: inherit.ease
        });
      }
    }
  }

  return new Transition(groups, this._parents, name, id1);
};

var id = 0;

function Transition(groups, parents, name, id) {
  this._groups = groups;
  this._parents = parents;
  this._name = name;
  this._id = id;
}

function transition(name) {
  return selection().transition(name);
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease
};

function linear$1(t) {
  return +t;
}

function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

var pi = Math.PI;
var halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}

function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

var b1 = 4 / 11;
var b2 = 6 / 11;
var b3 = 8 / 11;
var b4 = 3 / 4;
var b5 = 9 / 11;
var b6 = 10 / 11;
var b7 = 15 / 16;
var b8 = 21 / 22;
var b9 = 63 / 64;
var b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

var tau = 2 * Math.PI;
var amplitude = 1;
var period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

var defaultTiming = {
  time: null, // Set on use.
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(node, id) {
  var timing;
  while (!(timing = node.__transition) || !(timing = timing[id])) {
    if (!(node = node.parentNode)) {
      return defaultTiming.time = now(), defaultTiming;
    }
  }
  return timing;
}

var selection_transition = function(name) {
  var id,
      timing;

  if (name instanceof Transition) {
    id = name._id, name = name._name;
  } else {
    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
  }

  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
      if (node = group[i]) {
        schedule(node, name, id, i, group, timing || inherit(node, id));
      }
    }
  }

  return new Transition(groups, this._parents, name, id);
};

selection.prototype.interrupt = selection_interrupt;
selection.prototype.transition = selection_transition;

var root$1 = [null];

var active = function(node, name) {
  var schedules = node.__transition,
      schedule,
      i;

  if (schedules) {
    name = name == null ? null : name + "";
    for (i in schedules) {
      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
        return new Transition([[node]], root$1, name, +i);
      }
    }
  }

  return null;
};

var constant$4 = function(x) {
  return function() {
    return x;
  };
};

var BrushEvent = function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
};

function nopropagation$1() {
  exports.event.stopImmediatePropagation();
}

var noevent$1 = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

var MODE_DRAG = {name: "drag"};
var MODE_SPACE = {name: "space"};
var MODE_HANDLE = {name: "handle"};
var MODE_CENTER = {name: "center"};

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function(xy) { return xy; },
  output: function(xy) { return xy; }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return {type: t};
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !exports.event.button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local$$1(node) {
  while (!node.__brush) if (!(node = node.parentNode)) return;
  return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0]
      || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush$1(X);
}

function brushY() {
  return brush$1(Y);
}

var brush = function() {
  return brush$1(XY);
};

function brush$1(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = dispatch(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group
        .property("__brush", initialize)
      .selectAll(".overlay")
      .data([type("overlay")]);

    overlay.enter().append("rect")
        .attr("class", "overlay")
        .attr("pointer-events", "all")
        .attr("cursor", cursors.overlay)
      .merge(overlay)
        .each(function() {
          var extent = local$$1(this).extent;
          select(this)
              .attr("x", extent[0][0])
              .attr("y", extent[0][1])
              .attr("width", extent[1][0] - extent[0][0])
              .attr("height", extent[1][1] - extent[0][1]);
        });

    group.selectAll(".selection")
      .data([type("selection")])
      .enter().append("rect")
        .attr("class", "selection")
        .attr("cursor", cursors.selection)
        .attr("fill", "#777")
        .attr("fill-opacity", 0.3)
        .attr("stroke", "#fff")
        .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle")
      .data(dim.handles, function(d) { return d.type; });

    handle.exit().remove();

    handle.enter().append("rect")
        .attr("class", function(d) { return "handle handle--" + d.type; })
        .attr("cursor", function(d) { return cursors[d.type]; });

    group
        .each(redraw)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function(group, selection$$1) {
    if (group.selection) {
      group
          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
          .tween("brush", function() {
            var that = this,
                state = that.__brush,
                emit = emitter(that, arguments),
                selection0 = state.selection,
                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(this, arguments) : selection$$1, state.extent),
                i = interpolateValue(selection0, selection1);

            function tween(t) {
              state.selection = t === 1 && empty(selection1) ? null : i(t);
              redraw.call(that);
              emit.brush();
            }

            return selection0 && selection1 ? tween : tween(1);
          });
    } else {
      group
          .each(function() {
            var that = this,
                args = arguments,
                state = that.__brush,
                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(that, args) : selection$$1, state.extent),
                emit = emitter(that, args).beforestart();

            interrupt(that);
            state.selection = selection1 == null || empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
          });
    }
  };

  function redraw() {
    var group = select(this),
        selection$$1 = local$$1(this).selection;

    if (selection$$1) {
      group.selectAll(".selection")
          .style("display", null)
          .attr("x", selection$$1[0][0])
          .attr("y", selection$$1[0][1])
          .attr("width", selection$$1[1][0] - selection$$1[0][0])
          .attr("height", selection$$1[1][1] - selection$$1[0][1]);

      group.selectAll(".handle")
          .style("display", null)
          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection$$1[1][0] - handleSize / 2 : selection$$1[0][0] - handleSize / 2; })
          .attr("y", function(d) { return d.type[0] === "s" ? selection$$1[1][1] - handleSize / 2 : selection$$1[0][1] - handleSize / 2; })
          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection$$1[1][0] - selection$$1[0][0] + handleSize : handleSize; })
          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection$$1[1][1] - selection$$1[0][1] + handleSize : handleSize; });
    }

    else {
      group.selectAll(".selection,.handle")
          .style("display", "none")
          .attr("x", null)
          .attr("y", null)
          .attr("width", null)
          .attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function() {
      this.emit("brush");
      return this;
    },
    end: function() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function(type) {
      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (exports.event.touches) { if (exports.event.changedTouches.length < exports.event.touches.length) return noevent$1(); }
    else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = exports.event.target.__data__.type,
        mode = (exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local$$1(that),
        extent = state.extent,
        selection$$1 = state.selection,
        W = extent[0][0], w0, w1,
        N = extent[0][1], n0, n1,
        E = extent[1][0], e0, e1,
        S = extent[1][1], s0, s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && exports.event.shiftKey,
        lockX,
        lockY,
        point0 = mouse(that),
        point = point0,
        emit = emitter(that, arguments).beforestart();

    if (type === "overlay") {
      state.selection = selection$$1 = [
        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
      ];
    } else {
      w0 = selection$$1[0][0];
      n0 = selection$$1[0][1];
      e0 = selection$$1[1][0];
      s0 = selection$$1[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = select(that)
        .attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay")
        .attr("cursor", cursors[type]);

    if (exports.event.touches) {
      group
          .on("touchmove.brush", moved, true)
          .on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = select(exports.event.view)
          .on("keydown.brush", keydowned, true)
          .on("keyup.brush", keyupped, true)
          .on("mousemove.brush", moved, true)
          .on("mouseup.brush", ended, true);

      dragDisable(exports.event.view);
    }

    nopropagation$1();
    interrupt(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = mouse(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
        else lockX = true;
      }
      point = point1;
      moving = true;
      noevent$1();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG: {
          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
          break;
        }
        case MODE_HANDLE: {
          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
          break;
        }
        case MODE_CENTER: {
          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
          break;
        }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection$$1 = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection$$1[0][0], e1 = selection$$1[1][0];
      if (lockY) n1 = selection$$1[0][1], s1 = selection$$1[1][1];

      if (selection$$1[0][0] !== w1
          || selection$$1[0][1] !== n1
          || selection$$1[1][0] !== e1
          || selection$$1[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      nopropagation$1();
      if (exports.event.touches) {
        if (exports.event.touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        yesdrag(exports.event.view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection$$1 = state.selection; // May be set by brush.move (on start)!
      if (empty(selection$$1)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          shifting = signX && signY;
          break;
        }
        case 18: { // ALT
          if (mode === MODE_HANDLE) {
            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
            mode = MODE_CENTER;
            move();
          }
          break;
        }
        case 32: { // SPACE; takes priority over ALT
          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
            mode = MODE_SPACE;
            overlay.attr("cursor", cursors.selection);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }

    function keyupped() {
      switch (exports.event.keyCode) {
        case 16: { // SHIFT
          if (shifting) {
            lockX = lockY = shifting = false;
            move();
          }
          break;
        }
        case 18: { // ALT
          if (mode === MODE_CENTER) {
            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
            mode = MODE_HANDLE;
            move();
          }
          break;
        }
        case 32: { // SPACE
          if (mode === MODE_SPACE) {
            if (exports.event.altKey) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
            } else {
              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
            }
            overlay.attr("cursor", cursors[type]);
            move();
          }
          break;
        }
        default: return;
      }
      noevent$1();
    }
  }

  function initialize() {
    var state = this.__brush || {selection: null};
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$4([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$4(!!_), brush) : filter;
  };

  brush.handleSize = function(_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}

var cos = Math.cos;
var sin = Math.sin;
var pi$1 = Math.PI;
var halfPi$1 = pi$1 / 2;
var tau$1 = pi$1 * 2;
var max$1 = Math.max;

function compareValue(compare) {
  return function(a, b) {
    return compare(
      a.source.value + a.target.value,
      b.source.value + b.target.value
    );
  };
}

var chord = function() {
  var padAngle = 0,
      sortGroups = null,
      sortSubgroups = null,
      sortChords = null;

  function chord(matrix) {
    var n = matrix.length,
        groupSums = [],
        groupIndex = sequence(n),
        subgroupIndex = [],
        chords = [],
        groups = chords.groups = new Array(n),
        subgroups = new Array(n * n),
        k,
        x,
        x0,
        dx,
        i,
        j;

    // Compute the sum.
    k = 0, i = -1; while (++i < n) {
      x = 0, j = -1; while (++j < n) {
        x += matrix[i][j];
      }
      groupSums.push(x);
      subgroupIndex.push(sequence(n));
      k += x;
    }

    // Sort groups…
    if (sortGroups) groupIndex.sort(function(a, b) {
      return sortGroups(groupSums[a], groupSums[b]);
    });

    // Sort subgroups…
    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
      d.sort(function(a, b) {
        return sortSubgroups(matrix[i][a], matrix[i][b]);
      });
    });

    // Convert the sum to scaling factor for [0, 2pi].
    // TODO Allow start and end angle to be specified?
    // TODO Allow padding to be specified as percentage?
    k = max$1(0, tau$1 - padAngle * n) / k;
    dx = k ? padAngle : tau$1 / n;

    // Compute the start and end angle for each group and subgroup.
    // Note: Opera has a bug reordering object literal properties!
    x = 0, i = -1; while (++i < n) {
      x0 = x, j = -1; while (++j < n) {
        var di = groupIndex[i],
            dj = subgroupIndex[di][j],
            v = matrix[di][dj],
            a0 = x,
            a1 = x += v * k;
        subgroups[dj * n + di] = {
          index: di,
          subindex: dj,
          startAngle: a0,
          endAngle: a1,
          value: v
        };
      }
      groups[di] = {
        index: di,
        startAngle: x0,
        endAngle: x,
        value: groupSums[di]
      };
      x += dx;
    }

    // Generate chords for each (non-empty) subgroup-subgroup link.
    i = -1; while (++i < n) {
      j = i - 1; while (++j < n) {
        var source = subgroups[j * n + i],
            target = subgroups[i * n + j];
        if (source.value || target.value) {
          chords.push(source.value < target.value
              ? {source: target, target: source}
              : {source: source, target: target});
        }
      }
    }

    return sortChords ? chords.sort(sortChords) : chords;
  }

  chord.padAngle = function(_) {
    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
  };

  chord.sortGroups = function(_) {
    return arguments.length ? (sortGroups = _, chord) : sortGroups;
  };

  chord.sortSubgroups = function(_) {
    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
  };

  chord.sortChords = function(_) {
    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
  };

  return chord;
};

var slice$2 = Array.prototype.slice;

var constant$5 = function(x) {
  return function() {
    return x;
  };
};

var pi$2 = Math.PI;
var tau$2 = 2 * pi$2;
var epsilon$1 = 1e-6;
var tauEpsilon = tau$2 - epsilon$1;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1)) {}

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$2 + tau$2;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$2)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function defaultSource(d) {
  return d.source;
}

function defaultTarget(d) {
  return d.target;
}

function defaultRadius(d) {
  return d.radius;
}

function defaultStartAngle(d) {
  return d.startAngle;
}

function defaultEndAngle(d) {
  return d.endAngle;
}

var ribbon = function() {
  var source = defaultSource,
      target = defaultTarget,
      radius = defaultRadius,
      startAngle = defaultStartAngle,
      endAngle = defaultEndAngle,
      context = null;

  function ribbon() {
    var buffer,
        argv = slice$2.call(arguments),
        s = source.apply(this, argv),
        t = target.apply(this, argv),
        sr = +radius.apply(this, (argv[0] = s, argv)),
        sa0 = startAngle.apply(this, argv) - halfPi$1,
        sa1 = endAngle.apply(this, argv) - halfPi$1,
        sx0 = sr * cos(sa0),
        sy0 = sr * sin(sa0),
        tr = +radius.apply(this, (argv[0] = t, argv)),
        ta0 = startAngle.apply(this, argv) - halfPi$1,
        ta1 = endAngle.apply(this, argv) - halfPi$1;

    if (!context) context = buffer = path();

    context.moveTo(sx0, sy0);
    context.arc(0, 0, sr, sa0, sa1);
    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
      context.arc(0, 0, tr, ta0, ta1);
    }
    context.quadraticCurveTo(0, 0, sx0, sy0);
    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  ribbon.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$5(+_), ribbon) : radius;
  };

  ribbon.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : startAngle;
  };

  ribbon.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$5(+_), ribbon) : endAngle;
  };

  ribbon.source = function(_) {
    return arguments.length ? (source = _, ribbon) : source;
  };

  ribbon.target = function(_) {
    return arguments.length ? (target = _, ribbon) : target;
  };

  ribbon.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
  };

  return ribbon;
};

var prefix = "$";

function Map() {}

Map.prototype = map$1.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map$1(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

var nest = function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) return rollup != null
        ? rollup(array) : (sortValues != null
        ? array.sort(sortValues)
        : array);

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = map$1(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
};

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return map$1();
}

function setMap(map, key, value) {
  map.set(key, value);
}

function Set() {}

var proto = map$1.prototype;

Set.prototype = set$2.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[prefix + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set$2(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

var keys = function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
};

var values = function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
};

var entries = function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
};

function objectConverter(columns) {
  return new Function("d", "return {" + columns.map(function(name, i) {
    return JSON.stringify(name) + ": d[" + i + "]";
  }).join(",") + "}");
}

function customConverter(columns, f) {
  var object = objectConverter(columns);
  return function(row, i) {
    return f(object(row), i, columns);
  };
}

// Compute unique columns in order of discovery.
function inferColumns(rows) {
  var columnSet = Object.create(null),
      columns = [];

  rows.forEach(function(row) {
    for (var column in row) {
      if (!(column in columnSet)) {
        columns.push(columnSet[column] = column);
      }
    }
  });

  return columns;
}

var dsv = function(delimiter) {
  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
      delimiterCode = delimiter.charCodeAt(0);

  function parse(text, f) {
    var convert, columns, rows = parseRows(text, function(row, i) {
      if (convert) return convert(row, i - 1);
      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
    });
    rows.columns = columns;
    return rows;
  }

  function parseRows(text, f) {
    var EOL = {}, // sentinel value for end-of-line
        EOF = {}, // sentinel value for end-of-file
        rows = [], // output rows
        N = text.length,
        I = 0, // current character index
        n = 0, // the current line number
        t, // the current token
        eol; // is the current token followed by EOL?

    function token() {
      if (I >= N) return EOF; // special case: end of file
      if (eol) return eol = false, EOL; // special case: end of line

      // special case: quotes
      var j = I, c;
      if (text.charCodeAt(j) === 34) {
        var i = j;
        while (i++ < N) {
          if (text.charCodeAt(i) === 34) {
            if (text.charCodeAt(i + 1) !== 34) break;
            ++i;
          }
        }
        I = i + 2;
        c = text.charCodeAt(i + 1);
        if (c === 13) {
          eol = true;
          if (text.charCodeAt(i + 2) === 10) ++I;
        } else if (c === 10) {
          eol = true;
        }
        return text.slice(j + 1, i).replace(/""/g, "\"");
      }

      // common case: find next delimiter or newline
      while (I < N) {
        var k = 1;
        c = text.charCodeAt(I++);
        if (c === 10) eol = true; // \n
        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
        else if (c !== delimiterCode) continue;
        return text.slice(j, I - k);
      }

      // special case: last token before EOF
      return text.slice(j);
    }

    while ((t = token()) !== EOF) {
      var a = [];
      while (t !== EOL && t !== EOF) {
        a.push(t);
        t = token();
      }
      if (f && (a = f(a, n++)) == null) continue;
      rows.push(a);
    }

    return rows;
  }

  function format(rows, columns) {
    if (columns == null) columns = inferColumns(rows);
    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
      return columns.map(function(column) {
        return formatValue(row[column]);
      }).join(delimiter);
    })).join("\n");
  }

  function formatRows(rows) {
    return rows.map(formatRow).join("\n");
  }

  function formatRow(row) {
    return row.map(formatValue).join(delimiter);
  }

  function formatValue(text) {
    return text == null ? ""
        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
        : text;
  }

  return {
    parse: parse,
    parseRows: parseRows,
    format: format,
    formatRows: formatRows
  };
};

var csv = dsv(",");

var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatRows = csv.formatRows;

var tsv = dsv("\t");

var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatRows = tsv.formatRows;

var center$1 = function(x, y) {
  var nodes;

  if (x == null) x = 0;
  if (y == null) y = 0;

  function force() {
    var i,
        n = nodes.length,
        node,
        sx = 0,
        sy = 0;

    for (i = 0; i < n; ++i) {
      node = nodes[i], sx += node.x, sy += node.y;
    }

    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
      node = nodes[i], node.x -= sx, node.y -= sy;
    }
  }

  force.initialize = function(_) {
    nodes = _;
  };

  force.x = function(_) {
    return arguments.length ? (x = +_, force) : x;
  };

  force.y = function(_) {
    return arguments.length ? (y = +_, force) : y;
  };

  return force;
};

var constant$6 = function(x) {
  return function() {
    return x;
  };
};

var jiggle = function() {
  return (Math.random() - 0.5) * 1e-6;
};

var tree_add = function(d) {
  var x = +this._x.call(null, d),
      y = +this._y.call(null, d);
  return add(this.cover(x, y), x, y, d);
};

function add(tree, x, y, d) {
  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points

  var parent,
      node = tree._root,
      leaf = {data: d},
      x0 = tree._x0,
      y0 = tree._y0,
      x1 = tree._x1,
      y1 = tree._y1,
      xm,
      ym,
      xp,
      yp,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return tree._root = leaf, tree;

  // Find the existing leaf for the new point, or add it.
  while (node.length) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
  }

  // Is the new point is exactly coincident with the existing point?
  xp = +tree._x.call(null, node.data);
  yp = +tree._y.call(null, node.data);
  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;

  // Otherwise, split the leaf node until the old and new point are separated.
  do {
    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
  return parent[j] = node, parent[i] = leaf, tree;
}

function addAll(data) {
  var d, i, n = data.length,
      x,
      y,
      xz = new Array(n),
      yz = new Array(n),
      x0 = Infinity,
      y0 = Infinity,
      x1 = -Infinity,
      y1 = -Infinity;

  // Compute the points and their extent.
  for (i = 0; i < n; ++i) {
    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
    xz[i] = x;
    yz[i] = y;
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
  }

  // If there were no (valid) points, inherit the existing extent.
  if (x1 < x0) x0 = this._x0, x1 = this._x1;
  if (y1 < y0) y0 = this._y0, y1 = this._y1;

  // Expand the tree to cover the new points.
  this.cover(x0, y0).cover(x1, y1);

  // Add the new points.
  for (i = 0; i < n; ++i) {
    add(this, xz[i], yz[i], data[i]);
  }

  return this;
}

var tree_cover = function(x, y) {
  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points

  var x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1;

  // If the quadtree has no extent, initialize them.
  // Integer extent are necessary so that if we later double the extent,
  // the existing quadrant boundaries don’t change due to floating point error!
  if (isNaN(x0)) {
    x1 = (x0 = Math.floor(x)) + 1;
    y1 = (y0 = Math.floor(y)) + 1;
  }

  // Otherwise, double repeatedly to cover.
  else if (x0 > x || x > x1 || y0 > y || y > y1) {
    var z = x1 - x0,
        node = this._root,
        parent,
        i;

    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
      case 0: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
        break;
      }
      case 1: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
        break;
      }
      case 2: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
        break;
      }
      case 3: {
        do parent = new Array(4), parent[i] = node, node = parent;
        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
        break;
      }
    }

    if (this._root && this._root.length) this._root = node;
  }

  // If the quadtree covers the point already, just return.
  else return this;

  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  return this;
};

var tree_data = function() {
  var data = [];
  this.visit(function(node) {
    if (!node.length) do data.push(node.data); while (node = node.next)
  });
  return data;
};

var tree_extent = function(_) {
  return arguments.length
      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
};

var Quad = function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
};

var tree_find = function(x, y, radius) {
  var data,
      x0 = this._x0,
      y0 = this._y0,
      x1,
      y1,
      x2,
      y2,
      x3 = this._x1,
      y3 = this._y1,
      quads = [],
      node = this._root,
      q,
      i;

  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
  if (radius == null) radius = Infinity;
  else {
    x0 = x - radius, y0 = y - radius;
    x3 = x + radius, y3 = y + radius;
    radius *= radius;
  }

  while (q = quads.pop()) {

    // Stop searching if this quadrant can’t contain a closer node.
    if (!(node = q.node)
        || (x1 = q.x0) > x3
        || (y1 = q.y0) > y3
        || (x2 = q.x1) < x0
        || (y2 = q.y1) < y0) continue;

    // Bisect the current quadrant.
    if (node.length) {
      var xm = (x1 + x2) / 2,
          ym = (y1 + y2) / 2;

      quads.push(
        new Quad(node[3], xm, ym, x2, y2),
        new Quad(node[2], x1, ym, xm, y2),
        new Quad(node[1], xm, y1, x2, ym),
        new Quad(node[0], x1, y1, xm, ym)
      );

      // Visit the closest quadrant first.
      if (i = (y >= ym) << 1 | (x >= xm)) {
        q = quads[quads.length - 1];
        quads[quads.length - 1] = quads[quads.length - 1 - i];
        quads[quads.length - 1 - i] = q;
      }
    }

    // Visit this point. (Visiting coincident points isn’t necessary!)
    else {
      var dx = x - +this._x.call(null, node.data),
          dy = y - +this._y.call(null, node.data),
          d2 = dx * dx + dy * dy;
      if (d2 < radius) {
        var d = Math.sqrt(radius = d2);
        x0 = x - d, y0 = y - d;
        x3 = x + d, y3 = y + d;
        data = node.data;
      }
    }
  }

  return data;
};

var tree_remove = function(d) {
  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points

  var parent,
      node = this._root,
      retainer,
      previous,
      next,
      x0 = this._x0,
      y0 = this._y0,
      x1 = this._x1,
      y1 = this._y1,
      x,
      y,
      xm,
      ym,
      right,
      bottom,
      i,
      j;

  // If the tree is empty, initialize the root as a leaf.
  if (!node) return this;

  // Find the leaf node for the point.
  // While descending, also retain the deepest parent with a non-removed sibling.
  if (node.length) while (true) {
    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
    if (!node.length) break;
    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
  }

  // Find the point to remove.
  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
  if (next = node.next) delete node.next;

  // If there are multiple coincident points, remove just the point.
  if (previous) return (next ? previous.next = next : delete previous.next), this;

  // If this is the root point, remove it.
  if (!parent) return this._root = next, this;

  // Remove this leaf.
  next ? parent[i] = next : delete parent[i];

  // If the parent now contains exactly one leaf, collapse superfluous parents.
  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
      && node === (parent[3] || parent[2] || parent[1] || parent[0])
      && !node.length) {
    if (retainer) retainer[j] = node;
    else this._root = node;
  }

  return this;
};

function removeAll(data) {
  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
  return this;
}

var tree_root = function() {
  return this._root;
};

var tree_size = function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
};

var tree_visit = function(callback) {
  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
    }
  }
  return this;
};

var tree_visitAfter = function(callback) {
  var quads = [], next = [], q;
  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
  while (q = quads.pop()) {
    var node = q.node;
    if (node.length) {
      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
    }
    next.push(q);
  }
  while (q = next.pop()) {
    callback(q.node, q.x0, q.y0, q.x1, q.y1);
  }
  return this;
};

function defaultX(d) {
  return d[0];
}

var tree_x = function(_) {
  return arguments.length ? (this._x = _, this) : this._x;
};

function defaultY(d) {
  return d[1];
}

var tree_y = function(_) {
  return arguments.length ? (this._y = _, this) : this._y;
};

function quadtree(nodes, x, y) {
  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
  return nodes == null ? tree : tree.addAll(nodes);
}

function Quadtree(x, y, x0, y0, x1, y1) {
  this._x = x;
  this._y = y;
  this._x0 = x0;
  this._y0 = y0;
  this._x1 = x1;
  this._y1 = y1;
  this._root = undefined;
}

function leaf_copy(leaf) {
  var copy = {data: leaf.data}, next = copy;
  while (leaf = leaf.next) next = next.next = {data: leaf.data};
  return copy;
}

var treeProto = quadtree.prototype = Quadtree.prototype;

treeProto.copy = function() {
  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      node = this._root,
      nodes,
      child;

  if (!node) return copy;

  if (!node.length) return copy._root = leaf_copy(node), copy;

  nodes = [{source: node, target: copy._root = new Array(4)}];
  while (node = nodes.pop()) {
    for (var i = 0; i < 4; ++i) {
      if (child = node.source[i]) {
        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
        else node.target[i] = leaf_copy(child);
      }
    }
  }

  return copy;
};

treeProto.add = tree_add;
treeProto.addAll = addAll;
treeProto.cover = tree_cover;
treeProto.data = tree_data;
treeProto.extent = tree_extent;
treeProto.find = tree_find;
treeProto.remove = tree_remove;
treeProto.removeAll = removeAll;
treeProto.root = tree_root;
treeProto.size = tree_size;
treeProto.visit = tree_visit;
treeProto.visitAfter = tree_visitAfter;
treeProto.x = tree_x;
treeProto.y = tree_y;

function x(d) {
  return d.x + d.vx;
}

function y(d) {
  return d.y + d.vy;
}

var collide = function(radius) {
  var nodes,
      radii,
      strength = 1,
      iterations = 1;

  if (typeof radius !== "function") radius = constant$6(radius == null ? 1 : +radius);

  function force() {
    var i, n = nodes.length,
        tree,
        node,
        xi,
        yi,
        ri,
        ri2;

    for (var k = 0; k < iterations; ++k) {
      tree = quadtree(nodes, x, y).visitAfter(prepare);
      for (i = 0; i < n; ++i) {
        node = nodes[i];
        ri = radii[node.index], ri2 = ri * ri;
        xi = node.x + node.vx;
        yi = node.y + node.vy;
        tree.visit(apply);
      }
    }

    function apply(quad, x0, y0, x1, y1) {
      var data = quad.data, rj = quad.r, r = ri + rj;
      if (data) {
        if (data.index > node.index) {
          var x = xi - data.x - data.vx,
              y = yi - data.y - data.vy,
              l = x * x + y * y;
          if (l < r * r) {
            if (x === 0) x = jiggle(), l += x * x;
            if (y === 0) y = jiggle(), l += y * y;
            l = (r - (l = Math.sqrt(l))) / l * strength;
            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
            node.vy += (y *= l) * r;
            data.vx -= x * (r = 1 - r);
            data.vy -= y * r;
          }
        }
        return;
      }
      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
    }
  }

  function prepare(quad) {
    if (quad.data) return quad.r = radii[quad.data.index];
    for (var i = quad.r = 0; i < 4; ++i) {
      if (quad[i] && quad[i].r > quad.r) {
        quad.r = quad[i].r;
      }
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    radii = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = +_, force) : strength;
  };

  force.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : radius;
  };

  return force;
};

function index(d) {
  return d.index;
}

function find(nodeById, nodeId) {
  var node = nodeById.get(nodeId);
  if (!node) throw new Error("missing: " + nodeId);
  return node;
}

var link = function(links) {
  var id = index,
      strength = defaultStrength,
      strengths,
      distance = constant$6(30),
      distances,
      nodes,
      count,
      bias,
      iterations = 1;

  if (links == null) links = [];

  function defaultStrength(link) {
    return 1 / Math.min(count[link.source.index], count[link.target.index]);
  }

  function force(alpha) {
    for (var k = 0, n = links.length; k < iterations; ++k) {
      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
        link = links[i], source = link.source, target = link.target;
        x = target.x + target.vx - source.x - source.vx || jiggle();
        y = target.y + target.vy - source.y - source.vy || jiggle();
        l = Math.sqrt(x * x + y * y);
        l = (l - distances[i]) / l * alpha * strengths[i];
        x *= l, y *= l;
        target.vx -= x * (b = bias[i]);
        target.vy -= y * b;
        source.vx += x * (b = 1 - b);
        source.vy += y * b;
      }
    }
  }

  function initialize() {
    if (!nodes) return;

    var i,
        n = nodes.length,
        m = links.length,
        nodeById = map$1(nodes, id),
        link;

    for (i = 0, count = new Array(n); i < m; ++i) {
      link = links[i], link.index = i;
      if (typeof link.source !== "object") link.source = find(nodeById, link.source);
      if (typeof link.target !== "object") link.target = find(nodeById, link.target);
      count[link.source.index] = (count[link.source.index] || 0) + 1;
      count[link.target.index] = (count[link.target.index] || 0) + 1;
    }

    for (i = 0, bias = new Array(m); i < m; ++i) {
      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
    }

    strengths = new Array(m), initializeStrength();
    distances = new Array(m), initializeDistance();
  }

  function initializeStrength() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      strengths[i] = +strength(links[i], i, links);
    }
  }

  function initializeDistance() {
    if (!nodes) return;

    for (var i = 0, n = links.length; i < n; ++i) {
      distances[i] = +distance(links[i], i, links);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.links = function(_) {
    return arguments.length ? (links = _, initialize(), force) : links;
  };

  force.id = function(_) {
    return arguments.length ? (id = _, force) : id;
  };

  force.iterations = function(_) {
    return arguments.length ? (iterations = +_, force) : iterations;
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initializeStrength(), force) : strength;
  };

  force.distance = function(_) {
    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$6(+_), initializeDistance(), force) : distance;
  };

  return force;
};

function x$1(d) {
  return d.x;
}

function y$1(d) {
  return d.y;
}

var initialRadius = 10;
var initialAngle = Math.PI * (3 - Math.sqrt(5));

var simulation = function(nodes) {
  var simulation,
      alpha = 1,
      alphaMin = 0.001,
      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
      alphaTarget = 0,
      velocityDecay = 0.6,
      forces = map$1(),
      stepper = timer(step),
      event = dispatch("tick", "end");

  if (nodes == null) nodes = [];

  function step() {
    tick();
    event.call("tick", simulation);
    if (alpha < alphaMin) {
      stepper.stop();
      event.call("end", simulation);
    }
  }

  function tick() {
    var i, n = nodes.length, node;

    alpha += (alphaTarget - alpha) * alphaDecay;

    forces.each(function(force) {
      force(alpha);
    });

    for (i = 0; i < n; ++i) {
      node = nodes[i];
      if (node.fx == null) node.x += node.vx *= velocityDecay;
      else node.x = node.fx, node.vx = 0;
      if (node.fy == null) node.y += node.vy *= velocityDecay;
      else node.y = node.fy, node.vy = 0;
    }
  }

  function initializeNodes() {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.index = i;
      if (isNaN(node.x) || isNaN(node.y)) {
        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
        node.x = radius * Math.cos(angle);
        node.y = radius * Math.sin(angle);
      }
      if (isNaN(node.vx) || isNaN(node.vy)) {
        node.vx = node.vy = 0;
      }
    }
  }

  function initializeForce(force) {
    if (force.initialize) force.initialize(nodes);
    return force;
  }

  initializeNodes();

  return simulation = {
    tick: tick,

    restart: function() {
      return stepper.restart(step), simulation;
    },

    stop: function() {
      return stepper.stop(), simulation;
    },

    nodes: function(_) {
      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
    },

    alpha: function(_) {
      return arguments.length ? (alpha = +_, simulation) : alpha;
    },

    alphaMin: function(_) {
      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
    },

    alphaDecay: function(_) {
      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
    },

    alphaTarget: function(_) {
      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
    },

    velocityDecay: function(_) {
      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
    },

    force: function(name, _) {
      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
    },

    find: function(x, y, radius) {
      var i = 0,
          n = nodes.length,
          dx,
          dy,
          d2,
          node,
          closest;

      if (radius == null) radius = Infinity;
      else radius *= radius;

      for (i = 0; i < n; ++i) {
        node = nodes[i];
        dx = x - node.x;
        dy = y - node.y;
        d2 = dx * dx + dy * dy;
        if (d2 < radius) closest = node, radius = d2;
      }

      return closest;
    },

    on: function(name, _) {
      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
    }
  };
};

var manyBody = function() {
  var nodes,
      node,
      alpha,
      strength = constant$6(-30),
      strengths,
      distanceMin2 = 1,
      distanceMax2 = Infinity,
      theta2 = 0.81;

  function force(_) {
    var i, n = nodes.length, tree = quadtree(nodes, x$1, y$1).visitAfter(accumulate);
    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length, node;
    strengths = new Array(n);
    for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
  }

  function accumulate(quad) {
    var strength = 0, q, c, x$$1, y$$1, i;

    // For internal nodes, accumulate forces from child quadrants.
    if (quad.length) {
      for (x$$1 = y$$1 = i = 0; i < 4; ++i) {
        if ((q = quad[i]) && (c = q.value)) {
          strength += c, x$$1 += c * q.x, y$$1 += c * q.y;
        }
      }
      quad.x = x$$1 / strength;
      quad.y = y$$1 / strength;
    }

    // For leaf nodes, accumulate forces from coincident quadrants.
    else {
      q = quad;
      q.x = q.data.x;
      q.y = q.data.y;
      do strength += strengths[q.data.index];
      while (q = q.next);
    }

    quad.value = strength;
  }

  function apply(quad, x1, _, x2) {
    if (!quad.value) return true;

    var x$$1 = quad.x - node.x,
        y$$1 = quad.y - node.y,
        w = x2 - x1,
        l = x$$1 * x$$1 + y$$1 * y$$1;

    // Apply the Barnes-Hut approximation if possible.
    // Limit forces for very close nodes; randomize direction if coincident.
    if (w * w / theta2 < l) {
      if (l < distanceMax2) {
        if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
        if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        node.vx += x$$1 * quad.value * alpha / l;
        node.vy += y$$1 * quad.value * alpha / l;
      }
      return true;
    }

    // Otherwise, process points directly.
    else if (quad.length || l >= distanceMax2) return;

    // Limit forces for very close nodes; randomize direction if coincident.
    if (quad.data !== node || quad.next) {
      if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
      if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
    }

    do if (quad.data !== node) {
      w = strengths[quad.data.index] * alpha / l;
      node.vx += x$$1 * w;
      node.vy += y$$1 * w;
    } while (quad = quad.next);
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.distanceMin = function(_) {
    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
  };

  force.distanceMax = function(_) {
    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
  };

  force.theta = function(_) {
    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
  };

  return force;
};

var x$2 = function(x) {
  var strength = constant$6(0.1),
      nodes,
      strengths,
      xz;

  if (typeof x !== "function") x = constant$6(x == null ? 0 : +x);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    xz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : x;
  };

  return force;
};

var y$2 = function(y) {
  var strength = constant$6(0.1),
      nodes,
      strengths,
      yz;

  if (typeof y !== "function") y = constant$6(y == null ? 0 : +y);

  function force(alpha) {
    for (var i = 0, n = nodes.length, node; i < n; ++i) {
      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
  }

  function initialize() {
    if (!nodes) return;
    var i, n = nodes.length;
    strengths = new Array(n);
    yz = new Array(n);
    for (i = 0; i < n; ++i) {
      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
  }

  force.initialize = function(_) {
    nodes = _;
    initialize();
  };

  force.strength = function(_) {
    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : strength;
  };

  force.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$6(+_), initialize(), force) : y;
  };

  return force;
};

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
var formatDecimal = function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
};

var exponent$1 = function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
};

var formatGroup = function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
};

var formatNumerals = function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
};

var formatDefault = function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
};

var prefixExponent;

var formatPrefixAuto = function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
};

var formatRounded = function(x, p) {
  var d = formatDecimal(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
};

var formatTypes = {
  "": formatDefault,
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
};

// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!formatTypes[type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};

var identity$3 = function(x) {
  return x;
};

var prefixes = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];

var formatLocale = function(locale) {
  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity$3,
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
};

var locale$1;



defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale$1 = formatLocale(definition);
  exports.format = locale$1.format;
  exports.formatPrefix = locale$1.formatPrefix;
  return locale$1;
}

var precisionFixed = function(step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
};

var precisionPrefix = function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
};

var precisionRound = function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
};

// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

var adder = function() {
  return new Adder;
};

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add$1(temp, y, this.t);
    add$1(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add$1(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}

var epsilon$2 = 1e-6;
var epsilon2$1 = 1e-12;
var pi$3 = Math.PI;
var halfPi$2 = pi$3 / 2;
var quarterPi = pi$3 / 4;
var tau$3 = pi$3 * 2;

var degrees$1 = 180 / pi$3;
var radians = pi$3 / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos$1 = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;

var log = Math.log;
var pow = Math.pow;
var sin$1 = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi$3 : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi$2 : x < -1 ? -halfPi$2 : Math.asin(x);
}

function haversin(x) {
  return (x = sin$1(x / 2)) * x;
}

function noop$1() {}

function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

var geoStream = function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
};

var areaRingSum = adder();

var areaSum = adder();
var lambda00;
var phi00;
var lambda0;
var cosPhi0;
var sinPhi0;

var areaStream = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? tau$3 + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = noop$1;
  },
  sphere: function() {
    areaSum.add(tau$3);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= radians, phi *= radians;
  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
}

function areaPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  phi = phi / 2 + quarterPi; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = cos$1(phi),
      sinPhi = sin$1(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
      v = k * sdLambda * sin$1(adLambda);
  areaRingSum.add(atan2(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

var area = function(object) {
  areaSum.reset();
  geoStream(object, areaStream);
  return areaSum * 2;
};

function spherical(cartesian) {
  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}

var lambda0$1;
var phi0;
var lambda1;
var phi1;
var lambda2;
var lambda00$1;
var phi00$1;
var p0;
var deltaSum = adder();
var ranges;
var range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    areaStream.polygonStart();
  },
  polygonEnd: function() {
    areaStream.polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > epsilon$2) phi1 = 90;
    else if (deltaSum < -epsilon$2) phi0 = -90;
    range[0] = lambda0$1, range[1] = lambda1;
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = cartesian([lambda * radians, phi * radians]);
  if (p0) {
    var normal = cartesianCross(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = cartesianCross(equatorial, normal);
    cartesianNormalizeInPlace(inflection);
    inflection = spherical(inflection);
    var delta = lambda - lambda2,
        sign$$1 = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * degrees$1 * sign$$1,
        phii,
        antimeridian = abs(delta) > 180;
    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
      phii = inflection[1] * degrees$1;
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
      phii = -inflection[1] * degrees$1;
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
      }
    } else {
      if (lambda1 >= lambda0$1) {
        if (lambda < lambda0$1) lambda0$1 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0$1 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0$1, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00$1 = lambda, phi00$1 = phi;
  }
  areaStream.point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  areaStream.lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00$1, phi00$1);
  areaStream.lineEnd();
  if (abs(deltaSum) > epsilon$2) lambda0$1 = -(lambda1 = 180);
  range[0] = lambda0$1, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

var bounds = function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
  ranges = [];
  geoStream(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0$1 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0$1, phi0], [lambda1, phi1]];
};

var W0;
var W1;
var X0;
var Y0;
var Z0;
var X1;
var Y1;
var Z1;
var X2;
var Y2;
var Z2;
var lambda00$2;
var phi00$2;
var x0;
var y0;
var z0; // previous point

var centroidStream = {
  sphere: noop$1,
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00$2, phi00$2);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00$2 = lambda, phi00$2 = phi;
  lambda *= radians, phi *= radians;
  centroidStream.point = centroidRingPoint;
  var cosPhi = cos$1(phi);
  x0 = cosPhi * cos$1(lambda);
  y0 = cosPhi * sin$1(lambda);
  z0 = sin$1(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var cosPhi = cos$1(phi),
      x = cosPhi * cos$1(lambda),
      y = cosPhi * sin$1(lambda),
      z = sin$1(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = sqrt(cx * cx + cy * cy + cz * cz),
      w = asin(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

var centroid = function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  geoStream(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < epsilon2$1) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < epsilon$2) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < epsilon2$1) return [NaN, NaN];
  }

  return [atan2(y, x) * degrees$1, asin(z / sqrt(m)) * degrees$1];
};

var constant$7 = function(x) {
  return function() {
    return x;
  };
};

var compose = function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
};

function rotationIdentity(lambda, phi) {
  return [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau$3) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > pi$3 ? lambda - tau$3 : lambda < -pi$3 ? lambda + tau$3 : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos$1(deltaPhi),
      sinDeltaPhi = sin$1(deltaPhi),
      cosDeltaGamma = cos$1(deltaGamma),
      sinDeltaGamma = sin$1(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      asin(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = cos$1(phi),
        x = cos$1(lambda) * cosPhi,
        y = sin$1(lambda) * cosPhi,
        z = sin$1(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      asin(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

var rotation = function(rotate) {
  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
  };

  return forward;
};

// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = cos$1(radius),
      sinRadius = sin$1(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau$3;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$3;
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = cartesian(point), point[0] -= cosRadius;
  cartesianNormalizeInPlace(point);
  var radius = acos(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + tau$3 - epsilon$2) % tau$3;
}

var circle = function() {
  var center = constant$7([0, 0]),
      radius = constant$7(90),
      precision = constant$7(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= degrees$1, x[1] *= degrees$1;
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * radians,
        p = precision.apply(this, arguments) * radians;
    ring = [];
    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : constant$7([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$7(+_), circle) : precision;
  };

  return circle;
};

var clipBuffer = function() {
  var lines = [],
      line;
  return {
    point: function(x, y) {
      line.push([x, y]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop$1,
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
};

var clipLine = function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
};

var pointEqual = function(a, b) {
  return abs(a[0] - b[0]) < epsilon$2 && abs(a[1] - b[1]) < epsilon$2;
};

function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    // If the first and last points of a segment are coincident, then treat as a
    // closed ring. TODO if all rings are closed, then the winding order of the
    // exterior ring should be checked.
    if (pointEqual(p0, p1)) {
      stream.lineStart();
      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
      stream.lineEnd();
      return;
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link$1(subject);
  link$1(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
};

function link$1(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}

var clipMax = 1e9;
var clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipExtent(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return abs(p[0] - x0) < epsilon$2 ? direction > 0 ? 0 : 3
        : abs(p[0] - x1) < epsilon$2 ? direction > 0 ? 2 : 1
        : abs(p[1] - y0) < epsilon$2 ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = clipBuffer(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = merge(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (clipLine(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}

var extent$1 = function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
};

var sum$1 = adder();

var polygonContains = function(polygon, point) {
  var lambda = point[0],
      phi = point[1],
      normal = [sin$1(lambda), -cos$1(lambda), 0],
      angle = 0,
      winding = 0;

  sum$1.reset();

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = point0[0],
        phi0 = point0[1] / 2 + quarterPi,
        sinPhi0 = sin$1(phi0),
        cosPhi0 = cos$1(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = point1[0],
          phi1 = point1[1] / 2 + quarterPi,
          sinPhi1 = sin$1(phi1),
          cosPhi1 = cos$1(phi1),
          delta = lambda1 - lambda0,
          sign$$1 = delta >= 0 ? 1 : -1,
          absDelta = sign$$1 * delta,
          antimeridian = absDelta > pi$3,
          k = sinPhi0 * sinPhi1;

      sum$1.add(atan2(k * sign$$1 * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
      angle += antimeridian ? delta + sign$$1 * tau$3 : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -epsilon$2 || angle < epsilon$2 && sum$1 < -epsilon$2) ^ (winding & 1);
};

var lengthSum = adder();
var lambda0$2;
var sinPhi0$1;
var cosPhi0$1;

var lengthStream = {
  sphere: noop$1,
  point: noop$1,
  lineStart: lengthLineStart,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = noop$1;
}

function lengthPointFirst(lambda, phi) {
  lambda *= radians, phi *= radians;
  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= radians, phi *= radians;
  var sinPhi = sin$1(phi),
      cosPhi = cos$1(phi),
      delta = abs(lambda - lambda0$2),
      cosDelta = cos$1(delta),
      sinDelta = sin$1(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
  lengthSum.add(atan2(sqrt(x * x + y * y), z));
  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
}

var length$1 = function(object) {
  lengthSum.reset();
  geoStream(object, lengthStream);
  return +lengthSum;
};

var coordinates = [null, null];
var object$1 = {type: "LineString", coordinates: coordinates};

var distance = function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return length$1(object$1);
};

var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return distance(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ab = distance(coordinates[0], coordinates[1]),
      ao = distance(coordinates[0], point),
      ob = distance(point, coordinates[1]);
  return ao + ob <= ab + epsilon$2;
}

function containsPolygon(coordinates, point) {
  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * radians, point[1] * radians];
}

var contains = function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
};

function graticuleX(y0, y1, dy) {
  var y = sequence(y0, y1 - epsilon$2, dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = sequence(x0, x1 - epsilon$2, dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return sequence(ceil(X0 / DX) * DX, X1, DX).map(X)
        .concat(sequence(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(sequence(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$2; }).map(x))
        .concat(sequence(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$2; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + epsilon$2], [180, 90 - epsilon$2]])
      .extentMinor([[-180, -80 - epsilon$2], [180, 80 + epsilon$2]]);
}

function graticule10() {
  return graticule()();
}

var interpolate$1 = function(a, b) {
  var x0 = a[0] * radians,
      y0 = a[1] * radians,
      x1 = b[0] * radians,
      y1 = b[1] * radians,
      cy0 = cos$1(y0),
      sy0 = sin$1(y0),
      cy1 = cos$1(y1),
      sy1 = sin$1(y1),
      kx0 = cy0 * cos$1(x0),
      ky0 = cy0 * sin$1(x0),
      kx1 = cy1 * cos$1(x1),
      ky1 = cy1 * sin$1(x1),
      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
      k = sin$1(d);

  var interpolate = d ? function(t) {
    var B = sin$1(t *= d) / k,
        A = sin$1(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      atan2(y, x) * degrees$1,
      atan2(z, sqrt(x * x + y * y)) * degrees$1
    ];
  } : function() {
    return [x0 * degrees$1, y0 * degrees$1];
  };

  interpolate.distance = d;

  return interpolate;
};

var identity$4 = function(x) {
  return x;
};

var areaSum$1 = adder();
var areaRingSum$1 = adder();
var x00;
var y00;
var x0$1;
var y0$1;

var areaStream$1 = {
  point: noop$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: function() {
    areaStream$1.lineStart = areaRingStart$1;
    areaStream$1.lineEnd = areaRingEnd$1;
  },
  polygonEnd: function() {
    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$1;
    areaSum$1.add(abs(areaRingSum$1));
    areaRingSum$1.reset();
  },
  result: function() {
    var area = areaSum$1 / 2;
    areaSum$1.reset();
    return area;
  }
};

function areaRingStart$1() {
  areaStream$1.point = areaPointFirst$1;
}

function areaPointFirst$1(x, y) {
  areaStream$1.point = areaPoint$1;
  x00 = x0$1 = x, y00 = y0$1 = y;
}

function areaPoint$1(x, y) {
  areaRingSum$1.add(y0$1 * x - x0$1 * y);
  x0$1 = x, y0$1 = y;
}

function areaRingEnd$1() {
  areaPoint$1(x00, y00);
}

var x0$2 = Infinity;
var y0$2 = x0$2;
var x1 = -x0$2;
var y1 = x1;

var boundsStream$1 = {
  point: boundsPoint$1,
  lineStart: noop$1,
  lineEnd: noop$1,
  polygonStart: noop$1,
  polygonEnd: noop$1,
  result: function() {
    var bounds = [[x0$2, y0$2], [x1, y1]];
    x1 = y1 = -(y0$2 = x0$2 = Infinity);
    return bounds;
  }
};

function boundsPoint$1(x, y) {
  if (x < x0$2) x0$2 = x;
  if (x > x1) x1 = x;
  if (y < y0$2) y0$2 = y;
  if (y > y1) y1 = y;
}

// TODO Enforce positive area for exterior, negative area for interior?

var X0$1 = 0;
var Y0$1 = 0;
var Z0$1 = 0;
var X1$1 = 0;
var Y1$1 = 0;
var Z1$1 = 0;
var X2$1 = 0;
var Y2$1 = 0;
var Z2$1 = 0;
var x00$1;
var y00$1;
var x0$3;
var y0$3;

var centroidStream$1 = {
  point: centroidPoint$1,
  lineStart: centroidLineStart$1,
  lineEnd: centroidLineEnd$1,
  polygonStart: function() {
    centroidStream$1.lineStart = centroidRingStart$1;
    centroidStream$1.lineEnd = centroidRingEnd$1;
  },
  polygonEnd: function() {
    centroidStream$1.point = centroidPoint$1;
    centroidStream$1.lineStart = centroidLineStart$1;
    centroidStream$1.lineEnd = centroidLineEnd$1;
  },
  result: function() {
    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
        : [NaN, NaN];
    X0$1 = Y0$1 = Z0$1 =
    X1$1 = Y1$1 = Z1$1 =
    X2$1 = Y2$1 = Z2$1 = 0;
    return centroid;
  }
};

function centroidPoint$1(x, y) {
  X0$1 += x;
  Y0$1 += y;
  ++Z0$1;
}

function centroidLineStart$1() {
  centroidStream$1.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream$1.point = centroidPointLine;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function centroidLineEnd$1() {
  centroidStream$1.point = centroidPoint$1;
}

function centroidRingStart$1() {
  centroidStream$1.point = centroidPointFirstRing;
}

function centroidRingEnd$1() {
  centroidPointRing(x00$1, y00$1);
}

function centroidPointFirstRing(x, y) {
  centroidStream$1.point = centroidPointRing;
  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0$3,
      dy = y - y0$3,
      z = sqrt(dx * dx + dy * dy);

  X1$1 += z * (x0$3 + x) / 2;
  Y1$1 += z * (y0$3 + y) / 2;
  Z1$1 += z;

  z = y0$3 * x - x0$3 * y;
  X2$1 += z * (x0$3 + x);
  Y2$1 += z * (y0$3 + y);
  Z2$1 += z * 3;
  centroidPoint$1(x0$3 = x, y0$3 = y);
}

function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, tau$3);
        break;
      }
    }
  },
  result: noop$1
};

var lengthSum$1 = adder();
var lengthRing;
var x00$2;
var y00$2;
var x0$4;
var y0$4;

var lengthStream$1 = {
  point: noop$1,
  lineStart: function() {
    lengthStream$1.point = lengthPointFirst$1;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint$1(x00$2, y00$2);
    lengthStream$1.point = noop$1;
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum$1;
    lengthSum$1.reset();
    return length;
  }
};

function lengthPointFirst$1(x, y) {
  lengthStream$1.point = lengthPoint$1;
  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
}

function lengthPoint$1(x, y) {
  x0$4 -= x, y0$4 -= y;
  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
  x0$4 = x, y0$4 = y;
}

function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle$1(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle$1(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle$1(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}

var index$1 = function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      geoStream(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    geoStream(object, projectionStream(areaStream$1));
    return areaStream$1.result();
  };

  path.measure = function(object) {
    geoStream(object, projectionStream(lengthStream$1));
    return lengthStream$1.result();
  };

  path.bounds = function(object) {
    geoStream(object, projectionStream(boundsStream$1));
    return boundsStream$1.result();
  };

  path.centroid = function(object) {
    geoStream(object, projectionStream(centroidStream$1));
    return centroidStream$1.result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity$4) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
};

var clip = function(pointVisible, clipLine, interpolate, start) {
  return function(rotate, sink) {
    var line = clipLine(sink),
        rotatedStart = rotate.invert(start[0], start[1]),
        ringBuffer = clipBuffer(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = merge(segments);
        var startInside = polygonContains(polygon, rotatedStart);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      var point = rotate(lambda, phi);
      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      var point = rotate(lambda, phi);
      line.point(point[0], point[1]);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point = rotate(lambda, phi);
      ringSink.point(point[0], point[1]);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
};

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - halfPi$2 - epsilon$2 : halfPi$2 - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - halfPi$2 - epsilon$2 : halfPi$2 - b[1]);
}

var clipAntimeridian = clip(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi$3, -halfPi$2]
);

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi$3 : -pi$3,
          delta = abs(lambda1 - lambda0);
      if (abs(delta - pi$3) < epsilon$2) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$2 : -halfPi$2);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi$3) { // line crosses antimeridian
        if (abs(lambda0 - sign0) < epsilon$2) lambda0 -= sign0 * epsilon$2; // handle degeneracies
        if (abs(lambda1 - sign1) < epsilon$2) lambda1 -= sign1 * epsilon$2;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > epsilon$2
      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * halfPi$2;
    stream.point(-pi$3, phi);
    stream.point(0, phi);
    stream.point(pi$3, phi);
    stream.point(pi$3, 0);
    stream.point(pi$3, -phi);
    stream.point(0, -phi);
    stream.point(-pi$3, -phi);
    stream.point(-pi$3, 0);
    stream.point(-pi$3, phi);
  } else if (abs(from[0] - to[0]) > epsilon$2) {
    var lambda = from[0] < to[0] ? pi$3 : -pi$3;
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}

var clipCircle = function(radius, delta) {
  var cr = cos$1(radius),
      smallRadius = cr > 0,
      notHemisphere = abs(cr) > epsilon$2; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    circleStream(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return cos$1(lambda) * cos$1(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? pi$3 : -pi$3), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        // Handle degeneracies.
        // TODO ignore if not clipping polygons.
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
            point1[0] += epsilon$2;
            point1[1] += epsilon$2;
            v = visible(point1[0], point1[1]);
          }
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1]);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
            }
          }
        }
        if (v && (!point0 || !pointEqual(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = cartesian(a),
        pb = cartesian(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = cartesianCross(pa, pb),
        n2n2 = cartesianDot(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = cartesianCross(n1, n2),
        A = cartesianScale(n1, c1),
        B = cartesianScale(n2, c2);
    cartesianAddInPlace(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = cartesianDot(A, u),
        uu = cartesianDot(u, u),
        t2 = w * w - uu * (cartesianDot(A, A) - 1);

    if (t2 < 0) return;

    var t = sqrt(t2),
        q = cartesianScale(u, (-w - t) / uu);
    cartesianAddInPlace(q, A);
    q = spherical(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = abs(delta - pi$3) < epsilon$2,
        meridian = polar || delta < epsilon$2;

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$2 ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > pi$3 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = cartesianScale(u, (-w + t) / uu);
      cartesianAddInPlace(q1, A);
      return [q, spherical(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : pi$3 - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$3, radius - pi$3]);
};

var transform = function(methods) {
  return {
    stream: transformer(methods)
  };
};

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};

function fitExtent(projection, extent, object) {
  var w = extent[1][0] - extent[0][0],
      h = extent[1][1] - extent[0][1],
      clip = projection.clipExtent && projection.clipExtent();

  projection
      .scale(150)
      .translate([0, 0]);

  if (clip != null) projection.clipExtent(null);

  geoStream(object, projection.stream(boundsStream$1));

  var b = boundsStream$1.result(),
      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;

  if (clip != null) projection.clipExtent(clip);

  return projection
      .scale(k * 150)
      .translate([x, y]);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

var maxDepth = 16;
var cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)

var resample = function(project, delta2) {
  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
};

function resampleNone(project) {
  return transformer({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample$1(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = sqrt(a * a + b * b + c * c),
          phi2 = asin(c /= m),
          lambda2 = abs(abs(c) - 1) < epsilon$2 || abs(lambda0 - lambda1) < epsilon$2 ? (lambda0 + lambda1) / 2 : atan2(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = cartesian([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}

var transformRadians = transformer({
  point: function(x, y) {
    this.stream.point(x * radians, y * radians);
  }
});

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      dx, dy, lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
      theta = null, preclip = clipAntimeridian, // clip angle
      x0 = null, y0, x1, y1, postclip = identity$4, // clip extent
      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
      cache,
      cacheStream;

  function projection(point) {
    point = projectRotate(point[0] * radians, point[1] * radians);
    return [point[0] * k + dx, dy - point[1] * k];
  }

  function invert(point) {
    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
    return point && [point[0] * degrees$1, point[1] * degrees$1];
  }

  function projectTransform(x, y) {
    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return fitExtent(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return fitSize(projection, size, object);
  };

  function recenter() {
    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
    var center = project(lambda, phi);
    dx = x - center[0] * k;
    dy = y + center[1] * k;
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}

function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = pi$3 / 3,
      m = projectionMutator(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
  };

  return p;
}

function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos$1(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin$1(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };

  return forward;
}

function conicEqualAreaRaw(y0, y1) {
  var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (abs(n) < epsilon$2) return cylindricalEqualAreaRaw(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;

  function project(x, y) {
    var r = sqrt(c - 2 * n * sin$1(y)) / n;
    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y;
    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

var conicEqualArea = function() {
  return conicProjection(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
};

var albers = function() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
};

// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
var albersUsa = function() {
  var cache,
      cacheStream,
      lower48 = albers(), lower48Point,
      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + epsilon$2, y + 0.120 * k + epsilon$2], [x - 0.214 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + epsilon$2, y + 0.166 * k + epsilon$2], [x - 0.115 * k - epsilon$2, y + 0.234 * k - epsilon$2]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return fitExtent(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return fitSize(albersUsa, size, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
};

function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = cos$1(x),
        cy = cos$1(y),
        k = scale(cx * cy);
    return [
      k * cy * sin$1(x),
      k * sin$1(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = sqrt(x * x + y * y),
        c = angle(z),
        sc = sin$1(c),
        cc = cos$1(c);
    return [
      atan2(x * sc, z * cc),
      asin(z && y * sc / z)
    ];
  }
}

var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
  return sqrt(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
  return 2 * asin(z / 2);
});

var azimuthalEqualArea = function() {
  return projection(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
};

var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
  return (c = acos(c)) && c / sin$1(c);
});

azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
  return z;
});

var azimuthalEquidistant = function() {
  return projection(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
};

function mercatorRaw(lambda, phi) {
  return [lambda, log(tan((halfPi$2 + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * atan(exp(y)) - halfPi$2];
};

var mercator = function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / tau$3);
};

function mercatorProjection(project) {
  var m = projection(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = pi$3 * scale(),
        t = m(rotation(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}

function tany(y) {
  return tan((halfPi$2 + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : log(cy0 / cos$1(y1)) / log(tany(y1) / tany(y0)),
      f = cy0 * pow(tany(y0), n) / n;

  if (!n) return mercatorRaw;

  function project(x, y) {
    if (f > 0) { if (y < -halfPi$2 + epsilon$2) y = -halfPi$2 + epsilon$2; }
    else { if (y > halfPi$2 - epsilon$2) y = halfPi$2 - epsilon$2; }
    var r = f / pow(tany(y), n);
    return [r * sin$1(n * x), f - r * cos$1(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi$2];
  };

  return project;
}

var conicConformal = function() {
  return conicProjection(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
};

function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

var equirectangular = function() {
  return projection(equirectangularRaw)
      .scale(152.63);
};

function conicEquidistantRaw(y0, y1) {
  var cy0 = cos$1(y0),
      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (abs(n) < epsilon$2) return equirectangularRaw;

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * sin$1(nx), g - gy * cos$1(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y;
    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
  };

  return project;
}

var conicEquidistant = function() {
  return conicProjection(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
};

function gnomonicRaw(x, y) {
  var cy = cos$1(y), k = cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

gnomonicRaw.invert = azimuthalInvert(atan);

var gnomonic = function() {
  return projection(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
};

function scaleTranslate(kx, ky, tx, ty) {
  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity$4 : transformer({
    point: function(x, y) {
      this.stream.point(x * kx + tx, y * ky + ty);
    }
  });
}

var identity$5 = function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = identity$4, // scale, translate and reflect
      x0 = null, y0, x1, y1, clip = identity$4, // clip extent
      cache,
      cacheStream,
      projection;

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return projection = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = transform(clip(cacheStream = stream));
    },
    clipExtent: function(_) {
      return arguments.length ? (clip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$4) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
    },
    scale: function(_) {
      return arguments.length ? (transform = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
    },
    translate: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
    },
    reflectX: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
    },
    reflectY: function(_) {
      return arguments.length ? (transform = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
    },
    fitExtent: function(extent, object) {
      return fitExtent(projection, extent, object);
    },
    fitSize: function(size, object) {
      return fitSize(projection, size, object);
    }
  };
};

function orthographicRaw(x, y) {
  return [cos$1(y) * sin$1(x), sin$1(y)];
}

orthographicRaw.invert = azimuthalInvert(asin);

var orthographic = function() {
  return projection(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + epsilon$2);
};

function stereographicRaw(x, y) {
  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
  return [cy * sin$1(x) / k, sin$1(y) / k];
}

stereographicRaw.invert = azimuthalInvert(function(z) {
  return 2 * atan(z);
});

var stereographic = function() {
  return projection(stereographicRaw)
      .scale(250)
      .clipAngle(142);
};

function transverseMercatorRaw(lambda, phi) {
  return [log(tan((halfPi$2 + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * atan(exp(x)) - halfPi$2];
};

var transverseMercator = function() {
  var m = mercatorProjection(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
};

function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

var cluster = function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
};

function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

var node_count = function() {
  return this.eachAfter(count);
};

var node_each = function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
};

var node_eachBefore = function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
};

var node_eachAfter = function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
};

var node_sum = function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
};

var node_sort = function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
};

var node_path = function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
};

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}

var node_ancestors = function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
};

var node_descendants = function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
};

var node_leaves = function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
};

var node_links = function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
};

function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy
};

function Node$2(value) {
  this._ = value;
  this.next = null;
}

var shuffle$1 = function(array) {
  var i,
      n = (array = array.slice()).length,
      head = null,
      node = head;

  while (n) {
    var next = new Node$2(array[n - 1]);
    if (node) node = node.next = next;
    else node = head = next;
    array[i] = array[--n];
  }

  return {
    head: head,
    tail: node
  };
};

var enclose = function(circles) {
  return encloseN(shuffle$1(circles), []);
};

function encloses(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r - b.r;
  return dr * dr + 1e-6 > dx * dx + dy * dy;
}

// Returns the smallest circle that contains circles L and intersects circles B.
function encloseN(L, B) {
  var circle,
      l0 = null,
      l1 = L.head,
      l2,
      p1;

  switch (B.length) {
    case 1: circle = enclose1(B[0]); break;
    case 2: circle = enclose2(B[0], B[1]); break;
    case 3: circle = enclose3(B[0], B[1], B[2]); break;
  }

  while (l1) {
    p1 = l1._, l2 = l1.next;
    if (!circle || !encloses(circle, p1)) {

      // Temporarily truncate L before l1.
      if (l0) L.tail = l0, l0.next = null;
      else L.head = L.tail = null;

      B.push(p1);
      circle = encloseN(L, B); // Note: reorders L!
      B.pop();

      // Move l1 to the front of L and reconnect the truncated list L.
      if (L.head) l1.next = L.head, L.head = l1;
      else l1.next = null, L.head = L.tail = l1;
      l0 = L.tail, l0.next = l2;

    } else {
      l0 = l1;
    }
    l1 = l2;
  }

  L.tail = l0;
  return circle;
}

function enclose1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function enclose2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function enclose3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = 2 * (x1 - x2),
      b2 = 2 * (y1 - y2),
      c2 = 2 * (r2 - r1),
      d2 = x1 * x1 + y1 * y1 - r1 * r1 - x2 * x2 - y2 * y2 + r2 * r2,
      a3 = 2 * (x1 - x3),
      b3 = 2 * (y1 - y3),
      c3 = 2 * (r3 - r1),
      d3 = x1 * x1 + y1 * y1 - r1 * r1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / ab - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / ab - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (xa * xb + ya * yb + r1),
      C = xa * xa + ya * ya - r1 * r1,
      r = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
  return {
    x: xa + xb * r + x1,
    y: ya + yb * r + y1,
    r: r
  };
}

function place(a, b, c) {
  var ax = a.x,
      ay = a.y,
      da = b.r + c.r,
      db = a.r + c.r,
      dx = b.x - ax,
      dy = b.y - ay,
      dc = dx * dx + dy * dy;
  if (dc) {
    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
    c.x = ax + x * dx + y * dy;
    c.y = ay + x * dy - y * dx;
  } else {
    c.x = ax + db;
    c.y = ay;
  }
}

function intersects(a, b) {
  var dx = b.x - a.x,
      dy = b.y - a.y,
      dr = a.r + b.r;
  return dr * dr - 1e-6 > dx * dx + dy * dy;
}

function distance2(node, x, y) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab - x,
      dy = (a.y * b.r + b.y * a.r) / ab - y;
  return dx * dx + dy * dy;
}

function Node$1(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the weighted centroid.
  var aa = a.r * a.r,
      ba = b.r * b.r,
      ca = c.r * c.r,
      oa = aa + ba + ca,
      ox = aa * a.x + ba * b.x + ca * c.x,
      oy = aa * a.y + ba * b.y + ca * c.y,
      cx, cy, i, j, k, sj, sk;

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node$1(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Update the weighted centroid.
    oa += ca = c._.r * c._.r;
    ox += ca * c._.x;
    oy += ca * c._.y;

    // Compute the new closest circle pair to the centroid.
    aa = distance2(a, cx = ox / oa, cy = oy / oa);
    while ((c = c.next) !== b) {
      if ((ca = distance2(c, cx, cy)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

var siblings = function(circles) {
  packEnclose(circles);
  return circles;
};

function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}

function constantZero() {
  return 0;
}

var constant$8 = function(x) {
  return function() {
    return x;
  };
};

function defaultRadius$1(d) {
  return Math.sqrt(d.value);
}

var index$2 = function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = constantZero;

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius$1))
          .eachAfter(packChildren(constantZero, 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = optional(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : constant$8(+x), pack) : padding;
  };

  return pack;
};

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = packEnclose(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}

var roundNode = function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
};

var treemapDice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
};

var partition = function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
};

var keyPrefix$1 = "$";
var preroot = {depth: -1};
var ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

var stratify = function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new Node(d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix$1 + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix$1 + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = required(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = required(x), stratify) : parentId;
  };

  return stratify;
};

function defaultSeparation$1(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(Node.prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
var tree = function() {
  var separation = defaultSeparation$1,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
};

var treemapSlice = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
};

var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

var squarify = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
}))(phi);

var index$3 = function() {
  var tile = squarify,
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = constantZero,
      paddingTop = constantZero,
      paddingRight = constantZero,
      paddingBottom = constantZero,
      paddingLeft = constantZero;

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(roundNode);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = required(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$8(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$8(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$8(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$8(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$8(+x), treemap) : paddingLeft;
  };

  return treemap;
};

var binary = function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
};

var sliceDice = function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
};

var resquarify = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
}))(phi);

var area$1 = function(polygon) {
  var i = -1,
      n = polygon.length,
      a,
      b = polygon[n - 1],
      area = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    area += a[1] * b[0] - a[0] * b[1];
  }

  return area / 2;
};

var centroid$1 = function(polygon) {
  var i = -1,
      n = polygon.length,
      x = 0,
      y = 0,
      a,
      b = polygon[n - 1],
      c,
      k = 0;

  while (++i < n) {
    a = b;
    b = polygon[i];
    k += c = a[0] * b[1] - b[0] * a[1];
    x += (a[0] + b[0]) * c;
    y += (a[1] + b[1]) * c;
  }

  return k *= 3, [x / k, y / k];
};

// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
var cross$1 = function(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
};

function lexicographicOrder(a, b) {
  return a[0] - b[0] || a[1] - b[1];
}

// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
  var n = points.length,
      indexes = [0, 1],
      size = 2;

  for (var i = 2; i < n; ++i) {
    while (size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
    indexes[size++] = i;
  }

  return indexes.slice(0, size); // remove popped points
}

var hull = function(points) {
  if ((n = points.length) < 3) return null;

  var i,
      n,
      sortedPoints = new Array(n),
      flippedPoints = new Array(n);

  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
  sortedPoints.sort(lexicographicOrder);
  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];

  var upperIndexes = computeUpperHullIndexes(sortedPoints),
      lowerIndexes = computeUpperHullIndexes(flippedPoints);

  // Construct the hull polygon, removing possible duplicate endpoints.
  var skipLeft = lowerIndexes[0] === upperIndexes[0],
      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
      hull = [];

  // Add upper hull in right-to-l order.
  // Then add lower hull in left-to-right order.
  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);

  return hull;
};

var contains$1 = function(polygon, point) {
  var n = polygon.length,
      p = polygon[n - 1],
      x = point[0], y = point[1],
      x0 = p[0], y0 = p[1],
      x1, y1,
      inside = false;

  for (var i = 0; i < n; ++i) {
    p = polygon[i], x1 = p[0], y1 = p[1];
    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
    x0 = x1, y0 = y1;
  }

  return inside;
};

var length$2 = function(polygon) {
  var i = -1,
      n = polygon.length,
      b = polygon[n - 1],
      xa,
      ya,
      xb = b[0],
      yb = b[1],
      perimeter = 0;

  while (++i < n) {
    xa = xb;
    ya = yb;
    b = polygon[i];
    xb = b[0];
    yb = b[1];
    xa -= xb;
    ya -= yb;
    perimeter += Math.sqrt(xa * xa + ya * ya);
  }

  return perimeter;
};

var slice$3 = [].slice;

var noabort = {};

function Queue(size) {
  this._size = size;
  this._call =
  this._error = null;
  this._tasks = [];
  this._data = [];
  this._waiting =
  this._active =
  this._ended =
  this._start = 0; // inside a synchronous task callback?
}

Queue.prototype = queue.prototype = {
  constructor: Queue,
  defer: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = slice$3.call(arguments, 1);
    t.push(callback);
    ++this._waiting, this._tasks.push(t);
    poke$1(this);
    return this;
  },
  abort: function() {
    if (this._error == null) abort(this, new Error("abort"));
    return this;
  },
  await: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
    maybeNotify(this);
    return this;
  },
  awaitAll: function(callback) {
    if (typeof callback !== "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    this._call = callback;
    maybeNotify(this);
    return this;
  }
};

function poke$1(q) {
  if (!q._start) {
    try { start$1(q); } // let the current task complete
    catch (e) {
      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
      else if (!q._data) throw e; // await callback errored synchronously
    }
  }
}

function start$1(q) {
  while (q._start = q._waiting && q._active < q._size) {
    var i = q._ended + q._active,
        t = q._tasks[i],
        j = t.length - 1,
        c = t[j];
    t[j] = end(q, i);
    --q._waiting, ++q._active;
    t = c.apply(null, t);
    if (!q._tasks[i]) continue; // task finished synchronously
    q._tasks[i] = t || noabort;
  }
}

function end(q, i) {
  return function(e, r) {
    if (!q._tasks[i]) return; // ignore multiple callbacks
    --q._active, ++q._ended;
    q._tasks[i] = null;
    if (q._error != null) return; // ignore secondary errors
    if (e != null) {
      abort(q, e);
    } else {
      q._data[i] = r;
      if (q._waiting) poke$1(q);
      else maybeNotify(q);
    }
  };
}

function abort(q, e) {
  var i = q._tasks.length, t;
  q._error = e; // ignore active callbacks
  q._data = undefined; // allow gc
  q._waiting = NaN; // prevent starting

  while (--i >= 0) {
    if (t = q._tasks[i]) {
      q._tasks[i] = null;
      if (t.abort) {
        try { t.abort(); }
        catch (e) { /* ignore */ }
      }
    }
  }

  q._active = NaN; // allow notification
  maybeNotify(q);
}

function maybeNotify(q) {
  if (!q._active && q._call) {
    var d = q._data;
    q._data = undefined; // allow gc
    q._call(q._error, d);
  }
}

function queue(concurrency) {
  if (concurrency == null) concurrency = Infinity;
  else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
  return new Queue(concurrency);
}

var defaultSource$1 = function() {
  return Math.random();
};

var uniform = ((function sourceRandomUniform(source) {
  function randomUniform(min, max) {
    min = min == null ? 0 : +min;
    max = max == null ? 1 : +max;
    if (arguments.length === 1) max = min, min = 0;
    else max -= min;
    return function() {
      return source() * max + min;
    };
  }

  randomUniform.source = sourceRandomUniform;

  return randomUniform;
}))(defaultSource$1);

var normal = ((function sourceRandomNormal(source) {
  function randomNormal(mu, sigma) {
    var x, r;
    mu = mu == null ? 0 : +mu;
    sigma = sigma == null ? 1 : +sigma;
    return function() {
      var y;

      // If available, use the second previously-generated uniform random.
      if (x != null) y = x, x = null;

      // Otherwise, generate a new x and y.
      else do {
        x = source() * 2 - 1;
        y = source() * 2 - 1;
        r = x * x + y * y;
      } while (!r || r > 1);

      return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
    };
  }

  randomNormal.source = sourceRandomNormal;

  return randomNormal;
}))(defaultSource$1);

var logNormal = ((function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = normal.source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
}))(defaultSource$1);

var irwinHall = ((function sourceRandomIrwinHall(source) {
  function randomIrwinHall(n) {
    return function() {
      for (var sum = 0, i = 0; i < n; ++i) sum += source();
      return sum;
    };
  }

  randomIrwinHall.source = sourceRandomIrwinHall;

  return randomIrwinHall;
}))(defaultSource$1);

var bates = ((function sourceRandomBates(source) {
  function randomBates(n) {
    var randomIrwinHall = irwinHall.source(source)(n);
    return function() {
      return randomIrwinHall() / n;
    };
  }

  randomBates.source = sourceRandomBates;

  return randomBates;
}))(defaultSource$1);

var exponential$1 = ((function sourceRandomExponential(source) {
  function randomExponential(lambda) {
    return function() {
      return -Math.log(1 - source()) / lambda;
    };
  }

  randomExponential.source = sourceRandomExponential;

  return randomExponential;
}))(defaultSource$1);

var request = function(url, callback) {
  var request,
      event = dispatch("beforesend", "progress", "load", "error"),
      mimeType,
      headers = map$1(),
      xhr = new XMLHttpRequest,
      user = null,
      password = null,
      response,
      responseType,
      timeout = 0;

  // If IE does not support CORS, use XDomainRequest.
  if (typeof XDomainRequest !== "undefined"
      && !("withCredentials" in xhr)
      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;

  "onload" in xhr
      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };

  function respond(o) {
    var status = xhr.status, result;
    if (!status && hasResponse(xhr)
        || status >= 200 && status < 300
        || status === 304) {
      if (response) {
        try {
          result = response.call(request, xhr);
        } catch (e) {
          event.call("error", request, e);
          return;
        }
      } else {
        result = xhr;
      }
      event.call("load", request, result);
    } else {
      event.call("error", request, o);
    }
  }

  xhr.onprogress = function(e) {
    event.call("progress", request, e);
  };

  request = {
    header: function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers.get(name);
      if (value == null) headers.remove(name);
      else headers.set(name, value + "");
      return request;
    },

    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return request;
    },

    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return request;
    },

    timeout: function(value) {
      if (!arguments.length) return timeout;
      timeout = +value;
      return request;
    },

    user: function(value) {
      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
    },

    password: function(value) {
      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
    },

    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(value) {
      response = value;
      return request;
    },

    // Alias for send("GET", …).
    get: function(data, callback) {
      return request.send("GET", data, callback);
    },

    // Alias for send("POST", …).
    post: function(data, callback) {
      return request.send("POST", data, callback);
    },

    // If callback is non-null, it will be used for error and load events.
    send: function(method, data, callback) {
      xhr.open(method, url, true, user, password);
      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
      if (responseType != null) xhr.responseType = responseType;
      if (timeout > 0) xhr.timeout = timeout;
      if (callback == null && typeof data === "function") callback = data, data = null;
      if (callback != null && callback.length === 1) callback = fixCallback(callback);
      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
      event.call("beforesend", request, xhr);
      xhr.send(data == null ? null : data);
      return request;
    },

    abort: function() {
      xhr.abort();
      return request;
    },

    on: function() {
      var value = event.on.apply(event, arguments);
      return value === event ? request : value;
    }
  };

  if (callback != null) {
    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
    return request.get(callback);
  }

  return request;
};

function fixCallback(callback) {
  return function(error, xhr) {
    callback(error == null ? xhr : null);
  };
}

function hasResponse(xhr) {
  var type = xhr.responseType;
  return type && type !== "text"
      ? xhr.response // null on error
      : xhr.responseText; // "" on error
}

var type$1 = function(defaultMimeType, response) {
  return function(url, callback) {
    var r = request(url).mimeType(defaultMimeType).response(response);
    if (callback != null) {
      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
      return r.get(callback);
    }
    return r;
  };
};

var html = type$1("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});

var json = type$1("application/json", function(xhr) {
  return JSON.parse(xhr.responseText);
});

var text = type$1("text/plain", function(xhr) {
  return xhr.responseText;
});

var xml = type$1("application/xml", function(xhr) {
  var xml = xhr.responseXML;
  if (!xml) throw new Error("parse error");
  return xml;
});

var dsv$1 = function(defaultMimeType, parse) {
  return function(url, row, callback) {
    if (arguments.length < 3) callback = row, row = null;
    var r = request(url).mimeType(defaultMimeType);
    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
    r.row(row);
    return callback ? r.get(callback) : r;
  };
};

function responseOf(parse, row) {
  return function(request$$1) {
    return parse(request$$1.responseText, row);
  };
}

var csv$1 = dsv$1("text/csv", csvParse);

var tsv$1 = dsv$1("text/tab-separated-values", tsvParse);

var array$2 = Array.prototype;

var map$3 = array$2.map;
var slice$4 = array$2.slice;

var implicit = {name: "implicit"};

function ordinal(range) {
  var index = map$1(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : slice$4.call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = map$1();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = slice$4.call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range$$1 = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range$$1[1] < range$$1[0],
        start = range$$1[reverse - 0],
        stop = range$$1[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
  };

  scale.rangeRound = function(_) {
    return range$$1 = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range$$1)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point$1() {
  return pointish(band().paddingInner(1));
}

var constant$9 = function(x) {
  return function() {
    return x;
  };
};

var number$1 = function(x) {
  return +x;
};

var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constant$9(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range$$1, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range$$1, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range$$1.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range$$1 = range$$1.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
  }

  return function(x) {
    var i = bisectRight(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range$$1 = unit,
      interpolate$$1 = interpolateValue,
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$1), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), rescale()) : range$$1.slice();
  };

  scale.rangeRound = function(_) {
    return range$$1 = slice$4.call(_), interpolate$$1 = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
  };

  return rescale();
}

var tickFormat = function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = tickStep(start, stop, count == null ? 10 : count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return exports.formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return exports.format(specifier);
};

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return tickFormat(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = tickIncrement(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = tickIncrement(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = tickIncrement(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear$2() {
  var scale = continuous(deinterpolateLinear, reinterpolate);

  scale.copy = function() {
    return copy(scale, linear$2());
  };

  return linearish(scale);
}

function identity$6() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = map$3.call(_, number$1), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity$6().domain(domain);
  };

  return linearish(scale);
}

var nice = function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
};

function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : constant$9(b);
}

function reinterpolate$1(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log$1() {
  var scale = continuous(deinterpolate, reinterpolate$1).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = exports.format(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return copy(scale, log$1().base(base));
  };

  return scale;
}

function raise$1(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow$1() {
  var exponent = 1,
      scale = continuous(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise$1(b, exponent) - (a = raise$1(a, exponent)))
        ? function(x) { return (raise$1(x, exponent) - a) / b; }
        : constant$9(b);
  }

  function reinterpolate(a, b) {
    b = raise$1(b, exponent) - (a = raise$1(a, exponent));
    return function(t) { return raise$1(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return copy(scale, pow$1().exponent(exponent));
  };

  return linearish(scale);
}

function sqrt$1() {
  return pow$1().exponent(0.5);
}

function quantile$$1() {
  var domain = [],
      range$$1 = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range$$1.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range$$1[bisectRight(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), rescale()) : range$$1.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile$$1()
        .domain(domain)
        .range(range$$1);
  };

  return scale;
}

function quantize$1() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range$$1 = [0, 1];

  function scale(x) {
    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range$$1 = slice$4.call(_)).length - 1, rescale()) : range$$1.slice();
  };

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize$1()
        .domain([x0, x1])
        .range(range$$1);
  };

  return linearish(scale);
}

function threshold$1() {
  var domain = [0.5],
      range$$1 = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = slice$4.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range$$1 = slice$4.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
  };

  scale.invertExtent = function(y) {
    var i = range$$1.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold$1()
        .domain(domain)
        .range(range$$1);
  };

  return scale;
}

var t0$1 = new Date;
var t1$1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0$1.setTime(+start), t1$1.setTime(+end);
      floori(t0$1), floori(t1$1);
      return Math.floor(count(t0$1, t1$1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

var milliseconds = millisecond.range;

var durationSecond$1 = 1e3;
var durationMinute$1 = 6e4;
var durationHour$1 = 36e5;
var durationDay$1 = 864e5;
var durationWeek$1 = 6048e5;

var second = newInterval(function(date) {
  date.setTime(Math.floor(date / durationSecond$1) * durationSecond$1);
}, function(date, step) {
  date.setTime(+date + step * durationSecond$1);
}, function(start, end) {
  return (end - start) / durationSecond$1;
}, function(date) {
  return date.getUTCSeconds();
});

var seconds = second.range;

var minute = newInterval(function(date) {
  date.setTime(Math.floor(date / durationMinute$1) * durationMinute$1);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getMinutes();
});

var minutes = minute.range;

var hour = newInterval(function(date) {
  var offset = date.getTimezoneOffset() * durationMinute$1 % durationHour$1;
  if (offset < 0) offset += durationHour$1;
  date.setTime(Math.floor((+date - offset) / durationHour$1) * durationHour$1 + offset);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getHours();
});

var hours = hour.range;

var day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay$1;
}, function(date) {
  return date.getDate() - 1;
});

var days = day.range;

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var months = month.range;

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var years = year.range;

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$1);
}, function(start, end) {
  return (end - start) / durationMinute$1;
}, function(date) {
  return date.getUTCMinutes();
});

var utcMinutes = utcMinute.range;

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour$1);
}, function(start, end) {
  return (end - start) / durationHour$1;
}, function(date) {
  return date.getUTCHours();
});

var utcHours = utcHour.range;

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay$1;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDays = utcDay.range;

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek$1;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcMonths = utcMonth.range;

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYears = utcYear.range;

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"};
var numberRe = /^\s*\d+/;
var percentRe = /^%/;
var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + day.count(year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(year(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(year(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

var locale$2;





defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$2 = formatLocale$1(definition);
  exports.timeFormat = locale$2.format;
  exports.timeParse = locale$2.parse;
  exports.utcFormat = locale$2.utcFormat;
  exports.utcParse = locale$2.utcParse;
  return locale$2;
}

var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : exports.utcFormat(isoSpecifier);

function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : exports.utcParse(isoSpecifier);

var durationSecond = 1000;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

function date$1(t) {
  return new Date(t);
}

function number$2(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format) {
  var scale = continuous(deinterpolateLinear, reinterpolate),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second$$1,  1,      durationSecond],
    [second$$1,  5,  5 * durationSecond],
    [second$$1, 15, 15 * durationSecond],
    [second$$1, 30, 30 * durationSecond],
    [minute$$1,  1,      durationMinute],
    [minute$$1,  5,  5 * durationMinute],
    [minute$$1, 15, 15 * durationMinute],
    [minute$$1, 30, 30 * durationMinute],
    [  hour$$1,  1,      durationHour  ],
    [  hour$$1,  3,  3 * durationHour  ],
    [  hour$$1,  6,  6 * durationHour  ],
    [  hour$$1, 12, 12 * durationHour  ],
    [   day$$1,  1,      durationDay   ],
    [   day$$1,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month$$1,  1,      durationMonth ],
    [ month$$1,  3,  3 * durationMonth ],
    [  year$$1,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second$$1(date) < date ? formatMillisecond
        : minute$$1(date) < date ? formatSecond
        : hour$$1(date) < date ? formatMinute
        : day$$1(date) < date ? formatHour
        : month$$1(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year$$1(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = tickStep(start / durationYear, stop / durationYear, interval);
        interval = year$$1;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = tickStep(start, stop, interval);
        interval = millisecond$$1;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(map$3.call(_, number$2)) : domain().map(date$1);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(nice(d, interval))
        : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format));
  };

  return scale;
}

var time = function() {
  return calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
};

var utcTime = function() {
  return calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
};

var colors = function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
};

var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");

var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");

var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");

var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));

var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));

var rainbow = cubehelix();

var rainbow$1 = function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
};

function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));

var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return linearish(scale);
}

var constant$10 = function(x) {
  return function constant() {
    return x;
  };
};

var abs$1 = Math.abs;
var atan2$1 = Math.atan2;
var cos$2 = Math.cos;
var max$2 = Math.max;
var min$1 = Math.min;
var sin$2 = Math.sin;
var sqrt$2 = Math.sqrt;

var epsilon$3 = 1e-12;
var pi$4 = Math.PI;
var halfPi$3 = pi$4 / 2;
var tau$4 = 2 * pi$4;

function acos$1(x) {
  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
}

function asin$1(x) {
  return x >= 1 ? halfPi$3 : x <= -1 ? -halfPi$3 : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt$2(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt$2(max$2(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

var arc = function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$10(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi$3,
        a1 = endAngle.apply(this, arguments) - halfPi$3,
        da = abs$1(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon$3)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau$4 - epsilon$3) {
      context.moveTo(r1 * cos$2(a0), r1 * sin$2(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$3) {
        context.moveTo(r0 * cos$2(a1), r0 * sin$2(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon$3) && (padRadius ? +padRadius.apply(this, arguments) : sqrt$2(r0 * r0 + r1 * r1)),
          rc = min$1(abs$1(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon$3) {
        var p0 = asin$1(rp / r0 * sin$2(ap)),
            p1 = asin$1(rp / r1 * sin$2(ap));
        if ((da0 -= p0 * 2) > epsilon$3) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$3) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos$2(a01),
          y01 = r1 * sin$2(a01),
          x10 = r0 * cos$2(a10),
          y10 = r0 * sin$2(a10);

      // Apply rounded corners?
      if (rc > epsilon$3) {
        var x11 = r1 * cos$2(a11),
            y11 = r1 * sin$2(a11),
            x00 = r0 * cos$2(a00),
            y00 = r0 * sin$2(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < pi$4) {
          var oc = da0 > epsilon$3 ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin$2(acos$1((ax * bx + ay * by) / (sqrt$2(ax * ax + ay * ay) * sqrt$2(bx * bx + by * by))) / 2),
              lc = sqrt$2(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min$1(rc, (r0 - lc) / (kc - 1));
          rc1 = min$1(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon$3)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon$3) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon$3) || !(da0 > epsilon$3)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon$3) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2$1(t0.y01, t0.x01), atan2$1(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2$1(t0.cy + t0.y11, t0.cx + t0.x11), atan2$1(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2$1(t1.y11, t1.x11), atan2$1(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$4 / 2;
    return [cos$2(a) * r, sin$2(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$10(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
};

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

var curveLinear = function(context) {
  return new Linear(context);
};

function x$3(p) {
  return p[0];
}

function y$3(p) {
  return p[1];
}

var line = function() {
  var x$$1 = x$3,
      y$$1 = y$3,
      defined = constant$10(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$10(+_), line) : x$$1;
  };

  line.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$10(+_), line) : y$$1;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
};

var area$2 = function() {
  var x0 = x$3,
      x1 = null,
      y0 = constant$10(0),
      y1 = y$3,
      defined = constant$10(true),
      context = null,
      curve = curveLinear,
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$10(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$10(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$10(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$10(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
};

var descending$1 = function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
};

var identity$7 = function(d) {
  return d;
};

var pie = function() {
  var value = identity$7,
      sortValues = descending$1,
      sort = null,
      startAngle = constant$10(0),
      endAngle = constant$10(tau$4),
      padAngle = constant$10(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau$4, Math.max(-tau$4, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$10(+_), pie) : padAngle;
  };

  return pie;
};

var curveRadialLinear = curveRadial(curveLinear);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}

function radialLine(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return l;
}

var radialLine$1 = function() {
  return radialLine(line().curve(curveRadialLinear));
};

var radialArea = function() {
  var a = area$2().curve(curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(curveRadial(_)) : c()._curve;
  };

  return a;
};

var slice$5 = Array.prototype.slice;

var radialPoint = function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
};

function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link$2(curve) {
  var source = linkSource,
      target = linkTarget,
      x$$1 = x$3,
      y$$1 = y$3,
      context = null;

  function link() {
    var buffer, argv = slice$5.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = path();
    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$10(+_), link) : x$$1;
  };

  link.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$10(+_), link) : y$$1;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial$1(context, x0, y0, x1, y1) {
  var p0 = radialPoint(x0, y0),
      p1 = radialPoint(x0, y0 = (y0 + y1) / 2),
      p2 = radialPoint(x1, y0),
      p3 = radialPoint(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link$2(curveHorizontal);
}

function linkVertical() {
  return link$2(curveVertical);
}

function linkRadial() {
  var l = link$2(curveRadial$1);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

var circle$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi$4);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$4);
  }
};

var cross$2 = {
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
};

var tan30 = Math.sqrt(1 / 3);
var tan30_2 = tan30 * 2;

var diamond = {
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
};

var ka = 0.89081309152928522810;
var kr = Math.sin(pi$4 / 10) / Math.sin(7 * pi$4 / 10);
var kx = Math.sin(tau$4 / 10) * kr;
var ky = -Math.cos(tau$4 / 10) * kr;

var star = {
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau$4 * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
};

var square = {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};

var sqrt3 = Math.sqrt(3);

var triangle = {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};

var c = -0.5;
var s = Math.sqrt(3) / 2;
var k = 1 / Math.sqrt(12);
var a = (k / 2 + 1) * 3;

var wye = {
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
};

var symbols = [
  circle$2,
  cross$2,
  diamond,
  square,
  star,
  triangle,
  wye
];

var symbol = function() {
  var type = constant$10(circle$2),
      size = constant$10(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = path();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$10(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant$10(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
};

var noop$2 = function() {};

function point$2(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$2(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basis$2 = function(context) {
  return new Basis(context);
};

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basisClosed$1 = function(context) {
  return new BasisClosed(context);
};

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

var basisOpen = function(context) {
  return new BasisOpen(context);
};

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

var bundle = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
}))(0.85);

function point$3(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$3(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinal = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalClosed = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var cardinalOpen = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
}))(0);

function point$4(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon$3) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon$3) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRom = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomClosed = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$4(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var catmullRomOpen = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}))(0.5);

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

var linearClosed = function(context) {
  return new LinearClosed(context);
};

function sign$1(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign$1(s0) + sign$1(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$5(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point$5(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point$5(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point$5(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

var natural = function(context) {
  return new Natural(context);
};

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

var step = function(context) {
  return new Step(context, 0.5);
};

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

var none$1 = function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
};

var none$2 = function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
};

function stackValue(d, key) {
  return d[key];
}

var stack = function() {
  var keys = constant$10([]),
      order = none$2,
      offset = none$1,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$10(slice$5.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$10(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? none$2 : typeof _ === "function" ? _ : constant$10(slice$5.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
  };

  return stack;
};

var expand = function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  none$1(series, order);
};

var diverging = function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
};

var silhouette = function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  none$1(series, order);
};

var wiggle = function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  none$1(series, order);
};

var ascending$2 = function(series) {
  var sums = series.map(sum$2);
  return none$2(series).sort(function(a, b) { return sums[a] - sums[b]; });
};

function sum$2(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

var descending$2 = function(series) {
  return ascending$2(series).reverse();
};

var insideOut = function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(sum$2),
      order = none$2(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
};

var reverse = function(series) {
  return none$2(series).reverse();
};

var constant$11 = function(x) {
  return function() {
    return x;
  };
};

function x$4(d) {
  return d[0];
}

function y$4(d) {
  return d[1];
}

function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = edges.push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  cells[left.index].halfedges.push(index);
  cells[right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = edges.length,
      edge;

  while (i--) {
    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$4
            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$4)) {
      delete edges[i];
    }
  }
}

function createCell(site) {
  return cells[site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = cells.length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!edges[halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > epsilon$4 || Math.abs(endY - startY) > epsilon$4) {
          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
              Math.abs(endX - x0) < epsilon$4 && y1 - endY > epsilon$4 ? [x0, Math.abs(startX - x0) < epsilon$4 ? startY : y1]
              : Math.abs(endY - y1) < epsilon$4 && x1 - endX > epsilon$4 ? [Math.abs(startY - y1) < epsilon$4 ? startX : x1, y1]
              : Math.abs(endX - x1) < epsilon$4 && endY - y0 > epsilon$4 ? [x1, Math.abs(startX - x1) < epsilon$4 ? startY : y0]
              : Math.abs(endY - y0) < epsilon$4 && endX - x0 > epsilon$4 ? [Math.abs(startY - y0) < epsilon$4 ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = cells[iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
        edges.push(createBorderEdge(site, v01, v11)) - 1,
        edges.push(createBorderEdge(site, v11, v10)) - 1,
        edges.push(createBorderEdge(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = cells[iCell]) {
      if (!cell.halfedges.length) {
        delete cells[iCell];
      }
    }
  }
}

var circlePool = [];

var firstCircle;

function Circle() {
  RedBlackNode(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -epsilon2$2) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = circles._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  circles.insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    circles.remove(circle);
    circlePool.push(circle);
    RedBlackNode(circle);
    arc.circle = null;
  }
}

var beachPool = [];

function Beach() {
  RedBlackNode(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  detachCircle(beach);
  beaches.remove(beach);
  beachPool.push(beach);
  RedBlackNode(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < epsilon$4
      && Math.abs(y - lArc.circle.cy) < epsilon$4) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  detachCircle(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < epsilon$4
      && Math.abs(y - rArc.circle.cy) < epsilon$4) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  detachCircle(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);

  attachCircle(lArc);
  attachCircle(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = beaches._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > epsilon$4) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > epsilon$4) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -epsilon$4) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -epsilon$4) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  createCell(site);
  var newArc = createBeach(site);
  beaches.insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    detachCircle(lArc);
    rArc = createBeach(lArc.site);
    beaches.insert(newArc, rArc);
    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
    attachCircle(lArc);
    attachCircle(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = createEdge(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  detachCircle(lArc);
  detachCircle(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
  newArc.edge = createEdge(lSite, site, null, vertex);
  rArc.edge = createEdge(site, rSite, null, vertex);
  attachCircle(lArc);
  attachCircle(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}

var epsilon$4 = 1e-6;
var epsilon2$2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new RedBlackTree;
  circles = new RedBlackTree;

  while (true) {
    circle = firstCircle;
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        addBeach(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      removeBeach(circle.arc);
    } else {
      break;
    }
  }

  sortCellHalfedges();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    clipEdges(x0, y0, x1, y1);
    clipCells(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
};

var voronoi = function() {
  var x$$1 = x$4,
      y$$1 = y$4,
      extent = null;

  function voronoi(data) {
    return new Diagram(data.map(function(d, i) {
      var s = [Math.round(x$$1(d, i, data) / epsilon$4) * epsilon$4, Math.round(y$$1(d, i, data) / epsilon$4) * epsilon$4];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$11(+_), voronoi) : x$$1;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$11(+_), voronoi) : y$$1;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
};

var constant$12 = function(x) {
  return function() {
    return x;
  };
};

function ZoomEvent(target, type, transform) {
  this.target = target;
  this.type = type;
  this.transform = transform;
}

function Transform(k, x, y) {
  this.k = k;
  this.x = x;
  this.y = y;
}

Transform.prototype = {
  constructor: Transform,
  scale: function(k) {
    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
  },
  translate: function(x, y) {
    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
  },
  apply: function(point) {
    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
  },
  applyX: function(x) {
    return x * this.k + this.x;
  },
  applyY: function(y) {
    return y * this.k + this.y;
  },
  invert: function(location) {
    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
  },
  invertX: function(x) {
    return (x - this.x) / this.k;
  },
  invertY: function(y) {
    return (y - this.y) / this.k;
  },
  rescaleX: function(x) {
    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
  },
  rescaleY: function(y) {
    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};

var identity$8 = new Transform(1, 0, 0);

transform$1.prototype = Transform.prototype;

function transform$1(node) {
  return node.__zoom || identity$8;
}

function nopropagation$2() {
  exports.event.stopImmediatePropagation();
}

var noevent$2 = function() {
  exports.event.preventDefault();
  exports.event.stopImmediatePropagation();
};

// Ignore right-click, since that should open the context menu.
function defaultFilter$2() {
  return !exports.event.button;
}

function defaultExtent$1() {
  var e = this, w, h;
  if (e instanceof SVGElement) {
    e = e.ownerSVGElement || e;
    w = e.width.baseVal.value;
    h = e.height.baseVal.value;
  } else {
    w = e.clientWidth;
    h = e.clientHeight;
  }
  return [[0, 0], [w, h]];
}

function defaultTransform() {
  return this.__zoom || identity$8;
}

var zoom = function() {
  var filter = defaultFilter$2,
      extent = defaultExtent$1,
      k0 = 0,
      k1 = Infinity,
      x0 = -k1,
      x1 = k1,
      y0 = x0,
      y1 = x1,
      duration = 250,
      interpolate$$1 = interpolateZoom,
      gestures = [],
      listeners = dispatch("start", "zoom", "end"),
      touchstarting,
      touchending,
      touchDelay = 500,
      wheelDelay = 150,
      clickDistance2 = 0;

  function zoom(selection$$1) {
    selection$$1
        .on("wheel.zoom", wheeled)
        .on("mousedown.zoom", mousedowned)
        .on("dblclick.zoom", dblclicked)
        .on("touchstart.zoom", touchstarted)
        .on("touchmove.zoom", touchmoved)
        .on("touchend.zoom touchcancel.zoom", touchended)
        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
        .property("__zoom", defaultTransform);
  }

  zoom.transform = function(collection, transform) {
    var selection$$1 = collection.selection ? collection.selection() : collection;
    selection$$1.property("__zoom", defaultTransform);
    if (collection !== selection$$1) {
      schedule(collection, transform);
    } else {
      selection$$1.interrupt().each(function() {
        gesture(this, arguments)
            .start()
            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
            .end();
      });
    }
  };

  zoom.scaleBy = function(selection$$1, k) {
    zoom.scaleTo(selection$$1, function() {
      var k0 = this.__zoom.k,
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return k0 * k1;
    });
  };

  zoom.scaleTo = function(selection$$1, k) {
    zoom.transform(selection$$1, function() {
      var e = extent.apply(this, arguments),
          t0 = this.__zoom,
          p0 = centroid(e),
          p1 = t0.invert(p0),
          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
      return constrain(translate(scale(t0, k1), p0, p1), e);
    });
  };

  zoom.translateBy = function(selection$$1, x, y) {
    zoom.transform(selection$$1, function() {
      return constrain(this.__zoom.translate(
        typeof x === "function" ? x.apply(this, arguments) : x,
        typeof y === "function" ? y.apply(this, arguments) : y
      ), extent.apply(this, arguments));
    });
  };

  function scale(transform, k) {
    k = Math.max(k0, Math.min(k1, k));
    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
  }

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
  }

  function constrain(transform, extent) {
    var dx0 = transform.invertX(extent[0][0]) - x0,
        dx1 = transform.invertX(extent[1][0]) - x1,
        dy0 = transform.invertY(extent[0][1]) - y0,
        dy1 = transform.invertY(extent[1][1]) - y1;
    return transform.translate(
      dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1),
      dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1)
    );
  }

  function centroid(extent) {
    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
  }

  function schedule(transition$$1, transform, center) {
    transition$$1
        .on("start.zoom", function() { gesture(this, arguments).start(); })
        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
        .tween("zoom", function() {
          var that = this,
              args = arguments,
              g = gesture(that, args),
              e = extent.apply(that, args),
              p = center || centroid(e),
              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
              a = that.__zoom,
              b = typeof transform === "function" ? transform.apply(that, args) : transform,
              i = interpolate$$1(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
          return function(t) {
            if (t === 1) t = b; // Avoid rounding error on end.
            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
            g.zoom(null, t);
          };
        });
  }

  function gesture(that, args) {
    for (var i = 0, n = gestures.length, g; i < n; ++i) {
      if ((g = gestures[i]).that === that) {
        return g;
      }
    }
    return new Gesture(that, args);
  }

  function Gesture(that, args) {
    this.that = that;
    this.args = args;
    this.index = -1;
    this.active = 0;
    this.extent = extent.apply(that, args);
  }

  Gesture.prototype = {
    start: function() {
      if (++this.active === 1) {
        this.index = gestures.push(this) - 1;
        this.emit("start");
      }
      return this;
    },
    zoom: function(key, transform) {
      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
      this.that.__zoom = transform;
      this.emit("zoom");
      return this;
    },
    end: function() {
      if (--this.active === 0) {
        gestures.splice(this.index, 1);
        this.index = -1;
        this.emit("end");
      }
      return this;
    },
    emit: function(type) {
      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function wheeled() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        t = this.__zoom,
        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, -exports.event.deltaY * (exports.event.deltaMode ? 120 : 1) / 500))),
        p = mouse(this);

    // If the mouse is in the same location as before, reuse it.
    // If there were recent wheel events, reset the wheel idle timeout.
    if (g.wheel) {
      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
        g.mouse[1] = t.invert(g.mouse[0] = p);
      }
      clearTimeout(g.wheel);
    }

    // If this wheel event won’t trigger a transform change, ignore it.
    else if (t.k === k) return;

    // Otherwise, capture the mouse point and location at the start.
    else {
      g.mouse = [p, t.invert(p)];
      interrupt(this);
      g.start();
    }

    noevent$2();
    g.wheel = setTimeout(wheelidled, wheelDelay);
    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));

    function wheelidled() {
      g.wheel = null;
      g.end();
    }
  }

  function mousedowned() {
    if (touchending || !filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
        p = mouse(this),
        x0 = exports.event.clientX,
        y0 = exports.event.clientY;

    dragDisable(exports.event.view);
    nopropagation$2();
    g.mouse = [p, this.__zoom.invert(p)];
    interrupt(this);
    g.start();

    function mousemoved() {
      noevent$2();
      if (!g.moved) {
        var dx = exports.event.clientX - x0, dy = exports.event.clientY - y0;
        g.moved = dx * dx + dy * dy > clickDistance2;
      }
      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent));
    }

    function mouseupped() {
      v.on("mousemove.zoom mouseup.zoom", null);
      yesdrag(exports.event.view, g.moved);
      noevent$2();
      g.end();
    }
  }

  function dblclicked() {
    if (!filter.apply(this, arguments)) return;
    var t0 = this.__zoom,
        p0 = mouse(this),
        p1 = t0.invert(p0),
        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));

    noevent$2();
    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
    else select(this).call(zoom.transform, t1);
  }

  function touchstarted() {
    if (!filter.apply(this, arguments)) return;
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        started,
        n = touches$$1.length, i, t, p;

    nopropagation$2();
    for (i = 0; i < n; ++i) {
      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
      p = [p, this.__zoom.invert(p), t.identifier];
      if (!g.touch0) g.touch0 = p, started = true;
      else if (!g.touch1) g.touch1 = p;
    }

    // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
    if (touchstarting) {
      touchstarting = clearTimeout(touchstarting);
      if (!g.touch1) {
        g.end();
        p = select(this).on("dblclick.zoom");
        if (p) p.apply(this, arguments);
        return;
      }
    }

    if (started) {
      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
      interrupt(this);
      g.start();
    }
  }

  function touchmoved() {
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, t, p, l;

    noevent$2();
    if (touchstarting) touchstarting = clearTimeout(touchstarting);
    for (i = 0; i < n; ++i) {
      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
    }
    t = g.that.__zoom;
    if (g.touch1) {
      var p0 = g.touch0[0], l0 = g.touch0[1],
          p1 = g.touch1[0], l1 = g.touch1[1],
          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
      t = scale(t, Math.sqrt(dp / dl));
      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
    }
    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
    else return;
    g.zoom("touch", constrain(translate(t, p, l), g.extent));
  }

  function touchended() {
    var g = gesture(this, arguments),
        touches$$1 = exports.event.changedTouches,
        n = touches$$1.length, i, t;

    nopropagation$2();
    if (touchending) clearTimeout(touchending);
    touchending = setTimeout(function() { touchending = null; }, touchDelay);
    for (i = 0; i < n; ++i) {
      t = touches$$1[i];
      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
    }
    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
    if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
    else g.end();
  }

  zoom.filter = function(_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$12(!!_), zoom) : filter;
  };

  zoom.extent = function(_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$12([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
  };

  zoom.scaleExtent = function(_) {
    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
  };

  zoom.translateExtent = function(_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
  };

  zoom.duration = function(_) {
    return arguments.length ? (duration = +_, zoom) : duration;
  };

  zoom.interpolate = function(_) {
    return arguments.length ? (interpolate$$1 = _, zoom) : interpolate$$1;
  };

  zoom.on = function() {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? zoom : value;
  };

  zoom.clickDistance = function(_) {
    return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
  };
    
  return zoom;
};

exports.version = version;
exports.bisect = bisectRight;
exports.bisectRight = bisectRight;
exports.bisectLeft = bisectLeft;
exports.ascending = ascending;
exports.bisector = bisector;
exports.cross = cross;
exports.descending = descending;
exports.deviation = deviation;
exports.extent = extent;
exports.histogram = histogram;
exports.thresholdFreedmanDiaconis = freedmanDiaconis;
exports.thresholdScott = scott;
exports.thresholdSturges = sturges;
exports.max = max;
exports.mean = mean;
exports.median = median;
exports.merge = merge;
exports.min = min;
exports.pairs = pairs;
exports.permute = permute;
exports.quantile = threshold;
exports.range = sequence;
exports.scan = scan;
exports.shuffle = shuffle;
exports.sum = sum;
exports.ticks = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
exports.transpose = transpose;
exports.variance = variance;
exports.zip = zip;
exports.axisTop = axisTop;
exports.axisRight = axisRight;
exports.axisBottom = axisBottom;
exports.axisLeft = axisLeft;
exports.brush = brush;
exports.brushX = brushX;
exports.brushY = brushY;
exports.brushSelection = brushSelection;
exports.chord = chord;
exports.ribbon = ribbon;
exports.nest = nest;
exports.set = set$2;
exports.map = map$1;
exports.keys = keys;
exports.values = values;
exports.entries = entries;
exports.color = color;
exports.rgb = rgb;
exports.hsl = hsl;
exports.lab = lab;
exports.hcl = hcl;
exports.cubehelix = cubehelix;
exports.dispatch = dispatch;
exports.drag = drag;
exports.dragDisable = dragDisable;
exports.dragEnable = yesdrag;
exports.dsvFormat = dsv;
exports.csvParse = csvParse;
exports.csvParseRows = csvParseRows;
exports.csvFormat = csvFormat;
exports.csvFormatRows = csvFormatRows;
exports.tsvParse = tsvParse;
exports.tsvParseRows = tsvParseRows;
exports.tsvFormat = tsvFormat;
exports.tsvFormatRows = tsvFormatRows;
exports.easeLinear = linear$1;
exports.easeQuad = quadInOut;
exports.easeQuadIn = quadIn;
exports.easeQuadOut = quadOut;
exports.easeQuadInOut = quadInOut;
exports.easeCubic = cubicInOut;
exports.easeCubicIn = cubicIn;
exports.easeCubicOut = cubicOut;
exports.easeCubicInOut = cubicInOut;
exports.easePoly = polyInOut;
exports.easePolyIn = polyIn;
exports.easePolyOut = polyOut;
exports.easePolyInOut = polyInOut;
exports.easeSin = sinInOut;
exports.easeSinIn = sinIn;
exports.easeSinOut = sinOut;
exports.easeSinInOut = sinInOut;
exports.easeExp = expInOut;
exports.easeExpIn = expIn;
exports.easeExpOut = expOut;
exports.easeExpInOut = expInOut;
exports.easeCircle = circleInOut;
exports.easeCircleIn = circleIn;
exports.easeCircleOut = circleOut;
exports.easeCircleInOut = circleInOut;
exports.easeBounce = bounceOut;
exports.easeBounceIn = bounceIn;
exports.easeBounceOut = bounceOut;
exports.easeBounceInOut = bounceInOut;
exports.easeBack = backInOut;
exports.easeBackIn = backIn;
exports.easeBackOut = backOut;
exports.easeBackInOut = backInOut;
exports.easeElastic = elasticOut;
exports.easeElasticIn = elasticIn;
exports.easeElasticOut = elasticOut;
exports.easeElasticInOut = elasticInOut;
exports.forceCenter = center$1;
exports.forceCollide = collide;
exports.forceLink = link;
exports.forceManyBody = manyBody;
exports.forceSimulation = simulation;
exports.forceX = x$2;
exports.forceY = y$2;
exports.formatDefaultLocale = defaultLocale;
exports.formatLocale = formatLocale;
exports.formatSpecifier = formatSpecifier;
exports.precisionFixed = precisionFixed;
exports.precisionPrefix = precisionPrefix;
exports.precisionRound = precisionRound;
exports.geoArea = area;
exports.geoBounds = bounds;
exports.geoCentroid = centroid;
exports.geoCircle = circle;
exports.geoClipExtent = extent$1;
exports.geoContains = contains;
exports.geoDistance = distance;
exports.geoGraticule = graticule;
exports.geoGraticule10 = graticule10;
exports.geoInterpolate = interpolate$1;
exports.geoLength = length$1;
exports.geoPath = index$1;
exports.geoAlbers = albers;
exports.geoAlbersUsa = albersUsa;
exports.geoAzimuthalEqualArea = azimuthalEqualArea;
exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
exports.geoAzimuthalEquidistant = azimuthalEquidistant;
exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
exports.geoConicConformal = conicConformal;
exports.geoConicConformalRaw = conicConformalRaw;
exports.geoConicEqualArea = conicEqualArea;
exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
exports.geoConicEquidistant = conicEquidistant;
exports.geoConicEquidistantRaw = conicEquidistantRaw;
exports.geoEquirectangular = equirectangular;
exports.geoEquirectangularRaw = equirectangularRaw;
exports.geoGnomonic = gnomonic;
exports.geoGnomonicRaw = gnomonicRaw;
exports.geoIdentity = identity$5;
exports.geoProjection = projection;
exports.geoProjectionMutator = projectionMutator;
exports.geoMercator = mercator;
exports.geoMercatorRaw = mercatorRaw;
exports.geoOrthographic = orthographic;
exports.geoOrthographicRaw = orthographicRaw;
exports.geoStereographic = stereographic;
exports.geoStereographicRaw = stereographicRaw;
exports.geoTransverseMercator = transverseMercator;
exports.geoTransverseMercatorRaw = transverseMercatorRaw;
exports.geoRotation = rotation;
exports.geoStream = geoStream;
exports.geoTransform = transform;
exports.cluster = cluster;
exports.hierarchy = hierarchy;
exports.pack = index$2;
exports.packSiblings = siblings;
exports.packEnclose = enclose;
exports.partition = partition;
exports.stratify = stratify;
exports.tree = tree;
exports.treemap = index$3;
exports.treemapBinary = binary;
exports.treemapDice = treemapDice;
exports.treemapSlice = treemapSlice;
exports.treemapSliceDice = sliceDice;
exports.treemapSquarify = squarify;
exports.treemapResquarify = resquarify;
exports.interpolate = interpolateValue;
exports.interpolateArray = array$1;
exports.interpolateBasis = basis$1;
exports.interpolateBasisClosed = basisClosed;
exports.interpolateDate = date;
exports.interpolateNumber = reinterpolate;
exports.interpolateObject = object;
exports.interpolateRound = interpolateRound;
exports.interpolateString = interpolateString;
exports.interpolateTransformCss = interpolateTransformCss;
exports.interpolateTransformSvg = interpolateTransformSvg;
exports.interpolateZoom = interpolateZoom;
exports.interpolateRgb = interpolateRgb;
exports.interpolateRgbBasis = rgbBasis;
exports.interpolateRgbBasisClosed = rgbBasisClosed;
exports.interpolateHsl = hsl$2;
exports.interpolateHslLong = hslLong;
exports.interpolateLab = lab$1;
exports.interpolateHcl = hcl$2;
exports.interpolateHclLong = hclLong;
exports.interpolateCubehelix = cubehelix$2;
exports.interpolateCubehelixLong = cubehelixLong;
exports.quantize = quantize;
exports.path = path;
exports.polygonArea = area$1;
exports.polygonCentroid = centroid$1;
exports.polygonHull = hull;
exports.polygonContains = contains$1;
exports.polygonLength = length$2;
exports.quadtree = quadtree;
exports.queue = queue;
exports.randomUniform = uniform;
exports.randomNormal = normal;
exports.randomLogNormal = logNormal;
exports.randomBates = bates;
exports.randomIrwinHall = irwinHall;
exports.randomExponential = exponential$1;
exports.request = request;
exports.html = html;
exports.json = json;
exports.text = text;
exports.xml = xml;
exports.csv = csv$1;
exports.tsv = tsv$1;
exports.scaleBand = band;
exports.scalePoint = point$1;
exports.scaleIdentity = identity$6;
exports.scaleLinear = linear$2;
exports.scaleLog = log$1;
exports.scaleOrdinal = ordinal;
exports.scaleImplicit = implicit;
exports.scalePow = pow$1;
exports.scaleSqrt = sqrt$1;
exports.scaleQuantile = quantile$$1;
exports.scaleQuantize = quantize$1;
exports.scaleThreshold = threshold$1;
exports.scaleTime = time;
exports.scaleUtc = utcTime;
exports.schemeCategory10 = category10;
exports.schemeCategory20b = category20b;
exports.schemeCategory20c = category20c;
exports.schemeCategory20 = category20;
exports.interpolateCubehelixDefault = cubehelix$3;
exports.interpolateRainbow = rainbow$1;
exports.interpolateWarm = warm;
exports.interpolateCool = cool;
exports.interpolateViridis = viridis;
exports.interpolateMagma = magma;
exports.interpolateInferno = inferno;
exports.interpolatePlasma = plasma;
exports.scaleSequential = sequential;
exports.creator = creator;
exports.local = local$1;
exports.matcher = matcher$1;
exports.mouse = mouse;
exports.namespace = namespace;
exports.namespaces = namespaces;
exports.select = select;
exports.selectAll = selectAll;
exports.selection = selection;
exports.selector = selector;
exports.selectorAll = selectorAll;
exports.style = styleValue;
exports.touch = touch;
exports.touches = touches;
exports.window = defaultView;
exports.customEvent = customEvent;
exports.arc = arc;
exports.area = area$2;
exports.line = line;
exports.pie = pie;
exports.radialArea = radialArea;
exports.radialLine = radialLine$1;
exports.linkHorizontal = linkHorizontal;
exports.linkVertical = linkVertical;
exports.linkRadial = linkRadial;
exports.symbol = symbol;
exports.symbols = symbols;
exports.symbolCircle = circle$2;
exports.symbolCross = cross$2;
exports.symbolDiamond = diamond;
exports.symbolSquare = square;
exports.symbolStar = star;
exports.symbolTriangle = triangle;
exports.symbolWye = wye;
exports.curveBasisClosed = basisClosed$1;
exports.curveBasisOpen = basisOpen;
exports.curveBasis = basis$2;
exports.curveBundle = bundle;
exports.curveCardinalClosed = cardinalClosed;
exports.curveCardinalOpen = cardinalOpen;
exports.curveCardinal = cardinal;
exports.curveCatmullRomClosed = catmullRomClosed;
exports.curveCatmullRomOpen = catmullRomOpen;
exports.curveCatmullRom = catmullRom;
exports.curveLinearClosed = linearClosed;
exports.curveLinear = curveLinear;
exports.curveMonotoneX = monotoneX;
exports.curveMonotoneY = monotoneY;
exports.curveNatural = natural;
exports.curveStep = step;
exports.curveStepAfter = stepAfter;
exports.curveStepBefore = stepBefore;
exports.stack = stack;
exports.stackOffsetExpand = expand;
exports.stackOffsetDiverging = diverging;
exports.stackOffsetNone = none$1;
exports.stackOffsetSilhouette = silhouette;
exports.stackOffsetWiggle = wiggle;
exports.stackOrderAscending = ascending$2;
exports.stackOrderDescending = descending$2;
exports.stackOrderInsideOut = insideOut;
exports.stackOrderNone = none$2;
exports.stackOrderReverse = reverse;
exports.timeInterval = newInterval;
exports.timeMillisecond = millisecond;
exports.timeMilliseconds = milliseconds;
exports.utcMillisecond = millisecond;
exports.utcMilliseconds = milliseconds;
exports.timeSecond = second;
exports.timeSeconds = seconds;
exports.utcSecond = second;
exports.utcSeconds = seconds;
exports.timeMinute = minute;
exports.timeMinutes = minutes;
exports.timeHour = hour;
exports.timeHours = hours;
exports.timeDay = day;
exports.timeDays = days;
exports.timeWeek = sunday;
exports.timeWeeks = sundays;
exports.timeSunday = sunday;
exports.timeSundays = sundays;
exports.timeMonday = monday;
exports.timeMondays = mondays;
exports.timeTuesday = tuesday;
exports.timeTuesdays = tuesdays;
exports.timeWednesday = wednesday;
exports.timeWednesdays = wednesdays;
exports.timeThursday = thursday;
exports.timeThursdays = thursdays;
exports.timeFriday = friday;
exports.timeFridays = fridays;
exports.timeSaturday = saturday;
exports.timeSaturdays = saturdays;
exports.timeMonth = month;
exports.timeMonths = months;
exports.timeYear = year;
exports.timeYears = years;
exports.utcMinute = utcMinute;
exports.utcMinutes = utcMinutes;
exports.utcHour = utcHour;
exports.utcHours = utcHours;
exports.utcDay = utcDay;
exports.utcDays = utcDays;
exports.utcWeek = utcSunday;
exports.utcWeeks = utcSundays;
exports.utcSunday = utcSunday;
exports.utcSundays = utcSundays;
exports.utcMonday = utcMonday;
exports.utcMondays = utcMondays;
exports.utcTuesday = utcTuesday;
exports.utcTuesdays = utcTuesdays;
exports.utcWednesday = utcWednesday;
exports.utcWednesdays = utcWednesdays;
exports.utcThursday = utcThursday;
exports.utcThursdays = utcThursdays;
exports.utcFriday = utcFriday;
exports.utcFridays = utcFridays;
exports.utcSaturday = utcSaturday;
exports.utcSaturdays = utcSaturdays;
exports.utcMonth = utcMonth;
exports.utcMonths = utcMonths;
exports.utcYear = utcYear;
exports.utcYears = utcYears;
exports.timeFormatDefaultLocale = defaultLocale$1;
exports.timeFormatLocale = formatLocale$1;
exports.isoFormat = formatIso;
exports.isoParse = parseIso;
exports.now = now;
exports.timer = timer;
exports.timerFlush = timerFlush;
exports.timeout = timeout$1;
exports.interval = interval$1;
exports.transition = transition;
exports.active = active;
exports.interrupt = interrupt;
exports.voronoi = voronoi;
exports.zoom = zoom;
exports.zoomTransform = transform$1;
exports.zoomIdentity = identity$8;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(102);
var PooledClass = __webpack_require__(18);
var ReactFeatureFlags = __webpack_require__(103);
var ReactReconciler = __webpack_require__(25);
var Transaction = __webpack_require__(40);

var invariant = __webpack_require__(0);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(172);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(18);

var emptyFunction = __webpack_require__(7);
var warning = __webpack_require__(1);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(136);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(250)();
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectSchool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setWindowSize; });
var selectSchool=function selectSchool(payload){return{type:'SELECTED_SCHOOL:SET',payload:payload};};var setWindowSize=function setWindowSize(){return function(dispatch,getState){dispatch({type:'APP:WINDOW_RESIZE'});};};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactBaseClasses = __webpack_require__(92);
var ReactChildren = __webpack_require__(159);
var ReactDOMFactories = __webpack_require__(164);
var ReactElement = __webpack_require__(23);
var ReactPropTypes = __webpack_require__(165);
var ReactVersion = __webpack_require__(168);

var createReactClass = __webpack_require__(169);
var onlyChild = __webpack_require__(171);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(12);

var warning = __webpack_require__(1);
var canDefineProperty = __webpack_require__(94);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(95);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(180);
var ReactInstrumentation = __webpack_require__(8);

var warning = __webpack_require__(1);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(65);
var setInnerHTML = __webpack_require__(42);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(66);
var setTextContent = __webpack_require__(107);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(296),
    getValue = __webpack_require__(301);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(55);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(31);
var EventPluginUtils = __webpack_require__(59);

var accumulateInto = __webpack_require__(99);
var forEachAccumulated = __webpack_require__(100);
var warning = __webpack_require__(1);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var EventPluginRegistry = __webpack_require__(58);
var EventPluginUtils = __webpack_require__(59);
var ReactErrorUtils = __webpack_require__(60);

var accumulateInto = __webpack_require__(99);
var forEachAccumulated = __webpack_require__(100);
var invariant = __webpack_require__(0);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(14);

var getEventTarget = __webpack_require__(61);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(48),
    getRawTag = __webpack_require__(297),
    objectToString = __webpack_require__(298);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Tooltip=function(){function Tooltip(content,classnames){var _this=this;_classCallCheck(this,Tooltip);this.container=document.createElement('div');this.container.setAttribute('role','dialog');this.container.classList.add('tooltip');if(classnames){this.container.classList.add(classnames);}this.position=null;this.container.innerHTML=content;this.hidden=true;this.onclick=function(){};this.onhide=function(){};document.body.addEventListener('click',function(){_this.hide();},false);this.container.addEventListener('click',function(){_this.onclick();},false);this.container.addEventListener('keydown',function(e){var keys={SPACE:32,ENTER:13};if(e.type==='click'||e.keyCode===keys.SPACE||e.keyCode===keys.ENTER){_this.onclick();}},false);}_createClass(Tooltip,[{key:'show',value:function show(){this.container.tabIndex=0;this.container.classList.add('visible');this.container.focus();this.hidden=false;}},{key:'hide',value:function hide(){if(!this.hidden){this.container.removeAttribute('tabIndex');this.container.classList.remove('visible');this.onhide();this.hidden=true;}}},{key:'move',value:function move(top,left){this.container.style.top=top+'px';this.container.style.left=left+'px';}},{key:'onClick',value:function onClick(callback){this.onclick=callback;}},{key:'onHide',value:function onHide(callback){this.onhide=callback;}},{key:'elm',get:function get(){return this.container;}}]);return Tooltip;}();/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(383);
var finalCreateStore=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a),window.devToolsExtension?window.devToolsExtension():function(f){return f;})(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */]);/* harmony default export */ __webpack_exports__["a"] = (finalCreateStore(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */]));

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export studentEnrolment */
/* unused harmony export studentClassrooms */
/* unused harmony export playspace */
/* unused harmony export classSpace */
function sortByName(data){return data.sort(function(a,b){if(a.name.toLowerCase()<b.name.toLowerCase())return-1;if(a.name.toLowerCase()>b.name.toLowerCase())return 1;return 0;});}function sortByPlayspace(data){return data.sort(function(a,b){if(a.playspace>b.playspace){return 1;}if(a.playspace<b.playspace){return-1;}return 0;});}function sortByClassSpace(data){return data.sort(function(a,b){if(a.classroomspace>b.classroomspace){return 1;}if(a.classroomspace<b.classroomspace){return-1;}return 0;});}var studentEnrolment=function studentEnrolment(schools){return sortByName(schools.filter(function(d){if(!d.enrolment||d.enrolment==='NA'){console.warn(d.name+' is missing current enrolment details');return false;}return true;}));};var studentClassrooms=function studentClassrooms(schools){return sortByName(schools.filter(function(d){if(!d.classrooms||d.classrooms.permanent==='NA'||d.classrooms.demountable==='NA'){console.warn(d.name+' is missing classroom numbers');return false;}return true;}));};var playspace=function playspace(schools){return sortByPlayspace(schools.filter(function(d){// Dealing with real world edge cases
if(d.playspace==='NA'||d.playspace<1||isNaN(d.playspace)){if(d.playspace<1){console.warn(d.name+' playspace is less than 1m\xB2 and cannot be show in visualisation');}else{console.warn(d.name+' is missing playspace information');}return false;}return true;}).map(function(d){return d;}));};var classSpace=function classSpace(schools){return sortByClassSpace(schools.filter(function(d){// Dealing with real world edge cases
if(d.classroomspace==='NA'||d.classroomspace<1||isNaN(d.classroomspace)){if(d.classroomspace<1){console.warn(d.name+' classroom space is less than 1m\xB2 and cannot be show in visualisation');}else{console.warn(d.name+' is missing classroom space information');}return false;}return true;}).map(function(d){return d;}));};/* harmony default export */ __webpack_exports__["a"] = ({studentEnrolment:studentEnrolment,studentClassrooms:studentClassrooms,playspace:playspace,classSpace:classSpace});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(32);
var ViewportMetrics = __webpack_require__(106);

var getEventModifierState = __webpack_require__(63);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);
var DOMNamespaces = __webpack_require__(65);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(66);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var EventPluginRegistry = __webpack_require__(58);
var ReactEventEmitterMixin = __webpack_require__(201);
var ViewportMetrics = __webpack_require__(106);

var getVendorPrefixedEventName = __webpack_require__(202);
var isEventSupported = __webpack_require__(62);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isDev="production"==='development';var getSchoolUrl=function getSchoolUrl(school){if(isDev){// console.log('returning dev url', school)
return'?school='+school.uid;}// console.log('returning cms url')
return'https://schoolinfrastructure.nsw.gov.au/school-lookup?school_code='+school.uid;};/* harmony default export */ __webpack_exports__["a"] = (getSchoolUrl);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(286),
    listCacheDelete = __webpack_require__(287),
    listCacheGet = __webpack_require__(288),
    listCacheHas = __webpack_require__(289),
    listCacheSet = __webpack_require__(290);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(134);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(310);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(91);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export smallThreshold */
/* unused harmony export isProjectedYear */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSchoolSmall; });
/* unused harmony export isSmallValue */
// Do we determine this point to be a small node? 
var isSmallProjectedNode=function isSmallProjectedNode(index){return isProjectedYear(index);};/* harmony default export */ __webpack_exports__["a"] = (isSmallProjectedNode);var smallThreshold=50;// Does the index belong to a projected year? 
var isProjectedYear=function isProjectedYear(index){return index>=2;};// Is the school small? 
// Determined by the first projected year being <= 50; 
var isSchoolSmall=function isSchoolSmall(school){return isSmallValue(school.projections[2]);};var isSmallValue=function isSmallValue(v){return v<=smallThreshold;};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(54).enable();
  window.Promise = __webpack_require__(56);
}

// fetch() polyfill for making API calls.
__webpack_require__(57);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(3);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(28);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(28);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactErrorUtils = __webpack_require__(60);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(26);
var Danger = __webpack_require__(186);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactInstrumentation = __webpack_require__(8);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(66);
var setInnerHTML = __webpack_require__(42);
var setTextContent = __webpack_require__(107);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactPropTypesSecret = __webpack_require__(204);
var propTypesFactory = __webpack_require__(96);

var React = __webpack_require__(22);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(12);
var ReactInstanceMap = __webpack_require__(33);
var ReactInstrumentation = __webpack_require__(8);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var emptyFunction = __webpack_require__(7);
var warning = __webpack_require__(1);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(264);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(80);
var objectAssign = __webpack_require__(3);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = __webpack_require__(82);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

exports.iframeResizer = __webpack_require__(83);
exports.iframeResizerContentWindow = __webpack_require__(84);


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */


;(function(undefined) {
	'use strict';

	if(typeof window === 'undefined') return; // don't run for server side render

	var
		count                 = 0,
		logEnabled            = false,
		hiddenCheckEnabled    = false,
		msgHeader             = 'message',
		msgHeaderLen          = msgHeader.length,
		msgId                 = '[iFrameSizer]', //Must match iframe msg ID
		msgIdLen              = msgId.length,
		pagePosition          = null,
		requestAnimationFrame = window.requestAnimationFrame,
		resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
		settings              = {},
		timer                 = null,
		logId                 = 'Host Page',

		defaults              = {
			autoResize                : true,
			bodyBackground            : null,
			bodyMargin                : null,
			bodyMarginV1              : 8,
			bodyPadding               : null,
			checkOrigin               : true,
			inPageLinks               : false,
			enablePublicMethods       : true,
			heightCalculationMethod   : 'bodyOffset',
			id                        : 'iFrameResizer',
			interval                  : 32,
			log                       : false,
			maxHeight                 : Infinity,
			maxWidth                  : Infinity,
			minHeight                 : 0,
			minWidth                  : 0,
			resizeFrom                : 'parent',
			scrolling                 : false,
			sizeHeight                : true,
			sizeWidth                 : false,
			warningTimeout            : 5000,
			tolerance                 : 0,
			widthCalculationMethod    : 'scroll',
			closedCallback            : function(){},
			initCallback              : function(){},
			messageCallback           : function(){warn('MessageCallback function not defined');},
			resizedCallback           : function(){},
			scrollCallback            : function(){return true;}
		};

	function addEventListener(obj,evt,func){
		/* istanbul ignore else */ // Not testable in PhantonJS
		if ('addEventListener' in window){
			obj.addEventListener(evt,func, false);
		} else if ('attachEvent' in window){//IE
			obj.attachEvent('on'+evt,func);
		}
	}

	function removeEventListener(el,evt,func){
		/* istanbul ignore else */ // Not testable in phantonJS
		if ('removeEventListener' in window){
			el.removeEventListener(evt,func, false);
		} else if ('detachEvent' in window){ //IE
			el.detachEvent('on'+evt,func);
		}
	}

	function setupRequestAnimationFrame(){
		var
			vendors = ['moz', 'webkit', 'o', 'ms'],
			x;

		// Remove vendor prefixing if prefixed and break early if not
		for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
			requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		}

		if (!(requestAnimationFrame)){
			log('setup','RequestAnimationFrame not supported');
		}
	}

	function getMyID(iframeId){
		var retStr = 'Host page: '+iframeId;

		if (window.top !== window.self){
			if (window.parentIFrame && window.parentIFrame.getId){
				retStr = window.parentIFrame.getId()+': '+iframeId;
			} else {
				retStr = 'Nested host page: '+iframeId;
			}
		}

		return retStr;
	}

	function formatLogHeader(iframeId){
		return msgId + '[' + getMyID(iframeId) + ']';
	}

	function isLogEnabled(iframeId){
		return settings[iframeId] ? settings[iframeId].log : logEnabled;
	}

	function log(iframeId,msg){
		output('log',iframeId,msg,isLogEnabled(iframeId));
	}

	function info(iframeId,msg){
		output('info',iframeId,msg,isLogEnabled(iframeId));
	}

	function warn(iframeId,msg){
		output('warn',iframeId,msg,true);
	}

	function output(type,iframeId,msg,enabled){
		if (true === enabled && 'object' === typeof window.console){
			console[type](formatLogHeader(iframeId),msg);
		}
	}

	function iFrameListener(event){
		function resizeIFrame(){
			function resize(){
				setSize(messageData);
				setPagePosition(iframeId);
				callback('resizedCallback',messageData);
			}

			ensureInRange('Height');
			ensureInRange('Width');

			syncResize(resize,messageData,'init');
		}

		function processMsg(){
			var data = msg.substr(msgIdLen).split(':');

			return {
				iframe: settings[data[0]].iframe,
				id:     data[0],
				height: data[1],
				width:  data[2],
				type:   data[3]
			};
		}

		function ensureInRange(Dimension){
			var
				max  = Number(settings[iframeId]['max' + Dimension]),
				min  = Number(settings[iframeId]['min' + Dimension]),
				dimension = Dimension.toLowerCase(),
				size = Number(messageData[dimension]);

			log(iframeId,'Checking ' + dimension + ' is in range ' + min + '-' + max);

			if (size<min) {
				size=min;
				log(iframeId,'Set ' + dimension + ' to min value');
			}

			if (size>max) {
				size=max;
				log(iframeId,'Set ' + dimension + ' to max value');
			}

			messageData[dimension] = '' + size;
		}


		function isMessageFromIFrame(){
			function checkAllowedOrigin(){
				function checkList(){
					var
						i = 0,
						retCode = false;

					log(iframeId,'Checking connection is from allowed list of origins: ' + checkOrigin);

					for (; i < checkOrigin.length; i++) {
						if (checkOrigin[i] === origin) {
							retCode = true;
							break;
						}
					}
					return retCode;
				}

				function checkSingle(){
					var remoteHost  = settings[iframeId].remoteHost;
					log(iframeId,'Checking connection is from: '+remoteHost);
					return origin === remoteHost;
				}

				return checkOrigin.constructor === Array ? checkList() : checkSingle();
			}

			var
				origin      = event.origin,
				checkOrigin = settings[iframeId].checkOrigin;

			if (checkOrigin && (''+origin !== 'null') && !checkAllowedOrigin()) {
				throw new Error(
					'Unexpected message received from: ' + origin +
					' for ' + messageData.iframe.id +
					'. Message was: ' + event.data +
					'. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
				);
			}

			return true;
		}

		function isMessageForUs(){
			return msgId === (('' + msg).substr(0,msgIdLen)) && (msg.substr(msgIdLen).split(':')[0] in settings); //''+Protects against non-string msg
		}

		function isMessageFromMetaParent(){
			//Test if this message is from a parent above us. This is an ugly test, however, updating
			//the message format would break backwards compatibity.
			var retCode = messageData.type in {'true':1,'false':1,'undefined':1};

			if (retCode){
				log(iframeId,'Ignoring init message from meta parent page');
			}

			return retCode;
		}

		function getMsgBody(offset){
			return msg.substr(msg.indexOf(':')+msgHeaderLen+offset);
		}

		function forwardMsgFromIFrame(msgBody){
			log(iframeId,'MessageCallback passed: {iframe: '+ messageData.iframe.id + ', message: ' + msgBody + '}');
			callback('messageCallback',{
				iframe: messageData.iframe,
				message: JSON.parse(msgBody)
			});
			log(iframeId,'--');
		}

		function getPageInfo(){
			var
				bodyPosition   = document.body.getBoundingClientRect(),
				iFramePosition = messageData.iframe.getBoundingClientRect();

			return JSON.stringify({
				iframeHeight: iFramePosition.height,
				iframeWidth:  iFramePosition.width,
				clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
				clientWidth:  Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0),
				offsetTop:    parseInt(iFramePosition.top  - bodyPosition.top,  10),
				offsetLeft:   parseInt(iFramePosition.left - bodyPosition.left, 10),
				scrollTop:    window.pageYOffset,
				scrollLeft:   window.pageXOffset
			});
		}

		function sendPageInfoToIframe(iframe,iframeId){
			function debouncedTrigger(){
				trigger(
					'Send Page Info',
					'pageInfo:' + getPageInfo(),
					iframe,
					iframeId
				);
			}

			debouce(debouncedTrigger,32);
		}


		function startPageInfoMonitor(){
			function setListener(type,func){
				function sendPageInfo(){
					if (settings[id]){
						sendPageInfoToIframe(settings[id].iframe,id);
					} else {
						stop();
					}
				}

				['scroll','resize'].forEach(function(evt){
					log(id, type +  evt + ' listener for sendPageInfo');
					func(window,evt,sendPageInfo);
				});
			}

			function stop(){
				setListener('Remove ', removeEventListener);
			}

			function start(){
				setListener('Add ', addEventListener);
			}

			var id = iframeId; //Create locally scoped copy of iFrame ID

			start();

			settings[id].stopPageInfo = stop;
		}

		function stopPageInfoMonitor(){
			if (settings[iframeId] && settings[iframeId].stopPageInfo){
				settings[iframeId].stopPageInfo();
				delete settings[iframeId].stopPageInfo;
			}
		}

		function checkIFrameExists(){
			var retBool = true;

			if (null === messageData.iframe) {
				warn(iframeId,'IFrame ('+messageData.id+') not found');
				retBool = false;
			}
			return retBool;
		}

		function getElementPosition(target){
			var iFramePosition = target.getBoundingClientRect();

			getPagePosition(iframeId);

			return {
				x: Math.floor( Number(iFramePosition.left) + Number(pagePosition.x) ),
				y: Math.floor( Number(iFramePosition.top)  + Number(pagePosition.y) )
			};
		}

		function scrollRequestFromChild(addOffset){
			/* istanbul ignore next */  //Not testable in Karma
			function reposition(){
				pagePosition = newPosition;
				scrollTo();
				log(iframeId,'--');
			}

			function calcOffset(){
				return {
					x: Number(messageData.width) + offset.x,
					y: Number(messageData.height) + offset.y
				};
			}

			function scrollParent(){
				if (window.parentIFrame){
					window.parentIFrame['scrollTo'+(addOffset?'Offset':'')](newPosition.x,newPosition.y);
				} else {
					warn(iframeId,'Unable to scroll to requested position, window.parentIFrame not found');
				}
			}

			var
				offset = addOffset ? getElementPosition(messageData.iframe) : {x:0,y:0},
				newPosition = calcOffset();

			log(iframeId,'Reposition requested from iFrame (offset x:'+offset.x+' y:'+offset.y+')');

			if(window.top !== window.self){
				scrollParent();
			} else {
				reposition();
			}
		}

		function scrollTo(){
			if (false !== callback('scrollCallback',pagePosition)){
				setPagePosition(iframeId);
			} else {
				unsetPagePosition();
			}
		}

		function findTarget(location){
			function jumpToTarget(){
				var jumpPosition = getElementPosition(target);

				log(iframeId,'Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
				pagePosition = {
					x: jumpPosition.x,
					y: jumpPosition.y
				};

				scrollTo();
				log(iframeId,'--');
			}

			function jumpToParent(){
				if (window.parentIFrame){
					window.parentIFrame.moveToAnchor(hash);
				} else {
					log(iframeId,'In page link #'+hash+' not found and window.parentIFrame not found');
				}
			}

			var
				hash     = location.split('#')[1] || '',
				hashData = decodeURIComponent(hash),
				target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

			if (target){
				jumpToTarget();
			} else if(window.top!==window.self){
				jumpToParent();
			} else {
				log(iframeId,'In page link #'+hash+' not found');
			}
		}

		function callback(funcName,val){
			return chkCallback(iframeId,funcName,val);
		}

		function actionMsg(){

			if(settings[iframeId].firstRun) firstRun();

			switch(messageData.type){
			case 'close':
				closeIFrame(messageData.iframe);
				break;
			case 'message':
				forwardMsgFromIFrame(getMsgBody(6));
				break;
			case 'scrollTo':
				scrollRequestFromChild(false);
				break;
			case 'scrollToOffset':
				scrollRequestFromChild(true);
				break;
			case 'pageInfo':
				sendPageInfoToIframe(settings[iframeId].iframe,iframeId);
				startPageInfoMonitor();
				break;
			case 'pageInfoStop':
				stopPageInfoMonitor();
				break;
			case 'inPageLink':
				findTarget(getMsgBody(9));
				break;
			case 'reset':
				resetIFrame(messageData);
				break;
			case 'init':
				resizeIFrame();
				callback('initCallback',messageData.iframe);
				break;
			default:
				resizeIFrame();
			}
		}

		function hasSettings(iframeId){
			var retBool = true;

			if (!settings[iframeId]){
				retBool = false;
				warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
			}

			return retBool;
		}

		function iFrameReadyMsgReceived(){
			for (var iframeId in settings){
				trigger('iFrame requested init',createOutgoingMsg(iframeId),document.getElementById(iframeId),iframeId);
			}
		}

		function firstRun() {
			settings[iframeId].firstRun = false;
		}

		function clearWarningTimeout() {
			clearTimeout(settings[iframeId].msgTimeout);
			settings[iframeId].warningTimeout = 0;
		}

		var
			msg = event.data,
			messageData = {},
			iframeId = null;

		if('[iFrameResizerChild]Ready' === msg){
			iFrameReadyMsgReceived();
		} else if (isMessageForUs()){
			messageData = processMsg();
			iframeId    = logId = messageData.id;
			settings[iframeId].loaded = true;

			if (!isMessageFromMetaParent() && hasSettings(iframeId)){
				log(iframeId,'Received: '+msg);

				if ( checkIFrameExists() && isMessageFromIFrame() ){
					actionMsg();
				}
			}
		} else {
			info(iframeId,'Ignored: '+msg);
		}

	}


	function chkCallback(iframeId,funcName,val){
		var
			func = null,
			retVal = null;

		if(settings[iframeId]){
			func = settings[iframeId][funcName];

			if( 'function' === typeof func){
				retVal = func(val);
			} else {
				throw new TypeError(funcName+' on iFrame['+iframeId+'] is not a function');
			}
		}

		return retVal;
	}

	function closeIFrame(iframe){
		var iframeId = iframe.id;

		log(iframeId,'Removing iFrame: '+iframeId);
		if (iframe.parentNode) { iframe.parentNode.removeChild(iframe); }
		chkCallback(iframeId,'closedCallback',iframeId);
		log(iframeId,'--');
		delete settings[iframeId];
	}

	function getPagePosition(iframeId){
		if(null === pagePosition){
			pagePosition = {
				x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
				y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
			};
			log(iframeId,'Get page position: '+pagePosition.x+','+pagePosition.y);
		}
	}

	function setPagePosition(iframeId){
		if(null !== pagePosition){
			window.scrollTo(pagePosition.x,pagePosition.y);
			log(iframeId,'Set page position: '+pagePosition.x+','+pagePosition.y);
			unsetPagePosition();
		}
	}

	function unsetPagePosition(){
		pagePosition = null;
	}

	function resetIFrame(messageData){
		function reset(){
			setSize(messageData);
			trigger('reset','reset',messageData.iframe,messageData.id);
		}

		log(messageData.id,'Size reset requested by '+('init'===messageData.type?'host page':'iFrame'));
		getPagePosition(messageData.id);
		syncResize(reset,messageData,'reset');
	}

	function setSize(messageData){
		function setDimension(dimension){
			messageData.iframe.style[dimension] = messageData[dimension] + 'px';
			log(
				messageData.id,
				'IFrame (' + iframeId +
				') ' + dimension +
				' set to ' + messageData[dimension] + 'px'
			);
		}

		function chkZero(dimension){
			//FireFox sets dimension of hidden iFrames to zero.
			//So if we detect that set up an event to check for
			//when iFrame becomes visible.

			/* istanbul ignore next */  //Not testable in PhantomJS
			if (!hiddenCheckEnabled && '0' === messageData[dimension]){
				hiddenCheckEnabled = true;
				log(iframeId,'Hidden iFrame detected, creating visibility listener');
				fixHiddenIFrames();
			}
		}

		function processDimension(dimension){
			setDimension(dimension);
			chkZero(dimension);
		}

		var iframeId = messageData.iframe.id;

		if(settings[iframeId]){
			if( settings[iframeId].sizeHeight) { processDimension('height'); }
			if( settings[iframeId].sizeWidth ) { processDimension('width'); }
		}
	}

	function syncResize(func,messageData,doNotSync){
		/* istanbul ignore if */  //Not testable in PhantomJS
		if(doNotSync!==messageData.type && requestAnimationFrame){
			log(messageData.id,'Requesting animation frame');
			requestAnimationFrame(func);
		} else {
			func();
		}
	}

	function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
		function postMessageToIFrame(){
			var target = settings[id].targetOrigin;
			log(id,'[' + calleeMsg + '] Sending msg to iframe['+id+'] ('+msg+') targetOrigin: '+target);
			iframe.contentWindow.postMessage( msgId + msg, target );
		}

		function iFrameNotFound(){
			warn(id,'[' + calleeMsg + '] IFrame('+id+') not found');
		}

		function chkAndSend(){
			if(iframe && 'contentWindow' in iframe && (null !== iframe.contentWindow)){ //Null test for PhantomJS
				postMessageToIFrame();
			} else {
				iFrameNotFound();
			}
		}

		function warnOnNoResponse() {
			function warning() {
				if (settings[id] && !settings[id].loaded && !errorShown) {
					errorShown = true;
					warn(id, 'IFrame has not responded within '+ settings[id].warningTimeout/1000 +' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ingored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
				}
			}

			if (!!noResponseWarning && !!settings[id].warningTimeout) {
				settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
			}
		}

		var errorShown = false;

		id = id || iframe.id;

		if(settings[id]) {
			chkAndSend();
			warnOnNoResponse();
		}

	}

	function createOutgoingMsg(iframeId){
		return iframeId +
			':' + settings[iframeId].bodyMarginV1 +
			':' + settings[iframeId].sizeWidth +
			':' + settings[iframeId].log +
			':' + settings[iframeId].interval +
			':' + settings[iframeId].enablePublicMethods +
			':' + settings[iframeId].autoResize +
			':' + settings[iframeId].bodyMargin +
			':' + settings[iframeId].heightCalculationMethod +
			':' + settings[iframeId].bodyBackground +
			':' + settings[iframeId].bodyPadding +
			':' + settings[iframeId].tolerance +
			':' + settings[iframeId].inPageLinks +
			':' + settings[iframeId].resizeFrom +
			':' + settings[iframeId].widthCalculationMethod;
	}

	function setupIFrame(iframe,options){
		function setLimits(){
			function addStyle(style){
				if ((Infinity !== settings[iframeId][style]) && (0 !== settings[iframeId][style])){
					iframe.style[style] = settings[iframeId][style] + 'px';
					log(iframeId,'Set '+style+' = '+settings[iframeId][style]+'px');
				}
			}

			function chkMinMax(dimension){
				if (settings[iframeId]['min'+dimension]>settings[iframeId]['max'+dimension]){
					throw new Error('Value for min'+dimension+' can not be greater than max'+dimension);
				}
			}

			chkMinMax('Height');
			chkMinMax('Width');

			addStyle('maxHeight');
			addStyle('minHeight');
			addStyle('maxWidth');
			addStyle('minWidth');
		}

		function newId(){
			var id = ((options && options.id) || defaults.id + count++);
			if  (null !== document.getElementById(id)){
				id = id + count++;
			}
			return id;
		}

		function ensureHasId(iframeId){
			logId=iframeId;
			if (''===iframeId){
				iframe.id = iframeId =  newId();
				logEnabled = (options || {}).log;
				logId=iframeId;
				log(iframeId,'Added missing iframe ID: '+ iframeId +' (' + iframe.src + ')');
			}


			return iframeId;
		}

		function setScrolling(){
			log(iframeId,'IFrame scrolling ' + (settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
			iframe.style.overflow = false === settings[iframeId].scrolling ? 'hidden' : 'auto';
			switch(settings[iframeId].scrolling) {
				case true:
					iframe.scrolling = 'yes';
					break;
				case false:
					iframe.scrolling = 'no';
					break;
				default:
					iframe.scrolling = settings[iframeId].scrolling;
			}
		}

		//The V1 iFrame script expects an int, where as in V2 expects a CSS
		//string value such as '1px 3em', so if we have an int for V2, set V1=V2
		//and then convert V2 to a string PX value.
		function setupBodyMarginValues(){
			if (('number'===typeof(settings[iframeId].bodyMargin)) || ('0'===settings[iframeId].bodyMargin)){
				settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
				settings[iframeId].bodyMargin   = '' + settings[iframeId].bodyMargin + 'px';
			}
		}

		function checkReset(){
			// Reduce scope of firstRun to function, because IE8's JS execution
			// context stack is borked and this value gets externally
			// changed midway through running this function!!!
			var
				firstRun           = settings[iframeId].firstRun,
				resetRequertMethod = settings[iframeId].heightCalculationMethod in resetRequiredMethods;

			if (!firstRun && resetRequertMethod){
				resetIFrame({iframe:iframe, height:0, width:0, type:'init'});
			}
		}

		function setupIFrameObject(){
			if(Function.prototype.bind){ //Ignore unpolyfilled IE8.
				settings[iframeId].iframe.iFrameResizer = {

					close        : closeIFrame.bind(null,settings[iframeId].iframe),

					resize       : trigger.bind(null,'Window resize', 'resize', settings[iframeId].iframe),

					moveToAnchor : function(anchor){
						trigger('Move to anchor','moveToAnchor:'+anchor, settings[iframeId].iframe,iframeId);
					},

					sendMessage  : function(message){
						message = JSON.stringify(message);
						trigger('Send Message','message:'+message, settings[iframeId].iframe, iframeId);
					}
				};
			}
		}

		//We have to call trigger twice, as we can not be sure if all
		//iframes have completed loading when this code runs. The
		//event listener also catches the page changing in the iFrame.
		function init(msg){
			function iFrameLoaded(){
				trigger('iFrame.onload', msg, iframe, undefined , true);
				checkReset();
			}

			addEventListener(iframe,'load',iFrameLoaded);
			trigger('init', msg, iframe, undefined, true);
		}

		function checkOptions(options){
			if ('object' !== typeof options){
				throw new TypeError('Options is not an object');
			}
		}

		function copyOptions(options){
			for (var option in defaults) {
				if (defaults.hasOwnProperty(option)){
					settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
				}
			}
		}

		function getTargetOrigin (remoteHost){
			return ('' === remoteHost || 'file://' === remoteHost) ? '*' : remoteHost;
		}

		function processOptions(options){
			options = options || {};
			settings[iframeId] = {
				firstRun	: true,
				iframe		: iframe,
				remoteHost	: iframe.src.split('/').slice(0,3).join('/')
			};

			checkOptions(options);
			copyOptions(options);

			settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
		}

		function beenHere(){
			return (iframeId in settings && 'iFrameResizer' in iframe);
		}

		var iframeId = ensureHasId(iframe.id);

		if (!beenHere()){
			processOptions(options);
			setScrolling();
			setLimits();
			setupBodyMarginValues();
			init(createOutgoingMsg(iframeId));
			setupIFrameObject();
		} else {
			warn(iframeId,'Ignored iFrame, already setup.');
		}
	}

	function debouce(fn,time){
		if (null === timer){
			timer = setTimeout(function(){
				timer = null;
				fn();
			}, time);
		}
	}

	/* istanbul ignore next */  //Not testable in PhantomJS
	function fixHiddenIFrames(){
		function checkIFrames(){
			function checkIFrame(settingId){
				function chkDimension(dimension){
					return '0px' === settings[settingId].iframe.style[dimension];
				}

				function isVisible(el) {
					return (null !== el.offsetParent);
				}

				if (isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))){
					trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
				}
			}

			for (var settingId in settings){
				checkIFrame(settingId);
			}
		}

		function mutationObserved(mutations){
			log('window','Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
			debouce(checkIFrames,16);
		}

		function createMutationObserver(){
			var
				target = document.querySelector('body'),

				config = {
					attributes            : true,
					attributeOldValue     : false,
					characterData         : true,
					characterDataOldValue : false,
					childList             : true,
					subtree               : true
				},

				observer = new MutationObserver(mutationObserved);

			observer.observe(target, config);
		}

		var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

		if (MutationObserver) createMutationObserver();
	}


	function resizeIFrames(event){
		function resize(){
			sendTriggerMsg('Window '+event,'resize');
		}

		log('window','Trigger event: '+event);
		debouce(resize,16);
	}

	/* istanbul ignore next */  //Not testable in PhantomJS
	function tabVisible() {
		function resize(){
			sendTriggerMsg('Tab Visable','resize');
		}

		if('hidden' !== document.visibilityState) {
			log('document','Trigger event: Visiblity change');
			debouce(resize,16);
		}
	}

	function sendTriggerMsg(eventName,event){
		function isIFrameResizeEnabled(iframeId) {
			return	'parent' === settings[iframeId].resizeFrom &&
					settings[iframeId].autoResize &&
					!settings[iframeId].firstRun;
		}

		for (var iframeId in settings){
			if(isIFrameResizeEnabled(iframeId)){
				trigger(eventName, event, document.getElementById(iframeId), iframeId);
			}
		}
	}

	function setupEventListeners(){
		addEventListener(window,'message',iFrameListener);

		addEventListener(window,'resize', function(){resizeIFrames('resize');});

		addEventListener(document,'visibilitychange',tabVisible);
		addEventListener(document,'-webkit-visibilitychange',tabVisible); //Andriod 4.4
		addEventListener(window,'focusin',function(){resizeIFrames('focus');}); //IE8-9
		addEventListener(window,'focus',function(){resizeIFrames('focus');});
	}


	function factory(){
		function init(options,element){
			function chkType(){
				if(!element.tagName) {
					throw new TypeError('Object is not a valid DOM element');
				} else if ('IFRAME' !== element.tagName.toUpperCase()) {
					throw new TypeError('Expected <IFRAME> tag, found <'+element.tagName+'>');
				}
			}

			if(element) {
				chkType();
				setupIFrame(element, options);
				iFrames.push(element);
			}
		}

		function warnDeprecatedOptions(options) {
			if (options && options.enablePublicMethods) {
				warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
			}
		}

		var iFrames;

		setupRequestAnimationFrame();
		setupEventListeners();

		return function iFrameResizeF(options,target){
			iFrames = []; //Only return iFrames past in on this call

			warnDeprecatedOptions(options);

			switch (typeof(target)){
			case 'undefined':
			case 'string':
				Array.prototype.forEach.call(
					document.querySelectorAll( target || 'iframe' ),
					init.bind(undefined, options)
				);
				break;
			case 'object':
				init(options,target);
				break;
			default:
				throw new TypeError('Unexpected data type ('+typeof(target)+')');
			}

			return iFrames;
		};
	}

	function createJQueryPublicMethod($){
		if (!$.fn) {
			info('','Unable to bind to jQuery, it is not fully loaded.');
		} else if (!$.fn.iFrameResize){
			$.fn.iFrameResize = function $iFrameResizeF(options) {
				function init(index, element) {
					setupIFrame(element, options);
				}

				return this.filter('iframe').each(init).end();
			};
		}
	}

	if (window.jQuery) { createJQueryPublicMethod(window.jQuery); }

	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === 'object' && typeof module.exports === 'object') { //Node for browserfy
		module.exports = factory();
	} else {
		window.iFrameResize = window.iFrameResize || factory();
	}

})();


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Ian Caunce - ian@hallnet.co.uk
 */


;(function(undefined) {
	'use strict';

	if(typeof window === 'undefined') return; // don't run for server side render

	var
		autoResize            = true,
		base                  = 10,
		bodyBackground        = '',
		bodyMargin            = 0,
		bodyMarginStr         = '',
		bodyObserver          = null,
		bodyPadding           = '',
		calculateWidth        = false,
		doubleEventList       = {'resize':1,'click':1},
		eventCancelTimer      = 128,
		firstRun              = true,
		height                = 1,
		heightCalcModeDefault = 'bodyOffset',
		heightCalcMode        = heightCalcModeDefault,
		initLock              = true,
		initMsg               = '',
		inPageLinks           = {},
		interval              = 32,
		intervalTimer         = null,
		logging               = false,
		msgID                 = '[iFrameSizer]',  //Must match host page msg ID
		msgIdLen              = msgID.length,
		myID                  = '',
		observer              = null,
		resetRequiredMethods  = {max:1,min:1,bodyScroll:1,documentElementScroll:1},
		resizeFrom            = 'child',
		sendPermit            = true,
		target                = window.parent,
		targetOriginDefault   = '*',
		tolerance             = 0,
		triggerLocked         = false,
		triggerLockedTimer    = null,
		throttledTimer        = 16,
		width                 = 1,
		widthCalcModeDefault  = 'scroll',
		widthCalcMode         = widthCalcModeDefault,
		win                   = window,
		messageCallback       = function(){ warn('MessageCallback function not defined'); },
		readyCallback         = function(){},
		pageInfoCallback      = function(){},
		customCalcMethods     = {
			height: function(){
				warn('Custom height calculation function not defined');
				return document.documentElement.offsetHeight;
			},
			width: function(){
				warn('Custom width calculation function not defined');
				return document.body.scrollWidth;
			}
		},
		eventHandlersByName   = {};


	function addEventListener(el,evt,func){
		/* istanbul ignore else */ // Not testable in phantonJS
		if ('addEventListener' in window){
			el.addEventListener(evt,func, false);
		} else if ('attachEvent' in window){ //IE
			el.attachEvent('on'+evt,func);
		}
	}

	function removeEventListener(el,evt,func){
		/* istanbul ignore else */ // Not testable in phantonJS
		if ('removeEventListener' in window){
			el.removeEventListener(evt,func, false);
		} else if ('detachEvent' in window){ //IE
			el.detachEvent('on'+evt,func);
		}
	}

	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	//Based on underscore.js
	function throttle(func) {
		var
			context, args, result,
			timeout = null,
			previous = 0,
			later = function() {
				previous = getNow();
				timeout = null;
				result = func.apply(context, args);
				if (!timeout) {
					context = args = null;
				}
			};

		return function() {
			var now = getNow();

			if (!previous) {
				previous = now;
			}

			var remaining = throttledTimer - (now - previous);

			context = this;
			args = arguments;

			if (remaining <= 0 || remaining > throttledTimer) {
				if (timeout) {
					clearTimeout(timeout);
					timeout = null;
				}

				previous = now;
				result = func.apply(context, args);

				if (!timeout) {
					context = args = null;
				}

			} else if (!timeout) {
				timeout = setTimeout(later, remaining);
			}

			return result;
		};
	}

	var getNow = Date.now || function() {
		/* istanbul ignore next */ // Not testable in PhantonJS
		return new Date().getTime();
	};

	function formatLogMsg(msg){
		return msgID + '[' + myID + ']' + ' ' + msg;
	}

	function log(msg){
		if (logging && ('object' === typeof window.console)){
			console.log(formatLogMsg(msg));
		}
	}

	function warn(msg){
		if ('object' === typeof window.console){
			console.warn(formatLogMsg(msg));
		}
	}


	function init(){
		readDataFromParent();
		log('Initialising iFrame ('+location.href+')');
		readDataFromPage();
		setMargin();
		setBodyStyle('background',bodyBackground);
		setBodyStyle('padding',bodyPadding);
		injectClearFixIntoBodyElement();
		checkHeightMode();
		checkWidthMode();
		stopInfiniteResizingOfIFrame();
		setupPublicMethods();
		startEventListeners();
		inPageLinks = setupInPageLinks();
		sendSize('init','Init message from host page');
		readyCallback();
	}

	function readDataFromParent(){

		function strBool(str){
			return 'true' === str ? true : false;
		}

		var data = initMsg.substr(msgIdLen).split(':');

		myID               = data[0];
		bodyMargin         = (undefined !== data[1]) ? Number(data[1])   : bodyMargin; //For V1 compatibility
		calculateWidth     = (undefined !== data[2]) ? strBool(data[2])  : calculateWidth;
		logging            = (undefined !== data[3]) ? strBool(data[3])  : logging;
		interval           = (undefined !== data[4]) ? Number(data[4])   : interval;
		autoResize         = (undefined !== data[6]) ? strBool(data[6])  : autoResize;
		bodyMarginStr      = data[7];
		heightCalcMode     = (undefined !== data[8]) ? data[8]           : heightCalcMode;
		bodyBackground     = data[9];
		bodyPadding        = data[10];
		tolerance          = (undefined !== data[11]) ? Number(data[11]) : tolerance;
		inPageLinks.enable = (undefined !== data[12]) ? strBool(data[12]): false;
		resizeFrom         = (undefined !== data[13]) ? data[13]         : resizeFrom;
		widthCalcMode      = (undefined !== data[14]) ? data[14]         : widthCalcMode;
	}

	function readDataFromPage(){
		function readData(){
			var data = window.iFrameResizer;

			log('Reading data from page: ' + JSON.stringify(data));

			messageCallback     = ('messageCallback'         in data) ? data.messageCallback         : messageCallback;
			readyCallback       = ('readyCallback'           in data) ? data.readyCallback           : readyCallback;
			targetOriginDefault = ('targetOrigin'            in data) ? data.targetOrigin            : targetOriginDefault;
			heightCalcMode      = ('heightCalculationMethod' in data) ? data.heightCalculationMethod : heightCalcMode;
			widthCalcMode       = ('widthCalculationMethod'  in data) ? data.widthCalculationMethod  : widthCalcMode;
		}

		function setupCustomCalcMethods(calcMode, calcFunc){
			if ('function' === typeof calcMode) {
				log('Setup custom ' + calcFunc + 'CalcMethod');
				customCalcMethods[calcFunc] = calcMode;
				calcMode = 'custom';
			}

			return calcMode;
		}

		if(('iFrameResizer' in window) && (Object === window.iFrameResizer.constructor)) {
			readData();
			heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
			widthCalcMode  = setupCustomCalcMethods(widthCalcMode,  'width');
		}

		log('TargetOrigin for parent set to: ' + targetOriginDefault);
	}


	function chkCSS(attr,value){
		if (-1 !== value.indexOf('-')){
			warn('Negative CSS value ignored for '+attr);
			value='';
		}
		return value;
	}

	function setBodyStyle(attr,value){
		if ((undefined !== value) && ('' !== value) && ('null' !== value)){
			document.body.style[attr] = value;
			log('Body '+attr+' set to "'+value+'"');
		}
	}

	function setMargin(){
		//If called via V1 script, convert bodyMargin from int to str
		if (undefined === bodyMarginStr){
			bodyMarginStr = bodyMargin+'px';
		}

		setBodyStyle('margin',chkCSS('margin',bodyMarginStr));
	}

	function stopInfiniteResizingOfIFrame(){
		document.documentElement.style.height = '';
		document.body.style.height = '';
		log('HTML & body height set to "auto"');
	}


	function manageTriggerEvent(options){

		var listener = {
			add:    function(eventName){
				function handleEvent(){
					sendSize(options.eventName,options.eventType);
				}

				eventHandlersByName[eventName] = handleEvent;

				addEventListener(window,eventName,handleEvent);
			},
			remove: function(eventName){
				var handleEvent = eventHandlersByName[eventName];
				delete eventHandlersByName[eventName];

				removeEventListener(window,eventName,handleEvent);
			}
		};

		if(options.eventNames && Array.prototype.map){
			options.eventName = options.eventNames[0];
			options.eventNames.map(listener[options.method]);
		} else {
			listener[options.method](options.eventName);
		}

		log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
	}

	function manageEventListeners(method){
		manageTriggerEvent({method:method, eventType: 'Animation Start',           eventNames: ['animationstart','webkitAnimationStart'] });
		manageTriggerEvent({method:method, eventType: 'Animation Iteration',       eventNames: ['animationiteration','webkitAnimationIteration'] });
		manageTriggerEvent({method:method, eventType: 'Animation End',             eventNames: ['animationend','webkitAnimationEnd'] });
		manageTriggerEvent({method:method, eventType: 'Input',                     eventName:  'input' });
		manageTriggerEvent({method:method, eventType: 'Mouse Up',                  eventName:  'mouseup' });
		manageTriggerEvent({method:method, eventType: 'Mouse Down',                eventName:  'mousedown' });
		manageTriggerEvent({method:method, eventType: 'Orientation Change',        eventName:  'orientationchange' });
		manageTriggerEvent({method:method, eventType: 'Print',                     eventName:  ['afterprint', 'beforeprint'] });
		manageTriggerEvent({method:method, eventType: 'Ready State Change',        eventName:  'readystatechange' });
		manageTriggerEvent({method:method, eventType: 'Touch Start',               eventName:  'touchstart' });
		manageTriggerEvent({method:method, eventType: 'Touch End',                 eventName:  'touchend' });
		manageTriggerEvent({method:method, eventType: 'Touch Cancel',              eventName:  'touchcancel' });
		manageTriggerEvent({method:method, eventType: 'Transition Start',          eventNames: ['transitionstart','webkitTransitionStart','MSTransitionStart','oTransitionStart','otransitionstart'] });
		manageTriggerEvent({method:method, eventType: 'Transition Iteration',      eventNames: ['transitioniteration','webkitTransitionIteration','MSTransitionIteration','oTransitionIteration','otransitioniteration'] });
		manageTriggerEvent({method:method, eventType: 'Transition End',            eventNames: ['transitionend','webkitTransitionEnd','MSTransitionEnd','oTransitionEnd','otransitionend'] });
		if('child' === resizeFrom){
			manageTriggerEvent({method:method, eventType: 'IFrame Resized',        eventName:  'resize' });
		}
	}

	function checkCalcMode(calcMode,calcModeDefault,modes,type){
		if (calcModeDefault !== calcMode){
			if (!(calcMode in modes)){
				warn(calcMode + ' is not a valid option for '+type+'CalculationMethod.');
				calcMode=calcModeDefault;
			}
			log(type+' calculation method set to "'+calcMode+'"');
		}

		return calcMode;
	}

	function checkHeightMode(){
		heightCalcMode = checkCalcMode(heightCalcMode,heightCalcModeDefault,getHeight,'height');
	}

	function checkWidthMode(){
		widthCalcMode = checkCalcMode(widthCalcMode,widthCalcModeDefault,getWidth,'width');
	}

	function startEventListeners(){
		if ( true === autoResize ) {
			manageEventListeners('add');
			setupMutationObserver();
		}
		else {
			log('Auto Resize disabled');
		}
	}

	function stopMsgsToParent(){
		log('Disable outgoing messages');
		sendPermit = false;
	}

	function removeMsgListener(){
		log('Remove event listener: Message');
		removeEventListener(window, 'message', receiver);
	}

	function disconnectMutationObserver(){
		if (null !== bodyObserver){
			/* istanbul ignore next */ // Not testable in PhantonJS
			bodyObserver.disconnect();
		}
	}

	function stopEventListeners(){
		manageEventListeners('remove');
		disconnectMutationObserver();
		clearInterval(intervalTimer);
	}

	function teardown(){
		stopMsgsToParent();
		removeMsgListener();
		if (true === autoResize) stopEventListeners();
	}

	function injectClearFixIntoBodyElement(){
		var clearFix = document.createElement('div');
		clearFix.style.clear   = 'both';
		clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
		document.body.appendChild(clearFix);
	}

	function setupInPageLinks(){

		function getPagePosition (){
			return {
				x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
				y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
			};
		}

		function getElementPosition(el){
			var
				elPosition   = el.getBoundingClientRect(),
				pagePosition = getPagePosition();

			return {
				x: parseInt(elPosition.left,10) + parseInt(pagePosition.x,10),
				y: parseInt(elPosition.top,10)  + parseInt(pagePosition.y,10)
			};
		}

		function findTarget(location){
			function jumpToTarget(target){
				var jumpPosition = getElementPosition(target);

				log('Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
				sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
			}

			var
				hash     = location.split('#')[1] || location, //Remove # if present
				hashData = decodeURIComponent(hash),
				target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

			if (undefined !== target){
				jumpToTarget(target);
			} else {
				log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
				sendMsg(0,0,'inPageLink','#'+hash);
			}
		}

		function checkLocationHash(){
			if ('' !== location.hash && '#' !== location.hash){
				findTarget(location.href);
			}
		}

		function bindAnchors(){
			function setupLink(el){
				function linkClicked(e){
					e.preventDefault();

					/*jshint validthis:true */
					findTarget(this.getAttribute('href'));
				}

				if ('#' !== el.getAttribute('href')){
					addEventListener(el,'click',linkClicked);
				}
			}

			Array.prototype.forEach.call( document.querySelectorAll( 'a[href^="#"]' ), setupLink );
		}

		function bindLocationHash(){
			addEventListener(window,'hashchange',checkLocationHash);
		}

		function initCheck(){ //check if page loaded with location hash after init resize
			setTimeout(checkLocationHash,eventCancelTimer);
		}

		function enableInPageLinks(){
			/* istanbul ignore else */ // Not testable in phantonJS
			if(Array.prototype.forEach && document.querySelectorAll){
				log('Setting up location.hash handlers');
				bindAnchors();
				bindLocationHash();
				initCheck();
			} else {
				warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
			}
		}

		if(inPageLinks.enable){
			enableInPageLinks();
		} else {
			log('In page linking not enabled');
		}

		return {
			findTarget:findTarget
		};
	}

	function setupPublicMethods(){
		log('Enable public methods');

		win.parentIFrame = {

			autoResize: function autoResizeF(resize){
				if (true === resize && false === autoResize) {
					autoResize=true;
					startEventListeners();
					//sendSize('autoResize','Auto Resize enabled');
				} else if (false === resize && true === autoResize) {
					autoResize=false;
					stopEventListeners();
				}

				return autoResize;
			},

			close: function closeF(){
				sendMsg(0,0,'close');
				teardown();
			},

			getId: function getIdF(){
				return myID;
			},

			getPageInfo: function getPageInfoF(callback){
				if ('function' === typeof callback){
					pageInfoCallback = callback;
					sendMsg(0,0,'pageInfo');
				} else {
					pageInfoCallback = function(){};
					sendMsg(0,0,'pageInfoStop');
				}
			},

			moveToAnchor: function moveToAnchorF(hash){
				inPageLinks.findTarget(hash);
			},

			reset: function resetF(){
				resetIFrame('parentIFrame.reset');
			},

			scrollTo: function scrollToF(x,y){
				sendMsg(y,x,'scrollTo'); // X&Y reversed at sendMsg uses height/width
			},

			scrollToOffset: function scrollToF(x,y){
				sendMsg(y,x,'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
			},

			sendMessage: function sendMessageF(msg,targetOrigin){
				sendMsg(0,0,'message',JSON.stringify(msg),targetOrigin);
			},

			setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod){
				heightCalcMode = heightCalculationMethod;
				checkHeightMode();
			},

			setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod){
				widthCalcMode = widthCalculationMethod;
				checkWidthMode();
			},

			setTargetOrigin: function setTargetOriginF(targetOrigin){
				log('Set targetOrigin: '+targetOrigin);
				targetOriginDefault = targetOrigin;
			},

			size: function sizeF(customHeight, customWidth){
				var valString = ''+(customHeight?customHeight:'')+(customWidth?','+customWidth:'');
				//lockTrigger();
				sendSize('size','parentIFrame.size('+valString+')', customHeight, customWidth);
			}
		};
	}

	function initInterval(){
		if ( 0 !== interval ){
			log('setInterval: '+interval+'ms');
			intervalTimer = setInterval(function(){
				sendSize('interval','setInterval: '+interval);
			},Math.abs(interval));
		}
	}

	/* istanbul ignore next */  //Not testable in PhantomJS
	function setupBodyMutationObserver(){
		function addImageLoadListners(mutation) {
			function addImageLoadListener(element){
				if (false === element.complete) {
					log('Attach listeners to ' + element.src);
					element.addEventListener('load', imageLoaded, false);
					element.addEventListener('error', imageError, false);
					elements.push(element);
				}
			}

			if (mutation.type === 'attributes' && mutation.attributeName === 'src'){
				addImageLoadListener(mutation.target);
			} else if (mutation.type === 'childList'){
				Array.prototype.forEach.call(
					mutation.target.querySelectorAll('img'),
					addImageLoadListener
				);
			}
		}

		function removeFromArray(element){
			elements.splice(elements.indexOf(element),1);
		}

		function removeImageLoadListener(element){
			log('Remove listeners from ' + element.src);
			element.removeEventListener('load', imageLoaded, false);
			element.removeEventListener('error', imageError, false);
			removeFromArray(element);
		}

		function imageEventTriggered(event,type,typeDesc){
			removeImageLoadListener(event.target);
			sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
		}

		function imageLoaded(event) {
			imageEventTriggered(event,'imageLoad','Image loaded');
		}

		function imageError(event) {
			imageEventTriggered(event,'imageLoadFailed','Image load failed');
		}

		function mutationObserved(mutations) {
			sendSize('mutationObserver','mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);

			//Deal with WebKit asyncing image loading when tags are injected into the page
			mutations.forEach(addImageLoadListners);
		}

		function createMutationObserver(){
			var
				target = document.querySelector('body'),

				config = {
					attributes            : true,
					attributeOldValue     : false,
					characterData         : true,
					characterDataOldValue : false,
					childList             : true,
					subtree               : true
				};

			observer = new MutationObserver(mutationObserved);

			log('Create body MutationObserver');
			observer.observe(target, config);

			return observer;
		}

		var
			elements         = [],
			MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
			observer         = createMutationObserver();

		return {
			disconnect: function (){
				if ('disconnect' in observer){
					log('Disconnect body MutationObserver');
					observer.disconnect();
					elements.forEach(removeImageLoadListener);
				}
			}
		};
	}

	function setupMutationObserver(){
		var	forceIntervalTimer = 0 > interval;

		/* istanbul ignore if */ // Not testable in PhantomJS
		if (window.MutationObserver || window.WebKitMutationObserver){
			if (forceIntervalTimer) {
				initInterval();
			} else {
				bodyObserver = setupBodyMutationObserver();
			}
		} else {
			log('MutationObserver not supported in this browser!');
			initInterval();
		}
	}


	// document.documentElement.offsetHeight is not reliable, so
	// we have to jump through hoops to get a better value.
	function getComputedStyle(prop,el) {
		/* istanbul ignore next */  //Not testable in PhantomJS
		function convertUnitsToPxForIE8(value) {
			var PIXEL = /^\d+(px)?$/i;

			if (PIXEL.test(value)) {
				return parseInt(value,base);
			}

			var
				style = el.style.left,
				runtimeStyle = el.runtimeStyle.left;

			el.runtimeStyle.left = el.currentStyle.left;
			el.style.left = value || 0;
			value = el.style.pixelLeft;
			el.style.left = style;
			el.runtimeStyle.left = runtimeStyle;

			return value;
		}

		var retVal = 0;
		el =  el || document.body;

		/* istanbul ignore else */ // Not testable in phantonJS
		if (('defaultView' in document) && ('getComputedStyle' in document.defaultView)) {
			retVal = document.defaultView.getComputedStyle(el, null);
			retVal = (null !== retVal) ? retVal[prop] : 0;
		} else {//IE8
			retVal =  convertUnitsToPxForIE8(el.currentStyle[prop]);
		}

		return parseInt(retVal,base);
	}

	function chkEventThottle(timer){
		if(timer > throttledTimer/2){
			throttledTimer = 2*timer;
			log('Event throttle increased to ' + throttledTimer + 'ms');
		}
	}

	//Idea from https://github.com/guardian/iframe-messenger
	function getMaxElement(side,elements) {
		var
			elementsLength = elements.length,
			elVal          = 0,
			maxVal         = 0,
			Side           = capitalizeFirstLetter(side),
			timer          = getNow();

		for (var i = 0; i < elementsLength; i++) {
			elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin'+Side,elements[i]);
			if (elVal > maxVal) {
				maxVal = elVal;
			}
		}

		timer = getNow() - timer;

		log('Parsed '+elementsLength+' HTML elements');
		log('Element position calculated in ' + timer + 'ms');

		chkEventThottle(timer);

		return maxVal;
	}

	function getAllMeasurements(dimention){
		return [
			dimention.bodyOffset(),
			dimention.bodyScroll(),
			dimention.documentElementOffset(),
			dimention.documentElementScroll()
		];
	}

	function getTaggedElements(side,tag){
		function noTaggedElementsFound(){
			warn('No tagged elements ('+tag+') found on page');
			return document.querySelectorAll('body *');
		}

		var elements = document.querySelectorAll('['+tag+']');

		if (0 === elements.length) noTaggedElementsFound();

		return getMaxElement(side,elements);
	}

	function getAllElements(){
		return document.querySelectorAll('body *');
	}

	var
		getHeight = {
			bodyOffset: function getBodyOffsetHeight(){
				return  document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
			},

			offset: function(){
				return getHeight.bodyOffset(); //Backwards compatability
			},

			bodyScroll: function getBodyScrollHeight(){
				return document.body.scrollHeight;
			},

			custom: function getCustomWidth(){
				return customCalcMethods.height();
			},

			documentElementOffset: function getDEOffsetHeight(){
				return document.documentElement.offsetHeight;
			},

			documentElementScroll: function getDEScrollHeight(){
				return document.documentElement.scrollHeight;
			},

			max: function getMaxHeight(){
				return Math.max.apply(null,getAllMeasurements(getHeight));
			},

			min: function getMinHeight(){
				return Math.min.apply(null,getAllMeasurements(getHeight));
			},

			grow: function growHeight(){
				return getHeight.max(); //Run max without the forced downsizing
			},

			lowestElement: function getBestHeight(){
				return Math.max(getHeight.bodyOffset(), getMaxElement('bottom',getAllElements()));
			},

			taggedElement: function getTaggedElementsHeight(){
				return getTaggedElements('bottom','data-iframe-height');
			}
		},

		getWidth = {
			bodyScroll: function getBodyScrollWidth(){
				return document.body.scrollWidth;
			},

			bodyOffset: function getBodyOffsetWidth(){
				return document.body.offsetWidth;
			},

			custom: function getCustomWidth(){
				return customCalcMethods.width();
			},

			documentElementScroll: function getDEScrollWidth(){
				return document.documentElement.scrollWidth;
			},

			documentElementOffset: function getDEOffsetWidth(){
				return document.documentElement.offsetWidth;
			},

			scroll: function getMaxWidth(){
				return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
			},

			max: function getMaxWidth(){
				return Math.max.apply(null,getAllMeasurements(getWidth));
			},

			min: function getMinWidth(){
				return Math.min.apply(null,getAllMeasurements(getWidth));
			},

			rightMostElement: function rightMostElement(){
				return getMaxElement('right', getAllElements());
			},

			taggedElement: function getTaggedElementsWidth(){
				return getTaggedElements('right', 'data-iframe-width');
			}
		};


	function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth){

		function resizeIFrame(){
			height = currentHeight;
			width  = currentWidth;

			sendMsg(height,width,triggerEvent);
		}

		function isSizeChangeDetected(){
			function checkTolarance(a,b){
				var retVal = Math.abs(a-b) <= tolerance;
				return !retVal;
			}

			currentHeight = (undefined !== customHeight)  ? customHeight : getHeight[heightCalcMode]();
			currentWidth  = (undefined !== customWidth )  ? customWidth  : getWidth[widthCalcMode]();

			return	checkTolarance(height,currentHeight) || (calculateWidth && checkTolarance(width,currentWidth));
		}

		function isForceResizableEvent(){
			return !(triggerEvent in {'init':1,'interval':1,'size':1});
		}

		function isForceResizableCalcMode(){
			return (heightCalcMode in resetRequiredMethods) || (calculateWidth && widthCalcMode in resetRequiredMethods);
		}

		function logIgnored(){
			log('No change in size detected');
		}

		function checkDownSizing(){
			if (isForceResizableEvent() && isForceResizableCalcMode()){
				resetIFrame(triggerEventDesc);
			} else if (!(triggerEvent in {'interval':1})){
				logIgnored();
			}
		}

		var	currentHeight,currentWidth;

		if (isSizeChangeDetected() || 'init' === triggerEvent){
			lockTrigger();
			resizeIFrame();
		} else {
			checkDownSizing();
		}
	}

	var sizeIFrameThrottled = throttle(sizeIFrame);

	function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth){
		function recordTrigger(){
			if (!(triggerEvent in {'reset':1,'resetPage':1,'init':1})){
				log( 'Trigger event: ' + triggerEventDesc );
			}
		}

		function isDoubleFiredEvent(){
			return  triggerLocked && (triggerEvent in doubleEventList);
		}

		if (!isDoubleFiredEvent()){
			recordTrigger();
			sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
		} else {
			log('Trigger event cancelled: '+triggerEvent);
		}
	}

	function lockTrigger(){
		if (!triggerLocked){
			triggerLocked = true;
			log('Trigger event lock on');
		}
		clearTimeout(triggerLockedTimer);
		triggerLockedTimer = setTimeout(function(){
			triggerLocked = false;
			log('Trigger event lock off');
			log('--');
		},eventCancelTimer);
	}

	function triggerReset(triggerEvent){
		height = getHeight[heightCalcMode]();
		width  = getWidth[widthCalcMode]();

		sendMsg(height,width,triggerEvent);
	}

	function resetIFrame(triggerEventDesc){
		var hcm = heightCalcMode;
		heightCalcMode = heightCalcModeDefault;

		log('Reset trigger event: ' + triggerEventDesc);
		lockTrigger();
		triggerReset('reset');

		heightCalcMode = hcm;
	}

	function sendMsg(height,width,triggerEvent,msg,targetOrigin){
		function setTargetOrigin(){
			if (undefined === targetOrigin){
				targetOrigin = targetOriginDefault;
			} else {
				log('Message targetOrigin: '+targetOrigin);
			}
		}

		function sendToParent(){
			var
				size  = height + ':' + width,
				message = myID + ':' +  size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');

			log('Sending message to host page (' + message + ')');
			target.postMessage( msgID + message, targetOrigin);
		}

		if(true === sendPermit){
			setTargetOrigin();
			sendToParent();
		}
	}

	function receiver(event) {
		var processRequestFromParent = {
			init: function initFromParent(){
				function fireInit(){
					initMsg = event.data;
					target  = event.source;

					init();
					firstRun = false;
					setTimeout(function(){ initLock = false;},eventCancelTimer);
				}

				if (document.body){
					fireInit();
				} else {
					log('Waiting for page ready');
					addEventListener(window,'readystatechange',processRequestFromParent.initFromParent);
				}
			},

			reset: function resetFromParent(){
				if (!initLock){
					log('Page size reset by host page');
					triggerReset('resetPage');
				} else {
					log('Page reset ignored by init');
				}
			},

			resize: function resizeFromParent(){
				sendSize('resizeParent','Parent window requested size check');
			},

			moveToAnchor: function moveToAnchorF(){
				inPageLinks.findTarget(getData());
			},
			inPageLink: function inPageLinkF() {this.moveToAnchor();}, //Backward compatability

			pageInfo: function pageInfoFromParent(){
				var msgBody = getData();
				log('PageInfoFromParent called from parent: ' + msgBody );
				pageInfoCallback(JSON.parse(msgBody));
				log(' --');
			},

			message: function messageFromParent(){
				var msgBody = getData();

				log('MessageCallback called from parent: ' + msgBody );
				messageCallback(JSON.parse(msgBody));
				log(' --');
			}
		};

		function isMessageForUs(){
			return msgID === (''+event.data).substr(0,msgIdLen); //''+ Protects against non-string messages
		}

		function getMessageType(){
			return event.data.split(']')[1].split(':')[0];
		}

		function getData(){
			return event.data.substr(event.data.indexOf(':')+1);
		}

		function isMiddleTier(){
			return !(typeof module !== 'undefined' && module.exports) && ('iFrameResize' in window);
		}

		function isInitMsg(){
			//Test if this message is from a child below us. This is an ugly test, however, updating
			//the message format would break backwards compatibity.
			return event.data.split(':')[2] in {'true':1,'false':1};
		}

		function callFromParent(){
			var messageType = getMessageType();

			if (messageType in processRequestFromParent){
				processRequestFromParent[messageType]();
			} else if (!isMiddleTier() && !isInitMsg()){
				warn('Unexpected message ('+event.data+')');
			}
		}

		function processMessage(){
			if (false === firstRun) {
				callFromParent();
			} else if (isInitMsg()) {
				processRequestFromParent.init();
			} else {
				log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
			}
		}

		if (isMessageForUs()){
			processMessage();
		}
	}

	//Normally the parent kicks things off when it detects the iFrame has loaded.
	//If this script is async-loaded, then tell parent page to retry init.
	function chkLateLoaded(){
		if('loading' !== document.readyState){
			window.parent.postMessage('[iFrameResizerChild]Ready','*');
		}
	}

	addEventListener(window, 'message', receiver);
	chkLateLoaded();

	

})();


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_meanBy__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_meanBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_meanBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
function averageProjectionsPercentage(schools,cluster){if(cluster&&cluster.projections_percentage){// We need to get a 2012 value.
var avg2012=__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(schools,function(s){return s.projections_percentage[0];})/schools.length;var all=[avg2012].concat(cluster.projections_percentage);return all;}var projectionsPercentage=[];var _loop=function _loop(i){var avg=__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(schools,function(s){if(isNaN(s.projections_percentage[i]))return 0;return s.projections_percentage[i];})/schools.length;projectionsPercentage.push(avg);};for(var i=0;i<schools[0].projections_percentage.length;i++){_loop(i);}return projectionsPercentage;}function totalProjections(schools){var projections=[];var _loop2=function _loop2(i){var sum=__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(schools,function(s){if(isNaN(s.projections[i]))return 0;return s.projections[i];});projections.push(sum);};for(var i=0;i<schools[0].projections.length;i++){_loop2(i);}return projections;}function clusterAggregate(schools,cluster){var average={isClusterAggregate:true,name:'Schools Group Average',playspace:__WEBPACK_IMPORTED_MODULE_0_lodash_meanBy___default()(schools,function(s){if(isNaN(s.playspace))return 0;return s.playspace;}),enrolment:__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(schools,function(s){if(isNaN(s.enrolment))return 0;return s.enrolment;}),projections_years:schools[0].projections_years,projections:totalProjections(schools),projections_percentage:averageProjectionsPercentage(schools,cluster),ligo:__WEBPACK_IMPORTED_MODULE_0_lodash_meanBy___default()(schools,function(s){if(isNaN(s.ligo))return 0;return s.ligo;}),classroomspace:__WEBPACK_IMPORTED_MODULE_0_lodash_meanBy___default()(schools,function(s){if(isNaN(s.classroomspace))return 0;return s.classroomspace;})};return average;}/* harmony default export */ __webpack_exports__["a"] = (clusterAggregate);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(302),
    mapCacheDelete = __webpack_require__(309),
    mapCacheGet = __webpack_require__(311),
    mapCacheHas = __webpack_require__(312),
    mapCacheSet = __webpack_require__(313);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(17),
    isSymbol = __webpack_require__(91);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(35);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29),
    _assign = __webpack_require__(3);

var ReactNoopUpdateQueue = __webpack_require__(93);

var canDefineProperty = __webpack_require__(94);
var emptyObject = __webpack_require__(39);
var invariant = __webpack_require__(0);
var lowPriorityWarning = __webpack_require__(158);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(166);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(18);

var invariant = __webpack_require__(0);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(5);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);
var escapeTextContentForBrowser = __webpack_require__(43);
var setInnerHTML = __webpack_require__(42);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(24);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactInstrumentation = __webpack_require__(8);

var quoteAttributeValueForBrowser = __webpack_require__(200);
var warning = __webpack_require__(1);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(67);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);

var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var ReactCompositeComponent = __webpack_require__(209);
var ReactEmptyComponent = __webpack_require__(115);
var ReactHostComponent = __webpack_require__(116);

var getNextDebugID = __webpack_require__(210);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var React = __webpack_require__(22);

var invariant = __webpack_require__(0);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(12);
var REACT_ELEMENT_TYPE = __webpack_require__(211);

var getIteratorFn = __webpack_require__(212);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(71);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var ReactCurrentOwner = __webpack_require__(12);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(7);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(224);

var containsNode = __webpack_require__(226);
var focusNode = __webpack_require__(108);
var getActiveElement = __webpack_require__(121);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(26);
var DOMProperty = __webpack_require__(24);
var React = __webpack_require__(22);
var ReactBrowserEventEmitter = __webpack_require__(44);
var ReactCurrentOwner = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactDOMContainerInfo = __webpack_require__(241);
var ReactDOMFeatureFlags = __webpack_require__(242);
var ReactFeatureFlags = __webpack_require__(103);
var ReactInstanceMap = __webpack_require__(33);
var ReactInstrumentation = __webpack_require__(8);
var ReactMarkupChecksum = __webpack_require__(243);
var ReactReconciler = __webpack_require__(25);
var ReactUpdateQueue = __webpack_require__(72);
var ReactUpdates = __webpack_require__(11);

var emptyObject = __webpack_require__(39);
var instantiateReactComponent = __webpack_require__(113);
var invariant = __webpack_require__(0);
var setInnerHTML = __webpack_require__(42);
var shouldUpdateReactComponent = __webpack_require__(70);
var warning = __webpack_require__(1);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(114);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(124);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(258);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(131);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(75);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(284),
    baseMatchesProperty = __webpack_require__(349),
    identity = __webpack_require__(359),
    isArray = __webpack_require__(17),
    property = __webpack_require__(360);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(46),
    stackClear = __webpack_require__(291),
    stackDelete = __webpack_require__(292),
    stackGet = __webpack_require__(293),
    stackHas = __webpack_require__(294),
    stackSet = __webpack_require__(295);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObject = __webpack_require__(87);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 137 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(314),
    isObjectLike = __webpack_require__(35);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(315),
    arraySome = __webpack_require__(318),
    cacheHas = __webpack_require__(319);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(331),
    baseKeys = __webpack_require__(338),
    isArrayLike = __webpack_require__(342);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(333),
    isObjectLike = __webpack_require__(35);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15),
    stubFalse = __webpack_require__(334);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)(module)))

/***/ }),
/* 143 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(335),
    baseUnary = __webpack_require__(336),
    nodeUtil = __webpack_require__(337);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(87);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(148);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(149),
    toKey = __webpack_require__(51);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(17),
    isKey = __webpack_require__(90),
    stringToPath = __webpack_require__(350),
    toString = __webpack_require__(353);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getSchoolColor=function getSchoolColor(schoolWithLineNodes){return function(school){if(school.isActive)return'#05E2FC';if(school.isClusterAggregate)return'#007C98';if(school.uid===schoolWithLineNodes.uid)return'#404040';return'#7A96A5';};};/* harmony default export */ __webpack_exports__["a"] = (getSchoolColor);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (str, index) {
    return 'i' + (index === undefined ? '' : index) + '-' + str.replace(/\W/g, '');
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_filter_data__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tooltip__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var tooltip=void 0;var svg=void 0;function makePlayspace(schools_data,cluster,chartName){var width=1000;var height=600;var stack_gap=30;var margin={top:50,right:0,bottom:50,left:0};var data=__WEBPACK_IMPORTED_MODULE_5__modules_filter_data__["a" /* default */].playspace(schools_data);var scaleFactor=data.length<5?0:0.5*data.length;// This is a bit crude and might not scale in all case but works for data we hacve
var elm=void 0;var card=void 0;var aside=void 0;var main=void 0;var slice=void 0;var average=void 0;var activeSchool=void 0;var playspaceScale=__WEBPACK_IMPORTED_MODULE_7_d3__["scaleLinear"]().domain([0,__WEBPACK_IMPORTED_MODULE_7_d3__["max"](data.map(function(d){return Math.sqrt(d.playspace)+scaleFactor;}))]).range([0,height-margin.top]);var calculatePlayspace=function calculatePlayspace(d){return playspaceScale(Math.sqrt(d.playspace))/2;};var invertPlayspace=function invertPlayspace(d){return playspaceScale.invert(d.playspace)*2;};function calculateAverage(){var sum=0;data.forEach(function(obj){if(obj.isActive){activeSchool=obj;}sum+=parseFloat(obj.playspace);});average=sum/data.length;}function initialiseElements(){elm=document.createElement('div');aside=__WEBPACK_IMPORTED_MODULE_7_d3__["select"](elm).append('div').attr('class','aside');main=__WEBPACK_IMPORTED_MODULE_7_d3__["select"](elm).append('div').attr('class','main').attr('aria-hidden','true');// For clusters with lots of schools, we need to make the viewbox bigger
var viewBoxY1=0;var viewBoxY2=height;var defaultSchools=14;// 14 schools fit by default
var outOfSightSchools=schools_data.length-defaultSchools;if(outOfSightSchools>0){var extraHeight=height/defaultSchools*outOfSightSchools;extraHeight=extraHeight+100;// just breathing room
viewBoxY1=0-extraHeight*0.5;viewBoxY2=height+extraHeight*0.5;}svg=main.append('svg').attr('id',chartName).attr('viewBox','0 '+viewBoxY1+' '+width+' '+viewBoxY2).attr('class','cluster-chart playspace-chart');}function setupToolTip(){var content='<div class="tooltip-content-wrapper">\n        <div class="tooltip-content">\n        <div>\n          <p class="tooltip-title"></p>\n          <p class="tooltip-number"></p>\n          <p class="a11y">Press enter to navigate to this school\'s page or tab to select another school.</p>\n        </div>\n        </div>\n      </div>';tooltip=new __WEBPACK_IMPORTED_MODULE_8__tooltip__["a" /* default */](content);main.node().appendChild(tooltip.elm);}var handleClick=function handleClick(d){if(__WEBPACK_IMPORTED_MODULE_7_d3__["event"])__WEBPACK_IMPORTED_MODULE_7_d3__["event"].stopPropagation();__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])(_defineProperty({},chartName,{selectedSchool:d,showTooltip:true})));};function drawAside(){if(activeSchool){card=aside.append('div').attr('class','card--highlight');card.append('p').attr('class','card-title').text(activeSchool.name);card.append('p').attr('class','big-number').text(Math.round(activeSchool.playspace*100)/100+'m\xB2');}card=aside.append('div').attr('class','card card-average');card.append('p').attr('class','card-title').text('Average play space for '+cluster+' schools group');card.append('p').attr('class','big-number').text(Math.round(average*100)/100+'m\xB2');// card.append('p')
//   .attr('class', 'card-title')
//   .text('per student')
}function drawChart(){var averagePlayspace=calculatePlayspace({playspace:average});var defs=svg.append('defs');var svgContainer=svg.append('g').attr('transform','translate('+margin.left+' '+margin.top+')').append('g').attr('transform',function(){var top=height-margin.bottom-margin.top-stack_gap*data.length-calculatePlayspace(data[data.length-1])/2;return'translate('+10+' '+top+')';}).append('g').attr('transform','matrix(0.866, 0.5, -0.866, 0.5, 0, 0)');// An alternative method results in a smaller isometric projection
// Can someone tell me why the translate is slightly different between the two methods?
// .append("g")
// .attr("transform", "translate(" + (stack_gap * (data.length-1)) + " " + (height - (stack_gap * (data.length-1)) ) +")")
// .attr("transform", "scale(1, 0.5)")
// .append("g")
// .attr("transform", "rotate(45)")
// Make a copy of the data and splice in the avergage for cluster view
var copy=data.map(function(d){return d;});if(!activeSchool){var j=0;copy.forEach(function(d,i){j=d.playspace>average?j:i;});copy.splice(j+1,0,{playspace:average,isAverage:true});}// Slice is in correct order use d
slice=defs.selectAll('g').data(copy).enter().append('g').attr('id',function(d,i){return'slice-'+d.uid;}).on('keydown',function(d,i){if(d.isAverage)return;var e=__WEBPACK_IMPORTED_MODULE_7_d3__["event"];var keys={SPACE:32,ENTER:13};if(e.type==='click'||e.keyCode===keys.SPACE||e.keyCode===keys.ENTER){__WEBPACK_IMPORTED_MODULE_7_d3__["selectAll"]('use').classed('nmbm',false);__WEBPACK_IMPORTED_MODULE_7_d3__["select"]('#use-'+d.uid).classed('nmbm',true);handleClick(d);}});slice.attr('transform',function(d,i){var sqd=calculatePlayspace(d);var y=i*stack_gap-sqd;var x=i*stack_gap;return'translate('+x+' '+y+')';}).attr('class',function(d){return'slice '+(d.isActive?'is-active':'');}).attr('tabindex',0);slice.append('rect').attr('class',function(d){return d.isAverage?'average':'rect';}).attr('width',calculatePlayspace).attr('height',calculatePlayspace);slice.filter(function(d){return!d.isAverage;}).append('rect').attr('class','left-side').attr('width',calculatePlayspace).attr('height',5).attr('transform',function(d){var sqd=calculatePlayspace(d);return'skewX(45) rotate(180 0 0) translate(0 '+-(sqd+5)+')';});slice.filter(function(d){return!d.isAverage;}).append('rect').attr('class','right-side').attr('height',calculatePlayspace).attr('width',5).attr('transform',function(d){var sqd=calculatePlayspace(d);return'skewY(45) rotate(0 0 '+sqd+')  translate('+sqd+' '+-sqd+')';});slice.each(function(d){if(d.isActive){__WEBPACK_IMPORTED_MODULE_7_d3__["select"](this).append('rect').attr('class','average').attr('width',function(){return averagePlayspace;}).attr('height',function(){return averagePlayspace;}).attr('pointer-events','none').attr('transform',function(d){var sqd=calculatePlayspace(d)-averagePlayspace;var y=sqd;var x=0;return'translate('+x+' '+y+')';});}});svgContainer.selectAll('use').data(copy).enter().append('use').attr('class',function(d,i){return copy[copy.length-i-1].isActive?'is-active':null;}).attr('id',function(d,i){return'use-'+copy[copy.length-i-1].uid;}).attr('data-name',function(d,i){return''+copy[copy.length-i-1].name;}).attr('xlink:href',function(d,i){return'#slice-'+copy[copy.length-i-1].uid;}).attr('tabindex',-1).on('mouseover',function(d,i){var node=__WEBPACK_IMPORTED_MODULE_7_d3__["select"]('#slice-'+copy[copy.length-i-1].uid).node();if(node.focus)node.focus();}).on('mouseout',function(d,i){var node=__WEBPACK_IMPORTED_MODULE_7_d3__["select"]('#slice-'+copy[copy.length-i-1].uid).node();if(node.blur)node.blur();}).on('click',function(d,i){if(copy[copy.length-i-1].isAverage)return;__WEBPACK_IMPORTED_MODULE_7_d3__["selectAll"]('use').classed('nmbm',false);__WEBPACK_IMPORTED_MODULE_7_d3__["select"](this).classed('nmbm',true);handleClick(copy[copy.length-i-1]);}).each(function(d,i){if(copy[copy.length-i-1].isAverage)return;});}function drawKey(){var keyArea=invertPlayspace({playspace:20});var keySize=20;var key=svg.append('g');key.attr('class','key').attr('transform',function(d,i){var y=height-margin.bottom/2;var x=margin.left;return'translate('+x+' '+y+')';});var perspectiveContainer=key.append('g').attr('class','slice').attr('transform','translate('+keySize+' '+-2.5+')').append('g').attr('transform','matrix(0.866, 0.5, -0.866, 0.5, 0, 0)');perspectiveContainer.append('rect').attr('class','rect').attr('width',keySize).attr('height',keySize);perspectiveContainer.append('rect').attr('class','left-side').attr('width',keySize).attr('height',5).attr('transform',function(d){return'skewX(45) rotate(180 0 0) translate(0 '+-(keySize+5)+')';});perspectiveContainer.append('rect').attr('class','right-side').attr('height',keySize).attr('width',5).attr('transform',function(d){return'skewY(45) rotate(0 0 '+keySize+')  translate('+keySize+' '+-keySize+')';});key.append('text').text('= '+Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["b" /* format */])(keyArea,1)+'m\xB2 play space').attr('transform',function(d,i){var y=17;var x=margin.left+keySize*1.75+10;return'translate('+x+' '+y+')';});// if (activeSchool) {
//   key.append('line')
//     .attr('class', 'dashed-line')
//     .attr('x1', 225)
//     .attr('x2', 255)
//     .attr('y1', 13)
//     .attr('y2', 13)
//     .attr('stroke', 'red')
//   key.append('text')
//     .text('Average play space')
//     .attr('transform', (d, i) => {
//       const y = 17
//       const x = margin.left + keySize * 2 + 225
//       return `translate(${x} ${y})`
//     })
// }
}calculateAverage();initialiseElements();setupToolTip();main.append('div').style('font-size','11px').text('Data subject to change.*');drawAside();drawChart();drawKey();elm.classList.add('chart');return elm;}var AvgPlayspace=function(_Component){_inherits(AvgPlayspace,_Component);function AvgPlayspace(){_classCallCheck(this,AvgPlayspace);return _possibleConstructorReturn(this,(AvgPlayspace.__proto__||Object.getPrototypeOf(AvgPlayspace)).apply(this,arguments));}_createClass(AvgPlayspace,[{key:'wrapChart',value:function wrapChart(){this.container=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);while(this.container.firstChild){this.container.removeChild(this.container.firstChild);}var data=this.props.data;var chart=makePlayspace(data.schools,data.name,this.props.chartName);this.container.appendChild(chart);}},{key:'componentDidMount',value:function componentDidMount(){this.wrapChart();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props$ui=this.props.ui,selectedSchool=_props$ui.selectedSchool,showTooltip=_props$ui.showTooltip;if(showTooltip&&selectedSchool){svg.selectAll('.nmbm').classed('nmbm',false);svg.select('#use-'+selectedSchool.uid).classed('nmbm',true);tooltip.onClick(function(){if(window.parentIFrame){window.parentIFrame.sendMessage({type:'change:school',school:__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */]});}else{window.location.search='school='+selectedSchool.uid;}});tooltip.elm.classList.add('tooltip-arrow');tooltip.elm.classList.remove('tooltip-active');if(selectedSchool.isActive){tooltip.elm.classList.remove('tooltip-arrow');tooltip.elm.classList.add('tooltip-active');}tooltip.show();tooltip.elm.querySelector('.tooltip-title').innerHTML=selectedSchool.name;tooltip.elm.querySelector('.tooltip-number').innerHTML=Object(__WEBPACK_IMPORTED_MODULE_6__modules_helpers__["b" /* format */])(selectedSchool.playspace)+'m\xB2';var bb=svg.select('#use-'+selectedSchool.uid).node().getBoundingClientRect();var scrollX=window.scrollX||document.documentElement.scrollLeft;var scrollY=window.scrollY||document.documentElement.scrollTop;var top=bb.top+bb.height/2+scrollY-tooltip.elm.clientHeight-20;var left=bb.left+bb.width+scrollX-tooltip.elm.clientWidth/2-10;tooltip.move(top,left);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return AvgPlayspace;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){return{ui:state.ui[ownProps.chartName]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectSchool:function selectSchool(p){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])(p));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AvgPlayspace));

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_filter_data__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var svg=void 0;var tooltip=void 0;function makeClassroomSpace(schools_data,cluster,chartName){var width=1000;var height=600;var stack_gap=30;var margin={top:50,right:0,bottom:50,left:0};var data=__WEBPACK_IMPORTED_MODULE_8__modules_filter_data__["a" /* default */].classSpace(schools_data);var scaleFactor=data.length<5?0:0.5*data.length;// This is a bit crude and might not scale in all case but works for data we hacve
var elm=void 0;var card=void 0;var aside=void 0;var main=void 0;var slice=void 0;var average=void 0;var activeSchool=void 0;var classroomSpaceScale=__WEBPACK_IMPORTED_MODULE_5_d3__["scaleLinear"]().domain([0,__WEBPACK_IMPORTED_MODULE_5_d3__["max"](data.map(function(d){return Math.sqrt(d.classroomspace)+scaleFactor;}))]).range([0,height-margin.top]);var calculateClassroomSpace=function calculateClassroomSpace(d){return classroomSpaceScale(Math.sqrt(d.classroomspace))/2;};var invertClassroomSpace=function invertClassroomSpace(d){return classroomSpaceScale.invert(d.classroomspace)*2;};function calculateAverage(){var sum=0;data.forEach(function(obj){if(obj.isActive){activeSchool=obj;}sum+=parseFloat(obj.classroomspace);});average=sum/data.length;}function initialiseElements(){elm=document.createElement('div');aside=__WEBPACK_IMPORTED_MODULE_5_d3__["select"](elm).append('div').attr('class','aside');main=__WEBPACK_IMPORTED_MODULE_5_d3__["select"](elm).append('div').attr('class','main').attr('aria-hidden','true');// For clusters with lots of schools, we need to make the viewbox bigger
var viewBoxY1=0;var viewBoxY2=height;var defaultSchools=14;// 14 schools fit by default
var outOfSightSchools=schools_data.length-defaultSchools;if(outOfSightSchools>0){var extraHeight=height/defaultSchools*outOfSightSchools;extraHeight=extraHeight+100;// just breathing room
viewBoxY1=0-extraHeight*0.5;viewBoxY2=height+extraHeight*0.5;}svg=main.append('svg').attr('id',chartName).attr('viewBox','0 '+viewBoxY1+' '+width+' '+viewBoxY2).attr('class','cluster-chart classroomspace-chart');}function setupToolTip(){var content='<div class="tooltip-content-wrapper">\n      <div class="tooltip-content">\n      <div>\n        <p class="tooltip-title"></p>\n        <p class="tooltip-number"></p>\n        <p class="a11y">Press enter to navigate to this school\'s page or tab to select another school.</p>\n      </div>\n      </div>\n    </div>';tooltip=new __WEBPACK_IMPORTED_MODULE_6__tooltip__["a" /* default */](content);main.node().appendChild(tooltip.elm);}var handleClick=function handleClick(d){if(__WEBPACK_IMPORTED_MODULE_5_d3__["event"])__WEBPACK_IMPORTED_MODULE_5_d3__["event"].stopPropagation();__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])(_defineProperty({},chartName,{selectedSchool:d,showTooltip:true})));};function drawAside(){if(activeSchool){card=aside.append('div').attr('class','card--highlight');card.append('p').attr('class','card-title').text(activeSchool.name);card.append('p').attr('class','big-number').text(Math.round(activeSchool.classroomspace*100)/100+'m\xB2');}card=aside.append('div').attr('class','card card-average');card.append('p').attr('class','card-title').text('Average classroom space for '+cluster+' schools group');card.append('p').attr('class','big-number').text(Math.round(average*100)/100+'m\xB2');// card.append('p')
//   .attr('class', 'card-title')
//   .text('per student')
}function drawChart(){var averageClassroomSpace=calculateClassroomSpace({classroomspace:average});var defs=svg.append('defs');var svgContainer=svg.append('g').attr('transform','translate('+margin.left+' '+margin.top+')').append('g').attr('transform',function(){var top=height-margin.bottom-margin.top-stack_gap*data.length-calculateClassroomSpace(data[data.length-1])/2;return'translate('+10+' '+top+')';}).append('g').attr('transform','matrix(0.866, 0.5, -0.866, 0.5, 0, 0)');// An alternative method results in a smaller isometric projection
// Can someone tell me why the translate is slightly different between the two methods?
// .append("g")
// .attr("transform", "translate(" + (stack_gap * (data.length-1)) + " " + (height - (stack_gap * (data.length-1)) ) +")")
// .attr("transform", "scale(1, 0.5)")
// .append("g")
// .attr("transform", "rotate(45)")
// Make a copy of the data and splice in the avergage for cluster view
var copy=data.map(function(d){return d;});if(!activeSchool){var j=0;copy.forEach(function(d,i){j=d.classroomspace>average?j:i;});copy.splice(j+1,0,{classroomspace:average,isAverage:true});}// Slice is in correct order use d
slice=defs.selectAll('g').data(copy).enter().append('g').attr('id',function(d,i){return'slice-classroom-'+d.uid;}).attr('data-name',function(d,i){return''+d.name;}).on('keydown',function(d,i){if(d.isAverage)return;var e=__WEBPACK_IMPORTED_MODULE_5_d3__["event"];var keys={SPACE:32,ENTER:13};if(e.type==='click'||e.keyCode===keys.SPACE||e.keyCode===keys.ENTER){__WEBPACK_IMPORTED_MODULE_5_d3__["selectAll"]('use').classed('nmbm',false);__WEBPACK_IMPORTED_MODULE_5_d3__["select"]('#use-classroom-'+d.uid).classed('nmbm',true);handleClick(d);}});slice.attr('transform',function(d,i){var sqd=calculateClassroomSpace(d);var y=i*stack_gap-sqd;var x=i*stack_gap;return'translate('+x+' '+y+')';}).attr('class',function(d){return'slice '+(d.isActive?'is-active':'');}).attr('tabindex',0);slice.append('rect').attr('class',function(d){return d.isAverage?'average':'rect';}).attr('width',calculateClassroomSpace).attr('height',calculateClassroomSpace);slice.filter(function(d){return!d.isAverage;}).append('rect').attr('class','left-side').attr('width',calculateClassroomSpace).attr('height',5).attr('transform',function(d){var sqd=calculateClassroomSpace(d);return'skewX(45) rotate(180 0 0) translate(0 '+-(sqd+5)+')';});slice.filter(function(d){return!d.isAverage;}).append('rect').attr('class','right-side').attr('height',calculateClassroomSpace).attr('width',5).attr('transform',function(d){var sqd=calculateClassroomSpace(d);return'skewY(45) rotate(0 0 '+sqd+')  translate('+sqd+' '+-sqd+')';});slice.each(function(d){if(d.isActive){__WEBPACK_IMPORTED_MODULE_5_d3__["select"](this).append('rect').attr('class','average').attr('width',function(){return averageClassroomSpace;}).attr('height',function(){return averageClassroomSpace;}).attr('pointer-events','none').attr('transform',function(d){var sqd=calculateClassroomSpace(d)-averageClassroomSpace;var y=sqd;var x=0;return'translate('+x+' '+y+')';});}});// Use is in reverse correct order use copy[copy.length - i - 1]
svgContainer.selectAll('use').data(copy).enter().append('use').attr('class',function(d,i){return copy[copy.length-i-1].isActive?'is-active':null;}).attr('id',function(d,i){return'use-classroom-'+copy[copy.length-i-1].uid;}).attr('data-name',function(d,i){return''+copy[copy.length-i-1].name;}).attr('xlink:href',function(d,i){return'#slice-classroom-'+copy[copy.length-i-1].uid;}).attr('tabindex',-1).on('mouseover',function(d,i){var node=__WEBPACK_IMPORTED_MODULE_5_d3__["select"]('#slice-classroom-'+copy[copy.length-i-1].uid).node();if(node.focus)node.focus();}).on('mouseout',function(d,i){var node=__WEBPACK_IMPORTED_MODULE_5_d3__["select"]('#slice-classroom-'+copy[copy.length-i-1].uid).node();if(node.blur)node.blur();}).on('click',function(d,i){if(copy[copy.length-i-1].isAverage)return;__WEBPACK_IMPORTED_MODULE_5_d3__["selectAll"]('use').classed('nmbm',false);__WEBPACK_IMPORTED_MODULE_5_d3__["select"](this).classed('nmbm',true);handleClick(copy[copy.length-i-1]);});}function drawKey(){var keyArea=invertClassroomSpace({classroomspace:20});var keySize=20;var key=svg.append('g');key.attr('class','key').attr('transform',function(d,i){var y=height-margin.bottom/2;var x=margin.left;return'translate('+x+' '+y+')';});var perspectiveContainer=key.append('g').attr('class','slice').attr('transform','translate('+keySize+' '+-2.5+')').append('g').attr('transform','matrix(0.866, 0.5, -0.866, 0.5, 0, 0)');perspectiveContainer.append('rect').attr('class','rect').attr('width',keySize).attr('height',keySize);perspectiveContainer.append('rect').attr('class','left-side').attr('width',keySize).attr('height',5).attr('transform',function(d){return'skewX(45) rotate(180 0 0) translate(0 '+-(keySize+5)+')';});perspectiveContainer.append('rect').attr('class','right-side').attr('height',keySize).attr('width',5).attr('transform',function(d){return'skewY(45) rotate(0 0 '+keySize+')  translate('+keySize+' '+-keySize+')';});key.append('text').text('= '+Object(__WEBPACK_IMPORTED_MODULE_7__modules_helpers__["b" /* format */])(keyArea*100,1)+'cm\xB2 classroom space').attr('transform',function(d,i){var y=17;var x=margin.left+keySize*1.75+10;return'translate('+x+' '+y+')';});}calculateAverage();initialiseElements();setupToolTip();main.append('div').style('font-size','11px').text('Data subject to change.*');drawAside();drawChart();drawKey();elm.classList.add('chart');return elm;}var AvgClassroomSpace=function(_Component){_inherits(AvgClassroomSpace,_Component);function AvgClassroomSpace(){_classCallCheck(this,AvgClassroomSpace);return _possibleConstructorReturn(this,(AvgClassroomSpace.__proto__||Object.getPrototypeOf(AvgClassroomSpace)).apply(this,arguments));}_createClass(AvgClassroomSpace,[{key:'wrapChart',value:function wrapChart(){this.container=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);while(this.container.firstChild){this.container.removeChild(this.container.firstChild);}var data=this.props.data;var chart=makeClassroomSpace(data.schools,data.name,this.props.chartName);this.container.appendChild(chart);}},{key:'componentDidMount',value:function componentDidMount(){this.wrapChart();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _props$ui=this.props.ui,selectedSchool=_props$ui.selectedSchool,showTooltip=_props$ui.showTooltip;if(showTooltip&&selectedSchool){svg.selectAll('.nmbm').classed('nmbm',false);svg.select('#use-classroom-'+selectedSchool.uid).classed('nmbm',true);tooltip.onClick(function(){if(window.parentIFrame){window.parentIFrame.sendMessage({type:'change:school',school:selectedSchool.uid});}else{window.location.search='school='+selectedSchool.uid;}});tooltip.elm.classList.add('tooltip-arrow');tooltip.elm.classList.remove('tooltip-active');if(selectedSchool.isActive){tooltip.elm.classList.remove('tooltip-arrow');tooltip.elm.classList.add('tooltip-active');}tooltip.show();tooltip.elm.querySelector('.tooltip-title').innerHTML=selectedSchool.name;tooltip.elm.querySelector('.tooltip-number').innerHTML=Object(__WEBPACK_IMPORTED_MODULE_7__modules_helpers__["b" /* format */])(selectedSchool.classroomspace)+'m\xB2';var bb=svg.select('#use-classroom-'+selectedSchool.uid).node().getBoundingClientRect();var scrollX=window.scrollX||document.documentElement.scrollLeft;var scrollY=window.scrollY||document.documentElement.scrollTop;var top=bb.top+bb.height/2+scrollY-tooltip.elm.clientHeight-20;var left=bb.left+bb.width+scrollX-tooltip.elm.clientWidth/2-10;tooltip.move(top,left);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return AvgClassroomSpace;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){return{ui:state.ui[ownProps.chartName]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectSchool:function selectSchool(p){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])(p));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AvgClassroomSpace));

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53);
module.exports = __webpack_require__(157);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(16);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null)),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(160);
var ReactElement = __webpack_require__(23);

var emptyFunction = __webpack_require__(7);
var traverseAllChildren = __webpack_require__(161);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var ReactCurrentOwner = __webpack_require__(12);
var REACT_ELEMENT_TYPE = __webpack_require__(95);

var getIteratorFn = __webpack_require__(162);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(163);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(23);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(23),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(96);

module.exports = factory(isValidElement);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(7);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var ReactPropTypesSecret = __webpack_require__(97);
var checkPropTypes = __webpack_require__(167);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(92),
    Component = _require.Component;

var _require2 = __webpack_require__(23),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(93);
var factory = __webpack_require__(170);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var emptyObject = __webpack_require__(39);
var _invariant = __webpack_require__(0);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(29);

var ReactElement = __webpack_require__(23);

var invariant = __webpack_require__(0);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(5);
var ReactDefaultInjection = __webpack_require__(173);
var ReactMount = __webpack_require__(122);
var ReactReconciler = __webpack_require__(25);
var ReactUpdates = __webpack_require__(11);
var ReactVersion = __webpack_require__(245);

var findDOMNode = __webpack_require__(246);
var getHostComponentFromComposite = __webpack_require__(123);
var renderSubtreeIntoContainer = __webpack_require__(247);
var warning = __webpack_require__(1);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(174);
var BeforeInputEventPlugin = __webpack_require__(175);
var ChangeEventPlugin = __webpack_require__(179);
var DefaultEventPluginOrder = __webpack_require__(182);
var EnterLeaveEventPlugin = __webpack_require__(183);
var HTMLDOMPropertyConfig = __webpack_require__(184);
var ReactComponentBrowserEnvironment = __webpack_require__(185);
var ReactDOMComponent = __webpack_require__(191);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactDOMEmptyComponent = __webpack_require__(216);
var ReactDOMTreeTraversal = __webpack_require__(217);
var ReactDOMTextComponent = __webpack_require__(218);
var ReactDefaultBatchingStrategy = __webpack_require__(219);
var ReactEventListener = __webpack_require__(220);
var ReactInjection = __webpack_require__(222);
var ReactReconcileTransaction = __webpack_require__(223);
var SVGDOMPropertyConfig = __webpack_require__(229);
var SelectEventPlugin = __webpack_require__(230);
var SimpleEventPlugin = __webpack_require__(231);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(30);
var ExecutionEnvironment = __webpack_require__(6);
var FallbackCompositionState = __webpack_require__(176);
var SyntheticCompositionEvent = __webpack_require__(177);
var SyntheticInputEvent = __webpack_require__(178);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(18);

var getTextContentAccessor = __webpack_require__(101);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(31);
var EventPropagators = __webpack_require__(30);
var ExecutionEnvironment = __webpack_require__(6);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);
var SyntheticEvent = __webpack_require__(14);

var inputValueTracking = __webpack_require__(104);
var getEventTarget = __webpack_require__(61);
var isEventSupported = __webpack_require__(62);
var isTextInputElement = __webpack_require__(105);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(181);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(30);
var ReactDOMComponentTree = __webpack_require__(5);
var SyntheticMouseEvent = __webpack_require__(41);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(24);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(64);
var ReactDOMIDOperations = __webpack_require__(190);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var DOMLazyTree = __webpack_require__(26);
var ExecutionEnvironment = __webpack_require__(6);

var createNodesFromMarkup = __webpack_require__(187);
var emptyFunction = __webpack_require__(7);
var invariant = __webpack_require__(0);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(6);

var createArrayFromMixed = __webpack_require__(188);
var getMarkupWrap = __webpack_require__(189);
var invariant = __webpack_require__(0);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(0);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(6);

var invariant = __webpack_require__(0);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(64);
var ReactDOMComponentTree = __webpack_require__(5);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var AutoFocusUtils = __webpack_require__(192);
var CSSPropertyOperations = __webpack_require__(193);
var DOMLazyTree = __webpack_require__(26);
var DOMNamespaces = __webpack_require__(65);
var DOMProperty = __webpack_require__(24);
var DOMPropertyOperations = __webpack_require__(110);
var EventPluginHub = __webpack_require__(31);
var EventPluginRegistry = __webpack_require__(58);
var ReactBrowserEventEmitter = __webpack_require__(44);
var ReactDOMComponentFlags = __webpack_require__(98);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactDOMInput = __webpack_require__(203);
var ReactDOMOption = __webpack_require__(205);
var ReactDOMSelect = __webpack_require__(111);
var ReactDOMTextarea = __webpack_require__(206);
var ReactInstrumentation = __webpack_require__(8);
var ReactMultiChild = __webpack_require__(207);
var ReactServerRenderingTransaction = __webpack_require__(214);

var emptyFunction = __webpack_require__(7);
var escapeTextContentForBrowser = __webpack_require__(43);
var invariant = __webpack_require__(0);
var isEventSupported = __webpack_require__(62);
var shallowEqual = __webpack_require__(69);
var inputValueTracking = __webpack_require__(104);
var validateDOMNesting = __webpack_require__(73);
var warning = __webpack_require__(1);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(5);

var focusNode = __webpack_require__(108);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(109);
var ExecutionEnvironment = __webpack_require__(6);
var ReactInstrumentation = __webpack_require__(8);

var camelizeStyleName = __webpack_require__(194);
var dangerousStyleValue = __webpack_require__(196);
var hyphenateStyleName = __webpack_require__(197);
var memoizeStringOnly = __webpack_require__(199);
var warning = __webpack_require__(1);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(195);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(109);
var warning = __webpack_require__(1);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(198);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(43);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(31);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var DOMPropertyOperations = __webpack_require__(110);
var LinkedValueUtils = __webpack_require__(67);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var React = __webpack_require__(22);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactDOMSelect = __webpack_require__(111);

var warning = __webpack_require__(1);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(67);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactComponentEnvironment = __webpack_require__(68);
var ReactInstanceMap = __webpack_require__(33);
var ReactInstrumentation = __webpack_require__(8);

var ReactCurrentOwner = __webpack_require__(12);
var ReactReconciler = __webpack_require__(25);
var ReactChildReconciler = __webpack_require__(208);

var emptyFunction = __webpack_require__(7);
var flattenChildren = __webpack_require__(213);
var invariant = __webpack_require__(0);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(25);

var instantiateReactComponent = __webpack_require__(113);
var KeyEscapeUtils = __webpack_require__(71);
var shouldUpdateReactComponent = __webpack_require__(70);
var traverseAllChildren = __webpack_require__(117);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","URL":"https://static-doe-cpw.visualise.today/"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(118);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var React = __webpack_require__(22);
var ReactComponentEnvironment = __webpack_require__(68);
var ReactCurrentOwner = __webpack_require__(12);
var ReactErrorUtils = __webpack_require__(60);
var ReactInstanceMap = __webpack_require__(33);
var ReactInstrumentation = __webpack_require__(8);
var ReactNodeTypes = __webpack_require__(114);
var ReactReconciler = __webpack_require__(25);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(39);
var invariant = __webpack_require__(0);
var shallowEqual = __webpack_require__(69);
var shouldUpdateReactComponent = __webpack_require__(70);
var warning = __webpack_require__(1);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(71);
var traverseAllChildren = __webpack_require__(117);
var warning = __webpack_require__(1);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","URL":"https://static-doe-cpw.visualise.today/"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(118);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)))

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(18);
var Transaction = __webpack_require__(40);
var ReactInstrumentation = __webpack_require__(8);
var ReactServerUpdateQueue = __webpack_require__(215);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(72);

var warning = __webpack_require__(1);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var DOMLazyTree = __webpack_require__(26);
var ReactDOMComponentTree = __webpack_require__(5);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var invariant = __webpack_require__(0);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2),
    _assign = __webpack_require__(3);

var DOMChildrenOperations = __webpack_require__(64);
var DOMLazyTree = __webpack_require__(26);
var ReactDOMComponentTree = __webpack_require__(5);

var escapeTextContentForBrowser = __webpack_require__(43);
var invariant = __webpack_require__(0);
var validateDOMNesting = __webpack_require__(73);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var ReactUpdates = __webpack_require__(11);
var Transaction = __webpack_require__(40);

var emptyFunction = __webpack_require__(7);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var EventListener = __webpack_require__(119);
var ExecutionEnvironment = __webpack_require__(6);
var PooledClass = __webpack_require__(18);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactUpdates = __webpack_require__(11);

var getEventTarget = __webpack_require__(61);
var getUnboundedScrollPosition = __webpack_require__(221);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(24);
var EventPluginHub = __webpack_require__(31);
var EventPluginUtils = __webpack_require__(59);
var ReactComponentEnvironment = __webpack_require__(68);
var ReactEmptyComponent = __webpack_require__(115);
var ReactBrowserEventEmitter = __webpack_require__(44);
var ReactHostComponent = __webpack_require__(116);
var ReactUpdates = __webpack_require__(11);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(102);
var PooledClass = __webpack_require__(18);
var ReactBrowserEventEmitter = __webpack_require__(44);
var ReactInputSelection = __webpack_require__(120);
var ReactInstrumentation = __webpack_require__(8);
var Transaction = __webpack_require__(40);
var ReactUpdateQueue = __webpack_require__(72);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);

var getNodeForCharacterOffset = __webpack_require__(225);
var getTextContentAccessor = __webpack_require__(101);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(227);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(228);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(30);
var ExecutionEnvironment = __webpack_require__(6);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactInputSelection = __webpack_require__(120);
var SyntheticEvent = __webpack_require__(14);

var getActiveElement = __webpack_require__(121);
var isTextInputElement = __webpack_require__(105);
var shallowEqual = __webpack_require__(69);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(2);

var EventListener = __webpack_require__(119);
var EventPropagators = __webpack_require__(30);
var ReactDOMComponentTree = __webpack_require__(5);
var SyntheticAnimationEvent = __webpack_require__(232);
var SyntheticClipboardEvent = __webpack_require__(233);
var SyntheticEvent = __webpack_require__(14);
var SyntheticFocusEvent = __webpack_require__(234);
var SyntheticKeyboardEvent = __webpack_require__(235);
var SyntheticMouseEvent = __webpack_require__(41);
var SyntheticDragEvent = __webpack_require__(237);
var SyntheticTouchEvent = __webpack_require__(238);
var SyntheticTransitionEvent = __webpack_require__(239);
var SyntheticUIEvent = __webpack_require__(32);
var SyntheticWheelEvent = __webpack_require__(240);

var emptyFunction = __webpack_require__(7);
var getEventCharCode = __webpack_require__(74);
var invariant = __webpack_require__(0);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(32);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(32);

var getEventCharCode = __webpack_require__(74);
var getEventKey = __webpack_require__(236);
var getEventModifierState = __webpack_require__(63);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(74);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(41);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(32);

var getEventModifierState = __webpack_require__(63);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(41);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(73);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(244);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(2);

var ReactCurrentOwner = __webpack_require__(12);
var ReactDOMComponentTree = __webpack_require__(5);
var ReactInstanceMap = __webpack_require__(33);

var getHostComponentFromComposite = __webpack_require__(123);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(122);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_index_scss__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_get_data__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iframe_resizer__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iframe_resizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_iframe_resizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_map__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_cluster_projections__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_students__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_classrooms__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AvgSpaceComparison__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_playspace__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_classroom_space__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_all_schools__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_throttle__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__modules_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_filter_data__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_prev_next__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_singleClusterProjectionsLineGraph_clusterAggregate__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getProjectionSchools(){var data=__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].schools.map(function(d){return d;}).filter(function(d){return Array.isArray(d.projections_percentage);});// Add the cluster aggregate as "another school"
var cluster=Object(__WEBPACK_IMPORTED_MODULE_18__components_singleClusterProjectionsLineGraph_clusterAggregate__["a" /* default */])(data,__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */]);data.push(cluster);return data;}var components=[{name:'cluster-map',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_map__["a" /* default */],{data:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */]}),className:'cluster-map-section'},{name:'projection',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_cluster_projections__["a" /* default */],{data:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */],school:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["b" /* activeSchool */],isMetro:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["c" /* metroClusters */].indexOf(__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].uid)!==-1,chartName:'projection'}),title:'Projected change in enrolments',sub:'last updated: June 2017',controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_prev_next__["a" /* default */],{chart:'projection',schools:getProjectionSchools()})},{name:'skip',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#summary-table'},'Skip to summary of '+__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].name+' statistics.'),className:'a11y'},{name:'student-enrolment',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_students__["a" /* default */],{chartName:'student-enrolment',data:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */]}),title:'Number of enrolments',hr:true,controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_prev_next__["a" /* default */],{chart:'student-enrolment',schools:__WEBPACK_IMPORTED_MODULE_16__modules_filter_data__["a" /* default */].studentEnrolment(__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].schools)})},{name:'classrooms',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_classrooms__["a" /* default */],{chartName:'classrooms',data:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */]}),title:'Classrooms',hr:true,controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_prev_next__["a" /* default */],{chart:'classrooms',schools:__WEBPACK_IMPORTED_MODULE_16__modules_filter_data__["a" /* default */].studentClassrooms(__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].schools)})},{name:'playspace',title:'Play space per student',hr:true,component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_playspace__["a" /* default */],{chartName:'playspace',data:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */]}),controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_prev_next__["a" /* default */],{chart:'playspace',schools:__WEBPACK_IMPORTED_MODULE_16__modules_filter_data__["a" /* default */].playspace(__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].schools)})},{name:'classroom-space',title:'Classroom space per student',hr:true,component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_classroom_space__["a" /* default */],{chartName:'classroom-space',data:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */]}),controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_prev_next__["a" /* default */],{chart:'classroom-space',schools:__WEBPACK_IMPORTED_MODULE_16__modules_filter_data__["a" /* default */].classSpace(__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].schools)})},{name:'playspace-comparison',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_AvgSpaceComparison__["a" /* default */],{data:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */],chartName:'playspace-comparison'}),controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_prev_next__["a" /* default */],{chart:'playspace-comparison',schools:__WEBPACK_IMPORTED_MODULE_16__modules_filter_data__["a" /* default */].playspace(__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].schools)})},{name:'schools-table',component:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_all_schools__["a" /* default */],{data:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */],school:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["b" /* activeSchool */]}),title:'Summary of '+__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].name+' schools group',className:'bg-dark'}];var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.state={selectedSchool:__WEBPACK_IMPORTED_MODULE_4__modules_get_data__["a" /* activeCluster */].schools[0].uid};_this.handleWindowResize=__WEBPACK_IMPORTED_MODULE_15__modules_throttle___default()(_this.handleWindowResize.bind(_this),500);return _this;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.handleWindowResize);// Make sure that the arrows on the enrolment graph are in the right position.
// First load has them in the wrong position
window.onload=function(_){window.dispatchEvent(new Event('resize'));};}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.handleWindowResize);}},{key:'handleWindowResize',value:function handleWindowResize(){this.props.setWindowSize();}},{key:'makeSection',value:function makeSection(chart){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{key:'section-'+chart.name,className:'section '+(chart.className||'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},chart.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'mbm'},chart.title),chart.sub&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'section-sup'},chart.sub),chart.hr&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),chart.component,chart.controls));}},{key:'renderCharts',value:function renderCharts(charts){var _this2=this;return charts.map(function(chartName){var chart=components.find(function(d){return d.name===chartName;});if(!chart&&chartName!=='playspace-responsive'){console.error(chartName,' is not a valid chart');return null;}if(chartName==='playspace-responsive'){var _charts=_this2.props.isMobile?['playspace','classroom-space']:['playspace-comparison'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_charts.map(function(chartName){var chart=components.find(function(d){return d.name===chartName;});return _this2.makeSection(chart);}));}return _this2.makeSection(chart);});}},{key:'render',value:function render(){var defaultCharts=this.props.isMobile?['cluster-map','projection','skip','student-enrolment','classrooms','playspace','classroom-space','schools-table']:['cluster-map','projection','skip','student-enrolment','classrooms','playspace-comparison','schools-table'];var charts=__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["a" /* Q */].charts?__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["a" /* Q */].charts.split(','):defaultCharts;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-wrapper'},this.renderCharts(charts));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isMobile:state.ui.isMobile};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setWindowSize:function setWindowSize(p){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* setWindowSize */])(p));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App));

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(75);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(7);
var invariant = __webpack_require__(0);
var ReactPropTypesSecret = __webpack_require__(97);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(273);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(130);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(261);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(259);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(127);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(263);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(266);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(267);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21), __webpack_require__(78)(module)))

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(128);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(129);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(130);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(131);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(274);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(75);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export activeSchoolID */
/* unused harmony export activeClusterID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activeCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activeSchool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_data_json__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_metroClusters_json__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_metroClusters_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_metroClusters_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(9);
/* unused harmony reexport data */
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__data_metroClusters_json___default.a; });
var activeSchoolID=__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Q */].school;var activeClusterID=__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* Q */].cluster;var activeCluster=void 0;var activeSchool=void 0;__WEBPACK_IMPORTED_MODULE_0__data_data_json___default.a.clusters.sort(function(a,b){if(a.name>b.name){return 1;}if(a.name<b.name){return-1;}return 0;});if(activeClusterID){activeCluster=Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* getCluster */])(activeClusterID,__WEBPACK_IMPORTED_MODULE_0__data_data_json___default.a);if(!activeCluster){console.error('No cluster data for cluster code '+activeClusterID);}}else if(activeSchoolID){activeCluster=Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["d" /* getClusterBySchool */])(activeSchoolID,__WEBPACK_IMPORTED_MODULE_0__data_data_json___default.a);if(!activeCluster){console.error('No cluster data for school code '+activeSchoolID);}}if(!activeCluster){activeCluster=Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* getCluster */])(__WEBPACK_IMPORTED_MODULE_0__data_data_json___default.a.clusters[0].uid,__WEBPACK_IMPORTED_MODULE_0__data_data_json___default.a);}activeCluster.isActive=true;activeCluster.schools.sort(function(a,b){return a.name>b.name;});activeCluster.schools.forEach(function(obj){if(parseInt(obj.uid,10)===parseInt(activeSchoolID,10)){obj.isActive=true;activeSchool=obj;}});

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = {
	"clusters": [
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 100
			},
			"enrolment": 2438,
			"level": "Primary",
			"ligo": 0.81,
			"name": "Bathurst City Primary",
			"playspace": 107.57,
			"projections": [
				2438,
				2685,
				2830,
				2845,
				2930
			],
			"projections_percentage": [
				0,
				10.13,
				16.08,
				16.69,
				20.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 18
					},
					"classroomspace": 2.99,
					"enrolment": 564,
					"ligo": 0.63,
					"location": [
						149.569957036472,
						-33.4217450011272
					],
					"name": "Bathurst Public School",
					"playspace": 49.49,
					"projections": [
						464,
						564,
						620,
						650,
						640,
						660
					],
					"projections_orig": [
						"464",
						"564",
						"620",
						"650",
						"640",
						"660"
					],
					"projections_percentage": [
						-17.73,
						0,
						9.93,
						15.25,
						13.48,
						17.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1150
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.7,
					"enrolment": 487,
					"ligo": 0.77,
					"location": [
						149.540380876478,
						-33.3775730412862
					],
					"name": "Eglinton Public School",
					"playspace": 35.66,
					"projections": [
						477,
						487,
						575,
						605,
						595,
						615
					],
					"projections_orig": [
						"477",
						"487",
						"575",
						"605",
						"595",
						"615"
					],
					"projections_percentage": [
						-2.05,
						0,
						18.07,
						24.23,
						22.18,
						26.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1823
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.39,
					"enrolment": 274,
					"ligo": 0.87,
					"location": [
						149.604090656805,
						-33.4167325274107
					],
					"name": "Kelso Public School",
					"playspace": 95.3,
					"projections": [
						275,
						274,
						305,
						320,
						335,
						345
					],
					"projections_orig": [
						"275",
						"274",
						"305",
						"320",
						"335",
						"345"
					],
					"projections_percentage": [
						0.36,
						0,
						11.31,
						16.79,
						22.26,
						25.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2275
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 4
					},
					"classroomspace": 2.94,
					"enrolment": 131,
					"ligo": 1,
					"location": [
						149.549243697678,
						-33.4912630702383
					],
					"name": "Perthville Public School",
					"playspace": 78.23,
					"projections": [
						116,
						131,
						130,
						135,
						140,
						145
					],
					"projections_orig": [
						"116",
						"131",
						"130",
						"135",
						"140",
						"145"
					],
					"projections_percentage": [
						-11.45,
						0,
						-0.76,
						3.05,
						6.87,
						10.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2862
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.62,
					"enrolment": 271,
					"ligo": 0.78,
					"location": [
						149.647003118759,
						-33.4279781924847
					],
					"name": "Raglan Public School",
					"playspace": 127.81,
					"projections": [
						237,
						271,
						295,
						310,
						320,
						330
					],
					"projections_orig": [
						"237",
						"271",
						"295",
						"310",
						"320",
						"330"
					],
					"projections_percentage": [
						-12.55,
						0,
						8.86,
						14.39,
						18.08,
						21.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2927
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.49,
					"enrolment": 20,
					"ligo": 1,
					"location": [
						149.562762120857,
						-33.6920076364636
					],
					"name": "Rockley Public School",
					"playspace": 326.63,
					"projections": [
						7,
						20,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"20",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-65,
						0,
						25,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2974
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.75,
					"enrolment": 436,
					"ligo": 0.76,
					"location": [
						149.558773614588,
						-33.4118485332193
					],
					"name": "Bathurst West Public School",
					"playspace": 59.04,
					"projections": [
						402,
						436,
						475,
						510,
						505,
						520
					],
					"projections_orig": [
						"402",
						"436",
						"475",
						"510",
						"505",
						"520"
					],
					"projections_percentage": [
						-7.8,
						0,
						8.94,
						16.97,
						15.83,
						19.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3824
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 2.77,
					"enrolment": 255,
					"ligo": 0.7,
					"location": [
						149.569679563804,
						-33.4335915035141
					],
					"name": "Bathurst South Public School",
					"playspace": 88.37,
					"projections": [
						222,
						255,
						265,
						280,
						290,
						295
					],
					"projections_orig": [
						"222",
						"255",
						"265",
						"280",
						"290",
						"295"
					],
					"projections_percentage": [
						-12.94,
						0,
						3.92,
						9.8,
						13.73,
						15.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3847
				}
			],
			"uid": 10001
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 155
			},
			"enrolment": 3089,
			"level": "Primary",
			"ligo": 0.66,
			"name": "North Wollongong",
			"playspace": 94.84,
			"projections": [
				3089,
				3160,
				3320,
				3405,
				3435
			],
			"projections_percentage": [
				0,
				2.3,
				7.48,
				10.23,
				11.2
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.62,
					"enrolment": 346,
					"ligo": 0.62,
					"location": [
						150.872555034596,
						-34.387173075239
					],
					"name": "Balgownie Public School",
					"playspace": 33.37,
					"projections": [
						300,
						346,
						355,
						370,
						380,
						385
					],
					"projections_orig": [
						"300",
						"346",
						"355",
						"370",
						"380",
						"385"
					],
					"projections_percentage": [
						-13.29,
						0,
						2.6,
						6.94,
						9.83,
						11.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1106
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.17,
					"enrolment": 194,
					"ligo": 0.78,
					"location": [
						150.899537222568,
						-34.3680570137568
					],
					"name": "Corrimal Public School",
					"playspace": 51.87,
					"projections": [
						159,
						194,
						180,
						190,
						195,
						195
					],
					"projections_orig": [
						"159",
						"194",
						"180",
						"190",
						"195",
						"195"
					],
					"projections_percentage": [
						-18.04,
						0,
						-7.22,
						-2.06,
						0.52,
						0.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1661
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.14,
					"enrolment": 375,
					"ligo": 0.5,
					"location": [
						150.892082396198,
						-34.3908959163072
					],
					"name": "Fairy Meadow Public School",
					"playspace": 55.13,
					"projections": [
						423,
						375,
						390,
						410,
						420,
						425
					],
					"projections_orig": [
						"423",
						"375",
						"390",
						"410",
						"420",
						"425"
					],
					"projections_percentage": [
						12.8,
						0,
						4,
						9.33,
						12,
						13.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1898
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 18
					},
					"classroomspace": 1.96,
					"enrolment": 547,
					"ligo": 0.85,
					"location": [
						150.906020904158,
						-34.3456750994195
					],
					"name": "Woonona Public School",
					"playspace": 38.07,
					"projections": [
						394,
						547,
						530,
						555,
						565,
						570
					],
					"projections_orig": [
						"394",
						"547",
						"530",
						"555",
						"565",
						"570"
					],
					"projections_percentage": [
						-27.97,
						0,
						-3.11,
						1.46,
						3.29,
						4.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3510
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 5.02,
					"enrolment": 123,
					"ligo": 0.58,
					"location": [
						150.890141249507,
						-34.3800091768286
					],
					"name": "Tarrawanna Public School",
					"playspace": 324.79,
					"projections": [
						131,
						123,
						130,
						140,
						140,
						145
					],
					"projections_orig": [
						"131",
						"123",
						"130",
						"140",
						"140",
						"145"
					],
					"projections_percentage": [
						6.5,
						0,
						5.69,
						13.82,
						13.82,
						17.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3820
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.63,
					"enrolment": 173,
					"ligo": 0.62,
					"location": [
						150.902082397861,
						-34.3897864671792
					],
					"name": "Towradgi Public School",
					"playspace": 119.14,
					"projections": [
						148,
						173,
						175,
						185,
						190,
						190
					],
					"projections_orig": [
						"148",
						"173",
						"175",
						"185",
						"190",
						"190"
					],
					"projections_percentage": [
						-14.45,
						0,
						1.16,
						6.94,
						9.83,
						9.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3866
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.76,
					"enrolment": 223,
					"ligo": 0.52,
					"location": [
						150.905091397685,
						-34.3778919479532
					],
					"name": "Corrimal East Public School",
					"playspace": 150.41,
					"projections": [
						267,
						223,
						235,
						245,
						255,
						255
					],
					"projections_orig": [
						"267",
						"223",
						"235",
						"245",
						"255",
						"255"
					],
					"projections_percentage": [
						19.73,
						0,
						5.38,
						9.87,
						14.35,
						14.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3877
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.27,
					"enrolment": 256,
					"ligo": 0.8,
					"location": [
						150.90652345035,
						-34.3590166835345
					],
					"name": "Russell Vale Public School",
					"playspace": 48.97,
					"projections": [
						248,
						256,
						265,
						280,
						285,
						290
					],
					"projections_orig": [
						"248",
						"256",
						"265",
						"280",
						"285",
						"290"
					],
					"projections_percentage": [
						-3.12,
						0,
						3.52,
						9.38,
						11.33,
						13.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3973
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 8.64,
					"enrolment": 161,
					"ligo": 0.86,
					"location": [
						150.913095691602,
						-34.3711959160968
					],
					"name": "Bellambi Public School",
					"playspace": 159.78,
					"projections": [
						169,
						161,
						185,
						195,
						200,
						205
					],
					"projections_orig": [
						"169",
						"161",
						"185",
						"195",
						"200",
						"205"
					],
					"projections_percentage": [
						4.97,
						0,
						14.91,
						21.12,
						24.22,
						27.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3979
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.73,
					"enrolment": 223,
					"ligo": 0.55,
					"location": [
						150.889461075648,
						-34.399042115404
					],
					"name": "Mount Ousley Public School",
					"playspace": 40.72,
					"projections": [
						165,
						223,
						215,
						225,
						235,
						235
					],
					"projections_orig": [
						"165",
						"223",
						"215",
						"225",
						"235",
						"235"
					],
					"projections_percentage": [
						-26.01,
						0,
						-3.59,
						0.9,
						5.38,
						5.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4095
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 9
					},
					"classroomspace": 2.93,
					"enrolment": 216,
					"ligo": 0.64,
					"location": [
						150.914642239957,
						-34.3520526946849
					],
					"name": "Woonona East Public School",
					"playspace": 102.25,
					"projections": [
						273,
						216,
						255,
						265,
						275,
						275
					],
					"projections_orig": [
						"273",
						"216",
						"255",
						"265",
						"275",
						"275"
					],
					"projections_percentage": [
						26.39,
						0,
						18.06,
						22.69,
						27.31,
						27.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4296
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 7
					},
					"classroomspace": 2.98,
					"enrolment": 252,
					"ligo": 0.62,
					"location": [
						150.872493825157,
						-34.3960730091053
					],
					"name": "Pleasant Heights Public School",
					"playspace": 13.53,
					"projections": [
						188,
						252,
						245,
						260,
						265,
						265
					],
					"projections_orig": [
						"188",
						"252",
						"245",
						"260",
						"265",
						"265"
					],
					"projections_percentage": [
						-25.4,
						0,
						-2.78,
						3.17,
						5.16,
						5.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4357
				}
			],
			"uid": 10003
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 71
			},
			"enrolment": 1995,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Shellharbour",
			"playspace": 65.22,
			"projections": [
				1995,
				2060,
				2090,
				2090,
				2090
			],
			"projections_percentage": [
				0,
				3.26,
				4.76,
				4.76,
				4.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.41,
					"enrolment": 478,
					"ligo": 0.41,
					"location": [
						150.865093268961,
						-34.5781386336009
					],
					"name": "Shellharbour Public School",
					"playspace": 37.17,
					"projections": [
						461,
						478,
						515,
						525,
						525,
						525
					],
					"projections_orig": [
						"461",
						"478",
						"515",
						"525",
						"525",
						"525"
					],
					"projections_percentage": [
						-3.56,
						0,
						7.74,
						9.83,
						9.83,
						9.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3060
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.57,
					"enrolment": 553,
					"ligo": 0.73,
					"location": [
						150.848167528148,
						-34.5819365533343
					],
					"name": "Flinders Public School",
					"playspace": 139.06,
					"projections": [
						532,
						553,
						560,
						565,
						565,
						565
					],
					"projections_orig": [
						"532",
						"553",
						"560",
						"565",
						"565",
						"565"
					],
					"projections_percentage": [
						-3.8,
						0,
						1.27,
						2.17,
						2.17,
						2.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4463
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.81,
					"enrolment": 402,
					"ligo": 0.87,
					"location": [
						150.85168512495,
						-34.6244038578664
					],
					"name": "Minnamurra Public School",
					"playspace": 48.55,
					"projections": [
						437,
						402,
						440,
						445,
						445,
						445
					],
					"projections_orig": [
						"437",
						"402",
						"440",
						"445",
						"445",
						"445"
					],
					"projections_percentage": [
						8.71,
						0,
						9.45,
						10.7,
						10.7,
						10.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4498
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 14
					},
					"classroomspace": 2.73,
					"enrolment": 562,
					"ligo": 0.82,
					"location": [
						150.854167461507,
						-34.5956218502914
					],
					"name": "Shell Cove Public School",
					"playspace": 36.11,
					"projections": [
						496,
						562,
						545,
						555,
						555,
						555
					],
					"projections_orig": [
						"496",
						"562",
						"545",
						"555",
						"555",
						"555"
					],
					"projections_percentage": [
						-11.74,
						0,
						-3.02,
						-1.25,
						-1.25,
						-1.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4641
				}
			],
			"uid": 10004
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 111
			},
			"enrolment": 1616,
			"level": "Primary",
			"ligo": 0.62,
			"name": "South Wollongong",
			"playspace": 90.56,
			"projections": [
				1616,
				1645,
				1715,
				1765,
				1775
			],
			"projections_percentage": [
				0,
				1.79,
				6.13,
				9.22,
				9.84
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.89,
					"enrolment": 336,
					"ligo": 0.67,
					"location": [
						150.855153611246,
						-34.4800694274536
					],
					"name": "Berkeley Public School",
					"playspace": 64.13,
					"projections": [
						286,
						336,
						335,
						350,
						360,
						365
					],
					"projections_orig": [
						"286",
						"336",
						"335",
						"350",
						"360",
						"365"
					],
					"projections_percentage": [
						-14.88,
						0,
						-0.3,
						4.17,
						7.14,
						8.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1202
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 2.43,
					"enrolment": 273,
					"ligo": 0.58,
					"location": [
						150.914985829546,
						-34.4856816457399
					],
					"name": "Port Kembla Public School",
					"playspace": 65.32,
					"projections": [
						214,
						273,
						275,
						290,
						300,
						300
					],
					"projections_orig": [
						"214",
						"273",
						"275",
						"290",
						"300",
						"300"
					],
					"projections_percentage": [
						-21.61,
						0,
						0.73,
						6.23,
						9.89,
						9.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2896
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.99,
					"enrolment": 112,
					"ligo": 0.65,
					"location": [
						150.881577395598,
						-34.5016108694209
					],
					"name": "Primbee Public School",
					"playspace": 86.55,
					"projections": [
						81,
						112,
						105,
						110,
						115,
						115
					],
					"projections_orig": [
						"81",
						"112",
						"105",
						"110",
						"115",
						"115"
					],
					"projections_percentage": [
						-27.68,
						0,
						-6.25,
						-1.79,
						2.68,
						2.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2904
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 6.04,
					"enrolment": 286,
					"ligo": 0.61,
					"location": [
						150.877907197116,
						-34.4810706587907
					],
					"name": "Warrawong Public School",
					"playspace": 111.35,
					"projections": [
						284,
						286,
						300,
						315,
						320,
						325
					],
					"projections_orig": [
						"284",
						"286",
						"300",
						"315",
						"320",
						"325"
					],
					"projections_percentage": [
						-0.7,
						0,
						4.9,
						10.14,
						11.89,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3104
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.58,
					"enrolment": 149,
					"ligo": 0.6,
					"location": [
						150.86773121972,
						-34.4891150242797
					],
					"name": "Lake Heights Public School",
					"playspace": 46.99,
					"projections": [
						147,
						149,
						155,
						160,
						165,
						165
					],
					"projections_orig": [
						"147",
						"149",
						"155",
						"160",
						"165",
						"165"
					],
					"projections_percentage": [
						-1.34,
						0,
						4.03,
						7.38,
						10.74,
						10.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4011
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 8.02,
					"enrolment": 153,
					"ligo": 0.64,
					"location": [
						150.869952043968,
						-34.4714558508906
					],
					"name": "Cringila Public School",
					"playspace": 118.29,
					"projections": [
						150,
						153,
						170,
						175,
						180,
						180
					],
					"projections_orig": [
						"150",
						"153",
						"170",
						"175",
						"180",
						"180"
					],
					"projections_percentage": [
						-1.96,
						0,
						11.11,
						14.38,
						17.65,
						17.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4037
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 4.71,
					"enrolment": 111,
					"ligo": 0.37,
					"location": [
						150.893426541994,
						-34.4887428213478
					],
					"name": "Kemblawarra Public School",
					"playspace": 186.55,
					"projections": [
						108,
						111,
						100,
						100,
						105,
						105
					],
					"projections_orig": [
						"108",
						"111",
						"100",
						"100",
						"105",
						"105"
					],
					"projections_percentage": [
						-2.7,
						0,
						-9.91,
						-9.91,
						-5.41,
						-5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4083
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.93,
					"enrolment": 196,
					"ligo": 0.87,
					"location": [
						150.840164077477,
						-34.4755664804454
					],
					"name": "Berkeley West Public School",
					"playspace": 45.27,
					"projections": [
						187,
						196,
						205,
						215,
						220,
						220
					],
					"projections_orig": [
						"187",
						"196",
						"205",
						"215",
						"220",
						"220"
					],
					"projections_percentage": [
						-4.59,
						0,
						4.59,
						9.69,
						12.24,
						12.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4180
				}
			],
			"uid": 10005
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 102
			},
			"enrolment": 2187,
			"level": "Primary",
			"ligo": 0.73,
			"name": "Westlake Primary",
			"playspace": 69.96,
			"projections": [
				2187,
				2355,
				2415,
				2460,
				2515
			],
			"projections_percentage": [
				0,
				7.68,
				10.43,
				12.48,
				15
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 18
					},
					"classroomspace": 2.82,
					"enrolment": 709,
					"ligo": 0.86,
					"location": [
						150.77753446986,
						-34.4953338293473
					],
					"name": "Dapto Public School",
					"playspace": 26.16,
					"projections": [
						622,
						709,
						705,
						735,
						770,
						800
					],
					"projections_orig": [
						"622",
						"709",
						"705",
						"735",
						"770",
						"800"
					],
					"projections_percentage": [
						-12.27,
						0,
						-0.56,
						3.67,
						8.6,
						12.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1727
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.37,
					"enrolment": 318,
					"ligo": 0.55,
					"location": [
						150.795075970518,
						-34.5058279358415
					],
					"name": "Lakelands Public School",
					"playspace": 79.14,
					"projections": [
						294,
						318,
						345,
						350,
						350,
						355
					],
					"projections_orig": [
						"294",
						"318",
						"345",
						"350",
						"350",
						"355"
					],
					"projections_percentage": [
						-7.55,
						0,
						8.49,
						10.06,
						10.06,
						11.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4266
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.67,
					"enrolment": 538,
					"ligo": 0.66,
					"location": [
						150.815686364942,
						-34.4924233225085
					],
					"name": "Hayes Park Public School",
					"playspace": 44.43,
					"projections": [
						521,
						538,
						605,
						620,
						625,
						635
					],
					"projections_orig": [
						"521",
						"538",
						"605",
						"620",
						"625",
						"635"
					],
					"projections_percentage": [
						-3.16,
						0,
						12.45,
						15.24,
						16.17,
						18.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4399
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 7.13,
					"enrolment": 232,
					"ligo": 0.86,
					"location": [
						150.807806161489,
						-34.502089069897
					],
					"name": "Koonawarra Public School",
					"playspace": 127.37,
					"projections": [
						313,
						232,
						285,
						290,
						290,
						295
					],
					"projections_orig": [
						"313",
						"232",
						"285",
						"290",
						"290",
						"295"
					],
					"projections_percentage": [
						34.91,
						0,
						22.84,
						25,
						25,
						27.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4409
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.5,
					"enrolment": 390,
					"ligo": 0.73,
					"location": [
						150.785793204803,
						-34.5160487005655
					],
					"name": "Mount Brown Public School",
					"playspace": 72.7,
					"projections": [
						354,
						390,
						415,
						420,
						425,
						430
					],
					"projections_orig": [
						"354",
						"390",
						"415",
						"420",
						"425",
						"430"
					],
					"projections_percentage": [
						-9.23,
						0,
						6.41,
						7.69,
						8.97,
						10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4423
				}
			],
			"uid": 10006
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 125
			},
			"enrolment": 3138,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Wollongong Cbd Primary",
			"playspace": 53.99,
			"projections": [
				3138,
				3260,
				3410,
				3495,
				3515
			],
			"projections_percentage": [
				0,
				3.89,
				8.67,
				11.38,
				12.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 4.66,
					"enrolment": 188,
					"ligo": 0.81,
					"location": [
						150.886688863028,
						-34.4386544208947
					],
					"name": "Coniston Public School",
					"playspace": 66.66,
					"projections": [
						235,
						188,
						230,
						240,
						245,
						245
					],
					"projections_orig": [
						"235",
						"188",
						"230",
						"240",
						"245",
						"245"
					],
					"projections_percentage": [
						25,
						0,
						22.34,
						27.66,
						30.32,
						30.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1612
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 10
					},
					"classroomspace": 2.5,
					"enrolment": 341,
					"ligo": 0.69,
					"location": [
						150.872867529441,
						-34.4145916209238
					],
					"name": "Keiraville Public School",
					"playspace": 34.56,
					"projections": [
						259,
						341,
						325,
						340,
						350,
						350
					],
					"projections_orig": [
						"259",
						"341",
						"325",
						"340",
						"350",
						"350"
					],
					"projections_percentage": [
						-24.05,
						0,
						-4.69,
						-0.29,
						2.64,
						2.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2271
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.32,
					"enrolment": 87,
					"ligo": 0.63,
					"location": [
						150.855926808222,
						-34.4112215867063
					],
					"name": "Mount Keira Public School",
					"playspace": 45.36,
					"projections": [
						76,
						87,
						95,
						100,
						100,
						105
					],
					"projections_orig": [
						"76",
						"87",
						"95",
						"100",
						"100",
						"105"
					],
					"projections_percentage": [
						-12.64,
						0,
						9.2,
						14.94,
						14.94,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2642
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.6,
					"enrolment": 242,
					"ligo": 0.73,
					"location": [
						150.870494013188,
						-34.4238197765219
					],
					"name": "Wollongong West Public School",
					"playspace": 74.43,
					"projections": [
						213,
						242,
						245,
						260,
						265,
						265
					],
					"projections_orig": [
						"213",
						"242",
						"245",
						"260",
						"265",
						"265"
					],
					"projections_percentage": [
						-11.98,
						0,
						1.24,
						7.44,
						9.5,
						9.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3477
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 7
					},
					"classroomspace": 2.66,
					"enrolment": 237,
					"ligo": 0.63,
					"location": [
						150.879784322533,
						-34.418264398008
					],
					"name": "Gwynneville Public School",
					"playspace": 101.46,
					"projections": [
						193,
						237,
						250,
						265,
						270,
						270
					],
					"projections_orig": [
						"193",
						"237",
						"250",
						"265",
						"270",
						"270"
					],
					"projections_percentage": [
						-18.57,
						0,
						5.49,
						11.81,
						13.92,
						13.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3826
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.18,
					"enrolment": 329,
					"ligo": 0.72,
					"location": [
						150.870662755164,
						-34.4370363937347
					],
					"name": "Mount St Thomas Public School",
					"playspace": 30.25,
					"projections": [
						312,
						329,
						345,
						360,
						370,
						370
					],
					"projections_orig": [
						"312",
						"329",
						"345",
						"360",
						"370",
						"370"
					],
					"projections_percentage": [
						-5.17,
						0,
						4.86,
						9.42,
						12.46,
						12.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3881
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 17
					},
					"classroomspace": 2.46,
					"enrolment": 458,
					"ligo": 0.57,
					"location": [
						150.896216289691,
						-34.4223353210806
					],
					"name": "Wollongong Public School",
					"playspace": 21.61,
					"projections": [
						422,
						458,
						470,
						490,
						505,
						505
					],
					"projections_orig": [
						"422",
						"458",
						"470",
						"490",
						"505",
						"505"
					],
					"projections_percentage": [
						-7.86,
						0,
						2.62,
						6.99,
						10.26,
						10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3954
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.55,
					"enrolment": 297,
					"ligo": 0.54,
					"location": [
						150.853836125583,
						-34.4400883171415
					],
					"name": "Figtree Public School",
					"playspace": 66.88,
					"projections": [
						319,
						297,
						325,
						340,
						350,
						350
					],
					"projections_orig": [
						"319",
						"297",
						"325",
						"340",
						"350",
						"350"
					],
					"projections_percentage": [
						7.41,
						0,
						9.43,
						14.48,
						17.85,
						17.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3964
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 13
					},
					"classroomspace": 2.47,
					"enrolment": 416,
					"ligo": 0.64,
					"location": [
						150.860841540884,
						-34.4293040507253
					],
					"name": "Lindsay Park Public School",
					"playspace": 36.92,
					"projections": [
						308,
						416,
						390,
						405,
						415,
						420
					],
					"projections_orig": [
						"308",
						"416",
						"390",
						"405",
						"415",
						"420"
					],
					"projections_percentage": [
						-25.96,
						0,
						-6.25,
						-2.64,
						-0.24,
						0.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4042
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.45,
					"enrolment": 244,
					"ligo": 0.66,
					"location": [
						150.856085634133,
						-34.4316035350907
					],
					"name": "Figtree Heights Public School",
					"playspace": 44.51,
					"projections": [
						223,
						244,
						260,
						270,
						275,
						280
					],
					"projections_orig": [
						"223",
						"244",
						"260",
						"270",
						"275",
						"280"
					],
					"projections_percentage": [
						-8.61,
						0,
						6.56,
						10.66,
						12.7,
						14.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4462
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 11
					},
					"classroomspace": 2.5,
					"enrolment": 299,
					"ligo": 0.67,
					"location": [
						150.847149569334,
						-34.4265102280745
					],
					"name": "Nareena Hills Public School",
					"playspace": 71.26,
					"projections": [
						317,
						299,
						325,
						340,
						350,
						355
					],
					"projections_orig": [
						"317",
						"299",
						"325",
						"340",
						"350",
						"355"
					],
					"projections_percentage": [
						6.02,
						0,
						8.7,
						13.71,
						17.06,
						18.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4500
				}
			],
			"uid": 10007
		},
		{
			"classrooms": {
				"demountable": 21,
				"permanent": 75
			},
			"enrolment": 2286,
			"level": "Primary",
			"ligo": 0.73,
			"name": "Wollongong Northern Beaches",
			"playspace": 52.87,
			"projections": [
				2286,
				2365,
				2510,
				2605,
				2665
			],
			"projections_percentage": [
				0,
				3.46,
				9.8,
				13.95,
				16.58
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 7
					},
					"classroomspace": 2.7,
					"enrolment": 338,
					"ligo": 0.65,
					"location": [
						150.935247752811,
						-34.3054032786763
					],
					"name": "Austinmer Public School",
					"playspace": 15.81,
					"projections": [
						344,
						338,
						365,
						385,
						395,
						395
					],
					"projections_orig": [
						"344",
						"338",
						"365",
						"385",
						"395",
						"395"
					],
					"projections_percentage": [
						1.78,
						0,
						7.99,
						13.91,
						16.86,
						16.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1076
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 7
					},
					"classroomspace": 2.56,
					"enrolment": 216,
					"ligo": 0.79,
					"location": [
						150.912103535895,
						-34.3273101757218
					],
					"name": "Bulli Public School",
					"playspace": 61.31,
					"projections": [
						212,
						216,
						225,
						235,
						240,
						240
					],
					"projections_orig": [
						"212",
						"216",
						"225",
						"235",
						"240",
						"240"
					],
					"projections_percentage": [
						-1.85,
						0,
						4.17,
						8.8,
						11.11,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1411
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 4
					},
					"classroomspace": 2.63,
					"enrolment": 139,
					"ligo": 0.66,
					"location": [
						150.946582642598,
						-34.2895666255615
					],
					"name": "Coledale Public School",
					"playspace": 78.06,
					"projections": [
						114,
						139,
						135,
						140,
						145,
						145
					],
					"projections_orig": [
						"114",
						"139",
						"135",
						"140",
						"145",
						"145"
					],
					"projections_percentage": [
						-17.99,
						0,
						-2.88,
						0.72,
						4.32,
						4.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1587
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 19
					},
					"classroomspace": 2.53,
					"enrolment": 482,
					"ligo": 0.98,
					"location": [
						150.987791542614,
						-34.1839389145216
					],
					"name": "Helensburgh Public School",
					"playspace": 29.47,
					"projections": [
						481,
						482,
						500,
						540,
						580,
						620
					],
					"projections_orig": [
						"481",
						"482",
						"500",
						"540",
						"580",
						"620"
					],
					"projections_percentage": [
						-0.21,
						0,
						3.73,
						12.03,
						20.33,
						28.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2153
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.97,
					"enrolment": 57,
					"ligo": 0.64,
					"location": [
						151.001836432641,
						-34.2123524681033
					],
					"name": "Otford Public School",
					"playspace": 77.73,
					"projections": [
						63,
						57,
						60,
						65,
						70,
						75
					],
					"projections_orig": [
						"63",
						"57",
						"60",
						"65",
						"70",
						"75"
					],
					"projections_percentage": [
						10.53,
						0,
						5.26,
						14.04,
						22.81,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2818
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.64,
					"enrolment": 73,
					"ligo": 0.78,
					"location": [
						150.9660782928,
						-34.2656968445563
					],
					"name": "Scarborough Public School",
					"playspace": 62.59,
					"projections": [
						66,
						73,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"66",
						"73",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						-9.59,
						0,
						9.59,
						16.44,
						16.44,
						16.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3045
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.64,
					"enrolment": 154,
					"ligo": 0.73,
					"location": [
						150.984362576867,
						-34.2291926498658
					],
					"name": "Stanwell Park Public School",
					"playspace": 38.01,
					"projections": [
						168,
						154,
						170,
						185,
						195,
						205
					],
					"projections_orig": [
						"168",
						"154",
						"170",
						"185",
						"195",
						"205"
					],
					"projections_percentage": [
						9.09,
						0,
						10.39,
						20.13,
						26.62,
						33.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3103
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 2.36,
					"enrolment": 465,
					"ligo": 0.82,
					"location": [
						150.918825192459,
						-34.315723511646
					],
					"name": "Thirroul Public School",
					"playspace": 35.33,
					"projections": [
						348,
						465,
						460,
						485,
						495,
						500
					],
					"projections_orig": [
						"348",
						"465",
						"460",
						"485",
						"495",
						"500"
					],
					"projections_percentage": [
						-25.16,
						0,
						-1.08,
						4.3,
						6.45,
						7.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3201
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 10
					},
					"classroomspace": 2.71,
					"enrolment": 362,
					"ligo": 0.49,
					"location": [
						150.918608972705,
						-34.3359011469774
					],
					"name": "Waniora Public School",
					"playspace": 77.52,
					"projections": [
						320,
						362,
						370,
						390,
						400,
						400
					],
					"projections_orig": [
						"320",
						"362",
						"370",
						"390",
						"400",
						"400"
					],
					"projections_percentage": [
						-11.6,
						0,
						2.21,
						7.73,
						10.5,
						10.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3960
				}
			],
			"uid": 10008
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 47
			},
			"enrolment": 717,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Unanderra",
			"playspace": 89.33,
			"projections": [
				717,
				810,
				850,
				875,
				880
			],
			"projections_percentage": [
				0,
				12.97,
				18.55,
				22.04,
				22.73
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.16,
					"enrolment": 126,
					"ligo": 0.64,
					"location": [
						150.817004066212,
						-34.4327681191786
					],
					"name": "Mount Kembla Public School",
					"playspace": 81.47,
					"projections": [
						151,
						126,
						140,
						150,
						155,
						155
					],
					"projections_orig": [
						"151",
						"126",
						"140",
						"150",
						"155",
						"155"
					],
					"projections_percentage": [
						19.84,
						0,
						11.11,
						19.05,
						23.02,
						23.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2643
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.92,
					"enrolment": 401,
					"ligo": 0.65,
					"location": [
						150.834677275787,
						-34.4449139532128
					],
					"name": "Unanderra Public School",
					"playspace": 33.95,
					"projections": [
						483,
						401,
						465,
						485,
						500,
						505
					],
					"projections_orig": [
						"483",
						"401",
						"465",
						"485",
						"500",
						"505"
					],
					"projections_percentage": [
						20.45,
						0,
						15.96,
						20.95,
						24.69,
						25.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3308
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 5.99,
					"enrolment": 190,
					"ligo": 0.82,
					"location": [
						150.835312354999,
						-34.4610699140548
					],
					"name": "Farmborough Road Public School",
					"playspace": 152.56,
					"projections": [
						223,
						190,
						205,
						215,
						220,
						220
					],
					"projections_orig": [
						"223",
						"190",
						"205",
						"215",
						"220",
						"220"
					],
					"projections_percentage": [
						17.37,
						0,
						7.89,
						13.16,
						15.79,
						15.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3976
				}
			],
			"uid": 10009
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 130
			},
			"enrolment": 2041,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Lake Illawarra Primary",
			"playspace": 84.74,
			"projections": [
				2041,
				2255,
				2295,
				2310,
				2340
			],
			"projections_percentage": [
				0,
				10.49,
				12.44,
				13.18,
				14.65
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.36,
					"enrolment": 180,
					"ligo": 0.71,
					"location": [
						150.86669220596,
						-34.5319749700228
					],
					"name": "Windang Public School",
					"playspace": 129.96,
					"projections": [
						171,
						180,
						190,
						195,
						200,
						205
					],
					"projections_orig": [
						"171",
						"180",
						"190",
						"195",
						"200",
						"205"
					],
					"projections_percentage": [
						-5,
						0,
						5.56,
						8.33,
						11.11,
						13.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1992
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.02,
					"enrolment": 439,
					"ligo": 0.68,
					"location": [
						150.817393119255,
						-34.5630059698292
					],
					"name": "Oak Flats Public School",
					"playspace": 30.39,
					"projections": [
						454,
						439,
						480,
						485,
						490,
						495
					],
					"projections_orig": [
						"454",
						"439",
						"480",
						"485",
						"490",
						"495"
					],
					"projections_percentage": [
						3.42,
						0,
						9.34,
						10.48,
						11.62,
						12.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3860
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.03,
					"enrolment": 244,
					"ligo": 0.52,
					"location": [
						150.859062616159,
						-34.5390194596889
					],
					"name": "Lake Illawarra South Public School",
					"playspace": 102.55,
					"projections": [
						278,
						244,
						275,
						280,
						280,
						285
					],
					"projections_orig": [
						"278",
						"244",
						"275",
						"280",
						"280",
						"285"
					],
					"projections_percentage": [
						13.93,
						0,
						12.7,
						14.75,
						14.75,
						16.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3867
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.65,
					"enrolment": 250,
					"ligo": 0.81,
					"location": [
						150.853921641464,
						-34.5572030806258
					],
					"name": "Warilla Public School",
					"playspace": 52.21,
					"projections": [
						207,
						250,
						245,
						250,
						250,
						255
					],
					"projections_orig": [
						"207",
						"250",
						"245",
						"250",
						"250",
						"255"
					],
					"projections_percentage": [
						-17.2,
						0,
						-2,
						0,
						0,
						2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4005
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.05,
					"enrolment": 282,
					"ligo": 0.57,
					"location": [
						150.830573389364,
						-34.5593404189686
					],
					"name": "Balarang Public School",
					"playspace": 88.78,
					"projections": [
						377,
						282,
						365,
						370,
						375,
						380
					],
					"projections_orig": [
						"377",
						"282",
						"365",
						"370",
						"375",
						"380"
					],
					"projections_percentage": [
						33.69,
						0,
						29.43,
						31.21,
						32.98,
						34.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4291
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.07,
					"enrolment": 152,
					"ligo": 0.88,
					"location": [
						150.85351222295,
						-34.5467797912314
					],
					"name": "Warilla North Public School",
					"playspace": 102.21,
					"projections": [
						108,
						152,
						160,
						165,
						165,
						165
					],
					"projections_orig": [
						"108",
						"152",
						"160",
						"165",
						"165",
						"165"
					],
					"projections_percentage": [
						-28.95,
						0,
						5.26,
						8.55,
						8.55,
						8.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4333
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 5.87,
					"enrolment": 243,
					"ligo": 0.61,
					"location": [
						150.844248571402,
						-34.5547141065624
					],
					"name": "Mount Warrigal Public School",
					"playspace": 79.38,
					"projections": [
						264,
						243,
						265,
						270,
						270,
						275
					],
					"projections_orig": [
						"264",
						"243",
						"265",
						"270",
						"270",
						"275"
					],
					"projections_percentage": [
						8.64,
						0,
						9.05,
						11.11,
						11.11,
						13.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4395
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 5.44,
					"enrolment": 251,
					"ligo": 0.63,
					"location": [
						150.846152946655,
						-34.5598871276146
					],
					"name": "Barrack Heights Public School",
					"playspace": 92.46,
					"projections": [
						263,
						251,
						275,
						280,
						280,
						280
					],
					"projections_orig": [
						"263",
						"251",
						"275",
						"280",
						"280",
						"280"
					],
					"projections_percentage": [
						4.78,
						0,
						9.56,
						11.55,
						11.55,
						11.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4501
				}
			],
			"uid": 10010
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 173
			},
			"enrolment": 4668,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Bellevue Hill Primary",
			"playspace": 9.96,
			"projections": [
				4668,
				4880,
				4790,
				4800,
				4900
			],
			"projections_percentage": [
				0,
				4.54,
				2.61,
				2.83,
				4.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 20
					},
					"classroomspace": 2.44,
					"enrolment": 607,
					"ligo": 0.45,
					"location": [
						151.259475518191,
						-33.8866737539736
					],
					"name": "Bellevue Hill Public School",
					"playspace": 5.29,
					"projections": [
						533,
						607,
						665,
						650,
						655,
						675
					],
					"projections_orig": [
						"533",
						"607",
						"665",
						"650",
						"655",
						"675"
					],
					"projections_percentage": [
						-12.19,
						0,
						9.56,
						7.08,
						7.91,
						11.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1179
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 1.92,
					"enrolment": 643,
					"ligo": 0.71,
					"location": [
						151.276781114553,
						-33.8888375925686
					],
					"name": "Bondi Beach Public School",
					"playspace": 10.61,
					"projections": [
						384,
						643,
						705,
						690,
						665,
						665
					],
					"projections_orig": [
						"384",
						"643",
						"705",
						"690",
						"665",
						"665"
					],
					"projections_percentage": [
						-40.28,
						0,
						9.64,
						7.31,
						3.42,
						3.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1292
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 13
					},
					"classroomspace": 2.7,
					"enrolment": 336,
					"ligo": 0.44,
					"location": [
						151.241062190599,
						-33.8753108010719
					],
					"name": "Double Bay Public School",
					"playspace": 8.33,
					"projections": [
						368,
						336,
						410,
						410,
						415,
						420
					],
					"projections_orig": [
						"368",
						"336",
						"410",
						"410",
						"415",
						"420"
					],
					"projections_percentage": [
						9.52,
						0,
						22.02,
						22.02,
						23.51,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1768
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.3,
					"enrolment": 353,
					"ligo": 0.76,
					"location": [
						151.230041583736,
						-33.8816525094199
					],
					"name": "Glenmore Road Public School",
					"playspace": 10.58,
					"projections": [
						301,
						353,
						385,
						385,
						390,
						415
					],
					"projections_orig": [
						"301",
						"353",
						"385",
						"385",
						"390",
						"415"
					],
					"projections_percentage": [
						-14.73,
						0,
						9.07,
						9.07,
						10.48,
						17.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2009
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 2.26,
					"enrolment": 642,
					"ligo": 0.68,
					"location": [
						151.271017215784,
						-33.8736394820853
					],
					"name": "Rose Bay Public School",
					"playspace": 8.8,
					"projections": [
						556,
						642,
						650,
						630,
						630,
						630
					],
					"projections_orig": [
						"556",
						"642",
						"650",
						"630",
						"630",
						"630"
					],
					"projections_percentage": [
						-13.4,
						0,
						1.25,
						-1.87,
						-1.87,
						-1.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2988
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 13
					},
					"classroomspace": 2.97,
					"enrolment": 381,
					"ligo": 0.86,
					"location": [
						151.281527315039,
						-33.8502885887502
					],
					"name": "Vaucluse Public School",
					"playspace": 25.23,
					"projections": [
						216,
						381,
						340,
						330,
						330,
						330
					],
					"projections_orig": [
						"216",
						"381",
						"340",
						"330",
						"330",
						"330"
					],
					"projections_percentage": [
						-43.31,
						0,
						-10.76,
						-13.39,
						-13.39,
						-13.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3325
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 1.83,
					"enrolment": 592,
					"ligo": 0.71,
					"location": [
						151.264352475637,
						-33.892955334127
					],
					"name": "Bondi Public School",
					"playspace": 10.89,
					"projections": [
						398,
						592,
						610,
						610,
						605,
						620
					],
					"projections_orig": [
						"398",
						"592",
						"610",
						"610",
						"605",
						"620"
					],
					"projections_percentage": [
						-32.77,
						0,
						3.04,
						3.04,
						2.2,
						4.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7407
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.42,
					"enrolment": 326,
					"ligo": 0.37,
					"location": [
						151.230412035628,
						-33.8877266900375
					],
					"name": "Paddington Public School",
					"playspace": 5.88,
					"projections": [
						266,
						326,
						330,
						320,
						330,
						355
					],
					"projections_orig": [
						"266",
						"326",
						"330",
						"320",
						"330",
						"355"
					],
					"projections_percentage": [
						-18.4,
						0,
						1.23,
						-1.84,
						1.23,
						8.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7432
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 29
					},
					"classroomspace": 2.31,
					"enrolment": 788,
					"ligo": 0.62,
					"location": [
						151.241540290263,
						-33.8865503101473
					],
					"name": "Woollahra Public School",
					"playspace": 4.03,
					"projections": [
						647,
						788,
						785,
						765,
						780,
						790
					],
					"projections_orig": [
						"647",
						"788",
						"785",
						"765",
						"780",
						"790"
					],
					"projections_percentage": [
						-17.89,
						0,
						-0.38,
						-2.92,
						-1.02,
						0.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7442
				}
			],
			"uid": 10011
		},
		{
			"classrooms": {
				"demountable": 29,
				"permanent": 196
			},
			"enrolment": 4565,
			"level": "Primary",
			"ligo": 0.63,
			"name": "Randwick Primary",
			"playspace": 20.29,
			"projections": [
				4565,
				4990,
				5155,
				5155,
				5390
			],
			"projections_percentage": [
				0,
				9.31,
				12.92,
				12.92,
				18.07
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.25,
					"enrolment": 421,
					"ligo": 0.68,
					"location": [
						151.262347991875,
						-33.9004589700813
					],
					"name": "Bronte Public School",
					"playspace": 7.01,
					"projections": [
						369,
						421,
						450,
						440,
						450,
						485
					],
					"projections_orig": [
						"369",
						"421",
						"450",
						"440",
						"450",
						"485"
					],
					"projections_percentage": [
						-12.35,
						0,
						6.89,
						4.51,
						6.89,
						15.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1372
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 26
					},
					"classroomspace": 2.47,
					"enrolment": 601,
					"ligo": 0.75,
					"location": [
						151.260821669587,
						-33.9071881120155
					],
					"name": "Clovelly Public School",
					"playspace": 12.27,
					"projections": [
						515,
						601,
						635,
						630,
						625,
						650
					],
					"projections_orig": [
						"515",
						"601",
						"635",
						"630",
						"625",
						"650"
					],
					"projections_percentage": [
						-14.31,
						0,
						5.66,
						4.83,
						3.99,
						8.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1573
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 23
					},
					"classroomspace": 2.11,
					"enrolment": 621,
					"ligo": 0.74,
					"location": [
						151.249631759227,
						-33.9204968688459
					],
					"name": "Coogee Public School",
					"playspace": 7.22,
					"projections": [
						617,
						621,
						680,
						700,
						685,
						735
					],
					"projections_orig": [
						"617",
						"621",
						"680",
						"700",
						"685",
						"735"
					],
					"projections_percentage": [
						-0.64,
						0,
						9.5,
						12.72,
						10.31,
						18.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1616
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.7,
					"enrolment": 451,
					"ligo": 0.67,
					"location": [
						151.224663933127,
						-33.9091323268954
					],
					"name": "Kensington Public School",
					"playspace": 8.1,
					"projections": [
						396,
						451,
						525,
						585,
						585,
						580
					],
					"projections_orig": [
						"396",
						"451",
						"525",
						"585",
						"585",
						"580"
					],
					"projections_percentage": [
						-12.2,
						0,
						16.41,
						29.71,
						29.71,
						28.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2283
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 19
					},
					"classroomspace": 5.55,
					"enrolment": 447,
					"ligo": 0.62,
					"location": [
						151.236787336296,
						-33.9249308372524
					],
					"name": "Rainbow Street Public School",
					"playspace": 23.83,
					"projections": [
						411,
						447,
						540,
						565,
						570,
						585
					],
					"projections_orig": [
						"411",
						"447",
						"540",
						"565",
						"570",
						"585"
					],
					"projections_percentage": [
						-8.05,
						0,
						20.81,
						26.4,
						27.52,
						30.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2930
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.71,
					"enrolment": 535,
					"ligo": 0.56,
					"location": [
						151.254498904242,
						-33.9336808981312
					],
					"name": "South Coogee Public School",
					"playspace": 21.43,
					"projections": [
						539,
						535,
						620,
						675,
						650,
						670
					],
					"projections_orig": [
						"539",
						"535",
						"620",
						"675",
						"650",
						"670"
					],
					"projections_percentage": [
						0.75,
						0,
						15.89,
						26.17,
						21.5,
						25.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3703
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.52,
					"enrolment": 281,
					"ligo": 0.62,
					"location": [
						151.252097666311,
						-33.8986882162533
					],
					"name": "Waverley Public School",
					"playspace": 24.17,
					"projections": [
						217,
						281,
						255,
						245,
						250,
						275
					],
					"projections_orig": [
						"217",
						"281",
						"255",
						"245",
						"250",
						"275"
					],
					"projections_percentage": [
						-22.78,
						0,
						-9.25,
						-12.81,
						-11.03,
						-2.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3953
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 32
					},
					"classroomspace": 2.4,
					"enrolment": 927,
					"ligo": 0.59,
					"location": [
						151.241433395817,
						-33.9105666952041
					],
					"name": "Randwick Public School",
					"playspace": 8.14,
					"projections": [
						719,
						927,
						950,
						945,
						960,
						1030
					],
					"projections_orig": [
						"719",
						"927",
						"950",
						"945",
						"960",
						"1030"
					],
					"projections_percentage": [
						-22.44,
						0,
						2.48,
						1.94,
						3.56,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4250
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.35,
					"enrolment": 281,
					"ligo": 0.41,
					"location": [
						151.228465528834,
						-33.9288804877056
					],
					"name": "Daceyville Public School",
					"playspace": 70.46,
					"projections": [
						242,
						281,
						335,
						370,
						380,
						380
					],
					"projections_orig": [
						"242",
						"281",
						"335",
						"370",
						"380",
						"380"
					],
					"projections_percentage": [
						-13.88,
						0,
						19.22,
						31.67,
						35.23,
						35.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7413
				}
			],
			"uid": 10012
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 100
			},
			"enrolment": 1941,
			"level": "Primary",
			"ligo": 0.54,
			"name": "Maroubra Primary",
			"playspace": 253.34,
			"projections": [
				1941,
				2400,
				2790,
				2820,
				2790
			],
			"projections_percentage": [
				0,
				23.65,
				43.74,
				45.29,
				43.74
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 28.94,
					"enrolment": 26,
					"ligo": 0.54,
					"location": [
						151.235668132664,
						-33.9794855157581
					],
					"name": "La Perouse Public School",
					"playspace": 1407.79,
					"projections": [
						47,
						26,
						60,
						70,
						70,
						70
					],
					"projections_orig": [
						"47",
						"26",
						"60",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						80.77,
						0,
						130.77,
						169.23,
						169.23,
						169.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2373
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 6
					},
					"classroomspace": 2.63,
					"enrolment": 303,
					"ligo": 0.39,
					"location": [
						151.248546484368,
						-33.9614897343349
					],
					"name": "Malabar Public School",
					"playspace": 24.97,
					"projections": [
						259,
						303,
						355,
						435,
						430,
						420
					],
					"projections_orig": [
						"259",
						"303",
						"355",
						"435",
						"430",
						"420"
					],
					"projections_percentage": [
						-14.52,
						0,
						17.16,
						43.56,
						41.91,
						38.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2454
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.83,
					"enrolment": 329,
					"ligo": 0.74,
					"location": [
						151.2531786247,
						-33.943900767357
					],
					"name": "Maroubra Bay Public School",
					"playspace": 56.43,
					"projections": [
						188,
						329,
						365,
						410,
						405,
						400
					],
					"projections_orig": [
						"188",
						"329",
						"365",
						"410",
						"405",
						"400"
					],
					"projections_percentage": [
						-42.86,
						0,
						10.94,
						24.62,
						23.1,
						21.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2482
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 4.4,
					"enrolment": 226,
					"ligo": 0.78,
					"location": [
						151.22999838766,
						-33.9551052755874
					],
					"name": "Matraville Public School",
					"playspace": 51.04,
					"projections": [
						201,
						226,
						300,
						365,
						400,
						405
					],
					"projections_orig": [
						"201",
						"226",
						"300",
						"365",
						"400",
						"405"
					],
					"projections_percentage": [
						-11.06,
						0,
						32.74,
						61.5,
						76.99,
						79.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2502
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.04,
					"enrolment": 228,
					"ligo": 0.26,
					"location": [
						151.23955238238,
						-33.9575223244423
					],
					"name": "Matraville Soldiers Settlement Public School",
					"playspace": 26.42,
					"projections": [
						217,
						228,
						285,
						330,
						330,
						325
					],
					"projections_orig": [
						"217",
						"228",
						"285",
						"330",
						"330",
						"325"
					],
					"projections_percentage": [
						-4.82,
						0,
						25,
						44.74,
						44.74,
						42.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4067
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 9
					},
					"classroomspace": 3.86,
					"enrolment": 169,
					"ligo": 0.45,
					"location": [
						151.242692501035,
						-33.9662213938743
					],
					"name": "Chifley Public School",
					"playspace": 186.6,
					"projections": [
						230,
						169,
						230,
						270,
						270,
						260
					],
					"projections_orig": [
						"230",
						"169",
						"230",
						"270",
						"270",
						"260"
					],
					"projections_percentage": [
						36.09,
						0,
						36.09,
						59.76,
						59.76,
						53.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4299
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 26
					},
					"classroomspace": 2.58,
					"enrolment": 660,
					"ligo": 0.65,
					"location": [
						151.239728856488,
						-33.9370270595463
					],
					"name": "Maroubra Junction Public School",
					"playspace": 20.11,
					"projections": [
						570,
						660,
						805,
						910,
						915,
						910
					],
					"projections_orig": [
						"570",
						"660",
						"805",
						"910",
						"915",
						"910"
					],
					"projections_percentage": [
						-13.64,
						0,
						21.97,
						37.88,
						38.64,
						37.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7427
				}
			],
			"uid": 10013
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 65
			},
			"enrolment": 1343,
			"level": "Primary",
			"ligo": 0.59,
			"name": "Botany Primary",
			"playspace": 62.94,
			"projections": [
				1343,
				1760,
				2090,
				2320,
				2390
			],
			"projections_percentage": [
				0,
				31.05,
				55.62,
				72.75,
				77.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 11
					},
					"classroomspace": 2.87,
					"enrolment": 270,
					"ligo": 0.46,
					"location": [
						151.206758012382,
						-33.9529246419934
					],
					"name": "Banksmeadow Public School",
					"playspace": 80.44,
					"projections": [
						262,
						270,
						330,
						400,
						440,
						435
					],
					"projections_orig": [
						"262",
						"270",
						"330",
						"400",
						"440",
						"435"
					],
					"projections_percentage": [
						-2.96,
						0,
						22.22,
						48.15,
						62.96,
						61.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1121
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.44,
					"enrolment": 284,
					"ligo": 0.62,
					"location": [
						151.195347229319,
						-33.942844983843
					],
					"name": "Botany Public School",
					"playspace": 50.39,
					"projections": [
						194,
						284,
						355,
						420,
						475,
						460
					],
					"projections_orig": [
						"194",
						"284",
						"355",
						"420",
						"475",
						"460"
					],
					"projections_percentage": [
						-31.69,
						0,
						25,
						47.89,
						67.25,
						61.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1323
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.71,
					"enrolment": 350,
					"ligo": 0.5,
					"location": [
						151.192999298401,
						-33.9293430357274
					],
					"name": "Mascot Public School",
					"playspace": 83.28,
					"projections": [
						461,
						350,
						430,
						540,
						615,
						650
					],
					"projections_orig": [
						"461",
						"350",
						"430",
						"540",
						"615",
						"650"
					],
					"projections_percentage": [
						31.71,
						0,
						22.86,
						54.29,
						75.71,
						85.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2499
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 10
					},
					"classroomspace": 3.01,
					"enrolment": 263,
					"ligo": 0.47,
					"location": [
						151.215012301461,
						-33.9426915649607
					],
					"name": "Pagewood Public School",
					"playspace": 38.38,
					"projections": [
						184,
						263,
						360,
						415,
						450,
						495
					],
					"projections_orig": [
						"184",
						"263",
						"360",
						"415",
						"450",
						"495"
					],
					"projections_percentage": [
						-30.04,
						0,
						36.88,
						57.79,
						71.1,
						88.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3905
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.76,
					"enrolment": 176,
					"ligo": 0.9,
					"location": [
						151.213245859943,
						-33.9278421249237
					],
					"name": "Eastlakes Public School",
					"playspace": 62.19,
					"projections": [
						211,
						176,
						285,
						315,
						340,
						350
					],
					"projections_orig": [
						"211",
						"176",
						"285",
						"315",
						"340",
						"350"
					],
					"projections_percentage": [
						19.89,
						0,
						61.93,
						78.98,
						93.18,
						98.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4516
				}
			],
			"uid": 10014
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 165
			},
			"enrolment": 2129,
			"level": "Primary",
			"ligo": 0.52,
			"name": "Green Square Primary",
			"playspace": 20.42,
			"projections": [
				2847,
				3435,
				4000,
				4275,
				4475
			],
			"projections_percentage": [
				0,
				20.65,
				40.5,
				50.16,
				57.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 4.05,
					"enrolment": 241,
					"ligo": 0.55,
					"location": [
						151.189640992739,
						-33.8923881515648
					],
					"name": "Darlington Public School",
					"playspace": 13.8,
					"projections": [
						270,
						241,
						315,
						330,
						340,
						340
					],
					"projections_orig": [
						"270",
						"241",
						"315",
						"330",
						"340",
						"340"
					],
					"projections_percentage": [
						12.03,
						0,
						30.71,
						36.93,
						41.08,
						41.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1735
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.68,
					"enrolment": 380,
					"ligo": 0.59,
					"location": [
						151.186309677469,
						-33.9008383609057
					],
					"name": "Erskineville Public School",
					"playspace": 15.17,
					"projections": [
						334,
						380,
						435,
						465,
						470,
						475
					],
					"projections_orig": [
						"334",
						"380",
						"435",
						"465",
						"470",
						"475"
					],
					"projections_percentage": [
						-12.11,
						0,
						14.47,
						22.37,
						23.68,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4147
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 1.48,
					"enrolment": 430,
					"ligo": 0.61,
					"location": [
						151.2149369965,
						-33.8904205974704
					],
					"name": "Bourke Street Public School",
					"playspace": 6.37,
					"projections": [
						137,
						430,
						450,
						475,
						480,
						485
					],
					"projections_orig": [
						"137",
						"430",
						"450",
						"475",
						"480",
						"485"
					],
					"projections_percentage": [
						-68.14,
						0,
						4.65,
						10.47,
						11.63,
						12.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7408
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.86,
					"enrolment": 360,
					"ligo": 0.42,
					"location": [
						151.197909720288,
						-33.9215401934209
					],
					"name": "Gardeners Road Public School",
					"playspace": 38.75,
					"projections": [
						268,
						360,
						505,
						620,
						685,
						705
					],
					"projections_orig": [
						"268",
						"360",
						"505",
						"620",
						"685",
						"705"
					],
					"projections_percentage": [
						-25.56,
						0,
						40.28,
						72.22,
						90.28,
						95.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7418
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 48
					},
					"classroomspace": 4.85,
					"enrolment": 371,
					"ligo": 0.46,
					"location": [
						151.195595971057,
						-33.9013345944937
					],
					"name": "Alexandria Park Community School",
					"playspace": 23.4,
					"projections": [
						397,
						397,
						718,
						718,
						865,
						865,
						1055,
						1055,
						1150,
						1150,
						1235,
						1235
					],
					"projections_orig": [
						"397",
						"397",
						"718",
						"718",
						"865",
						"865",
						"1055",
						"1055",
						"1150",
						"1150",
						"1235",
						"1235"
					],
					"projections_percentage": [
						0,
						0,
						80.86,
						80.86,
						117.88,
						117.88,
						165.74,
						165.74,
						189.67,
						189.67,
						211.08,
						211.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8556
				}
			],
			"uid": 10015
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 165
			},
			"enrolment": 2129,
			"level": "Secondary",
			"ligo": 0.52,
			"name": "Green Square Primary",
			"playspace": 20.42,
			"projections": [
				2847,
				3435,
				4000,
				4275,
				4475
			],
			"projections_percentage": [
				0,
				20.65,
				40.5,
				50.16,
				57.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 4.05,
					"enrolment": 241,
					"ligo": 0.55,
					"location": [
						151.189640992739,
						-33.8923881515648
					],
					"name": "Darlington Public School",
					"playspace": 13.8,
					"projections": [
						270,
						241,
						315,
						330,
						340,
						340
					],
					"projections_orig": [
						"270",
						"241",
						"315",
						"330",
						"340",
						"340"
					],
					"projections_percentage": [
						12.03,
						0,
						30.71,
						36.93,
						41.08,
						41.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1735
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.68,
					"enrolment": 380,
					"ligo": 0.59,
					"location": [
						151.186309677469,
						-33.9008383609057
					],
					"name": "Erskineville Public School",
					"playspace": 15.17,
					"projections": [
						334,
						380,
						435,
						465,
						470,
						475
					],
					"projections_orig": [
						"334",
						"380",
						"435",
						"465",
						"470",
						"475"
					],
					"projections_percentage": [
						-12.11,
						0,
						14.47,
						22.37,
						23.68,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4147
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 1.48,
					"enrolment": 430,
					"ligo": 0.61,
					"location": [
						151.2149369965,
						-33.8904205974704
					],
					"name": "Bourke Street Public School",
					"playspace": 6.37,
					"projections": [
						137,
						430,
						450,
						475,
						480,
						485
					],
					"projections_orig": [
						"137",
						"430",
						"450",
						"475",
						"480",
						"485"
					],
					"projections_percentage": [
						-68.14,
						0,
						4.65,
						10.47,
						11.63,
						12.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7408
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.86,
					"enrolment": 360,
					"ligo": 0.42,
					"location": [
						151.197909720288,
						-33.9215401934209
					],
					"name": "Gardeners Road Public School",
					"playspace": 38.75,
					"projections": [
						268,
						360,
						505,
						620,
						685,
						705
					],
					"projections_orig": [
						"268",
						"360",
						"505",
						"620",
						"685",
						"705"
					],
					"projections_percentage": [
						-25.56,
						0,
						40.28,
						72.22,
						90.28,
						95.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7418
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 48
					},
					"classroomspace": 4.85,
					"enrolment": 371,
					"ligo": 0.46,
					"location": [
						151.195595971057,
						-33.9013345944937
					],
					"name": "Alexandria Park Community School",
					"playspace": 23.4,
					"projections": [
						397,
						397,
						718,
						718,
						865,
						865,
						1055,
						1055,
						1150,
						1150,
						1235,
						1235
					],
					"projections_orig": [
						"397",
						"397",
						"718",
						"718",
						"865",
						"865",
						"1055",
						"1055",
						"1150",
						"1150",
						"1235",
						"1235"
					],
					"projections_percentage": [
						0,
						0,
						80.86,
						80.86,
						117.88,
						117.88,
						165.74,
						165.74,
						189.67,
						189.67,
						211.08,
						211.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8556
				}
			],
			"uid": 10015
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 73
			},
			"enrolment": 1701,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Inner City Primary",
			"playspace": 20.99,
			"projections": [
				1701,
				2050,
				2205,
				2245,
				2310
			],
			"projections_percentage": [
				0,
				20.52,
				29.63,
				31.98,
				35.8
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 1.92,
					"enrolment": 344,
					"ligo": 0.61,
					"location": [
						151.181060188296,
						-33.8824323394974
					],
					"name": "Forest Lodge Public School",
					"playspace": 9.26,
					"projections": [
						314,
						344,
						395,
						435,
						425,
						415
					],
					"projections_orig": [
						"314",
						"344",
						"395",
						"435",
						"425",
						"415"
					],
					"projections_percentage": [
						-8.72,
						0,
						14.83,
						26.45,
						23.55,
						20.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1932
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 1.37,
					"enrolment": 193,
					"ligo": 0.58,
					"location": [
						151.205273419505,
						-33.8604766978692
					],
					"name": "Fort Street Public School",
					"playspace": 10.02,
					"projections": [
						97,
						193,
						210,
						235,
						255,
						275
					],
					"projections_orig": [
						"97",
						"193",
						"210",
						"235",
						"255",
						"275"
					],
					"projections_percentage": [
						-49.74,
						0,
						8.81,
						21.76,
						32.12,
						42.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1937
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 3.44,
					"enrolment": 279,
					"ligo": 0.92,
					"location": [
						151.195820650611,
						-33.8772844491475
					],
					"name": "Ultimo Public School",
					"playspace": 8.63,
					"projections": [
						287,
						279,
						400,
						430,
						445,
						460
					],
					"projections_orig": [
						"287",
						"279",
						"400",
						"430",
						"445",
						"460"
					],
					"projections_percentage": [
						2.87,
						0,
						43.37,
						54.12,
						59.5,
						64.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3305
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.39,
					"enrolment": 280,
					"ligo": 0.6,
					"location": [
						151.215446699665,
						-33.8820573301366
					],
					"name": "Crown Street Public School",
					"playspace": 8.92,
					"projections": [
						292,
						280,
						350,
						370,
						380,
						400
					],
					"projections_orig": [
						"292",
						"280",
						"350",
						"370",
						"380",
						"400"
					],
					"projections_percentage": [
						4.29,
						0,
						25,
						32.14,
						35.71,
						42.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3935
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.37,
					"enrolment": 35,
					"ligo": 0.8,
					"location": [
						151.220913133045,
						-33.8707612263727
					],
					"name": "Plunkett Street Public School",
					"playspace": 91.19,
					"projections": [
						60,
						35,
						55,
						60,
						65,
						70
					],
					"projections_orig": [
						"60",
						"35",
						"55",
						"60",
						"65",
						"70"
					],
					"projections_percentage": [
						71.43,
						0,
						57.14,
						71.43,
						85.71,
						100
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4551
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.43,
					"enrolment": 311,
					"ligo": 0.52,
					"location": [
						151.223312462447,
						-33.8782482488838
					],
					"name": "Darlinghurst Public School",
					"playspace": 7.29,
					"projections": [
						220,
						311,
						360,
						375,
						385,
						400
					],
					"projections_orig": [
						"220",
						"311",
						"360",
						"375",
						"385",
						"400"
					],
					"projections_percentage": [
						-29.26,
						0,
						15.76,
						20.58,
						23.79,
						28.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7414
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.03,
					"enrolment": 259,
					"ligo": 0.7,
					"location": [
						151.191171379351,
						-33.8837410248622
					],
					"name": "Glebe Public School",
					"playspace": 11.65,
					"projections": [
						139,
						259,
						280,
						300,
						290,
						290
					],
					"projections_orig": [
						"139",
						"259",
						"280",
						"300",
						"290",
						"290"
					],
					"projections_percentage": [
						-46.33,
						0,
						8.11,
						15.83,
						11.97,
						11.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7419
				}
			],
			"uid": 10016
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 69
			},
			"enrolment": 1478,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Newtown Primary",
			"playspace": 42.35,
			"projections": [
				1478,
				1555,
				1595,
				1645,
				1675
			],
			"projections_percentage": [
				0,
				5.21,
				7.92,
				11.3,
				13.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.15,
					"enrolment": 264,
					"ligo": 0.66,
					"location": [
						151.175783974597,
						-33.9062078048056
					],
					"name": "Camdenville Public School",
					"playspace": 35.39,
					"projections": [
						235,
						264,
						260,
						265,
						275,
						280
					],
					"projections_orig": [
						"235",
						"264",
						"260",
						"265",
						"275",
						"280"
					],
					"projections_percentage": [
						-10.98,
						0,
						-1.52,
						0.38,
						4.17,
						6.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1483
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.51,
					"enrolment": 284,
					"ligo": 0.56,
					"location": [
						151.185911055226,
						-33.8919747278783
					],
					"name": "Newtown North Public School",
					"playspace": 13.36,
					"projections": [
						263,
						284,
						285,
						300,
						310,
						310
					],
					"projections_orig": [
						"263",
						"284",
						"285",
						"300",
						"310",
						"310"
					],
					"projections_percentage": [
						-7.39,
						0,
						0.35,
						5.63,
						9.15,
						9.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2744
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 4.14,
					"enrolment": 90,
					"ligo": 0.72,
					"location": [
						151.177959625748,
						-33.9127874358669
					],
					"name": "St Peters Public School",
					"playspace": 151.9,
					"projections": [
						60,
						90,
						90,
						95,
						100,
						105
					],
					"projections_orig": [
						"60",
						"90",
						"90",
						"95",
						"100",
						"105"
					],
					"projections_percentage": [
						-33.33,
						0,
						0,
						5.56,
						11.11,
						16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3032
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.85,
					"enrolment": 321,
					"ligo": 0.65,
					"location": [
						151.161506806585,
						-33.9201726114034
					],
					"name": "Tempe Public School",
					"playspace": 34.66,
					"projections": [
						231,
						321,
						335,
						345,
						365,
						380
					],
					"projections_orig": [
						"231",
						"321",
						"335",
						"345",
						"365",
						"380"
					],
					"projections_percentage": [
						-28.04,
						0,
						4.36,
						7.48,
						13.71,
						18.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3948
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.85,
					"enrolment": 123,
					"ligo": 1,
					"location": [
						151.177886816808,
						-33.8957216390437
					],
					"name": "Australia Street Infants School",
					"playspace": 9.85,
					"projections": [
						136,
						123,
						135,
						140,
						140,
						140
					],
					"projections_orig": [
						"136",
						"123",
						"135",
						"140",
						"140",
						"140"
					],
					"projections_percentage": [
						10.57,
						0,
						9.76,
						13.82,
						13.82,
						13.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5104
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 9
					},
					"classroomspace": 2.29,
					"enrolment": 396,
					"ligo": 0.6,
					"location": [
						151.179373167956,
						-33.8998552806166
					],
					"name": "Newtown Public School",
					"playspace": 8.93,
					"projections": [
						295,
						396,
						450,
						450,
						455,
						460
					],
					"projections_orig": [
						"295",
						"396",
						"450",
						"450",
						"455",
						"460"
					],
					"projections_percentage": [
						-25.51,
						0,
						13.64,
						13.64,
						14.9,
						16.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7431
				}
			],
			"uid": 10017
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 194
			},
			"enrolment": 4708,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Orange Grove Primary",
			"playspace": 15.66,
			"projections": [
				4708,
				4720,
				4870,
				5145,
				5140
			],
			"projections_percentage": [
				0,
				0.25,
				3.44,
				9.28,
				9.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.34,
					"enrolment": 418,
					"ligo": 0.73,
					"location": [
						151.168868767707,
						-33.8858905217732
					],
					"name": "Annandale Public School",
					"playspace": 13.79,
					"projections": [
						400,
						418,
						430,
						440,
						455,
						455
					],
					"projections_orig": [
						"400",
						"418",
						"430",
						"440",
						"455",
						"455"
					],
					"projections_percentage": [
						-4.31,
						0,
						2.87,
						5.26,
						8.85,
						8.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1041
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.38,
					"enrolment": 401,
					"ligo": 0.63,
					"location": [
						151.172058507888,
						-33.878029649028
					],
					"name": "Annandale North Public School",
					"playspace": 6.28,
					"projections": [
						415,
						401,
						470,
						520,
						555,
						555
					],
					"projections_orig": [
						"415",
						"401",
						"470",
						"520",
						"555",
						"555"
					],
					"projections_percentage": [
						3.49,
						0,
						17.21,
						29.68,
						38.4,
						38.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1042
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.17,
					"enrolment": 368,
					"ligo": 0.74,
					"location": [
						151.176486282558,
						-33.8529271000012
					],
					"name": "Birchgrove Public School",
					"playspace": 10.11,
					"projections": [
						392,
						368,
						360,
						360,
						365,
						360
					],
					"projections_orig": [
						"392",
						"368",
						"360",
						"360",
						"365",
						"360"
					],
					"projections_percentage": [
						6.52,
						0,
						-2.17,
						-2.17,
						-0.82,
						-2.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1240
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 2.52,
					"enrolment": 634,
					"ligo": 0.24,
					"location": [
						151.134993595091,
						-33.8795425615584
					],
					"name": "Haberfield Public School",
					"playspace": 14.76,
					"projections": [
						600,
						634,
						670,
						690,
						740,
						720
					],
					"projections_orig": [
						"600",
						"634",
						"670",
						"690",
						"740",
						"720"
					],
					"projections_percentage": [
						-5.36,
						0,
						5.68,
						8.83,
						16.72,
						13.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2117
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.88,
					"enrolment": 336,
					"ligo": 0.59,
					"location": [
						151.147436221457,
						-33.8865327586997
					],
					"name": "Kegworth Public School",
					"playspace": 30.73,
					"projections": [
						310,
						336,
						335,
						345,
						350,
						350
					],
					"projections_orig": [
						"310",
						"336",
						"335",
						"345",
						"350",
						"350"
					],
					"projections_percentage": [
						-7.74,
						0,
						-0.3,
						2.68,
						4.17,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2270
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.9,
					"enrolment": 170,
					"ligo": 0.48,
					"location": [
						151.192792525038,
						-33.8560846728761
					],
					"name": "Nicholson Street Public School",
					"playspace": 16.08,
					"projections": [
						160,
						170,
						170,
						175,
						180,
						180
					],
					"projections_orig": [
						"160",
						"170",
						"170",
						"175",
						"180",
						"180"
					],
					"projections_percentage": [
						-5.88,
						0,
						0,
						2.94,
						5.88,
						5.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2749
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.04,
					"enrolment": 429,
					"ligo": 0.86,
					"location": [
						151.158624498632,
						-33.8727127893945
					],
					"name": "Orange Grove Public School",
					"playspace": 27.53,
					"projections": [
						240,
						429,
						380,
						380,
						430,
						430
					],
					"projections_orig": [
						"240",
						"429",
						"380",
						"380",
						"430",
						"430"
					],
					"projections_percentage": [
						-44.06,
						0,
						-11.42,
						-11.42,
						0.23,
						0.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2812
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 8
					},
					"classroomspace": 3.14,
					"enrolment": 242,
					"ligo": 0.51,
					"location": [
						151.140251329795,
						-33.8746976547612
					],
					"name": "Dobroyd Point Public School",
					"playspace": 24.51,
					"projections": [
						244,
						242,
						260,
						265,
						275,
						275
					],
					"projections_orig": [
						"244",
						"242",
						"260",
						"265",
						"275",
						"275"
					],
					"projections_percentage": [
						0.83,
						0,
						7.44,
						9.5,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3873
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 1.99,
					"enrolment": 341,
					"ligo": 0.61,
					"location": [
						151.183686919397,
						-33.8590603875269
					],
					"name": "Balmain Public School",
					"playspace": 4.75,
					"projections": [
						223,
						341,
						315,
						335,
						345,
						340
					],
					"projections_orig": [
						"223",
						"341",
						"315",
						"335",
						"345",
						"340"
					],
					"projections_percentage": [
						-34.6,
						0,
						-7.62,
						-1.76,
						1.17,
						-0.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7404
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 2.26,
					"enrolment": 730,
					"ligo": 0.55,
					"location": [
						151.157834337243,
						-33.8838365825982
					],
					"name": "Leichhardt Public School",
					"playspace": 10.19,
					"projections": [
						572,
						730,
						715,
						730,
						745,
						745
					],
					"projections_orig": [
						"572",
						"730",
						"715",
						"730",
						"745",
						"745"
					],
					"projections_percentage": [
						-21.64,
						0,
						-2.05,
						0,
						2.05,
						2.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7423
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 2.35,
					"enrolment": 639,
					"ligo": 0.89,
					"location": [
						151.170144641606,
						-33.8625455347685
					],
					"name": "Rozelle Public School",
					"playspace": 13.57,
					"projections": [
						538,
						639,
						615,
						630,
						705,
						730
					],
					"projections_orig": [
						"538",
						"639",
						"615",
						"630",
						"705",
						"730"
					],
					"projections_percentage": [
						-15.81,
						0,
						-3.76,
						-1.41,
						10.33,
						14.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7435
				}
			],
			"uid": 10018
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 73
			},
			"enrolment": 1915,
			"level": "Primary",
			"ligo": 0.84,
			"name": "Drummoyne Peninsula Primary",
			"playspace": 26.61,
			"projections": [
				1915,
				2125,
				2200,
				2305,
				2380
			],
			"projections_percentage": [
				0,
				10.97,
				14.88,
				20.37,
				24.28
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 17
					},
					"classroomspace": 2.57,
					"enrolment": 639,
					"ligo": 0.81,
					"location": [
						151.129929883859,
						-33.8532607910629
					],
					"name": "Abbotsford Public School",
					"playspace": 24.83,
					"projections": [
						461,
						639,
						625,
						640,
						665,
						680
					],
					"projections_orig": [
						"461",
						"639",
						"625",
						"640",
						"665",
						"680"
					],
					"projections_percentage": [
						-27.86,
						0,
						-2.19,
						0.16,
						4.07,
						6.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1001
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.18,
					"enrolment": 687,
					"ligo": 0.77,
					"location": [
						151.152820412447,
						-33.8556076663427
					],
					"name": "Drummoyne Public School",
					"playspace": 7.72,
					"projections": [
						610,
						687,
						725,
						735,
						760,
						800
					],
					"projections_orig": [
						"610",
						"687",
						"725",
						"735",
						"760",
						"800"
					],
					"projections_percentage": [
						-11.21,
						0,
						5.53,
						6.99,
						10.63,
						16.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1774
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 22
					},
					"classroomspace": 2.86,
					"enrolment": 412,
					"ligo": 0.78,
					"location": [
						151.128183003411,
						-33.8670858248609
					],
					"name": "Five Dock Public School",
					"playspace": 28.31,
					"projections": [
						331,
						412,
						435,
						475,
						515,
						525
					],
					"projections_orig": [
						"331",
						"412",
						"435",
						"475",
						"515",
						"525"
					],
					"projections_percentage": [
						-19.66,
						0,
						5.58,
						15.29,
						25,
						27.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1920
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.55,
					"enrolment": 177,
					"ligo": 1,
					"location": [
						151.142922426586,
						-33.8616958448601
					],
					"name": "Russell Lea Public School",
					"playspace": 45.58,
					"projections": [
						146,
						177,
						340,
						350,
						365,
						375
					],
					"projections_orig": [
						"146",
						"177",
						"340",
						"350",
						"365",
						"375"
					],
					"projections_percentage": [
						-17.51,
						0,
						92.09,
						97.74,
						106.21,
						111.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5132
				}
			],
			"uid": 10019
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 87
			},
			"enrolment": 1787,
			"level": "Primary",
			"ligo": 0.54,
			"name": "Marrickville Primary",
			"playspace": 30.83,
			"projections": [
				1787,
				1830,
				1905,
				2070,
				2180
			],
			"projections_percentage": [
				0,
				2.41,
				6.6,
				15.84,
				21.99
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.29,
					"enrolment": 376,
					"ligo": 0.65,
					"location": [
						151.144696642717,
						-33.9141589819501
					],
					"name": "Marrickville West Public School",
					"playspace": 20.95,
					"projections": [
						250,
						376,
						345,
						365,
						410,
						440
					],
					"projections_orig": [
						"250",
						"376",
						"345",
						"365",
						"410",
						"440"
					],
					"projections_percentage": [
						-33.51,
						0,
						-8.24,
						-2.93,
						9.04,
						17.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3951
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 4.36,
					"enrolment": 312,
					"ligo": 0.53,
					"location": [
						151.16233944032,
						-33.9069775300149
					],
					"name": "Marrickville Public School",
					"playspace": 43.26,
					"projections": [
						192,
						312,
						295,
						300,
						325,
						345
					],
					"projections_orig": [
						"192",
						"312",
						"295",
						"300",
						"325",
						"345"
					],
					"projections_percentage": [
						-38.46,
						0,
						-5.45,
						-3.85,
						4.17,
						10.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3952
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 20
					},
					"classroomspace": 2.63,
					"enrolment": 654,
					"ligo": 0.48,
					"location": [
						151.156147181195,
						-33.9011959806341
					],
					"name": "Wilkins Public School",
					"playspace": 44.42,
					"projections": [
						589,
						654,
						710,
						735,
						780,
						800
					],
					"projections_orig": [
						"589",
						"654",
						"710",
						"735",
						"780",
						"800"
					],
					"projections_percentage": [
						-9.94,
						0,
						8.56,
						12.39,
						19.27,
						22.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4543
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.54,
					"enrolment": 445,
					"ligo": 0.48,
					"location": [
						151.152268575467,
						-33.9205593154717
					],
					"name": "Ferncourt Public School",
					"playspace": 14.69,
					"projections": [
						385,
						445,
						480,
						505,
						555,
						595
					],
					"projections_orig": [
						"385",
						"445",
						"480",
						"505",
						"555",
						"595"
					],
					"projections_percentage": [
						-13.48,
						0,
						7.87,
						13.48,
						24.72,
						33.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5114
				}
			],
			"uid": 10020
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 105
			},
			"enrolment": 2530,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Inner West Primary",
			"playspace": 18.93,
			"projections": [
				2530,
				2730,
				2885,
				3045,
				3055
			],
			"projections_percentage": [
				0,
				7.91,
				14.03,
				20.36,
				20.75
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 2.41,
					"enrolment": 813,
					"ligo": 0.74,
					"location": [
						151.136524255578,
						-33.895551790359
					],
					"name": "Summer Hill Public School",
					"playspace": 9.28,
					"projections": [
						768,
						813,
						895,
						945,
						995,
						965
					],
					"projections_orig": [
						"768",
						"813",
						"895",
						"945",
						"995",
						"965"
					],
					"projections_percentage": [
						-5.54,
						0,
						10.09,
						16.24,
						22.39,
						18.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.28,
					"enrolment": 197,
					"ligo": 0.46,
					"location": [
						151.145741112095,
						-33.8975921716683
					],
					"name": "Lewisham Public School",
					"playspace": 29.91,
					"projections": [
						95,
						197,
						190,
						195,
						205,
						210
					],
					"projections_orig": [
						"95",
						"197",
						"190",
						"195",
						"205",
						"210"
					],
					"projections_percentage": [
						-51.78,
						0,
						-3.55,
						-1.02,
						4.06,
						6.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4369
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 23
					},
					"classroomspace": 2.85,
					"enrolment": 510,
					"ligo": 0.63,
					"location": [
						151.14057334101,
						-33.9057177239983
					],
					"name": "Dulwich Hill Public School",
					"playspace": 17.26,
					"projections": [
						531,
						510,
						595,
						660,
						720,
						735
					],
					"projections_orig": [
						"531",
						"510",
						"595",
						"660",
						"720",
						"735"
					],
					"projections_percentage": [
						4.12,
						0,
						16.67,
						29.41,
						41.18,
						44.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4496
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 6
					},
					"classroomspace": 2.5,
					"enrolment": 256,
					"ligo": 0.57,
					"location": [
						151.150659854346,
						-33.8956637004032
					],
					"name": "Petersham Public School",
					"playspace": 30.92,
					"projections": [
						232,
						256,
						275,
						290,
						300,
						305
					],
					"projections_orig": [
						"232",
						"256",
						"275",
						"290",
						"300",
						"305"
					],
					"projections_percentage": [
						-9.38,
						0,
						7.42,
						13.28,
						17.19,
						19.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4502
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.87,
					"enrolment": 89,
					"ligo": 1,
					"location": [
						151.157437294327,
						-33.8887833440851
					],
					"name": "Taverners Hill Infants School",
					"playspace": 11.93,
					"projections": [
						77,
						89,
						90,
						95,
						95,
						100
					],
					"projections_orig": [
						"77",
						"89",
						"90",
						"95",
						"95",
						"100"
					],
					"projections_percentage": [
						-13.48,
						0,
						1.12,
						6.74,
						6.74,
						12.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5112
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 2.42,
					"enrolment": 665,
					"ligo": 0.7,
					"location": [
						151.165234634111,
						-33.8952392021891
					],
					"name": "Stanmore Public School",
					"playspace": 14.29,
					"projections": [
						543,
						665,
						685,
						700,
						730,
						740
					],
					"projections_orig": [
						"543",
						"665",
						"685",
						"700",
						"730",
						"740"
					],
					"projections_percentage": [
						-18.35,
						0,
						3.01,
						5.26,
						9.77,
						11.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7436
				}
			],
			"uid": 10021
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 177
			},
			"enrolment": 4595,
			"level": "Primary",
			"ligo": 0.64,
			"name": "Burwood Primary",
			"playspace": 18.47,
			"projections": [
				4595,
				5705,
				6730,
				7445,
				7830
			],
			"projections_percentage": [
				0,
				24.16,
				46.46,
				62.02,
				70.4
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.64,
					"enrolment": 439,
					"ligo": 0.77,
					"location": [
						151.127747661555,
						-33.8894137929762
					],
					"name": "Ashfield Public School",
					"playspace": 12.13,
					"projections": [
						236,
						439,
						440,
						470,
						500,
						510
					],
					"projections_orig": [
						"236",
						"439",
						"440",
						"470",
						"500",
						"510"
					],
					"projections_percentage": [
						-46.24,
						0,
						0.23,
						7.06,
						13.9,
						16.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1065
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 18
					},
					"classroomspace": 2.95,
					"enrolment": 634,
					"ligo": 0.75,
					"location": [
						151.099026028474,
						-33.8775813593982
					],
					"name": "Burwood Public School",
					"playspace": 18.55,
					"projections": [
						595,
						634,
						845,
						1080,
						1245,
						1380
					],
					"projections_orig": [
						"595",
						"634",
						"845",
						"1080",
						"1245",
						"1380"
					],
					"projections_percentage": [
						-6.15,
						0,
						33.28,
						70.35,
						96.37,
						117.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1455
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.36,
					"enrolment": 280,
					"ligo": 0.5,
					"location": [
						151.093754960803,
						-33.8888615258936
					],
					"name": "Enfield Public School",
					"playspace": 30.99,
					"projections": [
						273,
						280,
						360,
						390,
						415,
						430
					],
					"projections_orig": [
						"273",
						"280",
						"360",
						"390",
						"415",
						"430"
					],
					"projections_percentage": [
						-2.5,
						0,
						28.57,
						39.29,
						48.21,
						53.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1844
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 3.43,
					"enrolment": 451,
					"ligo": 0.54,
					"location": [
						151.0847963428,
						-33.8673864484321
					],
					"name": "Homebush Public School",
					"playspace": 9.47,
					"projections": [
						462,
						451,
						565,
						765,
						950,
						1015
					],
					"projections_orig": [
						"462",
						"451",
						"565",
						"765",
						"950",
						"1015"
					],
					"projections_percentage": [
						2.44,
						0,
						25.28,
						69.62,
						110.64,
						125.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2173
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 31
					},
					"classroomspace": 2.54,
					"enrolment": 800,
					"ligo": 0.47,
					"location": [
						151.085322805185,
						-33.8907762819474
					],
					"name": "Strathfield South Public School",
					"playspace": 17.86,
					"projections": [
						808,
						800,
						955,
						1060,
						1095,
						1125
					],
					"projections_orig": [
						"808",
						"800",
						"955",
						"1060",
						"1095",
						"1125"
					],
					"projections_percentage": [
						1,
						0,
						19.38,
						32.5,
						36.88,
						40.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3124
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.41,
					"enrolment": 322,
					"ligo": 0.64,
					"location": [
						151.078599736164,
						-33.8749092612902
					],
					"name": "Marie Bashir Public School",
					"playspace": 26.69,
					"projections": [
						0,
						322,
						580,
						655,
						680,
						695
					],
					"projections_orig": [
						"0",
						"322",
						"580",
						"655",
						"680",
						"695"
					],
					"projections_percentage": [
						-100,
						0,
						80.12,
						103.42,
						111.18,
						115.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4652
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 10
					},
					"classroomspace": 2.67,
					"enrolment": 552,
					"ligo": 0.74,
					"location": [
						151.066334856928,
						-33.866204304963
					],
					"name": "Homebush West Public School",
					"playspace": 10.1,
					"projections": [
						389,
						552,
						630,
						790,
						905,
						960
					],
					"projections_orig": [
						"389",
						"552",
						"630",
						"790",
						"905",
						"960"
					],
					"projections_percentage": [
						-29.53,
						0,
						14.13,
						43.12,
						63.95,
						73.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5251
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 24
					},
					"classroomspace": 2.46,
					"enrolment": 695,
					"ligo": 0.78,
					"location": [
						151.115555015904,
						-33.8802211866954
					],
					"name": "Croydon Public School",
					"playspace": 18.71,
					"projections": [
						656,
						695,
						855,
						1015,
						1115,
						1160
					],
					"projections_orig": [
						"656",
						"695",
						"855",
						"1015",
						"1115",
						"1160"
					],
					"projections_percentage": [
						-5.61,
						0,
						23.02,
						46.04,
						60.43,
						66.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7411
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.1,
					"enrolment": 422,
					"ligo": 0.59,
					"location": [
						151.10861312836,
						-33.8941216856458
					],
					"name": "Croydon Park Public School",
					"playspace": 21.76,
					"projections": [
						367,
						422,
						475,
						505,
						540,
						555
					],
					"projections_orig": [
						"367",
						"422",
						"475",
						"505",
						"540",
						"555"
					],
					"projections_percentage": [
						-13.03,
						0,
						12.56,
						19.67,
						27.96,
						31.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7412
				}
			],
			"uid": 10022
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 97
			},
			"enrolment": 1910,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Concord Primary",
			"playspace": 95.96,
			"projections": [
				1910,
				2800,
				3370,
				4030,
				4390
			],
			"projections_percentage": [
				0,
				46.6,
				76.44,
				110.99,
				129.84
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.69,
					"enrolment": 280,
					"ligo": 0.63,
					"location": [
						151.106536361661,
						-33.8636648439982
					],
					"name": "Concord Public School",
					"playspace": 26.38,
					"projections": [
						246,
						280,
						345,
						405,
						440,
						455
					],
					"projections_orig": [
						"246",
						"280",
						"345",
						"405",
						"440",
						"455"
					],
					"projections_percentage": [
						-12.14,
						0,
						23.21,
						44.64,
						57.14,
						62.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1607
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 18
					},
					"classroomspace": 3.45,
					"enrolment": 382,
					"ligo": 0.59,
					"location": [
						151.08633141656,
						-33.8400710321112
					],
					"name": "Concord West Public School",
					"playspace": 22.05,
					"projections": [
						421,
						382,
						700,
						775,
						925,
						1050
					],
					"projections_orig": [
						"421",
						"382",
						"700",
						"775",
						"925",
						"1050"
					],
					"projections_percentage": [
						10.21,
						0,
						83.25,
						102.88,
						142.15,
						174.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1608
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 14
					},
					"classroomspace": 2.28,
					"enrolment": 411,
					"ligo": 0.84,
					"location": [
						151.103390472131,
						-33.8498291660043
					],
					"name": "Mortlake Public School",
					"playspace": 26.98,
					"projections": [
						346,
						411,
						465,
						535,
						595,
						620
					],
					"projections_orig": [
						"346",
						"411",
						"465",
						"535",
						"595",
						"620"
					],
					"projections_percentage": [
						-15.82,
						0,
						13.14,
						30.17,
						44.77,
						50.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2625
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 22
					},
					"classroomspace": 3.02,
					"enrolment": 599,
					"ligo": 0.62,
					"location": [
						151.092696722437,
						-33.8551117117025
					],
					"name": "Strathfield North Public School",
					"playspace": 14.97,
					"projections": [
						643,
						599,
						840,
						895,
						1020,
						1175
					],
					"projections_orig": [
						"643",
						"599",
						"840",
						"895",
						"1020",
						"1175"
					],
					"projections_percentage": [
						7.35,
						0,
						40.23,
						49.42,
						70.28,
						96.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3123
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 7.08,
					"enrolment": 238,
					"ligo": 0.66,
					"location": [
						151.082650235778,
						-33.8488329168886
					],
					"name": "Victoria Avenue Public School",
					"playspace": 389.44,
					"projections": [
						0,
						238,
						450,
						760,
						1050,
						1090
					],
					"projections_orig": [
						"0",
						"238",
						"450",
						"760",
						"1050",
						"1090"
					],
					"projections_percentage": [
						-100,
						0,
						89.08,
						219.33,
						341.18,
						357.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4655
				}
			],
			"uid": 10023
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 175
			},
			"enrolment": 3850,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Canterbury Primary",
			"playspace": 36.88,
			"projections": [
				3850,
				4450,
				5165,
				5690,
				5980
			],
			"projections_percentage": [
				0,
				15.58,
				34.16,
				47.79,
				55.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.14,
					"enrolment": 372,
					"ligo": 0.63,
					"location": [
						151.119412032017,
						-33.8993827698717
					],
					"name": "Ashbury Public School",
					"playspace": 17.79,
					"projections": [
						383,
						372,
						415,
						500,
						535,
						550
					],
					"projections_orig": [
						"383",
						"372",
						"415",
						"500",
						"535",
						"550"
					],
					"projections_percentage": [
						2.96,
						0,
						11.56,
						34.41,
						43.82,
						47.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1064
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 32
					},
					"classroomspace": 2.06,
					"enrolment": 775,
					"ligo": 0.68,
					"location": [
						151.10460939895,
						-33.9121608958901
					],
					"name": "Campsie Public School",
					"playspace": 4.81,
					"projections": [
						689,
						775,
						870,
						1065,
						1195,
						1250
					],
					"projections_orig": [
						"689",
						"775",
						"870",
						"1065",
						"1195",
						"1250"
					],
					"projections_percentage": [
						-11.1,
						0,
						12.26,
						37.42,
						54.19,
						61.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1488
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.46,
					"enrolment": 324,
					"ligo": 0.6,
					"location": [
						151.122951004063,
						-33.9092569466019
					],
					"name": "Canterbury Public School",
					"playspace": 46.23,
					"projections": [
						257,
						324,
						350,
						450,
						525,
						545
					],
					"projections_orig": [
						"257",
						"324",
						"350",
						"450",
						"525",
						"545"
					],
					"projections_percentage": [
						-20.68,
						0,
						8.02,
						38.89,
						62.04,
						68.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1497
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 25
					},
					"classroomspace": 2.75,
					"enrolment": 589,
					"ligo": 0.7,
					"location": [
						151.10904147734,
						-33.9290649356982
					],
					"name": "Clemton Park Public School",
					"playspace": 28.03,
					"projections": [
						612,
						589,
						725,
						795,
						860,
						890
					],
					"projections_orig": [
						"612",
						"589",
						"725",
						"795",
						"860",
						"890"
					],
					"projections_percentage": [
						3.9,
						0,
						23.09,
						34.97,
						46.01,
						51.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1566
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 2.33,
					"enrolment": 661,
					"ligo": 0.47,
					"location": [
						151.123260290432,
						-33.9288031807345
					],
					"name": "Earlwood Public School",
					"playspace": 20.69,
					"projections": [
						630,
						661,
						750,
						820,
						895,
						935
					],
					"projections_orig": [
						"630",
						"661",
						"750",
						"820",
						"895",
						"935"
					],
					"projections_percentage": [
						-4.69,
						0,
						13.46,
						24.05,
						35.4,
						41.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1807
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.07,
					"enrolment": 220,
					"ligo": 0.69,
					"location": [
						151.138890555506,
						-33.9245938640605
					],
					"name": "Undercliffe Public School",
					"playspace": 15.64,
					"projections": [
						155,
						220,
						245,
						270,
						295,
						315
					],
					"projections_orig": [
						"155",
						"220",
						"245",
						"270",
						"295",
						"315"
					],
					"projections_percentage": [
						-29.55,
						0,
						11.36,
						22.73,
						34.09,
						43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3310
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.63,
					"enrolment": 283,
					"ligo": 0.71,
					"location": [
						151.116231011291,
						-33.9173671688228
					],
					"name": "Canterbury South Public School",
					"playspace": 43.76,
					"projections": [
						192,
						283,
						320,
						345,
						375,
						400
					],
					"projections_orig": [
						"192",
						"283",
						"320",
						"345",
						"375",
						"400"
					],
					"projections_percentage": [
						-32.16,
						0,
						13.07,
						21.91,
						32.51,
						41.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5109
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 3.06,
					"enrolment": 566,
					"ligo": 0.65,
					"location": [
						151.095124890015,
						-33.90920849144
					],
					"name": "Harcourt Public School",
					"playspace": 20.96,
					"projections": [
						612,
						566,
						685,
						825,
						910,
						995
					],
					"projections_orig": [
						"612",
						"566",
						"685",
						"825",
						"910",
						"995"
					],
					"projections_percentage": [
						8.13,
						0,
						21.02,
						45.76,
						60.78,
						75.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5118
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.31,
					"enrolment": 60,
					"ligo": 1,
					"location": [
						151.129611642504,
						-33.9022432879165
					],
					"name": "Yeo Park Infants School",
					"playspace": 134,
					"projections": [
						81,
						60,
						90,
						95,
						100,
						100
					],
					"projections_orig": [
						"81",
						"60",
						"90",
						"95",
						"100",
						"100"
					],
					"projections_percentage": [
						35,
						0,
						50,
						58.33,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5120
				}
			],
			"uid": 10024
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 88
			},
			"enrolment": 2682,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Middle Harbour Primary",
			"playspace": 10.42,
			"projections": [
				2682,
				2705,
				2630,
				2610,
				2630
			],
			"projections_percentage": [
				0,
				0.86,
				-1.94,
				-2.68,
				-1.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 21
					},
					"classroomspace": 2.17,
					"enrolment": 655,
					"ligo": 0.73,
					"location": [
						151.231905591634,
						-33.8232263713789
					],
					"name": "Middle Harbour Public School",
					"playspace": 10.18,
					"projections": [
						519,
						655,
						635,
						615,
						610,
						615
					],
					"projections_orig": [
						"519",
						"655",
						"635",
						"615",
						"610",
						"615"
					],
					"projections_percentage": [
						-20.76,
						0,
						-3.05,
						-6.11,
						-6.87,
						-6.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2543
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 33
					},
					"classroomspace": 2.14,
					"enrolment": 995,
					"ligo": 0.73,
					"location": [
						151.21922157852,
						-33.8324876907797
					],
					"name": "Neutral Bay Public School",
					"playspace": 4.56,
					"projections": [
						845,
						995,
						985,
						970,
						970,
						985
					],
					"projections_orig": [
						"845",
						"995",
						"985",
						"970",
						"970",
						"985"
					],
					"projections_percentage": [
						-15.08,
						0,
						-1.01,
						-2.51,
						-2.51,
						-1.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2730
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 5
					},
					"classroomspace": 3.02,
					"enrolment": 313,
					"ligo": 0.71,
					"location": [
						151.242786626574,
						-33.8119567926538
					],
					"name": "Beauty Point Public School",
					"playspace": 18.12,
					"projections": [
						271,
						313,
						330,
						320,
						315,
						315
					],
					"projections_orig": [
						"271",
						"313",
						"330",
						"320",
						"315",
						"315"
					],
					"projections_percentage": [
						-13.42,
						0,
						5.43,
						2.24,
						0.64,
						0.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5212
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 2.48,
					"enrolment": 719,
					"ligo": 0.86,
					"location": [
						151.240738170793,
						-33.8275977069646
					],
					"name": "Mosman Public School",
					"playspace": 8.8,
					"projections": [
						695,
						719,
						755,
						725,
						715,
						715
					],
					"projections_orig": [
						"695",
						"719",
						"755",
						"725",
						"715",
						"715"
					],
					"projections_percentage": [
						-3.34,
						0,
						5.01,
						0.83,
						-0.56,
						-0.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7430
				}
			],
			"uid": 10025
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 95
			},
			"enrolment": 2817,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Lane Cove Primary",
			"playspace": 20.59,
			"projections": [
				2817,
				3145,
				3320,
				3520,
				3700
			],
			"projections_percentage": [
				0,
				11.64,
				17.86,
				24.96,
				31.35
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 10
					},
					"classroomspace": 2.94,
					"enrolment": 486,
					"ligo": 0.76,
					"location": [
						151.183355706403,
						-33.8257287627576
					],
					"name": "Greenwich Public School",
					"playspace": 39.47,
					"projections": [
						432,
						486,
						595,
						605,
						635,
						680
					],
					"projections_orig": [
						"432",
						"486",
						"595",
						"605",
						"635",
						"680"
					],
					"projections_percentage": [
						-11.11,
						0,
						22.43,
						24.49,
						30.66,
						39.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2076
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 37
					},
					"classroomspace": 2.41,
					"enrolment": 851,
					"ligo": 0.83,
					"location": [
						151.169114562966,
						-33.8158164070545
					],
					"name": "Lane Cove Public School",
					"playspace": 14.45,
					"projections": [
						815,
						851,
						965,
						995,
						1040,
						1085
					],
					"projections_orig": [
						"815",
						"851",
						"965",
						"995",
						"1040",
						"1085"
					],
					"projections_percentage": [
						-4.23,
						0,
						13.4,
						16.92,
						22.21,
						27.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2368
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 29
					},
					"classroomspace": 1.91,
					"enrolment": 894,
					"ligo": 0.86,
					"location": [
						151.202417879362,
						-33.8346858680164
					],
					"name": "North Sydney Public School",
					"playspace": 13.38,
					"projections": [
						709,
						894,
						940,
						1055,
						1145,
						1180
					],
					"projections_orig": [
						"709",
						"894",
						"940",
						"1055",
						"1145",
						"1180"
					],
					"projections_percentage": [
						-20.69,
						0,
						5.15,
						18.01,
						28.08,
						31.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2766
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 19
					},
					"classroomspace": 2.39,
					"enrolment": 586,
					"ligo": 0.6,
					"location": [
						151.151472732228,
						-33.8100777932264
					],
					"name": "Lane Cove West Public School",
					"playspace": 15.05,
					"projections": [
						533,
						586,
						645,
						665,
						700,
						755
					],
					"projections_orig": [
						"533",
						"586",
						"645",
						"665",
						"700",
						"755"
					],
					"projections_percentage": [
						-9.04,
						0,
						10.07,
						13.48,
						19.45,
						28.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3908
				}
			],
			"uid": 10026
		},
		{
			"classrooms": {
				"demountable": 73,
				"permanent": 356
			},
			"enrolment": 9213,
			"level": "Primary",
			"ligo": 0.85,
			"name": "Chatswood Primary",
			"playspace": 18.66,
			"projections": [
				9213,
				10050,
				10305,
				10585,
				10945
			],
			"projections_percentage": [
				0,
				9.08,
				11.85,
				14.89,
				18.8
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 35
					},
					"classroomspace": 2.58,
					"enrolment": 1145,
					"ligo": 0.8,
					"location": [
						151.185863931389,
						-33.8107887531249
					],
					"name": "Artarmon Public School",
					"playspace": 5.5,
					"projections": [
						858,
						1145,
						1205,
						1220,
						1245,
						1280
					],
					"projections_orig": [
						"858",
						"1145",
						"1205",
						"1220",
						"1245",
						"1280"
					],
					"projections_percentage": [
						-25.07,
						0,
						5.24,
						6.55,
						8.73,
						11.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1061
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 27
					},
					"classroomspace": 2.35,
					"enrolment": 935,
					"ligo": 0.84,
					"location": [
						151.21181143356,
						-33.821205875267
					],
					"name": "Cammeray Public School",
					"playspace": 7.7,
					"projections": [
						767,
						935,
						710,
						690,
						705,
						740
					],
					"projections_orig": [
						"767",
						"935",
						"710",
						"690",
						"705",
						"740"
					],
					"projections_percentage": [
						-17.97,
						0,
						-24.06,
						-26.2,
						-24.6,
						-20.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1485
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.42,
					"enrolment": 765,
					"ligo": 0.8,
					"location": [
						151.169423327822,
						-33.7805072907259
					],
					"name": "Lindfield Public School",
					"playspace": 14.11,
					"projections": [
						729,
						765,
						835,
						875,
						895,
						920
					],
					"projections_orig": [
						"729",
						"765",
						"835",
						"875",
						"895",
						"920"
					],
					"projections_percentage": [
						-4.71,
						0,
						9.15,
						14.38,
						16.99,
						20.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2403
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 2.38,
					"enrolment": 722,
					"ligo": 0.78,
					"location": [
						151.18455170918,
						-33.7680569621218
					],
					"name": "Lindfield East Public School",
					"playspace": 24.58,
					"projections": [
						738,
						722,
						860,
						880,
						885,
						900
					],
					"projections_orig": [
						"738",
						"722",
						"860",
						"880",
						"885",
						"900"
					],
					"projections_percentage": [
						2.22,
						0,
						19.11,
						21.88,
						22.58,
						24.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2404
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 18
					},
					"classroomspace": 2.44,
					"enrolment": 540,
					"ligo": 0.84,
					"location": [
						151.219018365301,
						-33.8121990897143
					],
					"name": "Northbridge Public School",
					"playspace": 11.76,
					"projections": [
						535,
						540,
						575,
						590,
						605,
						630
					],
					"projections_orig": [
						"535",
						"540",
						"575",
						"590",
						"605",
						"630"
					],
					"projections_percentage": [
						-0.93,
						0,
						6.48,
						9.26,
						12.04,
						16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2761
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 2.59,
					"enrolment": 615,
					"ligo": 0.92,
					"location": [
						151.18852927863,
						-33.7815218655458
					],
					"name": "Roseville Public School",
					"playspace": 13.65,
					"projections": [
						568,
						615,
						735,
						745,
						760,
						785
					],
					"projections_orig": [
						"568",
						"615",
						"735",
						"745",
						"760",
						"785"
					],
					"projections_percentage": [
						-7.64,
						0,
						19.51,
						21.14,
						23.58,
						27.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2994
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 34
					},
					"classroomspace": 2.44,
					"enrolment": 1085,
					"ligo": 0.92,
					"location": [
						151.200784769196,
						-33.8018810533138
					],
					"name": "Willoughby Public School",
					"playspace": 8.16,
					"projections": [
						939,
						1085,
						1225,
						1255,
						1295,
						1345
					],
					"projections_orig": [
						"939",
						"1085",
						"1225",
						"1255",
						"1295",
						"1345"
					],
					"projections_percentage": [
						-13.46,
						0,
						12.9,
						15.67,
						19.35,
						23.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3449
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 11
					},
					"classroomspace": 2.64,
					"enrolment": 446,
					"ligo": 0.79,
					"location": [
						151.148832520504,
						-33.7658255351927
					],
					"name": "Killara Public School",
					"playspace": 21.98,
					"projections": [
						282,
						446,
						430,
						470,
						485,
						485
					],
					"projections_orig": [
						"282",
						"446",
						"430",
						"470",
						"485",
						"485"
					],
					"projections_percentage": [
						-36.77,
						0,
						-3.59,
						5.38,
						8.74,
						8.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3918
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 2.77,
					"enrolment": 471,
					"ligo": 0.79,
					"location": [
						151.202378147964,
						-33.7831699555336
					],
					"name": "Castle Cove Public School",
					"playspace": 31.59,
					"projections": [
						465,
						471,
						565,
						575,
						585,
						605
					],
					"projections_orig": [
						"465",
						"471",
						"565",
						"575",
						"585",
						"605"
					],
					"projections_percentage": [
						-1.27,
						0,
						19.96,
						22.08,
						24.2,
						28.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3919
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 2.82,
					"enrolment": 415,
					"ligo": 0.83,
					"location": [
						151.145694284021,
						-33.7749000338003
					],
					"name": "Beaumont Road Public School",
					"playspace": 33.98,
					"projections": [
						372,
						415,
						465,
						480,
						490,
						495
					],
					"projections_orig": [
						"372",
						"415",
						"465",
						"480",
						"490",
						"495"
					],
					"projections_percentage": [
						-10.36,
						0,
						12.05,
						15.66,
						18.07,
						19.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3956
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 4.41,
					"enrolment": 511,
					"ligo": 0.7,
					"location": [
						151.154788425904,
						-33.8043293941286
					],
					"name": "Mowbray Public School",
					"playspace": 49.62,
					"projections": [
						327,
						511,
						505,
						525,
						550,
						580
					],
					"projections_orig": [
						"327",
						"511",
						"505",
						"525",
						"550",
						"580"
					],
					"projections_percentage": [
						-36.01,
						0,
						-1.17,
						2.74,
						7.63,
						13.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4015
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 41
					},
					"classroomspace": 7.57,
					"enrolment": 317,
					"ligo": 0.85,
					"location": [
						151.2099198,
						-33.8261132
					],
					"name": "Anzac Park Public School",
					"playspace": 17.03,
					"projections": [
						0,
						317,
						720,
						760,
						800,
						855
					],
					"projections_orig": [
						"0",
						"317",
						"720",
						"760",
						"800",
						"855"
					],
					"projections_percentage": [
						-100,
						0,
						127.13,
						139.75,
						152.37,
						169.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4656
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						151.154788425904,
						-33.8043293941286
					],
					"name": "Lindfield Learning Village",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4658
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 33
					},
					"classroomspace": 2.4,
					"enrolment": 1246,
					"ligo": 0.87,
					"location": [
						151.178171883234,
						-33.797784835502
					],
					"name": "Chatswood Public School",
					"playspace": 2.88,
					"projections": [
						823,
						1246,
						1220,
						1240,
						1285,
						1325
					],
					"projections_orig": [
						"823",
						"1246",
						"1220",
						"1240",
						"1285",
						"1325"
					],
					"projections_percentage": [
						-33.95,
						0,
						-2.09,
						-0.48,
						3.13,
						6.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7409
				}
			],
			"uid": 10027
		},
		{
			"classrooms": {
				"demountable": 35,
				"permanent": 210
			},
			"enrolment": 5386,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Ryde Primary",
			"playspace": 30.76,
			"projections": [
				5386,
				5805,
				6385,
				6620,
				6745
			],
			"projections_percentage": [
				0,
				7.78,
				18.55,
				22.91,
				25.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 18
					},
					"classroomspace": 2.46,
					"enrolment": 518,
					"ligo": 0.74,
					"location": [
						151.13590060927,
						-33.8219285536797
					],
					"name": "Boronia Park Public School",
					"playspace": 11.26,
					"projections": [
						392,
						518,
						520,
						555,
						565,
						570
					],
					"projections_orig": [
						"392",
						"518",
						"520",
						"555",
						"565",
						"570"
					],
					"projections_percentage": [
						-24.32,
						0,
						0.39,
						7.14,
						9.07,
						10.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1320
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.48,
					"enrolment": 368,
					"ligo": 0.8,
					"location": [
						151.150881180823,
						-33.8356581387433
					],
					"name": "Hunters Hill Public School",
					"playspace": 16.78,
					"projections": [
						360,
						368,
						370,
						380,
						385,
						385
					],
					"projections_orig": [
						"360",
						"368",
						"370",
						"380",
						"385",
						"385"
					],
					"projections_percentage": [
						-2.17,
						0,
						0.54,
						3.26,
						4.62,
						4.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2189
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 3.25,
					"enrolment": 579,
					"ligo": 0.61,
					"location": [
						151.106515554485,
						-33.8133355488522
					],
					"name": "Ryde Public School",
					"playspace": 39.94,
					"projections": [
						430,
						579,
						625,
						680,
						705,
						720
					],
					"projections_orig": [
						"430",
						"579",
						"625",
						"680",
						"705",
						"720"
					],
					"projections_percentage": [
						-25.73,
						0,
						7.94,
						17.44,
						21.76,
						24.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3021
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 15
					},
					"classroomspace": 2.75,
					"enrolment": 384,
					"ligo": 0.7,
					"location": [
						151.120764622388,
						-33.7941009237394
					],
					"name": "North Ryde Public School",
					"playspace": 56.18,
					"projections": [
						264,
						384,
						360,
						410,
						420,
						425
					],
					"projections_orig": [
						"264",
						"384",
						"360",
						"410",
						"420",
						"425"
					],
					"projections_percentage": [
						-31.25,
						0,
						-6.25,
						6.77,
						9.38,
						10.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3022
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 29
					},
					"classroomspace": 3.09,
					"enrolment": 756,
					"ligo": 0.72,
					"location": [
						151.096094522173,
						-33.7935228065192
					],
					"name": "Denistone East Public School",
					"playspace": 16.89,
					"projections": [
						838,
						756,
						900,
						960,
						990,
						1005
					],
					"projections_orig": [
						"838",
						"756",
						"900",
						"960",
						"990",
						"1005"
					],
					"projections_percentage": [
						10.85,
						0,
						19.05,
						26.98,
						30.95,
						32.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3862
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 15
					},
					"classroomspace": 2.75,
					"enrolment": 484,
					"ligo": 0.75,
					"location": [
						151.095549276911,
						-33.78116460338
					],
					"name": "Eastwood Heights Public School",
					"playspace": 28.02,
					"projections": [
						332,
						484,
						525,
						550,
						555,
						560
					],
					"projections_orig": [
						"332",
						"484",
						"525",
						"550",
						"555",
						"560"
					],
					"projections_percentage": [
						-31.4,
						0,
						8.47,
						13.64,
						14.67,
						15.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4041
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 16
					},
					"classroomspace": 3,
					"enrolment": 637,
					"ligo": 0.6,
					"location": [
						151.10984641685,
						-33.7868451851011
					],
					"name": "Kent Road Public School",
					"playspace": 49.58,
					"projections": [
						338,
						637,
						645,
						740,
						815,
						895
					],
					"projections_orig": [
						"338",
						"637",
						"645",
						"740",
						"815",
						"895"
					],
					"projections_percentage": [
						-46.94,
						0,
						1.26,
						16.17,
						27.94,
						40.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4160
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.09,
					"enrolment": 325,
					"ligo": 0.48,
					"location": [
						151.130029829195,
						-33.7948034958414
					],
					"name": "Truscott Street Public School",
					"playspace": 29.02,
					"projections": [
						290,
						325,
						410,
						535,
						560,
						545
					],
					"projections_orig": [
						"290",
						"325",
						"410",
						"535",
						"560",
						"545"
					],
					"projections_percentage": [
						-10.77,
						0,
						26.15,
						64.62,
						72.31,
						67.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4164
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.44,
					"enrolment": 512,
					"ligo": 0.64,
					"location": [
						151.126891601742,
						-33.8062784497401
					],
					"name": "Ryde East Public School",
					"playspace": 49.98,
					"projections": [
						435,
						512,
						555,
						575,
						585,
						595
					],
					"projections_orig": [
						"435",
						"512",
						"555",
						"575",
						"585",
						"595"
					],
					"projections_percentage": [
						-15.04,
						0,
						8.4,
						12.3,
						14.26,
						16.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4257
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 30
					},
					"classroomspace": 2.34,
					"enrolment": 823,
					"ligo": 0.61,
					"location": [
						151.078710289919,
						-33.7931616478117
					],
					"name": "Eastwood Public School",
					"playspace": 9.94,
					"projections": [
						706,
						823,
						895,
						1000,
						1040,
						1045
					],
					"projections_orig": [
						"706",
						"823",
						"895",
						"1000",
						"1040",
						"1045"
					],
					"projections_percentage": [
						-14.22,
						0,
						8.75,
						21.51,
						26.37,
						26.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7416
				}
			],
			"uid": 10028
		},
		{
			"classrooms": {
				"demountable": 29,
				"permanent": 92
			},
			"enrolment": 2720,
			"level": "Primary",
			"ligo": 0.65,
			"name": "West Ryde Primary",
			"playspace": 49.16,
			"projections": [
				2720,
				2995,
				3260,
				3440,
				3560
			],
			"projections_percentage": [
				0,
				10.11,
				19.85,
				26.47,
				30.88
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 14
					},
					"classroomspace": 2.46,
					"enrolment": 441,
					"ligo": 0.51,
					"location": [
						151.070149735628,
						-33.8051961967448
					],
					"name": "Ermington Public School",
					"playspace": 32.75,
					"projections": [
						450,
						441,
						500,
						540,
						570,
						595
					],
					"projections_orig": [
						"450",
						"441",
						"500",
						"540",
						"570",
						"595"
					],
					"projections_percentage": [
						2.04,
						0,
						13.38,
						22.45,
						29.25,
						34.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1860
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.25,
					"enrolment": 521,
					"ligo": 0.76,
					"location": [
						151.125687585928,
						-33.8324671161413
					],
					"name": "Gladesville Public School",
					"playspace": 40.91,
					"projections": [
						447,
						521,
						590,
						645,
						655,
						655
					],
					"projections_orig": [
						"447",
						"521",
						"590",
						"645",
						"655",
						"655"
					],
					"projections_percentage": [
						-14.2,
						0,
						13.24,
						23.8,
						25.72,
						25.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1990
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.46,
					"enrolment": 466,
					"ligo": 0.78,
					"location": [
						151.110673319372,
						-33.8251000827941
					],
					"name": "Putney Public School",
					"playspace": 20.59,
					"projections": [
						445,
						466,
						610,
						665,
						700,
						715
					],
					"projections_orig": [
						"445",
						"466",
						"610",
						"665",
						"700",
						"715"
					],
					"projections_percentage": [
						-4.51,
						0,
						30.9,
						42.7,
						50.21,
						53.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2913
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 18
					},
					"classroomspace": 2.56,
					"enrolment": 605,
					"ligo": 0.85,
					"location": [
						151.084501603473,
						-33.8087597143442
					],
					"name": "West Ryde Public School",
					"playspace": 10.39,
					"projections": [
						307,
						605,
						505,
						540,
						575,
						605
					],
					"projections_orig": [
						"307",
						"605",
						"505",
						"540",
						"575",
						"605"
					],
					"projections_percentage": [
						-49.26,
						0,
						-16.53,
						-10.74,
						-4.96,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3023
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.48,
					"enrolment": 202,
					"ligo": 0.35,
					"location": [
						151.072600624564,
						-33.8153186631846
					],
					"name": "Melrose Park Public School",
					"playspace": 103.33,
					"projections": [
						136,
						202,
						210,
						235,
						260,
						280
					],
					"projections_orig": [
						"136",
						"202",
						"210",
						"235",
						"260",
						"280"
					],
					"projections_percentage": [
						-32.67,
						0,
						3.96,
						16.34,
						28.71,
						38.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3846
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 7
					},
					"classroomspace": 2.52,
					"enrolment": 309,
					"ligo": 0.72,
					"location": [
						151.097909114046,
						-33.8173353790618
					],
					"name": "Meadowbank Public School",
					"playspace": 19.61,
					"projections": [
						173,
						309,
						360,
						390,
						410,
						425
					],
					"projections_orig": [
						"173",
						"309",
						"360",
						"390",
						"410",
						"425"
					],
					"projections_percentage": [
						-44.01,
						0,
						16.5,
						26.21,
						32.69,
						37.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3863
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.86,
					"enrolment": 176,
					"ligo": 0.61,
					"location": [
						151.058174058618,
						-33.816333332384
					],
					"name": "Rydalmere East Public School",
					"playspace": 116.53,
					"projections": [
						191,
						176,
						220,
						245,
						270,
						285
					],
					"projections_orig": [
						"191",
						"176",
						"220",
						"245",
						"270",
						"285"
					],
					"projections_percentage": [
						8.52,
						0,
						25,
						39.2,
						53.41,
						61.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4123
				}
			],
			"uid": 10029
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 129
			},
			"enrolment": 3125,
			"level": "Primary",
			"ligo": 0.56,
			"name": "Belrose Primary",
			"playspace": 52.22,
			"projections": [
				3125,
				3125,
				3245,
				3410,
				3425
			],
			"projections_percentage": [
				0,
				0,
				3.84,
				9.12,
				9.6
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.14,
					"enrolment": 298,
					"ligo": 0.63,
					"location": [
						151.224771183444,
						-33.7514466987687
					],
					"name": "Frenchs Forest Public School",
					"playspace": 56.87,
					"projections": [
						253,
						298,
						315,
						340,
						370,
						370
					],
					"projections_orig": [
						"253",
						"298",
						"315",
						"340",
						"370",
						"370"
					],
					"projections_percentage": [
						-15.1,
						0,
						5.7,
						14.09,
						24.16,
						24.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1946
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.09,
					"enrolment": 307,
					"ligo": 0.63,
					"location": [
						151.215087766293,
						-33.7274235908926
					],
					"name": "Belrose Public School",
					"playspace": 95.65,
					"projections": [
						308,
						307,
						325,
						345,
						365,
						370
					],
					"projections_orig": [
						"308",
						"307",
						"325",
						"345",
						"365",
						"370"
					],
					"projections_percentage": [
						0.33,
						0,
						5.86,
						12.38,
						18.89,
						20.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3748
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 21
					},
					"classroomspace": 2.71,
					"enrolment": 718,
					"ligo": 0.65,
					"location": [
						151.213971899983,
						-33.7619119298215
					],
					"name": "Forestville Public School",
					"playspace": 24.3,
					"projections": [
						592,
						718,
						705,
						725,
						750,
						750
					],
					"projections_orig": [
						"592",
						"718",
						"705",
						"725",
						"750",
						"750"
					],
					"projections_percentage": [
						-17.55,
						0,
						-1.81,
						0.97,
						4.46,
						4.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4019
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.49,
					"enrolment": 355,
					"ligo": 0.61,
					"location": [
						151.217892712114,
						-33.7393899938916
					],
					"name": "Wakehurst Public School",
					"playspace": 46.94,
					"projections": [
						348,
						355,
						380,
						410,
						440,
						440
					],
					"projections_orig": [
						"348",
						"355",
						"380",
						"410",
						"440",
						"440"
					],
					"projections_percentage": [
						-1.97,
						0,
						7.04,
						15.49,
						23.94,
						23.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4368
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 24
					},
					"classroomspace": 2.84,
					"enrolment": 702,
					"ligo": 0.52,
					"location": [
						151.216702245381,
						-33.7752141995901
					],
					"name": "Killarney Heights Public School",
					"playspace": 27.35,
					"projections": [
						593,
						702,
						690,
						695,
						700,
						700
					],
					"projections_orig": [
						"593",
						"702",
						"690",
						"695",
						"700",
						"700"
					],
					"projections_percentage": [
						-15.53,
						0,
						-1.71,
						-1,
						-0.28,
						-0.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4386
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.19,
					"enrolment": 527,
					"ligo": 0.45,
					"location": [
						151.204278052258,
						-33.7434309013953
					],
					"name": "Mimosa Public School",
					"playspace": 26.88,
					"projections": [
						432,
						527,
						510,
						520,
						565,
						575
					],
					"projections_orig": [
						"432",
						"527",
						"510",
						"520",
						"565",
						"575"
					],
					"projections_percentage": [
						-18.03,
						0,
						-3.23,
						-1.33,
						7.21,
						9.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4432
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.62,
					"enrolment": 218,
					"ligo": 0.43,
					"location": [
						151.195129012632,
						-33.7405979548407
					],
					"name": "Kambora Public School",
					"playspace": 87.53,
					"projections": [
						187,
						218,
						200,
						210,
						220,
						220
					],
					"projections_orig": [
						"187",
						"218",
						"200",
						"210",
						"220",
						"220"
					],
					"projections_percentage": [
						-14.22,
						0,
						-8.26,
						-3.67,
						0.92,
						0.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4515
				}
			],
			"uid": 10030
		},
		{
			"classrooms": {
				"demountable": 40,
				"permanent": 194
			},
			"enrolment": 5668,
			"level": "Primary",
			"ligo": 0.73,
			"name": "St Ives Primary",
			"playspace": 43.25,
			"projections": [
				5668,
				6165,
				6350,
				6490,
				6630
			],
			"projections_percentage": [
				0,
				8.77,
				12.03,
				14.5,
				16.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.7,
					"enrolment": 301,
					"ligo": 0.64,
					"location": [
						151.146848446957,
						-33.7146239655849
					],
					"name": "Turramurra North Public School",
					"playspace": 58.68,
					"projections": [
						286,
						301,
						350,
						355,
						365,
						375
					],
					"projections_orig": [
						"286",
						"301",
						"350",
						"355",
						"365",
						"375"
					],
					"projections_percentage": [
						-4.98,
						0,
						16.28,
						17.94,
						21.26,
						24.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3288
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 21
					},
					"classroomspace": 2.84,
					"enrolment": 594,
					"ligo": 0.7,
					"location": [
						151.121522061708,
						-33.7289740309048
					],
					"name": "Warrawee Public School",
					"playspace": 28.5,
					"projections": [
						583,
						594,
						670,
						695,
						705,
						710
					],
					"projections_orig": [
						"583",
						"594",
						"670",
						"695",
						"705",
						"710"
					],
					"projections_percentage": [
						-1.85,
						0,
						12.79,
						17,
						18.69,
						19.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3390
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 2.48,
					"enrolment": 663,
					"ligo": 0.78,
					"location": [
						151.141160506084,
						-33.7317076369474
					],
					"name": "Pymble Public School",
					"playspace": 14.11,
					"projections": [
						569,
						663,
						695,
						710,
						730,
						750
					],
					"projections_orig": [
						"569",
						"663",
						"695",
						"710",
						"730",
						"750"
					],
					"projections_percentage": [
						-14.18,
						0,
						4.83,
						7.09,
						10.11,
						13.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3777
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 2.55,
					"enrolment": 712,
					"ligo": 0.76,
					"location": [
						151.127267882141,
						-33.7145571340096
					],
					"name": "Wahroonga Public School",
					"playspace": 36.63,
					"projections": [
						685,
						712,
						800,
						830,
						850,
						855
					],
					"projections_orig": [
						"685",
						"712",
						"800",
						"830",
						"850",
						"855"
					],
					"projections_percentage": [
						-3.79,
						0,
						12.36,
						16.57,
						19.38,
						20.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3833
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 26
					},
					"classroomspace": 2.83,
					"enrolment": 577,
					"ligo": 0.83,
					"location": [
						151.113530426754,
						-33.7438716555798
					],
					"name": "Turramurra Public School",
					"playspace": 39.93,
					"projections": [
						476,
						577,
						605,
						615,
						625,
						645
					],
					"projections_orig": [
						"476",
						"577",
						"605",
						"615",
						"625",
						"645"
					],
					"projections_percentage": [
						-17.5,
						0,
						4.85,
						6.59,
						8.32,
						11.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3855
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.44,
					"enrolment": 572,
					"ligo": 0.77,
					"location": [
						151.139145621027,
						-33.7594866930365
					],
					"name": "Gordon West Public School",
					"playspace": 30.98,
					"projections": [
						503,
						572,
						650,
						680,
						695,
						710
					],
					"projections_orig": [
						"503",
						"572",
						"650",
						"680",
						"695",
						"710"
					],
					"projections_percentage": [
						-12.06,
						0,
						13.64,
						18.88,
						21.5,
						24.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3943
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 10
					},
					"classroomspace": 2.73,
					"enrolment": 335,
					"ligo": 0.72,
					"location": [
						151.157541578073,
						-33.7460699007841
					],
					"name": "Gordon East Public School",
					"playspace": 37.98,
					"projections": [
						321,
						335,
						395,
						420,
						425,
						430
					],
					"projections_orig": [
						"321",
						"335",
						"395",
						"420",
						"425",
						"430"
					],
					"projections_percentage": [
						-4.18,
						0,
						17.91,
						25.37,
						26.87,
						28.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3985
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.73,
					"enrolment": 343,
					"ligo": 0.68,
					"location": [
						151.123924576678,
						-33.7628973158596
					],
					"name": "West Pymble Public School",
					"playspace": 56.21,
					"projections": [
						287,
						343,
						355,
						365,
						375,
						385
					],
					"projections_orig": [
						"287",
						"343",
						"355",
						"365",
						"375",
						"385"
					],
					"projections_percentage": [
						-16.33,
						0,
						3.5,
						6.41,
						9.33,
						12.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4283
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 23
					},
					"classroomspace": 2.47,
					"enrolment": 899,
					"ligo": 0.76,
					"location": [
						151.162637933863,
						-33.7191629870251
					],
					"name": "St Ives North Public School",
					"playspace": 12.47,
					"projections": [
						685,
						899,
						950,
						955,
						975,
						1005
					],
					"projections_orig": [
						"685",
						"899",
						"950",
						"955",
						"975",
						"1005"
					],
					"projections_percentage": [
						-23.8,
						0,
						5.67,
						6.23,
						8.45,
						11.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4293
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 13
					},
					"classroomspace": 2.33,
					"enrolment": 487,
					"ligo": 0.73,
					"location": [
						151.165644886872,
						-33.7385294380491
					],
					"name": "St Ives Public School",
					"playspace": 28.05,
					"projections": [
						370,
						487,
						500,
						525,
						540,
						555
					],
					"projections_orig": [
						"370",
						"487",
						"500",
						"525",
						"540",
						"555"
					],
					"projections_percentage": [
						-24.02,
						0,
						2.67,
						7.8,
						10.88,
						13.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4331
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.35,
					"enrolment": 185,
					"ligo": 0.68,
					"location": [
						151.177926537855,
						-33.7243919512106
					],
					"name": "St Ives Park Public School",
					"playspace": 132.17,
					"projections": [
						169,
						185,
						195,
						200,
						205,
						210
					],
					"projections_orig": [
						"169",
						"185",
						"195",
						"200",
						"205",
						"210"
					],
					"projections_percentage": [
						-8.65,
						0,
						5.41,
						8.11,
						10.81,
						13.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4400
				}
			],
			"uid": 10031
		},
		{
			"classrooms": {
				"demountable": 64,
				"permanent": 286
			},
			"enrolment": 8418,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Dee Why Primary",
			"playspace": 27.64,
			"projections": [
				8418,
				8515,
				8665,
				8990,
				9205
			],
			"projections_percentage": [
				0,
				1.15,
				2.93,
				6.79,
				9.35
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.44,
					"enrolment": 400,
					"ligo": 0.85,
					"location": [
						151.285949424063,
						-33.7484188782483
					],
					"name": "Dee Why Public School",
					"playspace": 31.8,
					"projections": [
						219,
						400,
						365,
						365,
						370,
						370
					],
					"projections_orig": [
						"219",
						"400",
						"365",
						"365",
						"370",
						"370"
					],
					"projections_percentage": [
						-45.25,
						0,
						-8.75,
						-8.75,
						-7.5,
						-7.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1744
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 34
					},
					"classroomspace": 2.74,
					"enrolment": 1129,
					"ligo": 0.51,
					"location": [
						151.300000933268,
						-33.6774713530786
					],
					"name": "Mona Vale Public School",
					"playspace": 20.54,
					"projections": [
						883,
						1129,
						1145,
						1245,
						1355,
						1415
					],
					"projections_orig": [
						"883",
						"1129",
						"1145",
						"1245",
						"1355",
						"1415"
					],
					"projections_percentage": [
						-21.79,
						0,
						1.42,
						10.27,
						20.02,
						25.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2593
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 14
					},
					"classroomspace": 2.32,
					"enrolment": 440,
					"ligo": 0.68,
					"location": [
						151.297980011368,
						-33.7205876609439
					],
					"name": "Narrabeen Lakes Public School",
					"playspace": 10.74,
					"projections": [
						334,
						440,
						405,
						405,
						405,
						405
					],
					"projections_orig": [
						"334",
						"440",
						"405",
						"405",
						"405",
						"405"
					],
					"projections_percentage": [
						-24.09,
						0,
						-7.95,
						-7.95,
						-7.95,
						-7.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2706
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 26
					},
					"classroomspace": 2.75,
					"enrolment": 838,
					"ligo": 0.8,
					"location": [
						151.312778401982,
						-33.6611012167071
					],
					"name": "Newport Public School",
					"playspace": 12.14,
					"projections": [
						743,
						838,
						880,
						895,
						920,
						935
					],
					"projections_orig": [
						"743",
						"838",
						"880",
						"895",
						"920",
						"935"
					],
					"projections_percentage": [
						-11.34,
						0,
						5.01,
						6.8,
						9.79,
						11.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2740
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 33
					},
					"classroomspace": 2.37,
					"enrolment": 910,
					"ligo": 0.94,
					"location": [
						151.327180302895,
						-33.6397481348075
					],
					"name": "Avalon Public School",
					"playspace": 20.27,
					"projections": [
						894,
						910,
						930,
						935,
						970,
						995
					],
					"projections_orig": [
						"894",
						"910",
						"930",
						"935",
						"970",
						"995"
					],
					"projections_percentage": [
						-1.76,
						0,
						2.2,
						2.75,
						6.59,
						9.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3792
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.41,
					"enrolment": 491,
					"ligo": 0.52,
					"location": [
						151.273627522182,
						-33.7496860284521
					],
					"name": "Narraweena Public School",
					"playspace": 22.14,
					"projections": [
						326,
						491,
						430,
						430,
						430,
						430
					],
					"projections_orig": [
						"326",
						"491",
						"430",
						"430",
						"430",
						"430"
					],
					"projections_percentage": [
						-33.6,
						0,
						-12.42,
						-12.42,
						-12.42,
						-12.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3827
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 15
					},
					"classroomspace": 2.57,
					"enrolment": 664,
					"ligo": 0.83,
					"location": [
						151.29808031217,
						-33.6997695038372
					],
					"name": "Narrabeen North Public School",
					"playspace": 22.83,
					"projections": [
						495,
						664,
						665,
						685,
						695,
						700
					],
					"projections_orig": [
						"495",
						"664",
						"665",
						"685",
						"695",
						"700"
					],
					"projections_percentage": [
						-25.45,
						0,
						0.15,
						3.16,
						4.67,
						5.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3906
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 15
					},
					"classroomspace": 2.73,
					"enrolment": 633,
					"ligo": 0.69,
					"location": [
						151.292586652641,
						-33.7331379564161
					],
					"name": "Collaroy Plateau Public School",
					"playspace": 23.63,
					"projections": [
						566,
						633,
						645,
						640,
						640,
						640
					],
					"projections_orig": [
						"566",
						"633",
						"645",
						"640",
						"640",
						"640"
					],
					"projections_percentage": [
						-10.58,
						0,
						1.9,
						1.11,
						1.11,
						1.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3970
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 22
					},
					"classroomspace": 2.98,
					"enrolment": 592,
					"ligo": 0.61,
					"location": [
						151.259669127383,
						-33.7520951724615
					],
					"name": "Beacon Hill Public School",
					"playspace": 57.85,
					"projections": [
						605,
						592,
						645,
						665,
						690,
						685
					],
					"projections_orig": [
						"605",
						"592",
						"645",
						"665",
						"690",
						"685"
					],
					"projections_percentage": [
						2.2,
						0,
						8.95,
						12.33,
						16.55,
						15.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3971
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 21
					},
					"classroomspace": 2.48,
					"enrolment": 588,
					"ligo": 0.69,
					"location": [
						151.284517974012,
						-33.70406269759
					],
					"name": "Elanora Heights Public School",
					"playspace": 55.88,
					"projections": [
						546,
						588,
						565,
						545,
						630,
						725
					],
					"projections_orig": [
						"546",
						"588",
						"565",
						"545",
						"630",
						"725"
					],
					"projections_percentage": [
						-7.14,
						0,
						-3.91,
						-7.31,
						7.14,
						23.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4199
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 2.64,
					"enrolment": 724,
					"ligo": 0.7,
					"location": [
						151.273440809447,
						-33.7377392388515
					],
					"name": "Cromer Public School",
					"playspace": 21.65,
					"projections": [
						848,
						724,
						800,
						810,
						820,
						820
					],
					"projections_orig": [
						"848",
						"724",
						"800",
						"810",
						"820",
						"820"
					],
					"projections_percentage": [
						17.13,
						0,
						10.5,
						11.88,
						13.26,
						13.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4241
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.88,
					"enrolment": 498,
					"ligo": 0.64,
					"location": [
						151.286238645654,
						-33.7283494973938
					],
					"name": "Wheeler Heights Public School",
					"playspace": 37.44,
					"projections": [
						534,
						498,
						535,
						530,
						530,
						530
					],
					"projections_orig": [
						"534",
						"498",
						"535",
						"530",
						"530",
						"530"
					],
					"projections_percentage": [
						7.23,
						0,
						7.43,
						6.43,
						6.43,
						6.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4249
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.41,
					"enrolment": 511,
					"ligo": 0.73,
					"location": [
						151.314446805039,
						-33.6445753378815
					],
					"name": "Bilgola Plateau Public School",
					"playspace": 22.38,
					"projections": [
						464,
						511,
						505,
						515,
						535,
						555
					],
					"projections_orig": [
						"464",
						"511",
						"505",
						"515",
						"535",
						"555"
					],
					"projections_percentage": [
						-9.2,
						0,
						-1.17,
						0.78,
						4.7,
						8.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4359
				}
			],
			"uid": 10032
		},
		{
			"classrooms": {
				"demountable": 59,
				"permanent": 170
			},
			"enrolment": 5527,
			"level": "Primary",
			"ligo": 0.75,
			"name": "Hornsby Primary",
			"playspace": 47,
			"projections": [
				5527,
				5650,
				6150,
				6360,
				6390
			],
			"projections_percentage": [
				0,
				2.23,
				11.27,
				15.07,
				15.61
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 12
					},
					"classroomspace": 2.79,
					"enrolment": 398,
					"ligo": 0.59,
					"location": [
						151.113254423094,
						-33.6862746272847
					],
					"name": "Asquith Public School",
					"playspace": 34.34,
					"projections": [
						303,
						398,
						410,
						480,
						510,
						510
					],
					"projections_orig": [
						"303",
						"398",
						"410",
						"480",
						"510",
						"510"
					],
					"projections_percentage": [
						-23.87,
						0,
						3.02,
						20.6,
						28.14,
						28.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1070
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 2.59,
					"enrolment": 406,
					"ligo": 0.78,
					"location": [
						151.146838971181,
						-33.618140415501
					],
					"name": "Berowra Public School",
					"playspace": 55.46,
					"projections": [
						381,
						406,
						450,
						470,
						475,
						480
					],
					"projections_orig": [
						"381",
						"406",
						"450",
						"470",
						"475",
						"480"
					],
					"projections_percentage": [
						-6.16,
						0,
						10.84,
						15.76,
						17,
						18.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1205
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.38,
					"enrolment": 54,
					"ligo": 0.91,
					"location": [
						151.169196210226,
						-33.588955895145
					],
					"name": "Cowan Public School",
					"playspace": 166.52,
					"projections": [
						53,
						54,
						60,
						60,
						60,
						60
					],
					"projections_orig": [
						"53",
						"54",
						"60",
						"60",
						"60",
						"60"
					],
					"projections_percentage": [
						-1.85,
						0,
						11.11,
						11.11,
						11.11,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1668
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 10
					},
					"classroomspace": 2.67,
					"enrolment": 353,
					"ligo": 0.7,
					"location": [
						151.097335421037,
						-33.7232975847471
					],
					"name": "Normanhurst Public School",
					"playspace": 42.63,
					"projections": [
						319,
						353,
						360,
						375,
						380,
						380
					],
					"projections_orig": [
						"319",
						"353",
						"360",
						"375",
						"380",
						"380"
					],
					"projections_percentage": [
						-9.63,
						0,
						1.98,
						6.23,
						7.65,
						7.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2760
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 17
					},
					"classroomspace": 2.41,
					"enrolment": 856,
					"ligo": 0.71,
					"location": [
						151.112067566075,
						-33.7079668184629
					],
					"name": "Waitara Public School",
					"playspace": 13.24,
					"projections": [
						606,
						856,
						805,
						875,
						920,
						920
					],
					"projections_orig": [
						"606",
						"856",
						"805",
						"875",
						"920",
						"920"
					],
					"projections_percentage": [
						-29.21,
						0,
						-5.96,
						2.22,
						7.48,
						7.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3334
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.58,
					"enrolment": 445,
					"ligo": 0.89,
					"location": [
						151.117027395413,
						-33.6725716510761
					],
					"name": "Mount Colah Public School",
					"playspace": 40.49,
					"projections": [
						395,
						445,
						465,
						540,
						565,
						570
					],
					"projections_orig": [
						"395",
						"445",
						"465",
						"540",
						"565",
						"570"
					],
					"projections_percentage": [
						-11.24,
						0,
						4.49,
						21.35,
						26.97,
						28.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3885
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.38,
					"enrolment": 174,
					"ligo": 0.67,
					"location": [
						151.135234638827,
						-33.6580540380818
					],
					"name": "Mount Kuring-gai Public School",
					"playspace": 34.7,
					"projections": [
						146,
						174,
						195,
						210,
						220,
						225
					],
					"projections_orig": [
						"146",
						"174",
						"195",
						"210",
						"220",
						"225"
					],
					"projections_percentage": [
						-16.09,
						0,
						12.07,
						20.69,
						26.44,
						29.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4049
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.51,
					"enrolment": 446,
					"ligo": 0.92,
					"location": [
						151.096645583359,
						-33.6697893726028
					],
					"name": "Hornsby Heights Public School",
					"playspace": 39.64,
					"projections": [
						344,
						446,
						435,
						490,
						515,
						515
					],
					"projections_orig": [
						"344",
						"446",
						"435",
						"490",
						"515",
						"515"
					],
					"projections_percentage": [
						-22.87,
						0,
						-2.47,
						9.87,
						15.47,
						15.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4274
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 17
					},
					"classroomspace": 2.8,
					"enrolment": 543,
					"ligo": 0.66,
					"location": [
						151.08805836025,
						-33.7217360428331
					],
					"name": "Normanhurst West Public School",
					"playspace": 28.13,
					"projections": [
						427,
						543,
						540,
						565,
						565,
						570
					],
					"projections_orig": [
						"427",
						"543",
						"540",
						"565",
						"565",
						"570"
					],
					"projections_percentage": [
						-21.36,
						0,
						-0.55,
						4.05,
						4.05,
						4.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4275
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 25
					},
					"classroomspace": 2.47,
					"enrolment": 837,
					"ligo": 0.54,
					"location": [
						151.098241425172,
						-33.681838435564
					],
					"name": "Hornsby North Public School",
					"playspace": 21,
					"projections": [
						814,
						837,
						890,
						995,
						1035,
						1040
					],
					"projections_orig": [
						"814",
						"837",
						"890",
						"995",
						"1035",
						"1040"
					],
					"projections_percentage": [
						-2.75,
						0,
						6.33,
						18.88,
						23.66,
						24.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4365
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.44,
					"enrolment": 395,
					"ligo": 0.85,
					"location": [
						151.142434309767,
						-33.6092067328493
					],
					"name": "Wideview Public School",
					"playspace": 54.58,
					"projections": [
						361,
						395,
						425,
						440,
						445,
						445
					],
					"projections_orig": [
						"361",
						"395",
						"425",
						"440",
						"445",
						"445"
					],
					"projections_percentage": [
						-8.61,
						0,
						7.59,
						11.39,
						12.66,
						12.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4433
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 17
					},
					"classroomspace": 2.87,
					"enrolment": 620,
					"ligo": 0.81,
					"location": [
						151.095621882663,
						-33.7126650523083
					],
					"name": "Hornsby South Public School",
					"playspace": 33.31,
					"projections": [
						484,
						620,
						615,
						650,
						670,
						675
					],
					"projections_orig": [
						"484",
						"620",
						"615",
						"650",
						"670",
						"675"
					],
					"projections_percentage": [
						-21.94,
						0,
						-0.81,
						4.84,
						8.06,
						8.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5191
				}
			],
			"uid": 10033
		},
		{
			"classrooms": {
				"demountable": 75,
				"permanent": 191
			},
			"enrolment": 6935,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Manly Primary",
			"playspace": 21.76,
			"projections": [
				6935,
				6860,
				6725,
				6795,
				6805
			],
			"projections_percentage": [
				0,
				-1.08,
				-3.03,
				-2.02,
				-1.87
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 19
					},
					"classroomspace": 2.56,
					"enrolment": 554,
					"ligo": 0.8,
					"location": [
						151.250801040894,
						-33.7933485899455
					],
					"name": "Seaforth Public School",
					"playspace": 32.66,
					"projections": [
						478,
						554,
						550,
						550,
						560,
						565
					],
					"projections_orig": [
						"478",
						"554",
						"550",
						"550",
						"560",
						"565"
					],
					"projections_percentage": [
						-13.72,
						0,
						-0.72,
						-0.72,
						1.08,
						1.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1104
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.54,
					"enrolment": 312,
					"ligo": 0.61,
					"location": [
						151.270807491705,
						-33.7621637701868
					],
					"name": "Brookvale Public School",
					"playspace": 35.54,
					"projections": [
						167,
						312,
						245,
						245,
						245,
						245
					],
					"projections_orig": [
						"167",
						"312",
						"245",
						"245",
						"245",
						"245"
					],
					"projections_percentage": [
						-46.47,
						0,
						-21.47,
						-21.47,
						-21.47,
						-21.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1379
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 27
					},
					"classroomspace": 1.75,
					"enrolment": 1152,
					"ligo": 0.82,
					"location": [
						151.287013726799,
						-33.7726580321863
					],
					"name": "Harbord Public School",
					"playspace": 14.58,
					"projections": [
						1052,
						1152,
						1165,
						1120,
						1125,
						1120
					],
					"projections_orig": [
						"1052",
						"1152",
						"1165",
						"1120",
						"1125",
						"1120"
					],
					"projections_percentage": [
						-8.68,
						0,
						1.13,
						-2.78,
						-2.34,
						-2.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2133
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 27
					},
					"classroomspace": 2.47,
					"enrolment": 880,
					"ligo": 0.73,
					"location": [
						151.269581991557,
						-33.7925068737794
					],
					"name": "Manly West Public School",
					"playspace": 17.79,
					"projections": [
						824,
						880,
						920,
						885,
						895,
						900
					],
					"projections_orig": [
						"824",
						"880",
						"920",
						"885",
						"895",
						"900"
					],
					"projections_percentage": [
						-6.36,
						0,
						4.55,
						0.57,
						1.7,
						2.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2469
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 20
					},
					"classroomspace": 2.56,
					"enrolment": 739,
					"ligo": 0.86,
					"location": [
						151.258157758968,
						-33.8058705806229
					],
					"name": "Balgowlah Heights Public School",
					"playspace": 18.58,
					"projections": [
						634,
						739,
						755,
						730,
						745,
						750
					],
					"projections_orig": [
						"634",
						"739",
						"755",
						"730",
						"745",
						"750"
					],
					"projections_percentage": [
						-14.21,
						0,
						2.17,
						-1.22,
						0.81,
						1.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3736
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 17
					},
					"classroomspace": 2.77,
					"enrolment": 913,
					"ligo": 0.7,
					"location": [
						151.288397485715,
						-33.7645380630382
					],
					"name": "Curl Curl North Public School",
					"playspace": 20.07,
					"projections": [
						826,
						913,
						965,
						960,
						965,
						960
					],
					"projections_orig": [
						"826",
						"913",
						"965",
						"960",
						"965",
						"960"
					],
					"projections_percentage": [
						-9.53,
						0,
						5.7,
						5.15,
						5.7,
						5.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3925
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 1.84,
					"enrolment": 715,
					"ligo": 0.7,
					"location": [
						151.287186632047,
						-33.7996295943319
					],
					"name": "Manly Village Public School",
					"playspace": 6.84,
					"projections": [
						634,
						715,
						695,
						660,
						665,
						665
					],
					"projections_orig": [
						"634",
						"715",
						"695",
						"660",
						"665",
						"665"
					],
					"projections_percentage": [
						-11.33,
						0,
						-2.8,
						-7.69,
						-6.99,
						-6.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3950
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 13
					},
					"classroomspace": 2.87,
					"enrolment": 615,
					"ligo": 0.75,
					"location": [
						151.247593412536,
						-33.7831776488384
					],
					"name": "Balgowlah North Public School",
					"playspace": 36.68,
					"projections": [
						580,
						615,
						620,
						625,
						635,
						635
					],
					"projections_orig": [
						"580",
						"615",
						"620",
						"625",
						"635",
						"635"
					],
					"projections_percentage": [
						-5.69,
						0,
						0.81,
						1.63,
						3.25,
						3.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3984
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 7
					},
					"classroomspace": 2.78,
					"enrolment": 492,
					"ligo": 0.88,
					"location": [
						151.26064791528,
						-33.7839867910313
					],
					"name": "Manly Vale Public School",
					"playspace": 11.9,
					"projections": [
						307,
						492,
						415,
						415,
						415,
						420
					],
					"projections_orig": [
						"307",
						"492",
						"415",
						"415",
						"415",
						"420"
					],
					"projections_percentage": [
						-37.6,
						0,
						-15.65,
						-15.65,
						-15.65,
						-14.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4021
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.58,
					"enrolment": 563,
					"ligo": 0.76,
					"location": [
						151.249421315448,
						-33.7654369812292
					],
					"name": "Allambie Heights Public School",
					"playspace": 22.94,
					"projections": [
						460,
						563,
						530,
						535,
						545,
						545
					],
					"projections_orig": [
						"460",
						"563",
						"530",
						"535",
						"545",
						"545"
					],
					"projections_percentage": [
						-18.29,
						0,
						-5.86,
						-4.97,
						-3.2,
						-3.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4200
				}
			],
			"uid": 10034
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 17
			},
			"enrolment": 330,
			"level": "Primary",
			"ligo": 0.9,
			"name": "Terrey Hills Primary",
			"playspace": 109.94,
			"projections": [
				330,
				380,
				415,
				455,
				500
			],
			"projections_percentage": [
				0,
				15.15,
				25.76,
				37.88,
				51.52
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.08,
					"enrolment": 80,
					"ligo": 0.89,
					"location": [
						151.21522028973,
						-33.5481787600884
					],
					"name": "Brooklyn Public School",
					"playspace": 109.61,
					"projections": [
						95,
						80,
						105,
						110,
						110,
						110
					],
					"projections_orig": [
						"95",
						"80",
						"105",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						18.75,
						0,
						31.25,
						37.5,
						37.5,
						37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1377
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.29,
					"enrolment": 250,
					"ligo": 0.91,
					"location": [
						151.223608055379,
						-33.6854051218039
					],
					"name": "Terrey Hills Public School",
					"playspace": 110.27,
					"projections": [
						213,
						250,
						275,
						305,
						345,
						390
					],
					"projections_orig": [
						"213",
						"250",
						"275",
						"305",
						"345",
						"390"
					],
					"projections_percentage": [
						-14.8,
						0,
						10,
						22,
						38,
						56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3190
				}
			],
			"uid": 10035
		},
		{
			"classrooms": {
				"demountable": 32,
				"permanent": 150
			},
			"enrolment": 3887,
			"level": "Primary",
			"ligo": 0.74,
			"name": "Kogarah Primary",
			"playspace": 40.11,
			"projections": [
				3887,
				4225,
				4775,
				5210,
				5430
			],
			"projections_percentage": [
				0,
				8.7,
				22.85,
				34.04,
				39.7
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 22
					},
					"classroomspace": 2.8,
					"enrolment": 737,
					"ligo": 0.45,
					"location": [
						151.149950363396,
						-33.9628751677524
					],
					"name": "Brighton-Le-Sands Public School",
					"playspace": 32.43,
					"projections": [
						729,
						737,
						785,
						900,
						955,
						990
					],
					"projections_orig": [
						"729",
						"737",
						"785",
						"900",
						"955",
						"990"
					],
					"projections_percentage": [
						-1.09,
						0,
						6.51,
						22.12,
						29.58,
						34.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1358
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 22
					},
					"classroomspace": 2.24,
					"enrolment": 623,
					"ligo": 0.76,
					"location": [
						151.128497793146,
						-33.9727387927937
					],
					"name": "Carlton South Public School",
					"playspace": 16.39,
					"projections": [
						524,
						623,
						665,
						730,
						790,
						835
					],
					"projections_orig": [
						"524",
						"623",
						"665",
						"730",
						"790",
						"835"
					],
					"projections_percentage": [
						-15.89,
						0,
						6.74,
						17.17,
						26.81,
						34.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1513
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 14
					},
					"classroomspace": 2.92,
					"enrolment": 395,
					"ligo": 0.9,
					"location": [
						151.135652025498,
						-33.9619794808357
					],
					"name": "Kogarah Public School",
					"playspace": 17.59,
					"projections": [
						316,
						395,
						400,
						485,
						535,
						570
					],
					"projections_orig": [
						"316",
						"395",
						"400",
						"485",
						"535",
						"570"
					],
					"projections_percentage": [
						-20,
						0,
						1.27,
						22.78,
						35.44,
						44.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2319
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 3.49,
					"enrolment": 428,
					"ligo": 0.79,
					"location": [
						151.1417620686,
						-33.9523170635731
					],
					"name": "Rockdale Public School",
					"playspace": 9.38,
					"projections": [
						450,
						428,
						485,
						540,
						580,
						600
					],
					"projections_orig": [
						"450",
						"428",
						"485",
						"540",
						"580",
						"600"
					],
					"projections_percentage": [
						5.14,
						0,
						13.32,
						26.17,
						35.51,
						40.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2973
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 26
					},
					"classroomspace": 2.46,
					"enrolment": 633,
					"ligo": 0.86,
					"location": [
						151.128179260937,
						-33.9952874387931
					],
					"name": "Sans Souci Public School",
					"playspace": 28.11,
					"projections": [
						583,
						633,
						655,
						670,
						690,
						700
					],
					"projections_orig": [
						"583",
						"633",
						"655",
						"670",
						"690",
						"700"
					],
					"projections_percentage": [
						-7.9,
						0,
						3.48,
						5.85,
						9,
						10.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3038
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 23
					},
					"classroomspace": 2.27,
					"enrolment": 591,
					"ligo": 0.65,
					"location": [
						151.142829032242,
						-33.9812911589111
					],
					"name": "Ramsgate Public School",
					"playspace": 16.64,
					"projections": [
						480,
						591,
						630,
						670,
						695,
						710
					],
					"projections_orig": [
						"480",
						"591",
						"630",
						"670",
						"695",
						"710"
					],
					"projections_percentage": [
						-18.78,
						0,
						6.6,
						13.37,
						17.6,
						20.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3830
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.3,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						151.161674162795,
						-33.9494679304849
					],
					"name": "Kyeemagh Infants School",
					"playspace": 179.32,
					"projections": [
						55,
						61,
						70,
						90,
						110,
						115
					],
					"projections_orig": [
						"55",
						"61",
						"70",
						"90",
						"110",
						"115"
					],
					"projections_percentage": [
						-9.84,
						0,
						14.75,
						47.54,
						80.33,
						88.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5141
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 2.72,
					"enrolment": 419,
					"ligo": 0.51,
					"location": [
						151.146907166984,
						-33.9407577124162
					],
					"name": "Arncliffe Public School",
					"playspace": 20.99,
					"projections": [
						396,
						419,
						535,
						690,
						855,
						910
					],
					"projections_orig": [
						"396",
						"419",
						"535",
						"690",
						"855",
						"910"
					],
					"projections_percentage": [
						-5.49,
						0,
						27.68,
						64.68,
						104.06,
						117.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7401
				}
			],
			"uid": 10036
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 66
			},
			"enrolment": 1324,
			"level": "Primary",
			"ligo": 0.8,
			"name": "Bexley Primary",
			"playspace": 32.09,
			"projections": [
				1324,
				1450,
				1615,
				1820,
				1910
			],
			"projections_percentage": [
				0,
				9.52,
				21.98,
				37.46,
				44.26
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 15
					},
					"classroomspace": 2.6,
					"enrolment": 545,
					"ligo": 0.65,
					"location": [
						151.119404293741,
						-33.9415691230378
					],
					"name": "Bexley North Public School",
					"playspace": 26.55,
					"projections": [
						449,
						545,
						560,
						620,
						685,
						720
					],
					"projections_orig": [
						"449",
						"545",
						"560",
						"620",
						"685",
						"720"
					],
					"projections_percentage": [
						-17.61,
						0,
						2.75,
						13.76,
						25.69,
						32.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2308
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.06,
					"enrolment": 339,
					"ligo": 0.66,
					"location": [
						151.137602227717,
						-33.9370237616066
					],
					"name": "Athelstane Public School",
					"playspace": 28.01,
					"projections": [
						311,
						339,
						370,
						425,
						520,
						555
					],
					"projections_orig": [
						"311",
						"339",
						"370",
						"425",
						"520",
						"555"
					],
					"projections_percentage": [
						-8.26,
						0,
						9.14,
						25.37,
						53.39,
						63.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3453
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 3.69,
					"enrolment": 97,
					"ligo": 1,
					"location": [
						151.144789186774,
						-33.9319741590921
					],
					"name": "Arncliffe West Infants School",
					"playspace": 47.34,
					"projections": [
						112,
						97,
						100,
						115,
						135,
						140
					],
					"projections_orig": [
						"112",
						"97",
						"100",
						"115",
						"135",
						"140"
					],
					"projections_percentage": [
						15.46,
						0,
						3.09,
						18.56,
						39.18,
						44.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5103
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.46,
					"enrolment": 58,
					"ligo": 1,
					"location": [
						151.125318234045,
						-33.9336341610531
					],
					"name": "Bardwell Park Infants School",
					"playspace": 26.59,
					"projections": [
						59,
						58,
						70,
						75,
						85,
						90
					],
					"projections_orig": [
						"59",
						"58",
						"70",
						"75",
						"85",
						"90"
					],
					"projections_percentage": [
						1.72,
						0,
						20.69,
						29.31,
						46.55,
						55.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5148
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.12,
					"enrolment": 285,
					"ligo": 0.71,
					"location": [
						151.129419890435,
						-33.9485336421339
					],
					"name": "Bexley Public School",
					"playspace": 31.97,
					"projections": [
						290,
						285,
						350,
						380,
						395,
						405
					],
					"projections_orig": [
						"290",
						"285",
						"350",
						"380",
						"395",
						"405"
					],
					"projections_percentage": [
						1.75,
						0,
						22.81,
						33.33,
						38.6,
						42.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7406
				}
			],
			"uid": 10037
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 49
			},
			"enrolment": 1079,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Blakehurst Primary",
			"playspace": 37,
			"projections": [
				1079,
				1150,
				1250,
				1340,
				1435
			],
			"projections_percentage": [
				0,
				6.58,
				15.85,
				24.19,
				32.99
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.64,
					"enrolment": 269,
					"ligo": 0.8,
					"location": [
						151.115394467153,
						-33.9833565266028
					],
					"name": "Blakehurst Public School",
					"playspace": 38.21,
					"projections": [
						366,
						269,
						310,
						340,
						375,
						400
					],
					"projections_orig": [
						"366",
						"269",
						"310",
						"340",
						"375",
						"400"
					],
					"projections_percentage": [
						36.06,
						0,
						15.24,
						26.39,
						39.41,
						48.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1255
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 22
					},
					"classroomspace": 2.44,
					"enrolment": 539,
					"ligo": 0.61,
					"location": [
						151.099874026887,
						-33.9857190292907
					],
					"name": "Connells Point Public School",
					"playspace": 42.66,
					"projections": [
						525,
						539,
						555,
						600,
						630,
						680
					],
					"projections_orig": [
						"525",
						"539",
						"555",
						"600",
						"630",
						"680"
					],
					"projections_percentage": [
						-2.6,
						0,
						2.97,
						11.32,
						16.88,
						26.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1613
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.46,
					"enrolment": 271,
					"ligo": 0.74,
					"location": [
						151.106243717522,
						-33.9967858241356
					],
					"name": "Bald Face Public School",
					"playspace": 30.13,
					"projections": [
						266,
						271,
						285,
						310,
						335,
						355
					],
					"projections_orig": [
						"266",
						"271",
						"285",
						"310",
						"335",
						"355"
					],
					"projections_percentage": [
						-1.85,
						0,
						5.17,
						14.39,
						23.62,
						31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3794
				}
			],
			"uid": 10038
		},
		{
			"classrooms": {
				"demountable": 34,
				"permanent": 170
			},
			"enrolment": 4145,
			"level": "Primary",
			"ligo": 0.73,
			"name": "Hurstville Primary",
			"playspace": 25.69,
			"projections": [
				4145,
				4455,
				4825,
				5085,
				5195
			],
			"projections_percentage": [
				0,
				7.48,
				16.41,
				22.68,
				25.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.56,
					"enrolment": 540,
					"ligo": 0.69,
					"location": [
						151.08455053349,
						-33.9535637685791
					],
					"name": "Beverly Hills Public School",
					"playspace": 28.85,
					"projections": [
						488,
						540,
						600,
						635,
						670,
						695
					],
					"projections_orig": [
						"488",
						"540",
						"600",
						"635",
						"670",
						"695"
					],
					"projections_percentage": [
						-9.63,
						0,
						11.11,
						17.59,
						24.07,
						28.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1215
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 36
					},
					"classroomspace": 2.79,
					"enrolment": 862,
					"ligo": 0.79,
					"location": [
						151.123081154896,
						-33.9635390385247
					],
					"name": "Carlton Public School",
					"playspace": 10.99,
					"projections": [
						865,
						862,
						935,
						1000,
						1035,
						1015
					],
					"projections_orig": [
						"865",
						"862",
						"935",
						"1000",
						"1035",
						"1015"
					],
					"projections_percentage": [
						0.35,
						0,
						8.47,
						16.01,
						20.07,
						17.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1512
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 46
					},
					"classroomspace": 2.75,
					"enrolment": 1236,
					"ligo": 0.76,
					"location": [
						151.111211013678,
						-33.9649060348519
					],
					"name": "Hurstville Public School",
					"playspace": 9.52,
					"projections": [
						1041,
						1236,
						1270,
						1420,
						1525,
						1580
					],
					"projections_orig": [
						"1041",
						"1236",
						"1270",
						"1420",
						"1525",
						"1580"
					],
					"projections_percentage": [
						-15.78,
						0,
						2.75,
						14.89,
						23.38,
						27.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2197
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 19
					},
					"classroomspace": 2.63,
					"enrolment": 502,
					"ligo": 0.81,
					"location": [
						151.098715784743,
						-33.9724003209257
					],
					"name": "Hurstville South Public School",
					"playspace": 17.46,
					"projections": [
						450,
						502,
						530,
						570,
						605,
						635
					],
					"projections_orig": [
						"450",
						"502",
						"530",
						"570",
						"605",
						"635"
					],
					"projections_percentage": [
						-10.36,
						0,
						5.58,
						13.55,
						20.52,
						26.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2198
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 27
					},
					"classroomspace": 2.98,
					"enrolment": 496,
					"ligo": 0.29,
					"location": [
						151.101896505354,
						-33.9479626048213
					],
					"name": "Kingsgrove Public School",
					"playspace": 49.01,
					"projections": [
						608,
						496,
						535,
						585,
						620,
						635
					],
					"projections_orig": [
						"608",
						"496",
						"535",
						"585",
						"620",
						"635"
					],
					"projections_percentage": [
						22.58,
						0,
						7.86,
						17.94,
						25,
						28.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2307
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 20
					},
					"classroomspace": 2.65,
					"enrolment": 457,
					"ligo": 0.78,
					"location": [
						151.087703611963,
						-33.9623473188772
					],
					"name": "Penshurst Public School",
					"playspace": 12.22,
					"projections": [
						426,
						457,
						525,
						550,
						565,
						570
					],
					"projections_orig": [
						"426",
						"457",
						"525",
						"550",
						"565",
						"570"
					],
					"projections_percentage": [
						-6.78,
						0,
						14.88,
						20.35,
						23.63,
						24.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2861
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 4.54,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						151.090727990426,
						-33.9730320947994
					],
					"name": "Hurstville Grove Infants School",
					"playspace": 51.78,
					"projections": [
						63,
						52,
						60,
						65,
						65,
						65
					],
					"projections_orig": [
						"63",
						"52",
						"60",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						21.15,
						0,
						15.38,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5195
				}
			],
			"uid": 10039
		},
		{
			"classrooms": {
				"demountable": 25,
				"permanent": 204
			},
			"enrolment": 4035,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Lakemba Primary",
			"playspace": 29.01,
			"projections": [
				4035,
				4565,
				5080,
				5480,
				5860
			],
			"projections_percentage": [
				0,
				13.14,
				25.9,
				35.81,
				45.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 4.92,
					"enrolment": 326,
					"ligo": 0.49,
					"location": [
						151.084359574785,
						-33.9104281455487
					],
					"name": "Belmore North Public School",
					"playspace": 19.49,
					"projections": [
						345,
						326,
						385,
						475,
						495,
						515
					],
					"projections_orig": [
						"345",
						"326",
						"385",
						"475",
						"495",
						"515"
					],
					"projections_percentage": [
						5.83,
						0,
						18.1,
						45.71,
						51.84,
						57.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1185
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4,
					"enrolment": 269,
					"ligo": 0.72,
					"location": [
						151.092151747631,
						-33.9251207413188
					],
					"name": "Belmore South Public School",
					"playspace": 58.92,
					"projections": [
						226,
						269,
						300,
						370,
						390,
						415
					],
					"projections_orig": [
						"226",
						"269",
						"300",
						"370",
						"390",
						"415"
					],
					"projections_percentage": [
						-15.99,
						0,
						11.52,
						37.55,
						44.98,
						54.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1186
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 17
					},
					"classroomspace": 2.8,
					"enrolment": 503,
					"ligo": 0.72,
					"location": [
						151.070906780903,
						-33.9231996269018
					],
					"name": "Lakemba Public School",
					"playspace": 11.97,
					"projections": [
						389,
						503,
						535,
						575,
						620,
						655
					],
					"projections_orig": [
						"389",
						"503",
						"535",
						"575",
						"620",
						"655"
					],
					"projections_percentage": [
						-22.66,
						0,
						6.36,
						14.31,
						23.26,
						30.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2360
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 29
					},
					"classroomspace": 3.3,
					"enrolment": 586,
					"ligo": 0.8,
					"location": [
						151.055621153403,
						-33.930711999804
					],
					"name": "Punchbowl Public School",
					"playspace": 41.57,
					"projections": [
						674,
						586,
						715,
						785,
						885,
						980
					],
					"projections_orig": [
						"674",
						"586",
						"715",
						"785",
						"885",
						"980"
					],
					"projections_percentage": [
						15.02,
						0,
						22.01,
						33.96,
						51.02,
						67.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2910
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 3.36,
					"enrolment": 385,
					"ligo": 0.63,
					"location": [
						151.085303250647,
						-33.934724335548
					],
					"name": "McCallums Hill Public School",
					"playspace": 29.99,
					"projections": [
						357,
						385,
						445,
						485,
						525,
						565
					],
					"projections_orig": [
						"357",
						"385",
						"445",
						"485",
						"525",
						"565"
					],
					"projections_percentage": [
						-7.27,
						0,
						15.58,
						25.97,
						36.36,
						46.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3886
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 25
					},
					"classroomspace": 2.65,
					"enrolment": 633,
					"ligo": 0.45,
					"location": [
						151.075346418815,
						-33.941404066174
					],
					"name": "Beverly Hills North Public School",
					"playspace": 27.08,
					"projections": [
						692,
						633,
						740,
						820,
						880,
						940
					],
					"projections_orig": [
						"692",
						"633",
						"740",
						"820",
						"880",
						"940"
					],
					"projections_percentage": [
						9.32,
						0,
						16.9,
						29.54,
						39.02,
						48.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3944
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 33
					},
					"classroomspace": 2.95,
					"enrolment": 742,
					"ligo": 0.86,
					"location": [
						151.073760750887,
						-33.9159310785725
					],
					"name": "Hampden Park Public School",
					"playspace": 22.62,
					"projections": [
						710,
						742,
						830,
						900,
						955,
						1010
					],
					"projections_orig": [
						"710",
						"742",
						"830",
						"900",
						"955",
						"1010"
					],
					"projections_percentage": [
						-4.31,
						0,
						11.86,
						21.29,
						28.71,
						36.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4494
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 29
					},
					"classroomspace": 2.59,
					"enrolment": 591,
					"ligo": 0.71,
					"location": [
						151.068216404997,
						-33.9248812281619
					],
					"name": "Wiley Park Public School",
					"playspace": 20.46,
					"projections": [
						552,
						591,
						615,
						670,
						730,
						780
					],
					"projections_orig": [
						"552",
						"591",
						"615",
						"670",
						"730",
						"780"
					],
					"projections_percentage": [
						-6.6,
						0,
						4.06,
						13.37,
						23.52,
						31.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4553
				}
			],
			"uid": 10040
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 37
			},
			"enrolment": 594,
			"level": "Primary",
			"ligo": 0.58,
			"name": "Riverwood Primary",
			"playspace": 90.1,
			"projections": [
				594,
				655,
				710,
				765,
				815
			],
			"projections_percentage": [
				0,
				10.27,
				19.53,
				28.79,
				37.21
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 4.75,
					"enrolment": 116,
					"ligo": 0.8,
					"location": [
						151.047557763619,
						-33.9470431308903
					],
					"name": "Riverwood Public School",
					"playspace": 139.92,
					"projections": [
						88,
						116,
						100,
						110,
						120,
						130
					],
					"projections_orig": [
						"88",
						"116",
						"100",
						"110",
						"120",
						"130"
					],
					"projections_percentage": [
						-24.14,
						0,
						-13.79,
						-5.17,
						3.45,
						12.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3743
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.55,
					"enrolment": 302,
					"ligo": 0.61,
					"location": [
						151.067672497865,
						-33.9488321091853
					],
					"name": "Narwee Public School",
					"playspace": 52.87,
					"projections": [
						245,
						302,
						355,
						380,
						405,
						430
					],
					"projections_orig": [
						"245",
						"302",
						"355",
						"380",
						"405",
						"430"
					],
					"projections_percentage": [
						-18.87,
						0,
						17.55,
						25.83,
						34.11,
						42.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3875
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.09,
					"enrolment": 176,
					"ligo": 0.32,
					"location": [
						151.056849218002,
						-33.9457928864993
					],
					"name": "Hannans Road Public School",
					"playspace": 77.52,
					"projections": [
						173,
						176,
						200,
						220,
						240,
						255
					],
					"projections_orig": [
						"173",
						"176",
						"200",
						"220",
						"240",
						"255"
					],
					"projections_percentage": [
						-1.7,
						0,
						13.64,
						25,
						36.36,
						44.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4092
				}
			],
			"uid": 10041
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 138
			},
			"enrolment": 3222,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Peakhurst Primary",
			"playspace": 46.81,
			"projections": [
				3222,
				3395,
				3525,
				3575,
				3640
			],
			"projections_percentage": [
				0,
				5.37,
				9.4,
				10.96,
				12.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.73,
					"enrolment": 380,
					"ligo": 0.56,
					"location": [
						151.081164287144,
						-33.9719108165538
					],
					"name": "Mortdale Public School",
					"playspace": 24.83,
					"projections": [
						358,
						380,
						370,
						380,
						375,
						375
					],
					"projections_orig": [
						"358",
						"380",
						"370",
						"380",
						"375",
						"375"
					],
					"projections_percentage": [
						-5.79,
						0,
						-2.63,
						0,
						-1.32,
						-1.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2624
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 14
					},
					"classroomspace": 2.46,
					"enrolment": 535,
					"ligo": 0.57,
					"location": [
						151.080726681959,
						-33.9852992606591
					],
					"name": "Oatley Public School",
					"playspace": 25.3,
					"projections": [
						411,
						535,
						530,
						545,
						540,
						540
					],
					"projections_orig": [
						"411",
						"535",
						"530",
						"545",
						"540",
						"540"
					],
					"projections_percentage": [
						-23.18,
						0,
						-0.93,
						1.87,
						0.93,
						0.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2796
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 17
					},
					"classroomspace": 2.36,
					"enrolment": 623,
					"ligo": 0.41,
					"location": [
						151.063068940508,
						-33.9559893767134
					],
					"name": "Peakhurst Public School",
					"playspace": 27.38,
					"projections": [
						511,
						623,
						645,
						680,
						710,
						740
					],
					"projections_orig": [
						"511",
						"623",
						"645",
						"680",
						"710",
						"740"
					],
					"projections_percentage": [
						-17.98,
						0,
						3.53,
						9.15,
						13.96,
						18.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2849
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.27,
					"enrolment": 273,
					"ligo": 0.87,
					"location": [
						151.045804663321,
						-33.9846947142711
					],
					"name": "Lugarno Public School",
					"playspace": 88.59,
					"projections": [
						287,
						273,
						330,
						345,
						355,
						365
					],
					"projections_orig": [
						"287",
						"273",
						"330",
						"345",
						"355",
						"365"
					],
					"projections_percentage": [
						5.13,
						0,
						20.88,
						26.37,
						30.04,
						33.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3796
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 18
					},
					"classroomspace": 2.47,
					"enrolment": 573,
					"ligo": 0.67,
					"location": [
						151.065806730683,
						-33.9785428210383
					],
					"name": "Oatley West Public School",
					"playspace": 22.23,
					"projections": [
						472,
						573,
						545,
						560,
						555,
						550
					],
					"projections_orig": [
						"472",
						"573",
						"545",
						"560",
						"555",
						"550"
					],
					"projections_percentage": [
						-17.63,
						0,
						-4.89,
						-2.27,
						-3.14,
						-4.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3797
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.44,
					"enrolment": 305,
					"ligo": 0.6,
					"location": [
						151.050246678927,
						-33.9620667820048
					],
					"name": "Peakhurst West Public School",
					"playspace": 73.1,
					"projections": [
						340,
						305,
						380,
						400,
						420,
						440
					],
					"projections_orig": [
						"340",
						"305",
						"380",
						"400",
						"420",
						"440"
					],
					"projections_percentage": [
						11.48,
						0,
						24.59,
						31.15,
						37.7,
						44.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4013
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.99,
					"enrolment": 274,
					"ligo": 0.63,
					"location": [
						151.073460636777,
						-33.9618183281781
					],
					"name": "Penshurst West Public School",
					"playspace": 61.74,
					"projections": [
						328,
						274,
						325,
						335,
						335,
						340
					],
					"projections_orig": [
						"328",
						"274",
						"325",
						"335",
						"335",
						"340"
					],
					"projections_percentage": [
						19.71,
						0,
						18.61,
						22.26,
						22.26,
						24.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4051
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.23,
					"enrolment": 259,
					"ligo": 0.55,
					"location": [
						151.055752920708,
						-33.9723618163573
					],
					"name": "Peakhurst South Public School",
					"playspace": 51.29,
					"projections": [
						279,
						259,
						270,
						280,
						285,
						290
					],
					"projections_orig": [
						"279",
						"259",
						"270",
						"280",
						"285",
						"290"
					],
					"projections_percentage": [
						7.72,
						0,
						4.25,
						8.11,
						10.04,
						11.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4323
				}
			],
			"uid": 10042
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 82
			},
			"enrolment": 1990,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Como Primary",
			"playspace": 48.58,
			"projections": [
				1990,
				1995,
				2035,
				2095,
				2135
			],
			"projections_percentage": [
				0,
				0.25,
				2.26,
				5.28,
				7.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.51,
					"enrolment": 104,
					"ligo": 0.47,
					"location": [
						151.068867999244,
						-34.0013468493641
					],
					"name": "Como Public School",
					"playspace": 59.08,
					"projections": [
						61,
						104,
						95,
						95,
						100,
						100
					],
					"projections_orig": [
						"61",
						"104",
						"95",
						"95",
						"100",
						"100"
					],
					"projections_percentage": [
						-41.35,
						0,
						-8.65,
						-8.65,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1605
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.75,
					"enrolment": 430,
					"ligo": 0.72,
					"location": [
						151.08088984486,
						-34.0081363829548
					],
					"name": "Oyster Bay Public School",
					"playspace": 24.04,
					"projections": [
						374,
						430,
						425,
						430,
						440,
						450
					],
					"projections_orig": [
						"374",
						"430",
						"425",
						"430",
						"440",
						"450"
					],
					"projections_percentage": [
						-13.02,
						0,
						-1.16,
						0,
						2.33,
						4.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3593
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.21,
					"enrolment": 133,
					"ligo": 0.65,
					"location": [
						151.061545679704,
						-34.0182656231847
					],
					"name": "Jannali Public School",
					"playspace": 87.75,
					"projections": [
						114,
						133,
						150,
						165,
						170,
						175
					],
					"projections_orig": [
						"114",
						"133",
						"150",
						"165",
						"170",
						"175"
					],
					"projections_percentage": [
						-14.29,
						0,
						12.78,
						24.06,
						27.82,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3829
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.93,
					"enrolment": 380,
					"ligo": 0.79,
					"location": [
						151.059695055995,
						-34.0046439732275
					],
					"name": "Como West Public School",
					"playspace": 16.87,
					"projections": [
						334,
						380,
						390,
						390,
						400,
						410
					],
					"projections_orig": [
						"334",
						"380",
						"390",
						"390",
						"400",
						"410"
					],
					"projections_percentage": [
						-12.11,
						0,
						2.63,
						2.63,
						5.26,
						7.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3896
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.17,
					"enrolment": 368,
					"ligo": 0.82,
					"location": [
						151.07277809379,
						-34.0173895442041
					],
					"name": "Jannali East Public School",
					"playspace": 25.97,
					"projections": [
						278,
						368,
						370,
						390,
						405,
						415
					],
					"projections_orig": [
						"278",
						"368",
						"370",
						"390",
						"405",
						"415"
					],
					"projections_percentage": [
						-24.46,
						0,
						0.54,
						5.98,
						10.05,
						12.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4004
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.53,
					"enrolment": 393,
					"ligo": 0.59,
					"location": [
						151.082970673767,
						-34.0135779585641
					],
					"name": "Kareela Public School",
					"playspace": 50.32,
					"projections": [
						341,
						393,
						400,
						400,
						410,
						415
					],
					"projections_orig": [
						"341",
						"393",
						"400",
						"400",
						"410",
						"415"
					],
					"projections_percentage": [
						-13.23,
						0,
						1.78,
						1.78,
						4.33,
						5.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4488
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.66,
					"enrolment": 182,
					"ligo": 0.61,
					"location": [
						151.056130404376,
						-34.0129096602753
					],
					"name": "Bonnet Bay Public School",
					"playspace": 76.05,
					"projections": [
						110,
						182,
						165,
						165,
						170,
						170
					],
					"projections_orig": [
						"110",
						"182",
						"165",
						"165",
						"170",
						"170"
					],
					"projections_percentage": [
						-39.56,
						0,
						-9.34,
						-9.34,
						-6.59,
						-6.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4507
				}
			],
			"uid": 10043
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 57
			},
			"enrolment": 1536,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Sylvania Primary",
			"playspace": 62,
			"projections": [
				1536,
				1635,
				1730,
				1800,
				1840
			],
			"projections_percentage": [
				0,
				6.45,
				12.63,
				17.19,
				19.79
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.87,
					"enrolment": 118,
					"ligo": 0.7,
					"location": [
						151.111313291391,
						-34.0082048111965
					],
					"name": "Sylvania Public School",
					"playspace": 62.77,
					"projections": [
						123,
						118,
						135,
						145,
						150,
						155
					],
					"projections_orig": [
						"123",
						"118",
						"135",
						"145",
						"150",
						"155"
					],
					"projections_percentage": [
						4.24,
						0,
						14.41,
						22.88,
						27.12,
						31.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3143
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.66,
					"enrolment": 83,
					"ligo": 0.44,
					"location": [
						151.123160108264,
						-34.0184867011977
					],
					"name": "Taren Point Public School",
					"playspace": 97.74,
					"projections": [
						81,
						83,
						90,
						95,
						100,
						100
					],
					"projections_orig": [
						"81",
						"83",
						"90",
						"95",
						"100",
						"100"
					],
					"projections_percentage": [
						-2.41,
						0,
						8.43,
						14.46,
						20.48,
						20.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3168
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 24
					},
					"classroomspace": 2.63,
					"enrolment": 681,
					"ligo": 0.58,
					"location": [
						151.096536087928,
						-34.0130004521173
					],
					"name": "Sylvania Heights Public School",
					"playspace": 35.39,
					"projections": [
						626,
						681,
						700,
						715,
						740,
						755
					],
					"projections_orig": [
						"626",
						"681",
						"700",
						"715",
						"740",
						"755"
					],
					"projections_percentage": [
						-8.08,
						0,
						2.79,
						4.99,
						8.66,
						10.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4024
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 9
					},
					"classroomspace": 2.66,
					"enrolment": 312,
					"ligo": 0.69,
					"location": [
						151.11211263658,
						-34.0309702195828
					],
					"name": "Miranda North Public School",
					"playspace": 69.92,
					"projections": [
						268,
						312,
						340,
						380,
						405,
						415
					],
					"projections_orig": [
						"268",
						"312",
						"340",
						"380",
						"405",
						"415"
					],
					"projections_percentage": [
						-14.1,
						0,
						8.97,
						21.79,
						29.81,
						33.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4122
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.52,
					"enrolment": 342,
					"ligo": 0.63,
					"location": [
						151.088588571115,
						-34.0256745861275
					],
					"name": "Gymea North Public School",
					"playspace": 44.19,
					"projections": [
						337,
						342,
						370,
						395,
						405,
						415
					],
					"projections_orig": [
						"337",
						"342",
						"370",
						"395",
						"405",
						"415"
					],
					"projections_percentage": [
						-1.46,
						0,
						8.19,
						15.5,
						18.42,
						21.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4389
				}
			],
			"uid": 10044
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 76
			},
			"enrolment": 2177,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Cronulla Primary",
			"playspace": 46.07,
			"projections": [
				2534,
				2560,
				2610,
				2625,
				2640
			],
			"projections_percentage": [
				0,
				1.03,
				3,
				3.59,
				4.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 10
					},
					"classroomspace": 2.85,
					"enrolment": 389,
					"ligo": 0.52,
					"location": [
						151.147021710644,
						-34.0535837974654
					],
					"name": "Cronulla Public School",
					"playspace": 34.04,
					"projections": [
						202,
						389,
						340,
						350,
						355,
						360
					],
					"projections_orig": [
						"202",
						"389",
						"340",
						"350",
						"355",
						"360"
					],
					"projections_percentage": [
						-48.07,
						0,
						-12.6,
						-10.03,
						-8.74,
						-7.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1682
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.61,
					"enrolment": 209,
					"ligo": 0.97,
					"location": [
						151.204713700827,
						-34.0099886133899
					],
					"name": "Kurnell Public School",
					"playspace": 73.89,
					"projections": [
						198,
						209,
						215,
						220,
						220,
						220
					],
					"projections_orig": [
						"198",
						"209",
						"215",
						"220",
						"220",
						"220"
					],
					"projections_percentage": [
						-5.26,
						0,
						2.87,
						5.26,
						5.26,
						5.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2341
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.62,
					"enrolment": 318,
					"ligo": 0.68,
					"location": [
						151.153644789394,
						-34.0655568270115
					],
					"name": "Cronulla South Public School",
					"playspace": 24.38,
					"projections": [
						333,
						318,
						350,
						365,
						365,
						370
					],
					"projections_orig": [
						"333",
						"318",
						"350",
						"365",
						"365",
						"370"
					],
					"projections_percentage": [
						4.72,
						0,
						10.06,
						14.78,
						14.78,
						16.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3668
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.6,
					"enrolment": 203,
					"ligo": 0.99,
					"location": [
						151.153218458322,
						-34.0861193944416
					],
					"name": "Bundeena Public School",
					"playspace": 72.01,
					"projections": [
						198,
						203,
						200,
						200,
						200,
						200
					],
					"projections_orig": [
						"198",
						"203",
						"200",
						"200",
						"200",
						"200"
					],
					"projections_percentage": [
						-2.46,
						0,
						-1.48,
						-1.48,
						-1.48,
						-1.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3765
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.3,
					"enrolment": 500,
					"ligo": 0.66,
					"location": [
						151.145538145274,
						-34.0449557944347
					],
					"name": "Woolooware Public School",
					"playspace": 21.89,
					"projections": [
						430,
						500,
						540,
						560,
						570,
						575
					],
					"projections_orig": [
						"430",
						"500",
						"540",
						"560",
						"570",
						"575"
					],
					"projections_percentage": [
						-14,
						0,
						8,
						12,
						14,
						15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3957
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 20
					},
					"classroomspace": 2.34,
					"enrolment": 558,
					"ligo": 0.72,
					"location": [
						151.124641492604,
						-34.0367458338082
					],
					"name": "Caringbah North Public School",
					"playspace": 50.22,
					"projections": [
						507,
						915,
						915,
						915,
						915,
						915
					],
					"projections_orig": [
						"507",
						"915",
						"915",
						"915",
						"915",
						"915"
					],
					"projections_percentage": [
						-44.59,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3972
				}
			],
			"uid": 10045
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 65
			},
			"enrolment": 1759,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Lilli Pilli Primary",
			"playspace": 36.11,
			"projections": [
				1759,
				1850,
				1985,
				2030,
				2065
			],
			"projections_percentage": [
				0,
				5.17,
				12.85,
				15.41,
				17.4
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.88,
					"enrolment": 281,
					"ligo": 0.52,
					"location": [
						151.122692107321,
						-34.0538921069686
					],
					"name": "Caringbah Public School",
					"playspace": 63.15,
					"projections": [
						298,
						281,
						310,
						340,
						350,
						355
					],
					"projections_orig": [
						"298",
						"281",
						"310",
						"340",
						"350",
						"355"
					],
					"projections_percentage": [
						6.05,
						0,
						10.32,
						21,
						24.56,
						26.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1508
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.36,
					"enrolment": 377,
					"ligo": 0.68,
					"location": [
						151.119103440725,
						-34.0664666617136
					],
					"name": "Lilli Pilli Public School",
					"playspace": 27.27,
					"projections": [
						397,
						377,
						395,
						425,
						435,
						440
					],
					"projections_orig": [
						"397",
						"377",
						"395",
						"425",
						"435",
						"440"
					],
					"projections_percentage": [
						5.31,
						0,
						4.77,
						12.73,
						15.38,
						16.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4084
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.2,
					"enrolment": 464,
					"ligo": 0.74,
					"location": [
						151.112997727985,
						-34.0454893115809
					],
					"name": "Laguna Street Public School",
					"playspace": 38.07,
					"projections": [
						408,
						464,
						455,
						500,
						515,
						530
					],
					"projections_orig": [
						"408",
						"464",
						"455",
						"500",
						"515",
						"530"
					],
					"projections_percentage": [
						-12.07,
						0,
						-1.94,
						7.76,
						10.99,
						14.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4230
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 22
					},
					"classroomspace": 2.66,
					"enrolment": 637,
					"ligo": 0.73,
					"location": [
						151.132469644565,
						-34.0517166992478
					],
					"name": "Burraneer Bay Public School",
					"playspace": 15.94,
					"projections": [
						677,
						637,
						690,
						720,
						730,
						740
					],
					"projections_orig": [
						"677",
						"637",
						"690",
						"720",
						"730",
						"740"
					],
					"projections_percentage": [
						6.28,
						0,
						8.32,
						13.03,
						14.6,
						16.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4259
				}
			],
			"uid": 10046
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 78
			},
			"enrolment": 1988,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Miranda Primary",
			"playspace": 24.64,
			"projections": [
				1988,
				2215,
				2325,
				2455,
				2525
			],
			"projections_percentage": [
				0,
				11.42,
				16.95,
				23.49,
				27.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 2.54,
					"enrolment": 824,
					"ligo": 0.81,
					"location": [
						151.082714570522,
						-34.0459341973764
					],
					"name": "Gymea Bay Public School",
					"playspace": 19.8,
					"projections": [
						846,
						824,
						935,
						980,
						1010,
						1035
					],
					"projections_orig": [
						"846",
						"824",
						"935",
						"980",
						"1010",
						"1035"
					],
					"projections_percentage": [
						2.67,
						0,
						13.47,
						18.93,
						22.57,
						25.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2116
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.38,
					"enrolment": 277,
					"ligo": 0.65,
					"location": [
						151.09698289363,
						-34.0345957014145
					],
					"name": "Miranda Public School",
					"playspace": 45.33,
					"projections": [
						253,
						277,
						320,
						365,
						405,
						425
					],
					"projections_orig": [
						"253",
						"277",
						"320",
						"365",
						"405",
						"425"
					],
					"projections_percentage": [
						-8.66,
						0,
						15.52,
						31.77,
						46.21,
						53.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2574
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 11
					},
					"classroomspace": 2.7,
					"enrolment": 401,
					"ligo": 0.7,
					"location": [
						151.072730872324,
						-34.0592421493878
					],
					"name": "Grays Point Public School",
					"playspace": 16.33,
					"projections": [
						369,
						401,
						420,
						435,
						445,
						455
					],
					"projections_orig": [
						"369",
						"401",
						"420",
						"435",
						"445",
						"455"
					],
					"projections_percentage": [
						-7.98,
						0,
						4.74,
						8.48,
						10.97,
						13.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3914
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.63,
					"enrolment": 486,
					"ligo": 0.63,
					"location": [
						151.102606218363,
						-34.0474821177797
					],
					"name": "Yowie Bay Public School",
					"playspace": 17.12,
					"projections": [
						469,
						486,
						540,
						545,
						595,
						610
					],
					"projections_orig": [
						"469",
						"486",
						"540",
						"545",
						"595",
						"610"
					],
					"projections_percentage": [
						-3.5,
						0,
						11.11,
						12.14,
						22.43,
						25.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4124
				}
			],
			"uid": 10047
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 65
			},
			"enrolment": 1216,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Sutherland Primary",
			"playspace": 52.3,
			"projections": [
				1216,
				1375,
				1500,
				1555,
				1590
			],
			"projections_percentage": [
				0,
				13.08,
				23.36,
				27.88,
				30.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.48,
					"enrolment": 264,
					"ligo": 0.54,
					"location": [
						151.058778005926,
						-34.0331239795281
					],
					"name": "Sutherland Public School",
					"playspace": 37.77,
					"projections": [
						217,
						264,
						310,
						360,
						380,
						395
					],
					"projections_orig": [
						"217",
						"264",
						"310",
						"360",
						"380",
						"395"
					],
					"projections_percentage": [
						-17.8,
						0,
						17.42,
						36.36,
						43.94,
						49.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3136
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.55,
					"enrolment": 268,
					"ligo": 0.53,
					"location": [
						151.067800690251,
						-34.0268325530119
					],
					"name": "Sutherland North Public School",
					"playspace": 52.58,
					"projections": [
						222,
						268,
						310,
						355,
						370,
						375
					],
					"projections_orig": [
						"222",
						"268",
						"310",
						"355",
						"370",
						"375"
					],
					"projections_percentage": [
						-17.16,
						0,
						15.67,
						32.46,
						38.06,
						39.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3822
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.45,
					"enrolment": 233,
					"ligo": 0.63,
					"location": [
						151.076270587096,
						-34.0327760637838
					],
					"name": "Kirrawee Public School",
					"playspace": 84.93,
					"projections": [
						235,
						233,
						275,
						300,
						305,
						310
					],
					"projections_orig": [
						"235",
						"233",
						"275",
						"300",
						"305",
						"310"
					],
					"projections_percentage": [
						0.86,
						0,
						18.03,
						28.76,
						30.9,
						33.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4075
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.7,
					"enrolment": 451,
					"ligo": 0.77,
					"location": [
						151.048684790397,
						-34.0463670061095
					],
					"name": "Loftus Public School",
					"playspace": 33.9,
					"projections": [
						504,
						451,
						480,
						485,
						500,
						510
					],
					"projections_orig": [
						"504",
						"451",
						"480",
						"485",
						"500",
						"510"
					],
					"projections_percentage": [
						11.75,
						0,
						6.43,
						7.54,
						10.86,
						13.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4221
				}
			],
			"uid": 10048
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 107
			},
			"enrolment": 2300,
			"level": "Primary",
			"ligo": 0.77,
			"name": "Engadine Primary",
			"playspace": 57.21,
			"projections": [
				2300,
				2345,
				2360,
				2420,
				2465
			],
			"projections_percentage": [
				0,
				1.96,
				2.61,
				5.22,
				7.17
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.27,
					"enrolment": 361,
					"ligo": 0.77,
					"location": [
						151.012889529202,
						-34.0643285075941
					],
					"name": "Engadine Public School",
					"playspace": 40.32,
					"projections": [
						263,
						361,
						340,
						345,
						360,
						375
					],
					"projections_orig": [
						"263",
						"361",
						"340",
						"345",
						"360",
						"375"
					],
					"projections_percentage": [
						-27.15,
						0,
						-5.82,
						-4.43,
						-0.28,
						3.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1845
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.91,
					"enrolment": 320,
					"ligo": 0.79,
					"location": [
						151.006599102054,
						-34.0866373166359
					],
					"name": "Heathcote Public School",
					"playspace": 11.64,
					"projections": [
						277,
						320,
						330,
						335,
						345,
						350
					],
					"projections_orig": [
						"277",
						"320",
						"330",
						"335",
						"345",
						"350"
					],
					"projections_percentage": [
						-13.44,
						0,
						3.12,
						4.69,
						7.81,
						9.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2149
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 5.51,
					"enrolment": 40,
					"ligo": 0.87,
					"location": [
						150.995535123929,
						-34.1374805792819
					],
					"name": "Waterfall Public School",
					"playspace": 154.33,
					"projections": [
						47,
						40,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"47",
						"40",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						17.5,
						0,
						-37.5,
						-37.5,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3396
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 2.32,
					"enrolment": 731,
					"ligo": 0.77,
					"location": [
						151.002831398149,
						-34.0583542141056
					],
					"name": "Engadine West Public School",
					"playspace": 26.12,
					"projections": [
						754,
						731,
						790,
						800,
						820,
						835
					],
					"projections_orig": [
						"754",
						"731",
						"790",
						"800",
						"820",
						"835"
					],
					"projections_percentage": [
						3.15,
						0,
						8.07,
						9.44,
						12.18,
						14.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4292
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.45,
					"enrolment": 296,
					"ligo": 0.69,
					"location": [
						151.027452483266,
						-34.0568365043699
					],
					"name": "Yarrawarrah Public School",
					"playspace": 39.76,
					"projections": [
						179,
						296,
						275,
						275,
						280,
						285
					],
					"projections_orig": [
						"179",
						"296",
						"275",
						"275",
						"280",
						"285"
					],
					"projections_percentage": [
						-39.53,
						0,
						-7.09,
						-7.09,
						-5.41,
						-3.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4298
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.94,
					"enrolment": 427,
					"ligo": 0.72,
					"location": [
						151.024477215941,
						-34.0471976343015
					],
					"name": "Marton Public School",
					"playspace": 46.7,
					"projections": [
						367,
						427,
						435,
						430,
						440,
						445
					],
					"projections_orig": [
						"367",
						"427",
						"435",
						"430",
						"440",
						"445"
					],
					"projections_percentage": [
						-14.05,
						0,
						1.87,
						0.7,
						3.04,
						4.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4431
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 4.33,
					"enrolment": 125,
					"ligo": 0.78,
					"location": [
						151.019885732261,
						-34.082655719723
					],
					"name": "Heathcote East Public School",
					"playspace": 81.6,
					"projections": [
						158,
						125,
						135,
						135,
						135,
						135
					],
					"projections_orig": [
						"158",
						"125",
						"135",
						"135",
						"135",
						"135"
					],
					"projections_percentage": [
						26.4,
						0,
						8,
						8,
						8,
						8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5272
				}
			],
			"uid": 10049
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 223
			},
			"enrolment": 2256,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Menai Primary",
			"playspace": 81.24,
			"projections": [
				3006,
				3205,
				3270,
				3330,
				3395
			],
			"projections_percentage": [
				0,
				6.62,
				8.78,
				10.78,
				12.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 9.13,
					"enrolment": 92,
					"ligo": 0.85,
					"location": [
						151.005828307197,
						-34.0122636563891
					],
					"name": "Menai Public School",
					"playspace": 179.46,
					"projections": [
						170,
						92,
						100,
						110,
						110,
						110
					],
					"projections_orig": [
						"170",
						"92",
						"100",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						84.78,
						0,
						8.7,
						19.57,
						19.57,
						19.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2520
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 4.48,
					"enrolment": 109,
					"ligo": 0.84,
					"location": [
						151.041904479547,
						-34.0261821176837
					],
					"name": "Woronora River Public School",
					"playspace": 60.75,
					"projections": [
						121,
						109,
						120,
						125,
						125,
						130
					],
					"projections_orig": [
						"121",
						"109",
						"120",
						"125",
						"125",
						"130"
					],
					"projections_percentage": [
						11.01,
						0,
						10.09,
						14.68,
						14.68,
						19.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3735
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.79,
					"enrolment": 207,
					"ligo": 0.58,
					"location": [
						151.043258600633,
						-33.9985420370741
					],
					"name": "Illawong Public School",
					"playspace": 84.69,
					"projections": [
						215,
						207,
						225,
						225,
						225,
						225
					],
					"projections_orig": [
						"215",
						"207",
						"225",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						3.86,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4077
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.6,
					"enrolment": 533,
					"ligo": 0.61,
					"location": [
						151.028801996242,
						-34.0192325771512
					],
					"name": "Bangor Public School",
					"playspace": 37.59,
					"projections": [
						509,
						533,
						530,
						535,
						545,
						550
					],
					"projections_orig": [
						"509",
						"533",
						"530",
						"535",
						"545",
						"550"
					],
					"projections_percentage": [
						-4.5,
						0,
						-0.56,
						0.38,
						2.25,
						3.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4536
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.76,
					"enrolment": 341,
					"ligo": 0.39,
					"location": [
						151.026637853788,
						-34.003297701935
					],
					"name": "Tharawal Public School",
					"playspace": 52.97,
					"projections": [
						350,
						341,
						340,
						345,
						345,
						350
					],
					"projections_orig": [
						"350",
						"341",
						"340",
						"345",
						"345",
						"350"
					],
					"projections_percentage": [
						2.64,
						0,
						-0.29,
						1.17,
						1.17,
						2.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4573
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.67,
					"enrolment": 224,
					"ligo": 0.59,
					"location": [
						151.024678346599,
						-33.9919094892248
					],
					"name": "Alfords Point Public School",
					"playspace": 81.82,
					"projections": [
						230,
						224,
						240,
						240,
						240,
						240
					],
					"projections_orig": [
						"230",
						"224",
						"240",
						"240",
						"240",
						"240"
					],
					"projections_percentage": [
						2.68,
						0,
						7.14,
						7.14,
						7.14,
						7.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4605
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 70
					},
					"classroomspace": 5.79,
					"enrolment": 311,
					"ligo": 0.7,
					"location": [
						151.00674515831,
						-34.0357603468063
					],
					"name": "Lucas Heights Community School",
					"playspace": 63.28,
					"projections": [
						887,
						887,
						750,
						750,
						825,
						825,
						845,
						845,
						870,
						870,
						895,
						895
					],
					"projections_orig": [
						"887",
						"887",
						"750",
						"750",
						"825",
						"825",
						"845",
						"845",
						"870",
						"870",
						"895",
						"895"
					],
					"projections_percentage": [
						0,
						0,
						-15.45,
						-15.45,
						-6.99,
						-6.99,
						-4.74,
						-4.74,
						-1.92,
						-1.92,
						0.9,
						0.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8271
				}
			],
			"uid": 10050
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 223
			},
			"enrolment": 2256,
			"level": "Secondary",
			"ligo": 0.66,
			"name": "Menai Primary",
			"playspace": 81.24,
			"projections": [
				3006,
				3205,
				3270,
				3330,
				3395
			],
			"projections_percentage": [
				0,
				6.62,
				8.78,
				10.78,
				12.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 9.13,
					"enrolment": 92,
					"ligo": 0.85,
					"location": [
						151.005828307197,
						-34.0122636563891
					],
					"name": "Menai Public School",
					"playspace": 179.46,
					"projections": [
						170,
						92,
						100,
						110,
						110,
						110
					],
					"projections_orig": [
						"170",
						"92",
						"100",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						84.78,
						0,
						8.7,
						19.57,
						19.57,
						19.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2520
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 4.48,
					"enrolment": 109,
					"ligo": 0.84,
					"location": [
						151.041904479547,
						-34.0261821176837
					],
					"name": "Woronora River Public School",
					"playspace": 60.75,
					"projections": [
						121,
						109,
						120,
						125,
						125,
						130
					],
					"projections_orig": [
						"121",
						"109",
						"120",
						"125",
						"125",
						"130"
					],
					"projections_percentage": [
						11.01,
						0,
						10.09,
						14.68,
						14.68,
						19.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3735
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.79,
					"enrolment": 207,
					"ligo": 0.58,
					"location": [
						151.043258600633,
						-33.9985420370741
					],
					"name": "Illawong Public School",
					"playspace": 84.69,
					"projections": [
						215,
						207,
						225,
						225,
						225,
						225
					],
					"projections_orig": [
						"215",
						"207",
						"225",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						3.86,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4077
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.6,
					"enrolment": 533,
					"ligo": 0.61,
					"location": [
						151.028801996242,
						-34.0192325771512
					],
					"name": "Bangor Public School",
					"playspace": 37.59,
					"projections": [
						509,
						533,
						530,
						535,
						545,
						550
					],
					"projections_orig": [
						"509",
						"533",
						"530",
						"535",
						"545",
						"550"
					],
					"projections_percentage": [
						-4.5,
						0,
						-0.56,
						0.38,
						2.25,
						3.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4536
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.76,
					"enrolment": 341,
					"ligo": 0.39,
					"location": [
						151.026637853788,
						-34.003297701935
					],
					"name": "Tharawal Public School",
					"playspace": 52.97,
					"projections": [
						350,
						341,
						340,
						345,
						345,
						350
					],
					"projections_orig": [
						"350",
						"341",
						"340",
						"345",
						"345",
						"350"
					],
					"projections_percentage": [
						2.64,
						0,
						-0.29,
						1.17,
						1.17,
						2.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4573
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.67,
					"enrolment": 224,
					"ligo": 0.59,
					"location": [
						151.024678346599,
						-33.9919094892248
					],
					"name": "Alfords Point Public School",
					"playspace": 81.82,
					"projections": [
						230,
						224,
						240,
						240,
						240,
						240
					],
					"projections_orig": [
						"230",
						"224",
						"240",
						"240",
						"240",
						"240"
					],
					"projections_percentage": [
						2.68,
						0,
						7.14,
						7.14,
						7.14,
						7.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4605
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 70
					},
					"classroomspace": 5.79,
					"enrolment": 311,
					"ligo": 0.7,
					"location": [
						151.00674515831,
						-34.0357603468063
					],
					"name": "Lucas Heights Community School",
					"playspace": 63.28,
					"projections": [
						887,
						887,
						750,
						750,
						825,
						825,
						845,
						845,
						870,
						870,
						895,
						895
					],
					"projections_orig": [
						"887",
						"887",
						"750",
						"750",
						"825",
						"825",
						"845",
						"845",
						"870",
						"870",
						"895",
						"895"
					],
					"projections_percentage": [
						0,
						0,
						-15.45,
						-15.45,
						-6.99,
						-6.99,
						-4.74,
						-4.74,
						-1.92,
						-1.92,
						0.9,
						0.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8271
				}
			],
			"uid": 10050
		},
		{
			"classrooms": {
				"demountable": 44,
				"permanent": 128
			},
			"enrolment": 4236,
			"level": "Primary",
			"ligo": 0.78,
			"name": "Narellan Primary",
			"playspace": 47.59,
			"projections": [
				4261,
				4855,
				7205,
				8890,
				10350
			],
			"projections_percentage": [
				0,
				13.94,
				69.09,
				108.64,
				142.9
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 2.3,
					"enrolment": 276,
					"ligo": 0.61,
					"location": [
						150.686659265721,
						-34.015462683473
					],
					"name": "Cobbitty Public School",
					"playspace": 37.38,
					"projections": [
						219,
						276,
						295,
						660,
						890,
						1115
					],
					"projections_orig": [
						"219",
						"276",
						"295",
						"660",
						"890",
						"1115"
					],
					"projections_percentage": [
						-20.65,
						0,
						6.88,
						139.13,
						222.46,
						303.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1580
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.59,
					"enrolment": 319,
					"ligo": 0.58,
					"location": [
						150.733577461764,
						-34.0415681880667
					],
					"name": "Narellan Public School",
					"playspace": 73.39,
					"projections": [
						285,
						319,
						415,
						500,
						600,
						605
					],
					"projections_orig": [
						"285",
						"319",
						"415",
						"500",
						"600",
						"605"
					],
					"projections_percentage": [
						-10.66,
						0,
						30.09,
						56.74,
						88.09,
						89.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2704
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 22
					},
					"classroomspace": 2.43,
					"enrolment": 708,
					"ligo": 0.82,
					"location": [
						150.761308220632,
						-34.060695343667
					],
					"name": "Mount Annan Public School",
					"playspace": 33.57,
					"projections": [
						616,
						708,
						815,
						1045,
						1290,
						1565
					],
					"projections_orig": [
						"616",
						"708",
						"815",
						"1045",
						"1290",
						"1565"
					],
					"projections_percentage": [
						-12.99,
						0,
						15.11,
						47.6,
						82.2,
						121.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4597
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 23
					},
					"classroomspace": 2.4,
					"enrolment": 842,
					"ligo": 0.77,
					"location": [
						150.744571918838,
						-34.0554474784333
					],
					"name": "Narellan Vale Public School",
					"playspace": 23.31,
					"projections": [
						800,
						842,
						1020,
						1320,
						1650,
						2015
					],
					"projections_orig": [
						"800",
						"842",
						"1020",
						"1320",
						"1650",
						"2015"
					],
					"projections_percentage": [
						-4.99,
						0,
						21.14,
						56.77,
						95.96,
						139.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4621
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 16
					},
					"classroomspace": 2.91,
					"enrolment": 587,
					"ligo": 0.82,
					"location": [
						150.770418239192,
						-34.0483375068347
					],
					"name": "Currans Hill Public School",
					"playspace": 35.93,
					"projections": [
						479,
						612,
						665,
						920,
						1190,
						1460
					],
					"projections_orig": [
						"479",
						"612",
						"665",
						"920",
						"1190",
						"1460"
					],
					"projections_percentage": [
						-21.73,
						0,
						8.66,
						50.33,
						94.44,
						138.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4625
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 23
					},
					"classroomspace": 2.39,
					"enrolment": 788,
					"ligo": 0.83,
					"location": [
						150.738709091781,
						-34.0263887301015
					],
					"name": "Harrington Park Public School",
					"playspace": 25.05,
					"projections": [
						806,
						788,
						870,
						1095,
						1355,
						1590
					],
					"projections_orig": [
						"806",
						"788",
						"870",
						"1095",
						"1355",
						"1590"
					],
					"projections_percentage": [
						2.28,
						0,
						10.41,
						38.96,
						71.95,
						101.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4628
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 22
					},
					"classroomspace": 2.93,
					"enrolment": 716,
					"ligo": 0.82,
					"location": [
						150.734876354088,
						-33.9974154525283
					],
					"name": "Oran Park Public School",
					"playspace": 104.51,
					"projections": [
						0,
						716,
						775,
						1665,
						1915,
						2000
					],
					"projections_orig": [
						"0",
						"716",
						"775",
						"1665",
						"1915",
						"2000"
					],
					"projections_percentage": [
						-100,
						0,
						8.24,
						132.54,
						167.46,
						179.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4651
				}
			],
			"uid": 10051
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 74
			},
			"enrolment": 2085,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Macquarie Fields Primary",
			"playspace": 27.11,
			"projections": [
				2085,
				2245,
				2660,
				2860,
				3250
			],
			"projections_percentage": [
				0,
				7.67,
				27.58,
				37.17,
				55.88
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 2.61,
					"enrolment": 605,
					"ligo": 0.6,
					"location": [
						150.867430716969,
						-33.9997482598808
					],
					"name": "Ingleburn Public School",
					"playspace": 21.55,
					"projections": [
						556,
						605,
						640,
						835,
						970,
						1130
					],
					"projections_orig": [
						"556",
						"605",
						"640",
						"835",
						"970",
						"1130"
					],
					"projections_percentage": [
						-8.1,
						0,
						5.79,
						38.02,
						60.33,
						86.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2206
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 25
					},
					"classroomspace": 2.46,
					"enrolment": 944,
					"ligo": 0.83,
					"location": [
						150.881521727451,
						-33.9950183998838
					],
					"name": "Macquarie Fields Public School",
					"playspace": 18.11,
					"projections": [
						683,
						944,
						975,
						1005,
						1005,
						1025
					],
					"projections_orig": [
						"683",
						"944",
						"975",
						"1005",
						"1005",
						"1025"
					],
					"projections_percentage": [
						-27.65,
						0,
						3.28,
						6.46,
						6.46,
						8.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4064
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.03,
					"enrolment": 536,
					"ligo": 0.72,
					"location": [
						150.86300679005,
						-34.0107047373427
					],
					"name": "Sackville Street Public School",
					"playspace": 41.68,
					"projections": [
						537,
						536,
						630,
						820,
						885,
						1095
					],
					"projections_orig": [
						"537",
						"536",
						"630",
						"820",
						"885",
						"1095"
					],
					"projections_percentage": [
						0.19,
						0,
						17.54,
						52.99,
						65.11,
						104.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4491
				}
			],
			"uid": 10052
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 88
			},
			"enrolment": 1801,
			"level": "Primary",
			"ligo": 0.57,
			"name": "Minto Primary",
			"playspace": 55.28,
			"projections": [
				1801,
				1855,
				1995,
				2065,
				2175
			],
			"projections_percentage": [
				0,
				3,
				10.77,
				14.66,
				20.77
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 6
					},
					"classroomspace": 2.55,
					"enrolment": 203,
					"ligo": 0.62,
					"location": [
						150.847060919032,
						-34.0292305259858
					],
					"name": "Minto Public School",
					"playspace": 54.74,
					"projections": [
						168,
						203,
						235,
						260,
						280,
						300
					],
					"projections_orig": [
						"168",
						"203",
						"235",
						"260",
						"280",
						"300"
					],
					"projections_percentage": [
						-17.24,
						0,
						15.76,
						28.08,
						37.93,
						47.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2572
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 21
					},
					"classroomspace": 2.56,
					"enrolment": 618,
					"ligo": 0.64,
					"location": [
						150.840154111847,
						-34.0499354575497
					],
					"name": "Leumeah Public School",
					"playspace": 31.3,
					"projections": [
						576,
						618,
						685,
						735,
						750,
						785
					],
					"projections_orig": [
						"576",
						"618",
						"685",
						"735",
						"750",
						"785"
					],
					"projections_percentage": [
						-6.8,
						0,
						10.84,
						18.93,
						21.36,
						27.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4058
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.78,
					"enrolment": 245,
					"ligo": 0.62,
					"location": [
						150.848057407769,
						-34.0381884912547
					],
					"name": "Campbellfield Public School",
					"playspace": 90.54,
					"projections": [
						159,
						245,
						230,
						250,
						260,
						275
					],
					"projections_orig": [
						"159",
						"245",
						"230",
						"250",
						"260",
						"275"
					],
					"projections_percentage": [
						-35.1,
						0,
						-6.12,
						2.04,
						6.12,
						12.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4490
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 3.54,
					"enrolment": 450,
					"ligo": 0.45,
					"location": [
						150.851202217383,
						-34.0276194871762
					],
					"name": "Sarah Redfern Public School",
					"playspace": 20.38,
					"projections": [
						335,
						450,
						405,
						420,
						430,
						445
					],
					"projections_orig": [
						"335",
						"450",
						"405",
						"420",
						"430",
						"445"
					],
					"projections_percentage": [
						-25.56,
						0,
						-10,
						-6.67,
						-4.44,
						-1.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4509
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.48,
					"enrolment": 285,
					"ligo": 0.52,
					"location": [
						150.857016793422,
						-34.0226200626754
					],
					"name": "The Grange Public School",
					"playspace": 79.46,
					"projections": [
						189,
						285,
						300,
						330,
						345,
						370
					],
					"projections_orig": [
						"189",
						"285",
						"300",
						"330",
						"345",
						"370"
					],
					"projections_percentage": [
						-33.68,
						0,
						5.26,
						15.79,
						21.05,
						29.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4518
				}
			],
			"uid": 10053
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 71
			},
			"enrolment": 1115,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Glenfield Primary",
			"playspace": 87.67,
			"projections": [
				1115,
				1235,
				1295,
				1320,
				1380
			],
			"projections_percentage": [
				0,
				10.76,
				16.14,
				18.39,
				23.77
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 2.48,
					"enrolment": 409,
					"ligo": 0.82,
					"location": [
						150.895843916908,
						-33.9712603357457
					],
					"name": "Glenfield Public School",
					"playspace": 33.5,
					"projections": [
						264,
						409,
						430,
						475,
						505,
						545
					],
					"projections_orig": [
						"264",
						"409",
						"430",
						"475",
						"505",
						"545"
					],
					"projections_percentage": [
						-35.45,
						0,
						5.13,
						16.14,
						23.47,
						33.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2001
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 5.27,
					"enrolment": 276,
					"ligo": 0.58,
					"location": [
						150.898250276534,
						-33.993358350418
					],
					"name": "Curran Public School",
					"playspace": 81.26,
					"projections": [
						280,
						276,
						310,
						300,
						280,
						270
					],
					"projections_orig": [
						"280",
						"276",
						"310",
						"300",
						"280",
						"270"
					],
					"projections_percentage": [
						1.45,
						0,
						12.32,
						8.7,
						1.45,
						-2.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4460
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 8.74,
					"enrolment": 163,
					"ligo": 0.68,
					"location": [
						150.896237563849,
						-33.9865031405672
					],
					"name": "Guise Public School",
					"playspace": 138.34,
					"projections": [
						141,
						163,
						170,
						170,
						170,
						170
					],
					"projections_orig": [
						"141",
						"163",
						"170",
						"170",
						"170",
						"170"
					],
					"projections_percentage": [
						-13.5,
						0,
						4.29,
						4.29,
						4.29,
						4.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4461
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.99,
					"enrolment": 267,
					"ligo": 0.54,
					"location": [
						150.90279236819,
						-33.9752312969404
					],
					"name": "Glenwood Public School",
					"playspace": 97.6,
					"projections": [
						289,
						267,
						325,
						350,
						365,
						395
					],
					"projections_orig": [
						"289",
						"267",
						"325",
						"350",
						"365",
						"395"
					],
					"projections_percentage": [
						8.24,
						0,
						21.72,
						31.09,
						36.7,
						47.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4529
				}
			],
			"uid": 10054
		},
		{
			"classrooms": {
				"demountable": 19,
				"permanent": 94
			},
			"enrolment": 2290,
			"level": "Primary",
			"ligo": 0.69,
			"name": "Campbelltown South Primary",
			"playspace": 49.56,
			"projections": [
				2290,
				2415,
				2830,
				3140,
				3315
			],
			"projections_percentage": [
				0,
				5.46,
				23.58,
				37.12,
				44.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.8,
					"enrolment": 266,
					"ligo": 0.66,
					"location": [
						150.81528348165,
						-34.0978772280444
					],
					"name": "Woodland Road Public School",
					"playspace": 81.53,
					"projections": [
						227,
						266,
						285,
						315,
						335,
						355
					],
					"projections_orig": [
						"227",
						"266",
						"285",
						"315",
						"335",
						"355"
					],
					"projections_percentage": [
						-14.66,
						0,
						7.14,
						18.42,
						25.94,
						33.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4492
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.95,
					"enrolment": 303,
					"ligo": 0.79,
					"location": [
						150.798301885277,
						-34.0873589888571
					],
					"name": "Ambarvale Public School",
					"playspace": 60.74,
					"projections": [
						260,
						303,
						325,
						415,
						500,
						565
					],
					"projections_orig": [
						"260",
						"303",
						"325",
						"415",
						"500",
						"565"
					],
					"projections_percentage": [
						-14.19,
						0,
						7.26,
						36.96,
						65.02,
						86.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4505
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 22
					},
					"classroomspace": 3,
					"enrolment": 717,
					"ligo": 0.62,
					"location": [
						150.794447624105,
						-34.1041469608988
					],
					"name": "Rosemeadow Public School",
					"playspace": 26.42,
					"projections": [
						568,
						717,
						720,
						865,
						990,
						1075
					],
					"projections_orig": [
						"568",
						"717",
						"720",
						"865",
						"990",
						"1075"
					],
					"projections_percentage": [
						-20.78,
						0,
						0.42,
						20.64,
						38.08,
						49.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4537
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.95,
					"enrolment": 531,
					"ligo": 0.73,
					"location": [
						150.790474874179,
						-34.0934226424436
					],
					"name": "Thomas Acres Public School",
					"playspace": 34.4,
					"projections": [
						524,
						531,
						565,
						710,
						790,
						790
					],
					"projections_orig": [
						"524",
						"531",
						"565",
						"710",
						"790",
						"790"
					],
					"projections_percentage": [
						-1.32,
						0,
						6.4,
						33.71,
						48.78,
						48.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4539
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.75,
					"enrolment": 473,
					"ligo": 0.67,
					"location": [
						150.803627538148,
						-34.1097819768367
					],
					"name": "St Helens Park Public School",
					"playspace": 44.7,
					"projections": [
						477,
						473,
						520,
						525,
						525,
						530
					],
					"projections_orig": [
						"477",
						"473",
						"520",
						"525",
						"525",
						"530"
					],
					"projections_percentage": [
						0.85,
						0,
						9.94,
						10.99,
						10.99,
						12.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4603
				}
			],
			"uid": 10055
		},
		{
			"classrooms": {
				"demountable": 26,
				"permanent": 84
			},
			"enrolment": 2251,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Camden Primary",
			"playspace": 57.67,
			"projections": [
				2251,
				2500,
				3345,
				4155,
				4715
			],
			"projections_percentage": [
				0,
				11.06,
				48.6,
				84.58,
				109.46
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.72,
					"enrolment": 297,
					"ligo": 0.36,
					"location": [
						150.694218516619,
						-34.0522327715557
					],
					"name": "Camden Public School",
					"playspace": 77.21,
					"projections": [
						306,
						297,
						315,
						430,
						510,
						525
					],
					"projections_orig": [
						"306",
						"297",
						"315",
						"430",
						"510",
						"525"
					],
					"projections_percentage": [
						3.03,
						0,
						6.06,
						44.78,
						71.72,
						76.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1482
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 21
					},
					"classroomspace": 2.81,
					"enrolment": 821,
					"ligo": 0.7,
					"location": [
						150.694590334788,
						-34.0705946799473
					],
					"name": "Camden South Public School",
					"playspace": 23.96,
					"projections": [
						650,
						821,
						800,
						1100,
						1425,
						1735
					],
					"projections_orig": [
						"650",
						"821",
						"800",
						"1100",
						"1425",
						"1735"
					],
					"projections_percentage": [
						-20.83,
						0,
						-2.56,
						33.98,
						73.57,
						111.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4286
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 2.75,
					"enrolment": 447,
					"ligo": 0.64,
					"location": [
						150.711109329106,
						-34.0613529946601
					],
					"name": "Mawarra Public School",
					"playspace": 47.07,
					"projections": [
						408,
						447,
						500,
						595,
						680,
						700
					],
					"projections_orig": [
						"408",
						"447",
						"500",
						"595",
						"680",
						"700"
					],
					"projections_percentage": [
						-8.72,
						0,
						11.86,
						33.11,
						52.13,
						56.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4466
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 12
					},
					"classroomspace": 2.95,
					"enrolment": 477,
					"ligo": 0.42,
					"location": [
						150.721566695531,
						-34.0559075187287
					],
					"name": "Elderslie Public School",
					"playspace": 37.08,
					"projections": [
						260,
						477,
						460,
						580,
						710,
						810
					],
					"projections_orig": [
						"260",
						"477",
						"460",
						"580",
						"710",
						"810"
					],
					"projections_percentage": [
						-45.49,
						0,
						-3.56,
						21.59,
						48.85,
						69.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4646
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 6.37,
					"enrolment": 209,
					"ligo": 0.94,
					"location": [
						150.721566695531,
						-34.0559075187287
					],
					"name": "Spring Farm Public School",
					"playspace": 103.02,
					"projections": [
						0,
						209,
						425,
						640,
						830,
						945
					],
					"projections_orig": [
						"0",
						"209",
						"425",
						"640",
						"830",
						"945"
					],
					"projections_percentage": [
						-100,
						0,
						103.35,
						206.22,
						297.13,
						352.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4657
				}
			],
			"uid": 10056
		},
		{
			"classrooms": {
				"demountable": 24,
				"permanent": 167
			},
			"enrolment": 3816,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Fairfield Primary",
			"playspace": 28.48,
			"projections": [
				3816,
				3870,
				3875,
				3845,
				3905
			],
			"projections_percentage": [
				0,
				1.42,
				1.55,
				0.76,
				2.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 33
					},
					"classroomspace": 3.15,
					"enrolment": 580,
					"ligo": 0.61,
					"location": [
						150.955281683605,
						-33.8678770198042
					],
					"name": "Fairfield Public School",
					"playspace": 19.73,
					"projections": [
						554,
						580,
						630,
						655,
						685,
						715
					],
					"projections_orig": [
						"554",
						"580",
						"630",
						"655",
						"685",
						"715"
					],
					"projections_percentage": [
						-4.48,
						0,
						8.62,
						12.93,
						18.1,
						23.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1895
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 33
					},
					"classroomspace": 3.23,
					"enrolment": 723,
					"ligo": 0.64,
					"location": [
						150.92522193873,
						-33.8682490060173
					],
					"name": "Fairfield West Public School",
					"playspace": 25.83,
					"projections": [
						662,
						723,
						745,
						730,
						695,
						700
					],
					"projections_orig": [
						"662",
						"723",
						"745",
						"730",
						"695",
						"700"
					],
					"projections_percentage": [
						-8.44,
						0,
						3.04,
						0.97,
						-3.87,
						-3.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1896
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 27
					},
					"classroomspace": 3.28,
					"enrolment": 570,
					"ligo": 0.67,
					"location": [
						150.934772348483,
						-33.853726140249
					],
					"name": "Smithfield Public School",
					"playspace": 34.34,
					"projections": [
						497,
						570,
						550,
						545,
						555,
						565
					],
					"projections_orig": [
						"497",
						"570",
						"550",
						"545",
						"555",
						"565"
					],
					"projections_percentage": [
						-12.81,
						0,
						-3.51,
						-4.39,
						-2.63,
						-0.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3073
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 32
					},
					"classroomspace": 2.85,
					"enrolment": 984,
					"ligo": 0.73,
					"location": [
						150.939778935554,
						-33.8654278349126
					],
					"name": "Fairfield Heights Public School",
					"playspace": 11.91,
					"projections": [
						845,
						984,
						970,
						990,
						955,
						965
					],
					"projections_orig": [
						"845",
						"984",
						"970",
						"990",
						"955",
						"965"
					],
					"projections_percentage": [
						-14.13,
						0,
						-1.42,
						0.61,
						-2.95,
						-1.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3632
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 24
					},
					"classroomspace": 2.41,
					"enrolment": 626,
					"ligo": 0.73,
					"location": [
						150.940755704119,
						-33.8771667705698
					],
					"name": "Fairvale Public School",
					"playspace": 21.18,
					"projections": [
						566,
						626,
						630,
						625,
						625,
						630
					],
					"projections_orig": [
						"566",
						"626",
						"630",
						"625",
						"625",
						"630"
					],
					"projections_percentage": [
						-9.58,
						0,
						0.64,
						-0.16,
						-0.16,
						0.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4009
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.26,
					"enrolment": 333,
					"ligo": 0.67,
					"location": [
						150.916966029498,
						-33.8572980718862
					],
					"name": "Smithfield West Public School",
					"playspace": 57.86,
					"projections": [
						309,
						333,
						345,
						330,
						330,
						330
					],
					"projections_orig": [
						"309",
						"333",
						"345",
						"330",
						"330",
						"330"
					],
					"projections_percentage": [
						-7.21,
						0,
						3.6,
						-0.9,
						-0.9,
						-0.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4355
				}
			],
			"uid": 10057
		},
		{
			"classrooms": {
				"demountable": 45,
				"permanent": 198
			},
			"enrolment": 4784,
			"level": "Primary",
			"ligo": 0.56,
			"name": "Bonnyrigg Primary",
			"playspace": 44.22,
			"projections": [
				4784,
				5115,
				4980,
				4765,
				4770
			],
			"projections_percentage": [
				0,
				6.92,
				4.1,
				-0.4,
				-0.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 16
					},
					"classroomspace": 3.17,
					"enrolment": 418,
					"ligo": 0.73,
					"location": [
						150.882423964681,
						-33.859175742191
					],
					"name": "Bossley Park Public School",
					"playspace": 53.93,
					"projections": [
						382,
						418,
						465,
						450,
						435,
						440
					],
					"projections_orig": [
						"382",
						"418",
						"465",
						"450",
						"435",
						"440"
					],
					"projections_percentage": [
						-8.61,
						0,
						11.24,
						7.66,
						4.07,
						5.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1321
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 34
					},
					"classroomspace": 2.93,
					"enrolment": 764,
					"ligo": 0.56,
					"location": [
						150.898998978792,
						-33.8864680443515
					],
					"name": "St Johns Park Public School",
					"playspace": 30.57,
					"projections": [
						782,
						764,
						800,
						780,
						735,
						740
					],
					"projections_orig": [
						"782",
						"764",
						"800",
						"780",
						"735",
						"740"
					],
					"projections_percentage": [
						2.36,
						0,
						4.71,
						2.09,
						-3.8,
						-3.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3029
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 33
					},
					"classroomspace": 2.94,
					"enrolment": 977,
					"ligo": 0.69,
					"location": [
						150.909880528759,
						-33.8882990013686
					],
					"name": "Harrington Street Public School",
					"playspace": 17.6,
					"projections": [
						991,
						977,
						1025,
						1015,
						955,
						940
					],
					"projections_orig": [
						"991",
						"977",
						"1025",
						"1015",
						"955",
						"940"
					],
					"projections_percentage": [
						1.43,
						0,
						4.91,
						3.89,
						-2.25,
						-3.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4314
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 20
					},
					"classroomspace": 2.86,
					"enrolment": 507,
					"ligo": 0.41,
					"location": [
						150.911694550226,
						-33.8793245185741
					],
					"name": "King Park Public School",
					"playspace": 45.26,
					"projections": [
						521,
						507,
						515,
						495,
						485,
						485
					],
					"projections_orig": [
						"521",
						"507",
						"515",
						"495",
						"485",
						"485"
					],
					"projections_percentage": [
						2.76,
						0,
						1.58,
						-2.37,
						-4.34,
						-4.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4467
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.06,
					"enrolment": 252,
					"ligo": 0.45,
					"location": [
						150.887952919576,
						-33.8886651746655
					],
					"name": "Bonnyrigg Public School",
					"playspace": 75.8,
					"projections": [
						232,
						252,
						280,
						270,
						255,
						255
					],
					"projections_orig": [
						"232",
						"252",
						"280",
						"270",
						"255",
						"255"
					],
					"projections_percentage": [
						-7.94,
						0,
						11.11,
						7.14,
						1.19,
						1.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4545
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 20
					},
					"classroomspace": 3.1,
					"enrolment": 459,
					"ligo": 0.51,
					"location": [
						150.890730184434,
						-33.8670984795043
					],
					"name": "Prairievale Public School",
					"playspace": 43.86,
					"projections": [
						422,
						459,
						475,
						455,
						440,
						440
					],
					"projections_orig": [
						"422",
						"459",
						"475",
						"455",
						"440",
						"440"
					],
					"projections_percentage": [
						-8.06,
						0,
						3.49,
						-0.87,
						-4.14,
						-4.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4554
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 18
					},
					"classroomspace": 3.49,
					"enrolment": 541,
					"ligo": 0.47,
					"location": [
						150.905014466369,
						-33.8545263570675
					],
					"name": "William Stimson Public School",
					"playspace": 30.37,
					"projections": [
						567,
						541,
						600,
						580,
						575,
						580
					],
					"projections_orig": [
						"567",
						"541",
						"600",
						"580",
						"575",
						"580"
					],
					"projections_percentage": [
						4.81,
						0,
						10.91,
						7.21,
						6.28,
						7.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4563
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 25
					},
					"classroomspace": 2.95,
					"enrolment": 583,
					"ligo": 0.46,
					"location": [
						150.878813289688,
						-33.8736303999846
					],
					"name": "Governor Philip King Public School",
					"playspace": 39.21,
					"projections": [
						653,
						583,
						640,
						630,
						595,
						595
					],
					"projections_orig": [
						"653",
						"583",
						"640",
						"630",
						"595",
						"595"
					],
					"projections_percentage": [
						12.01,
						0,
						9.78,
						8.06,
						2.06,
						2.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4567
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.99,
					"enrolment": 283,
					"ligo": 0.72,
					"location": [
						150.875893601372,
						-33.8828935537812
					],
					"name": "Edensor Park Public School",
					"playspace": 61.4,
					"projections": [
						279,
						283,
						315,
						305,
						290,
						295
					],
					"projections_orig": [
						"279",
						"283",
						"315",
						"305",
						"290",
						"295"
					],
					"projections_percentage": [
						-1.41,
						0,
						11.31,
						7.77,
						2.47,
						4.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4583
				}
			],
			"uid": 10058
		},
		{
			"classrooms": {
				"demountable": 55,
				"permanent": 136
			},
			"enrolment": 4350,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Bonnyrigg Heights Primary",
			"playspace": 29.12,
			"projections": [
				4350,
				4535,
				5180,
				5770,
				6610
			],
			"projections_percentage": [
				0,
				4.25,
				19.08,
				32.64,
				51.95
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.72,
					"enrolment": 431,
					"ligo": 0.36,
					"location": [
						150.8683578896,
						-33.9020587286856
					],
					"name": "Green Valley Public School",
					"playspace": 23.07,
					"projections": [
						507,
						431,
						460,
						445,
						420,
						415
					],
					"projections_orig": [
						"507",
						"431",
						"460",
						"445",
						"420",
						"415"
					],
					"projections_percentage": [
						17.63,
						0,
						6.73,
						3.25,
						-2.55,
						-3.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2075
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 22
					},
					"classroomspace": 2.62,
					"enrolment": 651,
					"ligo": 0.78,
					"location": [
						150.84858353072,
						-33.9317043767776
					],
					"name": "Hoxton Park Public School",
					"playspace": 29.52,
					"projections": [
						570,
						651,
						765,
						1020,
						1215,
						1400
					],
					"projections_orig": [
						"570",
						"651",
						"765",
						"1020",
						"1215",
						"1400"
					],
					"projections_percentage": [
						-12.44,
						0,
						17.51,
						56.68,
						86.64,
						115.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2187
				},
				{
					"classrooms": {
						"demountable": 23,
						"permanent": 31
					},
					"classroomspace": 3.04,
					"enrolment": 1107,
					"ligo": 0.5,
					"location": [
						150.866779224688,
						-33.8900010525572
					],
					"name": "Bonnyrigg Heights Public School",
					"playspace": 22.36,
					"projections": [
						916,
						1107,
						980,
						980,
						920,
						890
					],
					"projections_orig": [
						"916",
						"1107",
						"980",
						"980",
						"920",
						"890"
					],
					"projections_percentage": [
						-17.25,
						0,
						-11.47,
						-11.47,
						-16.89,
						-19.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4594
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 22
					},
					"classroomspace": 2.26,
					"enrolment": 606,
					"ligo": 0.59,
					"location": [
						150.859391581517,
						-33.912056129619
					],
					"name": "Hinchinbrook Public School",
					"playspace": 51.52,
					"projections": [
						529,
						606,
						585,
						575,
						595,
						660
					],
					"projections_orig": [
						"529",
						"606",
						"585",
						"575",
						"595",
						"660"
					],
					"projections_percentage": [
						-12.71,
						0,
						-3.47,
						-5.12,
						-1.82,
						8.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4613
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 22
					},
					"classroomspace": 2.63,
					"enrolment": 797,
					"ligo": 0.84,
					"location": [
						150.838096006924,
						-33.9384546409992
					],
					"name": "Greenway Park Public School",
					"playspace": 21.99,
					"projections": [
						767,
						797,
						1010,
						1410,
						1840,
						2385
					],
					"projections_orig": [
						"767",
						"797",
						"1010",
						"1410",
						"1840",
						"2385"
					],
					"projections_percentage": [
						-3.76,
						0,
						26.73,
						76.91,
						130.87,
						199.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4624
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 22
					},
					"classroomspace": 2.71,
					"enrolment": 758,
					"ligo": 0.68,
					"location": [
						150.850787072464,
						-33.8881534990344
					],
					"name": "Cecil Hills Public School",
					"playspace": 26.26,
					"projections": [
						646,
						758,
						735,
						750,
						780,
						860
					],
					"projections_orig": [
						"646",
						"758",
						"735",
						"750",
						"780",
						"860"
					],
					"projections_percentage": [
						-14.78,
						0,
						-3.03,
						-1.06,
						2.9,
						13.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4635
				}
			],
			"uid": 10059
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 14
			},
			"enrolment": 451,
			"level": "Primary",
			"ligo": 0.83,
			"name": "Appin Primary",
			"playspace": 98.84,
			"projections": [
				451,
				460,
				645,
				860,
				1010
			],
			"projections_percentage": [
				0,
				2,
				43.02,
				90.69,
				123.95
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 2.51,
					"enrolment": 287,
					"ligo": 0.87,
					"location": [
						150.787934456696,
						-34.1996132565375
					],
					"name": "Appin Public School",
					"playspace": 81.44,
					"projections": [
						202,
						287,
						275,
						395,
						520,
						565
					],
					"projections_orig": [
						"202",
						"287",
						"275",
						"395",
						"520",
						"565"
					],
					"projections_percentage": [
						-29.62,
						0,
						-4.18,
						37.63,
						81.18,
						96.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1045
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.87,
					"enrolment": 164,
					"ligo": 0.79,
					"location": [
						150.713398423338,
						-34.1792128787377
					],
					"name": "Douglas Park Public School",
					"playspace": 116.23,
					"projections": [
						144,
						164,
						185,
						250,
						340,
						445
					],
					"projections_orig": [
						"144",
						"164",
						"185",
						"250",
						"340",
						"445"
					],
					"projections_percentage": [
						-12.2,
						0,
						12.8,
						52.44,
						107.32,
						171.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1770
				}
			],
			"uid": 10060
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 178
			},
			"enrolment": 2304,
			"level": "Primary",
			"ligo": 0.67,
			"name": "West Liverpool Primary",
			"playspace": 77.25,
			"projections": [
				2304,
				2400,
				2390,
				2375,
				2410
			],
			"projections_percentage": [
				0,
				4.17,
				3.73,
				3.08,
				4.6
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 4,
					"enrolment": 388,
					"ligo": 0.54,
					"location": [
						150.899160774279,
						-33.8998749544552
					],
					"name": "Mount Pritchard Public School",
					"playspace": 67.47,
					"projections": [
						442,
						388,
						425,
						415,
						395,
						400
					],
					"projections_orig": [
						"442",
						"388",
						"425",
						"415",
						"395",
						"400"
					],
					"projections_percentage": [
						13.92,
						0,
						9.54,
						6.96,
						1.8,
						3.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2648
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.78,
					"enrolment": 239,
					"ligo": 0.87,
					"location": [
						150.911774871981,
						-33.9049336640886
					],
					"name": "Mount Pritchard East Public School",
					"playspace": 52.96,
					"projections": [
						217,
						239,
						250,
						245,
						235,
						235
					],
					"projections_orig": [
						"217",
						"239",
						"250",
						"245",
						"235",
						"235"
					],
					"projections_percentage": [
						-9.21,
						0,
						4.6,
						2.51,
						-1.67,
						-1.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4210
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.13,
					"enrolment": 326,
					"ligo": 0.66,
					"location": [
						150.89086374878,
						-33.9169744117778
					],
					"name": "Sadleir Public School",
					"playspace": 62.85,
					"projections": [
						292,
						326,
						315,
						325,
						335,
						345
					],
					"projections_orig": [
						"292",
						"326",
						"315",
						"325",
						"335",
						"345"
					],
					"projections_percentage": [
						-10.43,
						0,
						-3.37,
						-0.31,
						2.76,
						5.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4319
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.65,
					"enrolment": 217,
					"ligo": 0.75,
					"location": [
						150.890035051024,
						-33.9091629358883
					],
					"name": "Heckenberg Public School",
					"playspace": 100.59,
					"projections": [
						217,
						217,
						235,
						230,
						235,
						235
					],
					"projections_orig": [
						"217",
						"217",
						"235",
						"230",
						"235",
						"235"
					],
					"projections_percentage": [
						0,
						0,
						8.29,
						5.99,
						8.29,
						8.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4336
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 6.43,
					"enrolment": 245,
					"ligo": 0.67,
					"location": [
						150.881287984179,
						-33.9108610937015
					],
					"name": "Busby Public School",
					"playspace": 93.2,
					"projections": [
						251,
						245,
						250,
						250,
						245,
						250
					],
					"projections_orig": [
						"251",
						"245",
						"250",
						"250",
						"245",
						"250"
					],
					"projections_percentage": [
						2.45,
						0,
						2.04,
						2.04,
						0,
						2.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4337
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 5.13,
					"enrolment": 221,
					"ligo": 0.7,
					"location": [
						150.87696311891,
						-33.9220848508684
					],
					"name": "Miller Public School",
					"playspace": 120.17,
					"projections": [
						229,
						221,
						205,
						210,
						220,
						225
					],
					"projections_orig": [
						"229",
						"221",
						"205",
						"210",
						"220",
						"225"
					],
					"projections_percentage": [
						3.62,
						0,
						-7.24,
						-4.98,
						-0.45,
						1.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4338
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 5.95,
					"enrolment": 277,
					"ligo": 0.72,
					"location": [
						150.897159187718,
						-33.9164188683212
					],
					"name": "Ashcroft Public School",
					"playspace": 78.26,
					"projections": [
						265,
						277,
						285,
						290,
						300,
						310
					],
					"projections_orig": [
						"265",
						"277",
						"285",
						"290",
						"300",
						"310"
					],
					"projections_percentage": [
						-4.33,
						0,
						2.89,
						4.69,
						8.3,
						11.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4344
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 3.61,
					"enrolment": 391,
					"ligo": 0.48,
					"location": [
						150.873428048142,
						-33.9058289104225
					],
					"name": "Busby West Public School",
					"playspace": 42.49,
					"projections": [
						496,
						391,
						435,
						425,
						410,
						410
					],
					"projections_orig": [
						"496",
						"391",
						"435",
						"425",
						"410",
						"410"
					],
					"projections_percentage": [
						26.85,
						0,
						11.25,
						8.7,
						4.86,
						4.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4396
				}
			],
			"uid": 10061
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 96
			},
			"enrolment": 2288,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Liverpool Primary",
			"playspace": 47.12,
			"projections": [
				2288,
				2810,
				3055,
				3255,
				3430
			],
			"projections_percentage": [
				0,
				22.81,
				33.52,
				42.26,
				49.91
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.36,
					"enrolment": 217,
					"ligo": 0.48,
					"location": [
						150.92954037897,
						-33.9104232176675
					],
					"name": "Warwick Farm Public School",
					"playspace": 119.76,
					"projections": [
						259,
						217,
						280,
						295,
						300,
						305
					],
					"projections_orig": [
						"259",
						"217",
						"280",
						"295",
						"300",
						"305"
					],
					"projections_percentage": [
						19.35,
						0,
						29.03,
						35.94,
						38.25,
						40.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3678
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 26
					},
					"classroomspace": 3.07,
					"enrolment": 638,
					"ligo": 0.63,
					"location": [
						150.907857271028,
						-33.926045778594
					],
					"name": "Liverpool West Public School",
					"playspace": 28.62,
					"projections": [
						571,
						638,
						705,
						755,
						775,
						810
					],
					"projections_orig": [
						"571",
						"638",
						"705",
						"755",
						"775",
						"810"
					],
					"projections_percentage": [
						-10.5,
						0,
						10.5,
						18.34,
						21.47,
						26.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4161
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 26
					},
					"classroomspace": 2.72,
					"enrolment": 688,
					"ligo": 0.78,
					"location": [
						150.91436305925,
						-33.9166178126482
					],
					"name": "Marsden Road Public School",
					"playspace": 28.75,
					"projections": [
						624,
						688,
						815,
						870,
						885,
						910
					],
					"projections_orig": [
						"624",
						"688",
						"815",
						"870",
						"885",
						"910"
					],
					"projections_percentage": [
						-9.3,
						0,
						18.46,
						26.45,
						28.63,
						32.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4278
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 28
					},
					"classroomspace": 2.73,
					"enrolment": 745,
					"ligo": 0.8,
					"location": [
						150.925240905855,
						-33.9235629918419
					],
					"name": "Liverpool Public School",
					"playspace": 11.37,
					"projections": [
						716,
						745,
						1010,
						1135,
						1295,
						1405
					],
					"projections_orig": [
						"716",
						"745",
						"1010",
						"1135",
						"1295",
						"1405"
					],
					"projections_percentage": [
						-3.89,
						0,
						35.57,
						52.35,
						73.83,
						88.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7424
				}
			],
			"uid": 10062
		},
		{
			"classrooms": {
				"demountable": 42,
				"permanent": 114
			},
			"enrolment": 3381,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Edmondson Park Primary",
			"playspace": 43.3,
			"projections": [
				3381,
				3585,
				3990,
				4210,
				4450
			],
			"projections_percentage": [
				0,
				6.03,
				18.01,
				24.52,
				31.62
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.53,
					"enrolment": 567,
					"ligo": 0.66,
					"location": [
						150.891018489151,
						-33.946661595715
					],
					"name": "Prestons Public School",
					"playspace": 55.14,
					"projections": [
						447,
						567,
						640,
						715,
						760,
						805
					],
					"projections_orig": [
						"447",
						"567",
						"640",
						"715",
						"760",
						"805"
					],
					"projections_percentage": [
						-21.16,
						0,
						12.87,
						26.1,
						34.04,
						41.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2901
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 25
					},
					"classroomspace": 2.59,
					"enrolment": 931,
					"ligo": 0.64,
					"location": [
						150.910254758079,
						-33.9435012704351
					],
					"name": "Casula Public School",
					"playspace": 18.58,
					"projections": [
						692,
						931,
						920,
						980,
						980,
						1000
					],
					"projections_orig": [
						"692",
						"931",
						"920",
						"980",
						"980",
						"1000"
					],
					"projections_percentage": [
						-25.67,
						0,
						-1.18,
						5.26,
						5.26,
						7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4198
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.41,
					"enrolment": 416,
					"ligo": 0.61,
					"location": [
						150.89325511284,
						-33.932175883842
					],
					"name": "Lurnea Public School",
					"playspace": 51.62,
					"projections": [
						424,
						416,
						440,
						480,
						500,
						530
					],
					"projections_orig": [
						"424",
						"416",
						"440",
						"480",
						"500",
						"530"
					],
					"projections_percentage": [
						1.92,
						0,
						5.77,
						15.38,
						20.19,
						27.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4289
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 6
					},
					"classroomspace": 3.02,
					"enrolment": 296,
					"ligo": 0.53,
					"location": [
						150.858809258137,
						-33.9746106852305
					],
					"name": "Bardia Public School",
					"playspace": 45.44,
					"projections": [
						0,
						296,
						275,
						370,
						465,
						500
					],
					"projections_orig": [
						"0",
						"296",
						"275",
						"370",
						"465",
						"500"
					],
					"projections_percentage": [
						-100,
						0,
						-7.09,
						25,
						57.09,
						68.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4311
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 5.07,
					"enrolment": 179,
					"ligo": 0.78,
					"location": [
						150.890352519849,
						-33.9246352416755
					],
					"name": "Cartwright Public School",
					"playspace": 71.72,
					"projections": [
						177,
						179,
						200,
						220,
						235,
						255
					],
					"projections_orig": [
						"177",
						"179",
						"200",
						"220",
						"235",
						"255"
					],
					"projections_percentage": [
						-1.12,
						0,
						11.73,
						22.91,
						31.28,
						42.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4360
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 24
					},
					"classroomspace": 2.9,
					"enrolment": 992,
					"ligo": 0.86,
					"location": [
						150.871860812695,
						-33.9463637040143
					],
					"name": "Dalmeny Public School",
					"playspace": 17.3,
					"projections": [
						936,
						992,
						1110,
						1225,
						1270,
						1360
					],
					"projections_orig": [
						"936",
						"992",
						"1110",
						"1225",
						"1270",
						"1360"
					],
					"projections_percentage": [
						-5.65,
						0,
						11.9,
						23.49,
						28.02,
						37.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4634
				}
			],
			"uid": 10063
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 76
			},
			"enrolment": 1362,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Rossmore Primary",
			"playspace": 133.35,
			"projections": [
				1362,
				1870,
				3055,
				5250,
				9150
			],
			"projections_percentage": [
				0,
				37.3,
				124.3,
				285.46,
				571.81
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.89,
					"enrolment": 271,
					"ligo": 0.7,
					"location": [
						150.812004223568,
						-33.9338326084582
					],
					"name": "Austral Public School",
					"playspace": 83.51,
					"projections": [
						344,
						271,
						460,
						780,
						1375,
						2310
					],
					"projections_orig": [
						"344",
						"271",
						"460",
						"780",
						"1375",
						"2310"
					],
					"projections_percentage": [
						26.94,
						0,
						69.74,
						187.82,
						407.38,
						752.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1077
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 3.34,
					"enrolment": 134,
					"ligo": 0.72,
					"location": [
						150.731151462594,
						-33.9390327150911
					],
					"name": "Bringelly Public School",
					"playspace": 153.05,
					"projections": [
						139,
						134,
						200,
						225,
						695,
						1580
					],
					"projections_orig": [
						"139",
						"134",
						"200",
						"225",
						"695",
						"1580"
					],
					"projections_percentage": [
						3.73,
						0,
						49.25,
						67.91,
						418.66,
						1079.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1360
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 4
					},
					"classroomspace": 4.88,
					"enrolment": 102,
					"ligo": 0.58,
					"location": [
						150.852064674412,
						-33.841038345282
					],
					"name": "Horsley Park Public School",
					"playspace": 280.76,
					"projections": [
						105,
						102,
						110,
						135,
						165,
						195
					],
					"projections_orig": [
						"105",
						"102",
						"110",
						"135",
						"165",
						"195"
					],
					"projections_percentage": [
						2.94,
						0,
						7.84,
						32.35,
						61.76,
						91.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2182
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.46,
					"enrolment": 83,
					"ligo": 0.81,
					"location": [
						150.691840025966,
						-33.8812260223337
					],
					"name": "Luddenham Public School",
					"playspace": 115.93,
					"projections": [
						81,
						83,
						110,
						125,
						150,
						180
					],
					"projections_orig": [
						"81",
						"83",
						"110",
						"125",
						"150",
						"180"
					],
					"projections_percentage": [
						-2.41,
						0,
						32.53,
						50.6,
						80.72,
						116.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2431
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.6,
					"enrolment": 152,
					"ligo": 0.53,
					"location": [
						150.810102737333,
						-33.9589513252469
					],
					"name": "Leppington Public School",
					"playspace": 160.82,
					"projections": [
						109,
						152,
						275,
						925,
						1635,
						2795
					],
					"projections_orig": [
						"109",
						"152",
						"275",
						"925",
						"1635",
						"2795"
					],
					"projections_percentage": [
						-28.29,
						0,
						80.92,
						508.55,
						975.66,
						1738.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2926
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 7.26,
					"enrolment": 99,
					"ligo": 0.55,
					"location": [
						150.770618344389,
						-33.9458291823145
					],
					"name": "Rossmore Public School",
					"playspace": 90.14,
					"projections": [
						144,
						99,
						215,
						275,
						490,
						1025
					],
					"projections_orig": [
						"144",
						"99",
						"215",
						"275",
						"490",
						"1025"
					],
					"projections_percentage": [
						45.45,
						0,
						117.17,
						177.78,
						394.95,
						935.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2999
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.63,
					"enrolment": 161,
					"ligo": 0.64,
					"location": [
						150.79030754117,
						-33.8839237682524
					],
					"name": "Kemps Creek Public School",
					"playspace": 120.99,
					"projections": [
						156,
						161,
						165,
						175,
						255,
						525
					],
					"projections_orig": [
						"156",
						"161",
						"165",
						"175",
						"255",
						"525"
					],
					"projections_percentage": [
						-3.11,
						0,
						2.48,
						8.7,
						58.39,
						226.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3615
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.03,
					"enrolment": 360,
					"ligo": 0.65,
					"location": [
						150.848804697493,
						-33.9177123427688
					],
					"name": "Middleton Grange Public School",
					"playspace": 61.57,
					"projections": [
						138,
						360,
						335,
						415,
						485,
						540
					],
					"projections_orig": [
						"138",
						"360",
						"335",
						"415",
						"485",
						"540"
					],
					"projections_percentage": [
						-61.67,
						0,
						-6.94,
						15.28,
						34.72,
						50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4647
				}
			],
			"uid": 10064
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 124
			},
			"enrolment": 3121,
			"level": "Primary",
			"ligo": 0.55,
			"name": "Chipping Norton Primary",
			"playspace": 42.29,
			"projections": [
				3121,
				3190,
				3325,
				3375,
				3465
			],
			"projections_percentage": [
				0,
				2.21,
				6.54,
				8.14,
				11.02
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.79,
					"enrolment": 327,
					"ligo": 0.38,
					"location": [
						150.960570865657,
						-33.908802956448
					],
					"name": "Chipping Norton Public School",
					"playspace": 60.02,
					"projections": [
						268,
						327,
						350,
						365,
						370,
						375
					],
					"projections_orig": [
						"268",
						"327",
						"350",
						"365",
						"370",
						"375"
					],
					"projections_percentage": [
						-18.04,
						0,
						7.03,
						11.62,
						13.15,
						14.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1560
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.92,
					"enrolment": 453,
					"ligo": 0.62,
					"location": [
						150.954583929942,
						-33.9481320579308
					],
					"name": "Hammondville Public School",
					"playspace": 45.91,
					"projections": [
						506,
						453,
						470,
						480,
						480,
						490
					],
					"projections_orig": [
						"506",
						"453",
						"470",
						"480",
						"480",
						"490"
					],
					"projections_percentage": [
						11.7,
						0,
						3.75,
						5.96,
						5.96,
						8.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2128
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 19
					},
					"classroomspace": 2.5,
					"enrolment": 619,
					"ligo": 0.54,
					"location": [
						150.936921557423,
						-33.9584932111104
					],
					"name": "Wattle Grove Public School",
					"playspace": 34.46,
					"projections": [
						548,
						619,
						620,
						635,
						640,
						655
					],
					"projections_orig": [
						"548",
						"619",
						"620",
						"635",
						"640",
						"655"
					],
					"projections_percentage": [
						-11.47,
						0,
						0.16,
						2.58,
						3.39,
						5.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3871
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 2.43,
					"enrolment": 686,
					"ligo": 0.53,
					"location": [
						150.953258838289,
						-33.9562751127164
					],
					"name": "Holsworthy Public School",
					"playspace": 46.38,
					"projections": [
						570,
						686,
						685,
						700,
						705,
						720
					],
					"projections_orig": [
						"570",
						"686",
						"685",
						"700",
						"705",
						"720"
					],
					"projections_percentage": [
						-16.91,
						0,
						-0.15,
						2.04,
						2.77,
						4.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4288
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.09,
					"enrolment": 401,
					"ligo": 0.75,
					"location": [
						150.951629934662,
						-33.9327402493539
					],
					"name": "Nuwarra Public School",
					"playspace": 37.93,
					"projections": [
						319,
						401,
						410,
						455,
						480,
						510
					],
					"projections_orig": [
						"319",
						"401",
						"410",
						"455",
						"480",
						"510"
					],
					"projections_percentage": [
						-20.45,
						0,
						2.24,
						13.47,
						19.7,
						27.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4420
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 23
					},
					"classroomspace": 2.59,
					"enrolment": 635,
					"ligo": 0.47,
					"location": [
						150.952176983889,
						-33.9256387066161
					],
					"name": "Newbridge Heights Public School",
					"playspace": 29.06,
					"projections": [
						595,
						635,
						655,
						690,
						700,
						715
					],
					"projections_orig": [
						"595",
						"635",
						"655",
						"690",
						"700",
						"715"
					],
					"projections_percentage": [
						-6.3,
						0,
						3.15,
						8.66,
						10.24,
						12.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4499
				}
			],
			"uid": 10065
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 88
			},
			"enrolment": 2126,
			"level": "Primary",
			"ligo": 0.74,
			"name": "Picton Primary",
			"playspace": 87.29,
			"projections": [
				2126,
				2279,
				2509,
				2709,
				2944
			],
			"projections_percentage": [
				0,
				7.2,
				18.02,
				27.42,
				38.48
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.54,
					"enrolment": 351,
					"ligo": 0.82,
					"location": [
						150.582333657521,
						-34.2933847727368
					],
					"name": "Bargo Public School",
					"playspace": 52.81,
					"projections": [
						381,
						351,
						355,
						370,
						370,
						370
					],
					"projections_orig": [
						"381",
						"351",
						"355",
						"370",
						"370",
						"370"
					],
					"projections_percentage": [
						8.55,
						0,
						1.14,
						5.41,
						5.41,
						5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1134
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.1,
					"enrolment": 170,
					"ligo": 0.84,
					"location": [
						150.543424630778,
						-34.2473394563535
					],
					"name": "Buxton Public School",
					"playspace": 142.61,
					"projections": [
						183,
						170,
						180,
						185,
						185,
						185
					],
					"projections_orig": [
						"183",
						"170",
						"180",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						7.65,
						0,
						5.88,
						8.82,
						8.82,
						8.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1460
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 14
					},
					"classroomspace": 3.02,
					"enrolment": 380,
					"ligo": 0.7,
					"location": [
						150.609406637959,
						-34.1760105230226
					],
					"name": "Picton Public School",
					"playspace": 28.12,
					"projections": [
						484,
						380,
						490,
						555,
						600,
						640
					],
					"projections_orig": [
						"484",
						"380",
						"490",
						"555",
						"600",
						"640"
					],
					"projections_percentage": [
						27.37,
						0,
						28.95,
						46.05,
						57.89,
						68.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2867
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.76,
					"enrolment": 398,
					"ligo": 0.66,
					"location": [
						150.589437897989,
						-34.2271017344063
					],
					"name": "Tahmoor Public School",
					"playspace": 55.36,
					"projections": [
						344,
						398,
						400,
						420,
						430,
						445
					],
					"projections_orig": [
						"344",
						"398",
						"400",
						"420",
						"430",
						"445"
					],
					"projections_percentage": [
						-13.57,
						0,
						0.5,
						5.53,
						8.04,
						11.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3148
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.43,
					"enrolment": 381,
					"ligo": 0.68,
					"location": [
						150.569539864734,
						-34.2040585847635
					],
					"name": "Thirlmere Public School",
					"playspace": 32.65,
					"projections": [
						351,
						381,
						385,
						405,
						410,
						415
					],
					"projections_orig": [
						"351",
						"381",
						"385",
						"405",
						"410",
						"415"
					],
					"projections_percentage": [
						-7.87,
						0,
						1.05,
						6.3,
						7.61,
						8.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3200
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5,
					"enrolment": 39,
					"ligo": 0.79,
					"location": [
						150.571280242992,
						-34.3209896620632
					],
					"name": "Yanderra Public School",
					"playspace": 245.79,
					"projections": [
						53,
						39,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"53",
						"39",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						35.9,
						0,
						-35.9,
						-35.9,
						-35.9,
						-35.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3537
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 16
					},
					"classroomspace": 3.3,
					"enrolment": 407,
					"ligo": 0.69,
					"location": [
						150.684819117204,
						-34.2287892310207
					],
					"name": "Wilton Public School",
					"playspace": 53.66,
					"projections": [
						79,
						407,
						430,
						535,
						675,
						850
					],
					"projections_orig": [
						"79",
						"407",
						"430",
						"535",
						"675",
						"850"
					],
					"projections_percentage": [
						-80.59,
						0,
						5.65,
						31.45,
						65.85,
						108.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4650
				}
			],
			"uid": 10066
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 24
			},
			"enrolment": 578,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Cawdor Primary",
			"playspace": 102.77,
			"projections": [
				578,
				597,
				835,
				1065,
				1280
			],
			"projections_percentage": [
				0,
				3.29,
				44.46,
				84.26,
				121.45
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.26,
					"enrolment": 83,
					"ligo": 0.11,
					"location": [
						150.673887862265,
						-34.110212288967
					],
					"name": "Cawdor Public School",
					"playspace": 50,
					"projections": [
						59,
						83,
						80,
						110,
						135,
						155
					],
					"projections_orig": [
						"59",
						"83",
						"80",
						"110",
						"135",
						"155"
					],
					"projections_percentage": [
						-28.92,
						0,
						-3.61,
						32.53,
						62.65,
						86.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1537
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.66,
					"enrolment": 32,
					"ligo": 0.62,
					"location": [
						150.636099229439,
						-34.0712334417275
					],
					"name": "Mount Hunter Public School",
					"playspace": 239.54,
					"projections": [
						36,
						32,
						25,
						65,
						80,
						90
					],
					"projections_orig": [
						"36",
						"32",
						"<50",
						"65",
						"80",
						"90"
					],
					"projections_percentage": [
						12.5,
						0,
						-21.88,
						103.12,
						150,
						181.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2640
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.52,
					"enrolment": 152,
					"ligo": 0.85,
					"location": [
						150.508550975815,
						-34.079495760483
					],
					"name": "Oakdale Public School",
					"playspace": 83.8,
					"projections": [
						167,
						152,
						185,
						250,
						320,
						395
					],
					"projections_orig": [
						"167",
						"152",
						"185",
						"250",
						"320",
						"395"
					],
					"projections_percentage": [
						9.87,
						0,
						21.71,
						64.47,
						110.53,
						159.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2789
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.3,
					"enrolment": 311,
					"ligo": 0.88,
					"location": [
						150.571529579697,
						-34.0789236166551
					],
					"name": "The Oaks Public School",
					"playspace": 37.76,
					"projections": [
						300,
						311,
						300,
						410,
						530,
						640
					],
					"projections_orig": [
						"300",
						"311",
						"300",
						"410",
						"530",
						"640"
					],
					"projections_percentage": [
						-3.54,
						0,
						-3.54,
						31.83,
						70.42,
						105.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2793
				}
			],
			"uid": 10067
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 151
			},
			"enrolment": 2628,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Campbelltown Primary",
			"playspace": 68.76,
			"projections": [
				2628,
				3100,
				3360,
				3665,
				3990
			],
			"projections_percentage": [
				0,
				17.96,
				27.85,
				39.46,
				51.83
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.98,
					"enrolment": 319,
					"ligo": 0.74,
					"location": [
						150.81582082112,
						-34.0695569243044
					],
					"name": "Campbelltown Public School",
					"playspace": 30.91,
					"projections": [
						317,
						319,
						415,
						490,
						590,
						700
					],
					"projections_orig": [
						"317",
						"319",
						"415",
						"490",
						"590",
						"700"
					],
					"projections_percentage": [
						-0.63,
						0,
						30.09,
						53.61,
						84.95,
						119.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1486
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 3
					},
					"classroomspace": 2.96,
					"enrolment": 155,
					"ligo": 0.65,
					"location": [
						150.859316785257,
						-34.0727965918979
					],
					"name": "Kentlyn Public School",
					"playspace": 54.49,
					"projections": [
						124,
						155,
						165,
						170,
						175,
						180
					],
					"projections_orig": [
						"124",
						"155",
						"165",
						"170",
						"175",
						"180"
					],
					"projections_percentage": [
						-20,
						0,
						6.45,
						9.68,
						12.9,
						16.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2285
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.87,
					"enrolment": 333,
					"ligo": 0.6,
					"location": [
						150.825779742908,
						-34.0615622236796
					],
					"name": "Campbelltown North Public School",
					"playspace": 115.5,
					"projections": [
						367,
						333,
						445,
						490,
						575,
						665
					],
					"projections_orig": [
						"367",
						"333",
						"445",
						"490",
						"575",
						"665"
					],
					"projections_percentage": [
						10.21,
						0,
						33.63,
						47.15,
						72.67,
						99.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4126
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.06,
					"enrolment": 306,
					"ligo": 0.81,
					"location": [
						150.830647627643,
						-34.0720954150123
					],
					"name": "Campbelltown East Public School",
					"playspace": 76.13,
					"projections": [
						288,
						306,
						325,
						325,
						375,
						400
					],
					"projections_orig": [
						"288",
						"306",
						"325",
						"325",
						"375",
						"400"
					],
					"projections_percentage": [
						-5.88,
						0,
						6.21,
						6.21,
						22.55,
						30.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4277
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 2.54,
					"enrolment": 622,
					"ligo": 0.61,
					"location": [
						150.813812072714,
						-34.0864920469936
					],
					"name": "Bradbury Public School",
					"playspace": 47.18,
					"projections": [
						622,
						622,
						725,
						810,
						855,
						905
					],
					"projections_orig": [
						"622",
						"622",
						"725",
						"810",
						"855",
						"905"
					],
					"projections_percentage": [
						0,
						0,
						16.56,
						30.23,
						37.46,
						45.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4403
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4.6,
					"enrolment": 266,
					"ligo": 0.66,
					"location": [
						150.82790495156,
						-34.088223869914
					],
					"name": "Briar Road Public School",
					"playspace": 67.56,
					"projections": [
						297,
						266,
						310,
						325,
						335,
						350
					],
					"projections_orig": [
						"297",
						"266",
						"310",
						"325",
						"335",
						"350"
					],
					"projections_percentage": [
						11.65,
						0,
						16.54,
						22.18,
						25.94,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4458
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 5.11,
					"enrolment": 207,
					"ligo": 0.61,
					"location": [
						150.833504043669,
						-34.082160177693
					],
					"name": "John Warby Public School",
					"playspace": 94.15,
					"projections": [
						308,
						207,
						245,
						260,
						265,
						280
					],
					"projections_orig": [
						"308",
						"207",
						"245",
						"260",
						"265",
						"280"
					],
					"projections_percentage": [
						48.79,
						0,
						18.36,
						25.6,
						28.02,
						35.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4479
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.34,
					"enrolment": 420,
					"ligo": 0.68,
					"location": [
						150.842525609621,
						-34.0671940345251
					],
					"name": "Ruse Public School",
					"playspace": 64.13,
					"projections": [
						382,
						420,
						470,
						490,
						495,
						510
					],
					"projections_orig": [
						"382",
						"420",
						"470",
						"490",
						"495",
						"510"
					],
					"projections_percentage": [
						-9.05,
						0,
						11.9,
						16.67,
						17.86,
						21.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4489
				}
			],
			"uid": 10068
		},
		{
			"classrooms": {
				"demountable": 24,
				"permanent": 180
			},
			"enrolment": 3537,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Cabramatta Primary",
			"playspace": 46.23,
			"projections": [
				3537,
				3770,
				3780,
				3630,
				3675
			],
			"projections_percentage": [
				0,
				6.59,
				6.87,
				2.63,
				3.9
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 42
					},
					"classroomspace": 3.38,
					"enrolment": 715,
					"ligo": 0.39,
					"location": [
						150.941797949178,
						-33.8962446974902
					],
					"name": "Cabramatta Public School",
					"playspace": 19.35,
					"projections": [
						792,
						715,
						835,
						875,
						840,
						855
					],
					"projections_orig": [
						"792",
						"715",
						"835",
						"875",
						"840",
						"855"
					],
					"projections_percentage": [
						10.77,
						0,
						16.78,
						22.38,
						17.48,
						19.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1472
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 43
					},
					"classroomspace": 3.44,
					"enrolment": 874,
					"ligo": 0.67,
					"location": [
						150.938627279339,
						-33.8861973075158
					],
					"name": "Canley Vale Public School",
					"playspace": 16.73,
					"projections": [
						930,
						874,
						910,
						910,
						870,
						880
					],
					"projections_orig": [
						"930",
						"874",
						"910",
						"910",
						"870",
						"880"
					],
					"projections_percentage": [
						6.41,
						0,
						4.12,
						4.12,
						-0.46,
						0.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1494
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 34
					},
					"classroomspace": 3.58,
					"enrolment": 562,
					"ligo": 0.74,
					"location": [
						150.922324998431,
						-33.8962032711731
					],
					"name": "Cabramatta West Public School",
					"playspace": 47.66,
					"projections": [
						569,
						562,
						620,
						615,
						585,
						590
					],
					"projections_orig": [
						"569",
						"562",
						"620",
						"615",
						"585",
						"590"
					],
					"projections_percentage": [
						1.25,
						0,
						10.32,
						9.43,
						4.09,
						4.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3980
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 29
					},
					"classroomspace": 3.17,
					"enrolment": 550,
					"ligo": 0.75,
					"location": [
						150.921730069824,
						-33.8853066708831
					],
					"name": "Canley Heights Public School",
					"playspace": 30.74,
					"projections": [
						572,
						550,
						610,
						600,
						580,
						590
					],
					"projections_orig": [
						"572",
						"550",
						"610",
						"600",
						"580",
						"590"
					],
					"projections_percentage": [
						4,
						0,
						10.91,
						9.09,
						5.45,
						7.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3983
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 7
					},
					"classroomspace": 4.46,
					"enrolment": 151,
					"ligo": 0.72,
					"location": [
						150.964616145768,
						-33.898300056327
					],
					"name": "Lansvale East Public School",
					"playspace": 144.84,
					"projections": [
						104,
						151,
						120,
						115,
						115,
						115
					],
					"projections_orig": [
						"104",
						"151",
						"120",
						"115",
						"115",
						"115"
					],
					"projections_percentage": [
						-31.13,
						0,
						-20.53,
						-23.84,
						-23.84,
						-23.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4391
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 25
					},
					"classroomspace": 3.02,
					"enrolment": 685,
					"ligo": 0.73,
					"location": [
						150.952888492766,
						-33.8917435264393
					],
					"name": "Lansvale Public School",
					"playspace": 18.03,
					"projections": [
						704,
						685,
						675,
						665,
						640,
						645
					],
					"projections_orig": [
						"704",
						"685",
						"675",
						"665",
						"640",
						"645"
					],
					"projections_percentage": [
						2.77,
						0,
						-1.46,
						-2.92,
						-6.57,
						-5.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5220
				}
			],
			"uid": 10069
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 117
			},
			"enrolment": 2733,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Raby Road Primary",
			"playspace": 65.08,
			"projections": [
				2733,
				3210,
				4235,
				5320,
				6280
			],
			"projections_percentage": [
				0,
				17.45,
				54.96,
				94.66,
				129.78
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 33
					},
					"classroomspace": 2.6,
					"enrolment": 805,
					"ligo": 0.58,
					"location": [
						150.831097801242,
						-34.0218562650923
					],
					"name": "St Andrews Public School",
					"playspace": 22.67,
					"projections": [
						701,
						805,
						830,
						885,
						895,
						895
					],
					"projections_orig": [
						"701",
						"805",
						"830",
						"885",
						"895",
						"895"
					],
					"projections_percentage": [
						-12.92,
						0,
						3.11,
						9.94,
						11.18,
						11.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4481
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.96,
					"enrolment": 309,
					"ligo": 0.62,
					"location": [
						150.808690757717,
						-34.0434935998198
					],
					"name": "Claymore Public School",
					"playspace": 117.05,
					"projections": [
						403,
						309,
						375,
						530,
						700,
						840
					],
					"projections_orig": [
						"403",
						"309",
						"375",
						"530",
						"700",
						"840"
					],
					"projections_percentage": [
						30.42,
						0,
						21.36,
						71.52,
						126.54,
						171.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4510
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 21
					},
					"classroomspace": 2.54,
					"enrolment": 519,
					"ligo": 0.62,
					"location": [
						150.803151526146,
						-34.0488259255401
					],
					"name": "Blairmount Public School",
					"playspace": 45.36,
					"projections": [
						487,
						519,
						625,
						980,
						1480,
						2025
					],
					"projections_orig": [
						"487",
						"519",
						"625",
						"980",
						"1480",
						"2025"
					],
					"projections_percentage": [
						-6.17,
						0,
						20.42,
						88.82,
						185.16,
						290.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4535
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.72,
					"enrolment": 346,
					"ligo": 0.79,
					"location": [
						150.810304947558,
						-34.0280439926067
					],
					"name": "Eschol Park Public School",
					"playspace": 66.13,
					"projections": [
						355,
						346,
						350,
						455,
						545,
						620
					],
					"projections_orig": [
						"355",
						"346",
						"350",
						"455",
						"545",
						"620"
					],
					"projections_percentage": [
						2.6,
						0,
						1.16,
						31.5,
						57.51,
						79.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4558
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.57,
					"enrolment": 553,
					"ligo": 0.69,
					"location": [
						150.818838325561,
						-34.0161966521858
					],
					"name": "Robert Townson Public School",
					"playspace": 19.81,
					"projections": [
						580,
						553,
						795,
						1040,
						1250,
						1385
					],
					"projections_orig": [
						"580",
						"553",
						"795",
						"1040",
						"1250",
						"1385"
					],
					"projections_percentage": [
						4.88,
						0,
						43.76,
						88.07,
						126.04,
						150.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4569
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 5
					},
					"classroomspace": 2.99,
					"enrolment": 201,
					"ligo": 0.58,
					"location": [
						150.805032507808,
						-34.0222586190498
					],
					"name": "Kearns Public School",
					"playspace": 119.46,
					"projections": [
						203,
						201,
						235,
						345,
						450,
						515
					],
					"projections_orig": [
						"203",
						"201",
						"235",
						"345",
						"450",
						"515"
					],
					"projections_percentage": [
						1,
						0,
						16.92,
						71.64,
						123.88,
						156.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4593
				}
			],
			"uid": 10070
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 54
			},
			"enrolment": 1129,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Villawood Primary",
			"playspace": 92.74,
			"projections": [
				1129,
				1190,
				1260,
				1270,
				1310
			],
			"projections_percentage": [
				0,
				5.4,
				11.6,
				12.49,
				16.03
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 17
					},
					"classroomspace": 2.84,
					"enrolment": 452,
					"ligo": 0.35,
					"location": [
						150.986737710407,
						-33.8670170377887
					],
					"name": "Old Guildford Public School",
					"playspace": 30.72,
					"projections": [
						298,
						452,
						430,
						470,
						480,
						495
					],
					"projections_orig": [
						"298",
						"452",
						"430",
						"470",
						"480",
						"495"
					],
					"projections_percentage": [
						-34.07,
						0,
						-4.87,
						3.98,
						6.19,
						9.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2801
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3,
					"enrolment": 229,
					"ligo": 0.78,
					"location": [
						150.969928496161,
						-33.8857205787205
					],
					"name": "Carramar Public School",
					"playspace": 112.12,
					"projections": [
						244,
						229,
						270,
						275,
						275,
						285
					],
					"projections_orig": [
						"244",
						"229",
						"270",
						"275",
						"275",
						"285"
					],
					"projections_percentage": [
						6.55,
						0,
						17.9,
						20.09,
						20.09,
						24.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3328
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.85,
					"enrolment": 187,
					"ligo": 0.6,
					"location": [
						150.971446487537,
						-33.8652687119429
					],
					"name": "Yennora Public School",
					"playspace": 155.15,
					"projections": [
						163,
						187,
						195,
						205,
						205,
						210
					],
					"projections_orig": [
						"163",
						"187",
						"195",
						"205",
						"205",
						"210"
					],
					"projections_percentage": [
						-12.83,
						0,
						4.28,
						9.63,
						9.63,
						12.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3986
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.26,
					"enrolment": 261,
					"ligo": 0.71,
					"location": [
						150.971968664959,
						-33.8778743504033
					],
					"name": "Villawood North Public School",
					"playspace": 72.98,
					"projections": [
						296,
						261,
						295,
						310,
						310,
						320
					],
					"projections_orig": [
						"296",
						"261",
						"295",
						"310",
						"310",
						"320"
					],
					"projections_percentage": [
						13.41,
						0,
						13.03,
						18.77,
						18.77,
						22.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4065
				}
			],
			"uid": 10071
		},
		{
			"classrooms": {
				"demountable": 24,
				"permanent": 85
			},
			"enrolment": 2472,
			"level": "Primary",
			"ligo": 0.75,
			"name": "Glenmore Park Primary",
			"playspace": 72.81,
			"projections": [
				2472,
				2665,
				2820,
				2940,
				3080
			],
			"projections_percentage": [
				0,
				7.81,
				14.08,
				18.93,
				24.6
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 3.33,
					"enrolment": 83,
					"ligo": 0.74,
					"location": [
						150.651431593947,
						-33.8361749760247
					],
					"name": "Mulgoa Public School",
					"playspace": 153.98,
					"projections": [
						80,
						83,
						100,
						100,
						105,
						110
					],
					"projections_orig": [
						"80",
						"83",
						"100",
						"100",
						"105",
						"110"
					],
					"projections_percentage": [
						-3.61,
						0,
						20.48,
						20.48,
						26.51,
						32.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2659
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 21
					},
					"classroomspace": 2.51,
					"enrolment": 721,
					"ligo": 0.63,
					"location": [
						150.668128101967,
						-33.7763136772837
					],
					"name": "Regentville Public School",
					"playspace": 31.52,
					"projections": [
						658,
						721,
						785,
						805,
						820,
						835
					],
					"projections_orig": [
						"658",
						"721",
						"785",
						"805",
						"820",
						"835"
					],
					"projections_percentage": [
						-8.74,
						0,
						8.88,
						11.65,
						13.73,
						15.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2951
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.9,
					"enrolment": 92,
					"ligo": 0.73,
					"location": [
						150.64157451762,
						-33.8635376964966
					],
					"name": "Wallacia Public School",
					"playspace": 142.71,
					"projections": [
						84,
						92,
						125,
						160,
						200,
						230
					],
					"projections_orig": [
						"84",
						"92",
						"125",
						"160",
						"200",
						"230"
					],
					"projections_percentage": [
						-8.7,
						0,
						35.87,
						73.91,
						117.39,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3346
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.6,
					"enrolment": 351,
					"ligo": 0.89,
					"location": [
						150.605474510347,
						-33.8901189473057
					],
					"name": "Warragamba Public School",
					"playspace": 42.51,
					"projections": [
						373,
						351,
						405,
						465,
						510,
						570
					],
					"projections_orig": [
						"373",
						"351",
						"405",
						"465",
						"510",
						"570"
					],
					"projections_percentage": [
						6.27,
						0,
						15.38,
						32.48,
						45.3,
						62.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3744
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 20
					},
					"classroomspace": 2.75,
					"enrolment": 675,
					"ligo": 0.81,
					"location": [
						150.681029380503,
						-33.7850809795646
					],
					"name": "Glenmore Park Public School",
					"playspace": 28.72,
					"projections": [
						619,
						675,
						700,
						720,
						730,
						745
					],
					"projections_orig": [
						"619",
						"675",
						"700",
						"720",
						"730",
						"745"
					],
					"projections_percentage": [
						-8.3,
						0,
						3.7,
						6.67,
						8.15,
						10.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4591
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 21
					},
					"classroomspace": 2.86,
					"enrolment": 550,
					"ligo": 0.68,
					"location": [
						150.689621013971,
						-33.7880420512103
					],
					"name": "Surveyors Creek Public School",
					"playspace": 37.4,
					"projections": [
						421,
						550,
						550,
						570,
						575,
						590
					],
					"projections_orig": [
						"421",
						"550",
						"550",
						"570",
						"575",
						"590"
					],
					"projections_percentage": [
						-23.45,
						0,
						0,
						3.64,
						4.55,
						7.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4631
				}
			],
			"uid": 10072
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 86
			},
			"enrolment": 1710,
			"level": "Primary",
			"ligo": 0.81,
			"name": "Blue Mountains Upper Primary",
			"playspace": 77.8,
			"projections": [
				1710,
				1845,
				1830,
				1795,
				1785
			],
			"projections_percentage": [
				0,
				7.89,
				7.02,
				4.97,
				4.39
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.56,
					"enrolment": 335,
					"ligo": 0.92,
					"location": [
						150.28554021333,
						-33.6386784702674
					],
					"name": "Blackheath Public School",
					"playspace": 28.18,
					"projections": [
						307,
						335,
						350,
						345,
						340,
						335
					],
					"projections_orig": [
						"307",
						"335",
						"350",
						"345",
						"340",
						"335"
					],
					"projections_percentage": [
						-8.36,
						0,
						4.48,
						2.99,
						1.49,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1246
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.15,
					"enrolment": 240,
					"ligo": 0.73,
					"location": [
						150.429053821006,
						-33.7214610912147
					],
					"name": "Lawson Public School",
					"playspace": 37.23,
					"projections": [
						171,
						240,
						250,
						250,
						245,
						250
					],
					"projections_orig": [
						"171",
						"240",
						"250",
						"250",
						"245",
						"250"
					],
					"projections_percentage": [
						-28.75,
						0,
						4.17,
						4.17,
						2.08,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2381
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 3.07,
					"enrolment": 267,
					"ligo": 0.64,
					"location": [
						150.336588720885,
						-33.7117160631759
					],
					"name": "Leura Public School",
					"playspace": 57.74,
					"projections": [
						313,
						267,
						300,
						300,
						290,
						290
					],
					"projections_orig": [
						"313",
						"267",
						"300",
						"300",
						"290",
						"290"
					],
					"projections_percentage": [
						17.23,
						0,
						12.36,
						12.36,
						8.61,
						8.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2391
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 0
					},
					"classroomspace": 11.4,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						150.231995692926,
						-33.7154165243031
					],
					"name": "Megalong Public School",
					"playspace": 130.33,
					"projections": [
						16,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						60,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2515
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 4.44,
					"enrolment": 68,
					"ligo": 0.86,
					"location": [
						150.253548221192,
						-33.5922355584722
					],
					"name": "Mount Victoria Public School",
					"playspace": 155.11,
					"projections": [
						84,
						68,
						75,
						80,
						75,
						75
					],
					"projections_orig": [
						"84",
						"68",
						"75",
						"80",
						"75",
						"75"
					],
					"projections_percentage": [
						23.53,
						0,
						10.29,
						17.65,
						10.29,
						10.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2652
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.68,
					"enrolment": 373,
					"ligo": 0.83,
					"location": [
						150.372472774163,
						-33.7138043682895
					],
					"name": "Wentworth Falls Public School",
					"playspace": 34.73,
					"projections": [
						378,
						373,
						410,
						405,
						400,
						395
					],
					"projections_orig": [
						"378",
						"373",
						"410",
						"405",
						"400",
						"395"
					],
					"projections_percentage": [
						1.34,
						0,
						9.92,
						8.58,
						7.24,
						5.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3422
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.11,
					"enrolment": 141,
					"ligo": 0.8,
					"location": [
						150.315673749093,
						-33.6987974488108
					],
					"name": "Katoomba North Public School",
					"playspace": 96.98,
					"projections": [
						159,
						141,
						165,
						160,
						160,
						155
					],
					"projections_orig": [
						"159",
						"141",
						"165",
						"160",
						"160",
						"155"
					],
					"projections_percentage": [
						12.77,
						0,
						17.02,
						13.48,
						13.48,
						9.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3987
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.79,
					"enrolment": 276,
					"ligo": 0.69,
					"location": [
						150.313630485319,
						-33.7195463881693
					],
					"name": "Katoomba Public School",
					"playspace": 82.09,
					"projections": [
						248,
						276,
						285,
						280,
						275,
						275
					],
					"projections_orig": [
						"248",
						"276",
						"285",
						"280",
						"275",
						"275"
					],
					"projections_percentage": [
						-10.14,
						0,
						3.26,
						1.45,
						-0.36,
						-0.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4546
				}
			],
			"uid": 10073
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 78
			},
			"enrolment": 1879,
			"level": "Primary",
			"ligo": 0.79,
			"name": "Blue Mountains Mid Primary",
			"playspace": 48.97,
			"projections": [
				1879,
				1980,
				1960,
				1915,
				1910
			],
			"projections_percentage": [
				0,
				5.38,
				4.31,
				1.92,
				1.65
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 18
					},
					"classroomspace": 2.78,
					"enrolment": 457,
					"ligo": 0.67,
					"location": [
						150.573161402855,
						-33.7041140517797
					],
					"name": "Springwood Public School",
					"playspace": 52.79,
					"projections": [
						332,
						457,
						425,
						420,
						415,
						410
					],
					"projections_orig": [
						"332",
						"457",
						"425",
						"420",
						"415",
						"410"
					],
					"projections_percentage": [
						-27.35,
						0,
						-7,
						-8.1,
						-9.19,
						-10.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3095
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.79,
					"enrolment": 406,
					"ligo": 0.9,
					"location": [
						150.459501078816,
						-33.7262423828468
					],
					"name": "Hazelbrook Public School",
					"playspace": 41.89,
					"projections": [
						478,
						406,
						460,
						450,
						440,
						440
					],
					"projections_orig": [
						"478",
						"406",
						"460",
						"450",
						"440",
						"440"
					],
					"projections_percentage": [
						17.73,
						0,
						13.3,
						10.84,
						8.37,
						8.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3854
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.55,
					"enrolment": 326,
					"ligo": 0.84,
					"location": [
						150.545842398853,
						-33.6912767032821
					],
					"name": "Faulconbridge Public School",
					"playspace": 71.4,
					"projections": [
						338,
						326,
						340,
						340,
						330,
						330
					],
					"projections_orig": [
						"338",
						"326",
						"340",
						"340",
						"330",
						"330"
					],
					"projections_percentage": [
						3.68,
						0,
						4.29,
						4.29,
						1.23,
						1.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4354
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 16
					},
					"classroomspace": 2.53,
					"enrolment": 365,
					"ligo": 0.84,
					"location": [
						150.610521763187,
						-33.6696831016358
					],
					"name": "Winmalee Public School",
					"playspace": 36.9,
					"projections": [
						391,
						365,
						405,
						405,
						395,
						395
					],
					"projections_orig": [
						"391",
						"365",
						"405",
						"405",
						"395",
						"395"
					],
					"projections_percentage": [
						7.12,
						0,
						10.96,
						10.96,
						8.22,
						8.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4436
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.41,
					"enrolment": 325,
					"ligo": 0.7,
					"location": [
						150.586236868589,
						-33.6897795455703
					],
					"name": "Ellison Public School",
					"playspace": 41.87,
					"projections": [
						330,
						325,
						350,
						345,
						335,
						335
					],
					"projections_orig": [
						"330",
						"325",
						"350",
						"345",
						"335",
						"335"
					],
					"projections_percentage": [
						1.54,
						0,
						7.69,
						6.15,
						3.08,
						3.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4568
				}
			],
			"uid": 10074
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 61
			},
			"enrolment": 1466,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Blue Mountains Lower Primary",
			"playspace": 76.02,
			"projections": [
				1466,
				1585,
				1570,
				1535,
				1530
			],
			"projections_percentage": [
				0,
				8.12,
				7.09,
				4.71,
				4.37
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.01,
					"enrolment": 137,
					"ligo": 0.69,
					"location": [
						150.603709000798,
						-33.7366758575536
					],
					"name": "Blaxland Public School",
					"playspace": 136.8,
					"projections": [
						163,
						137,
						165,
						165,
						160,
						160
					],
					"projections_orig": [
						"163",
						"137",
						"165",
						"165",
						"160",
						"160"
					],
					"projections_percentage": [
						18.98,
						0,
						20.44,
						20.44,
						16.79,
						16.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1258
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.53,
					"enrolment": 280,
					"ligo": 0.65,
					"location": [
						150.617703523061,
						-33.7657027745992
					],
					"name": "Glenbrook Public School",
					"playspace": 60.49,
					"projections": [
						249,
						280,
						300,
						295,
						290,
						290
					],
					"projections_orig": [
						"249",
						"280",
						"300",
						"295",
						"290",
						"290"
					],
					"projections_percentage": [
						-11.07,
						0,
						7.14,
						5.36,
						3.57,
						3.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1994
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.65,
					"enrolment": 174,
					"ligo": 0.76,
					"location": [
						150.599071568183,
						-33.7277530635211
					],
					"name": "Warrimoo Public School",
					"playspace": 75.09,
					"projections": [
						201,
						174,
						195,
						195,
						190,
						190
					],
					"projections_orig": [
						"201",
						"174",
						"195",
						"195",
						"190",
						"190"
					],
					"projections_percentage": [
						15.52,
						0,
						12.07,
						12.07,
						9.2,
						9.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4195
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.45,
					"enrolment": 403,
					"ligo": 0.59,
					"location": [
						150.624288296988,
						-33.7464791527448
					],
					"name": "Blaxland East Public School",
					"playspace": 40.97,
					"projections": [
						382,
						403,
						435,
						430,
						420,
						420
					],
					"projections_orig": [
						"382",
						"403",
						"435",
						"430",
						"420",
						"420"
					],
					"projections_percentage": [
						-5.21,
						0,
						7.94,
						6.7,
						4.22,
						4.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4313
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 3.08,
					"enrolment": 254,
					"ligo": 0.73,
					"location": [
						150.630322492268,
						-33.7720010013496
					],
					"name": "Lapstone Public School",
					"playspace": 53.33,
					"projections": [
						217,
						254,
						270,
						270,
						265,
						260
					],
					"projections_orig": [
						"217",
						"254",
						"270",
						"270",
						"265",
						"260"
					],
					"projections_percentage": [
						-14.57,
						0,
						6.3,
						6.3,
						4.33,
						2.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4424
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.14,
					"enrolment": 218,
					"ligo": 0.86,
					"location": [
						150.632872120137,
						-33.7300747338763
					],
					"name": "Mount Riverview Public School",
					"playspace": 89.43,
					"projections": [
						180,
						218,
						220,
						215,
						210,
						210
					],
					"projections_orig": [
						"180",
						"218",
						"220",
						"215",
						"210",
						"210"
					],
					"projections_percentage": [
						-17.43,
						0,
						0.92,
						-1.38,
						-3.67,
						-3.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4435
				}
			],
			"uid": 10075
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 45
			},
			"enrolment": 1075,
			"level": "Primary",
			"ligo": 0.78,
			"name": "Emu Plains Primary",
			"playspace": 61.78,
			"projections": [
				1075,
				1105,
				1100,
				1080,
				1075
			],
			"projections_percentage": [
				0,
				2.79,
				2.33,
				0.47,
				0
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 21
					},
					"classroomspace": 2.54,
					"enrolment": 485,
					"ligo": 0.84,
					"location": [
						150.658540717773,
						-33.755696934138
					],
					"name": "Emu Plains Public School",
					"playspace": 45.82,
					"projections": [
						385,
						485,
						500,
						500,
						490,
						490
					],
					"projections_orig": [
						"385",
						"485",
						"500",
						"500",
						"490",
						"490"
					],
					"projections_percentage": [
						-20.62,
						0,
						3.09,
						3.09,
						1.03,
						1.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1841
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.34,
					"enrolment": 337,
					"ligo": 0.8,
					"location": [
						150.649956396951,
						-33.7369078213267
					],
					"name": "Emu Heights Public School",
					"playspace": 72.19,
					"projections": [
						322,
						337,
						365,
						360,
						355,
						350
					],
					"projections_orig": [
						"322",
						"337",
						"365",
						"360",
						"355",
						"350"
					],
					"projections_percentage": [
						-4.45,
						0,
						8.31,
						6.82,
						5.34,
						3.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4442
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.62,
					"enrolment": 253,
					"ligo": 0.69,
					"location": [
						150.650865755212,
						-33.7650779581007
					],
					"name": "Leonay Public School",
					"playspace": 67.34,
					"projections": [
						209,
						253,
						240,
						240,
						235,
						235
					],
					"projections_orig": [
						"209",
						"253",
						"240",
						"240",
						"235",
						"235"
					],
					"projections_percentage": [
						-17.39,
						0,
						-5.14,
						-5.14,
						-7.11,
						-7.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4475
				}
			],
			"uid": 10076
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 43
			},
			"enrolment": 1142,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Kurrajong Primary",
			"playspace": 29.96,
			"projections": [
				1142,
				1260,
				1300,
				1315,
				1355
			],
			"projections_percentage": [
				0,
				10.33,
				13.84,
				15.15,
				18.65
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 3.37,
					"enrolment": 61,
					"ligo": 0.87,
					"location": [
						150.51631938742,
						-33.4973848441303
					],
					"name": "Bilpin Public School",
					"playspace": 9.54,
					"projections": [
						74,
						61,
						70,
						70,
						70,
						70
					],
					"projections_orig": [
						"74",
						"61",
						"70",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						21.31,
						0,
						14.75,
						14.75,
						14.75,
						14.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1228
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.07,
					"enrolment": 122,
					"ligo": 0.79,
					"location": [
						150.69611106805,
						-33.5064209116673
					],
					"name": "Comleroy Road Public School",
					"playspace": 6.53,
					"projections": [
						153,
						122,
						155,
						155,
						155,
						155
					],
					"projections_orig": [
						"153",
						"122",
						"155",
						"155",
						"155",
						"155"
					],
					"projections_percentage": [
						25.41,
						0,
						27.05,
						27.05,
						27.05,
						27.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1604
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.9,
					"enrolment": 182,
					"ligo": 0.46,
					"location": [
						150.692010169657,
						-33.5504802526539
					],
					"name": "Kurmond Public School",
					"playspace": 61.99,
					"projections": [
						206,
						182,
						215,
						220,
						220,
						225
					],
					"projections_orig": [
						"206",
						"182",
						"215",
						"220",
						"220",
						"225"
					],
					"projections_percentage": [
						13.19,
						0,
						18.13,
						20.88,
						20.88,
						23.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2340
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 6
					},
					"classroomspace": 2.81,
					"enrolment": 240,
					"ligo": 0.53,
					"location": [
						150.662905238008,
						-33.5556553764535
					],
					"name": "Kurrajong Public School",
					"playspace": 1.27,
					"projections": [
						225,
						240,
						270,
						280,
						285,
						295
					],
					"projections_orig": [
						"225",
						"240",
						"270",
						"280",
						"285",
						"295"
					],
					"projections_percentage": [
						-6.25,
						0,
						12.5,
						16.67,
						18.75,
						22.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2342
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 3.44,
					"enrolment": 104,
					"ligo": 0.74,
					"location": [
						150.639105487537,
						-33.5420154117902
					],
					"name": "Kurrajong North Public School",
					"playspace": 10.49,
					"projections": [
						84,
						104,
						110,
						110,
						115,
						120
					],
					"projections_orig": [
						"84",
						"104",
						"110",
						"110",
						"115",
						"120"
					],
					"projections_percentage": [
						-19.23,
						0,
						5.77,
						5.77,
						10.58,
						15.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2344
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.56,
					"enrolment": 206,
					"ligo": 0.81,
					"location": [
						150.717509508362,
						-33.581264920691
					],
					"name": "Richmond North Public School",
					"playspace": 105.6,
					"projections": [
						162,
						206,
						195,
						210,
						215,
						225
					],
					"projections_orig": [
						"162",
						"206",
						"195",
						"210",
						"215",
						"225"
					],
					"projections_percentage": [
						-21.36,
						0,
						-5.34,
						1.94,
						4.37,
						9.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2965
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.69,
					"enrolment": 227,
					"ligo": 0.78,
					"location": [
						150.666072742396,
						-33.5945058871495
					],
					"name": "Grose View Public School",
					"playspace": 14.27,
					"projections": [
						294,
						227,
						245,
						255,
						255,
						265
					],
					"projections_orig": [
						"294",
						"227",
						"245",
						"255",
						"255",
						"265"
					],
					"projections_percentage": [
						29.52,
						0,
						7.93,
						12.33,
						12.33,
						16.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4483
				}
			],
			"uid": 10077
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 45
			},
			"enrolment": 1004,
			"level": "Primary",
			"ligo": 0.73,
			"name": "Hawkesbury West Primary",
			"playspace": 83.43,
			"projections": [
				1004,
				1090,
				1135,
				1165,
				1200
			],
			"projections_percentage": [
				0,
				8.57,
				13.05,
				16.04,
				19.52
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.64,
					"enrolment": 45,
					"ligo": 0.94,
					"location": [
						150.740437782278,
						-33.3727959949823
					],
					"name": "Colo Heights Public School",
					"playspace": 96.13,
					"projections": [
						40,
						45,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"40",
						"45",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						-11.11,
						0,
						11.11,
						11.11,
						11.11,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1346
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.37,
					"enrolment": 126,
					"ligo": 0.72,
					"location": [
						150.877434584625,
						-33.5312007148259
					],
					"name": "Ebenezer Public School",
					"playspace": 37.08,
					"projections": [
						140,
						126,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"140",
						"126",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						11.11,
						0,
						3.17,
						3.17,
						3.17,
						3.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1813
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.97,
					"enrolment": 184,
					"ligo": 0.59,
					"location": [
						150.798758224189,
						-33.5580076097292
					],
					"name": "Freemans Reach Public School",
					"playspace": 53.35,
					"projections": [
						198,
						184,
						210,
						215,
						220,
						225
					],
					"projections_orig": [
						"198",
						"184",
						"210",
						"215",
						"220",
						"225"
					],
					"projections_percentage": [
						7.61,
						0,
						14.13,
						16.85,
						19.57,
						22.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1944
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.36,
					"enrolment": 246,
					"ligo": 0.82,
					"location": [
						150.766964485018,
						-33.5313670594965
					],
					"name": "Glossodia Public School",
					"playspace": 34.23,
					"projections": [
						213,
						246,
						260,
						275,
						285,
						290
					],
					"projections_orig": [
						"213",
						"246",
						"260",
						"275",
						"285",
						"290"
					],
					"projections_percentage": [
						-13.41,
						0,
						5.69,
						11.79,
						15.85,
						17.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2021
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.25,
					"enrolment": 57,
					"ligo": 0.71,
					"location": [
						150.778185552226,
						-33.5112934014607
					],
					"name": "Kurrajong East Public School",
					"playspace": 217.95,
					"projections": [
						111,
						57,
						80,
						85,
						80,
						85
					],
					"projections_orig": [
						"111",
						"57",
						"80",
						"85",
						"80",
						"85"
					],
					"projections_percentage": [
						94.74,
						0,
						40.35,
						49.12,
						40.35,
						49.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2343
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.33,
					"enrolment": 346,
					"ligo": 0.6,
					"location": [
						150.839753961222,
						-33.5577920816439
					],
					"name": "Wilberforce Public School",
					"playspace": 61.86,
					"projections": [
						329,
						346,
						360,
						380,
						400,
						420
					],
					"projections_orig": [
						"329",
						"346",
						"360",
						"380",
						"400",
						"420"
					],
					"projections_percentage": [
						-4.91,
						0,
						4.05,
						9.83,
						15.61,
						21.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3441
				}
			],
			"uid": 10078
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 48
			},
			"enrolment": 1045,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Richmond Primary",
			"playspace": 67.9,
			"projections": [
				1045,
				1185,
				1300,
				1335,
				1385
			],
			"projections_percentage": [
				0,
				13.4,
				24.4,
				27.75,
				32.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.75,
					"enrolment": 208,
					"ligo": 0.81,
					"location": [
						150.735553608576,
						-33.6469317635991
					],
					"name": "Londonderry Public School",
					"playspace": 112.34,
					"projections": [
						191,
						208,
						225,
						255,
						270,
						285
					],
					"projections_orig": [
						"191",
						"208",
						"225",
						"255",
						"270",
						"285"
					],
					"projections_percentage": [
						-8.17,
						0,
						8.17,
						22.6,
						29.81,
						37.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2421
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.3,
					"enrolment": 364,
					"ligo": 0.43,
					"location": [
						150.758268199255,
						-33.5992176565877
					],
					"name": "Richmond Public School",
					"playspace": 55.18,
					"projections": [
						347,
						364,
						395,
						430,
						440,
						455
					],
					"projections_orig": [
						"347",
						"364",
						"395",
						"430",
						"440",
						"455"
					],
					"projections_percentage": [
						-4.67,
						0,
						8.52,
						18.13,
						20.88,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3999
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.75,
					"enrolment": 110,
					"ligo": 0.67,
					"location": [
						150.677114201284,
						-33.6675399017512
					],
					"name": "Castlereagh Public School",
					"playspace": 51.3,
					"projections": [
						92,
						110,
						110,
						120,
						125,
						125
					],
					"projections_orig": [
						"92",
						"110",
						"110",
						"120",
						"125",
						"125"
					],
					"projections_percentage": [
						-16.36,
						0,
						0,
						9.09,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4148
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.01,
					"enrolment": 363,
					"ligo": 0.72,
					"location": [
						150.741506780262,
						-33.6030832776571
					],
					"name": "Hobartville Public School",
					"playspace": 52.78,
					"projections": [
						434,
						363,
						455,
						495,
						500,
						520
					],
					"projections_orig": [
						"434",
						"363",
						"455",
						"495",
						"500",
						"520"
					],
					"projections_percentage": [
						19.56,
						0,
						25.34,
						36.36,
						37.74,
						43.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4452
				}
			],
			"uid": 10079
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 65
			},
			"enrolment": 942,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Windsor Primary",
			"playspace": 65.34,
			"projections": [
				942,
				1150,
				1380,
				1595,
				1785
			],
			"projections_percentage": [
				0,
				22.08,
				46.5,
				69.32,
				89.49
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.17,
					"enrolment": 160,
					"ligo": 0.47,
					"location": [
						150.816228689141,
						-33.6108825910557
					],
					"name": "Windsor Public School",
					"playspace": 36.01,
					"projections": [
						204,
						160,
						205,
						225,
						245,
						260
					],
					"projections_orig": [
						"204",
						"160",
						"205",
						"225",
						"245",
						"260"
					],
					"projections_percentage": [
						27.5,
						0,
						28.12,
						40.62,
						53.12,
						62.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3459
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 5.31,
					"enrolment": 211,
					"ligo": 0.87,
					"location": [
						150.80484025251,
						-33.6181691338545
					],
					"name": "Windsor South Public School",
					"playspace": 80.53,
					"projections": [
						165,
						211,
						205,
						240,
						260,
						275
					],
					"projections_orig": [
						"165",
						"211",
						"205",
						"240",
						"260",
						"275"
					],
					"projections_percentage": [
						-21.8,
						0,
						-2.84,
						13.74,
						23.22,
						30.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4066
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.58,
					"enrolment": 332,
					"ligo": 0.55,
					"location": [
						150.794390945689,
						-33.640186200179
					],
					"name": "Bligh Park Public School",
					"playspace": 60.63,
					"projections": [
						401,
						332,
						395,
						480,
						565,
						645
					],
					"projections_orig": [
						"401",
						"332",
						"395",
						"480",
						"565",
						"645"
					],
					"projections_percentage": [
						20.78,
						0,
						18.98,
						44.58,
						70.18,
						94.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4585
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.06,
					"enrolment": 239,
					"ligo": 0.59,
					"location": [
						150.812361332178,
						-33.6409300387105
					],
					"name": "Windsor Park Public School",
					"playspace": 84.2,
					"projections": [
						282,
						239,
						345,
						435,
						525,
						605
					],
					"projections_orig": [
						"282",
						"239",
						"345",
						"435",
						"525",
						"605"
					],
					"projections_percentage": [
						17.99,
						0,
						44.35,
						82.01,
						119.67,
						153.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4614
				}
			],
			"uid": 10080
		},
		{
			"classrooms": {
				"demountable": 21,
				"permanent": 129
			},
			"enrolment": 3264,
			"level": "Primary",
			"ligo": 0.6,
			"name": "Penrith CBD Primary",
			"playspace": 52.32,
			"projections": [
				3264,
				3530,
				3745,
				3850,
				3920
			],
			"projections_percentage": [
				0,
				8.15,
				14.74,
				17.95,
				20.1
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 2.73,
					"enrolment": 426,
					"ligo": 0.6,
					"location": [
						150.726414628727,
						-33.7639655538434
					],
					"name": "Kingswood Public School",
					"playspace": 81.45,
					"projections": [
						332,
						426,
						435,
						465,
						475,
						480
					],
					"projections_orig": [
						"332",
						"426",
						"435",
						"465",
						"475",
						"480"
					],
					"projections_percentage": [
						-22.07,
						0,
						2.11,
						9.15,
						11.5,
						12.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2312
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 2.81,
					"enrolment": 113,
					"ligo": 0.5,
					"location": [
						150.721750956542,
						-33.7820677098075
					],
					"name": "Orchard Hills Public School",
					"playspace": 40.9,
					"projections": [
						88,
						113,
						110,
						115,
						120,
						125
					],
					"projections_orig": [
						"88",
						"113",
						"110",
						"115",
						"120",
						"125"
					],
					"projections_percentage": [
						-22.12,
						0,
						-2.65,
						1.77,
						6.19,
						10.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2815
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.3,
					"enrolment": 417,
					"ligo": 0.46,
					"location": [
						150.70532344924,
						-33.7554308453328
					],
					"name": "Penrith Public School",
					"playspace": 19.11,
					"projections": [
						396,
						417,
						505,
						535,
						580,
						595
					],
					"projections_orig": [
						"396",
						"417",
						"505",
						"535",
						"580",
						"595"
					],
					"projections_percentage": [
						-5.04,
						0,
						21.1,
						28.3,
						39.09,
						42.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2859
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 3.44,
					"enrolment": 508,
					"ligo": 0.49,
					"location": [
						150.701287009762,
						-33.7630679957137
					],
					"name": "Penrith South Public School",
					"playspace": 54.04,
					"projections": [
						382,
						508,
						525,
						555,
						570,
						585
					],
					"projections_orig": [
						"382",
						"508",
						"525",
						"555",
						"570",
						"585"
					],
					"projections_percentage": [
						-24.8,
						0,
						3.35,
						9.25,
						12.2,
						15.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4138
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 3.32,
					"enrolment": 328,
					"ligo": 0.61,
					"location": [
						150.7118836141,
						-33.7683337806041
					],
					"name": "Kingswood South Public School",
					"playspace": 56.79,
					"projections": [
						307,
						328,
						360,
						380,
						390,
						395
					],
					"projections_orig": [
						"307",
						"328",
						"360",
						"380",
						"390",
						"395"
					],
					"projections_percentage": [
						-6.4,
						0,
						9.76,
						15.85,
						18.9,
						20.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4339
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.7,
					"enrolment": 574,
					"ligo": 0.59,
					"location": [
						150.697048706689,
						-33.7770610138502
					],
					"name": "York Public School",
					"playspace": 53.57,
					"projections": [
						526,
						574,
						645,
						670,
						675,
						690
					],
					"projections_orig": [
						"526",
						"574",
						"645",
						"670",
						"675",
						"690"
					],
					"projections_percentage": [
						-8.36,
						0,
						12.37,
						16.72,
						17.6,
						20.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4482
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.5,
					"enrolment": 366,
					"ligo": 0.8,
					"location": [
						150.683316447607,
						-33.771938926553
					],
					"name": "Jamisontown Public School",
					"playspace": 72.54,
					"projections": [
						325,
						366,
						385,
						400,
						400,
						410
					],
					"projections_orig": [
						"325",
						"366",
						"385",
						"400",
						"400",
						"410"
					],
					"projections_percentage": [
						-11.2,
						0,
						5.19,
						9.29,
						9.29,
						12.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4544
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 18
					},
					"classroomspace": 3.05,
					"enrolment": 532,
					"ligo": 0.77,
					"location": [
						150.74584204423,
						-33.7732652158203
					],
					"name": "Claremont Meadows Public School",
					"playspace": 40.16,
					"projections": [
						422,
						532,
						565,
						625,
						640,
						640
					],
					"projections_orig": [
						"422",
						"532",
						"565",
						"625",
						"640",
						"640"
					],
					"projections_percentage": [
						-20.68,
						0,
						6.2,
						17.48,
						20.3,
						20.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4622
				}
			],
			"uid": 10081
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 84
			},
			"enrolment": 1877,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Penrith North Primary",
			"playspace": 59.37,
			"projections": [
				1877,
				2025,
				2110,
				2155,
				2200
			],
			"projections_percentage": [
				0,
				7.88,
				12.41,
				14.81,
				17.21
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 25
					},
					"classroomspace": 2.69,
					"enrolment": 530,
					"ligo": 0.72,
					"location": [
						150.725657005425,
						-33.7481983362315
					],
					"name": "Cambridge Park Public School",
					"playspace": 40.93,
					"projections": [
						451,
						530,
						575,
						595,
						605,
						615
					],
					"projections_orig": [
						"451",
						"530",
						"575",
						"595",
						"605",
						"615"
					],
					"projections_percentage": [
						-14.91,
						0,
						8.49,
						12.26,
						14.15,
						16.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4060
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.86,
					"enrolment": 135,
					"ligo": 0.76,
					"location": [
						150.71205014965,
						-33.7417737138503
					],
					"name": "Kingswood Park Public School",
					"playspace": 104.85,
					"projections": [
						148,
						135,
						150,
						155,
						160,
						165
					],
					"projections_orig": [
						"148",
						"135",
						"150",
						"155",
						"160",
						"165"
					],
					"projections_percentage": [
						9.63,
						0,
						11.11,
						14.81,
						18.52,
						22.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4346
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 3.66,
					"enrolment": 398,
					"ligo": 0.7,
					"location": [
						150.746007198791,
						-33.7560709137441
					],
					"name": "Werrington Public School",
					"playspace": 47.69,
					"projections": [
						411,
						398,
						460,
						485,
						500,
						510
					],
					"projections_orig": [
						"411",
						"398",
						"460",
						"485",
						"500",
						"510"
					],
					"projections_percentage": [
						3.27,
						0,
						15.58,
						21.86,
						25.63,
						28.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4473
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.63,
					"enrolment": 402,
					"ligo": 0.66,
					"location": [
						150.722821480506,
						-33.7374252822137
					],
					"name": "Cambridge Gardens Public School",
					"playspace": 52.53,
					"projections": [
						291,
						402,
						400,
						415,
						420,
						430
					],
					"projections_orig": [
						"291",
						"402",
						"400",
						"415",
						"420",
						"430"
					],
					"projections_percentage": [
						-27.61,
						0,
						-0.5,
						3.23,
						4.48,
						6.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4484
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 13
					},
					"classroomspace": 3.16,
					"enrolment": 412,
					"ligo": 0.64,
					"location": [
						150.746658511681,
						-33.744905316807
					],
					"name": "Werrington County Public School",
					"playspace": 50.84,
					"projections": [
						325,
						412,
						440,
						460,
						470,
						480
					],
					"projections_orig": [
						"325",
						"412",
						"440",
						"460",
						"470",
						"480"
					],
					"projections_percentage": [
						-21.12,
						0,
						6.8,
						11.65,
						14.08,
						16.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4541
				}
			],
			"uid": 10082
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 95
			},
			"enrolment": 2279,
			"level": "Primary",
			"ligo": 0.6,
			"name": "St Clair Primary",
			"playspace": 53.17,
			"projections": [
				2279,
				2390,
				2505,
				2590,
				2675
			],
			"projections_percentage": [
				0,
				4.87,
				9.92,
				13.65,
				17.38
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.79,
					"enrolment": 404,
					"ligo": 0.62,
					"location": [
						150.800283309353,
						-33.7967135407229
					],
					"name": "Clairgate Public School",
					"playspace": 52.96,
					"projections": [
						374,
						404,
						435,
						450,
						460,
						470
					],
					"projections_orig": [
						"374",
						"404",
						"435",
						"450",
						"460",
						"470"
					],
					"projections_percentage": [
						-7.43,
						0,
						7.67,
						11.39,
						13.86,
						16.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4527
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.63,
					"enrolment": 272,
					"ligo": 0.45,
					"location": [
						150.786997981092,
						-33.796197070162
					],
					"name": "St Clair Public School",
					"playspace": 98.15,
					"projections": [
						265,
						272,
						310,
						320,
						320,
						330
					],
					"projections_orig": [
						"265",
						"272",
						"310",
						"320",
						"320",
						"330"
					],
					"projections_percentage": [
						-2.57,
						0,
						13.97,
						17.65,
						17.65,
						21.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4531
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 20
					},
					"classroomspace": 2.52,
					"enrolment": 652,
					"ligo": 0.62,
					"location": [
						150.782462887474,
						-33.8060492137746
					],
					"name": "Blackwell Public School",
					"playspace": 28.53,
					"projections": [
						523,
						652,
						665,
						690,
						710,
						730
					],
					"projections_orig": [
						"523",
						"652",
						"665",
						"690",
						"710",
						"730"
					],
					"projections_percentage": [
						-19.79,
						0,
						1.99,
						5.83,
						8.9,
						11.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4559
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.66,
					"enrolment": 374,
					"ligo": 0.69,
					"location": [
						150.773922714087,
						-33.7937016358343
					],
					"name": "Banks Public School",
					"playspace": 52.57,
					"projections": [
						325,
						374,
						380,
						395,
						405,
						415
					],
					"projections_orig": [
						"325",
						"374",
						"380",
						"395",
						"405",
						"415"
					],
					"projections_percentage": [
						-13.1,
						0,
						1.6,
						5.61,
						8.29,
						10.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4571
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 20
					},
					"classroomspace": 2.52,
					"enrolment": 577,
					"ligo": 0.6,
					"location": [
						150.803415619054,
						-33.8048396070605
					],
					"name": "James Erskine Public School",
					"playspace": 33.62,
					"projections": [
						560,
						577,
						600,
						650,
						695,
						730
					],
					"projections_orig": [
						"560",
						"577",
						"600",
						"650",
						"695",
						"730"
					],
					"projections_percentage": [
						-2.95,
						0,
						3.99,
						12.65,
						20.45,
						26.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4579
				}
			],
			"uid": 10083
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 63
			},
			"enrolment": 1525,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Cranebrook Primary",
			"playspace": 74.89,
			"projections": [
				1525,
				1605,
				1770,
				1905,
				2270
			],
			"projections_percentage": [
				0,
				5.25,
				16.07,
				24.92,
				48.85
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.5,
					"enrolment": 355,
					"ligo": 0.42,
					"location": [
						150.752059852492,
						-33.7078072038979
					],
					"name": "Llandilo Public School",
					"playspace": 64.29,
					"projections": [
						284,
						355,
						420,
						500,
						575,
						905
					],
					"projections_orig": [
						"284",
						"355",
						"420",
						"500",
						"575",
						"905"
					],
					"projections_percentage": [
						-20,
						0,
						18.31,
						40.85,
						61.97,
						154.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2413
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.82,
					"enrolment": 258,
					"ligo": 0.73,
					"location": [
						150.707783698565,
						-33.7216811898758
					],
					"name": "Braddock Public School",
					"playspace": 140.12,
					"projections": [
						189,
						258,
						240,
						260,
						275,
						285
					],
					"projections_orig": [
						"189",
						"258",
						"240",
						"260",
						"275",
						"285"
					],
					"projections_percentage": [
						-26.74,
						0,
						-6.98,
						0.78,
						6.59,
						10.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4525
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 18
					},
					"classroomspace": 2.37,
					"enrolment": 516,
					"ligo": 0.61,
					"location": [
						150.7093850509,
						-33.7128779366819
					],
					"name": "Samuel Terry Public School",
					"playspace": 38.15,
					"projections": [
						481,
						516,
						555,
						595,
						620,
						635
					],
					"projections_orig": [
						"481",
						"516",
						"555",
						"595",
						"620",
						"635"
					],
					"projections_percentage": [
						-6.78,
						0,
						7.56,
						15.31,
						20.16,
						23.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4560
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 12
					},
					"classroomspace": 2.57,
					"enrolment": 396,
					"ligo": 0.31,
					"location": [
						150.708720794324,
						-33.7039954830488
					],
					"name": "Henry Fulton Public School",
					"playspace": 56.99,
					"projections": [
						310,
						396,
						390,
						415,
						435,
						445
					],
					"projections_orig": [
						"310",
						"396",
						"390",
						"415",
						"435",
						"445"
					],
					"projections_percentage": [
						-21.72,
						0,
						-1.52,
						4.8,
						9.85,
						12.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4619
				}
			],
			"uid": 10084
		},
		{
			"classrooms": {
				"demountable": 67,
				"permanent": 182
			},
			"enrolment": 4764,
			"level": "Primary",
			"ligo": 0.83,
			"name": "Auburn Primary",
			"playspace": 18.35,
			"projections": [
				4764,
				6410,
				8055,
				8665,
				9125
			],
			"projections_percentage": [
				0,
				34.55,
				69.08,
				81.88,
				91.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 28
					},
					"classroomspace": 2.69,
					"enrolment": 713,
					"ligo": 0.88,
					"location": [
						151.039228448383,
						-33.8411171289936
					],
					"name": "Auburn North Public School",
					"playspace": 25.11,
					"projections": [
						565,
						713,
						820,
						975,
						1045,
						1070
					],
					"projections_orig": [
						"565",
						"713",
						"820",
						"975",
						"1045",
						"1070"
					],
					"projections_percentage": [
						-20.76,
						0,
						15.01,
						36.75,
						46.56,
						50.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1073
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 26
					},
					"classroomspace": 3.63,
					"enrolment": 683,
					"ligo": 0.88,
					"location": [
						151.020267988256,
						-33.8600553852494
					],
					"name": "Auburn West Public School",
					"playspace": 14.38,
					"projections": [
						737,
						683,
						930,
						1020,
						995,
						990
					],
					"projections_orig": [
						"737",
						"683",
						"930",
						"1020",
						"995",
						"990"
					],
					"projections_percentage": [
						7.91,
						0,
						36.16,
						49.34,
						45.68,
						44.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1075
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 35
					},
					"classroomspace": 2.84,
					"enrolment": 894,
					"ligo": 0.79,
					"location": [
						151.027696123098,
						-33.8699295115984
					],
					"name": "Berala Public School",
					"playspace": 14.27,
					"projections": [
						881,
						894,
						1020,
						1185,
						1210,
						1235
					],
					"projections_orig": [
						"881",
						"894",
						"1020",
						"1185",
						"1210",
						"1235"
					],
					"projections_percentage": [
						-1.45,
						0,
						14.09,
						32.55,
						35.35,
						38.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1199
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 25
					},
					"classroomspace": 2.83,
					"enrolment": 740,
					"ligo": 0.75,
					"location": [
						151.046783064192,
						-33.8611955574813
					],
					"name": "Lidcombe Public School",
					"playspace": 20.54,
					"projections": [
						549,
						740,
						935,
						1115,
						1180,
						1240
					],
					"projections_orig": [
						"549",
						"740",
						"935",
						"1115",
						"1180",
						"1240"
					],
					"projections_percentage": [
						-25.81,
						0,
						26.35,
						50.68,
						59.46,
						67.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2394
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.52,
					"enrolment": 250,
					"ligo": 0.72,
					"location": [
						151.024817352281,
						-33.8857485404113
					],
					"name": "Regents Park Public School",
					"playspace": 20.6,
					"projections": [
						283,
						250,
						340,
						390,
						395,
						405
					],
					"projections_orig": [
						"283",
						"250",
						"340",
						"390",
						"395",
						"405"
					],
					"projections_percentage": [
						13.2,
						0,
						36,
						56,
						58,
						62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2950
				},
				{
					"classrooms": {
						"demountable": 23,
						"permanent": 18
					},
					"classroomspace": 2.89,
					"enrolment": 941,
					"ligo": 0.93,
					"location": [
						151.05424810258,
						-33.8407280685841
					],
					"name": "Newington Public School",
					"playspace": 12.23,
					"projections": [
						533,
						941,
						1380,
						2160,
						2525,
						2755
					],
					"projections_orig": [
						"533",
						"941",
						"1380",
						"2160",
						"2525",
						"2755"
					],
					"projections_percentage": [
						-43.36,
						0,
						46.65,
						129.54,
						168.33,
						192.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4627
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						151.05424810258,
						-33.8407280685841
					],
					"name": "Wentworth Point Public School (proposed)",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4662
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 34
					},
					"classroomspace": 3.89,
					"enrolment": 543,
					"ligo": 0.7,
					"location": [
						151.031918221151,
						-33.8550347255295
					],
					"name": "Auburn Public School",
					"playspace": 21.3,
					"projections": [
						583,
						543,
						985,
						1210,
						1315,
						1430
					],
					"projections_orig": [
						"583",
						"543",
						"985",
						"1210",
						"1315",
						"1430"
					],
					"projections_percentage": [
						7.37,
						0,
						81.4,
						122.84,
						142.17,
						163.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7403
				}
			],
			"uid": 10085
		},
		{
			"classrooms": {
				"demountable": 42,
				"permanent": 111
			},
			"enrolment": 3064,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Bankstown Primary",
			"playspace": 37.13,
			"projections": [
				3064,
				3575,
				4080,
				4595,
				4995
			],
			"projections_percentage": [
				0,
				16.68,
				33.16,
				49.97,
				63.02
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 8
					},
					"classroomspace": 2.72,
					"enrolment": 367,
					"ligo": 0.73,
					"location": [
						151.038595001779,
						-33.9058862470658
					],
					"name": "Bankstown North Public School",
					"playspace": 51.73,
					"projections": [
						370,
						367,
						470,
						545,
						625,
						690
					],
					"projections_orig": [
						"370",
						"367",
						"470",
						"545",
						"625",
						"690"
					],
					"projections_percentage": [
						0.82,
						0,
						28.07,
						48.5,
						70.3,
						88.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1124
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 23
					},
					"classroomspace": 2.82,
					"enrolment": 566,
					"ligo": 0.69,
					"location": [
						151.01357027348,
						-33.9250252490807
					],
					"name": "Condell Park Public School",
					"playspace": 21.25,
					"projections": [
						553,
						566,
						650,
						705,
						760,
						800
					],
					"projections_orig": [
						"553",
						"566",
						"650",
						"705",
						"760",
						"800"
					],
					"projections_percentage": [
						-2.3,
						0,
						14.84,
						24.56,
						34.28,
						41.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3789
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 20
					},
					"classroomspace": 3.26,
					"enrolment": 546,
					"ligo": 0.66,
					"location": [
						151.026893235243,
						-33.9080813866229
					],
					"name": "Yagoona Public School",
					"playspace": 30.75,
					"projections": [
						520,
						546,
						605,
						670,
						740,
						785
					],
					"projections_orig": [
						"520",
						"546",
						"605",
						"670",
						"740",
						"785"
					],
					"projections_percentage": [
						-4.76,
						0,
						10.81,
						22.71,
						35.53,
						43.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3869
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 3.32,
					"enrolment": 262,
					"ligo": 0.37,
					"location": [
						151.012911325612,
						-33.9141565216553
					],
					"name": "Wattawa Heights Public School",
					"playspace": 42.13,
					"projections": [
						240,
						262,
						300,
						330,
						360,
						380
					],
					"projections_orig": [
						"240",
						"262",
						"300",
						"330",
						"360",
						"380"
					],
					"projections_percentage": [
						-8.4,
						0,
						14.5,
						25.95,
						37.4,
						45.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4059
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 8
					},
					"classroomspace": 2.89,
					"enrolment": 312,
					"ligo": 0.53,
					"location": [
						151.019073883215,
						-33.9154250490517
					],
					"name": "Bankstown West Public School",
					"playspace": 35.39,
					"projections": [
						232,
						312,
						320,
						355,
						390,
						415
					],
					"projections_orig": [
						"232",
						"312",
						"320",
						"355",
						"390",
						"415"
					],
					"projections_percentage": [
						-25.64,
						0,
						2.56,
						13.78,
						25,
						33.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4142
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 2
					},
					"classroomspace": 3.39,
					"enrolment": 149,
					"ligo": 1,
					"location": [
						151.038879522757,
						-33.9306992741421
					],
					"name": "Bankstown South Infants School",
					"playspace": 66.69,
					"projections": [
						116,
						149,
						155,
						190,
						220,
						250
					],
					"projections_orig": [
						"116",
						"149",
						"155",
						"190",
						"220",
						"250"
					],
					"projections_percentage": [
						-22.15,
						0,
						4.03,
						27.52,
						47.65,
						67.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5246
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 41
					},
					"classroomspace": 2.64,
					"enrolment": 862,
					"ligo": 0.6,
					"location": [
						151.034786041055,
						-33.9216169501696
					],
					"name": "Bankstown Public School",
					"playspace": 12,
					"projections": [
						990,
						862,
						1075,
						1285,
						1500,
						1675
					],
					"projections_orig": [
						"990",
						"862",
						"1075",
						"1285",
						"1500",
						"1675"
					],
					"projections_percentage": [
						14.85,
						0,
						24.71,
						49.07,
						74.01,
						94.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7405
				}
			],
			"uid": 10086
		},
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 139
			},
			"enrolment": 3322,
			"level": "Primary",
			"ligo": 0.64,
			"name": "Sefton Primary",
			"playspace": 39.61,
			"projections": [
				3322,
				3765,
				4175,
				4475,
				4630
			],
			"projections_percentage": [
				0,
				13.34,
				25.68,
				34.71,
				39.37
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.67,
					"enrolment": 353,
					"ligo": 0.54,
					"location": [
						151.005293029393,
						-33.9054308832447
					],
					"name": "Bass Hill Public School",
					"playspace": 51.71,
					"projections": [
						373,
						353,
						440,
						465,
						485,
						500
					],
					"projections_orig": [
						"373",
						"353",
						"440",
						"465",
						"485",
						"500"
					],
					"projections_percentage": [
						5.67,
						0,
						24.65,
						31.73,
						37.39,
						41.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1148
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 28
					},
					"classroomspace": 2.77,
					"enrolment": 679,
					"ligo": 0.67,
					"location": [
						151.001525992758,
						-33.8864173799669
					],
					"name": "Chester Hill Public School",
					"playspace": 34.5,
					"projections": [
						542,
						679,
						700,
						825,
						920,
						950
					],
					"projections_orig": [
						"542",
						"679",
						"700",
						"825",
						"920",
						"950"
					],
					"projections_percentage": [
						-20.18,
						0,
						3.09,
						21.5,
						35.49,
						39.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3698
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 28
					},
					"classroomspace": 2.4,
					"enrolment": 853,
					"ligo": 0.54,
					"location": [
						150.99244877628,
						-33.9118779317418
					],
					"name": "Georges Hall Public School",
					"playspace": 20.55,
					"projections": [
						811,
						853,
						915,
						930,
						965,
						995
					],
					"projections_orig": [
						"811",
						"853",
						"915",
						"930",
						"965",
						"995"
					],
					"projections_percentage": [
						-4.92,
						0,
						7.27,
						9.03,
						13.13,
						16.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3702
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 3.62,
					"enrolment": 261,
					"ligo": 0.78,
					"location": [
						150.985306306003,
						-33.889829014333
					],
					"name": "Villawood East Public School",
					"playspace": 66.24,
					"projections": [
						253,
						261,
						305,
						335,
						355,
						370
					],
					"projections_orig": [
						"253",
						"261",
						"305",
						"335",
						"355",
						"370"
					],
					"projections_percentage": [
						-3.07,
						0,
						16.86,
						28.35,
						36.02,
						41.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3977
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.48,
					"enrolment": 505,
					"ligo": 0.44,
					"location": [
						151.000336427955,
						-33.8731298320673
					],
					"name": "Chester Hill North Public School",
					"playspace": 43.77,
					"projections": [
						518,
						505,
						610,
						745,
						845,
						885
					],
					"projections_orig": [
						"518",
						"505",
						"610",
						"745",
						"845",
						"885"
					],
					"projections_percentage": [
						2.57,
						0,
						20.79,
						47.52,
						67.33,
						75.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3981
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 17
					},
					"classroomspace": 2.45,
					"enrolment": 576,
					"ligo": 0.54,
					"location": [
						151.021207833206,
						-33.8953491734546
					],
					"name": "Birrong Public School",
					"playspace": 22.82,
					"projections": [
						535,
						576,
						680,
						745,
						770,
						790
					],
					"projections_orig": [
						"535",
						"576",
						"680",
						"745",
						"770",
						"790"
					],
					"projections_percentage": [
						-7.12,
						0,
						18.06,
						29.34,
						33.68,
						37.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4057
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 5
					},
					"classroomspace": 2.46,
					"enrolment": 95,
					"ligo": 1,
					"location": [
						151.009135319793,
						-33.8894035242283
					],
					"name": "Sefton Infants School",
					"playspace": 37.68,
					"projections": [
						90,
						95,
						115,
						130,
						135,
						140
					],
					"projections_orig": [
						"90",
						"95",
						"115",
						"130",
						"135",
						"140"
					],
					"projections_percentage": [
						-5.26,
						0,
						21.05,
						36.84,
						42.11,
						47.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5188
				}
			],
			"uid": 10087
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 176
			},
			"enrolment": 3618,
			"level": "Primary",
			"ligo": 0.6,
			"name": "Padstow Primary",
			"playspace": 60.37,
			"projections": [
				3618,
				3960,
				4075,
				4215,
				4365
			],
			"projections_percentage": [
				0,
				9.45,
				12.63,
				16.5,
				20.65
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.41,
					"enrolment": 490,
					"ligo": 0.58,
					"location": [
						151.00032138068,
						-33.9653882392771
					],
					"name": "Panania Public School",
					"playspace": 51.65,
					"projections": [
						458,
						490,
						515,
						525,
						540,
						560
					],
					"projections_orig": [
						"458",
						"490",
						"515",
						"525",
						"540",
						"560"
					],
					"projections_percentage": [
						-6.53,
						0,
						5.1,
						7.14,
						10.2,
						14.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1809
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.39,
					"enrolment": 254,
					"ligo": 0.87,
					"location": [
						150.980305105822,
						-33.9414764518932
					],
					"name": "Milperra Public School",
					"playspace": 74.03,
					"projections": [
						228,
						254,
						270,
						275,
						280,
						290
					],
					"projections_orig": [
						"228",
						"254",
						"270",
						"275",
						"280",
						"290"
					],
					"projections_percentage": [
						-10.24,
						0,
						6.3,
						8.27,
						10.24,
						14.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2560
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.44,
					"enrolment": 340,
					"ligo": 0.61,
					"location": [
						151.031204856313,
						-33.9539026947552
					],
					"name": "Padstow Park Public School",
					"playspace": 61.05,
					"projections": [
						323,
						340,
						380,
						385,
						400,
						410
					],
					"projections_orig": [
						"323",
						"340",
						"380",
						"385",
						"400",
						"410"
					],
					"projections_percentage": [
						-5,
						0,
						11.76,
						13.24,
						17.65,
						20.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2826
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.04,
					"enrolment": 311,
					"ligo": 0.64,
					"location": [
						151.016376861956,
						-33.9443294149885
					],
					"name": "Revesby Public School",
					"playspace": 26.62,
					"projections": [
						305,
						311,
						350,
						360,
						370,
						380
					],
					"projections_orig": [
						"305",
						"311",
						"350",
						"360",
						"370",
						"380"
					],
					"projections_percentage": [
						-1.93,
						0,
						12.54,
						15.76,
						18.97,
						22.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2958
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.89,
					"enrolment": 180,
					"ligo": 0.39,
					"location": [
						150.992524813715,
						-33.9580746005681
					],
					"name": "East Hills Public School",
					"playspace": 74.15,
					"projections": [
						152,
						180,
						185,
						190,
						195,
						200
					],
					"projections_orig": [
						"152",
						"180",
						"185",
						"190",
						"195",
						"200"
					],
					"projections_percentage": [
						-15.56,
						0,
						2.78,
						5.56,
						8.33,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3924
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 13
					},
					"classroomspace": 2.42,
					"enrolment": 391,
					"ligo": 0.6,
					"location": [
						151.030801402577,
						-33.9667434734505
					],
					"name": "Padstow Heights Public School",
					"playspace": 42.51,
					"projections": [
						382,
						391,
						445,
						460,
						475,
						490
					],
					"projections_orig": [
						"382",
						"391",
						"445",
						"460",
						"475",
						"490"
					],
					"projections_percentage": [
						-2.3,
						0,
						13.81,
						17.65,
						21.48,
						25.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3958
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.31,
					"enrolment": 368,
					"ligo": 0.73,
					"location": [
						150.999790089148,
						-33.945876912284
					],
					"name": "Panania North Public School",
					"playspace": 61.79,
					"projections": [
						322,
						368,
						415,
						420,
						435,
						450
					],
					"projections_orig": [
						"322",
						"368",
						"415",
						"420",
						"435",
						"450"
					],
					"projections_percentage": [
						-12.5,
						0,
						12.77,
						14.13,
						18.21,
						22.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4012
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.35,
					"enrolment": 326,
					"ligo": 0.61,
					"location": [
						151.017201009737,
						-33.9596255879613
					],
					"name": "Revesby South Public School",
					"playspace": 51.23,
					"projections": [
						310,
						326,
						355,
						365,
						375,
						385
					],
					"projections_orig": [
						"310",
						"326",
						"355",
						"365",
						"375",
						"385"
					],
					"projections_percentage": [
						-4.91,
						0,
						8.9,
						11.96,
						15.03,
						18.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4016
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.58,
					"enrolment": 354,
					"ligo": 0.44,
					"location": [
						151.030618517707,
						-33.94368144689
					],
					"name": "Padstow North Public School",
					"playspace": 91.14,
					"projections": [
						345,
						354,
						400,
						435,
						470,
						500
					],
					"projections_orig": [
						"345",
						"354",
						"400",
						"435",
						"470",
						"500"
					],
					"projections_percentage": [
						-2.54,
						0,
						12.99,
						22.88,
						32.77,
						41.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4088
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.19,
					"enrolment": 204,
					"ligo": 0.48,
					"location": [
						151.008116295764,
						-33.9573092690013
					],
					"name": "Tower Street Public School",
					"playspace": 96.72,
					"projections": [
						177,
						204,
						205,
						210,
						215,
						220
					],
					"projections_orig": [
						"177",
						"204",
						"205",
						"210",
						"215",
						"220"
					],
					"projections_percentage": [
						-13.24,
						0,
						0.49,
						2.94,
						5.39,
						7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4151
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.46,
					"enrolment": 400,
					"ligo": 0.63,
					"location": [
						151.009603216553,
						-33.9682168391521
					],
					"name": "Picnic Point Public School",
					"playspace": 33.16,
					"projections": [
						369,
						400,
						440,
						450,
						460,
						480
					],
					"projections_orig": [
						"369",
						"400",
						"440",
						"450",
						"460",
						"480"
					],
					"projections_percentage": [
						-7.75,
						0,
						10,
						12.5,
						15,
						20
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4342
				}
			],
			"uid": 10088
		},
		{
			"classrooms": {
				"demountable": 33,
				"permanent": 131
			},
			"enrolment": 3393,
			"level": "Primary",
			"ligo": 0.74,
			"name": "Toongabbie Primary",
			"playspace": 86.55,
			"projections": [
				3393,
				3690,
				3940,
				4155,
				4360
			],
			"projections_percentage": [
				0,
				8.75,
				16.12,
				22.46,
				28.5
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 22
					},
					"classroomspace": 2.53,
					"enrolment": 684,
					"ligo": 0.87,
					"location": [
						150.991506215155,
						-33.7862328246324
					],
					"name": "Northmead Public School",
					"playspace": 28.15,
					"projections": [
						630,
						684,
						750,
						780,
						800,
						815
					],
					"projections_orig": [
						"630",
						"684",
						"750",
						"780",
						"800",
						"815"
					],
					"projections_percentage": [
						-7.89,
						0,
						9.65,
						14.04,
						16.96,
						19.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2763
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 2.72,
					"enrolment": 621,
					"ligo": 0.5,
					"location": [
						150.967605634348,
						-33.7867643272827
					],
					"name": "Toongabbie Public School",
					"playspace": 23.47,
					"projections": [
						640,
						621,
						745,
						800,
						845,
						900
					],
					"projections_orig": [
						"640",
						"621",
						"745",
						"800",
						"845",
						"900"
					],
					"projections_percentage": [
						3.06,
						0,
						19.97,
						28.82,
						36.07,
						44.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3240
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 11
					},
					"classroomspace": 3.2,
					"enrolment": 662,
					"ligo": 0.8,
					"location": [
						150.966607755125,
						-33.8019475516991
					],
					"name": "Darcy Road Public School",
					"playspace": 22.82,
					"projections": [
						432,
						662,
						660,
						695,
						725,
						750
					],
					"projections_orig": [
						"432",
						"662",
						"660",
						"695",
						"725",
						"750"
					],
					"projections_percentage": [
						-34.74,
						0,
						-0.3,
						4.98,
						9.52,
						13.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4222
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 3.27,
					"enrolment": 253,
					"ligo": 0.6,
					"location": [
						150.956440432764,
						-33.792326732306
					],
					"name": "Toongabbie West Public School",
					"playspace": 57.57,
					"projections": [
						215,
						253,
						270,
						290,
						305,
						325
					],
					"projections_orig": [
						"215",
						"253",
						"270",
						"290",
						"305",
						"325"
					],
					"projections_percentage": [
						-15.02,
						0,
						6.72,
						14.62,
						20.55,
						28.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4364
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 13.9,
					"enrolment": 69,
					"ligo": 0.88,
					"location": [
						150.978813646416,
						-33.7971184714353
					],
					"name": "Toongabbie East Public School",
					"playspace": 403.63,
					"projections": [
						43,
						69,
						70,
						70,
						75,
						80
					],
					"projections_orig": [
						"43",
						"69",
						"70",
						"70",
						"75",
						"80"
					],
					"projections_percentage": [
						-37.68,
						0,
						1.45,
						1.45,
						8.7,
						15.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4366
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.91,
					"enrolment": 652,
					"ligo": 0.86,
					"location": [
						150.981800333395,
						-33.7734112073838
					],
					"name": "Winston Hills Public School",
					"playspace": 27.22,
					"projections": [
						567,
						652,
						725,
						790,
						850,
						900
					],
					"projections_orig": [
						"567",
						"652",
						"725",
						"790",
						"850",
						"900"
					],
					"projections_percentage": [
						-13.04,
						0,
						11.2,
						21.17,
						30.37,
						38.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4417
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 15
					},
					"classroomspace": 3.05,
					"enrolment": 452,
					"ligo": 0.67,
					"location": [
						150.967482953174,
						-33.7757764849631
					],
					"name": "Winston Heights Public School",
					"playspace": 42.96,
					"projections": [
						366,
						452,
						470,
						515,
						555,
						590
					],
					"projections_orig": [
						"366",
						"452",
						"470",
						"515",
						"555",
						"590"
					],
					"projections_percentage": [
						-19.03,
						0,
						3.98,
						13.94,
						22.79,
						30.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4471
				}
			],
			"uid": 10089
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 70
			},
			"enrolment": 1787,
			"level": "Primary",
			"ligo": 0.59,
			"name": "Dural Primary",
			"playspace": 195.29,
			"projections": [
				1787,
				1892,
				2027,
				2112,
				2172
			],
			"projections_percentage": [
				0,
				5.88,
				13.43,
				18.19,
				21.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.93,
					"enrolment": 78,
					"ligo": 0.74,
					"location": [
						151.051982831478,
						-33.622869027472
					],
					"name": "Arcadia Public School",
					"playspace": 256.56,
					"projections": [
						91,
						78,
						100,
						105,
						105,
						105
					],
					"projections_orig": [
						"91",
						"78",
						"100",
						"105",
						"105",
						"105"
					],
					"projections_percentage": [
						16.67,
						0,
						28.21,
						34.62,
						34.62,
						34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1048
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 16
					},
					"classroomspace": 2.42,
					"enrolment": 430,
					"ligo": 0.39,
					"location": [
						151.027374512938,
						-33.6864033587423
					],
					"name": "Dural Public School",
					"playspace": 49.56,
					"projections": [
						429,
						430,
						485,
						515,
						535,
						545
					],
					"projections_orig": [
						"429",
						"430",
						"485",
						"515",
						"535",
						"545"
					],
					"projections_percentage": [
						-0.23,
						0,
						12.79,
						19.77,
						24.42,
						26.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1799
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 7
					},
					"classroomspace": 2.64,
					"enrolment": 263,
					"ligo": 0.59,
					"location": [
						151.045117416112,
						-33.6474796610273
					],
					"name": "Galston Public School",
					"playspace": 50.58,
					"projections": [
						235,
						263,
						280,
						290,
						295,
						295
					],
					"projections_orig": [
						"235",
						"263",
						"280",
						"290",
						"295",
						"295"
					],
					"projections_percentage": [
						-10.65,
						0,
						6.46,
						10.27,
						12.17,
						12.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1952
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 11
					},
					"classroomspace": 2.66,
					"enrolment": 440,
					"ligo": 0.51,
					"location": [
						151.00379652709,
						-33.7005579797182
					],
					"name": "Glenhaven Public School",
					"playspace": 26.43,
					"projections": [
						418,
						440,
						445,
						505,
						545,
						575
					],
					"projections_orig": [
						"418",
						"440",
						"445",
						"505",
						"545",
						"575"
					],
					"projections_percentage": [
						-5,
						0,
						1.14,
						14.77,
						23.86,
						30.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2003
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.07,
					"enrolment": 255,
					"ligo": 0.66,
					"location": [
						151.006907883892,
						-33.5997632344074
					],
					"name": "Glenorie Public School",
					"playspace": 88.47,
					"projections": [
						227,
						255,
						240,
						245,
						240,
						240
					],
					"projections_orig": [
						"227",
						"255",
						"240",
						"245",
						"240",
						"240"
					],
					"projections_percentage": [
						-10.98,
						0,
						-5.88,
						-3.92,
						-5.88,
						-5.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2012
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.57,
					"enrolment": 215,
					"ligo": 0.72,
					"location": [
						151.004517960504,
						-33.6648410166956
					],
					"name": "Kenthurst Public School",
					"playspace": 50.02,
					"projections": [
						196,
						215,
						225,
						235,
						245,
						255
					],
					"projections_orig": [
						"196",
						"215",
						"225",
						"235",
						"245",
						"255"
					],
					"projections_percentage": [
						-8.84,
						0,
						4.65,
						9.3,
						13.95,
						18.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2284
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.26,
					"enrolment": 22,
					"ligo": 0.41,
					"location": [
						151.022845467349,
						-33.644099069482
					],
					"name": "Middle Dural Public School",
					"playspace": 948.29,
					"projections": [
						27,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						22.73,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2542
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.34,
					"enrolment": 84,
					"ligo": 0.33,
					"location": [
						150.952119669322,
						-33.6689393151424
					],
					"name": "Annangrove Public School",
					"playspace": 92.38,
					"projections": [
						79,
						84,
						95,
						110,
						125,
						135
					],
					"projections_orig": [
						"79",
						"84",
						"95",
						"110",
						"125",
						"135"
					],
					"projections_percentage": [
						-5.95,
						0,
						13.1,
						30.95,
						48.81,
						60.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3719
				}
			],
			"uid": 10090
		},
		{
			"classrooms": {
				"demountable": 91,
				"permanent": 160
			},
			"enrolment": 5844,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Epping Primary",
			"playspace": 24.85,
			"projections": [
				5844,
				5820,
				6770,
				7090,
				7090
			],
			"projections_percentage": [
				0,
				-0.41,
				15.85,
				21.32,
				21.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 12
					},
					"classroomspace": 2.49,
					"enrolment": 433,
					"ligo": 0.72,
					"location": [
						151.087263751161,
						-33.7714852946658
					],
					"name": "Epping Public School",
					"playspace": 31.2,
					"projections": [
						364,
						433,
						495,
						630,
						680,
						685
					],
					"projections_orig": [
						"364",
						"433",
						"495",
						"630",
						"680",
						"685"
					],
					"projections_percentage": [
						-15.94,
						0,
						14.32,
						45.5,
						57.04,
						58.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1850
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 30
					},
					"classroomspace": 2.71,
					"enrolment": 1095,
					"ligo": 0.75,
					"location": [
						151.068473454784,
						-33.7736296269218
					],
					"name": "Epping West Public School",
					"playspace": 16.12,
					"projections": [
						664,
						1095,
						1070,
						1210,
						1240,
						1250
					],
					"projections_orig": [
						"664",
						"1095",
						"1070",
						"1210",
						"1240",
						"1250"
					],
					"projections_percentage": [
						-39.36,
						0,
						-2.28,
						10.5,
						13.24,
						14.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1851
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 26
					},
					"classroomspace": 2.57,
					"enrolment": 792,
					"ligo": 0.78,
					"location": [
						151.026316506371,
						-33.7683650226115
					],
					"name": "North Rocks Public School",
					"playspace": 21.23,
					"projections": [
						644,
						792,
						810,
						900,
						965,
						995
					],
					"projections_orig": [
						"644",
						"792",
						"810",
						"900",
						"965",
						"995"
					],
					"projections_percentage": [
						-18.69,
						0,
						2.27,
						13.64,
						21.84,
						25.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2764
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 9
					},
					"classroomspace": 2.79,
					"enrolment": 467,
					"ligo": 0.4,
					"location": [
						151.072950303679,
						-33.7628560764733
					],
					"name": "Epping Heights Public School",
					"playspace": 16.67,
					"projections": [
						363,
						467,
						470,
						570,
						610,
						615
					],
					"projections_orig": [
						"363",
						"467",
						"470",
						"570",
						"610",
						"615"
					],
					"projections_percentage": [
						-22.27,
						0,
						0.64,
						22.06,
						30.62,
						31.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4038
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.74,
					"enrolment": 337,
					"ligo": 0.67,
					"location": [
						151.051975738227,
						-33.7656610933689
					],
					"name": "Roselea Public School",
					"playspace": 38.22,
					"projections": [
						358,
						337,
						370,
						395,
						405,
						410
					],
					"projections_orig": [
						"358",
						"337",
						"370",
						"395",
						"405",
						"410"
					],
					"projections_percentage": [
						6.23,
						0,
						9.79,
						17.21,
						20.18,
						21.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4294
				},
				{
					"classrooms": {
						"demountable": 28,
						"permanent": 24
					},
					"classroomspace": 2.95,
					"enrolment": 1164,
					"ligo": 0.75,
					"location": [
						151.03600176175,
						-33.7827846939696
					],
					"name": "Carlingford West Public School",
					"playspace": 22.99,
					"projections": [
						740,
						1164,
						1095,
						1290,
						1340,
						1315
					],
					"projections_orig": [
						"740",
						"1164",
						"1095",
						"1290",
						"1340",
						"1315"
					],
					"projections_percentage": [
						-36.43,
						0,
						-5.93,
						10.82,
						15.12,
						12.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4393
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 30
					},
					"classroomspace": 2.72,
					"enrolment": 955,
					"ligo": 0.61,
					"location": [
						151.038942060953,
						-33.7661845167
					],
					"name": "Murray Farm Public School",
					"playspace": 16.08,
					"projections": [
						785,
						955,
						995,
						1160,
						1210,
						1195
					],
					"projections_orig": [
						"785",
						"955",
						"995",
						"1160",
						"1210",
						"1195"
					],
					"projections_percentage": [
						-17.8,
						0,
						4.19,
						21.47,
						26.7,
						25.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4401
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 13
					},
					"classroomspace": 2.87,
					"enrolment": 601,
					"ligo": 0.58,
					"location": [
						151.055676543096,
						-33.7800945995602
					],
					"name": "Carlingford Public School",
					"playspace": 36.3,
					"projections": [
						335,
						601,
						515,
						615,
						640,
						625
					],
					"projections_orig": [
						"335",
						"601",
						"515",
						"615",
						"640",
						"625"
					],
					"projections_percentage": [
						-44.26,
						0,
						-14.31,
						2.33,
						6.49,
						3.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7302
				}
			],
			"uid": 10091
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 80
			},
			"enrolment": 1352,
			"level": "Primary",
			"ligo": 0.64,
			"name": "Parramatta East Primary",
			"playspace": 108.42,
			"projections": [
				1352,
				1535,
				1715,
				1860,
				1920
			],
			"projections_percentage": [
				0,
				13.54,
				26.85,
				37.57,
				42.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.24,
					"enrolment": 240,
					"ligo": 0.68,
					"location": [
						151.017921035403,
						-33.7931126747346
					],
					"name": "Burnside Public School",
					"playspace": 74.23,
					"projections": [
						216,
						240,
						275,
						300,
						310,
						315
					],
					"projections_orig": [
						"216",
						"240",
						"275",
						"300",
						"310",
						"315"
					],
					"projections_percentage": [
						-10,
						0,
						14.58,
						25,
						29.17,
						31.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1433
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 5.15,
					"enrolment": 131,
					"ligo": 0.66,
					"location": [
						151.044981744152,
						-33.8129061547109
					],
					"name": "Rydalmere Public School",
					"playspace": 202.79,
					"projections": [
						124,
						131,
						140,
						155,
						175,
						185
					],
					"projections_orig": [
						"124",
						"131",
						"140",
						"155",
						"175",
						"185"
					],
					"projections_percentage": [
						-5.34,
						0,
						6.87,
						18.32,
						33.59,
						41.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3020
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 10
					},
					"classroomspace": 2.66,
					"enrolment": 400,
					"ligo": 0.68,
					"location": [
						151.036431291616,
						-33.8035327372181
					],
					"name": "Dundas Public School",
					"playspace": 30.5,
					"projections": [
						354,
						400,
						445,
						505,
						555,
						580
					],
					"projections_orig": [
						"354",
						"400",
						"445",
						"505",
						"555",
						"580"
					],
					"projections_percentage": [
						-11.5,
						0,
						11.25,
						26.25,
						38.75,
						45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4029
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.74,
					"enrolment": 202,
					"ligo": 0.35,
					"location": [
						151.022923756698,
						-33.7998273737877
					],
					"name": "Oatlands Public School",
					"playspace": 70.37,
					"projections": [
						166,
						202,
						220,
						250,
						270,
						275
					],
					"projections_orig": [
						"166",
						"202",
						"220",
						"250",
						"270",
						"275"
					],
					"projections_percentage": [
						-17.82,
						0,
						8.91,
						23.76,
						33.66,
						36.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4071
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 9.57,
					"enrolment": 54,
					"ligo": 0.8,
					"location": [
						151.042897399118,
						-33.7971367191462
					],
					"name": "Telopea Public School",
					"playspace": 232.28,
					"projections": [
						56,
						54,
						75,
						95,
						115,
						120
					],
					"projections_orig": [
						"56",
						"54",
						"75",
						"95",
						"115",
						"120"
					],
					"projections_percentage": [
						3.7,
						0,
						38.89,
						75.93,
						112.96,
						122.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4103
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.66,
					"enrolment": 161,
					"ligo": 0.69,
					"location": [
						151.058079712707,
						-33.8065797223109
					],
					"name": "Ermington West Public School",
					"playspace": 73.1,
					"projections": [
						146,
						161,
						175,
						185,
						200,
						205
					],
					"projections_orig": [
						"146",
						"161",
						"175",
						"185",
						"200",
						"205"
					],
					"projections_percentage": [
						-9.32,
						0,
						8.7,
						14.91,
						24.22,
						27.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4125
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.86,
					"enrolment": 164,
					"ligo": 0.62,
					"location": [
						151.057653368933,
						-33.7956366245182
					],
					"name": "Yates Avenue Public School",
					"playspace": 75.64,
					"projections": [
						226,
						164,
						205,
						225,
						235,
						240
					],
					"projections_orig": [
						"226",
						"164",
						"205",
						"225",
						"235",
						"240"
					],
					"projections_percentage": [
						37.8,
						0,
						25,
						37.2,
						43.29,
						46.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4157
				}
			],
			"uid": 10092
		},
		{
			"classrooms": {
				"demountable": 51,
				"permanent": 83
			},
			"enrolment": 3238,
			"level": "Primary",
			"ligo": 0.82,
			"name": "Quakers Hill East Primary",
			"playspace": 24.17,
			"projections": [
				3238,
				3515,
				3775,
				4020,
				4310
			],
			"projections_percentage": [
				0,
				8.55,
				16.58,
				24.15,
				33.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 21
					},
					"classroomspace": 2.43,
					"enrolment": 708,
					"ligo": 0.91,
					"location": [
						150.913083865353,
						-33.7328719495015
					],
					"name": "Quakers Hill East Public School",
					"playspace": 30.19,
					"projections": [
						623,
						708,
						735,
						775,
						820,
						870
					],
					"projections_orig": [
						"623",
						"708",
						"735",
						"775",
						"820",
						"870"
					],
					"projections_percentage": [
						-12.01,
						0,
						3.81,
						9.46,
						15.82,
						22.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4212
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 18
					},
					"classroomspace": 2.69,
					"enrolment": 636,
					"ligo": 0.69,
					"location": [
						150.886771256665,
						-33.7169967073852
					],
					"name": "Hambledon Public School",
					"playspace": 29.32,
					"projections": [
						608,
						636,
						820,
						875,
						900,
						955
					],
					"projections_orig": [
						"608",
						"636",
						"820",
						"875",
						"900",
						"955"
					],
					"projections_percentage": [
						-4.4,
						0,
						28.93,
						37.58,
						41.51,
						50.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4590
				},
				{
					"classrooms": {
						"demountable": 16,
						"permanent": 20
					},
					"classroomspace": 2.74,
					"enrolment": 868,
					"ligo": 0.81,
					"location": [
						150.902746487966,
						-33.7198487783075
					],
					"name": "Barnier Public School",
					"playspace": 22.05,
					"projections": [
						731,
						868,
						930,
						1035,
						1140,
						1255
					],
					"projections_orig": [
						"731",
						"868",
						"930",
						"1035",
						"1140",
						"1255"
					],
					"projections_percentage": [
						-15.78,
						0,
						7.14,
						19.24,
						31.34,
						44.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4599
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 24
					},
					"classroomspace": 2.82,
					"enrolment": 1026,
					"ligo": 0.88,
					"location": [
						150.927613221935,
						-33.7365221762417
					],
					"name": "Caddies Creek Public School",
					"playspace": 15.11,
					"projections": [
						922,
						1026,
						1030,
						1090,
						1160,
						1230
					],
					"projections_orig": [
						"922",
						"1026",
						"1030",
						"1090",
						"1160",
						"1230"
					],
					"projections_percentage": [
						-10.14,
						0,
						0.39,
						6.24,
						13.06,
						19.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4615
				}
			],
			"uid": 10093
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 127
			},
			"enrolment": 2723,
			"level": "Primary",
			"ligo": 0.57,
			"name": "Seven Hills Primary",
			"playspace": 59.94,
			"projections": [
				2723,
				2940,
				3235,
				3570,
				3890
			],
			"projections_percentage": [
				0,
				7.97,
				18.8,
				31.11,
				42.86
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.73,
					"enrolment": 256,
					"ligo": 0.52,
					"location": [
						150.954398604356,
						-33.7597482374251
					],
					"name": "Seven Hills North Public School",
					"playspace": 54.2,
					"projections": [
						178,
						256,
						245,
						260,
						275,
						290
					],
					"projections_orig": [
						"178",
						"256",
						"245",
						"260",
						"275",
						"290"
					],
					"projections_percentage": [
						-30.47,
						0,
						-4.3,
						1.56,
						7.42,
						13.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3053
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 5.53,
					"enrolment": 127,
					"ligo": 0.54,
					"location": [
						150.937284391925,
						-33.770180521168
					],
					"name": "Seven Hills Public School",
					"playspace": 78.25,
					"projections": [
						122,
						127,
						135,
						150,
						165,
						180
					],
					"projections_orig": [
						"122",
						"127",
						"135",
						"150",
						"165",
						"180"
					],
					"projections_percentage": [
						-3.94,
						0,
						6.3,
						18.11,
						29.92,
						41.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3931
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.69,
					"enrolment": 235,
					"ligo": 0.75,
					"location": [
						150.912277484816,
						-33.7577171961256
					],
					"name": "Blacktown North Public School",
					"playspace": 58.14,
					"projections": [
						151,
						235,
						265,
						320,
						405,
						500
					],
					"projections_orig": [
						"151",
						"235",
						"265",
						"320",
						"405",
						"500"
					],
					"projections_percentage": [
						-35.74,
						0,
						12.77,
						36.17,
						72.34,
						112.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4061
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 23
					},
					"classroomspace": 3.26,
					"enrolment": 433,
					"ligo": 0.59,
					"location": [
						150.921651710903,
						-33.76658535589
					],
					"name": "Seven Hills West Public School",
					"playspace": 35.47,
					"projections": [
						362,
						433,
						455,
						515,
						570,
						615
					],
					"projections_orig": [
						"362",
						"433",
						"455",
						"515",
						"570",
						"615"
					],
					"projections_percentage": [
						-16.4,
						0,
						5.08,
						18.94,
						31.64,
						42.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4162
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 7.98,
					"enrolment": 147,
					"ligo": 0.5,
					"location": [
						150.93227306708,
						-33.7597822407503
					],
					"name": "Lalor Park Public School",
					"playspace": 113.03,
					"projections": [
						138,
						147,
						160,
						170,
						180,
						190
					],
					"projections_orig": [
						"138",
						"147",
						"160",
						"170",
						"180",
						"190"
					],
					"projections_percentage": [
						-6.12,
						0,
						8.84,
						15.65,
						22.45,
						29.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4191
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.28,
					"enrolment": 507,
					"ligo": 0.46,
					"location": [
						150.942062149595,
						-33.7579938086823
					],
					"name": "Vardys Road Public School",
					"playspace": 39.83,
					"projections": [
						469,
						507,
						540,
						575,
						610,
						645
					],
					"projections_orig": [
						"469",
						"507",
						"540",
						"575",
						"610",
						"645"
					],
					"projections_percentage": [
						-7.5,
						0,
						6.51,
						13.41,
						20.32,
						27.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4248
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.71,
					"enrolment": 296,
					"ligo": 0.55,
					"location": [
						150.925526792935,
						-33.7544614344258
					],
					"name": "Lynwood Park Public School",
					"playspace": 81.97,
					"projections": [
						352,
						296,
						355,
						370,
						425,
						470
					],
					"projections_orig": [
						"352",
						"296",
						"355",
						"370",
						"425",
						"470"
					],
					"projections_percentage": [
						18.92,
						0,
						19.93,
						25,
						43.58,
						58.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4258
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 22
					},
					"classroomspace": 2.52,
					"enrolment": 722,
					"ligo": 0.67,
					"location": [
						150.923875599744,
						-33.7455929715575
					],
					"name": "Kings Langley Public School",
					"playspace": 18.62,
					"projections": [
						673,
						722,
						785,
						875,
						940,
						1000
					],
					"projections_orig": [
						"673",
						"722",
						"785",
						"875",
						"940",
						"1000"
					],
					"projections_percentage": [
						-6.79,
						0,
						8.73,
						21.19,
						30.19,
						38.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4528
				}
			],
			"uid": 10094
		},
		{
			"classrooms": {
				"demountable": 89,
				"permanent": 162
			},
			"enrolment": 6061,
			"level": "Primary",
			"ligo": 0.8,
			"name": "Castle Hill Primary",
			"playspace": 21.49,
			"projections": [
				6061,
				6460,
				7130,
				7870,
				8410
			],
			"projections_percentage": [
				0,
				6.58,
				17.64,
				29.85,
				38.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 27
					},
					"classroomspace": 2.47,
					"enrolment": 931,
					"ligo": 0.76,
					"location": [
						151.004409443853,
						-33.7281235822013
					],
					"name": "Castle Hill Public School",
					"playspace": 18.44,
					"projections": [
						760,
						931,
						1120,
						1365,
						1605,
						1800
					],
					"projections_orig": [
						"760",
						"931",
						"1120",
						"1365",
						"1605",
						"1800"
					],
					"projections_percentage": [
						-18.37,
						0,
						20.3,
						46.62,
						72.4,
						93.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1529
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 17
					},
					"classroomspace": 2.86,
					"enrolment": 516,
					"ligo": 0.87,
					"location": [
						150.991350743713,
						-33.7407003908552
					],
					"name": "Excelsior Public School",
					"playspace": 41.29,
					"projections": [
						401,
						516,
						535,
						600,
						650,
						680
					],
					"projections_orig": [
						"401",
						"516",
						"535",
						"600",
						"650",
						"680"
					],
					"projections_percentage": [
						-22.29,
						0,
						3.68,
						16.28,
						25.97,
						31.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1890
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 22
					},
					"classroomspace": 2.69,
					"enrolment": 887,
					"ligo": 0.9,
					"location": [
						150.999692540672,
						-33.7526586739295
					],
					"name": "Baulkham Hills North Public School",
					"playspace": 19.33,
					"projections": [
						762,
						887,
						975,
						1080,
						1215,
						1280
					],
					"projections_orig": [
						"762",
						"887",
						"975",
						"1080",
						"1215",
						"1280"
					],
					"projections_percentage": [
						-14.09,
						0,
						9.92,
						21.76,
						36.98,
						44.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4377
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 29
					},
					"classroomspace": 2.77,
					"enrolment": 824,
					"ligo": 0.81,
					"location": [
						150.981622758318,
						-33.761703318116
					],
					"name": "Jasper Road Public School",
					"playspace": 18.63,
					"projections": [
						726,
						824,
						810,
						905,
						1040,
						1120
					],
					"projections_orig": [
						"726",
						"824",
						"810",
						"905",
						"1040",
						"1120"
					],
					"projections_percentage": [
						-11.89,
						0,
						-1.7,
						9.83,
						26.21,
						35.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4382
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 21
					},
					"classroomspace": 2.78,
					"enrolment": 767,
					"ligo": 0.79,
					"location": [
						150.971363248296,
						-33.7480756582982
					],
					"name": "Crestwood Public School",
					"playspace": 22.39,
					"projections": [
						666,
						767,
						835,
						870,
						920,
						985
					],
					"projections_orig": [
						"666",
						"767",
						"835",
						"870",
						"920",
						"985"
					],
					"projections_percentage": [
						-13.17,
						0,
						8.87,
						13.43,
						19.95,
						28.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4441
				},
				{
					"classrooms": {
						"demountable": 28,
						"permanent": 28
					},
					"classroomspace": 2.72,
					"enrolment": 1374,
					"ligo": 0.85,
					"location": [
						150.963161562186,
						-33.7573054140554
					],
					"name": "Matthew Pearce Public School",
					"playspace": 13.93,
					"projections": [
						1028,
						1374,
						1335,
						1335,
						1345,
						1360
					],
					"projections_orig": [
						"1028",
						"1374",
						"1335",
						"1335",
						"1345",
						"1360"
					],
					"projections_percentage": [
						-25.18,
						0,
						-2.84,
						-2.84,
						-2.11,
						-1.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4526
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 18
					},
					"classroomspace": 2.54,
					"enrolment": 762,
					"ligo": 0.65,
					"location": [
						150.991385407306,
						-33.7139586261294
					],
					"name": "Samuel Gilbert Public School",
					"playspace": 16.42,
					"projections": [
						664,
						762,
						850,
						975,
						1095,
						1185
					],
					"projections_orig": [
						"664",
						"762",
						"850",
						"975",
						"1095",
						"1185"
					],
					"projections_percentage": [
						-12.86,
						0,
						11.55,
						27.95,
						43.7,
						55.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4574
				}
			],
			"uid": 10095
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 155
			},
			"enrolment": 3719,
			"level": "Primary",
			"ligo": 0.68,
			"name": "Blacktown South Primary",
			"playspace": 50.99,
			"projections": [
				3719,
				4145,
				4525,
				4875,
				5205
			],
			"projections_percentage": [
				0,
				11.45,
				21.67,
				31.08,
				39.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.06,
					"enrolment": 225,
					"ligo": 0.65,
					"location": [
						150.871348508386,
						-33.7649532888973
					],
					"name": "Doonside Public School",
					"playspace": 68.68,
					"projections": [
						187,
						225,
						260,
						300,
						340,
						380
					],
					"projections_orig": [
						"187",
						"225",
						"260",
						"300",
						"340",
						"380"
					],
					"projections_percentage": [
						-16.89,
						0,
						15.56,
						33.33,
						51.11,
						68.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1760
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 3.23,
					"enrolment": 423,
					"ligo": 0.73,
					"location": [
						150.892216684504,
						-33.7710207452138
					],
					"name": "Blacktown West Public School",
					"playspace": 35.9,
					"projections": [
						408,
						423,
						485,
						545,
						605,
						670
					],
					"projections_orig": [
						"408",
						"423",
						"485",
						"545",
						"605",
						"670"
					],
					"projections_percentage": [
						-3.55,
						0,
						14.66,
						28.84,
						43.03,
						58.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4116
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.16,
					"enrolment": 252,
					"ligo": 0.75,
					"location": [
						150.92586218743,
						-33.7770179718775
					],
					"name": "Bert Oldfield Public School",
					"playspace": 123.42,
					"projections": [
						215,
						252,
						270,
						295,
						310,
						325
					],
					"projections_orig": [
						"215",
						"252",
						"270",
						"295",
						"310",
						"325"
					],
					"projections_percentage": [
						-14.68,
						0,
						7.14,
						17.06,
						23.02,
						28.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4192
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 29
					},
					"classroomspace": 2.42,
					"enrolment": 985,
					"ligo": 0.7,
					"location": [
						150.90680667851,
						-33.7810495759498
					],
					"name": "Blacktown South Public School",
					"playspace": 19.5,
					"projections": [
						819,
						985,
						1045,
						1155,
						1265,
						1360
					],
					"projections_orig": [
						"819",
						"985",
						"1045",
						"1155",
						"1265",
						"1360"
					],
					"projections_percentage": [
						-16.85,
						0,
						6.09,
						17.26,
						28.43,
						38.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4193
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.4,
					"enrolment": 575,
					"ligo": 0.78,
					"location": [
						150.893335739431,
						-33.7849044935515
					],
					"name": "Walters Road Public School",
					"playspace": 37.04,
					"projections": [
						516,
						575,
						645,
						680,
						715,
						750
					],
					"projections_orig": [
						"516",
						"575",
						"645",
						"680",
						"715",
						"750"
					],
					"projections_percentage": [
						-10.26,
						0,
						12.17,
						18.26,
						24.35,
						30.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4310
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 26
					},
					"classroomspace": 2.93,
					"enrolment": 555,
					"ligo": 0.51,
					"location": [
						150.917055542841,
						-33.7889410288748
					],
					"name": "Shelley Public School",
					"playspace": 42.1,
					"projections": [
						579,
						555,
						670,
						720,
						770,
						810
					],
					"projections_orig": [
						"579",
						"555",
						"670",
						"720",
						"770",
						"810"
					],
					"projections_percentage": [
						4.32,
						0,
						20.72,
						29.73,
						38.74,
						45.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4381
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 21
					},
					"classroomspace": 2.95,
					"enrolment": 704,
					"ligo": 0.64,
					"location": [
						150.935747319131,
						-33.7945991323979
					],
					"name": "Metella Road Public School",
					"playspace": 30.29,
					"projections": [
						621,
						704,
						770,
						830,
						870,
						910
					],
					"projections_orig": [
						"621",
						"704",
						"770",
						"830",
						"870",
						"910"
					],
					"projections_percentage": [
						-11.79,
						0,
						9.38,
						17.9,
						23.58,
						29.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4444
				}
			],
			"uid": 10096
		},
		{
			"classrooms": {
				"demountable": 27,
				"permanent": 194
			},
			"enrolment": 3161,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Lethbridge Park Primary",
			"playspace": 76.3,
			"projections": [
				3161,
				3505,
				3930,
				4305,
				4680
			],
			"projections_percentage": [
				0,
				10.88,
				24.33,
				36.19,
				48.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 34
					},
					"classroomspace": 6.02,
					"enrolment": 364,
					"ligo": 0.57,
					"location": [
						150.800854406806,
						-33.7372286801092
					],
					"name": "Lethbridge Park Public School",
					"playspace": 71.41,
					"projections": [
						405,
						364,
						440,
						470,
						500,
						530
					],
					"projections_orig": [
						"405",
						"364",
						"440",
						"470",
						"500",
						"530"
					],
					"projections_percentage": [
						11.26,
						0,
						20.88,
						29.12,
						37.36,
						45.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4408
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 8.13,
					"enrolment": 239,
					"ligo": 0.79,
					"location": [
						150.815497287723,
						-33.7390704590063
					],
					"name": "Blackett Public School",
					"playspace": 97.38,
					"projections": [
						273,
						239,
						275,
						295,
						315,
						330
					],
					"projections_orig": [
						"273",
						"239",
						"275",
						"295",
						"315",
						"330"
					],
					"projections_percentage": [
						14.23,
						0,
						15.06,
						23.43,
						31.8,
						38.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4453
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 9.26,
					"enrolment": 146,
					"ligo": 0.87,
					"location": [
						150.793236438952,
						-33.7261688069186
					],
					"name": "Willmot Public School",
					"playspace": 176.01,
					"projections": [
						215,
						146,
						225,
						250,
						270,
						290
					],
					"projections_orig": [
						"215",
						"146",
						"225",
						"250",
						"270",
						"290"
					],
					"projections_percentage": [
						47.26,
						0,
						54.11,
						71.23,
						84.93,
						98.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4470
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 5.55,
					"enrolment": 304,
					"ligo": 0.68,
					"location": [
						150.809431954501,
						-33.7262045684823
					],
					"name": "Shalvey Public School",
					"playspace": 83.99,
					"projections": [
						383,
						304,
						370,
						430,
						485,
						540
					],
					"projections_orig": [
						"383",
						"304",
						"370",
						"430",
						"485",
						"540"
					],
					"projections_percentage": [
						25.99,
						0,
						21.71,
						41.45,
						59.54,
						77.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4476
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 31
					},
					"classroomspace": 4.51,
					"enrolment": 382,
					"ligo": 0.6,
					"location": [
						150.826240843272,
						-33.7327335270981
					],
					"name": "Bidwill Public School",
					"playspace": 66.44,
					"projections": [
						479,
						382,
						445,
						525,
						600,
						680
					],
					"projections_orig": [
						"479",
						"382",
						"445",
						"525",
						"600",
						"680"
					],
					"projections_percentage": [
						25.39,
						0,
						16.49,
						37.43,
						57.07,
						78.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4480
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.68,
					"enrolment": 282,
					"ligo": 0.48,
					"location": [
						150.809352900983,
						-33.7325267602992
					],
					"name": "Noumea Public School",
					"playspace": 69.25,
					"projections": [
						288,
						282,
						320,
						345,
						365,
						385
					],
					"projections_orig": [
						"288",
						"282",
						"320",
						"345",
						"365",
						"385"
					],
					"projections_percentage": [
						2.13,
						0,
						13.48,
						22.34,
						29.43,
						36.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4493
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 23
					},
					"classroomspace": 2.73,
					"enrolment": 765,
					"ligo": 0.7,
					"location": [
						150.837566601271,
						-33.7346931786057
					],
					"name": "Hassall Grove Public School",
					"playspace": 30.5,
					"projections": [
						779,
						765,
						920,
						1080,
						1215,
						1350
					],
					"projections_orig": [
						"779",
						"765",
						"920",
						"1080",
						"1215",
						"1350"
					],
					"projections_percentage": [
						1.83,
						0,
						20.26,
						41.18,
						58.82,
						76.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4598
				},
				{
					"classrooms": {
						"demountable": 18,
						"permanent": 10
					},
					"classroomspace": 2.91,
					"enrolment": 679,
					"ligo": 0.91,
					"location": [
						150.782584220529,
						-33.7331419034383
					],
					"name": "Ropes Crossing Public School",
					"playspace": 15.46,
					"projections": [
						142,
						679,
						510,
						535,
						555,
						575
					],
					"projections_orig": [
						"142",
						"679",
						"510",
						"535",
						"555",
						"575"
					],
					"projections_percentage": [
						-79.09,
						0,
						-24.89,
						-21.21,
						-18.26,
						-15.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4645
				}
			],
			"uid": 10097
		},
		{
			"classrooms": {
				"demountable": 19,
				"permanent": 226
			},
			"enrolment": 4310,
			"level": "Primary",
			"ligo": 0.58,
			"name": "Mt Druitt Primary",
			"playspace": 61.04,
			"projections": [
				4310,
				4655,
				4990,
				5305,
				5605
			],
			"projections_percentage": [
				0,
				8,
				15.78,
				23.09,
				30.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.7,
					"enrolment": 472,
					"ligo": 0.48,
					"location": [
						150.837596331477,
						-33.7492487601415
					],
					"name": "Plumpton Public School",
					"playspace": 66,
					"projections": [
						493,
						472,
						550,
						585,
						620,
						655
					],
					"projections_orig": [
						"493",
						"472",
						"550",
						"585",
						"620",
						"655"
					],
					"projections_percentage": [
						4.45,
						0,
						16.53,
						23.94,
						31.36,
						38.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2887
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 23
					},
					"classroomspace": 2.53,
					"enrolment": 652,
					"ligo": 0.73,
					"location": [
						150.84015912433,
						-33.7687339171839
					],
					"name": "Rooty Hill Public School",
					"playspace": 28.21,
					"projections": [
						568,
						652,
						720,
						770,
						820,
						870
					],
					"projections_orig": [
						"568",
						"652",
						"720",
						"770",
						"820",
						"870"
					],
					"projections_percentage": [
						-12.88,
						0,
						10.43,
						18.1,
						25.77,
						33.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4056
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.5,
					"enrolment": 400,
					"ligo": 0.59,
					"location": [
						150.783250589628,
						-33.7559184711664
					],
					"name": "St Marys North Public School",
					"playspace": 46.23,
					"projections": [
						415,
						400,
						480,
						520,
						545,
						570
					],
					"projections_orig": [
						"415",
						"400",
						"480",
						"520",
						"545",
						"570"
					],
					"projections_percentage": [
						3.75,
						0,
						20,
						30,
						36.25,
						42.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4205
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 19
					},
					"classroomspace": 2.81,
					"enrolment": 590,
					"ligo": 0.75,
					"location": [
						150.813680344962,
						-33.763531734456
					],
					"name": "Mount Druitt Public School",
					"playspace": 32.32,
					"projections": [
						556,
						590,
						565,
						605,
						645,
						685
					],
					"projections_orig": [
						"556",
						"590",
						"565",
						"605",
						"645",
						"685"
					],
					"projections_percentage": [
						-5.76,
						0,
						-4.24,
						2.54,
						9.32,
						16.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4290
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 5.01,
					"enrolment": 334,
					"ligo": 0.56,
					"location": [
						150.81056720311,
						-33.7532377834465
					],
					"name": "Whalan Public School",
					"playspace": 79.41,
					"projections": [
						374,
						334,
						345,
						370,
						390,
						410
					],
					"projections_orig": [
						"374",
						"334",
						"345",
						"370",
						"390",
						"410"
					],
					"projections_percentage": [
						11.98,
						0,
						3.29,
						10.78,
						16.77,
						22.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4378
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 6.33,
					"enrolment": 337,
					"ligo": 0.69,
					"location": [
						150.795295148765,
						-33.7463771118576
					],
					"name": "Tregear Public School",
					"playspace": 90.47,
					"projections": [
						355,
						337,
						385,
						415,
						445,
						475
					],
					"projections_orig": [
						"355",
						"337",
						"385",
						"415",
						"445",
						"475"
					],
					"projections_percentage": [
						5.34,
						0,
						14.24,
						23.15,
						32.05,
						40.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4402
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.48,
					"enrolment": 253,
					"ligo": 0.72,
					"location": [
						150.806069431474,
						-33.7451786586706
					],
					"name": "Emerton Public School",
					"playspace": 64.21,
					"projections": [
						219,
						253,
						265,
						285,
						305,
						320
					],
					"projections_orig": [
						"219",
						"253",
						"265",
						"285",
						"305",
						"320"
					],
					"projections_percentage": [
						-13.44,
						0,
						4.74,
						12.65,
						20.55,
						26.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4422
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 4.59,
					"enrolment": 310,
					"ligo": 0.54,
					"location": [
						150.815228570272,
						-33.7450679635139
					],
					"name": "Dawson Public School",
					"playspace": 85.43,
					"projections": [
						387,
						310,
						340,
						365,
						390,
						410
					],
					"projections_orig": [
						"387",
						"310",
						"340",
						"365",
						"390",
						"410"
					],
					"projections_percentage": [
						24.84,
						0,
						9.68,
						17.74,
						25.81,
						32.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4446
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 23
					},
					"classroomspace": 3.1,
					"enrolment": 649,
					"ligo": 0.4,
					"location": [
						150.824868965105,
						-33.7474961039914
					],
					"name": "Hebersham Public School",
					"playspace": 32.7,
					"projections": [
						594,
						649,
						665,
						710,
						760,
						805
					],
					"projections_orig": [
						"594",
						"649",
						"665",
						"710",
						"760",
						"805"
					],
					"projections_percentage": [
						-8.47,
						0,
						2.47,
						9.4,
						17.1,
						24.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4447
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.24,
					"enrolment": 313,
					"ligo": 0.36,
					"location": [
						150.804820762091,
						-33.7594636355553
					],
					"name": "Madang Avenue Public School",
					"playspace": 85.46,
					"projections": [
						364,
						313,
						340,
						365,
						385,
						405
					],
					"projections_orig": [
						"364",
						"313",
						"340",
						"365",
						"385",
						"405"
					],
					"projections_percentage": [
						16.29,
						0,
						8.63,
						16.61,
						23,
						29.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4449
				}
			],
			"uid": 10098
		},
		{
			"classrooms": {
				"demountable": 34,
				"permanent": 79
			},
			"enrolment": 2796,
			"level": "Primary",
			"ligo": 0.77,
			"name": "Cherrybrook Primary",
			"playspace": 37.47,
			"projections": [
				2796,
				2775,
				2880,
				2960,
				3045
			],
			"projections_percentage": [
				0,
				-0.75,
				3,
				5.87,
				8.91
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.46,
					"enrolment": 592,
					"ligo": 0.75,
					"location": [
						151.072229076159,
						-33.7246784133177
					],
					"name": "Thornleigh West Public School",
					"playspace": 35.5,
					"projections": [
						573,
						592,
						590,
						610,
						610,
						610
					],
					"projections_orig": [
						"573",
						"592",
						"590",
						"610",
						"610",
						"610"
					],
					"projections_percentage": [
						-3.21,
						0,
						-0.34,
						3.04,
						3.04,
						3.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4276
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 22
					},
					"classroomspace": 2.79,
					"enrolment": 814,
					"ligo": 0.79,
					"location": [
						151.043326628318,
						-33.7315257629568
					],
					"name": "Cherrybrook Public School",
					"playspace": 34.27,
					"projections": [
						710,
						814,
						810,
						855,
						900,
						945
					],
					"projections_orig": [
						"710",
						"814",
						"810",
						"855",
						"900",
						"945"
					],
					"projections_percentage": [
						-12.78,
						0,
						-0.49,
						5.04,
						10.57,
						16.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4440
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 17
					},
					"classroomspace": 2.74,
					"enrolment": 656,
					"ligo": 0.72,
					"location": [
						151.038683067234,
						-33.7186333664553
					],
					"name": "John Purchase Public School",
					"playspace": 51.8,
					"projections": [
						666,
						656,
						665,
						680,
						690,
						705
					],
					"projections_orig": [
						"666",
						"656",
						"665",
						"680",
						"690",
						"705"
					],
					"projections_percentage": [
						1.52,
						0,
						1.37,
						3.66,
						5.18,
						7.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4572
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 16
					},
					"classroomspace": 2.55,
					"enrolment": 734,
					"ligo": 0.83,
					"location": [
						151.023762606671,
						-33.7212434816144
					],
					"name": "Oakhill Drive Public School",
					"playspace": 28.29,
					"projections": [
						553,
						734,
						710,
						735,
						760,
						785
					],
					"projections_orig": [
						"553",
						"734",
						"710",
						"735",
						"760",
						"785"
					],
					"projections_percentage": [
						-24.66,
						0,
						-3.27,
						0.14,
						3.54,
						6.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4604
				}
			],
			"uid": 10099
		},
		{
			"classrooms": {
				"demountable": 52,
				"permanent": 173
			},
			"enrolment": 4957,
			"level": "Primary",
			"ligo": 0.63,
			"name": "Merrylands Primary",
			"playspace": 41.16,
			"projections": [
				4957,
				5210,
				5695,
				6165,
				6450
			],
			"projections_percentage": [
				0,
				5.1,
				14.89,
				24.37,
				30.12
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 16,
						"permanent": 15
					},
					"classroomspace": 2.76,
					"enrolment": 748,
					"ligo": 0.47,
					"location": [
						150.940306320987,
						-33.8283442622197
					],
					"name": "Greystanes Public School",
					"playspace": 27.82,
					"projections": [
						634,
						748,
						800,
						860,
						915,
						955
					],
					"projections_orig": [
						"634",
						"748",
						"800",
						"860",
						"915",
						"955"
					],
					"projections_percentage": [
						-15.24,
						0,
						6.95,
						14.97,
						22.33,
						27.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2086
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 18
					},
					"classroomspace": 2.73,
					"enrolment": 560,
					"ligo": 0.78,
					"location": [
						150.981497026588,
						-33.8550650713543
					],
					"name": "Guildford Public School",
					"playspace": 25.7,
					"projections": [
						385,
						560,
						575,
						650,
						715,
						750
					],
					"projections_orig": [
						"385",
						"560",
						"575",
						"650",
						"715",
						"750"
					],
					"projections_percentage": [
						-31.25,
						0,
						2.68,
						16.07,
						27.68,
						33.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2093
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 14
					},
					"classroomspace": 2.71,
					"enrolment": 473,
					"ligo": 0.54,
					"location": [
						150.975519386388,
						-33.8401602014449
					],
					"name": "Merrylands Public School",
					"playspace": 22.27,
					"projections": [
						336,
						473,
						445,
						490,
						535,
						565
					],
					"projections_orig": [
						"336",
						"473",
						"445",
						"490",
						"535",
						"565"
					],
					"projections_percentage": [
						-28.96,
						0,
						-5.92,
						3.59,
						13.11,
						19.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2531
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 27
					},
					"classroomspace": 2.85,
					"enrolment": 741,
					"ligo": 0.45,
					"location": [
						150.974110204051,
						-33.8265329725747
					],
					"name": "Hilltop Road Public School",
					"playspace": 27.5,
					"projections": [
						610,
						741,
						855,
						945,
						1045,
						1085
					],
					"projections_orig": [
						"610",
						"741",
						"855",
						"945",
						"1045",
						"1085"
					],
					"projections_percentage": [
						-17.68,
						0,
						15.38,
						27.53,
						41.03,
						46.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3997
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 3.39,
					"enrolment": 425,
					"ligo": 0.59,
					"location": [
						150.967131373008,
						-33.8483289328641
					],
					"name": "Guildford West Public School",
					"playspace": 55.18,
					"projections": [
						461,
						425,
						470,
						495,
						520,
						535
					],
					"projections_orig": [
						"461",
						"425",
						"470",
						"495",
						"520",
						"535"
					],
					"projections_percentage": [
						8.47,
						0,
						10.59,
						16.47,
						22.35,
						25.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4000
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.96,
					"enrolment": 408,
					"ligo": 0.73,
					"location": [
						150.960376525948,
						-33.8194597992036
					],
					"name": "Ringrose Public School",
					"playspace": 52.78,
					"projections": [
						286,
						408,
						405,
						435,
						460,
						475
					],
					"projections_orig": [
						"286",
						"408",
						"405",
						"435",
						"460",
						"475"
					],
					"projections_percentage": [
						-29.9,
						0,
						-0.74,
						6.62,
						12.75,
						16.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4312
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.46,
					"enrolment": 344,
					"ligo": 0.59,
					"location": [
						150.959928540305,
						-33.8361168495277
					],
					"name": "Sherwood Grange Public School",
					"playspace": 64.5,
					"projections": [
						264,
						344,
						350,
						370,
						395,
						410
					],
					"projections_orig": [
						"264",
						"344",
						"350",
						"370",
						"395",
						"410"
					],
					"projections_percentage": [
						-23.26,
						0,
						1.74,
						7.56,
						14.83,
						19.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4328
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 20
					},
					"classroomspace": 2.83,
					"enrolment": 633,
					"ligo": 0.66,
					"location": [
						150.941606103392,
						-33.8145208408203
					],
					"name": "Beresford Road Public School",
					"playspace": 38.48,
					"projections": [
						429,
						633,
						595,
						630,
						665,
						685
					],
					"projections_orig": [
						"429",
						"633",
						"595",
						"630",
						"665",
						"685"
					],
					"projections_percentage": [
						-32.23,
						0,
						-6,
						-0.47,
						5.06,
						8.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4405
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.7,
					"enrolment": 246,
					"ligo": 0.67,
					"location": [
						150.940190262112,
						-33.8331172170239
					],
					"name": "Widemere Public School",
					"playspace": 78.8,
					"projections": [
						193,
						246,
						245,
						260,
						270,
						280
					],
					"projections_orig": [
						"193",
						"246",
						"245",
						"260",
						"270",
						"280"
					],
					"projections_percentage": [
						-21.54,
						0,
						-0.41,
						5.69,
						9.76,
						13.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4474
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 2.88,
					"enrolment": 379,
					"ligo": 0.78,
					"location": [
						150.990086231755,
						-33.8416899688346
					],
					"name": "Merrylands East Public School",
					"playspace": 18.55,
					"projections": [
						382,
						379,
						470,
						560,
						645,
						710
					],
					"projections_orig": [
						"382",
						"379",
						"470",
						"560",
						"645",
						"710"
					],
					"projections_percentage": [
						0.79,
						0,
						24.01,
						47.76,
						70.18,
						87.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5126
				}
			],
			"uid": 10100
		},
		{
			"classrooms": {
				"demountable": 56,
				"permanent": 99
			},
			"enrolment": 3557,
			"level": "Primary",
			"ligo": 0.85,
			"name": "Pendle Hill Primary",
			"playspace": 36.75,
			"projections": [
				3557,
				3695,
				4030,
				4335,
				4525
			],
			"projections_percentage": [
				0,
				3.88,
				13.3,
				21.87,
				27.21
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 28,
						"permanent": 17
					},
					"classroomspace": 2.78,
					"enrolment": 1110,
					"ligo": 0.87,
					"location": [
						150.951128769664,
						-33.798655868916
					],
					"name": "Girraween Public School",
					"playspace": 12.13,
					"projections": [
						741,
						1110,
						1095,
						1175,
						1250,
						1305
					],
					"projections_orig": [
						"741",
						"1110",
						"1095",
						"1175",
						"1250",
						"1305"
					],
					"projections_percentage": [
						-33.24,
						0,
						-1.35,
						5.86,
						12.61,
						17.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1988
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.4,
					"enrolment": 219,
					"ligo": 0.84,
					"location": [
						150.942831356896,
						-33.7816672133956
					],
					"name": "The Meadows Public School",
					"playspace": 83.74,
					"projections": [
						195,
						219,
						235,
						260,
						285,
						310
					],
					"projections_orig": [
						"195",
						"219",
						"235",
						"260",
						"285",
						"310"
					],
					"projections_percentage": [
						-10.96,
						0,
						7.31,
						18.72,
						30.14,
						41.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2510
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 14
					},
					"classroomspace": 2.7,
					"enrolment": 529,
					"ligo": 0.77,
					"location": [
						150.968522431793,
						-33.8135733842176
					],
					"name": "Wentworthville Public School",
					"playspace": 24.42,
					"projections": [
						369,
						529,
						630,
						695,
						755,
						800
					],
					"projections_orig": [
						"369",
						"529",
						"630",
						"695",
						"755",
						"800"
					],
					"projections_percentage": [
						-30.25,
						0,
						19.09,
						31.38,
						42.72,
						51.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3423
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 39
					},
					"classroomspace": 2.42,
					"enrolment": 1408,
					"ligo": 0.95,
					"location": [
						150.98643644476,
						-33.8110879861551
					],
					"name": "Westmead Public School",
					"playspace": 9.46,
					"projections": [
						1013,
						1408,
						1400,
						1540,
						1665,
						1720
					],
					"projections_orig": [
						"1013",
						"1408",
						"1400",
						"1540",
						"1665",
						"1720"
					],
					"projections_percentage": [
						-28.05,
						0,
						-0.57,
						9.38,
						18.25,
						22.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3883
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 11
					},
					"classroomspace": 3.08,
					"enrolment": 291,
					"ligo": 0.8,
					"location": [
						150.953041851416,
						-33.8099257222635
					],
					"name": "Pendle Hill Public School",
					"playspace": 54.02,
					"projections": [
						277,
						291,
						335,
						360,
						380,
						390
					],
					"projections_orig": [
						"277",
						"291",
						"335",
						"360",
						"380",
						"390"
					],
					"projections_percentage": [
						-4.81,
						0,
						15.12,
						23.71,
						30.58,
						34.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3993
				}
			],
			"uid": 10101
		},
		{
			"classrooms": {
				"demountable": 54,
				"permanent": 80
			},
			"enrolment": 3210,
			"level": "Primary",
			"ligo": 0.85,
			"name": "Parramatta CBD Primary",
			"playspace": 13.02,
			"projections": [
				3210,
				3590,
				4555,
				5555,
				6145
			],
			"projections_percentage": [
				0,
				11.84,
				41.9,
				73.05,
				91.43
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 21
					},
					"classroomspace": 1.93,
					"enrolment": 884,
					"ligo": 0.85,
					"location": [
						151.00784737274,
						-33.8162497377197
					],
					"name": "Parramatta Public School",
					"playspace": 3.01,
					"projections": [
						506,
						884,
						980,
						1325,
						1670,
						1915
					],
					"projections_orig": [
						"506",
						"884",
						"980",
						"1325",
						"1670",
						"1915"
					],
					"projections_percentage": [
						-42.76,
						0,
						10.86,
						49.89,
						88.91,
						116.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2840
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 9
					},
					"classroomspace": 2.17,
					"enrolment": 399,
					"ligo": 0.83,
					"location": [
						151.004401731495,
						-33.8043113250318
					],
					"name": "Parramatta North Public School",
					"playspace": 13.75,
					"projections": [
						262,
						399,
						430,
						525,
						640,
						670
					],
					"projections_orig": [
						"262",
						"399",
						"430",
						"525",
						"640",
						"670"
					],
					"projections_percentage": [
						-34.34,
						0,
						7.77,
						31.58,
						60.4,
						67.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2842
				},
				{
					"classrooms": {
						"demountable": 17,
						"permanent": 22
					},
					"classroomspace": 3.21,
					"enrolment": 782,
					"ligo": 0.85,
					"location": [
						150.990916509323,
						-33.8246678344757
					],
					"name": "Parramatta West Public School",
					"playspace": 6.67,
					"projections": [
						552,
						782,
						785,
						945,
						1110,
						1225
					],
					"projections_orig": [
						"552",
						"782",
						"785",
						"945",
						"1110",
						"1225"
					],
					"projections_percentage": [
						-29.41,
						0,
						0.38,
						20.84,
						41.94,
						56.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2843
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 8
					},
					"classroomspace": 2.69,
					"enrolment": 482,
					"ligo": 0.71,
					"location": [
						151.018072556063,
						-33.8060969717196
					],
					"name": "Parramatta East Public School",
					"playspace": 22.74,
					"projections": [
						336,
						482,
						495,
						590,
						680,
						695
					],
					"projections_orig": [
						"336",
						"482",
						"495",
						"590",
						"680",
						"695"
					],
					"projections_percentage": [
						-30.29,
						0,
						2.7,
						22.41,
						41.08,
						44.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3840
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 20
					},
					"classroomspace": 2.73,
					"enrolment": 663,
					"ligo": 0.88,
					"location": [
						151.019464551575,
						-33.8243487556393
					],
					"name": "Rosehill Public School",
					"playspace": 18.92,
					"projections": [
						530,
						663,
						900,
						1170,
						1455,
						1640
					],
					"projections_orig": [
						"530",
						"663",
						"900",
						"1170",
						"1455",
						"1640"
					],
					"projections_percentage": [
						-20.06,
						0,
						35.75,
						76.47,
						119.46,
						147.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7444
				}
			],
			"uid": 10102
		},
		{
			"classrooms": {
				"demountable": 28,
				"permanent": 86
			},
			"enrolment": 2085,
			"level": "Primary",
			"ligo": 0.67,
			"name": "Granville Primary",
			"playspace": 27.11,
			"projections": [
				2085,
				2420,
				2790,
				3125,
				3300
			],
			"projections_percentage": [
				0,
				16.07,
				33.81,
				49.88,
				58.27
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 32
					},
					"classroomspace": 3.01,
					"enrolment": 823,
					"ligo": 0.67,
					"location": [
						151.006039479983,
						-33.8573610204004
					],
					"name": "Blaxcell Street Public School",
					"playspace": 21.08,
					"projections": [
						869,
						823,
						960,
						1065,
						1175,
						1230
					],
					"projections_orig": [
						"869",
						"823",
						"960",
						"1065",
						"1175",
						"1230"
					],
					"projections_percentage": [
						5.59,
						0,
						16.65,
						29.4,
						42.77,
						49.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1257
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 2.87,
					"enrolment": 567,
					"ligo": 0.75,
					"location": [
						151.004827203956,
						-33.8335978159559
					],
					"name": "Granville Public School",
					"playspace": 20.28,
					"projections": [
						509,
						567,
						645,
						780,
						910,
						980
					],
					"projections_orig": [
						"509",
						"567",
						"645",
						"780",
						"910",
						"980"
					],
					"projections_percentage": [
						-10.23,
						0,
						13.76,
						37.57,
						60.49,
						72.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2064
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 14
					},
					"classroomspace": 3.08,
					"enrolment": 336,
					"ligo": 0.52,
					"location": [
						150.995825058224,
						-33.8487752287938
					],
					"name": "Granville South Public School",
					"playspace": 37.31,
					"projections": [
						225,
						336,
						355,
						420,
						470,
						500
					],
					"projections_orig": [
						"225",
						"336",
						"355",
						"420",
						"470",
						"500"
					],
					"projections_percentage": [
						-33.04,
						0,
						5.65,
						25,
						39.88,
						48.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2066
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 12
					},
					"classroomspace": 3.59,
					"enrolment": 359,
					"ligo": 0.75,
					"location": [
						151.010816906797,
						-33.8479494592838
					],
					"name": "Granville East Public School",
					"playspace": 29.77,
					"projections": [
						392,
						359,
						460,
						525,
						570,
						590
					],
					"projections_orig": [
						"392",
						"359",
						"460",
						"525",
						"570",
						"590"
					],
					"projections_percentage": [
						9.19,
						0,
						28.13,
						46.24,
						58.77,
						64.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5236
				}
			],
			"uid": 10103
		},
		{
			"classrooms": {
				"demountable": 19,
				"permanent": 71
			},
			"enrolment": 1877,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Greenacre Primary",
			"playspace": 32.41,
			"projections": [
				1877,
				1985,
				2120,
				2265,
				2390
			],
			"projections_percentage": [
				0,
				5.75,
				12.95,
				20.67,
				27.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 32
					},
					"classroomspace": 2.61,
					"enrolment": 850,
					"ligo": 0.56,
					"location": [
						151.056791408611,
						-33.910982043334
					],
					"name": "Greenacre Public School",
					"playspace": 12.21,
					"projections": [
						769,
						850,
						865,
						920,
						985,
						1035
					],
					"projections_orig": [
						"769",
						"850",
						"865",
						"920",
						"985",
						"1035"
					],
					"projections_percentage": [
						-9.53,
						0,
						1.76,
						8.24,
						15.88,
						21.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1123
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.04,
					"enrolment": 315,
					"ligo": 0.75,
					"location": [
						151.060902893283,
						-33.894711493801
					],
					"name": "Chullora Public School",
					"playspace": 49.77,
					"projections": [
						366,
						315,
						370,
						380,
						390,
						405
					],
					"projections_orig": [
						"366",
						"315",
						"370",
						"380",
						"390",
						"405"
					],
					"projections_percentage": [
						16.19,
						0,
						17.46,
						20.63,
						23.81,
						28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3808
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 15
					},
					"classroomspace": 2.77,
					"enrolment": 535,
					"ligo": 0.56,
					"location": [
						151.050853653323,
						-33.9060982853701
					],
					"name": "Banksia Road Public School",
					"playspace": 48.34,
					"projections": [
						362,
						535,
						545,
						595,
						645,
						685
					],
					"projections_orig": [
						"362",
						"535",
						"545",
						"595",
						"645",
						"685"
					],
					"projections_percentage": [
						-32.34,
						0,
						1.87,
						11.21,
						20.56,
						28.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4217
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 6
					},
					"classroomspace": 3.38,
					"enrolment": 177,
					"ligo": 1,
					"location": [
						151.050333113101,
						-33.9163405726803
					],
					"name": "Mount Lewis Infants School",
					"playspace": 19.3,
					"projections": [
						182,
						177,
						205,
						225,
						245,
						265
					],
					"projections_orig": [
						"182",
						"177",
						"205",
						"225",
						"245",
						"265"
					],
					"projections_percentage": [
						2.82,
						0,
						15.82,
						27.12,
						38.42,
						49.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5241
				}
			],
			"uid": 10104
		},
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 144
			},
			"enrolment": 3458,
			"level": "Primary",
			"ligo": 0.63,
			"name": "Blacktown Primary",
			"playspace": 47.84,
			"projections": [
				3458,
				3810,
				4270,
				4655,
				4980
			],
			"projections_percentage": [
				0,
				10.18,
				23.48,
				34.62,
				44.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 25
					},
					"classroomspace": 2.61,
					"enrolment": 955,
					"ligo": 0.38,
					"location": [
						150.884194844544,
						-33.7374554141058
					],
					"name": "Quakers Hill Public School",
					"playspace": 22.88,
					"projections": [
						676,
						955,
						1010,
						1185,
						1310,
						1405
					],
					"projections_orig": [
						"676",
						"955",
						"1010",
						"1185",
						"1310",
						"1405"
					],
					"projections_percentage": [
						-29.21,
						0,
						5.76,
						24.08,
						37.17,
						47.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2918
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 3.39,
					"enrolment": 480,
					"ligo": 0.6,
					"location": [
						150.896160832556,
						-33.7571647563549
					],
					"name": "Marayong Public School",
					"playspace": 54.24,
					"projections": [
						489,
						480,
						555,
						615,
						660,
						710
					],
					"projections_orig": [
						"489",
						"480",
						"555",
						"615",
						"660",
						"710"
					],
					"projections_percentage": [
						1.88,
						0,
						15.62,
						28.12,
						37.5,
						47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4166
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.68,
					"enrolment": 322,
					"ligo": 0.64,
					"location": [
						150.897843200731,
						-33.7424072092128
					],
					"name": "Marayong Heights Public School",
					"playspace": 40.17,
					"projections": [
						316,
						322,
						350,
						390,
						430,
						460
					],
					"projections_orig": [
						"316",
						"322",
						"350",
						"390",
						"430",
						"460"
					],
					"projections_percentage": [
						-1.86,
						0,
						8.7,
						21.12,
						33.54,
						42.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4282
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.69,
					"enrolment": 350,
					"ligo": 0.68,
					"location": [
						150.8860747578,
						-33.7611331905306
					],
					"name": "Marayong South Public School",
					"playspace": 63.53,
					"projections": [
						283,
						350,
						395,
						420,
						445,
						470
					],
					"projections_orig": [
						"283",
						"350",
						"395",
						"420",
						"445",
						"470"
					],
					"projections_percentage": [
						-19.14,
						0,
						12.86,
						20,
						27.14,
						34.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4327
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 3.32,
					"enrolment": 483,
					"ligo": 0.64,
					"location": [
						150.868048961276,
						-33.7556430141507
					],
					"name": "Crawford Public School",
					"playspace": 41.83,
					"projections": [
						509,
						483,
						570,
						605,
						645,
						680
					],
					"projections_orig": [
						"509",
						"483",
						"570",
						"605",
						"645",
						"680"
					],
					"projections_percentage": [
						5.38,
						0,
						18.01,
						25.26,
						33.54,
						40.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4504
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3,
					"enrolment": 285,
					"ligo": 0.72,
					"location": [
						150.859599991462,
						-33.7351550617567
					],
					"name": "William Dean Public School",
					"playspace": 73.2,
					"projections": [
						256,
						285,
						340,
						385,
						420,
						445
					],
					"projections_orig": [
						"256",
						"285",
						"340",
						"385",
						"420",
						"445"
					],
					"projections_percentage": [
						-10.18,
						0,
						19.3,
						35.09,
						47.37,
						56.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4576
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.17,
					"enrolment": 583,
					"ligo": 0.73,
					"location": [
						150.853255886781,
						-33.7431988480154
					],
					"name": "Glendenning Public School",
					"playspace": 39.02,
					"projections": [
						505,
						583,
						590,
						670,
						745,
						810
					],
					"projections_orig": [
						"505",
						"583",
						"590",
						"670",
						"745",
						"810"
					],
					"projections_percentage": [
						-13.38,
						0,
						1.2,
						14.92,
						27.79,
						38.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4608
				}
			],
			"uid": 10105
		},
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 78
			},
			"enrolment": 2455,
			"level": "Primary",
			"ligo": 0.76,
			"name": "Pennant Hills Primary",
			"playspace": 30.54,
			"projections": [
				2455,
				2570,
				2755,
				2840,
				2900
			],
			"projections_percentage": [
				0,
				4.68,
				12.22,
				15.68,
				18.13
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 28
					},
					"classroomspace": 2.42,
					"enrolment": 835,
					"ligo": 0.78,
					"location": [
						151.065063643707,
						-33.7527329368585
					],
					"name": "Beecroft Public School",
					"playspace": 12.33,
					"projections": [
						711,
						835,
						860,
						910,
						920,
						925
					],
					"projections_orig": [
						"711",
						"835",
						"860",
						"910",
						"920",
						"925"
					],
					"projections_percentage": [
						-14.85,
						0,
						2.99,
						8.98,
						10.18,
						10.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1166
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 15
					},
					"classroomspace": 2.52,
					"enrolment": 546,
					"ligo": 0.83,
					"location": [
						151.068285992991,
						-33.7360441753883
					],
					"name": "Pennant Hills Public School",
					"playspace": 35.59,
					"projections": [
						511,
						546,
						585,
						615,
						625,
						625
					],
					"projections_orig": [
						"511",
						"546",
						"585",
						"615",
						"625",
						"625"
					],
					"projections_percentage": [
						-6.41,
						0,
						7.14,
						12.64,
						14.47,
						14.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2857
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 23
					},
					"classroomspace": 2.33,
					"enrolment": 650,
					"ligo": 0.6,
					"location": [
						151.050130513639,
						-33.7458516404836
					],
					"name": "West Pennant Hills Public School",
					"playspace": 24.33,
					"projections": [
						569,
						650,
						675,
						725,
						780,
						830
					],
					"projections_orig": [
						"569",
						"650",
						"675",
						"725",
						"780",
						"830"
					],
					"projections_percentage": [
						-12.46,
						0,
						3.85,
						11.54,
						20,
						27.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2858
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.21,
					"enrolment": 424,
					"ligo": 0.83,
					"location": [
						151.095542590062,
						-33.756840884127
					],
					"name": "Epping North Public School",
					"playspace": 49.91,
					"projections": [
						406,
						424,
						450,
						505,
						515,
						520
					],
					"projections_orig": [
						"406",
						"424",
						"450",
						"505",
						"515",
						"520"
					],
					"projections_percentage": [
						-4.25,
						0,
						6.13,
						19.1,
						21.46,
						22.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4165
				}
			],
			"uid": 10106
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 35
			},
			"enrolment": 654,
			"level": "Primary",
			"ligo": 0.53,
			"name": "Schofields Primary",
			"playspace": 207.28,
			"projections": [
				654,
				935,
				2575,
				3470,
				4660
			],
			"projections_percentage": [
				0,
				42.97,
				293.73,
				430.58,
				612.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.46,
					"enrolment": 56,
					"ligo": 0.53,
					"location": [
						150.832749108896,
						-33.6961592318258
					],
					"name": "Marsden Park Public School",
					"playspace": 297.71,
					"projections": [
						69,
						56,
						165,
						780,
						1095,
						1460
					],
					"projections_orig": [
						"69",
						"56",
						"165",
						"780",
						"1095",
						"1460"
					],
					"projections_percentage": [
						23.21,
						0,
						194.64,
						1292.86,
						1855.36,
						2507.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2489
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.37,
					"enrolment": 251,
					"ligo": 0.71,
					"location": [
						150.869733854412,
						-33.677761365872
					],
					"name": "Riverstone Public School",
					"playspace": 77.02,
					"projections": [
						301,
						251,
						310,
						700,
						945,
						1260
					],
					"projections_orig": [
						"301",
						"251",
						"310",
						"700",
						"945",
						"1260"
					],
					"projections_percentage": [
						19.92,
						0,
						23.51,
						178.88,
						276.49,
						401.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2970
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 7
					},
					"classroomspace": 3.57,
					"enrolment": 321,
					"ligo": 0.5,
					"location": [
						150.875363705058,
						-33.6922658997546
					],
					"name": "Schofields Public School",
					"playspace": 66.97,
					"projections": [
						290,
						321,
						410,
						940,
						1250,
						1565
					],
					"projections_orig": [
						"290",
						"321",
						"410",
						"940",
						"1250",
						"1565"
					],
					"projections_percentage": [
						-9.66,
						0,
						27.73,
						192.83,
						289.41,
						387.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3046
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.17,
					"enrolment": 26,
					"ligo": 0.38,
					"location": [
						150.857321728101,
						-33.6471327934044
					],
					"name": "Vineyard Public School",
					"playspace": 387.41,
					"projections": [
						36,
						26,
						50,
						155,
						180,
						375
					],
					"projections_orig": [
						"36",
						"26",
						"50",
						"155",
						"180",
						"375"
					],
					"projections_percentage": [
						38.46,
						0,
						92.31,
						496.15,
						592.31,
						1342.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3329
				}
			],
			"uid": 10107
		},
		{
			"classrooms": {
				"demountable": 64,
				"permanent": 73
			},
			"enrolment": 3262,
			"level": "Primary",
			"ligo": 0.86,
			"name": "The Ponds Primary",
			"playspace": 20.38,
			"projections": [
				3262,
				3690,
				3940,
				4205,
				4460
			],
			"projections_percentage": [
				0,
				13.12,
				20.78,
				28.91,
				36.73
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 20
					},
					"classroomspace": 2.51,
					"enrolment": 712,
					"ligo": 0.8,
					"location": [
						150.935466149672,
						-33.726752910774
					],
					"name": "Parklea Public School",
					"playspace": 28.05,
					"projections": [
						702,
						712,
						880,
						975,
						1055,
						1145
					],
					"projections_orig": [
						"702",
						"712",
						"880",
						"975",
						"1055",
						"1145"
					],
					"projections_percentage": [
						-1.4,
						0,
						23.6,
						36.94,
						48.17,
						60.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2838
				},
				{
					"classrooms": {
						"demountable": 21,
						"permanent": 14
					},
					"classroomspace": 2.93,
					"enrolment": 835,
					"ligo": 0.79,
					"location": [
						150.925484986101,
						-33.704324554498
					],
					"name": "Kellyville Ridge Public School",
					"playspace": 17.17,
					"projections": [
						774,
						835,
						935,
						1040,
						1160,
						1260
					],
					"projections_orig": [
						"774",
						"835",
						"935",
						"1040",
						"1160",
						"1260"
					],
					"projections_percentage": [
						-7.31,
						0,
						11.98,
						24.55,
						38.92,
						50.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4639
				},
				{
					"classrooms": {
						"demountable": 19,
						"permanent": 18
					},
					"classroomspace": 2.76,
					"enrolment": 903,
					"ligo": 0.86,
					"location": [
						150.912011995865,
						-33.7078947012482
					],
					"name": "John Palmer Public School",
					"playspace": 20.4,
					"projections": [
						512,
						903,
						935,
						945,
						975,
						1005
					],
					"projections_orig": [
						"512",
						"903",
						"935",
						"945",
						"975",
						"1005"
					],
					"projections_percentage": [
						-43.3,
						0,
						3.54,
						4.65,
						7.97,
						11.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4648
				},
				{
					"classrooms": {
						"demountable": 15,
						"permanent": 21
					},
					"classroomspace": 2.99,
					"enrolment": 812,
					"ligo": 0.87,
					"location": [
						150.899219169294,
						-33.7036966668922
					],
					"name": "Riverbank Public School",
					"playspace": 15.88,
					"projections": [
						0,
						812,
						940,
						980,
						1015,
						1050
					],
					"projections_orig": [
						"0",
						"812",
						"940",
						"980",
						"1015",
						"1050"
					],
					"projections_percentage": [
						-100,
						0,
						15.76,
						20.69,
						25,
						29.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4653
				}
			],
			"uid": 10108
		},
		{
			"classrooms": {
				"demountable": 54,
				"permanent": 101
			},
			"enrolment": 3678,
			"level": "Primary",
			"ligo": 0.82,
			"name": "Kellyville Primary",
			"playspace": 24.42,
			"projections": [
				3678,
				4440,
				6440,
				7785,
				9665
			],
			"projections_percentage": [
				0,
				20.72,
				75.1,
				111.66,
				162.78
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 22
					},
					"classroomspace": 2.61,
					"enrolment": 728,
					"ligo": 0.83,
					"location": [
						150.957641421517,
						-33.712109170982
					],
					"name": "Kellyville Public School",
					"playspace": 17.11,
					"projections": [
						530,
						728,
						915,
						1340,
						1715,
						2000
					],
					"projections_orig": [
						"530",
						"728",
						"915",
						"1340",
						"1715",
						"2000"
					],
					"projections_percentage": [
						-27.2,
						0,
						25.69,
						84.07,
						135.58,
						174.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2274
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 25
					},
					"classroomspace": 3.16,
					"enrolment": 656,
					"ligo": 0.8,
					"location": [
						150.920080913483,
						-33.6786555040913
					],
					"name": "Rouse Hill Public School",
					"playspace": 27.96,
					"projections": [
						866,
						656,
						980,
						1850,
						2190,
						3280
					],
					"projections_orig": [
						"866",
						"656",
						"980",
						"1850",
						"2190",
						"3280"
					],
					"projections_percentage": [
						32.01,
						0,
						49.39,
						182.01,
						233.84,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3008
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.48,
					"enrolment": 613,
					"ligo": 0.8,
					"location": [
						150.946293521181,
						-33.6972537112269
					],
					"name": "Beaumont Hills Public School",
					"playspace": 31.43,
					"projections": [
						613,
						613,
						710,
						900,
						1060,
						1185
					],
					"projections_orig": [
						"613",
						"613",
						"710",
						"900",
						"1060",
						"1185"
					],
					"projections_percentage": [
						0,
						0,
						15.82,
						46.82,
						72.92,
						93.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4630
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 14
					},
					"classroomspace": 2.55,
					"enrolment": 749,
					"ligo": 0.68,
					"location": [
						150.932631871527,
						-33.6885902184696
					],
					"name": "Ironbark Ridge Public School",
					"playspace": 21.48,
					"projections": [
						544,
						749,
						800,
						1070,
						1305,
						1520
					],
					"projections_orig": [
						"544",
						"749",
						"800",
						"1070",
						"1305",
						"1520"
					],
					"projections_percentage": [
						-27.37,
						0,
						6.81,
						42.86,
						74.23,
						102.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4638
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 20
					},
					"classroomspace": 2.87,
					"enrolment": 932,
					"ligo": 0.83,
					"location": [
						150.976524543576,
						-33.7073991442358
					],
					"name": "Sherwood Ridge Public School",
					"playspace": 24.14,
					"projections": [
						779,
						932,
						1035,
						1280,
						1515,
						1680
					],
					"projections_orig": [
						"779",
						"932",
						"1035",
						"1280",
						"1515",
						"1680"
					],
					"projections_percentage": [
						-16.42,
						0,
						11.05,
						37.34,
						62.55,
						80.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4640
				}
			],
			"uid": 10109
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 42
			},
			"enrolment": 1002,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Hawkesbury East Primary",
			"playspace": 277.71,
			"projections": [
				1002,
				1201,
				1441,
				1781,
				2086
			],
			"projections_percentage": [
				0,
				19.86,
				43.81,
				77.74,
				108.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.5,
					"enrolment": 52,
					"ligo": 0.57,
					"location": [
						150.90688477043,
						-33.5587671750102
					],
					"name": "Cattai Public School",
					"playspace": 85.26,
					"projections": [
						57,
						52,
						60,
						65,
						70,
						70
					],
					"projections_orig": [
						"57",
						"52",
						"60",
						"65",
						"70",
						"70"
					],
					"projections_percentage": [
						9.62,
						0,
						15.38,
						25,
						34.62,
						34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1535
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.23,
					"enrolment": 28,
					"ligo": 0.42,
					"location": [
						150.976694650129,
						-33.6015425880439
					],
					"name": "Hillside Public School",
					"playspace": 400.87,
					"projections": [
						56,
						28,
						50,
						55,
						60,
						65
					],
					"projections_orig": [
						"56",
						"28",
						"50",
						"55",
						"60",
						"65"
					],
					"projections_percentage": [
						100,
						0,
						78.57,
						96.43,
						114.29,
						132.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2164
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.25,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						150.97197828918,
						-33.3206450175787
					],
					"name": "Macdonald Valley Public School",
					"playspace": 740.69,
					"projections": [
						8,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-27.27,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2439
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.74,
					"enrolment": 115,
					"ligo": 0.63,
					"location": [
						150.915991165076,
						-33.5936234394937
					],
					"name": "Maraylya Public School",
					"playspace": 95.2,
					"projections": [
						110,
						115,
						155,
						200,
						270,
						325
					],
					"projections_orig": [
						"110",
						"115",
						"155",
						"200",
						"270",
						"325"
					],
					"projections_percentage": [
						-4.35,
						0,
						34.78,
						73.91,
						134.78,
						182.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2472
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.41,
					"enrolment": 29,
					"ligo": 0.42,
					"location": [
						150.994250474276,
						-33.455557413087
					],
					"name": "Maroota Public School",
					"playspace": 348.11,
					"projections": [
						53,
						29,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"53",
						"29",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						82.76,
						0,
						72.41,
						72.41,
						72.41,
						72.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2480
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.48,
					"enrolment": 446,
					"ligo": 0.62,
					"location": [
						150.87057554826,
						-33.6197838366512
					],
					"name": "Oakville Public School",
					"playspace": 35.66,
					"projections": [
						426,
						446,
						550,
						730,
						965,
						1165
					],
					"projections_orig": [
						"426",
						"446",
						"550",
						"730",
						"965",
						"1165"
					],
					"projections_percentage": [
						-4.48,
						0,
						23.32,
						63.68,
						116.37,
						161.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2794
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 6
					},
					"classroomspace": 3.06,
					"enrolment": 286,
					"ligo": 0.65,
					"location": [
						150.859954616521,
						-33.5843094151674
					],
					"name": "Pitt Town Public School",
					"playspace": 82.3,
					"projections": [
						163,
						286,
						275,
						280,
						305,
						350
					],
					"projections_orig": [
						"163",
						"286",
						"275",
						"280",
						"305",
						"350"
					],
					"projections_percentage": [
						-43.01,
						0,
						-3.85,
						-2.1,
						6.64,
						22.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2884
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 5
					},
					"classroomspace": 8.72,
					"enrolment": 35,
					"ligo": 0.57,
					"location": [
						150.985052628361,
						-33.3861356144271
					],
					"name": "Wisemans Ferry Public School",
					"playspace": 433.56,
					"projections": [
						66,
						35,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"66",
						"35",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						88.57,
						0,
						42.86,
						42.86,
						42.86,
						42.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3470
				}
			],
			"uid": 10110
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 134
			},
			"enrolment": 3183,
			"level": "Primary",
			"ligo": 0.66,
			"name": "St Marys Primary",
			"playspace": 51.79,
			"projections": [
				3183,
				3405,
				3680,
				3910,
				4105
			],
			"projections_percentage": [
				0,
				6.97,
				15.61,
				22.84,
				28.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 23
					},
					"classroomspace": 2.39,
					"enrolment": 770,
					"ligo": 0.53,
					"location": [
						150.81265415491,
						-33.776958416077
					],
					"name": "Colyton Public School",
					"playspace": 27.07,
					"projections": [
						662,
						770,
						785,
						855,
						910,
						960
					],
					"projections_orig": [
						"662",
						"770",
						"785",
						"855",
						"910",
						"960"
					],
					"projections_percentage": [
						-14.03,
						0,
						1.95,
						11.04,
						18.18,
						24.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1596
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.39,
					"enrolment": 306,
					"ligo": 0.72,
					"location": [
						150.853862164885,
						-33.7877836797885
					],
					"name": "Eastern Creek Public School",
					"playspace": 55.95,
					"projections": [
						292,
						306,
						325,
						345,
						370,
						390
					],
					"projections_orig": [
						"292",
						"306",
						"325",
						"345",
						"370",
						"390"
					],
					"projections_percentage": [
						-4.58,
						0,
						6.21,
						12.75,
						20.92,
						27.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1808
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.95,
					"enrolment": 291,
					"ligo": 0.61,
					"location": [
						150.770330565374,
						-33.7685799398685
					],
					"name": "St Marys Public School",
					"playspace": 65.34,
					"projections": [
						228,
						291,
						300,
						330,
						355,
						375
					],
					"projections_orig": [
						"228",
						"291",
						"300",
						"330",
						"355",
						"375"
					],
					"projections_percentage": [
						-21.65,
						0,
						3.09,
						13.4,
						21.99,
						28.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3031
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 18
					},
					"classroomspace": 2.57,
					"enrolment": 495,
					"ligo": 0.63,
					"location": [
						150.789301929249,
						-33.7707406165155
					],
					"name": "Oxley Park Public School",
					"playspace": 39.12,
					"projections": [
						493,
						495,
						540,
						595,
						635,
						670
					],
					"projections_orig": [
						"493",
						"495",
						"540",
						"595",
						"635",
						"670"
					],
					"projections_percentage": [
						-0.4,
						0,
						9.09,
						20.2,
						28.28,
						35.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4055
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.84,
					"enrolment": 297,
					"ligo": 0.65,
					"location": [
						150.775488237882,
						-33.7795601681774
					],
					"name": "St Marys South Public School",
					"playspace": 83.78,
					"projections": [
						287,
						297,
						340,
						365,
						385,
						400
					],
					"projections_orig": [
						"287",
						"297",
						"340",
						"365",
						"385",
						"400"
					],
					"projections_percentage": [
						-3.37,
						0,
						14.48,
						22.9,
						29.63,
						34.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4279
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 3.27,
					"enrolment": 508,
					"ligo": 0.72,
					"location": [
						150.791139582858,
						-33.7839738756934
					],
					"name": "Bennett Road Public School",
					"playspace": 50.73,
					"projections": [
						451,
						508,
						570,
						610,
						645,
						665
					],
					"projections_orig": [
						"451",
						"508",
						"570",
						"610",
						"645",
						"665"
					],
					"projections_percentage": [
						-11.22,
						0,
						12.2,
						20.08,
						26.97,
						30.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4285
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 2.5,
					"enrolment": 516,
					"ligo": 0.76,
					"location": [
						150.831811017609,
						-33.7876058554851
					],
					"name": "Minchinbury Public School",
					"playspace": 40.55,
					"projections": [
						555,
						516,
						545,
						580,
						610,
						645
					],
					"projections_orig": [
						"555",
						"516",
						"545",
						"580",
						"610",
						"645"
					],
					"projections_percentage": [
						7.56,
						0,
						5.62,
						12.4,
						18.22,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4577
				}
			],
			"uid": 10111
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 155
			},
			"enrolment": 2712,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Albury City Primary",
			"playspace": 95,
			"projections": [
				2712,
				2670,
				2745,
				2770,
				2720
			],
			"projections_percentage": [
				0,
				-1.55,
				1.22,
				2.14,
				0.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 2.88,
					"enrolment": 574,
					"ligo": 0.79,
					"location": [
						146.920285140865,
						-36.0827945079037
					],
					"name": "Albury Public School",
					"playspace": 31.12,
					"projections": [
						618,
						574,
						620,
						640,
						640,
						620
					],
					"projections_orig": [
						"618",
						"574",
						"620",
						"640",
						"640",
						"620"
					],
					"projections_percentage": [
						7.67,
						0,
						8.01,
						11.5,
						11.5,
						8.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1017
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.94,
					"enrolment": 142,
					"ligo": 0.9,
					"location": [
						146.896314878771,
						-36.0774151944936
					],
					"name": "Albury West Public School",
					"playspace": 124.54,
					"projections": [
						122,
						142,
						130,
						130,
						135,
						130
					],
					"projections_orig": [
						"122",
						"142",
						"130",
						"130",
						"135",
						"130"
					],
					"projections_percentage": [
						-14.08,
						0,
						-8.45,
						-8.45,
						-4.93,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1019
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.29,
					"enrolment": 339,
					"ligo": 0.65,
					"location": [
						146.928184000598,
						-36.038016321529
					],
					"name": "Lavington Public School",
					"playspace": 114.88,
					"projections": [
						348,
						339,
						315,
						325,
						330,
						325
					],
					"projections_orig": [
						"348",
						"339",
						"315",
						"325",
						"330",
						"325"
					],
					"projections_percentage": [
						2.65,
						0,
						-7.08,
						-4.13,
						-2.65,
						-4.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2378
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 14
					},
					"classroomspace": 2.5,
					"enrolment": 487,
					"ligo": 0.9,
					"location": [
						146.982778452228,
						-36.0475263687704
					],
					"name": "Thurgoona Public School",
					"playspace": 55.69,
					"projections": [
						370,
						487,
						425,
						440,
						445,
						440
					],
					"projections_orig": [
						"370",
						"487",
						"425",
						"440",
						"445",
						"440"
					],
					"projections_percentage": [
						-24.02,
						0,
						-12.73,
						-9.65,
						-8.62,
						-9.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3208
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 4.37,
					"enrolment": 254,
					"ligo": 0.72,
					"location": [
						146.931440577263,
						-36.0644210028668
					],
					"name": "Albury North Public School",
					"playspace": 83.2,
					"projections": [
						251,
						254,
						275,
						280,
						285,
						280
					],
					"projections_orig": [
						"251",
						"254",
						"275",
						"280",
						"285",
						"280"
					],
					"projections_percentage": [
						-1.18,
						0,
						8.27,
						10.24,
						12.2,
						10.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3922
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 13
					},
					"classroomspace": 2.81,
					"enrolment": 348,
					"ligo": 0.46,
					"location": [
						146.947734286219,
						-36.0397396740408
					],
					"name": "Lavington East Public School",
					"playspace": 87.7,
					"projections": [
						336,
						348,
						345,
						355,
						355,
						350
					],
					"projections_orig": [
						"336",
						"348",
						"345",
						"355",
						"355",
						"350"
					],
					"projections_percentage": [
						-3.45,
						0,
						-0.86,
						2.01,
						2.01,
						0.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4168
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 5.43,
					"enrolment": 214,
					"ligo": 0.56,
					"location": [
						146.946534023287,
						-36.0492642209467
					],
					"name": "Hume Public School",
					"playspace": 142.45,
					"projections": [
						216,
						214,
						205,
						210,
						215,
						210
					],
					"projections_orig": [
						"216",
						"214",
						"205",
						"210",
						"215",
						"210"
					],
					"projections_percentage": [
						0.93,
						0,
						-4.21,
						-1.87,
						0.47,
						-1.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4407
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 6.77,
					"enrolment": 183,
					"ligo": 0.68,
					"location": [
						146.916999030304,
						-36.0557292409955
					],
					"name": "Glenroy Public School",
					"playspace": 103.48,
					"projections": [
						186,
						183,
						185,
						190,
						190,
						190
					],
					"projections_orig": [
						"186",
						"183",
						"185",
						"190",
						"190",
						"190"
					],
					"projections_percentage": [
						1.64,
						0,
						1.09,
						3.83,
						3.83,
						3.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4468
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.1,
					"enrolment": 171,
					"ligo": 0.61,
					"location": [
						146.95025584506,
						-36.0321306790772
					],
					"name": "Springdale Heights Public School",
					"playspace": 111.93,
					"projections": [
						170,
						171,
						170,
						175,
						175,
						175
					],
					"projections_orig": [
						"170",
						"171",
						"170",
						"175",
						"175",
						"175"
					],
					"projections_percentage": [
						-0.58,
						0,
						-0.58,
						2.34,
						2.34,
						2.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4523
				}
			],
			"uid": 10112
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 30
			},
			"enrolment": 792,
			"level": "Primary",
			"ligo": 0.85,
			"name": "Leeton Town",
			"playspace": 115.47,
			"projections": [
				792,
				752,
				762,
				697,
				642
			],
			"projections_percentage": [
				0,
				-5.05,
				-3.79,
				-11.99,
				-18.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.63,
					"enrolment": 369,
					"ligo": 0.74,
					"location": [
						146.407734430993,
						-34.5459581522012
					],
					"name": "Leeton Public School",
					"playspace": 60.09,
					"projections": [
						384,
						369,
						380,
						385,
						350,
						320
					],
					"projections_orig": [
						"384",
						"369",
						"380",
						"385",
						"350",
						"320"
					],
					"projections_percentage": [
						4.07,
						0,
						2.98,
						4.34,
						-5.15,
						-13.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2386
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 7.12,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						146.410933718096,
						-34.5981271210088
					],
					"name": "Yanco Public School",
					"playspace": 250.36,
					"projections": [
						57,
						37,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"57",
						"37",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						54.05,
						0,
						-32.43,
						-32.43,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3536
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 7
					},
					"classroomspace": 2.69,
					"enrolment": 386,
					"ligo": 0.81,
					"location": [
						146.396107260313,
						-34.5622124413498
					],
					"name": "Parkview Public School",
					"playspace": 35.95,
					"projections": [
						225,
						386,
						335,
						340,
						310,
						285
					],
					"projections_orig": [
						"225",
						"386",
						"335",
						"340",
						"310",
						"285"
					],
					"projections_percentage": [
						-41.71,
						0,
						-13.21,
						-11.92,
						-19.69,
						-26.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4413
				}
			],
			"uid": 10113
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 183
			},
			"enrolment": 3809,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Wagga City Primary",
			"playspace": 48.77,
			"projections": [
				3809,
				4070,
				4175,
				4080,
				4080
			],
			"projections_percentage": [
				0,
				6.85,
				9.61,
				7.11,
				7.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 5
					},
					"classroomspace": 2.99,
					"enrolment": 223,
					"ligo": 0.85,
					"location": [
						147.467352694528,
						-35.1485845328688
					],
					"name": "Forest Hill Public School",
					"playspace": 91.58,
					"projections": [
						210,
						223,
						240,
						245,
						240,
						230
					],
					"projections_orig": [
						"210",
						"223",
						"240",
						"245",
						"240",
						"230"
					],
					"projections_percentage": [
						-5.83,
						0,
						7.62,
						9.87,
						7.62,
						3.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1930
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.56,
					"enrolment": 530,
					"ligo": 0.71,
					"location": [
						147.380267320383,
						-35.1734680894194
					],
					"name": "Lake Albert Public School",
					"playspace": 37.95,
					"projections": [
						445,
						530,
						590,
						605,
						575,
						570
					],
					"projections_orig": [
						"445",
						"530",
						"590",
						"605",
						"575",
						"570"
					],
					"projections_percentage": [
						-16.04,
						0,
						11.32,
						14.15,
						8.49,
						7.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2357
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.4,
					"enrolment": 435,
					"ligo": 0.54,
					"location": [
						147.365235333366,
						-35.1075304736448
					],
					"name": "Wagga Wagga Public School",
					"playspace": 15.25,
					"projections": [
						382,
						435,
						450,
						460,
						445,
						445
					],
					"projections_orig": [
						"382",
						"435",
						"450",
						"460",
						"445",
						"445"
					],
					"projections_percentage": [
						-12.18,
						0,
						3.45,
						5.75,
						2.3,
						2.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3330
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 7
					},
					"classroomspace": 2.61,
					"enrolment": 271,
					"ligo": 0.67,
					"location": [
						147.379382675481,
						-35.0966053178279
					],
					"name": "North Wagga Public School",
					"playspace": 35.77,
					"projections": [
						249,
						271,
						265,
						270,
						270,
						270
					],
					"projections_orig": [
						"249",
						"271",
						"265",
						"270",
						"270",
						"270"
					],
					"projections_percentage": [
						-8.12,
						0,
						-2.21,
						-0.37,
						-0.37,
						-0.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3332
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.31,
					"enrolment": 318,
					"ligo": 0.44,
					"location": [
						147.366580374303,
						-35.1187025735858
					],
					"name": "South Wagga Public School",
					"playspace": 43.3,
					"projections": [
						297,
						318,
						335,
						355,
						345,
						350
					],
					"projections_orig": [
						"297",
						"318",
						"335",
						"355",
						"345",
						"350"
					],
					"projections_percentage": [
						-6.6,
						0,
						5.35,
						11.64,
						8.49,
						10.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3333
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.56,
					"enrolment": 80,
					"ligo": 1,
					"location": [
						147.296633206714,
						-35.1515811315981
					],
					"name": "Kapooka Public School",
					"playspace": 1.56,
					"projections": [
						57,
						80,
						75,
						80,
						80,
						80
					],
					"projections_orig": [
						"57",
						"80",
						"75",
						"80",
						"80",
						"80"
					],
					"projections_percentage": [
						-28.75,
						0,
						-6.25,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3923
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.42,
					"enrolment": 390,
					"ligo": 0.46,
					"location": [
						147.357145557115,
						-35.1281408808578
					],
					"name": "Turvey Park Public School",
					"playspace": 35.77,
					"projections": [
						350,
						390,
						415,
						425,
						415,
						420
					],
					"projections_orig": [
						"350",
						"390",
						"415",
						"425",
						"415",
						"420"
					],
					"projections_percentage": [
						-10.26,
						0,
						6.41,
						8.97,
						6.41,
						7.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4144
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.91,
					"enrolment": 456,
					"ligo": 0.64,
					"location": [
						147.372510035177,
						-35.1477198323025
					],
					"name": "Kooringal Public School",
					"playspace": 50.94,
					"projections": [
						420,
						456,
						545,
						555,
						530,
						530
					],
					"projections_orig": [
						"420",
						"456",
						"545",
						"555",
						"530",
						"530"
					],
					"projections_percentage": [
						-7.89,
						0,
						19.52,
						21.71,
						16.23,
						16.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4173
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 5.24,
					"enrolment": 274,
					"ligo": 0.6,
					"location": [
						147.351774228468,
						-35.1357792605959
					],
					"name": "Mount Austin Public School",
					"playspace": 81.74,
					"projections": [
						266,
						274,
						275,
						280,
						285,
						285
					],
					"projections_orig": [
						"266",
						"274",
						"275",
						"280",
						"285",
						"285"
					],
					"projections_percentage": [
						-2.92,
						0,
						0.36,
						2.19,
						4.01,
						4.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4215
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 4.66,
					"enrolment": 221,
					"ligo": 0.81,
					"location": [
						147.333479678367,
						-35.1237981558764
					],
					"name": "Ashmont Public School",
					"playspace": 58.53,
					"projections": [
						240,
						221,
						245,
						250,
						250,
						255
					],
					"projections_orig": [
						"240",
						"221",
						"245",
						"250",
						"250",
						"255"
					],
					"projections_percentage": [
						8.6,
						0,
						10.86,
						13.12,
						13.12,
						15.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4375
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4.75,
					"enrolment": 250,
					"ligo": 0.69,
					"location": [
						147.348207854156,
						-35.1459597480476
					],
					"name": "Red Hill Public School",
					"playspace": 62.5,
					"projections": [
						213,
						250,
						245,
						250,
						255,
						255
					],
					"projections_orig": [
						"213",
						"250",
						"245",
						"250",
						"255",
						"255"
					],
					"projections_percentage": [
						-14.8,
						0,
						-2,
						0,
						2,
						2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4410
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.99,
					"enrolment": 361,
					"ligo": 0.48,
					"location": [
						147.377329434852,
						-35.1369003894338
					],
					"name": "Sturt Public School",
					"playspace": 70.39,
					"projections": [
						333,
						361,
						390,
						400,
						390,
						390
					],
					"projections_orig": [
						"333",
						"361",
						"390",
						"400",
						"390",
						"390"
					],
					"projections_percentage": [
						-7.76,
						0,
						8.03,
						10.8,
						8.03,
						8.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4457
				}
			],
			"uid": 10114
		},
		{
			"classrooms": {
				"demountable": 47,
				"permanent": 145
			},
			"enrolment": 4149,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Queanbeyan Yass Primary",
			"playspace": 67.48,
			"projections": [
				4149,
				4860,
				5100,
				5180,
				5250
			],
			"projections_percentage": [
				0,
				17.14,
				22.92,
				24.85,
				26.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 19
					},
					"classroomspace": 2.78,
					"enrolment": 492,
					"ligo": 0.85,
					"location": [
						149.445485541765,
						-35.255977522603
					],
					"name": "Bungendore Public School",
					"playspace": 37.63,
					"projections": [
						456,
						492,
						565,
						545,
						515,
						470
					],
					"projections_orig": [
						"456",
						"492",
						"565",
						"545",
						"515",
						"470"
					],
					"projections_percentage": [
						-7.32,
						0,
						14.84,
						10.77,
						4.67,
						-4.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1421
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 2.63,
					"enrolment": 104,
					"ligo": 0.88,
					"location": [
						149.266554275508,
						-35.029799131663
					],
					"name": "Gundaroo Public School",
					"playspace": 131.41,
					"projections": [
						85,
						104,
						95,
						100,
						95,
						95
					],
					"projections_orig": [
						"85",
						"104",
						"95",
						"100",
						"95",
						"95"
					],
					"projections_percentage": [
						-18.27,
						0,
						-8.65,
						-3.85,
						-8.65,
						-8.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2104
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 25
					},
					"classroomspace": 2.58,
					"enrolment": 753,
					"ligo": 0.44,
					"location": [
						149.237136692915,
						-35.3575053578809
					],
					"name": "Queanbeyan Public School",
					"playspace": 26.17,
					"projections": [
						769,
						753,
						935,
						995,
						1020,
						1040
					],
					"projections_orig": [
						"769",
						"753",
						"935",
						"995",
						"1020",
						"1040"
					],
					"projections_percentage": [
						2.12,
						0,
						24.17,
						32.14,
						35.46,
						38.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2922
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 5
					},
					"classroomspace": 2.77,
					"enrolment": 273,
					"ligo": 0.74,
					"location": [
						149.254378322472,
						-35.1659048320763
					],
					"name": "Sutton Public School",
					"playspace": 87,
					"projections": [
						181,
						273,
						295,
						295,
						290,
						280
					],
					"projections_orig": [
						"181",
						"273",
						"295",
						"295",
						"290",
						"280"
					],
					"projections_percentage": [
						-33.7,
						0,
						8.06,
						8.06,
						6.23,
						2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3137
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.68,
					"enrolment": 286,
					"ligo": 0.62,
					"location": [
						148.906919753339,
						-34.8375062161716
					],
					"name": "Yass Public School",
					"playspace": 56.41,
					"projections": [
						222,
						286,
						295,
						310,
						320,
						325
					],
					"projections_orig": [
						"222",
						"286",
						"295",
						"310",
						"320",
						"325"
					],
					"projections_percentage": [
						-22.38,
						0,
						3.15,
						8.39,
						11.89,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3549
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 14
					},
					"classroomspace": 2.85,
					"enrolment": 436,
					"ligo": 0.67,
					"location": [
						149.215334584971,
						-35.3474627835867
					],
					"name": "Queanbeyan West Public School",
					"playspace": 74.77,
					"projections": [
						420,
						436,
						515,
						555,
						565,
						595
					],
					"projections_orig": [
						"420",
						"436",
						"515",
						"555",
						"565",
						"595"
					],
					"projections_percentage": [
						-3.67,
						0,
						18.12,
						27.29,
						29.59,
						36.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4127
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 4
					},
					"classroomspace": 3.66,
					"enrolment": 204,
					"ligo": 0.69,
					"location": [
						149.246481440354,
						-35.34483908572
					],
					"name": "Queanbeyan East Public School",
					"playspace": 87.76,
					"projections": [
						190,
						204,
						220,
						230,
						245,
						255
					],
					"projections_orig": [
						"190",
						"204",
						"220",
						"230",
						"245",
						"255"
					],
					"projections_percentage": [
						-6.86,
						0,
						7.84,
						12.75,
						20.1,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4371
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 4.54,
					"enrolment": 376,
					"ligo": 0.72,
					"location": [
						149.228162149189,
						-35.3646182721723
					],
					"name": "Queanbeyan South Public School",
					"playspace": 78.05,
					"projections": [
						398,
						376,
						470,
						500,
						500,
						525
					],
					"projections_orig": [
						"398",
						"376",
						"470",
						"500",
						"500",
						"525"
					],
					"projections_percentage": [
						5.85,
						0,
						25,
						32.98,
						32.98,
						39.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4394
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 3.24,
					"enrolment": 300,
					"ligo": 0.61,
					"location": [
						148.920147264982,
						-34.8489947361532
					],
					"name": "Berinba Public School",
					"playspace": 75.43,
					"projections": [
						264,
						300,
						345,
						360,
						370,
						375
					],
					"projections_orig": [
						"264",
						"300",
						"345",
						"360",
						"370",
						"375"
					],
					"projections_percentage": [
						-12,
						0,
						15,
						20,
						23.33,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4450
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 23
					},
					"classroomspace": 2.6,
					"enrolment": 925,
					"ligo": 0.89,
					"location": [
						149.199577806672,
						-35.3858474130057
					],
					"name": "Jerrabomberra Public School",
					"playspace": 20.19,
					"projections": [
						850,
						925,
						1125,
						1210,
						1260,
						1290
					],
					"projections_orig": [
						"850",
						"925",
						"1125",
						"1210",
						"1260",
						"1290"
					],
					"projections_percentage": [
						-8.11,
						0,
						21.62,
						30.81,
						36.22,
						39.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4633
				}
			],
			"uid": 10115
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 79
			},
			"enrolment": 1861,
			"level": "Primary",
			"ligo": 0.56,
			"name": "Albion Park Primary",
			"playspace": 53.93,
			"projections": [
				1861,
				1790,
				1820,
				1815,
				1820
			],
			"projections_percentage": [
				0,
				-3.82,
				-2.2,
				-2.47,
				-2.2
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.11,
					"enrolment": 432,
					"ligo": 0.69,
					"location": [
						150.772447303493,
						-34.5708526280196
					],
					"name": "Albion Park Public School",
					"playspace": 37.56,
					"projections": [
						452,
						432,
						440,
						445,
						445,
						445
					],
					"projections_orig": [
						"452",
						"432",
						"440",
						"445",
						"445",
						"445"
					],
					"projections_percentage": [
						4.63,
						0,
						1.85,
						3.01,
						3.01,
						3.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1015
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.77,
					"enrolment": 352,
					"ligo": 0.7,
					"location": [
						150.799675739986,
						-34.5684805659431
					],
					"name": "Albion Park Rail Public School",
					"playspace": 104.23,
					"projections": [
						367,
						352,
						355,
						360,
						360,
						365
					],
					"projections_orig": [
						"367",
						"352",
						"355",
						"360",
						"360",
						"365"
					],
					"projections_percentage": [
						4.26,
						0,
						0.85,
						2.27,
						2.27,
						3.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4121
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 22
					},
					"classroomspace": 2.36,
					"enrolment": 762,
					"ligo": 0.7,
					"location": [
						150.778643604003,
						-34.5914812883989
					],
					"name": "Mount Terry Public School",
					"playspace": 22.16,
					"projections": [
						645,
						762,
						720,
						735,
						730,
						730
					],
					"projections_orig": [
						"645",
						"762",
						"720",
						"735",
						"730",
						"730"
					],
					"projections_percentage": [
						-15.35,
						0,
						-5.51,
						-3.54,
						-4.2,
						-4.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4610
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 12
					},
					"classroomspace": 3.26,
					"enrolment": 315,
					"ligo": 0.16,
					"location": [
						150.755727898055,
						-34.5784303353752
					],
					"name": "Tullimbar Public School",
					"playspace": 51.76,
					"projections": [
						220,
						315,
						275,
						280,
						280,
						280
					],
					"projections_orig": [
						"220",
						"315",
						"275",
						"280",
						"280",
						"280"
					],
					"projections_percentage": [
						-30.16,
						0,
						-12.7,
						-11.11,
						-11.11,
						-11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4649
				}
			],
			"uid": 10116
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 156
			},
			"enrolment": 4065,
			"level": "Primary",
			"ligo": 0.75,
			"name": "Terrigal Primary",
			"playspace": 38.91,
			"projections": [
				4065,
				4155,
				4290,
				4310,
				4370
			],
			"projections_percentage": [
				0,
				2.21,
				5.54,
				6.03,
				7.5
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 17
					},
					"classroomspace": 2.44,
					"enrolment": 518,
					"ligo": 0.85,
					"location": [
						151.431455457706,
						-33.4704514097121
					],
					"name": "Avoca Beach Public School",
					"playspace": 15.29,
					"projections": [
						498,
						518,
						540,
						555,
						560,
						565
					],
					"projections_orig": [
						"498",
						"518",
						"540",
						"555",
						"560",
						"565"
					],
					"projections_percentage": [
						-3.86,
						0,
						4.25,
						7.14,
						8.11,
						9.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1082
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 2.63,
					"enrolment": 474,
					"ligo": 0.93,
					"location": [
						151.356904986171,
						-33.4779583636789
					],
					"name": "Brisbania Public School",
					"playspace": 31.41,
					"projections": [
						409,
						474,
						450,
						465,
						465,
						475
					],
					"projections_orig": [
						"409",
						"474",
						"450",
						"465",
						"465",
						"475"
					],
					"projections_percentage": [
						-13.71,
						0,
						-5.06,
						-1.9,
						-1.9,
						0.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1498
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.55,
					"enrolment": 338,
					"ligo": 0.64,
					"location": [
						151.41311538908,
						-33.4277840015381
					],
					"name": "Erina Heights Public School",
					"playspace": 16.43,
					"projections": [
						350,
						338,
						385,
						395,
						395,
						400
					],
					"projections_orig": [
						"350",
						"338",
						"385",
						"395",
						"395",
						"400"
					],
					"projections_percentage": [
						3.55,
						0,
						13.91,
						16.86,
						16.86,
						18.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1856
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.68,
					"enrolment": 407,
					"ligo": 0.73,
					"location": [
						151.379321602519,
						-33.4400386301948
					],
					"name": "Woodport Public School",
					"playspace": 46.91,
					"projections": [
						407,
						407,
						415,
						430,
						430,
						435
					],
					"projections_orig": [
						"407",
						"407",
						"415",
						"430",
						"430",
						"435"
					],
					"projections_percentage": [
						0,
						0,
						1.97,
						5.65,
						5.65,
						6.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1857
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.81,
					"enrolment": 160,
					"ligo": 0.63,
					"location": [
						151.408419175869,
						-33.4052473500983
					],
					"name": "Holgate Public School",
					"playspace": 32.91,
					"projections": [
						168,
						160,
						175,
						185,
						185,
						185
					],
					"projections_orig": [
						"168",
						"160",
						"175",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						5,
						0,
						9.38,
						15.62,
						15.62,
						15.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2171
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.64,
					"enrolment": 432,
					"ligo": 0.74,
					"location": [
						151.393879466869,
						-33.4684866865868
					],
					"name": "Kincumber Public School",
					"playspace": 36.5,
					"projections": [
						432,
						432,
						470,
						485,
						485,
						495
					],
					"projections_orig": [
						"432",
						"432",
						"470",
						"485",
						"485",
						"495"
					],
					"projections_percentage": [
						0,
						0,
						8.8,
						12.27,
						12.27,
						14.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2304
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 26
					},
					"classroomspace": 2.81,
					"enrolment": 810,
					"ligo": 0.84,
					"location": [
						151.438496516841,
						-33.4416858905275
					],
					"name": "Terrigal Public School",
					"playspace": 23.82,
					"projections": [
						676,
						810,
						790,
						815,
						820,
						830
					],
					"projections_orig": [
						"676",
						"810",
						"790",
						"815",
						"820",
						"830"
					],
					"projections_percentage": [
						-16.54,
						0,
						-2.47,
						0.62,
						1.23,
						2.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3191
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.91,
					"enrolment": 348,
					"ligo": 0.65,
					"location": [
						151.349465934417,
						-33.4368142167503
					],
					"name": "Gosford East Public School",
					"playspace": 71.13,
					"projections": [
						280,
						348,
						360,
						370,
						375,
						380
					],
					"projections_orig": [
						"280",
						"348",
						"360",
						"370",
						"375",
						"380"
					],
					"projections_percentage": [
						-19.54,
						0,
						3.45,
						6.32,
						7.76,
						9.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4218
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 4.14,
					"enrolment": 233,
					"ligo": 0.65,
					"location": [
						151.368892370086,
						-33.4293219968658
					],
					"name": "Chertsey Primary School",
					"playspace": 80.78,
					"projections": [
						225,
						233,
						240,
						250,
						250,
						255
					],
					"projections_orig": [
						"225",
						"233",
						"240",
						"250",
						"250",
						"255"
					],
					"projections_percentage": [
						-3.43,
						0,
						3,
						7.3,
						7.3,
						9.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4398
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.59,
					"enrolment": 345,
					"ligo": 0.82,
					"location": [
						151.436497996256,
						-33.4845389589281
					],
					"name": "Copacabana Public School",
					"playspace": 33.91,
					"projections": [
						280,
						345,
						330,
						340,
						345,
						350
					],
					"projections_orig": [
						"280",
						"345",
						"330",
						"340",
						"345",
						"350"
					],
					"projections_percentage": [
						-18.84,
						0,
						-4.35,
						-1.45,
						0,
						1.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4548
				}
			],
			"uid": 10117
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 37
			},
			"enrolment": 806,
			"level": "Primary",
			"ligo": 0.8,
			"name": "Kariong Mountains Primary",
			"playspace": 191.36,
			"projections": [
				806,
				911,
				936,
				951,
				961
			],
			"projections_percentage": [
				0,
				13.03,
				16.13,
				17.99,
				19.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 4.57,
					"enrolment": 68,
					"ligo": 0.77,
					"location": [
						151.21689936659,
						-33.2319671176974
					],
					"name": "Kulnura Public School",
					"playspace": 131.94,
					"projections": [
						91,
						68,
						70,
						70,
						75,
						75
					],
					"projections_orig": [
						"91",
						"68",
						"70",
						"70",
						"75",
						"75"
					],
					"projections_percentage": [
						33.82,
						0,
						2.94,
						2.94,
						10.29,
						10.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2334
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.89,
					"enrolment": 41,
					"ligo": 0.67,
					"location": [
						151.231508038572,
						-33.3263010416839
					],
					"name": "Peats Ridge Public School",
					"playspace": 128.78,
					"projections": [
						56,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"56",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						36.59,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2852
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 4.3,
					"enrolment": 63,
					"ligo": 0.68,
					"location": [
						151.290409221464,
						-33.3586097137886
					],
					"name": "Somersby Public School",
					"playspace": 165.57,
					"projections": [
						80,
						63,
						80,
						80,
						85,
						85
					],
					"projections_orig": [
						"80",
						"63",
						"80",
						"80",
						"85",
						"85"
					],
					"projections_percentage": [
						26.98,
						0,
						26.98,
						26.98,
						34.92,
						34.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3078
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.28,
					"enrolment": 72,
					"ligo": 0.96,
					"location": [
						151.243757362269,
						-33.2973423780099
					],
					"name": "Central Mangrove Public School",
					"playspace": 491.54,
					"projections": [
						79,
						72,
						70,
						75,
						75,
						75
					],
					"projections_orig": [
						"79",
						"72",
						"70",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						9.72,
						0,
						-2.78,
						4.17,
						4.17,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4110
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.51,
					"enrolment": 562,
					"ligo": 0.91,
					"location": [
						151.288691008836,
						-33.4411365588904
					],
					"name": "Kariong Public School",
					"playspace": 38.98,
					"projections": [
						643,
						562,
						650,
						670,
						675,
						685
					],
					"projections_orig": [
						"643",
						"562",
						"650",
						"670",
						"675",
						"685"
					],
					"projections_percentage": [
						14.41,
						0,
						15.66,
						19.22,
						20.11,
						21.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4580
				}
			],
			"uid": 10118
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 146
			},
			"enrolment": 3434,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Gosford Primary",
			"playspace": 35.46,
			"projections": [
				3434,
				3655,
				3765,
				3790,
				3850
			],
			"projections_percentage": [
				0,
				6.44,
				9.64,
				10.37,
				12.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.43,
					"enrolment": 538,
					"ligo": 0.56,
					"location": [
						151.333406570147,
						-33.4215559594425
					],
					"name": "Gosford Public School",
					"playspace": 19.49,
					"projections": [
						536,
						538,
						565,
						580,
						585,
						595
					],
					"projections_orig": [
						"536",
						"538",
						"565",
						"580",
						"585",
						"595"
					],
					"projections_percentage": [
						-0.37,
						0,
						5.02,
						7.81,
						8.74,
						10.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2049
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.38,
					"enrolment": 286,
					"ligo": 0.64,
					"location": [
						151.376230627238,
						-33.3816212929332
					],
					"name": "Lisarow Public School",
					"playspace": 43.72,
					"projections": [
						332,
						286,
						330,
						340,
						340,
						345
					],
					"projections_orig": [
						"332",
						"286",
						"330",
						"340",
						"340",
						"345"
					],
					"projections_percentage": [
						16.08,
						0,
						15.38,
						18.88,
						18.88,
						20.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2407
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.48,
					"enrolment": 386,
					"ligo": 0.74,
					"location": [
						151.363323858194,
						-33.3874807523214
					],
					"name": "Narara Public School",
					"playspace": 39.68,
					"projections": [
						336,
						386,
						385,
						395,
						395,
						405
					],
					"projections_orig": [
						"336",
						"386",
						"385",
						"395",
						"395",
						"405"
					],
					"projections_percentage": [
						-12.95,
						0,
						-0.26,
						2.33,
						2.33,
						4.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2703
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.51,
					"enrolment": 447,
					"ligo": 0.77,
					"location": [
						151.36938760508,
						-33.3550134075948
					],
					"name": "Ourimbah Public School",
					"playspace": 33.97,
					"projections": [
						380,
						447,
						460,
						475,
						480,
						490
					],
					"projections_orig": [
						"380",
						"447",
						"460",
						"475",
						"480",
						"490"
					],
					"projections_percentage": [
						-14.99,
						0,
						2.91,
						6.26,
						7.38,
						9.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2820
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.56,
					"enrolment": 525,
					"ligo": 0.93,
					"location": [
						151.328156446609,
						-33.4439164061601
					],
					"name": "Point Clare Public School",
					"playspace": 11.12,
					"projections": [
						492,
						525,
						570,
						585,
						590,
						600
					],
					"projections_orig": [
						"492",
						"525",
						"570",
						"585",
						"590",
						"600"
					],
					"projections_percentage": [
						-6.29,
						0,
						8.57,
						11.43,
						12.38,
						14.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4050
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.36,
					"enrolment": 353,
					"ligo": 0.72,
					"location": [
						151.356115561299,
						-33.409589437578
					],
					"name": "Wyoming Public School",
					"playspace": 46.75,
					"projections": [
						259,
						353,
						335,
						345,
						345,
						350
					],
					"projections_orig": [
						"259",
						"353",
						"335",
						"345",
						"345",
						"350"
					],
					"projections_percentage": [
						-26.63,
						0,
						-5.1,
						-2.27,
						-2.27,
						-0.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4397
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 21
					},
					"classroomspace": 2.55,
					"enrolment": 542,
					"ligo": 0.75,
					"location": [
						151.350402032169,
						-33.3833292079495
					],
					"name": "Niagara Park Public School",
					"playspace": 50.17,
					"projections": [
						493,
						542,
						550,
						570,
						575,
						580
					],
					"projections_orig": [
						"493",
						"542",
						"550",
						"570",
						"575",
						"580"
					],
					"projections_percentage": [
						-9.04,
						0,
						1.48,
						5.17,
						6.09,
						7.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4427
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.56,
					"enrolment": 357,
					"ligo": 0.64,
					"location": [
						151.361662779178,
						-33.3990996799917
					],
					"name": "Valley View Public School",
					"playspace": 38.76,
					"projections": [
						529,
						357,
						460,
						475,
						480,
						485
					],
					"projections_orig": [
						"529",
						"357",
						"460",
						"475",
						"480",
						"485"
					],
					"projections_percentage": [
						48.18,
						0,
						28.85,
						33.05,
						34.45,
						35.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4508
				}
			],
			"uid": 10119
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 129
			},
			"enrolment": 2926,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Woy Woy Primary",
			"playspace": 31.31,
			"projections": [
				2926,
				3070,
				3160,
				3185,
				3230
			],
			"projections_percentage": [
				0,
				4.92,
				8,
				8.85,
				10.39
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.3,
					"enrolment": 458,
					"ligo": 0.82,
					"location": [
						151.36340908129,
						-33.504168789793
					],
					"name": "Empire Bay Public School",
					"playspace": 26.65,
					"projections": [
						459,
						458,
						470,
						485,
						490,
						495
					],
					"projections_orig": [
						"459",
						"458",
						"470",
						"485",
						"490",
						"495"
					],
					"projections_percentage": [
						0.22,
						0,
						2.62,
						5.9,
						6.99,
						8.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1839
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 2.97,
					"enrolment": 557,
					"ligo": 0.6,
					"location": [
						151.332399362368,
						-33.5130897599395
					],
					"name": "Ettalong Public School",
					"playspace": 23.31,
					"projections": [
						547,
						557,
						605,
						620,
						625,
						635
					],
					"projections_orig": [
						"547",
						"557",
						"605",
						"620",
						"625",
						"635"
					],
					"projections_percentage": [
						-1.8,
						0,
						8.62,
						11.31,
						12.21,
						14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1864
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 2.43,
					"enrolment": 177,
					"ligo": 0.76,
					"location": [
						151.350593619541,
						-33.5260357400838
					],
					"name": "Pretty Beach Public School",
					"playspace": 25.36,
					"projections": [
						134,
						177,
						155,
						160,
						160,
						165
					],
					"projections_orig": [
						"134",
						"177",
						"155",
						"160",
						"160",
						"165"
					],
					"projections_percentage": [
						-24.29,
						0,
						-12.43,
						-9.6,
						-9.6,
						-6.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2902
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 30
					},
					"classroomspace": 2.28,
					"enrolment": 801,
					"ligo": 0.73,
					"location": [
						151.314575277563,
						-33.5256956382054
					],
					"name": "Umina Beach Public School",
					"playspace": 17.7,
					"projections": [
						758,
						801,
						845,
						870,
						875,
						890
					],
					"projections_orig": [
						"758",
						"801",
						"845",
						"870",
						"875",
						"890"
					],
					"projections_percentage": [
						-5.37,
						0,
						5.49,
						8.61,
						9.24,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3995
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 3.52,
					"enrolment": 494,
					"ligo": 0.69,
					"location": [
						151.321318470475,
						-33.5043918211174
					],
					"name": "Woy Woy South Public School",
					"playspace": 57.2,
					"projections": [
						538,
						494,
						530,
						545,
						550,
						555
					],
					"projections_orig": [
						"538",
						"494",
						"530",
						"545",
						"550",
						"555"
					],
					"projections_percentage": [
						8.91,
						0,
						7.29,
						10.32,
						11.34,
						12.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4329
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 19
					},
					"classroomspace": 3.02,
					"enrolment": 439,
					"ligo": 0.63,
					"location": [
						151.328303485527,
						-33.4911446078927
					],
					"name": "Woy Woy Public School",
					"playspace": 37.66,
					"projections": [
						478,
						439,
						465,
						480,
						485,
						490
					],
					"projections_orig": [
						"478",
						"439",
						"465",
						"480",
						"485",
						"490"
					],
					"projections_percentage": [
						8.88,
						0,
						5.92,
						9.34,
						10.48,
						11.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7445
				}
			],
			"uid": 10120
		},
		{
			"classrooms": {
				"demountable": 42,
				"permanent": 293
			},
			"enrolment": 7274,
			"level": "Primary",
			"ligo": 0.72,
			"name": "Wyong Primary",
			"playspace": 63.89,
			"projections": [
				7274,
				8035,
				8460,
				8855,
				9460
			],
			"projections_percentage": [
				0,
				10.46,
				16.3,
				21.73,
				30.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.1,
					"enrolment": 71,
					"ligo": 0.82,
					"location": [
						151.380346399258,
						-33.2397606498797
					],
					"name": "Jilliby Public School",
					"playspace": 154.17,
					"projections": [
						107,
						71,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"107",
						"71",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						50.7,
						0,
						12.68,
						19.72,
						19.72,
						19.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2236
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 26
					},
					"classroomspace": 2.58,
					"enrolment": 672,
					"ligo": 0.65,
					"location": [
						151.484360025993,
						-33.2628960010368
					],
					"name": "Kanwal Public School",
					"playspace": 31.33,
					"projections": [
						735,
						672,
						775,
						825,
						855,
						905
					],
					"projections_orig": [
						"735",
						"672",
						"775",
						"825",
						"855",
						"905"
					],
					"projections_percentage": [
						9.38,
						0,
						15.33,
						22.77,
						27.23,
						34.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2259
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.94,
					"enrolment": 203,
					"ligo": 0.38,
					"location": [
						151.458792216914,
						-33.2837188760993
					],
					"name": "Tacoma Public School",
					"playspace": 80.68,
					"projections": [
						134,
						203,
						200,
						210,
						215,
						230
					],
					"projections_orig": [
						"134",
						"203",
						"200",
						"210",
						"215",
						"230"
					],
					"projections_percentage": [
						-33.99,
						0,
						-1.48,
						3.45,
						5.91,
						13.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3147
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 3.09,
					"enrolment": 523,
					"ligo": 0.75,
					"location": [
						151.549401498965,
						-33.2681454422499
					],
					"name": "Toukley Public School",
					"playspace": 42.13,
					"projections": [
						546,
						523,
						570,
						600,
						620,
						655
					],
					"projections_orig": [
						"546",
						"523",
						"570",
						"600",
						"620",
						"655"
					],
					"projections_percentage": [
						4.4,
						0,
						8.99,
						14.72,
						18.55,
						25.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3250
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 16
					},
					"classroomspace": 2.59,
					"enrolment": 512,
					"ligo": 0.7,
					"location": [
						151.414212387231,
						-33.313497400282
					],
					"name": "Tuggerah Public School",
					"playspace": 14.74,
					"projections": [
						478,
						512,
						540,
						565,
						595,
						605
					],
					"projections_orig": [
						"478",
						"512",
						"540",
						"565",
						"595",
						"605"
					],
					"projections_percentage": [
						-6.64,
						0,
						5.47,
						10.35,
						16.21,
						18.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3269
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.86,
					"enrolment": 447,
					"ligo": 0.72,
					"location": [
						151.425274516536,
						-33.2720882973558
					],
					"name": "Wyong Public School",
					"playspace": 46.51,
					"projections": [
						395,
						447,
						515,
						545,
						565,
						595
					],
					"projections_orig": [
						"395",
						"447",
						"515",
						"545",
						"565",
						"595"
					],
					"projections_percentage": [
						-11.63,
						0,
						15.21,
						21.92,
						26.4,
						33.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3527
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 2.87,
					"enrolment": 71,
					"ligo": 0.64,
					"location": [
						151.34803170743,
						-33.2675793353214
					],
					"name": "Wyong Creek Public School",
					"playspace": 219.28,
					"projections": [
						61,
						71,
						60,
						60,
						65,
						65
					],
					"projections_orig": [
						"61",
						"71",
						"60",
						"60",
						"65",
						"65"
					],
					"projections_percentage": [
						-14.08,
						0,
						-15.49,
						-15.49,
						-8.45,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3528
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.55,
					"enrolment": 245,
					"ligo": 0.57,
					"location": [
						151.48550171265,
						-33.2791463549766
					],
					"name": "Tuggerawong Public School",
					"playspace": 49.2,
					"projections": [
						214,
						245,
						260,
						270,
						280,
						300
					],
					"projections_orig": [
						"214",
						"245",
						"260",
						"270",
						"280",
						"300"
					],
					"projections_percentage": [
						-12.65,
						0,
						6.12,
						10.2,
						14.29,
						22.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4097
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.54,
					"enrolment": 501,
					"ligo": 0.83,
					"location": [
						151.467380392675,
						-33.2505739829886
					],
					"name": "Warnervale Public School",
					"playspace": 41.99,
					"projections": [
						433,
						501,
						550,
						580,
						615,
						675
					],
					"projections_orig": [
						"433",
						"501",
						"550",
						"580",
						"615",
						"675"
					],
					"projections_percentage": [
						-13.57,
						0,
						9.78,
						15.77,
						22.75,
						34.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4117
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 2.54,
					"enrolment": 559,
					"ligo": 0.78,
					"location": [
						151.511108622369,
						-33.2529760456841
					],
					"name": "Gorokan Public School",
					"playspace": 35.1,
					"projections": [
						490,
						559,
						590,
						620,
						645,
						680
					],
					"projections_orig": [
						"490",
						"559",
						"590",
						"620",
						"645",
						"680"
					],
					"projections_percentage": [
						-12.34,
						0,
						5.55,
						10.91,
						15.38,
						21.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4517
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.56,
					"enrolment": 500,
					"ligo": 0.84,
					"location": [
						151.48394325543,
						-33.2420050641771
					],
					"name": "Woongarrah Public School",
					"playspace": 52.4,
					"projections": [
						551,
						500,
						585,
						630,
						655,
						715
					],
					"projections_orig": [
						"551",
						"500",
						"585",
						"630",
						"655",
						"715"
					],
					"projections_percentage": [
						10.2,
						0,
						17,
						26,
						31,
						43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4637
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 66
					},
					"classroomspace": 3.06,
					"enrolment": 1485,
					"ligo": 0.84,
					"location": [
						151.4654019058,
						-33.2648480111764
					],
					"name": "Wadalba Community School",
					"playspace": 31.55,
					"projections": [
						1296,
						1296,
						1485,
						1485,
						1655,
						1655,
						1735,
						1735,
						1830,
						1830,
						1975,
						1975
					],
					"projections_orig": [
						"1296",
						"1296",
						"1485",
						"1485",
						"1655",
						"1655",
						"1735",
						"1735",
						"1830",
						"1830",
						"1975",
						"1975"
					],
					"projections_percentage": [
						0,
						0,
						14.58,
						14.58,
						27.7,
						27.7,
						33.87,
						33.87,
						41.2,
						41.2,
						52.39,
						52.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8278
				}
			],
			"uid": 10121
		},
		{
			"classrooms": {
				"demountable": 42,
				"permanent": 293
			},
			"enrolment": 7274,
			"level": "Secondary",
			"ligo": 0.72,
			"name": "Wyong Primary",
			"playspace": 63.89,
			"projections": [
				7274,
				8035,
				8460,
				8855,
				9460
			],
			"projections_percentage": [
				0,
				10.46,
				16.3,
				21.73,
				30.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.1,
					"enrolment": 71,
					"ligo": 0.82,
					"location": [
						151.380346399258,
						-33.2397606498797
					],
					"name": "Jilliby Public School",
					"playspace": 154.17,
					"projections": [
						107,
						71,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"107",
						"71",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						50.7,
						0,
						12.68,
						19.72,
						19.72,
						19.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2236
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 26
					},
					"classroomspace": 2.58,
					"enrolment": 672,
					"ligo": 0.65,
					"location": [
						151.484360025993,
						-33.2628960010368
					],
					"name": "Kanwal Public School",
					"playspace": 31.33,
					"projections": [
						735,
						672,
						775,
						825,
						855,
						905
					],
					"projections_orig": [
						"735",
						"672",
						"775",
						"825",
						"855",
						"905"
					],
					"projections_percentage": [
						9.38,
						0,
						15.33,
						22.77,
						27.23,
						34.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2259
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.94,
					"enrolment": 203,
					"ligo": 0.38,
					"location": [
						151.458792216914,
						-33.2837188760993
					],
					"name": "Tacoma Public School",
					"playspace": 80.68,
					"projections": [
						134,
						203,
						200,
						210,
						215,
						230
					],
					"projections_orig": [
						"134",
						"203",
						"200",
						"210",
						"215",
						"230"
					],
					"projections_percentage": [
						-33.99,
						0,
						-1.48,
						3.45,
						5.91,
						13.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3147
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 3.09,
					"enrolment": 523,
					"ligo": 0.75,
					"location": [
						151.549401498965,
						-33.2681454422499
					],
					"name": "Toukley Public School",
					"playspace": 42.13,
					"projections": [
						546,
						523,
						570,
						600,
						620,
						655
					],
					"projections_orig": [
						"546",
						"523",
						"570",
						"600",
						"620",
						"655"
					],
					"projections_percentage": [
						4.4,
						0,
						8.99,
						14.72,
						18.55,
						25.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3250
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 16
					},
					"classroomspace": 2.59,
					"enrolment": 512,
					"ligo": 0.7,
					"location": [
						151.414212387231,
						-33.313497400282
					],
					"name": "Tuggerah Public School",
					"playspace": 14.74,
					"projections": [
						478,
						512,
						540,
						565,
						595,
						605
					],
					"projections_orig": [
						"478",
						"512",
						"540",
						"565",
						"595",
						"605"
					],
					"projections_percentage": [
						-6.64,
						0,
						5.47,
						10.35,
						16.21,
						18.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3269
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.86,
					"enrolment": 447,
					"ligo": 0.72,
					"location": [
						151.425274516536,
						-33.2720882973558
					],
					"name": "Wyong Public School",
					"playspace": 46.51,
					"projections": [
						395,
						447,
						515,
						545,
						565,
						595
					],
					"projections_orig": [
						"395",
						"447",
						"515",
						"545",
						"565",
						"595"
					],
					"projections_percentage": [
						-11.63,
						0,
						15.21,
						21.92,
						26.4,
						33.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3527
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 2.87,
					"enrolment": 71,
					"ligo": 0.64,
					"location": [
						151.34803170743,
						-33.2675793353214
					],
					"name": "Wyong Creek Public School",
					"playspace": 219.28,
					"projections": [
						61,
						71,
						60,
						60,
						65,
						65
					],
					"projections_orig": [
						"61",
						"71",
						"60",
						"60",
						"65",
						"65"
					],
					"projections_percentage": [
						-14.08,
						0,
						-15.49,
						-15.49,
						-8.45,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3528
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.55,
					"enrolment": 245,
					"ligo": 0.57,
					"location": [
						151.48550171265,
						-33.2791463549766
					],
					"name": "Tuggerawong Public School",
					"playspace": 49.2,
					"projections": [
						214,
						245,
						260,
						270,
						280,
						300
					],
					"projections_orig": [
						"214",
						"245",
						"260",
						"270",
						"280",
						"300"
					],
					"projections_percentage": [
						-12.65,
						0,
						6.12,
						10.2,
						14.29,
						22.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4097
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.54,
					"enrolment": 501,
					"ligo": 0.83,
					"location": [
						151.467380392675,
						-33.2505739829886
					],
					"name": "Warnervale Public School",
					"playspace": 41.99,
					"projections": [
						433,
						501,
						550,
						580,
						615,
						675
					],
					"projections_orig": [
						"433",
						"501",
						"550",
						"580",
						"615",
						"675"
					],
					"projections_percentage": [
						-13.57,
						0,
						9.78,
						15.77,
						22.75,
						34.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4117
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 2.54,
					"enrolment": 559,
					"ligo": 0.78,
					"location": [
						151.511108622369,
						-33.2529760456841
					],
					"name": "Gorokan Public School",
					"playspace": 35.1,
					"projections": [
						490,
						559,
						590,
						620,
						645,
						680
					],
					"projections_orig": [
						"490",
						"559",
						"590",
						"620",
						"645",
						"680"
					],
					"projections_percentage": [
						-12.34,
						0,
						5.55,
						10.91,
						15.38,
						21.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4517
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 16
					},
					"classroomspace": 2.56,
					"enrolment": 500,
					"ligo": 0.84,
					"location": [
						151.48394325543,
						-33.2420050641771
					],
					"name": "Woongarrah Public School",
					"playspace": 52.4,
					"projections": [
						551,
						500,
						585,
						630,
						655,
						715
					],
					"projections_orig": [
						"551",
						"500",
						"585",
						"630",
						"655",
						"715"
					],
					"projections_percentage": [
						10.2,
						0,
						17,
						26,
						31,
						43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4637
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 66
					},
					"classroomspace": 3.06,
					"enrolment": 1485,
					"ligo": 0.84,
					"location": [
						151.4654019058,
						-33.2648480111764
					],
					"name": "Wadalba Community School",
					"playspace": 31.55,
					"projections": [
						1296,
						1296,
						1485,
						1485,
						1655,
						1655,
						1735,
						1735,
						1830,
						1830,
						1975,
						1975
					],
					"projections_orig": [
						"1296",
						"1296",
						"1485",
						"1485",
						"1655",
						"1655",
						"1735",
						"1735",
						"1830",
						"1830",
						"1975",
						"1975"
					],
					"projections_percentage": [
						0,
						0,
						14.58,
						14.58,
						27.7,
						27.7,
						33.87,
						33.87,
						41.2,
						41.2,
						52.39,
						52.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8278
				}
			],
			"uid": 10121
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 119
			},
			"enrolment": 2579,
			"level": "Primary",
			"ligo": 0.86,
			"name": "Lake Munmorah Primary",
			"playspace": 44.82,
			"projections": [
				2579,
				2690,
				2745,
				2800,
				2895
			],
			"projections_percentage": [
				0,
				4.3,
				6.44,
				8.57,
				12.25
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.52,
					"enrolment": 478,
					"ligo": 0.77,
					"location": [
						151.576064402591,
						-33.1885814562644
					],
					"name": "Lake Munmorah Public School",
					"playspace": 36.17,
					"projections": [
						460,
						478,
						470,
						470,
						475,
						485
					],
					"projections_orig": [
						"460",
						"478",
						"470",
						"470",
						"475",
						"485"
					],
					"projections_percentage": [
						-3.77,
						0,
						-1.67,
						-1.67,
						-0.63,
						1.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2362
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 23
					},
					"classroomspace": 2.87,
					"enrolment": 564,
					"ligo": 0.85,
					"location": [
						151.548708057253,
						-33.2263751054165
					],
					"name": "Budgewoi Public School",
					"playspace": 28.42,
					"projections": [
						541,
						564,
						615,
						640,
						665,
						700
					],
					"projections_orig": [
						"541",
						"564",
						"615",
						"640",
						"665",
						"700"
					],
					"projections_percentage": [
						-4.08,
						0,
						9.04,
						13.48,
						17.91,
						24.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4183
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.32,
					"enrolment": 234,
					"ligo": 0.91,
					"location": [
						151.537569568272,
						-33.1504058354827
					],
					"name": "Mannering Park Public School",
					"playspace": 79.89,
					"projections": [
						278,
						234,
						240,
						240,
						240,
						245
					],
					"projections_orig": [
						"278",
						"234",
						"240",
						"240",
						"240",
						"245"
					],
					"projections_percentage": [
						18.8,
						0,
						2.56,
						2.56,
						2.56,
						4.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4316
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.35,
					"enrolment": 357,
					"ligo": 0.92,
					"location": [
						151.581137059917,
						-33.135469124043
					],
					"name": "Gwandalan Public School",
					"playspace": 44.69,
					"projections": [
						331,
						357,
						365,
						385,
						400,
						420
					],
					"projections_orig": [
						"331",
						"357",
						"365",
						"385",
						"400",
						"420"
					],
					"projections_percentage": [
						-7.28,
						0,
						2.24,
						7.84,
						12.04,
						17.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4320
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.34,
					"enrolment": 394,
					"ligo": 0.82,
					"location": [
						151.515310327972,
						-33.2153754174477
					],
					"name": "Northlakes Public School",
					"playspace": 51.11,
					"projections": [
						467,
						394,
						405,
						410,
						415,
						425
					],
					"projections_orig": [
						"467",
						"394",
						"405",
						"410",
						"415",
						"425"
					],
					"projections_percentage": [
						18.53,
						0,
						2.79,
						4.06,
						5.33,
						7.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4588
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.63,
					"enrolment": 552,
					"ligo": 0.86,
					"location": [
						151.502843750283,
						-33.2116753300321
					],
					"name": "Blue Haven Public School",
					"playspace": 28.65,
					"projections": [
						604,
						552,
						595,
						600,
						605,
						620
					],
					"projections_orig": [
						"604",
						"552",
						"595",
						"600",
						"605",
						"620"
					],
					"projections_percentage": [
						9.42,
						0,
						7.79,
						8.7,
						9.6,
						12.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4623
				}
			],
			"uid": 10122
		},
		{
			"classrooms": {
				"demountable": 29,
				"permanent": 146
			},
			"enrolment": 4059,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Tuggerah Lakes Primary",
			"playspace": 36.18,
			"projections": [
				4059,
				4265,
				4410,
				4475,
				4580
			],
			"projections_percentage": [
				0,
				5.08,
				8.65,
				10.25,
				12.84
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 24
					},
					"classroomspace": 2.71,
					"enrolment": 758,
					"ligo": 0.63,
					"location": [
						151.435030971843,
						-33.3508411424812
					],
					"name": "Berkeley Vale Public School",
					"playspace": 23.67,
					"projections": [
						760,
						758,
						840,
						865,
						875,
						885
					],
					"projections_orig": [
						"760",
						"758",
						"840",
						"865",
						"875",
						"885"
					],
					"projections_percentage": [
						0.26,
						0,
						10.82,
						14.12,
						15.44,
						16.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1203
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 24
					},
					"classroomspace": 2.8,
					"enrolment": 517,
					"ligo": 0.89,
					"location": [
						151.492308110878,
						-33.3468383333411
					],
					"name": "The Entrance Public School",
					"playspace": 18.95,
					"projections": [
						620,
						517,
						590,
						620,
						645,
						680
					],
					"projections_orig": [
						"620",
						"517",
						"590",
						"620",
						"645",
						"680"
					],
					"projections_percentage": [
						19.92,
						0,
						14.12,
						19.92,
						24.76,
						31.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1849
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 20
					},
					"classroomspace": 2.75,
					"enrolment": 452,
					"ligo": 0.76,
					"location": [
						151.456971960435,
						-33.3657059818545
					],
					"name": "Killarney Vale Public School",
					"playspace": 47.48,
					"projections": [
						331,
						452,
						425,
						435,
						440,
						450
					],
					"projections_orig": [
						"331",
						"452",
						"425",
						"435",
						"440",
						"450"
					],
					"projections_percentage": [
						-26.77,
						0,
						-5.97,
						-3.76,
						-2.65,
						-0.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4426
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 24
					},
					"classroomspace": 2.44,
					"enrolment": 739,
					"ligo": 0.51,
					"location": [
						151.475410550582,
						-33.3909569382872
					],
					"name": "Bateau Bay Public School",
					"playspace": 28.58,
					"projections": [
						675,
						739,
						760,
						785,
						800,
						815
					],
					"projections_orig": [
						"675",
						"739",
						"760",
						"785",
						"800",
						"815"
					],
					"projections_percentage": [
						-8.66,
						0,
						2.84,
						6.22,
						8.25,
						10.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4520
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 20
					},
					"classroomspace": 2.76,
					"enrolment": 743,
					"ligo": 0.82,
					"location": [
						151.448920452804,
						-33.4117267412739
					],
					"name": "Wamberal Public School",
					"playspace": 12.34,
					"projections": [
						531,
						743,
						715,
						740,
						745,
						755
					],
					"projections_orig": [
						"531",
						"743",
						"715",
						"740",
						"745",
						"755"
					],
					"projections_percentage": [
						-28.53,
						0,
						-3.77,
						-0.4,
						0.27,
						1.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4522
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.06,
					"enrolment": 374,
					"ligo": 0.76,
					"location": [
						151.431553289829,
						-33.3256156186319
					],
					"name": "Chittaway Bay Public School",
					"playspace": 80.24,
					"projections": [
						350,
						374,
						395,
						410,
						410,
						420
					],
					"projections_orig": [
						"350",
						"374",
						"395",
						"410",
						"410",
						"420"
					],
					"projections_percentage": [
						-6.42,
						0,
						5.61,
						9.63,
						9.63,
						12.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4542
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 15
					},
					"classroomspace": 2.5,
					"enrolment": 476,
					"ligo": 0.55,
					"location": [
						151.464985455847,
						-33.3754882513307
					],
					"name": "Brooke Avenue Public School",
					"playspace": 42.02,
					"projections": [
						447,
						476,
						540,
						555,
						560,
						575
					],
					"projections_orig": [
						"447",
						"476",
						"540",
						"555",
						"560",
						"575"
					],
					"projections_percentage": [
						-6.09,
						0,
						13.45,
						16.6,
						17.65,
						20.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4566
				}
			],
			"uid": 10123
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 191
			},
			"enrolment": 4387,
			"level": "Primary",
			"ligo": 0.61,
			"name": "Callaghan Primary",
			"playspace": 80.6,
			"projections": [
				4387,
				4530,
				4730,
				4825,
				4870
			],
			"projections_percentage": [
				0,
				3.26,
				7.82,
				9.98,
				11.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.62,
					"enrolment": 107,
					"ligo": 0.42,
					"location": [
						151.617237027743,
						-32.8378216129621
					],
					"name": "Black Hill Public School",
					"playspace": 62.5,
					"projections": [
						78,
						107,
						110,
						115,
						115,
						115
					],
					"projections_orig": [
						"78",
						"107",
						"110",
						"115",
						"115",
						"115"
					],
					"projections_percentage": [
						-27.1,
						0,
						2.8,
						7.48,
						7.48,
						7.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1247
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 7
					},
					"classroomspace": 2.73,
					"enrolment": 200,
					"ligo": 0.74,
					"location": [
						151.695253050888,
						-32.9042784050566
					],
					"name": "Jesmond Public School",
					"playspace": 20.64,
					"projections": [
						161,
						200,
						185,
						195,
						200,
						200
					],
					"projections_orig": [
						"161",
						"200",
						"185",
						"195",
						"200",
						"200"
					],
					"projections_percentage": [
						-19.5,
						0,
						-7.5,
						-2.5,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2234
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 2.2,
					"enrolment": 252,
					"ligo": 0.63,
					"location": [
						151.748597934052,
						-32.89603009908
					],
					"name": "Mayfield East Public School",
					"playspace": 40.76,
					"projections": [
						247,
						252,
						295,
						315,
						325,
						325
					],
					"projections_orig": [
						"247",
						"252",
						"295",
						"315",
						"325",
						"325"
					],
					"projections_percentage": [
						-1.98,
						0,
						17.06,
						25,
						28.97,
						28.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2506
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 15
					},
					"classroomspace": 2.04,
					"enrolment": 392,
					"ligo": 0.63,
					"location": [
						151.729401103028,
						-32.8885504263621
					],
					"name": "Mayfield West Public School",
					"playspace": 26.55,
					"projections": [
						317,
						392,
						365,
						390,
						400,
						405
					],
					"projections_orig": [
						"317",
						"392",
						"365",
						"390",
						"400",
						"405"
					],
					"projections_percentage": [
						-19.13,
						0,
						-6.89,
						-0.51,
						2.04,
						3.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2507
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.58,
					"enrolment": 113,
					"ligo": 0.59,
					"location": [
						151.61798265047,
						-32.8765305862486
					],
					"name": "Minmi Public School",
					"playspace": 119.81,
					"projections": [
						116,
						113,
						110,
						115,
						120,
						120
					],
					"projections_orig": [
						"116",
						"113",
						"110",
						"115",
						"120",
						"120"
					],
					"projections_percentage": [
						2.65,
						0,
						-2.65,
						1.77,
						6.19,
						6.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2571
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.14,
					"enrolment": 255,
					"ligo": 0.74,
					"location": [
						151.695772361534,
						-32.8801833714709
					],
					"name": "Shortland Public School",
					"playspace": 91.87,
					"projections": [
						254,
						255,
						250,
						265,
						270,
						275
					],
					"projections_orig": [
						"254",
						"255",
						"250",
						"265",
						"270",
						"275"
					],
					"projections_percentage": [
						-0.39,
						0,
						-1.96,
						3.92,
						5.88,
						7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3065
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.66,
					"enrolment": 257,
					"ligo": 0.62,
					"location": [
						151.670855758361,
						-32.9084085774848
					],
					"name": "Wallsend Public School",
					"playspace": 24.36,
					"projections": [
						261,
						257,
						290,
						295,
						295,
						295
					],
					"projections_orig": [
						"261",
						"257",
						"290",
						"295",
						"295",
						"295"
					],
					"projections_percentage": [
						1.56,
						0,
						12.84,
						14.79,
						14.79,
						14.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3357
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 3.35,
					"enrolment": 347,
					"ligo": 0.64,
					"location": [
						151.722807350158,
						-32.9055650570194
					],
					"name": "Waratah Public School",
					"playspace": 54.1,
					"projections": [
						431,
						347,
						395,
						420,
						435,
						435
					],
					"projections_orig": [
						"431",
						"347",
						"395",
						"420",
						"435",
						"435"
					],
					"projections_percentage": [
						24.21,
						0,
						13.83,
						21.04,
						25.36,
						25.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3377
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 2.34,
					"enrolment": 557,
					"ligo": 0.55,
					"location": [
						151.675298292902,
						-32.9207907909992
					],
					"name": "Wallsend South Public School",
					"playspace": 38.18,
					"projections": [
						551,
						557,
						565,
						575,
						580,
						580
					],
					"projections_orig": [
						"551",
						"557",
						"565",
						"575",
						"580",
						"580"
					],
					"projections_percentage": [
						-1.08,
						0,
						1.44,
						3.23,
						4.13,
						4.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3851
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 5.66,
					"enrolment": 72,
					"ligo": 0.42,
					"location": [
						151.715289074078,
						-32.8992141207512
					],
					"name": "Waratah West Public School",
					"playspace": 371.89,
					"projections": [
						78,
						72,
						75,
						80,
						85,
						85
					],
					"projections_orig": [
						"78",
						"72",
						"75",
						"80",
						"85",
						"85"
					],
					"projections_percentage": [
						8.33,
						0,
						4.17,
						11.11,
						18.06,
						18.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3932
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.51,
					"enrolment": 223,
					"ligo": 0.45,
					"location": [
						151.694931451093,
						-32.899464547509
					],
					"name": "Heaton Public School",
					"playspace": 158.7,
					"projections": [
						193,
						223,
						205,
						215,
						220,
						220
					],
					"projections_orig": [
						"193",
						"223",
						"205",
						"215",
						"220",
						"220"
					],
					"projections_percentage": [
						-13.45,
						0,
						-8.07,
						-3.59,
						-1.35,
						-1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 2.66,
					"enrolment": 379,
					"ligo": 0.64,
					"location": [
						151.665949985017,
						-32.9150616347286
					],
					"name": "Elermore Vale Public School",
					"playspace": 71.52,
					"projections": [
						410,
						379,
						415,
						420,
						420,
						420
					],
					"projections_orig": [
						"410",
						"379",
						"415",
						"420",
						"420",
						"420"
					],
					"projections_percentage": [
						8.18,
						0,
						9.5,
						10.82,
						10.82,
						10.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4163
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 2.56,
					"enrolment": 461,
					"ligo": 0.54,
					"location": [
						151.65891618405,
						-32.8822705353513
					],
					"name": "Maryland Public School",
					"playspace": 33.6,
					"projections": [
						493,
						461,
						515,
						540,
						555,
						575
					],
					"projections_orig": [
						"493",
						"461",
						"515",
						"540",
						"555",
						"575"
					],
					"projections_percentage": [
						6.94,
						0,
						11.71,
						17.14,
						20.39,
						24.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4600
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 18
					},
					"classroomspace": 2.29,
					"enrolment": 522,
					"ligo": 0.88,
					"location": [
						151.650609006063,
						-32.8732477927201
					],
					"name": "Glendore Public School",
					"playspace": 41.39,
					"projections": [
						443,
						522,
						510,
						540,
						555,
						570
					],
					"projections_orig": [
						"443",
						"522",
						"510",
						"540",
						"555",
						"570"
					],
					"projections_percentage": [
						-15.13,
						0,
						-2.3,
						3.45,
						6.32,
						9.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4620
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.96,
					"enrolment": 250,
					"ligo": 0.66,
					"location": [
						151.669202014083,
						-32.897290577825
					],
					"name": "Plattsburg Public School",
					"playspace": 53.07,
					"projections": [
						210,
						250,
						245,
						250,
						250,
						250
					],
					"projections_orig": [
						"210",
						"250",
						"245",
						"250",
						"250",
						"250"
					],
					"projections_percentage": [
						-16,
						0,
						-2,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7308
				}
			],
			"uid": 10124
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 242
			},
			"enrolment": 4946,
			"level": "Primary",
			"ligo": 0.56,
			"name": "Newcastle Primary",
			"playspace": 34.08,
			"projections": [
				4946,
				5243,
				5533,
				5733,
				5753
			],
			"projections_percentage": [
				0,
				6,
				11.87,
				15.91,
				16.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.48,
					"enrolment": 106,
					"ligo": 0.84,
					"location": [
						151.765103795327,
						-32.9126595628632
					],
					"name": "Carrington Public School",
					"playspace": 28.52,
					"projections": [
						82,
						106,
						110,
						115,
						120,
						120
					],
					"projections_orig": [
						"82",
						"106",
						"110",
						"115",
						"120",
						"120"
					],
					"projections_percentage": [
						-22.64,
						0,
						3.77,
						8.49,
						13.21,
						13.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1518
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.24,
					"enrolment": 138,
					"ligo": 0.4,
					"location": [
						151.74372881149,
						-32.9116663472211
					],
					"name": "Islington Public School",
					"playspace": 35.98,
					"projections": [
						75,
						138,
						135,
						145,
						150,
						150
					],
					"projections_orig": [
						"75",
						"138",
						"135",
						"145",
						"150",
						"150"
					],
					"projections_percentage": [
						-45.65,
						0,
						-2.17,
						5.07,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2212
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 21
					},
					"classroomspace": 2.64,
					"enrolment": 608,
					"ligo": 0.7,
					"location": [
						151.759806264846,
						-32.9394833093239
					],
					"name": "The Junction Public School",
					"playspace": 31.09,
					"projections": [
						584,
						608,
						660,
						700,
						725,
						725
					],
					"projections_orig": [
						"584",
						"608",
						"660",
						"700",
						"725",
						"725"
					],
					"projections_percentage": [
						-3.95,
						0,
						8.55,
						15.13,
						19.24,
						19.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2246
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.77,
					"enrolment": 247,
					"ligo": 0.64,
					"location": [
						151.777321214106,
						-32.9302875761928
					],
					"name": "Newcastle East Public School",
					"playspace": 15.66,
					"projections": [
						214,
						247,
						275,
						290,
						300,
						300
					],
					"projections_orig": [
						"214",
						"247",
						"275",
						"290",
						"300",
						"300"
					],
					"projections_percentage": [
						-13.36,
						0,
						11.34,
						17.41,
						21.46,
						21.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2736
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.67,
					"enrolment": 269,
					"ligo": 0.74,
					"location": [
						151.781203243775,
						-32.911809659695
					],
					"name": "Stockton Public School",
					"playspace": 48.29,
					"projections": [
						265,
						269,
						300,
						315,
						330,
						330
					],
					"projections_orig": [
						"265",
						"269",
						"300",
						"315",
						"330",
						"330"
					],
					"projections_percentage": [
						-1.49,
						0,
						11.52,
						17.1,
						22.68,
						22.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3110
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.45,
					"enrolment": 327,
					"ligo": 0.72,
					"location": [
						151.751385844722,
						-32.9078552114312
					],
					"name": "Tighes Hill Public School",
					"playspace": 13.86,
					"projections": [
						230,
						327,
						350,
						370,
						385,
						385
					],
					"projections_orig": [
						"230",
						"327",
						"350",
						"370",
						"385",
						"385"
					],
					"projections_percentage": [
						-29.66,
						0,
						7.03,
						13.15,
						17.74,
						17.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3213
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.75,
					"enrolment": 419,
					"ligo": 0.67,
					"location": [
						151.753091440698,
						-32.9335341941561
					],
					"name": "Hamilton South Public School",
					"playspace": 25.86,
					"projections": [
						398,
						419,
						460,
						490,
						505,
						505
					],
					"projections_orig": [
						"398",
						"419",
						"460",
						"490",
						"505",
						"505"
					],
					"projections_percentage": [
						-5.01,
						0,
						9.79,
						16.95,
						20.53,
						20.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3795
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.15,
					"enrolment": 161,
					"ligo": 0.41,
					"location": [
						151.734300117445,
						-32.9176934610533
					],
					"name": "Hamilton North Public School",
					"playspace": 34.13,
					"projections": [
						163,
						161,
						185,
						195,
						205,
						205
					],
					"projections_orig": [
						"163",
						"161",
						"185",
						"195",
						"205",
						"205"
					],
					"projections_percentage": [
						1.24,
						0,
						14.91,
						21.12,
						27.33,
						27.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3897
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.26,
					"enrolment": 48,
					"ligo": 0.81,
					"location": [
						151.795262293547,
						-32.8721106939618
					],
					"name": "Fern Bay Public School",
					"playspace": 95.82,
					"projections": [
						28,
						48,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"48",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-41.67,
						0,
						-47.92,
						-47.92,
						-47.92,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3996
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.7,
					"enrolment": 287,
					"ligo": 0.62,
					"location": [
						151.74278985416,
						-32.9235803078095
					],
					"name": "Hamilton Public School",
					"playspace": 16.35,
					"projections": [
						244,
						287,
						300,
						315,
						325,
						325
					],
					"projections_orig": [
						"244",
						"287",
						"300",
						"315",
						"325",
						"325"
					],
					"projections_percentage": [
						-14.98,
						0,
						4.53,
						9.76,
						13.24,
						13.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7420
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 67
					},
					"classroomspace": 3.99,
					"enrolment": 1168,
					"ligo": 0.1,
					"location": [
						151.727505924713,
						-32.9239077617365
					],
					"name": "Hunter School of Performing Arts",
					"playspace": 31.69,
					"projections": [
						1164,
						1164,
						1168,
						1168,
						1210,
						1210,
						1275,
						1275,
						1320,
						1320,
						1330,
						1330
					],
					"projections_orig": [
						"1164",
						"1164",
						"1168",
						"1168",
						"1210",
						"1210",
						"1275",
						"1275",
						"1320",
						"1320",
						"1330",
						"1330"
					],
					"projections_percentage": [
						0,
						0,
						0.34,
						0.34,
						3.95,
						3.95,
						9.54,
						9.54,
						13.4,
						13.4,
						14.26,
						14.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8819
				}
			],
			"uid": 10125
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 242
			},
			"enrolment": 4946,
			"level": "Secondary",
			"ligo": 0.56,
			"name": "Newcastle Primary",
			"playspace": 34.08,
			"projections": [
				4946,
				5243,
				5533,
				5733,
				5753
			],
			"projections_percentage": [
				0,
				6,
				11.87,
				15.91,
				16.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.48,
					"enrolment": 106,
					"ligo": 0.84,
					"location": [
						151.765103795327,
						-32.9126595628632
					],
					"name": "Carrington Public School",
					"playspace": 28.52,
					"projections": [
						82,
						106,
						110,
						115,
						120,
						120
					],
					"projections_orig": [
						"82",
						"106",
						"110",
						"115",
						"120",
						"120"
					],
					"projections_percentage": [
						-22.64,
						0,
						3.77,
						8.49,
						13.21,
						13.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1518
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.24,
					"enrolment": 138,
					"ligo": 0.4,
					"location": [
						151.74372881149,
						-32.9116663472211
					],
					"name": "Islington Public School",
					"playspace": 35.98,
					"projections": [
						75,
						138,
						135,
						145,
						150,
						150
					],
					"projections_orig": [
						"75",
						"138",
						"135",
						"145",
						"150",
						"150"
					],
					"projections_percentage": [
						-45.65,
						0,
						-2.17,
						5.07,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2212
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 21
					},
					"classroomspace": 2.64,
					"enrolment": 608,
					"ligo": 0.7,
					"location": [
						151.759806264846,
						-32.9394833093239
					],
					"name": "The Junction Public School",
					"playspace": 31.09,
					"projections": [
						584,
						608,
						660,
						700,
						725,
						725
					],
					"projections_orig": [
						"584",
						"608",
						"660",
						"700",
						"725",
						"725"
					],
					"projections_percentage": [
						-3.95,
						0,
						8.55,
						15.13,
						19.24,
						19.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2246
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.77,
					"enrolment": 247,
					"ligo": 0.64,
					"location": [
						151.777321214106,
						-32.9302875761928
					],
					"name": "Newcastle East Public School",
					"playspace": 15.66,
					"projections": [
						214,
						247,
						275,
						290,
						300,
						300
					],
					"projections_orig": [
						"214",
						"247",
						"275",
						"290",
						"300",
						"300"
					],
					"projections_percentage": [
						-13.36,
						0,
						11.34,
						17.41,
						21.46,
						21.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2736
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.67,
					"enrolment": 269,
					"ligo": 0.74,
					"location": [
						151.781203243775,
						-32.911809659695
					],
					"name": "Stockton Public School",
					"playspace": 48.29,
					"projections": [
						265,
						269,
						300,
						315,
						330,
						330
					],
					"projections_orig": [
						"265",
						"269",
						"300",
						"315",
						"330",
						"330"
					],
					"projections_percentage": [
						-1.49,
						0,
						11.52,
						17.1,
						22.68,
						22.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3110
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.45,
					"enrolment": 327,
					"ligo": 0.72,
					"location": [
						151.751385844722,
						-32.9078552114312
					],
					"name": "Tighes Hill Public School",
					"playspace": 13.86,
					"projections": [
						230,
						327,
						350,
						370,
						385,
						385
					],
					"projections_orig": [
						"230",
						"327",
						"350",
						"370",
						"385",
						"385"
					],
					"projections_percentage": [
						-29.66,
						0,
						7.03,
						13.15,
						17.74,
						17.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3213
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 2.75,
					"enrolment": 419,
					"ligo": 0.67,
					"location": [
						151.753091440698,
						-32.9335341941561
					],
					"name": "Hamilton South Public School",
					"playspace": 25.86,
					"projections": [
						398,
						419,
						460,
						490,
						505,
						505
					],
					"projections_orig": [
						"398",
						"419",
						"460",
						"490",
						"505",
						"505"
					],
					"projections_percentage": [
						-5.01,
						0,
						9.79,
						16.95,
						20.53,
						20.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3795
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.15,
					"enrolment": 161,
					"ligo": 0.41,
					"location": [
						151.734300117445,
						-32.9176934610533
					],
					"name": "Hamilton North Public School",
					"playspace": 34.13,
					"projections": [
						163,
						161,
						185,
						195,
						205,
						205
					],
					"projections_orig": [
						"163",
						"161",
						"185",
						"195",
						"205",
						"205"
					],
					"projections_percentage": [
						1.24,
						0,
						14.91,
						21.12,
						27.33,
						27.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3897
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.26,
					"enrolment": 48,
					"ligo": 0.81,
					"location": [
						151.795262293547,
						-32.8721106939618
					],
					"name": "Fern Bay Public School",
					"playspace": 95.82,
					"projections": [
						28,
						48,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"48",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-41.67,
						0,
						-47.92,
						-47.92,
						-47.92,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3996
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.7,
					"enrolment": 287,
					"ligo": 0.62,
					"location": [
						151.74278985416,
						-32.9235803078095
					],
					"name": "Hamilton Public School",
					"playspace": 16.35,
					"projections": [
						244,
						287,
						300,
						315,
						325,
						325
					],
					"projections_orig": [
						"244",
						"287",
						"300",
						"315",
						"325",
						"325"
					],
					"projections_percentage": [
						-14.98,
						0,
						4.53,
						9.76,
						13.24,
						13.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7420
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 67
					},
					"classroomspace": 3.99,
					"enrolment": 1168,
					"ligo": 0.1,
					"location": [
						151.727505924713,
						-32.9239077617365
					],
					"name": "Hunter School of Performing Arts",
					"playspace": 31.69,
					"projections": [
						1164,
						1164,
						1168,
						1168,
						1210,
						1210,
						1275,
						1275,
						1320,
						1320,
						1330,
						1330
					],
					"projections_orig": [
						"1164",
						"1164",
						"1168",
						"1168",
						"1210",
						"1210",
						"1275",
						"1275",
						"1320",
						"1320",
						"1330",
						"1330"
					],
					"projections_percentage": [
						0,
						0,
						0.34,
						0.34,
						3.95,
						3.95,
						9.54,
						9.54,
						13.4,
						13.4,
						14.26,
						14.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8819
				}
			],
			"uid": 10125
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 91
			},
			"enrolment": 2367,
			"level": "Primary",
			"ligo": 0.66,
			"name": "Cessnock Primary",
			"playspace": 153.79,
			"projections": [
				2367,
				2583,
				2688,
				2753,
				2793
			],
			"projections_percentage": [
				0,
				9.13,
				13.56,
				16.31,
				18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.33,
					"enrolment": 264,
					"ligo": 0.7,
					"location": [
						151.42581119306,
						-32.8089526262928
					],
					"name": "Abermain Public School",
					"playspace": 44.93,
					"projections": [
						212,
						264,
						255,
						265,
						270,
						275
					],
					"projections_orig": [
						"212",
						"264",
						"255",
						"265",
						"270",
						"275"
					],
					"projections_percentage": [
						-19.7,
						0,
						-3.41,
						0.38,
						2.27,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1003
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 6
					},
					"classroomspace": 2.83,
					"enrolment": 241,
					"ligo": 0.7,
					"location": [
						151.31633633649,
						-32.8589764930096
					],
					"name": "Bellbird Public School",
					"playspace": 45.1,
					"projections": [
						245,
						241,
						280,
						290,
						300,
						300
					],
					"projections_orig": [
						"245",
						"241",
						"280",
						"290",
						"300",
						"300"
					],
					"projections_percentage": [
						1.66,
						0,
						16.18,
						20.33,
						24.48,
						24.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1177
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.93,
					"enrolment": 303,
					"ligo": 0.6,
					"location": [
						151.36377593992,
						-32.8408929807509
					],
					"name": "Cessnock Public School",
					"playspace": 45.8,
					"projections": [
						320,
						303,
						335,
						350,
						360,
						365
					],
					"projections_orig": [
						"320",
						"303",
						"335",
						"350",
						"360",
						"365"
					],
					"projections_percentage": [
						5.61,
						0,
						10.56,
						15.51,
						18.81,
						20.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1542
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.29,
					"enrolment": 213,
					"ligo": 0.79,
					"location": [
						151.369726706261,
						-32.8272783678529
					],
					"name": "Cessnock East Public School",
					"playspace": 104.25,
					"projections": [
						197,
						213,
						235,
						245,
						250,
						255
					],
					"projections_orig": [
						"197",
						"213",
						"235",
						"245",
						"250",
						"255"
					],
					"projections_percentage": [
						-7.51,
						0,
						10.33,
						15.02,
						17.37,
						19.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1543
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.36,
					"enrolment": 395,
					"ligo": 0.72,
					"location": [
						151.345079991332,
						-32.8388460848359
					],
					"name": "Cessnock West Public School",
					"playspace": 19.63,
					"projections": [
						354,
						395,
						430,
						445,
						460,
						465
					],
					"projections_orig": [
						"354",
						"395",
						"430",
						"445",
						"460",
						"465"
					],
					"projections_percentage": [
						-10.38,
						0,
						8.86,
						12.66,
						16.46,
						17.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1545
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.76,
					"enrolment": 18,
					"ligo": 0.44,
					"location": [
						151.274017984363,
						-32.9580714824043
					],
					"name": "Congewai Public School",
					"playspace": 708.68,
					"projections": [
						14,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.22,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1822
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 2.57,
					"enrolment": 125,
					"ligo": 0.6,
					"location": [
						151.312463573184,
						-32.9152857981404
					],
					"name": "Ellalong Public School",
					"playspace": 67.79,
					"projections": [
						104,
						125,
						120,
						125,
						125,
						130
					],
					"projections_orig": [
						"104",
						"125",
						"120",
						"125",
						"125",
						"130"
					],
					"projections_percentage": [
						-16.8,
						0,
						-4,
						0,
						0,
						4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1826
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 3
					},
					"classroomspace": 2.53,
					"enrolment": 153,
					"ligo": 0.61,
					"location": [
						151.395778850069,
						-32.8568275920839
					],
					"name": "Kearsley Public School",
					"playspace": 80.69,
					"projections": [
						110,
						153,
						140,
						145,
						150,
						155
					],
					"projections_orig": [
						"110",
						"153",
						"140",
						"145",
						"150",
						"155"
					],
					"projections_percentage": [
						-28.1,
						0,
						-8.5,
						-5.23,
						-1.96,
						1.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2267
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.73,
					"enrolment": 76,
					"ligo": 0.51,
					"location": [
						151.369590822878,
						-32.8786352938445
					],
					"name": "Kitchener Public School",
					"playspace": 178.91,
					"projections": [
						79,
						76,
						90,
						95,
						95,
						95
					],
					"projections_orig": [
						"79",
						"76",
						"90",
						"95",
						"95",
						"95"
					],
					"projections_percentage": [
						3.95,
						0,
						18.42,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2315
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.86,
					"enrolment": 56,
					"ligo": 0.83,
					"location": [
						151.130306009153,
						-32.9923903161255
					],
					"name": "Laguna Public School",
					"playspace": 19.85,
					"projections": [
						40,
						56,
						60,
						65,
						65,
						65
					],
					"projections_orig": [
						"40",
						"56",
						"60",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						-28.57,
						0,
						7.14,
						16.07,
						16.07,
						16.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2356
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 4.48,
					"enrolment": 57,
					"ligo": 0.83,
					"location": [
						151.250491448997,
						-32.8889788625632
					],
					"name": "Millfield Public School",
					"playspace": 409.6,
					"projections": [
						64,
						57,
						60,
						65,
						65,
						65
					],
					"projections_orig": [
						"64",
						"57",
						"60",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						12.28,
						0,
						5.26,
						14.04,
						14.04,
						14.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2555
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 9
					},
					"classroomspace": 2.73,
					"enrolment": 422,
					"ligo": 0.45,
					"location": [
						151.348398166378,
						-32.8108227967433
					],
					"name": "Nulkaba Public School",
					"playspace": 26.86,
					"projections": [
						403,
						422,
						490,
						510,
						520,
						530
					],
					"projections_orig": [
						"403",
						"422",
						"490",
						"510",
						"520",
						"530"
					],
					"projections_percentage": [
						-4.5,
						0,
						16.11,
						20.85,
						23.22,
						25.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2771
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.28,
					"enrolment": 44,
					"ligo": 0.83,
					"location": [
						151.284748949326,
						-32.9014755876027
					],
					"name": "Paxton Public School",
					"playspace": 247.2,
					"projections": [
						80,
						44,
						70,
						70,
						75,
						75
					],
					"projections_orig": [
						"80",
						"44",
						"70",
						"70",
						"75",
						"75"
					],
					"projections_percentage": [
						81.82,
						0,
						59.09,
						59.09,
						70.45,
						70.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2846
				}
			],
			"uid": 10126
		},
		{
			"classrooms": {
				"demountable": 40,
				"permanent": 150
			},
			"enrolment": 4361,
			"level": "Primary",
			"ligo": 0.71,
			"name": "Tweed Primary",
			"playspace": 84.06,
			"projections": [
				4361,
				4536,
				4655,
				4710,
				4805
			],
			"projections_percentage": [
				0,
				4.01,
				6.74,
				8,
				10.18
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 17
					},
					"classroomspace": 2.59,
					"enrolment": 637,
					"ligo": 0.53,
					"location": [
						153.544939512573,
						-28.2220253641416
					],
					"name": "Banora Point Public School",
					"playspace": 33.72,
					"projections": [
						570,
						637,
						640,
						665,
						685,
						700
					],
					"projections_orig": [
						"570",
						"637",
						"640",
						"665",
						"685",
						"700"
					],
					"projections_percentage": [
						-10.52,
						0,
						0.47,
						4.4,
						7.54,
						9.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.41,
					"enrolment": 320,
					"ligo": 0.73,
					"location": [
						153.468287894056,
						-28.2236527014165
					],
					"name": "Bilambil Public School",
					"playspace": 49.92,
					"projections": [
						271,
						320,
						360,
						350,
						360,
						365
					],
					"projections_orig": [
						"271",
						"320",
						"360",
						"350",
						"360",
						"365"
					],
					"projections_percentage": [
						-15.31,
						0,
						12.5,
						9.38,
						12.5,
						14.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1224
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.82,
					"enrolment": 73,
					"ligo": 1,
					"location": [
						153.46689904554,
						-28.4355321242089
					],
					"name": "Burringbar Public School",
					"playspace": 225.49,
					"projections": [
						81,
						73,
						65,
						70,
						70,
						75
					],
					"projections_orig": [
						"81",
						"73",
						"65",
						"70",
						"70",
						"75"
					],
					"projections_percentage": [
						10.96,
						0,
						-10.96,
						-4.11,
						-4.11,
						2.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1449
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.96,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						153.429066714839,
						-28.2301779342569
					],
					"name": "Carool Public School",
					"playspace": 189.41,
					"projections": [
						32,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						77.78,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1515
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 6
					},
					"classroomspace": 2.32,
					"enrolment": 208,
					"ligo": 0.48,
					"location": [
						153.556074716219,
						-28.2628576264135
					],
					"name": "Cudgen Public School",
					"playspace": 18.23,
					"projections": [
						170,
						208,
						195,
						205,
						210,
						215
					],
					"projections_orig": [
						"170",
						"208",
						"195",
						"205",
						"210",
						"215"
					],
					"projections_percentage": [
						-18.27,
						0,
						-6.25,
						-1.44,
						0.96,
						3.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1696
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.53,
					"enrolment": 27,
					"ligo": 0.53,
					"location": [
						153.517132628414,
						-28.2875517827521
					],
					"name": "Duranbah Public School",
					"playspace": 169.32,
					"projections": [
						32,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						18.52,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1801
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.34,
					"enrolment": 41,
					"ligo": 0.69,
					"location": [
						153.565690862153,
						-28.1970614009006
					],
					"name": "Fingal Head Public School",
					"playspace": 228.4,
					"projections": [
						52,
						41,
						25,
						50,
						50,
						50
					],
					"projections_orig": [
						"52",
						"41",
						"<50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						26.83,
						0,
						-39.02,
						21.95,
						21.95,
						21.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1915
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.37,
					"enrolment": 462,
					"ligo": 0.51,
					"location": [
						153.500214707447,
						-28.2403296233827
					],
					"name": "Terranora Public School",
					"playspace": 35.5,
					"projections": [
						461,
						462,
						465,
						485,
						500,
						510
					],
					"projections_orig": [
						"461",
						"462",
						"465",
						"485",
						"500",
						"510"
					],
					"projections_percentage": [
						-0.22,
						0,
						0.65,
						4.98,
						8.23,
						10.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3189
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.55,
					"enrolment": 285,
					"ligo": 0.79,
					"location": [
						153.54211146087,
						-28.1692736841684
					],
					"name": "Tweed Heads Public School",
					"playspace": 31.3,
					"projections": [
						223,
						285,
						260,
						270,
						280,
						285
					],
					"projections_orig": [
						"223",
						"285",
						"260",
						"270",
						"280",
						"285"
					],
					"projections_percentage": [
						-21.75,
						0,
						-8.77,
						-5.26,
						-1.75,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3290
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 17
					},
					"classroomspace": 2.79,
					"enrolment": 692,
					"ligo": 0.88,
					"location": [
						153.568369581312,
						-28.3785343143034
					],
					"name": "Pottsville Beach Public School",
					"playspace": 21.14,
					"projections": [
						658,
						692,
						800,
						810,
						790,
						810
					],
					"projections_orig": [
						"658",
						"692",
						"800",
						"810",
						"790",
						"810"
					],
					"projections_percentage": [
						-4.91,
						0,
						15.61,
						17.05,
						14.16,
						17.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3578
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 11
					},
					"classroomspace": 2.71,
					"enrolment": 623,
					"ligo": 0.77,
					"location": [
						153.5790463543,
						-28.2591063310221
					],
					"name": "Kingscliff Public School",
					"playspace": 19.22,
					"projections": [
						469,
						623,
						665,
						675,
						660,
						670
					],
					"projections_orig": [
						"469",
						"623",
						"665",
						"675",
						"660",
						"670"
					],
					"projections_percentage": [
						-24.72,
						0,
						6.74,
						8.35,
						5.94,
						7.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4054
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.67,
					"enrolment": 204,
					"ligo": 0.54,
					"location": [
						153.540016727111,
						-28.1947773226597
					],
					"name": "Tweed Heads South Public School",
					"playspace": 50.95,
					"projections": [
						235,
						204,
						220,
						230,
						235,
						240
					],
					"projections_orig": [
						"235",
						"204",
						"220",
						"230",
						"235",
						"240"
					],
					"projections_percentage": [
						15.2,
						0,
						7.84,
						12.75,
						15.2,
						17.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4111
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 2.71,
					"enrolment": 509,
					"ligo": 0.69,
					"location": [
						153.525573898261,
						-28.216242616321
					],
					"name": "Centaur Public School",
					"playspace": 38.57,
					"projections": [
						481,
						509,
						495,
						515,
						530,
						540
					],
					"projections_orig": [
						"481",
						"509",
						"495",
						"515",
						"530",
						"540"
					],
					"projections_percentage": [
						-5.5,
						0,
						-2.75,
						1.18,
						4.13,
						6.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4607
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.75,
					"enrolment": 262,
					"ligo": 0.84,
					"location": [
						153.572451604275,
						-28.3388872954156
					],
					"name": "Bogangar Public School",
					"playspace": 65.69,
					"projections": [
						265,
						262,
						285,
						285,
						295,
						300
					],
					"projections_orig": [
						"265",
						"262",
						"285",
						"285",
						"295",
						"300"
					],
					"projections_percentage": [
						1.15,
						0,
						8.78,
						8.78,
						12.6,
						14.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4632
				}
			],
			"uid": 10127
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 207
			},
			"enrolment": 4047,
			"level": "Primary",
			"ligo": 0.6,
			"name": "Lake Macquarie West Primary",
			"playspace": 143.91,
			"projections": [
				4047,
				4025,
				4065,
				4050,
				4060
			],
			"projections_percentage": [
				0,
				-0.54,
				0.44,
				0.07,
				0.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.38,
					"enrolment": 32,
					"ligo": 0.62,
					"location": [
						151.538115008736,
						-33.0099877161941
					],
					"name": "Awaba Public School",
					"playspace": 159.82,
					"projections": [
						29,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.38,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1084
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 8.17,
					"enrolment": 59,
					"ligo": 0.53,
					"location": [
						151.622794777283,
						-32.9515630590033
					],
					"name": "Boolaroo Public School",
					"playspace": 90.56,
					"projections": [
						50,
						59,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"50",
						"59",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						-15.25,
						0,
						-6.78,
						-6.78,
						-6.78,
						-6.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1302
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.75,
					"enrolment": 63,
					"ligo": 0.25,
					"location": [
						151.583609782099,
						-32.9838102587299
					],
					"name": "Fassifern Public School",
					"playspace": 322.22,
					"projections": [
						58,
						63,
						60,
						60,
						60,
						60
					],
					"projections_orig": [
						"58",
						"63",
						"60",
						"60",
						"60",
						"60"
					],
					"projections_percentage": [
						-7.94,
						0,
						-4.76,
						-4.76,
						-4.76,
						-4.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1904
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.57,
					"enrolment": 284,
					"ligo": 0.59,
					"location": [
						151.589241668606,
						-33.0428787475407
					],
					"name": "Rathmines Public School",
					"playspace": 79.46,
					"projections": [
						245,
						284,
						270,
						275,
						275,
						275
					],
					"projections_orig": [
						"245",
						"284",
						"270",
						"275",
						"275",
						"275"
					],
					"projections_percentage": [
						-13.73,
						0,
						-4.93,
						-3.17,
						-3.17,
						-3.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2193
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 4.54,
					"enrolment": 70,
					"ligo": 0.68,
					"location": [
						151.606407840887,
						-32.9626538159798
					],
					"name": "Teralba Public School",
					"playspace": 107.37,
					"projections": [
						68,
						70,
						75,
						75,
						75,
						75
					],
					"projections_orig": [
						"68",
						"70",
						"75",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						-2.86,
						0,
						7.14,
						7.14,
						7.14,
						7.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3183
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.53,
					"enrolment": 166,
					"ligo": 0.41,
					"location": [
						151.595308217794,
						-33.0085215258834
					],
					"name": "Toronto Public School",
					"playspace": 42.76,
					"projections": [
						201,
						166,
						195,
						195,
						195,
						195
					],
					"projections_orig": [
						"201",
						"166",
						"195",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						21.08,
						0,
						17.47,
						17.47,
						17.47,
						17.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3247
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.27,
					"enrolment": 109,
					"ligo": 0.81,
					"location": [
						151.583581567115,
						-33.0718535412889
					],
					"name": "Wangi Wangi Public School",
					"playspace": 119.44,
					"projections": [
						114,
						109,
						105,
						105,
						105,
						105
					],
					"projections_orig": [
						"114",
						"109",
						"105",
						"105",
						"105",
						"105"
					],
					"projections_percentage": [
						4.59,
						0,
						-3.67,
						-3.67,
						-3.67,
						-3.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3373
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.67,
					"enrolment": 429,
					"ligo": 0.65,
					"location": [
						151.649303957995,
						-32.9795129343659
					],
					"name": "Warners Bay Public School",
					"playspace": 32.45,
					"projections": [
						420,
						429,
						440,
						445,
						445,
						445
					],
					"projections_orig": [
						"420",
						"429",
						"440",
						"445",
						"445",
						"445"
					],
					"projections_percentage": [
						-2.1,
						0,
						2.56,
						3.73,
						3.73,
						3.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3384
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 13.2,
					"enrolment": 23,
					"ligo": 0.75,
					"location": [
						151.629602252155,
						-32.9375822476999
					],
					"name": "Argenton Public School",
					"playspace": 855.2,
					"projections": [
						53,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"53",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						130.43,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3904
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.61,
					"enrolment": 219,
					"ligo": 0.63,
					"location": [
						151.577993769278,
						-32.9988458673462
					],
					"name": "Blackalls Park Public School",
					"playspace": 70.17,
					"projections": [
						242,
						219,
						220,
						220,
						220,
						220
					],
					"projections_orig": [
						"242",
						"219",
						"220",
						"220",
						"220",
						"220"
					],
					"projections_percentage": [
						10.5,
						0,
						0.46,
						0.46,
						0.46,
						0.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3966
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 5.92,
					"enrolment": 113,
					"ligo": 0.38,
					"location": [
						151.621508207541,
						-32.959509726998
					],
					"name": "Speers Point Public School",
					"playspace": 102.36,
					"projections": [
						137,
						113,
						115,
						115,
						115,
						115
					],
					"projections_orig": [
						"137",
						"113",
						"115",
						"115",
						"115",
						"115"
					],
					"projections_percentage": [
						21.24,
						0,
						1.77,
						1.77,
						1.77,
						1.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3968
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 7.91,
					"enrolment": 104,
					"ligo": 0.74,
					"location": [
						151.575783358569,
						-33.0077933444757
					],
					"name": "Biraban Public School",
					"playspace": 169.09,
					"projections": [
						103,
						104,
						110,
						110,
						110,
						110
					],
					"projections_orig": [
						"103",
						"104",
						"110",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						-0.96,
						0,
						5.77,
						5.77,
						5.77,
						5.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3988
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.01,
					"enrolment": 221,
					"ligo": 0.44,
					"location": [
						151.611457164425,
						-32.973366182359
					],
					"name": "Booragul Public School",
					"playspace": 90.57,
					"projections": [
						267,
						221,
						235,
						240,
						235,
						240
					],
					"projections_orig": [
						"267",
						"221",
						"235",
						"240",
						"235",
						"240"
					],
					"projections_percentage": [
						20.81,
						0,
						6.33,
						8.6,
						6.33,
						8.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4017
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 2.39,
					"enrolment": 245,
					"ligo": 0.73,
					"location": [
						151.610564444907,
						-33.0416022611789
					],
					"name": "Coal Point Public School",
					"playspace": 65.42,
					"projections": [
						232,
						245,
						225,
						225,
						225,
						225
					],
					"projections_orig": [
						"232",
						"245",
						"225",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						-5.31,
						0,
						-8.16,
						-8.16,
						-8.16,
						-8.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4022
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 18
					},
					"classroomspace": 2.41,
					"enrolment": 628,
					"ligo": 0.71,
					"location": [
						151.643276579499,
						-32.9910836552311
					],
					"name": "Eleebana Public School",
					"playspace": 35.01,
					"projections": [
						532,
						628,
						605,
						610,
						610,
						610
					],
					"projections_orig": [
						"532",
						"628",
						"605",
						"610",
						"610",
						"610"
					],
					"projections_percentage": [
						-15.29,
						0,
						-3.66,
						-2.87,
						-2.87,
						-2.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4034
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.39,
					"enrolment": 117,
					"ligo": 0.66,
					"location": [
						151.580276731374,
						-33.0608370253187
					],
					"name": "Arcadia Vale Public School",
					"playspace": 196.55,
					"projections": [
						109,
						117,
						120,
						125,
						120,
						125
					],
					"projections_orig": [
						"109",
						"117",
						"120",
						"125",
						"120",
						"125"
					],
					"projections_percentage": [
						-6.84,
						0,
						2.56,
						6.84,
						2.56,
						6.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4132
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 20
					},
					"classroomspace": 2.38,
					"enrolment": 564,
					"ligo": 0.77,
					"location": [
						151.642175798096,
						-33.008359625455
					],
					"name": "Valentine Public School",
					"playspace": 35.57,
					"projections": [
						472,
						564,
						530,
						535,
						535,
						535
					],
					"projections_orig": [
						"472",
						"564",
						"530",
						"535",
						"535",
						"535"
					],
					"projections_percentage": [
						-16.31,
						0,
						-6.03,
						-5.14,
						-5.14,
						-5.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4185
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 15
					},
					"classroomspace": 2.69,
					"enrolment": 438,
					"ligo": 0.41,
					"location": [
						151.643309683781,
						-32.9660922734363
					],
					"name": "Biddabah Public School",
					"playspace": 51.22,
					"projections": [
						423,
						438,
						455,
						460,
						455,
						455
					],
					"projections_orig": [
						"423",
						"438",
						"455",
						"460",
						"455",
						"455"
					],
					"projections_percentage": [
						-3.42,
						0,
						3.88,
						5.02,
						3.88,
						3.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4206
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 5.07,
					"enrolment": 163,
					"ligo": 0.64,
					"location": [
						151.600920256133,
						-32.9921270205201
					],
					"name": "Fennell Bay Public School",
					"playspace": 109,
					"projections": [
						153,
						163,
						155,
						160,
						160,
						160
					],
					"projections_orig": [
						"153",
						"163",
						"155",
						"160",
						"160",
						"160"
					],
					"projections_percentage": [
						-6.13,
						0,
						-4.91,
						-1.84,
						-1.84,
						-1.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4208
				}
			],
			"uid": 10128
		},
		{
			"classrooms": {
				"demountable": 26,
				"permanent": 175
			},
			"enrolment": 4392,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Port Stephens Primary",
			"playspace": 68.68,
			"projections": [
				4392,
				4743,
				4848,
				4933,
				4908
			],
			"projections_percentage": [
				0,
				7.99,
				10.38,
				12.32,
				11.75
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 3.55,
					"enrolment": 306,
					"ligo": 0.87,
					"location": [
						152.090008717033,
						-32.7767580680311
					],
					"name": "Anna Bay Public School",
					"playspace": 51.1,
					"projections": [
						383,
						306,
						380,
						390,
						400,
						400
					],
					"projections_orig": [
						"383",
						"306",
						"380",
						"390",
						"400",
						"400"
					],
					"projections_percentage": [
						25.16,
						0,
						24.18,
						27.45,
						30.72,
						30.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1040
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 0
					},
					"classroomspace": 4.34,
					"enrolment": 35,
					"ligo": 0.25,
					"location": [
						152.010631482553,
						-32.7663058241968
					],
					"name": "Bobs Farm Public School",
					"playspace": 166.17,
					"projections": [
						29,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-17.14,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1271
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 5
					},
					"classroomspace": 3.21,
					"enrolment": 119,
					"ligo": 0.9,
					"location": [
						151.965962298914,
						-32.654240079729
					],
					"name": "Karuah Public School",
					"playspace": 42.62,
					"projections": [
						75,
						119,
						115,
						110,
						105,
						105
					],
					"projections_orig": [
						"75",
						"119",
						"115",
						"110",
						"105",
						"105"
					],
					"projections_percentage": [
						-36.97,
						0,
						-3.36,
						-7.56,
						-11.76,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2263
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 13
					},
					"classroomspace": 2.61,
					"enrolment": 353,
					"ligo": 0.67,
					"location": [
						151.853947531166,
						-32.7393122665354
					],
					"name": "Medowie Public School",
					"playspace": 63.9,
					"projections": [
						351,
						353,
						365,
						360,
						345,
						335
					],
					"projections_orig": [
						"351",
						"353",
						"365",
						"360",
						"345",
						"335"
					],
					"projections_percentage": [
						-0.57,
						0,
						3.4,
						1.98,
						-2.27,
						-5.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2512
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.86,
					"enrolment": 64,
					"ligo": 0.12,
					"location": [
						151.704170898406,
						-32.7525013782796
					],
					"name": "Millers Forest Public School",
					"playspace": 88.11,
					"projections": [
						35,
						64,
						55,
						55,
						60,
						60
					],
					"projections_orig": [
						"35",
						"64",
						"55",
						"55",
						"60",
						"60"
					],
					"projections_percentage": [
						-45.31,
						0,
						-14.06,
						-14.06,
						-6.25,
						-6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2554
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.37,
					"enrolment": 33,
					"ligo": 0.26,
					"location": [
						151.699123420306,
						-32.7245057550042
					],
					"name": "Mount Kanwary Public School",
					"playspace": 57.73,
					"projections": [
						36,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						9.09,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2641
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 2.8,
					"enrolment": 362,
					"ligo": 0.7,
					"location": [
						152.112364445223,
						-32.7356385770897
					],
					"name": "Tomaree Public School",
					"playspace": 178.83,
					"projections": [
						443,
						362,
						480,
						495,
						505,
						510
					],
					"projections_orig": [
						"443",
						"362",
						"480",
						"495",
						"505",
						"510"
					],
					"projections_percentage": [
						22.38,
						0,
						32.6,
						36.74,
						39.5,
						40.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2723
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.72,
					"enrolment": 415,
					"ligo": 0.54,
					"location": [
						151.740657997696,
						-32.7661291039652
					],
					"name": "Raymond Terrace Public School",
					"playspace": 64.67,
					"projections": [
						367,
						415,
						440,
						460,
						475,
						475
					],
					"projections_orig": [
						"367",
						"415",
						"440",
						"460",
						"475",
						"475"
					],
					"projections_percentage": [
						-11.57,
						0,
						6.02,
						10.84,
						14.46,
						14.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2943
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 4.1,
					"enrolment": 87,
					"ligo": 0.69,
					"location": [
						151.903631457602,
						-32.7884460421666
					],
					"name": "Salt Ash Public School",
					"playspace": 40.47,
					"projections": [
						108,
						87,
						100,
						100,
						100,
						100
					],
					"projections_orig": [
						"108",
						"87",
						"100",
						"100",
						"100",
						"100"
					],
					"projections_percentage": [
						24.14,
						0,
						14.94,
						14.94,
						14.94,
						14.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3035
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 9
					},
					"classroomspace": 2.96,
					"enrolment": 351,
					"ligo": 0.74,
					"location": [
						152.064378016545,
						-32.7099784571803
					],
					"name": "Soldiers Point Public School",
					"playspace": 15.41,
					"projections": [
						342,
						351,
						395,
						405,
						415,
						415
					],
					"projections_orig": [
						"342",
						"351",
						"395",
						"405",
						"415",
						"415"
					],
					"projections_percentage": [
						-2.56,
						0,
						12.54,
						15.38,
						18.23,
						18.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3696
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.36,
					"enrolment": 308,
					"ligo": 0.77,
					"location": [
						151.75527357215,
						-32.7590490796796
					],
					"name": "Irrawang Public School",
					"playspace": 91.2,
					"projections": [
						294,
						308,
						315,
						335,
						350,
						350
					],
					"projections_orig": [
						"294",
						"308",
						"315",
						"335",
						"350",
						"350"
					],
					"projections_percentage": [
						-4.55,
						0,
						2.27,
						8.77,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4372
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 19
					},
					"classroomspace": 2.31,
					"enrolment": 579,
					"ligo": 0.94,
					"location": [
						152.004265294772,
						-32.72913587263
					],
					"name": "Tanilba Bay Public School",
					"playspace": 42.19,
					"projections": [
						475,
						579,
						615,
						630,
						645,
						645
					],
					"projections_orig": [
						"475",
						"579",
						"615",
						"630",
						"645",
						"645"
					],
					"projections_percentage": [
						-17.96,
						0,
						6.22,
						8.81,
						11.4,
						11.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4547
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 22
					},
					"classroomspace": 2.4,
					"enrolment": 606,
					"ligo": 0.83,
					"location": [
						151.877161033711,
						-32.7439541629152
					],
					"name": "Wirreanda Public School",
					"playspace": 25.31,
					"projections": [
						556,
						606,
						575,
						565,
						560,
						530
					],
					"projections_orig": [
						"556",
						"606",
						"575",
						"565",
						"560",
						"530"
					],
					"projections_percentage": [
						-8.25,
						0,
						-5.12,
						-6.77,
						-7.59,
						-12.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4564
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 12
					},
					"classroomspace": 2.49,
					"enrolment": 425,
					"ligo": 0.63,
					"location": [
						152.17314894559,
						-32.7288813103582
					],
					"name": "Shoal Bay Public School",
					"playspace": 42.57,
					"projections": [
						352,
						425,
						435,
						450,
						460,
						465
					],
					"projections_orig": [
						"352",
						"425",
						"435",
						"450",
						"460",
						"465"
					],
					"projections_percentage": [
						-17.18,
						0,
						2.35,
						5.88,
						8.24,
						9.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4589
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.27,
					"enrolment": 349,
					"ligo": 0.77,
					"location": [
						151.775327907097,
						-32.7587790612886
					],
					"name": "Grahamstown Public School",
					"playspace": 59.89,
					"projections": [
						415,
						349,
						405,
						425,
						445,
						450
					],
					"projections_orig": [
						"415",
						"349",
						"405",
						"425",
						"445",
						"450"
					],
					"projections_percentage": [
						18.91,
						0,
						16.05,
						21.78,
						27.51,
						28.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4609
				}
			],
			"uid": 10129
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 158
			},
			"enrolment": 3499,
			"level": "Primary",
			"ligo": 0.62,
			"name": "Charlestown Primary",
			"playspace": 63.9,
			"projections": [
				3499,
				3535,
				3570,
				3560,
				3570
			],
			"projections_percentage": [
				0,
				1.03,
				2.03,
				1.74,
				2.03
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.81,
					"enrolment": 315,
					"ligo": 0.67,
					"location": [
						151.663135698827,
						-33.0299110048005
					],
					"name": "Belmont Public School",
					"playspace": 54.18,
					"projections": [
						289,
						315,
						310,
						315,
						310,
						315
					],
					"projections_orig": [
						"289",
						"315",
						"310",
						"315",
						"310",
						"315"
					],
					"projections_percentage": [
						-8.25,
						0,
						-1.59,
						0,
						-1.59,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1183
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 5,
					"enrolment": 130,
					"ligo": 0.63,
					"location": [
						151.696983870389,
						-32.965201213215
					],
					"name": "Charlestown Public School",
					"playspace": 23.07,
					"projections": [
						136,
						130,
						135,
						135,
						135,
						135
					],
					"projections_orig": [
						"136",
						"130",
						"135",
						"135",
						"135",
						"135"
					],
					"projections_percentage": [
						4.62,
						0,
						3.85,
						3.85,
						3.85,
						3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1550
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.64,
					"enrolment": 263,
					"ligo": 0.62,
					"location": [
						151.717016933809,
						-32.9894040586081
					],
					"name": "Dudley Public School",
					"playspace": 32.03,
					"projections": [
						245,
						263,
						270,
						270,
						270,
						270
					],
					"projections_orig": [
						"245",
						"263",
						"270",
						"270",
						"270",
						"270"
					],
					"projections_percentage": [
						-6.84,
						0,
						2.66,
						2.66,
						2.66,
						2.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1778
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 9
					},
					"classroomspace": 2.71,
					"enrolment": 284,
					"ligo": 0.86,
					"location": [
						151.71194257255,
						-33.0110497867105
					],
					"name": "Redhead Public School",
					"playspace": 49.65,
					"projections": [
						262,
						284,
						290,
						295,
						295,
						295
					],
					"projections_orig": [
						"262",
						"284",
						"290",
						"295",
						"295",
						"295"
					],
					"projections_percentage": [
						-7.75,
						0,
						2.11,
						3.87,
						3.87,
						3.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2946
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.27,
					"enrolment": 220,
					"ligo": 0.5,
					"location": [
						151.691681858245,
						-32.9843389271604
					],
					"name": "Wiripaang Public School",
					"playspace": 162.86,
					"projections": [
						127,
						220,
						220,
						220,
						220,
						220
					],
					"projections_orig": [
						"127",
						"220",
						"220",
						"220",
						"220",
						"220"
					],
					"projections_percentage": [
						-42.27,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3762
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.56,
					"enrolment": 326,
					"ligo": 0.6,
					"location": [
						151.713434894573,
						-32.9639318598949
					],
					"name": "Kahibah Public School",
					"playspace": 43.44,
					"projections": [
						288,
						326,
						315,
						320,
						320,
						320
					],
					"projections_orig": [
						"288",
						"326",
						"315",
						"320",
						"320",
						"320"
					],
					"projections_percentage": [
						-11.66,
						0,
						-3.37,
						-1.84,
						-1.84,
						-1.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3874
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 7.03,
					"enrolment": 151,
					"ligo": 0.87,
					"location": [
						151.678839745098,
						-32.9923057625142
					],
					"name": "Windale Public School",
					"playspace": 89.75,
					"projections": [
						253,
						151,
						195,
						200,
						200,
						200
					],
					"projections_orig": [
						"253",
						"151",
						"195",
						"200",
						"200",
						"200"
					],
					"projections_percentage": [
						67.55,
						0,
						29.14,
						32.45,
						32.45,
						32.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3893
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.39,
					"enrolment": 190,
					"ligo": 0.63,
					"location": [
						151.671950382339,
						-33.0201656063615
					],
					"name": "Belmont North Public School",
					"playspace": 92.88,
					"projections": [
						123,
						190,
						165,
						165,
						165,
						165
					],
					"projections_orig": [
						"123",
						"190",
						"165",
						"165",
						"165",
						"165"
					],
					"projections_percentage": [
						-35.26,
						0,
						-13.16,
						-13.16,
						-13.16,
						-13.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3927
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.91,
					"enrolment": 171,
					"ligo": 0.55,
					"location": [
						151.669308413973,
						-32.9775057676111
					],
					"name": "Mount Hutton Public School",
					"playspace": 77.26,
					"projections": [
						172,
						171,
						170,
						170,
						170,
						170
					],
					"projections_orig": [
						"172",
						"171",
						"170",
						"170",
						"170",
						"170"
					],
					"projections_percentage": [
						0.58,
						0,
						-0.58,
						-0.58,
						-0.58,
						-0.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3939
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.16,
					"enrolment": 243,
					"ligo": 0.51,
					"location": [
						151.705445016695,
						-32.9712831606353
					],
					"name": "Charlestown East Public School",
					"playspace": 87.82,
					"projections": [
						202,
						243,
						220,
						225,
						220,
						225
					],
					"projections_orig": [
						"202",
						"243",
						"220",
						"225",
						"220",
						"225"
					],
					"projections_percentage": [
						-16.87,
						0,
						-9.47,
						-7.41,
						-9.47,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4194
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.6,
					"enrolment": 217,
					"ligo": 0.45,
					"location": [
						151.687948825094,
						-32.9682238466324
					],
					"name": "Charlestown South Public School",
					"playspace": 65.21,
					"projections": [
						139,
						217,
						195,
						195,
						195,
						195
					],
					"projections_orig": [
						"139",
						"217",
						"195",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						-35.94,
						0,
						-10.14,
						-10.14,
						-10.14,
						-10.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4324
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.47,
					"enrolment": 551,
					"ligo": 0.67,
					"location": [
						151.664640555219,
						-33.0145834077935
					],
					"name": "Floraville Public School",
					"playspace": 11.2,
					"projections": [
						553,
						551,
						570,
						575,
						575,
						575
					],
					"projections_orig": [
						"553",
						"551",
						"570",
						"575",
						"575",
						"575"
					],
					"projections_percentage": [
						0.36,
						0,
						3.45,
						4.36,
						4.36,
						4.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4379
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.6,
					"enrolment": 438,
					"ligo": 0.54,
					"location": [
						151.687967830093,
						-33.0162716981391
					],
					"name": "Jewells Primary School",
					"playspace": 41.33,
					"projections": [
						505,
						438,
						480,
						485,
						485,
						485
					],
					"projections_orig": [
						"505",
						"438",
						"480",
						"485",
						"485",
						"485"
					],
					"projections_percentage": [
						15.3,
						0,
						9.59,
						10.73,
						10.73,
						10.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4469
				}
			],
			"uid": 10130
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 89
			},
			"enrolment": 2082,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Kotara Primary",
			"playspace": 40.33,
			"projections": [
				2082,
				2135,
				2205,
				2245,
				2245
			],
			"projections_percentage": [
				0,
				2.55,
				5.91,
				7.83,
				7.83
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 3.25,
					"enrolment": 273,
					"ligo": 0.78,
					"location": [
						151.730005683356,
						-32.9325618948815
					],
					"name": "Adamstown Public School",
					"playspace": 64.44,
					"projections": [
						235,
						273,
						280,
						285,
						290,
						290
					],
					"projections_orig": [
						"235",
						"273",
						"280",
						"285",
						"290",
						"290"
					],
					"projections_percentage": [
						-13.92,
						0,
						2.56,
						4.4,
						6.23,
						6.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1008
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 2.98,
					"enrolment": 158,
					"ligo": 0.68,
					"location": [
						151.741390437664,
						-32.9370571358803
					],
					"name": "Merewether Public School",
					"playspace": 44.59,
					"projections": [
						166,
						158,
						185,
						195,
						200,
						200
					],
					"projections_orig": [
						"166",
						"158",
						"185",
						"195",
						"200",
						"200"
					],
					"projections_percentage": [
						5.06,
						0,
						17.09,
						23.42,
						26.58,
						26.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2525
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 2.27,
					"enrolment": 460,
					"ligo": 0.51,
					"location": [
						151.717557876332,
						-32.9311409851811
					],
					"name": "New Lambton South Public School",
					"playspace": 31.27,
					"projections": [
						407,
						460,
						475,
						500,
						515,
						515
					],
					"projections_orig": [
						"407",
						"460",
						"475",
						"500",
						"515",
						"515"
					],
					"projections_percentage": [
						-11.52,
						0,
						3.26,
						8.7,
						11.96,
						11.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3798
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.03,
					"enrolment": 319,
					"ligo": 0.75,
					"location": [
						151.694933895439,
						-32.9468482267985
					],
					"name": "Kotara South Public School",
					"playspace": 62.5,
					"projections": [
						258,
						319,
						300,
						305,
						305,
						305
					],
					"projections_orig": [
						"258",
						"319",
						"300",
						"305",
						"305",
						"305"
					],
					"projections_percentage": [
						-19.12,
						0,
						-5.96,
						-4.39,
						-4.39,
						-4.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4203
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 2.56,
					"enrolment": 530,
					"ligo": 0.56,
					"location": [
						151.712772458519,
						-32.9454693080959
					],
					"name": "Belair Public School",
					"playspace": 25.51,
					"projections": [
						479,
						530,
						530,
						535,
						535,
						535
					],
					"projections_orig": [
						"479",
						"530",
						"530",
						"535",
						"535",
						"535"
					],
					"projections_percentage": [
						-9.62,
						0,
						0,
						0.94,
						0.94,
						0.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4370
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.93,
					"enrolment": 342,
					"ligo": 0.64,
					"location": [
						151.738244834481,
						-32.947049327707
					],
					"name": "Merewether Heights Public School",
					"playspace": 13.64,
					"projections": [
						320,
						342,
						365,
						385,
						400,
						400
					],
					"projections_orig": [
						"320",
						"342",
						"365",
						"385",
						"400",
						"400"
					],
					"projections_percentage": [
						-6.43,
						0,
						6.73,
						12.57,
						16.96,
						16.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4416
				}
			],
			"uid": 10131
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 46
			},
			"enrolment": 1049,
			"level": "Primary",
			"ligo": 0.77,
			"name": "Swansea Primary",
			"playspace": 143.47,
			"projections": [
				1049,
				1075,
				1095,
				1095,
				1095
			],
			"projections_percentage": [
				0,
				2.48,
				4.39,
				4.39,
				4.39
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.26,
					"enrolment": 43,
					"ligo": 0.81,
					"location": [
						151.648405436278,
						-33.0739120460417
					],
					"name": "Pelican Flat Public School",
					"playspace": 340.21,
					"projections": [
						47,
						43,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"47",
						"43",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						9.3,
						0,
						16.28,
						16.28,
						16.28,
						16.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2476
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 2.78,
					"enrolment": 120,
					"ligo": 0.68,
					"location": [
						151.603961282201,
						-33.1357939444135
					],
					"name": "Nords Wharf Public School",
					"playspace": 123.28,
					"projections": [
						85,
						120,
						105,
						110,
						110,
						110
					],
					"projections_orig": [
						"85",
						"120",
						"105",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						-29.17,
						0,
						-12.5,
						-8.33,
						-8.33,
						-8.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2759
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.14,
					"enrolment": 232,
					"ligo": 0.83,
					"location": [
						151.636111184618,
						-33.0836675423834
					],
					"name": "Swansea Public School",
					"playspace": 35.68,
					"projections": [
						220,
						232,
						275,
						280,
						280,
						280
					],
					"projections_orig": [
						"220",
						"232",
						"275",
						"280",
						"280",
						"280"
					],
					"projections_percentage": [
						-5.17,
						0,
						18.53,
						20.69,
						20.69,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3141
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.45,
					"enrolment": 158,
					"ligo": 0.75,
					"location": [
						151.64951682282,
						-33.057984467019
					],
					"name": "Marks Point Public School",
					"playspace": 80.14,
					"projections": [
						185,
						158,
						155,
						160,
						160,
						160
					],
					"projections_orig": [
						"185",
						"158",
						"155",
						"160",
						"160",
						"160"
					],
					"projections_percentage": [
						17.09,
						0,
						-1.9,
						1.27,
						1.27,
						1.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3898
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.51,
					"enrolment": 96,
					"ligo": 0.76,
					"location": [
						151.653450578921,
						-33.0721230281809
					],
					"name": "Blacksmiths Public School",
					"playspace": 239.49,
					"projections": [
						123,
						96,
						105,
						105,
						105,
						105
					],
					"projections_orig": [
						"123",
						"96",
						"105",
						"105",
						"105",
						"105"
					],
					"projections_percentage": [
						28.12,
						0,
						9.38,
						9.38,
						9.38,
						9.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4197
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.45,
					"enrolment": 400,
					"ligo": 0.81,
					"location": [
						151.638547179011,
						-33.104085654651
					],
					"name": "Caves Beach Public School",
					"playspace": 42.01,
					"projections": [
						365,
						400,
						385,
						390,
						390,
						390
					],
					"projections_orig": [
						"365",
						"400",
						"385",
						"390",
						"390",
						"390"
					],
					"projections_percentage": [
						-8.75,
						0,
						-3.75,
						-2.5,
						-2.5,
						-2.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4367
				}
			],
			"uid": 10132
		},
		{
			"classrooms": {
				"demountable": 56,
				"permanent": 252
			},
			"enrolment": 6649,
			"level": "Primary",
			"ligo": 0.7,
			"name": "Maitland Primary",
			"playspace": 59.69,
			"projections": [
				6649,
				7000,
				7270,
				7425,
				7450
			],
			"projections_percentage": [
				0,
				5.28,
				9.34,
				11.67,
				12.05
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.33,
					"enrolment": 272,
					"ligo": 0.66,
					"location": [
						151.6537523384,
						-32.8040787149929
					],
					"name": "Beresfield Public School",
					"playspace": 29.68,
					"projections": [
						322,
						272,
						325,
						340,
						345,
						350
					],
					"projections_orig": [
						"322",
						"272",
						"325",
						"340",
						"345",
						"350"
					],
					"projections_percentage": [
						18.38,
						0,
						19.49,
						25,
						26.84,
						28.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1201
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 9
					},
					"classroomspace": 3.05,
					"enrolment": 435,
					"ligo": 0.59,
					"location": [
						151.573521872535,
						-32.7075735936284
					],
					"name": "Bolwarra Public School",
					"playspace": 50.32,
					"projections": [
						392,
						435,
						460,
						460,
						455,
						445
					],
					"projections_orig": [
						"392",
						"435",
						"460",
						"460",
						"455",
						"445"
					],
					"projections_percentage": [
						-9.89,
						0,
						5.75,
						5.75,
						4.6,
						2.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1286
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 10
					},
					"classroomspace": 2.38,
					"enrolment": 386,
					"ligo": 0.84,
					"location": [
						151.350262965666,
						-32.6590042800808
					],
					"name": "Branxton Public School",
					"playspace": 23.91,
					"projections": [
						330,
						386,
						415,
						460,
						470,
						445
					],
					"projections_orig": [
						"330",
						"386",
						"415",
						"460",
						"470",
						"445"
					],
					"projections_percentage": [
						-14.51,
						0,
						7.51,
						19.17,
						21.76,
						15.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1341
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 2
					},
					"classroomspace": 2.79,
					"enrolment": 178,
					"ligo": 0.84,
					"location": [
						151.530421637957,
						-32.7518337786118
					],
					"name": "Gillieston Public School",
					"playspace": 92.45,
					"projections": [
						105,
						178,
						190,
						195,
						200,
						205
					],
					"projections_orig": [
						"105",
						"178",
						"190",
						"195",
						"200",
						"205"
					],
					"projections_percentage": [
						-41.01,
						0,
						6.74,
						9.55,
						12.36,
						15.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1982
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.57,
					"enrolment": 187,
					"ligo": 0.91,
					"location": [
						151.38732143607,
						-32.6807001860885
					],
					"name": "Greta Public School",
					"playspace": 46.54,
					"projections": [
						206,
						187,
						220,
						230,
						235,
						235
					],
					"projections_orig": [
						"206",
						"187",
						"220",
						"230",
						"235",
						"235"
					],
					"projections_percentage": [
						10.16,
						0,
						17.65,
						22.99,
						25.67,
						25.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2084
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 25
					},
					"classroomspace": 3.16,
					"enrolment": 449,
					"ligo": 0.73,
					"location": [
						151.531591137713,
						-32.725112512395
					],
					"name": "Telarah Public School",
					"playspace": 30.83,
					"projections": [
						496,
						449,
						490,
						510,
						520,
						525
					],
					"projections_orig": [
						"496",
						"449",
						"490",
						"510",
						"520",
						"525"
					],
					"projections_percentage": [
						10.47,
						0,
						9.13,
						13.59,
						15.81,
						16.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2177
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.33,
					"enrolment": 55,
					"ligo": 0.41,
					"location": [
						151.603837248055,
						-32.6646740492067
					],
					"name": "Iona Public School",
					"playspace": 190.02,
					"projections": [
						66,
						55,
						65,
						65,
						60,
						60
					],
					"projections_orig": [
						"66",
						"55",
						"65",
						"65",
						"60",
						"60"
					],
					"projections_percentage": [
						20,
						0,
						18.18,
						18.18,
						9.09,
						9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2211
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 3
					},
					"classroomspace": 2.64,
					"enrolment": 149,
					"ligo": 0.8,
					"location": [
						151.606037560963,
						-32.7006135225472
					],
					"name": "Largs Public School",
					"playspace": 63.58,
					"projections": [
						117,
						149,
						135,
						135,
						135,
						130
					],
					"projections_orig": [
						"117",
						"149",
						"135",
						"135",
						"135",
						"130"
					],
					"projections_percentage": [
						-21.48,
						0,
						-9.4,
						-9.4,
						-9.4,
						-12.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2374
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.62,
					"enrolment": 171,
					"ligo": 0.36,
					"location": [
						151.451469034318,
						-32.6996807840043
					],
					"name": "Lochinvar Public School",
					"playspace": 104.31,
					"projections": [
						95,
						171,
						165,
						175,
						175,
						180
					],
					"projections_orig": [
						"95",
						"171",
						"165",
						"175",
						"175",
						"180"
					],
					"projections_percentage": [
						-44.44,
						0,
						-3.51,
						2.34,
						2.34,
						5.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2417
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 23
					},
					"classroomspace": 2.78,
					"enrolment": 582,
					"ligo": 0.61,
					"location": [
						151.584910242014,
						-32.748457239193
					],
					"name": "Maitland East Public School",
					"playspace": 21.58,
					"projections": [
						543,
						582,
						655,
						680,
						695,
						700
					],
					"projections_orig": [
						"543",
						"582",
						"655",
						"680",
						"695",
						"700"
					],
					"projections_percentage": [
						-6.7,
						0,
						12.54,
						16.84,
						19.42,
						20.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2451
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.62,
					"enrolment": 219,
					"ligo": 0.61,
					"location": [
						151.631626783529,
						-32.7259066259276
					],
					"name": "Morpeth Public School",
					"playspace": 23.47,
					"projections": [
						188,
						219,
						235,
						245,
						250,
						250
					],
					"projections_orig": [
						"188",
						"219",
						"235",
						"245",
						"250",
						"250"
					],
					"projections_percentage": [
						-14.16,
						0,
						7.31,
						11.87,
						14.16,
						14.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2623
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.72,
					"enrolment": 375,
					"ligo": 0.65,
					"location": [
						151.604161110685,
						-32.7431723223951
					],
					"name": "Tenambit Public School",
					"playspace": 43.13,
					"projections": [
						328,
						375,
						385,
						400,
						410,
						415
					],
					"projections_orig": [
						"328",
						"375",
						"385",
						"400",
						"410",
						"415"
					],
					"projections_percentage": [
						-12.53,
						0,
						2.67,
						6.67,
						9.33,
						10.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3180
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 22
					},
					"classroomspace": 2.45,
					"enrolment": 590,
					"ligo": 0.85,
					"location": [
						151.641361514857,
						-32.7792821890393
					],
					"name": "Thornton Public School",
					"playspace": 127.2,
					"projections": [
						542,
						590,
						610,
						635,
						675,
						685
					],
					"projections_orig": [
						"542",
						"590",
						"610",
						"635",
						"675",
						"685"
					],
					"projections_percentage": [
						-8.14,
						0,
						3.39,
						7.63,
						14.41,
						16.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3204
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.53,
					"enrolment": 379,
					"ligo": 0.3,
					"location": [
						151.553804530514,
						-32.7355536709923
					],
					"name": "Maitland Public School",
					"playspace": 15.62,
					"projections": [
						300,
						379,
						375,
						385,
						390,
						395
					],
					"projections_orig": [
						"300",
						"379",
						"375",
						"385",
						"390",
						"395"
					],
					"projections_percentage": [
						-20.84,
						0,
						-1.06,
						1.58,
						2.9,
						4.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3949
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.65,
					"enrolment": 155,
					"ligo": 0.46,
					"location": [
						151.663504372587,
						-32.8101509942166
					],
					"name": "Tarro Public School",
					"playspace": 123.06,
					"projections": [
						116,
						155,
						150,
						155,
						160,
						160
					],
					"projections_orig": [
						"116",
						"155",
						"150",
						"155",
						"160",
						"160"
					],
					"projections_percentage": [
						-25.16,
						0,
						-3.23,
						0,
						3.23,
						3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4263
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 5.69,
					"enrolment": 199,
					"ligo": 0.92,
					"location": [
						151.66915198165,
						-32.7924268117674
					],
					"name": "Woodberry Public School",
					"playspace": 112.83,
					"projections": [
						187,
						199,
						200,
						210,
						215,
						215
					],
					"projections_orig": [
						"187",
						"199",
						"200",
						"210",
						"215",
						"215"
					],
					"projections_percentage": [
						-6.03,
						0,
						0.5,
						5.53,
						8.04,
						8.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4459
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.1,
					"enrolment": 311,
					"ligo": 0.84,
					"location": [
						151.612310625293,
						-32.7642294066915
					],
					"name": "Metford Public School",
					"playspace": 48.43,
					"projections": [
						318,
						311,
						325,
						335,
						345,
						350
					],
					"projections_orig": [
						"318",
						"311",
						"325",
						"335",
						"345",
						"350"
					],
					"projections_percentage": [
						2.25,
						0,
						4.5,
						7.72,
						10.93,
						12.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4521
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 22
					},
					"classroomspace": 2.55,
					"enrolment": 876,
					"ligo": 0.8,
					"location": [
						151.529059227026,
						-32.7115128117547
					],
					"name": "Rutherford Public School",
					"playspace": 21,
					"projections": [
						606,
						876,
						875,
						905,
						925,
						935
					],
					"projections_orig": [
						"606",
						"876",
						"875",
						"905",
						"925",
						"935"
					],
					"projections_percentage": [
						-30.82,
						0,
						-0.11,
						3.31,
						5.59,
						6.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4561
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 17
					},
					"classroomspace": 2.79,
					"enrolment": 619,
					"ligo": 0.75,
					"location": [
						151.599397657566,
						-32.7726393759434
					],
					"name": "Ashtonfield Public School",
					"playspace": 6.34,
					"projections": [
						574,
						619,
						665,
						690,
						710,
						715
					],
					"projections_orig": [
						"574",
						"619",
						"665",
						"690",
						"710",
						"715"
					],
					"projections_percentage": [
						-7.27,
						0,
						7.43,
						11.47,
						14.7,
						15.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4642
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.58,
					"enrolment": 62,
					"ligo": 1,
					"location": [
						151.55922228186,
						-32.7275320489487
					],
					"name": "Nillo Infants School",
					"playspace": 19.4,
					"projections": [
						58,
						62,
						60,
						60,
						55,
						55
					],
					"projections_orig": [
						"58",
						"62",
						"60",
						"60",
						"55",
						"55"
					],
					"projections_percentage": [
						-6.45,
						0,
						-3.23,
						-3.23,
						-11.29,
						-11.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5128
				}
			],
			"uid": 10133
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 45
			},
			"enrolment": 1219,
			"level": "Primary",
			"ligo": 0.65,
			"name": "Morisset Primary",
			"playspace": 66.47,
			"projections": [
				1219,
				1220,
				1225,
				1225,
				1230
			],
			"projections_percentage": [
				0,
				0.08,
				0.49,
				0.49,
				0.9
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 9
					},
					"classroomspace": 2.64,
					"enrolment": 223,
					"ligo": 0.69,
					"location": [
						151.440912945326,
						-33.0808082762675
					],
					"name": "Cooranbong Public School",
					"playspace": 78.26,
					"projections": [
						169,
						223,
						200,
						200,
						200,
						200
					],
					"projections_orig": [
						"169",
						"223",
						"200",
						"200",
						"200",
						"200"
					],
					"projections_percentage": [
						-24.22,
						0,
						-10.31,
						-10.31,
						-10.31,
						-10.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1635
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 2
					},
					"classroomspace": 4.48,
					"enrolment": 115,
					"ligo": 0.48,
					"location": [
						151.498888110809,
						-33.0800632273603
					],
					"name": "Dora Creek Public School",
					"playspace": 79.86,
					"projections": [
						141,
						115,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"141",
						"115",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						22.61,
						0,
						13.04,
						13.04,
						13.04,
						13.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1762
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 14
					},
					"classroomspace": 2.6,
					"enrolment": 428,
					"ligo": 0.88,
					"location": [
						151.515563631862,
						-33.1137563616814
					],
					"name": "Bonnells Bay Public School",
					"playspace": 35.59,
					"projections": [
						348,
						428,
						420,
						420,
						420,
						420
					],
					"projections_orig": [
						"348",
						"428",
						"420",
						"420",
						"420",
						"420"
					],
					"projections_percentage": [
						-18.69,
						0,
						-1.87,
						-1.87,
						-1.87,
						-1.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2532
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.94,
					"enrolment": 235,
					"ligo": 0.49,
					"location": [
						151.488536611209,
						-33.102922155986
					],
					"name": "Morisset Public School",
					"playspace": 63.71,
					"projections": [
						239,
						235,
						240,
						245,
						245,
						245
					],
					"projections_orig": [
						"239",
						"235",
						"240",
						"245",
						"245",
						"245"
					],
					"projections_percentage": [
						1.7,
						0,
						2.13,
						4.26,
						4.26,
						4.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2621
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 9
					},
					"classroomspace": 2.7,
					"enrolment": 218,
					"ligo": 0.71,
					"location": [
						151.482866172352,
						-33.1758248322375
					],
					"name": "Wyee Public School",
					"playspace": 74.93,
					"projections": [
						202,
						218,
						230,
						230,
						230,
						235
					],
					"projections_orig": [
						"202",
						"218",
						"230",
						"230",
						"230",
						"235"
					],
					"projections_percentage": [
						-7.34,
						0,
						5.5,
						5.5,
						5.5,
						7.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3522
				}
			],
			"uid": 10134
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 158
			},
			"enrolment": 4024,
			"level": "Primary",
			"ligo": 0.69,
			"name": "Newcastle West Primary",
			"playspace": 66.82,
			"projections": [
				4024,
				4025,
				4135,
				4165,
				4185
			],
			"projections_percentage": [
				0,
				0.02,
				2.76,
				3.5,
				4
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.36,
					"enrolment": 301,
					"ligo": 0.6,
					"location": [
						151.593477892751,
						-32.9324334884525
					],
					"name": "Barnsley Public School",
					"playspace": 56.73,
					"projections": [
						264,
						301,
						300,
						310,
						315,
						320
					],
					"projections_orig": [
						"264",
						"301",
						"300",
						"310",
						"315",
						"320"
					],
					"projections_percentage": [
						-12.29,
						0,
						-0.33,
						2.99,
						4.65,
						6.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1138
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.98,
					"enrolment": 225,
					"ligo": 0.54,
					"location": [
						151.658041246276,
						-32.9459242138991
					],
					"name": "Cardiff Public School",
					"playspace": 38.2,
					"projections": [
						225,
						225,
						220,
						225,
						225,
						225
					],
					"projections_orig": [
						"225",
						"225",
						"220",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						0,
						0,
						-2.22,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1505
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 2.21,
					"enrolment": 402,
					"ligo": 0.67,
					"location": [
						151.704721345559,
						-32.9117509390879
					],
					"name": "Lambton Public School",
					"playspace": 27.23,
					"projections": [
						369,
						402,
						430,
						455,
						470,
						470
					],
					"projections_orig": [
						"369",
						"402",
						"430",
						"455",
						"470",
						"470"
					],
					"projections_percentage": [
						-8.21,
						0,
						6.97,
						13.18,
						16.92,
						16.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2366
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 2.05,
					"enrolment": 598,
					"ligo": 0.78,
					"location": [
						151.712466662394,
						-32.9229420988449
					],
					"name": "New Lambton Public School",
					"playspace": 9.39,
					"projections": [
						592,
						598,
						645,
						675,
						690,
						690
					],
					"projections_orig": [
						"592",
						"598",
						"645",
						"675",
						"690",
						"690"
					],
					"projections_percentage": [
						-1,
						0,
						7.86,
						12.88,
						15.38,
						15.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2738
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.04,
					"enrolment": 221,
					"ligo": 0.77,
					"location": [
						151.580474275862,
						-32.9042611194444
					],
					"name": "West Wallsend Public School",
					"playspace": 36.65,
					"projections": [
						223,
						221,
						230,
						240,
						245,
						250
					],
					"projections_orig": [
						"223",
						"221",
						"230",
						"240",
						"245",
						"250"
					],
					"projections_percentage": [
						0.9,
						0,
						4.07,
						8.6,
						10.86,
						13.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3358
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.66,
					"enrolment": 587,
					"ligo": 0.83,
					"location": [
						151.621801778585,
						-32.9216319445102
					],
					"name": "Edgeworth Public School",
					"playspace": 75.72,
					"projections": [
						572,
						587,
						580,
						585,
						580,
						585
					],
					"projections_orig": [
						"572",
						"587",
						"580",
						"585",
						"580",
						"585"
					],
					"projections_percentage": [
						-2.56,
						0,
						-1.19,
						-0.34,
						-1.19,
						-0.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3564
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.71,
					"enrolment": 307,
					"ligo": 0.66,
					"location": [
						151.664168417772,
						-32.9534045193004
					],
					"name": "Cardiff South Public School",
					"playspace": 53.1,
					"projections": [
						316,
						307,
						300,
						305,
						305,
						305
					],
					"projections_orig": [
						"316",
						"307",
						"300",
						"305",
						"305",
						"305"
					],
					"projections_percentage": [
						2.93,
						0,
						-2.28,
						-0.65,
						-0.65,
						-0.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3895
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 7
					},
					"classroomspace": 3.37,
					"enrolment": 210,
					"ligo": 0.66,
					"location": [
						151.683611698462,
						-32.9477929383421
					],
					"name": "Garden Suburb Public School",
					"playspace": 153.08,
					"projections": [
						219,
						210,
						210,
						215,
						215,
						215
					],
					"projections_orig": [
						"219",
						"210",
						"210",
						"215",
						"215",
						"215"
					],
					"projections_percentage": [
						4.29,
						0,
						0,
						2.38,
						2.38,
						2.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4136
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 12
					},
					"classroomspace": 2.65,
					"enrolment": 409,
					"ligo": 0.65,
					"location": [
						151.609313552939,
						-32.9254684840409
					],
					"name": "Edgeworth Heights Public School",
					"playspace": 61.76,
					"projections": [
						295,
						409,
						370,
						375,
						375,
						375
					],
					"projections_orig": [
						"295",
						"409",
						"370",
						"375",
						"375",
						"375"
					],
					"projections_percentage": [
						-27.87,
						0,
						-9.54,
						-8.31,
						-8.31,
						-8.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4155
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.76,
					"enrolment": 241,
					"ligo": 0.66,
					"location": [
						151.653887452327,
						-32.9272821428591
					],
					"name": "Glendale East Public School",
					"playspace": 92.9,
					"projections": [
						160,
						241,
						210,
						210,
						210,
						210
					],
					"projections_orig": [
						"160",
						"241",
						"210",
						"210",
						"210",
						"210"
					],
					"projections_percentage": [
						-33.61,
						0,
						-12.86,
						-12.86,
						-12.86,
						-12.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4207
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.44,
					"enrolment": 285,
					"ligo": 0.42,
					"location": [
						151.681568986601,
						-32.9596546891916
					],
					"name": "Hillsborough Public School",
					"playspace": 47.11,
					"projections": [
						268,
						285,
						295,
						300,
						295,
						300
					],
					"projections_orig": [
						"268",
						"285",
						"295",
						"300",
						"295",
						"300"
					],
					"projections_percentage": [
						-5.96,
						0,
						3.51,
						5.26,
						3.51,
						5.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4318
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.7,
					"enrolment": 74,
					"ligo": 1,
					"location": [
						151.689069471013,
						-32.9348486169527
					],
					"name": "New Lambton Heights Infants School",
					"playspace": 61.86,
					"projections": [
						56,
						74,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"56",
						"74",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						-24.32,
						0,
						8.11,
						14.86,
						14.86,
						14.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5247
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.39,
					"enrolment": 164,
					"ligo": 0.68,
					"location": [
						151.665844475849,
						-32.9366534629972
					],
					"name": "Cardiff North Public School",
					"playspace": 154.98,
					"projections": [
						126,
						164,
						155,
						155,
						155,
						155
					],
					"projections_orig": [
						"126",
						"164",
						"155",
						"155",
						"155",
						"155"
					],
					"projections_percentage": [
						-23.17,
						0,
						-5.49,
						-5.49,
						-5.49,
						-5.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5260
				}
			],
			"uid": 10135
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 89
			},
			"enrolment": 1839,
			"level": "Secondary",
			"ligo": 0.74,
			"name": "Bathurst City Secondary",
			"playspace": 47.2,
			"projections": [
				1839,
				2160,
				2290,
				2345,
				2325
			],
			"projections_percentage": [
				0,
				17.46,
				24.52,
				27.51,
				26.43
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 49
					},
					"classroomspace": 3.48,
					"enrolment": 1071,
					"ligo": 0.68,
					"location": [
						149.569964273239,
						-33.4122712020023
					],
					"name": "Denison College of Secondary Education, Bathurst High Campus",
					"playspace": 24.11,
					"projections": [
						921,
						1071,
						1230,
						1305,
						1335,
						1330
					],
					"projections_orig": [
						"921",
						"1071",
						"1230",
						"1305",
						"1335",
						"1330"
					],
					"projections_percentage": [
						-14.01,
						0,
						14.85,
						21.85,
						24.65,
						24.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8103
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 40
					},
					"classroomspace": 3.6,
					"enrolment": 768,
					"ligo": 0.81,
					"location": [
						149.615434450582,
						-33.4116050059876
					],
					"name": "Denison College of Secondary Education, Kelso High Campus",
					"playspace": 70.3,
					"projections": [
						861,
						768,
						930,
						985,
						1010,
						995
					],
					"projections_orig": [
						"861",
						"768",
						"930",
						"985",
						"1010",
						"995"
					],
					"projections_percentage": [
						12.11,
						0,
						21.09,
						28.26,
						31.51,
						29.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8517
				}
			],
			"uid": 20001
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 103
			},
			"enrolment": 1143,
			"level": "Secondary",
			"ligo": 1,
			"name": "Broken Hill Secondary",
			"playspace": 102.16,
			"projections": [
				1143,
				1275,
				1275,
				1150,
				1000
			],
			"projections_percentage": [
				0,
				11.55,
				11.55,
				0.61,
				-12.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 5.15,
					"enrolment": 663,
					"ligo": 1,
					"location": [
						141.455509430076,
						-31.9600785498984
					],
					"name": "Broken Hill High School",
					"playspace": 60.48,
					"projections": [
						656,
						663,
						720,
						720,
						655,
						570
					],
					"projections_orig": [
						"656",
						"663",
						"720",
						"720",
						"655",
						"570"
					],
					"projections_percentage": [
						-1.06,
						0,
						8.6,
						8.6,
						-1.21,
						-14.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8105
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 7.34,
					"enrolment": 480,
					"ligo": 1,
					"location": [
						141.471929953901,
						-31.9361039154943
					],
					"name": "Willyama High School",
					"playspace": 143.83,
					"projections": [
						585,
						480,
						555,
						555,
						495,
						430
					],
					"projections_orig": [
						"585",
						"480",
						"555",
						"555",
						"495",
						"430"
					],
					"projections_percentage": [
						21.88,
						0,
						15.62,
						15.62,
						3.12,
						-10.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8491
				}
			],
			"uid": 20002
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 159
			},
			"enrolment": 2357,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Lake Illawarra Secondary",
			"playspace": 72.87,
			"projections": [
				2357,
				2555,
				2615,
				2630,
				2665
			],
			"projections_percentage": [
				0,
				8.4,
				10.95,
				11.58,
				13.07
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 54
					},
					"classroomspace": 3.76,
					"enrolment": 947,
					"ligo": 0.74,
					"location": [
						150.785581549329,
						-34.5013173440378
					],
					"name": "Dapto High School",
					"playspace": 85.92,
					"projections": [
						984,
						947,
						1035,
						1065,
						1075,
						1095
					],
					"projections_orig": [
						"984",
						"947",
						"1035",
						"1065",
						"1075",
						"1095"
					],
					"projections_percentage": [
						3.91,
						0,
						9.29,
						12.46,
						13.52,
						15.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8204
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 6.17,
					"enrolment": 608,
					"ligo": 0.84,
					"location": [
						150.804532573775,
						-34.4937545683395
					],
					"name": "Kanahooka High School",
					"playspace": 86.01,
					"projections": [
						641,
						608,
						660,
						670,
						670,
						685
					],
					"projections_orig": [
						"641",
						"608",
						"660",
						"670",
						"670",
						"685"
					],
					"projections_percentage": [
						5.43,
						0,
						8.55,
						10.2,
						10.2,
						12.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8489
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 46
					},
					"classroomspace": 4.18,
					"enrolment": 802,
					"ligo": 0.77,
					"location": [
						150.773674381241,
						-34.5757331672151
					],
					"name": "Albion Park High School",
					"playspace": 46.69,
					"projections": [
						952,
						802,
						860,
						880,
						885,
						885
					],
					"projections_orig": [
						"952",
						"802",
						"860",
						"880",
						"885",
						"885"
					],
					"projections_percentage": [
						18.7,
						0,
						7.23,
						9.73,
						10.35,
						10.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8586
				}
			],
			"uid": 20003
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 305
			},
			"enrolment": 4772,
			"level": "Secondary",
			"ligo": 0.68,
			"name": "Wollongong North",
			"playspace": 89.05,
			"projections": [
				4772,
				5085,
				5310,
				5460,
				5540
			],
			"projections_percentage": [
				0,
				6.56,
				11.27,
				14.42,
				16.09
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 48
					},
					"classroomspace": 3.14,
					"enrolment": 1160,
					"ligo": 0.33,
					"location": [
						150.889201987508,
						-34.4057672054305
					],
					"name": "Wollongong High School of the Performing Arts",
					"playspace": 44.69,
					"projections": [
						980,
						1160,
						1245,
						1310,
						1355,
						1375
					],
					"projections_orig": [
						"980",
						"1160",
						"1245",
						"1310",
						"1355",
						"1375"
					],
					"projections_percentage": [
						-15.52,
						0,
						7.33,
						12.93,
						16.81,
						18.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8143
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 8.6,
					"enrolment": 354,
					"ligo": 0.8,
					"location": [
						150.910803839896,
						-34.3762296105041
					],
					"name": "Corrimal High School",
					"playspace": 285.69,
					"projections": [
						496,
						354,
						455,
						475,
						485,
						490
					],
					"projections_orig": [
						"496",
						"354",
						"455",
						"475",
						"485",
						"490"
					],
					"projections_percentage": [
						40.11,
						0,
						28.53,
						34.18,
						37.01,
						38.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8191
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 4.56,
					"enrolment": 664,
					"ligo": 0.64,
					"location": [
						150.908844216827,
						-34.3447319731173
					],
					"name": "Woonona High School",
					"playspace": 86.11,
					"projections": [
						654,
						664,
						655,
						695,
						710,
						720
					],
					"projections_orig": [
						"654",
						"664",
						"655",
						"695",
						"710",
						"720"
					],
					"projections_percentage": [
						-1.51,
						0,
						-1.36,
						4.67,
						6.93,
						8.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8410
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 60
					},
					"classroomspace": 4.11,
					"enrolment": 962,
					"ligo": 0.6,
					"location": [
						150.888659028548,
						-34.4060499844733
					],
					"name": "Keira High School",
					"playspace": 51.85,
					"projections": [
						958,
						962,
						1050,
						1105,
						1140,
						1160
					],
					"projections_orig": [
						"958",
						"962",
						"1050",
						"1105",
						"1140",
						"1160"
					],
					"projections_percentage": [
						-0.42,
						0,
						9.15,
						14.86,
						18.5,
						20.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8541
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 4.31,
					"enrolment": 743,
					"ligo": 1,
					"location": [
						150.895789188923,
						-34.4185884250679
					],
					"name": "Smiths Hill High School",
					"playspace": 23.94,
					"projections": [
						759,
						743,
						745,
						745,
						745,
						745
					],
					"projections_orig": [
						"759",
						"743",
						"745",
						"745",
						"745",
						"745"
					],
					"projections_percentage": [
						2.15,
						0,
						0.27,
						0.27,
						0.27,
						0.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8542
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 4.2,
					"enrolment": 889,
					"ligo": 0.74,
					"location": [
						150.921880603601,
						-34.3363280131164
					],
					"name": "Bulli High School",
					"playspace": 42.02,
					"projections": [
						815,
						889,
						935,
						980,
						1025,
						1050
					],
					"projections_orig": [
						"815",
						"889",
						"935",
						"980",
						"1025",
						"1050"
					],
					"projections_percentage": [
						-8.32,
						0,
						5.17,
						10.24,
						15.3,
						18.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8878
				}
			],
			"uid": 20004
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 201
			},
			"enrolment": 2549,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Wollongong South",
			"playspace": 79.55,
			"projections": [
				2550,
				2870,
				2990,
				3075,
				3110
			],
			"projections_percentage": [
				0,
				12.55,
				17.25,
				20.59,
				21.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 4.92,
					"enrolment": 707,
					"ligo": 0.62,
					"location": [
						150.852720200109,
						-34.4798550580354
					],
					"name": "Illawarra Sports High School",
					"playspace": 62.54,
					"projections": [
						902,
						707,
						770,
						800,
						820,
						830
					],
					"projections_orig": [
						"902",
						"707",
						"770",
						"800",
						"820",
						"830"
					],
					"projections_percentage": [
						27.58,
						0,
						8.91,
						13.15,
						15.98,
						17.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8205
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 39
					},
					"classroomspace": 11.31,
					"enrolment": 252,
					"ligo": 1,
					"location": [
						150.913492460957,
						-34.4900060058424
					],
					"name": "Five Islands Secondary College",
					"playspace": 94.49,
					"projections": [
						307,
						253,
						315,
						325,
						335,
						335
					],
					"projections_orig": [
						"307",
						"253",
						"315",
						"325",
						"335",
						"335"
					],
					"projections_percentage": [
						21.34,
						0,
						24.51,
						28.46,
						32.41,
						32.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8373
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 49
					},
					"classroomspace": 3.65,
					"enrolment": 964,
					"ligo": 0.74,
					"location": [
						150.856278745131,
						-34.4397576125448
					],
					"name": "Figtree High School",
					"playspace": 59.12,
					"projections": [
						1086,
						964,
						1120,
						1175,
						1215,
						1230
					],
					"projections_orig": [
						"1086",
						"964",
						"1120",
						"1175",
						"1215",
						"1230"
					],
					"projections_percentage": [
						12.66,
						0,
						16.18,
						21.89,
						26.04,
						27.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8449
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 58
					},
					"classroomspace": 5.61,
					"enrolment": 626,
					"ligo": 0.76,
					"location": [
						150.877479407304,
						-34.4800585262436
					],
					"name": "Warrawong High School",
					"playspace": 102.03,
					"projections": [
						550,
						626,
						665,
						690,
						705,
						715
					],
					"projections_orig": [
						"550",
						"626",
						"665",
						"690",
						"705",
						"715"
					],
					"projections_percentage": [
						-12.14,
						0,
						6.23,
						10.22,
						12.62,
						14.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8480
				}
			],
			"uid": 20005
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 161
			},
			"enrolment": 2631,
			"level": "Secondary",
			"ligo": 0.77,
			"name": "Oak Flats",
			"playspace": 53.3,
			"projections": [
				2631,
				2685,
				2795,
				2795,
				2850
			],
			"projections_percentage": [
				0,
				2.05,
				6.23,
				6.23,
				8.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 60
					},
					"classroomspace": 3.08,
					"enrolment": 1237,
					"ligo": 0.79,
					"location": [
						150.858254269675,
						-34.5650355688858
					],
					"name": "Warilla High School",
					"playspace": 21.84,
					"projections": [
						1220,
						1237,
						1190,
						1245,
						1240,
						1260
					],
					"projections_orig": [
						"1220",
						"1237",
						"1190",
						"1245",
						"1240",
						"1260"
					],
					"projections_percentage": [
						-1.37,
						0,
						-3.8,
						0.65,
						0.24,
						1.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8418
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 6.04,
					"enrolment": 596,
					"ligo": 0.8,
					"location": [
						150.851818513684,
						-34.5407336794093
					],
					"name": "Lake Illawarra High School",
					"playspace": 70.18,
					"projections": [
						728,
						596,
						655,
						685,
						690,
						705
					],
					"projections_orig": [
						"728",
						"596",
						"655",
						"685",
						"690",
						"705"
					],
					"projections_percentage": [
						22.15,
						0,
						9.9,
						14.93,
						15.77,
						18.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8474
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 44
					},
					"classroomspace": 4.18,
					"enrolment": 798,
					"ligo": 0.73,
					"location": [
						150.832005263296,
						-34.5599228231219
					],
					"name": "Oak Flats High School",
					"playspace": 67.88,
					"projections": [
						824,
						798,
						840,
						865,
						865,
						885
					],
					"projections_orig": [
						"824",
						"798",
						"840",
						"865",
						"865",
						"885"
					],
					"projections_percentage": [
						3.26,
						0,
						5.26,
						8.4,
						8.4,
						10.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8906
				}
			],
			"uid": 20006
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 241
			},
			"enrolment": 3868,
			"level": "Secondary",
			"ligo": 0.63,
			"name": "Sydney Secondary",
			"playspace": 27.97,
			"projections": [
				3868,
				4175,
				4585,
				4730,
				4765
			],
			"projections_percentage": [
				0,
				7.94,
				18.54,
				22.29,
				23.19
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 58
					},
					"classroomspace": 11.94,
					"enrolment": 312,
					"ligo": 0.63,
					"location": [
						151.200688504191,
						-33.9275785951026
					],
					"name": "J J Cahill Memorial High School",
					"playspace": 64.67,
					"projections": [
						360,
						312,
						385,
						465,
						490,
						505
					],
					"projections_orig": [
						"360",
						"312",
						"385",
						"465",
						"490",
						"505"
					],
					"projections_percentage": [
						15.38,
						0,
						23.4,
						49.04,
						57.05,
						61.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8263
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 37
					},
					"classroomspace": 3.5,
					"enrolment": 773,
					"ligo": 0.54,
					"location": [
						151.169230477324,
						-33.8581850892366
					],
					"name": "Sydney Secondary College Balmain Campus",
					"playspace": 27.89,
					"projections": [
						613,
						773,
						990,
						1055,
						1100,
						1095
					],
					"projections_orig": [
						"613",
						"773",
						"990",
						"1055",
						"1100",
						"1095"
					],
					"projections_percentage": [
						-20.7,
						0,
						28.07,
						36.48,
						42.3,
						41.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8484
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.19,
					"enrolment": 950,
					"ligo": 0.36,
					"location": [
						151.158667114161,
						-33.8795888427483
					],
					"name": "Sydney Secondary College Leichhardt Campus",
					"playspace": 7.39,
					"projections": [
						730,
						950,
						800,
						905,
						940,
						910
					],
					"projections_orig": [
						"730",
						"950",
						"800",
						"905",
						"940",
						"910"
					],
					"projections_percentage": [
						-23.16,
						0,
						-15.79,
						-4.74,
						-1.05,
						-4.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8507
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 37
					},
					"classroomspace": 3.71,
					"enrolment": 700,
					"ligo": 0.57,
					"location": [
						151.188013233796,
						-33.8756346209741
					],
					"name": "Sydney Secondary College Blackwattle Bay Campus",
					"playspace": 27.92,
					"projections": [
						657,
						700,
						825,
						960,
						980,
						990
					],
					"projections_orig": [
						"657",
						"700",
						"825",
						"960",
						"980",
						"990"
					],
					"projections_percentage": [
						-6.14,
						0,
						17.86,
						37.14,
						40,
						41.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8539
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 61
					},
					"classroomspace": 3.33,
					"enrolment": 1133,
					"ligo": 0.7,
					"location": [
						151.275456977484,
						-33.8787414185695
					],
					"name": "Rose Bay Secondary College",
					"playspace": 11.96,
					"projections": [
						969,
						1133,
						1175,
						1200,
						1220,
						1265
					],
					"projections_orig": [
						"969",
						"1133",
						"1175",
						"1200",
						"1220",
						"1265"
					],
					"projections_percentage": [
						-14.47,
						0,
						3.71,
						5.91,
						7.68,
						11.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8555
				}
			],
			"uid": 20007
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 214
			},
			"enrolment": 3414,
			"level": "Secondary",
			"ligo": 1,
			"name": "Sydney Specialist Secondary",
			"playspace": 17.74,
			"projections": [
				3414,
				3530,
				3620,
				3645,
				3675
			],
			"projections_percentage": [
				0,
				3.4,
				6.03,
				6.77,
				7.64
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 58
					},
					"classroomspace": 2.96,
					"enrolment": 1208,
					"ligo": 1,
					"location": [
						151.218306488928,
						-33.8927839368237
					],
					"name": "Sydney Boys High School",
					"playspace": 8.42,
					"projections": [
						1184,
						1208,
						1210,
						1210,
						1210,
						1210
					],
					"projections_orig": [
						"1184",
						"1208",
						"1210",
						"1210",
						"1210",
						"1210"
					],
					"projections_percentage": [
						-1.99,
						0,
						0.17,
						0.17,
						0.17,
						0.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8137
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.31,
					"enrolment": 936,
					"ligo": 1,
					"location": [
						151.220506645579,
						-33.8944049217764
					],
					"name": "Sydney Girls High School",
					"playspace": 19.75,
					"projections": [
						939,
						936,
						935,
						935,
						935,
						935
					],
					"projections_orig": [
						"939",
						"936",
						"935",
						"935",
						"935",
						"935"
					],
					"projections_percentage": [
						0.32,
						0,
						-0.11,
						-0.11,
						-0.11,
						-0.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8138
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 5.53,
					"enrolment": 156,
					"ligo": 1,
					"location": [
						151.21411255871,
						-33.8629871867641
					],
					"name": "Conservatorium High School",
					"playspace": 21.13,
					"projections": [
						159,
						156,
						175,
						210,
						220,
						235
					],
					"projections_orig": [
						"159",
						"156",
						"175",
						"210",
						"220",
						"235"
					],
					"projections_percentage": [
						1.92,
						0,
						12.18,
						34.62,
						41.03,
						50.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8147
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 9.62,
					"enrolment": 171,
					"ligo": 1,
					"location": [
						151.205608448478,
						-33.8887012865309
					],
					"name": "Cleveland Street Intensive English High School",
					"playspace": 11.61,
					"projections": [
						196,
						171,
						265,
						320,
						335,
						350
					],
					"projections_orig": [
						"196",
						"171",
						"265",
						"320",
						"335",
						"350"
					],
					"projections_percentage": [
						14.62,
						0,
						54.97,
						87.13,
						95.91,
						104.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8288
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 61
					},
					"classroomspace": 4,
					"enrolment": 943,
					"ligo": 1,
					"location": [
						151.15311425248,
						-33.8891124089209
					],
					"name": "Fort Street High School",
					"playspace": 27.81,
					"projections": [
						930,
						943,
						945,
						945,
						945,
						945
					],
					"projections_orig": [
						"930",
						"943",
						"945",
						"945",
						"945",
						"945"
					],
					"projections_percentage": [
						-1.38,
						0,
						0.21,
						0.21,
						0.21,
						0.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8504
				}
			],
			"uid": 20008
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 223
			},
			"enrolment": 2414,
			"level": "Secondary",
			"ligo": 0.46,
			"name": "Randwick Secondary",
			"playspace": 51.21,
			"projections": [
				2414,
				3545,
				3970,
				4100,
				4200
			],
			"projections_percentage": [
				0,
				46.85,
				64.46,
				69.84,
				73.99
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 54
					},
					"classroomspace": 5.73,
					"enrolment": 640,
					"ligo": 0.41,
					"location": [
						151.23860305479,
						-33.9247664276705
					],
					"name": "Randwick Boys High School",
					"playspace": 32.95,
					"projections": [
						642,
						640,
						1000,
						1090,
						1125,
						1165
					],
					"projections_orig": [
						"642",
						"640",
						"1000",
						"1090",
						"1125",
						"1165"
					],
					"projections_percentage": [
						0.31,
						0,
						56.25,
						70.31,
						75.78,
						82.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8161
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.74,
					"enrolment": 997,
					"ligo": 0.38,
					"location": [
						151.239741992317,
						-33.9214223262121
					],
					"name": "Randwick Girls High School",
					"playspace": 20.33,
					"projections": [
						900,
						997,
						1410,
						1540,
						1585,
						1650
					],
					"projections_orig": [
						"900",
						"997",
						"1410",
						"1540",
						"1585",
						"1650"
					],
					"projections_percentage": [
						-9.73,
						0,
						41.42,
						54.46,
						58.98,
						65.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8220
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 12.39,
					"enrolment": 259,
					"ligo": 0.59,
					"location": [
						151.245272577184,
						-33.9650293579162
					],
					"name": "Matraville Sports High School",
					"playspace": 98.06,
					"projections": [
						300,
						259,
						360,
						445,
						470,
						465
					],
					"projections_orig": [
						"300",
						"259",
						"360",
						"445",
						"470",
						"465"
					],
					"projections_percentage": [
						15.83,
						0,
						39,
						71.81,
						81.47,
						79.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8249
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 7.46,
					"enrolment": 518,
					"ligo": 0.44,
					"location": [
						151.234894213603,
						-33.9450594274324
					],
					"name": "South Sydney High School",
					"playspace": 53.49,
					"projections": [
						676,
						518,
						775,
						895,
						920,
						920
					],
					"projections_orig": [
						"676",
						"518",
						"775",
						"895",
						"920",
						"920"
					],
					"projections_percentage": [
						30.5,
						0,
						49.61,
						72.78,
						77.61,
						77.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8545
				}
			],
			"uid": 20009
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 186
			},
			"enrolment": 3137,
			"level": "Secondary",
			"ligo": 0.38,
			"name": "Marrickville Secondary",
			"playspace": 31.43,
			"projections": [
				3137,
				3130,
				3465,
				3770,
				4000
			],
			"projections_percentage": [
				0,
				-0.22,
				10.46,
				20.18,
				27.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 40
					},
					"classroomspace": 2.78,
					"enrolment": 959,
					"ligo": 0.41,
					"location": [
						151.161909185031,
						-33.9194212366912
					],
					"name": "Tempe High School",
					"playspace": 28.6,
					"projections": [
						914,
						959,
						1035,
						1190,
						1325,
						1425
					],
					"projections_orig": [
						"914",
						"959",
						"1035",
						"1190",
						"1325",
						"1425"
					],
					"projections_percentage": [
						-4.69,
						0,
						7.92,
						24.09,
						38.16,
						48.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8506
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 45
					},
					"classroomspace": 3.35,
					"enrolment": 1050,
					"ligo": 0.41,
					"location": [
						151.177927968251,
						-33.8992682088216
					],
					"name": "Newtown High School of Performing Arts",
					"playspace": 17.93,
					"projections": [
						1007,
						1050,
						955,
						1015,
						1065,
						1120
					],
					"projections_orig": [
						"1007",
						"1050",
						"955",
						"1015",
						"1065",
						"1120"
					],
					"projections_percentage": [
						-4.1,
						0,
						-9.05,
						-3.33,
						1.43,
						6.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8530
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 10.15,
					"enrolment": 353,
					"ligo": 0.48,
					"location": [
						151.156340125709,
						-33.906652783001
					],
					"name": "Marrickville High School",
					"playspace": 61.14,
					"projections": [
						323,
						353,
						365,
						380,
						405,
						420
					],
					"projections_orig": [
						"323",
						"353",
						"365",
						"380",
						"405",
						"420"
					],
					"projections_percentage": [
						-8.5,
						0,
						3.4,
						7.65,
						14.73,
						18.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8540
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 3.38,
					"enrolment": 775,
					"ligo": 0.21,
					"location": [
						151.14483650357,
						-33.9032713525243
					],
					"name": "Dulwich High School of Visual Arts and Design",
					"playspace": 18.06,
					"projections": [
						624,
						775,
						775,
						880,
						975,
						1035
					],
					"projections_orig": [
						"624",
						"775",
						"775",
						"880",
						"975",
						"1035"
					],
					"projections_percentage": [
						-19.48,
						0,
						0,
						13.55,
						25.81,
						33.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8833
				}
			],
			"uid": 20010
		},
		{
			"classrooms": {
				"demountable": 25,
				"permanent": 293
			},
			"enrolment": 5800,
			"level": "Secondary",
			"ligo": 0.58,
			"name": "Strathfield Secondary",
			"playspace": 21.02,
			"projections": [
				5800,
				6500,
				7870,
				9035,
				9800
			],
			"projections_percentage": [
				0,
				12.07,
				35.69,
				55.78,
				68.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 49
					},
					"classroomspace": 3.26,
					"enrolment": 1159,
					"ligo": 0.56,
					"location": [
						151.077719776134,
						-33.8666185742818
					],
					"name": "Homebush Boys High School",
					"playspace": 15.96,
					"projections": [
						1314,
						1159,
						1185,
						1535,
						1880,
						2080
					],
					"projections_orig": [
						"1314",
						"1159",
						"1185",
						"1535",
						"1880",
						"2080"
					],
					"projections_percentage": [
						13.37,
						0,
						2.24,
						32.44,
						62.21,
						79.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8151
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 53
					},
					"classroomspace": 3.04,
					"enrolment": 1116,
					"ligo": 0.59,
					"location": [
						151.113084533084,
						-33.8759459776366
					],
					"name": "Burwood Girls High School",
					"playspace": 15.79,
					"projections": [
						1108,
						1116,
						1210,
						1405,
						1595,
						1785
					],
					"projections_orig": [
						"1108",
						"1116",
						"1210",
						"1405",
						"1595",
						"1785"
					],
					"projections_percentage": [
						-0.72,
						0,
						8.42,
						25.9,
						42.92,
						59.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8152
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 64
					},
					"classroomspace": 3.42,
					"enrolment": 1130,
					"ligo": 0.62,
					"location": [
						151.085227092165,
						-33.873106163966
					],
					"name": "Strathfield Girls High School",
					"playspace": 14.11,
					"projections": [
						1135,
						1130,
						1305,
						1600,
						1790,
						1885
					],
					"projections_orig": [
						"1135",
						"1130",
						"1305",
						"1600",
						"1790",
						"1885"
					],
					"projections_percentage": [
						0.44,
						0,
						15.49,
						41.59,
						58.41,
						66.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8169
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 4.56,
					"enrolment": 557,
					"ligo": 0.22,
					"location": [
						151.071879233123,
						-33.8855666852136
					],
					"name": "Strathfield South High School",
					"playspace": 46.2,
					"projections": [
						682,
						557,
						715,
						795,
						860,
						910
					],
					"projections_orig": [
						"682",
						"557",
						"715",
						"795",
						"860",
						"910"
					],
					"projections_percentage": [
						22.44,
						0,
						28.37,
						42.73,
						54.4,
						63.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8252
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 45
					},
					"classroomspace": 3.01,
					"enrolment": 1137,
					"ligo": 0.72,
					"location": [
						151.108829947127,
						-33.8646867339216
					],
					"name": "Concord High School",
					"playspace": 18.33,
					"projections": [
						852,
						1137,
						1310,
						1650,
						1920,
						2055
					],
					"projections_orig": [
						"852",
						"1137",
						"1310",
						"1650",
						"1920",
						"2055"
					],
					"projections_percentage": [
						-25.07,
						0,
						15.22,
						45.12,
						68.87,
						80.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8535
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 3.42,
					"enrolment": 701,
					"ligo": 0.34,
					"location": [
						151.1289155085,
						-33.8902041783211
					],
					"name": "Ashfield Boys High School",
					"playspace": 15.73,
					"projections": [
						705,
						701,
						775,
						885,
						990,
						1085
					],
					"projections_orig": [
						"705",
						"701",
						"775",
						"885",
						"990",
						"1085"
					],
					"projections_percentage": [
						0.57,
						0,
						10.56,
						26.25,
						41.23,
						54.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8832
				}
			],
			"uid": 20011
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 200
			},
			"enrolment": 3407,
			"level": "Secondary",
			"ligo": 0.55,
			"name": "Ryde Secondary",
			"playspace": 42.89,
			"projections": [
				3407,
				3755,
				4060,
				4335,
				4535
			],
			"projections_percentage": [
				0,
				10.21,
				19.17,
				27.24,
				33.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 5.38,
					"enrolment": 619,
					"ligo": 0.48,
					"location": [
						151.146971921999,
						-33.832750176133
					],
					"name": "Hunters Hill High School",
					"playspace": 77.78,
					"projections": [
						562,
						619,
						765,
						795,
						820,
						860
					],
					"projections_orig": [
						"562",
						"619",
						"765",
						"795",
						"820",
						"860"
					],
					"projections_percentage": [
						-9.21,
						0,
						23.59,
						28.43,
						32.47,
						38.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8207
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 4.29,
					"enrolment": 787,
					"ligo": 0.65,
					"location": [
						151.069629305768,
						-33.8037708403054
					],
					"name": "Marsden High School",
					"playspace": 50.9,
					"projections": [
						668,
						787,
						765,
						820,
						890,
						925
					],
					"projections_orig": [
						"668",
						"787",
						"765",
						"820",
						"890",
						"925"
					],
					"projections_percentage": [
						-15.12,
						0,
						-2.8,
						4.19,
						13.09,
						17.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8225
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 48
					},
					"classroomspace": 3.29,
					"enrolment": 952,
					"ligo": 0.51,
					"location": [
						151.141023721512,
						-33.839937829506
					],
					"name": "Riverside Girls High School",
					"playspace": 29.64,
					"projections": [
						947,
						952,
						1025,
						1115,
						1225,
						1285
					],
					"projections_orig": [
						"947",
						"952",
						"1025",
						"1115",
						"1225",
						"1285"
					],
					"projections_percentage": [
						-0.53,
						0,
						7.67,
						17.12,
						28.68,
						34.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8243
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 48
					},
					"classroomspace": 3.47,
					"enrolment": 1049,
					"ligo": 0.55,
					"location": [
						151.117654271069,
						-33.8135014093624
					],
					"name": "Ryde Secondary College",
					"playspace": 13.25,
					"projections": [
						1031,
						1049,
						1200,
						1330,
						1400,
						1465
					],
					"projections_orig": [
						"1031",
						"1049",
						"1200",
						"1330",
						"1400",
						"1465"
					],
					"projections_percentage": [
						-1.72,
						0,
						14.39,
						26.79,
						33.46,
						39.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8415
				}
			],
			"uid": 20012
		},
		{
			"classrooms": {
				"demountable": 53,
				"permanent": 438
			},
			"enrolment": 9440,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Chatswood Secondary",
			"playspace": 16.41,
			"projections": [
				9439,
				11135,
				11600,
				11905,
				12155
			],
			"projections_percentage": [
				0,
				17.97,
				22.89,
				26.13,
				28.77
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 3.46,
					"enrolment": 927,
					"ligo": 1,
					"location": [
						151.207577526963,
						-33.8288050762772
					],
					"name": "North Sydney Boys High School",
					"playspace": 15.2,
					"projections": [
						912,
						927,
						925,
						925,
						925,
						925
					],
					"projections_orig": [
						"912",
						"927",
						"925",
						"925",
						"925",
						"925"
					],
					"projections_percentage": [
						-1.62,
						0,
						-0.22,
						-0.22,
						-0.22,
						-0.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8132
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 47
					},
					"classroomspace": 3.21,
					"enrolment": 923,
					"ligo": 1,
					"location": [
						151.203043679436,
						-33.8296142368394
					],
					"name": "North Sydney Girls High School",
					"playspace": 8.8,
					"projections": [
						930,
						923,
						925,
						925,
						925,
						925
					],
					"projections_orig": [
						"930",
						"923",
						"925",
						"925",
						"925",
						"925"
					],
					"projections_percentage": [
						0.76,
						0,
						0.22,
						0.22,
						0.22,
						0.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8133
				},
				{
					"classrooms": {
						"demountable": 14,
						"permanent": 32
					},
					"classroomspace": 2.6,
					"enrolment": 968,
					"ligo": 0.49,
					"location": [
						151.199698636661,
						-33.8034673947306
					],
					"name": "Willoughby Girls High School",
					"playspace": 9.2,
					"projections": [
						925,
						968,
						1200,
						1230,
						1260,
						1305
					],
					"projections_orig": [
						"925",
						"968",
						"1200",
						"1230",
						"1260",
						"1305"
					],
					"projections_percentage": [
						-4.44,
						0,
						23.97,
						27.07,
						30.17,
						34.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8159
				},
				{
					"classrooms": {
						"demountable": 22,
						"permanent": 60
					},
					"classroomspace": 4,
					"enrolment": 1397,
					"ligo": 0.65,
					"location": [
						151.175383309832,
						-33.7989162504694
					],
					"name": "Chatswood High School",
					"playspace": 26.05,
					"projections": [
						1263,
						1397,
						1790,
						1860,
						1930,
						1970
					],
					"projections_orig": [
						"1263",
						"1397",
						"1790",
						"1860",
						"1930",
						"1970"
					],
					"projections_percentage": [
						-9.59,
						0,
						28.13,
						33.14,
						38.15,
						41.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8232
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 2.75,
					"enrolment": 1054,
					"ligo": 0.68,
					"location": [
						151.244044386698,
						-33.8297364378348
					],
					"name": "Mosman High School",
					"playspace": 5.27,
					"projections": [
						887,
						1054,
						1155,
						1180,
						1155,
						1170
					],
					"projections_orig": [
						"887",
						"1054",
						"1155",
						"1180",
						"1155",
						"1170"
					],
					"projections_percentage": [
						-15.84,
						0,
						9.58,
						11.95,
						9.58,
						11.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8326
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.65,
					"enrolment": 947,
					"ligo": 0.67,
					"location": [
						151.167377186253,
						-33.7400811143014
					],
					"name": "St Ives High School",
					"playspace": 44.48,
					"projections": [
						819,
						947,
						1115,
						1195,
						1245,
						1270
					],
					"projections_orig": [
						"819",
						"947",
						"1115",
						"1195",
						"1245",
						"1270"
					],
					"projections_percentage": [
						-13.52,
						0,
						17.74,
						26.19,
						31.47,
						34.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8400
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 54
					},
					"classroomspace": 3.2,
					"enrolment": 1256,
					"ligo": 0.77,
					"location": [
						151.113062400851,
						-33.7563852624068
					],
					"name": "Turramurra High School",
					"playspace": 21.09,
					"projections": [
						1199,
						1256,
						1405,
						1500,
						1535,
						1565
					],
					"projections_orig": [
						"1199",
						"1256",
						"1405",
						"1500",
						"1535",
						"1565"
					],
					"projections_percentage": [
						-4.54,
						0,
						11.86,
						19.43,
						22.21,
						24.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8435
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 62
					},
					"classroomspace": 2.8,
					"enrolment": 1598,
					"ligo": 0.85,
					"location": [
						151.174478487807,
						-33.7555601678891
					],
					"name": "Killara High School",
					"playspace": 14.72,
					"projections": [
						1527,
						1597,
						1815,
						1920,
						2035,
						2085
					],
					"projections_orig": [
						"1527",
						"1597",
						"1815",
						"1920",
						"2035",
						"2085"
					],
					"projections_percentage": [
						-4.38,
						0,
						13.65,
						20.23,
						27.43,
						30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8457
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.68,
					"enrolment": 370,
					"ligo": 0.61,
					"location": [
						151.203253693954,
						-33.8313043057769
					],
					"name": "Cammeraygal High School",
					"playspace": 2.89,
					"projections": [
						0,
						370,
						805,
						865,
						895,
						940
					],
					"projections_orig": [
						"0",
						"370",
						"805",
						"865",
						"895",
						"940"
					],
					"projections_percentage": [
						-100,
						0,
						117.57,
						133.78,
						141.89,
						154.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8910
				}
			],
			"uid": 20013
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 555
			},
			"enrolment": 9258,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Northern Beaches Secondary",
			"playspace": 45.23,
			"projections": [
				9258,
				9490,
				9730,
				10060,
				10220
			],
			"projections_percentage": [
				0,
				2.51,
				5.1,
				8.66,
				10.39
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 3.67,
					"enrolment": 853,
					"ligo": 0.4,
					"location": [
						151.230709494951,
						-33.7494939999734
					],
					"name": "The Forest High School",
					"playspace": 54.91,
					"projections": [
						749,
						853,
						845,
						855,
						885,
						910
					],
					"projections_orig": [
						"749",
						"853",
						"845",
						"855",
						"885",
						"910"
					],
					"projections_percentage": [
						-12.19,
						0,
						-0.94,
						0.23,
						3.75,
						6.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8372
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 3.11,
					"enrolment": 1046,
					"ligo": 0.62,
					"location": [
						151.303841034416,
						-33.6689861602621
					],
					"name": "Pittwater High School",
					"playspace": 45.23,
					"projections": [
						927,
						1046,
						1030,
						1125,
						1215,
						1245
					],
					"projections_orig": [
						"927",
						"1046",
						"1030",
						"1125",
						"1215",
						"1245"
					],
					"projections_percentage": [
						-11.38,
						0,
						-1.53,
						7.55,
						16.16,
						19.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8379
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.5,
					"enrolment": 910,
					"ligo": 0.57,
					"location": [
						151.21651059955,
						-33.7719181532549
					],
					"name": "Killarney Heights High School",
					"playspace": 24.3,
					"projections": [
						953,
						911,
						1030,
						1065,
						1090,
						1110
					],
					"projections_orig": [
						"953",
						"911",
						"1030",
						"1065",
						"1090",
						"1110"
					],
					"projections_percentage": [
						4.61,
						0,
						13.06,
						16.9,
						19.65,
						21.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8422
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 56
					},
					"classroomspace": 4.93,
					"enrolment": 717,
					"ligo": 0.89,
					"location": [
						151.335113055556,
						-33.632148696336
					],
					"name": "Barrenjoey High School",
					"playspace": 39.38,
					"projections": [
						642,
						717,
						660,
						680,
						705,
						730
					],
					"projections_orig": [
						"642",
						"717",
						"660",
						"680",
						"705",
						"730"
					],
					"projections_percentage": [
						-10.46,
						0,
						-7.95,
						-5.16,
						-1.67,
						1.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8454
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.34,
					"enrolment": 850,
					"ligo": 0.59,
					"location": [
						151.204323487698,
						-33.7441301478641
					],
					"name": "Davidson High School",
					"playspace": 45.39,
					"projections": [
						772,
						851,
						900,
						945,
						1010,
						1060
					],
					"projections_orig": [
						"772",
						"851",
						"900",
						"945",
						"1010",
						"1060"
					],
					"projections_percentage": [
						-9.28,
						0,
						5.76,
						11.05,
						18.68,
						24.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8479
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 60
					},
					"classroomspace": 7.49,
					"enrolment": 536,
					"ligo": 0.9,
					"location": [
						151.282908132875,
						-33.7374270898842
					],
					"name": "Northern Beaches Secondary College Cromer Campus",
					"playspace": 76.78,
					"projections": [
						721,
						535,
						650,
						660,
						680,
						690
					],
					"projections_orig": [
						"721",
						"535",
						"650",
						"660",
						"680",
						"690"
					],
					"projections_percentage": [
						34.77,
						0,
						21.5,
						23.36,
						27.1,
						28.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8511
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 4.36,
					"enrolment": 809,
					"ligo": 0.6,
					"location": [
						151.297538644626,
						-33.6998746635036
					],
					"name": "Narrabeen Sports High School",
					"playspace": 68.42,
					"projections": [
						384,
						808,
						860,
						910,
						950,
						950
					],
					"projections_orig": [
						"384",
						"808",
						"860",
						"910",
						"950",
						"950"
					],
					"projections_percentage": [
						-52.48,
						0,
						6.44,
						12.62,
						17.57,
						17.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8512
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 4,
					"enrolment": 788,
					"ligo": 1,
					"location": [
						151.280812082538,
						-33.7635690877234
					],
					"name": "Northern Beaches Secondary College Manly Campus",
					"playspace": 60.25,
					"projections": [
						797,
						788,
						790,
						790,
						790,
						790
					],
					"projections_orig": [
						"797",
						"788",
						"790",
						"790",
						"790",
						"790"
					],
					"projections_percentage": [
						1.14,
						0,
						0.25,
						0.25,
						0.25,
						0.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8567
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 4.08,
					"enrolment": 622,
					"ligo": 1,
					"location": [
						151.28049654696,
						-33.7685197940452
					],
					"name": "Northern Beaches Secondary College Freshwater Senior Campus",
					"playspace": 62.78,
					"projections": [
						643,
						622,
						680,
						675,
						675,
						665
					],
					"projections_orig": [
						"643",
						"622",
						"680",
						"675",
						"675",
						"665"
					],
					"projections_percentage": [
						3.38,
						0,
						9.32,
						8.52,
						8.52,
						6.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8568
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 52
					},
					"classroomspace": 2.92,
					"enrolment": 1312,
					"ligo": 1,
					"location": [
						151.271638447539,
						-33.7814287471044
					],
					"name": "Northern Beaches Secondary College Mackellar Girls Campus",
					"playspace": 10.48,
					"projections": [
						1208,
						1312,
						1290,
						1275,
						1305,
						1305
					],
					"projections_orig": [
						"1208",
						"1312",
						"1290",
						"1275",
						"1305",
						"1305"
					],
					"projections_percentage": [
						-7.93,
						0,
						-1.68,
						-2.82,
						-0.53,
						-0.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8831
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 3.38,
					"enrolment": 815,
					"ligo": 1,
					"location": [
						151.255199410975,
						-33.7966281210235
					],
					"name": "Northern Beaches Secondary College Balgowlah Boys Campus",
					"playspace": 9.65,
					"projections": [
						534,
						815,
						755,
						750,
						755,
						765
					],
					"projections_orig": [
						"534",
						"815",
						"755",
						"750",
						"755",
						"765"
					],
					"projections_percentage": [
						-34.48,
						0,
						-7.36,
						-7.98,
						-7.36,
						-6.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8851
				}
			],
			"uid": 20014
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 211
			},
			"enrolment": 3526,
			"level": "Secondary",
			"ligo": 0.73,
			"name": "Ku-Ring-Gai Secondary",
			"playspace": 49.93,
			"projections": [
				3526,
				3755,
				4025,
				4130,
				4190
			],
			"projections_percentage": [
				0,
				6.49,
				14.15,
				17.13,
				18.83
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 44
					},
					"classroomspace": 3.69,
					"enrolment": 733,
					"ligo": 1,
					"location": [
						151.101452907121,
						-33.7058285855033
					],
					"name": "Hornsby Girls High School",
					"playspace": 24.8,
					"projections": [
						729,
						733,
						735,
						735,
						735,
						735
					],
					"projections_orig": [
						"729",
						"733",
						"735",
						"735",
						"735",
						"735"
					],
					"projections_percentage": [
						-0.55,
						0,
						0.27,
						0.27,
						0.27,
						0.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8120
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 42
					},
					"classroomspace": 3.99,
					"enrolment": 755,
					"ligo": 1,
					"location": [
						151.100621663901,
						-33.7228386635394
					],
					"name": "Normanhurst Boys High School",
					"playspace": 58.51,
					"projections": [
						733,
						755,
						755,
						755,
						755,
						755
					],
					"projections_orig": [
						"733",
						"755",
						"755",
						"755",
						"755",
						"755"
					],
					"projections_percentage": [
						-2.91,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8211
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 37
					},
					"classroomspace": 3.92,
					"enrolment": 833,
					"ligo": 0.54,
					"location": [
						151.112055581737,
						-33.6906835283493
					],
					"name": "Asquith Girls High School",
					"playspace": 33.8,
					"projections": [
						952,
						833,
						985,
						1125,
						1185,
						1220
					],
					"projections_orig": [
						"952",
						"833",
						"985",
						"1125",
						"1185",
						"1220"
					],
					"projections_percentage": [
						14.29,
						0,
						18.25,
						35.05,
						42.26,
						46.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8222
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 38
					},
					"classroomspace": 4.26,
					"enrolment": 608,
					"ligo": 0.54,
					"location": [
						151.103644812999,
						-33.6922378899317
					],
					"name": "Asquith Boys High School",
					"playspace": 46.28,
					"projections": [
						586,
						608,
						635,
						735,
						765,
						775
					],
					"projections_orig": [
						"586",
						"608",
						"635",
						"735",
						"765",
						"775"
					],
					"projections_percentage": [
						-3.62,
						0,
						4.44,
						20.89,
						25.82,
						27.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8245
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 5.01,
					"enrolment": 597,
					"ligo": 0.57,
					"location": [
						151.152269866045,
						-33.6910957923245
					],
					"name": "Ku-ring-gai High School",
					"playspace": 86.24,
					"projections": [
						537,
						597,
						645,
						675,
						690,
						705
					],
					"projections_orig": [
						"537",
						"597",
						"645",
						"675",
						"690",
						"705"
					],
					"projections_percentage": [
						-10.05,
						0,
						8.04,
						13.07,
						15.58,
						18.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8416
				}
			],
			"uid": 20015
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 266
			},
			"enrolment": 4620,
			"level": "Secondary",
			"ligo": 0.56,
			"name": "Sutherland Secondary",
			"playspace": 43.59,
			"projections": [
				4619,
				4535,
				4900,
				5290,
				5485
			],
			"projections_percentage": [
				0,
				-1.82,
				6.08,
				14.53,
				18.75
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 2.76,
					"enrolment": 1198,
					"ligo": 0.57,
					"location": [
						151.095591293342,
						-34.0334076255913
					],
					"name": "Port Hacking High School",
					"playspace": 42.62,
					"projections": [
						1090,
						1198,
						1155,
						1230,
						1370,
						1440
					],
					"projections_orig": [
						"1090",
						"1198",
						"1155",
						"1230",
						"1370",
						"1440"
					],
					"projections_percentage": [
						-9.02,
						0,
						-3.59,
						2.67,
						14.36,
						20.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8230
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 4.83,
					"enrolment": 625,
					"ligo": 0.4,
					"location": [
						151.082475828839,
						-34.0287545714055
					],
					"name": "Gymea Technology High School",
					"playspace": 66.57,
					"projections": [
						691,
						625,
						660,
						710,
						740,
						760
					],
					"projections_orig": [
						"691",
						"625",
						"660",
						"710",
						"740",
						"760"
					],
					"projections_percentage": [
						10.56,
						0,
						5.6,
						13.6,
						18.4,
						21.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8386
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 69
					},
					"classroomspace": 3.26,
					"enrolment": 1232,
					"ligo": 0.65,
					"location": [
						151.074939917778,
						-34.0437940010131
					],
					"name": "Kirrawee High School",
					"playspace": 23.91,
					"projections": [
						1172,
						1232,
						1100,
						1230,
						1360,
						1400
					],
					"projections_orig": [
						"1172",
						"1232",
						"1100",
						"1230",
						"1360",
						"1400"
					],
					"projections_percentage": [
						-4.87,
						0,
						-10.71,
						-0.16,
						10.39,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8437
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.97,
					"enrolment": 812,
					"ligo": 0.38,
					"location": [
						151.104745140298,
						-34.0184229446234
					],
					"name": "Sylvania High School",
					"playspace": 60.83,
					"projections": [
						723,
						812,
						840,
						900,
						945,
						980
					],
					"projections_orig": [
						"723",
						"812",
						"840",
						"900",
						"945",
						"980"
					],
					"projections_percentage": [
						-10.96,
						0,
						3.45,
						10.84,
						16.38,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8463
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 39
					},
					"classroomspace": 3.77,
					"enrolment": 753,
					"ligo": 0.82,
					"location": [
						151.061031292206,
						-34.0216599001281
					],
					"name": "The Jannali High School",
					"playspace": 24,
					"projections": [
						742,
						752,
						780,
						830,
						875,
						905
					],
					"projections_orig": [
						"742",
						"752",
						"780",
						"830",
						"875",
						"905"
					],
					"projections_percentage": [
						-1.33,
						0,
						3.72,
						10.37,
						16.36,
						20.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8852
				}
			],
			"uid": 20016
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 54
			},
			"enrolment": 1276,
			"level": "Secondary",
			"ligo": 0.4,
			"name": "Menai Secondary",
			"playspace": 32.79,
			"projections": [
				1276,
				1450,
				1500,
				1535,
				1550
			],
			"projections_percentage": [
				0,
				13.64,
				17.55,
				20.3,
				21.47
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 54
					},
					"classroomspace": 2.87,
					"enrolment": 1276,
					"ligo": 0.4,
					"location": [
						151.022821150242,
						-34.0034922144102
					],
					"name": "Menai High School",
					"playspace": 32.79,
					"projections": [
						1183,
						1276,
						1450,
						1500,
						1535,
						1550
					],
					"projections_orig": [
						"1183",
						"1276",
						"1450",
						"1500",
						"1535",
						"1550"
					],
					"projections_percentage": [
						-7.29,
						0,
						13.64,
						17.55,
						20.3,
						21.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8583
				}
			],
			"uid": 20017
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 198
			},
			"enrolment": 3744,
			"level": "Secondary",
			"ligo": 0.63,
			"name": "Caringbah Secondary",
			"playspace": 64.06,
			"projections": [
				3745,
				3860,
				4055,
				4245,
				4350
			],
			"projections_percentage": [
				0,
				3.07,
				8.28,
				13.35,
				16.15
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.35,
					"enrolment": 915,
					"ligo": 1,
					"location": [
						151.121722303011,
						-34.0330835322115
					],
					"name": "Caringbah High School",
					"playspace": 49.2,
					"projections": [
						907,
						915,
						915,
						920,
						925,
						930
					],
					"projections_orig": [
						"907",
						"915",
						"915",
						"920",
						"925",
						"930"
					],
					"projections_percentage": [
						-0.87,
						0,
						0,
						0.55,
						1.09,
						1.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8240
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 40
					},
					"classroomspace": 2.66,
					"enrolment": 1000,
					"ligo": 0.63,
					"location": [
						151.156815212965,
						-34.0397450385485
					],
					"name": "Cronulla High School",
					"playspace": 47.47,
					"projections": [
						744,
						1000,
						985,
						1035,
						1065,
						1090
					],
					"projections_orig": [
						"744",
						"1000",
						"985",
						"1035",
						"1065",
						"1090"
					],
					"projections_percentage": [
						-25.6,
						0,
						-1.5,
						3.5,
						6.5,
						9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8261
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.12,
					"enrolment": 824,
					"ligo": 0.26,
					"location": [
						151.118409651334,
						-34.0314833739557
					],
					"name": "Endeavour Sports High School",
					"playspace": 106.8,
					"projections": [
						801,
						825,
						795,
						845,
						950,
						990
					],
					"projections_orig": [
						"801",
						"825",
						"795",
						"845",
						"950",
						"990"
					],
					"projections_percentage": [
						-2.91,
						0,
						-3.64,
						2.42,
						15.15,
						20
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8404
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.56,
					"enrolment": 1005,
					"ligo": 0.64,
					"location": [
						151.144404971388,
						-34.0402955150159
					],
					"name": "Woolooware High School",
					"playspace": 52.77,
					"projections": [
						1075,
						1005,
						1165,
						1255,
						1305,
						1340
					],
					"projections_orig": [
						"1075",
						"1005",
						"1165",
						"1255",
						"1305",
						"1340"
					],
					"projections_percentage": [
						6.97,
						0,
						15.92,
						24.88,
						29.85,
						33.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8433
				}
			],
			"uid": 20018
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 113
			},
			"enrolment": 1811,
			"level": "Secondary",
			"ligo": 0.76,
			"name": "Engadine Secondary",
			"playspace": 54.94,
			"projections": [
				1811,
				1970,
				2025,
				2125,
				2205
			],
			"projections_percentage": [
				0,
				8.78,
				11.82,
				17.34,
				21.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 50
					},
					"classroomspace": 4.18,
					"enrolment": 755,
					"ligo": 0.9,
					"location": [
						151.014713218706,
						-34.0813973996484
					],
					"name": "Heathcote High School",
					"playspace": 60.27,
					"projections": [
						832,
						755,
						885,
						915,
						960,
						1000
					],
					"projections_orig": [
						"832",
						"755",
						"885",
						"915",
						"960",
						"1000"
					],
					"projections_percentage": [
						10.2,
						0,
						17.22,
						21.19,
						27.15,
						32.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8246
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 63
					},
					"classroomspace": 3.52,
					"enrolment": 1056,
					"ligo": 0.62,
					"location": [
						151.018592842882,
						-34.0610389431858
					],
					"name": "Engadine High School",
					"playspace": 49.6,
					"projections": [
						990,
						1056,
						1085,
						1110,
						1165,
						1205
					],
					"projections_orig": [
						"990",
						"1056",
						"1085",
						"1110",
						"1165",
						"1205"
					],
					"projections_percentage": [
						-6.25,
						0,
						2.75,
						5.11,
						10.32,
						14.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8432
				}
			],
			"uid": 20019
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 201
			},
			"enrolment": 2576,
			"level": "Secondary",
			"ligo": 0.62,
			"name": "Georges River Secondary",
			"playspace": 42.77,
			"projections": [
				2576,
				2685,
				2955,
				3140,
				3295
			],
			"projections_percentage": [
				0,
				4.23,
				14.71,
				21.89,
				27.91
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 52
					},
					"classroomspace": 3.43,
					"enrolment": 882,
					"ligo": 1,
					"location": [
						151.080211295645,
						-33.9775593320306
					],
					"name": "Georges River College Oatley Senior Campus",
					"playspace": 37.68,
					"projections": [
						968,
						882,
						960,
						1050,
						1130,
						1180
					],
					"projections_orig": [
						"968",
						"882",
						"960",
						"1050",
						"1130",
						"1180"
					],
					"projections_percentage": [
						9.75,
						0,
						8.84,
						19.05,
						28.12,
						33.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8284
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 61
					},
					"classroomspace": 5.08,
					"enrolment": 703,
					"ligo": 0.4,
					"location": [
						151.057292814597,
						-33.9670617075588
					],
					"name": "Georges River College Peakhurst Campus",
					"playspace": 46.01,
					"projections": [
						621,
						703,
						695,
						745,
						780,
						810
					],
					"projections_orig": [
						"621",
						"703",
						"695",
						"745",
						"780",
						"810"
					],
					"projections_percentage": [
						-11.66,
						0,
						-1.14,
						5.97,
						10.95,
						15.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8408
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 8.07,
					"enrolment": 360,
					"ligo": 0.55,
					"location": [
						151.110307433607,
						-33.9621516848667
					],
					"name": "Georges River College Hurstville Boys Campus",
					"playspace": 72.84,
					"projections": [
						326,
						360,
						335,
						385,
						410,
						440
					],
					"projections_orig": [
						"326",
						"360",
						"335",
						"385",
						"410",
						"440"
					],
					"projections_percentage": [
						-9.44,
						0,
						-6.94,
						6.94,
						13.89,
						22.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8813
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 3.84,
					"enrolment": 631,
					"ligo": 0.52,
					"location": [
						151.086625237486,
						-33.964408624469
					],
					"name": "Georges River College Penshurst Girls Campus",
					"playspace": 14.53,
					"projections": [
						692,
						631,
						695,
						775,
						820,
						865
					],
					"projections_orig": [
						"692",
						"631",
						"695",
						"775",
						"820",
						"865"
					],
					"projections_percentage": [
						9.67,
						0,
						10.14,
						22.82,
						29.95,
						37.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8857
				}
			],
			"uid": 20020
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 281
			},
			"enrolment": 4466,
			"level": "Secondary",
			"ligo": 0.72,
			"name": "Kogarah Secondary",
			"playspace": 46,
			"projections": [
				4466,
				4645,
				4975,
				5305,
				5610
			],
			"projections_percentage": [
				0,
				4.01,
				11.4,
				18.79,
				25.62
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 41
					},
					"classroomspace": 3.11,
					"enrolment": 927,
					"ligo": 1,
					"location": [
						151.136480732683,
						-33.9583049963864
					],
					"name": "St George Girls High School",
					"playspace": 17.64,
					"projections": [
						953,
						927,
						925,
						925,
						925,
						925
					],
					"projections_orig": [
						"953",
						"927",
						"925",
						"925",
						"925",
						"925"
					],
					"projections_percentage": [
						2.8,
						0,
						-0.22,
						-0.22,
						-0.22,
						-0.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8136
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 56
					},
					"classroomspace": 3.9,
					"enrolment": 917,
					"ligo": 1,
					"location": [
						151.114013826614,
						-33.9620973727078
					],
					"name": "Sydney Technical High School",
					"playspace": 32.91,
					"projections": [
						912,
						917,
						915,
						915,
						915,
						915
					],
					"projections_orig": [
						"912",
						"917",
						"915",
						"915",
						"915",
						"915"
					],
					"projections_percentage": [
						-0.55,
						0,
						-0.22,
						-0.22,
						-0.22,
						-0.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8141
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 46
					},
					"classroomspace": 3.22,
					"enrolment": 1101,
					"ligo": 0.65,
					"location": [
						151.11279368152,
						-33.9815707372845
					],
					"name": "Blakehurst High School",
					"playspace": 15.46,
					"projections": [
						1073,
						1101,
						1175,
						1260,
						1370,
						1505
					],
					"projections_orig": [
						"1073",
						"1101",
						"1175",
						"1260",
						"1370",
						"1505"
					],
					"projections_percentage": [
						-2.54,
						0,
						6.72,
						14.44,
						24.43,
						36.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8236
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 39
					},
					"classroomspace": 7.83,
					"enrolment": 319,
					"ligo": 0.5,
					"location": [
						151.137559500031,
						-33.9693739580468
					],
					"name": "Moorefield Girls High School",
					"playspace": 56.96,
					"projections": [
						441,
						319,
						375,
						425,
						470,
						505
					],
					"projections_orig": [
						"441",
						"319",
						"375",
						"425",
						"470",
						"505"
					],
					"projections_percentage": [
						38.24,
						0,
						17.55,
						33.23,
						47.34,
						58.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8241
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.5,
					"enrolment": 968,
					"ligo": 0.61,
					"location": [
						151.134758472696,
						-33.9612353210319
					],
					"name": "Kogarah High School",
					"playspace": 12.14,
					"projections": [
						784,
						968,
						965,
						1120,
						1255,
						1370
					],
					"projections_orig": [
						"784",
						"968",
						"965",
						"1120",
						"1255",
						"1370"
					],
					"projections_percentage": [
						-19.01,
						0,
						-0.31,
						15.7,
						29.65,
						41.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8320
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 12.34,
					"enrolment": 234,
					"ligo": 0.55,
					"location": [
						151.137130492755,
						-33.9658353117995
					],
					"name": "James Cook Boys High School",
					"playspace": 140.89,
					"projections": [
						435,
						234,
						290,
						330,
						370,
						390
					],
					"projections_orig": [
						"435",
						"234",
						"290",
						"330",
						"370",
						"390"
					],
					"projections_percentage": [
						85.9,
						0,
						23.93,
						41.03,
						58.12,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8882
				}
			],
			"uid": 20021
		},
		{
			"classrooms": {
				"demountable": 27,
				"permanent": 371
			},
			"enrolment": 5398,
			"level": "Secondary",
			"ligo": 0.49,
			"name": "Canterbury Secondary",
			"playspace": 31.04,
			"projections": [
				5398,
				5890,
				6700,
				7420,
				8200
			],
			"projections_percentage": [
				0,
				9.11,
				24.12,
				37.46,
				51.91
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 7.41,
					"enrolment": 344,
					"ligo": 0.4,
					"location": [
						151.1231779079,
						-33.9045388591468
					],
					"name": "Canterbury Boys High School",
					"playspace": 51.28,
					"projections": [
						484,
						344,
						440,
						505,
						580,
						645
					],
					"projections_orig": [
						"484",
						"344",
						"440",
						"505",
						"580",
						"645"
					],
					"projections_percentage": [
						40.7,
						0,
						27.91,
						46.8,
						68.6,
						87.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8107
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 5.84,
					"enrolment": 497,
					"ligo": 0.7,
					"location": [
						151.053074525931,
						-33.923316397907
					],
					"name": "Punchbowl Boys High School",
					"playspace": 47.24,
					"projections": [
						414,
						497,
						530,
						585,
						640,
						720
					],
					"projections_orig": [
						"414",
						"497",
						"530",
						"585",
						"640",
						"720"
					],
					"projections_percentage": [
						-16.7,
						0,
						6.64,
						17.71,
						28.77,
						44.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8184
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 65
					},
					"classroomspace": 4.63,
					"enrolment": 873,
					"ligo": 0.42,
					"location": [
						151.098305431017,
						-33.9344094563357
					],
					"name": "Kingsgrove North High School",
					"playspace": 26.55,
					"projections": [
						893,
						873,
						975,
						1090,
						1195,
						1305
					],
					"projections_orig": [
						"893",
						"873",
						"975",
						"1090",
						"1195",
						"1305"
					],
					"projections_percentage": [
						2.29,
						0,
						11.68,
						24.86,
						36.88,
						49.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8221
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.16,
					"enrolment": 972,
					"ligo": 0.46,
					"location": [
						151.102610099491,
						-33.9484803682262
					],
					"name": "Kingsgrove High School",
					"playspace": 17.99,
					"projections": [
						1023,
						972,
						1055,
						1170,
						1280,
						1360
					],
					"projections_orig": [
						"1023",
						"972",
						"1055",
						"1170",
						"1280",
						"1360"
					],
					"projections_percentage": [
						5.25,
						0,
						8.54,
						20.37,
						31.69,
						39.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8247
				},
				{
					"classrooms": {
						"demountable": 27,
						"permanent": 39
					},
					"classroomspace": 3.85,
					"enrolment": 1190,
					"ligo": 0.34,
					"location": [
						151.077698559926,
						-33.9473873107061
					],
					"name": "Beverly Hills Girls High School",
					"playspace": 24.7,
					"projections": [
						1147,
						1190,
						1235,
						1370,
						1520,
						1660
					],
					"projections_orig": [
						"1147",
						"1190",
						"1235",
						"1370",
						"1520",
						"1660"
					],
					"projections_percentage": [
						-3.61,
						0,
						3.78,
						15.13,
						27.73,
						39.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8255
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 7.73,
					"enrolment": 318,
					"ligo": 0.68,
					"location": [
						151.084783232784,
						-33.9111492984973
					],
					"name": "Belmore Boys High School",
					"playspace": 33.85,
					"projections": [
						367,
						318,
						315,
						385,
						425,
						480
					],
					"projections_orig": [
						"367",
						"318",
						"315",
						"385",
						"425",
						"480"
					],
					"projections_percentage": [
						15.41,
						0,
						-0.94,
						21.07,
						33.65,
						50.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8804
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 43
					},
					"classroomspace": 3.6,
					"enrolment": 727,
					"ligo": 0.48,
					"location": [
						151.121812055875,
						-33.9077671731585
					],
					"name": "Canterbury Girls High School",
					"playspace": 17.33,
					"projections": [
						661,
						727,
						715,
						890,
						995,
						1155
					],
					"projections_orig": [
						"661",
						"727",
						"715",
						"890",
						"995",
						"1155"
					],
					"projections_percentage": [
						-9.08,
						0,
						-1.65,
						22.42,
						36.86,
						58.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8806
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 5.97,
					"enrolment": 477,
					"ligo": 0.44,
					"location": [
						151.065434328677,
						-33.9239840294488
					],
					"name": "Wiley Park Girls High School",
					"playspace": 29.4,
					"projections": [
						618,
						477,
						625,
						705,
						785,
						875
					],
					"projections_orig": [
						"618",
						"477",
						"625",
						"705",
						"785",
						"875"
					],
					"projections_percentage": [
						29.56,
						0,
						31.03,
						47.8,
						64.57,
						83.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8888
				}
			],
			"uid": 20022
		},
		{
			"classrooms": {
				"demountable": 48,
				"permanent": 350
			},
			"enrolment": 7230,
			"level": "Secondary",
			"ligo": 0.63,
			"name": "Fairfield Secondary",
			"playspace": 40.4,
			"projections": [
				7229,
				6660,
				6530,
				6575,
				6765
			],
			"projections_percentage": [
				0,
				-7.87,
				-9.67,
				-9.05,
				-6.42
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 88
					},
					"classroomspace": 3.92,
					"enrolment": 1487,
					"ligo": 0.65,
					"location": [
						150.929714616422,
						-33.8984276916141
					],
					"name": "Cabramatta High School",
					"playspace": 44.32,
					"projections": [
						1405,
						1487,
						1350,
						1335,
						1330,
						1350
					],
					"projections_orig": [
						"1405",
						"1487",
						"1350",
						"1335",
						"1330",
						"1350"
					],
					"projections_percentage": [
						-5.51,
						0,
						-9.21,
						-10.22,
						-10.56,
						-9.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8209
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 67
					},
					"classroomspace": 2.75,
					"enrolment": 1710,
					"ligo": 0.4,
					"location": [
						150.919499314633,
						-33.8682694200599
					],
					"name": "Westfields Sports High School",
					"playspace": 20.05,
					"projections": [
						1617,
						1709,
						1590,
						1545,
						1540,
						1560
					],
					"projections_orig": [
						"1617",
						"1709",
						"1590",
						"1545",
						"1540",
						"1560"
					],
					"projections_percentage": [
						-5.38,
						0,
						-6.96,
						-9.6,
						-9.89,
						-8.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8384
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 62
					},
					"classroomspace": 3.24,
					"enrolment": 1484,
					"ligo": 0.73,
					"location": [
						150.95146301688,
						-33.8852740712513
					],
					"name": "Canley Vale High School",
					"playspace": 12.39,
					"projections": [
						1303,
						1484,
						1355,
						1340,
						1330,
						1380
					],
					"projections_orig": [
						"1303",
						"1484",
						"1355",
						"1340",
						"1330",
						"1380"
					],
					"projections_percentage": [
						-12.2,
						0,
						-8.69,
						-9.7,
						-10.38,
						-7.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8393
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 54
					},
					"classroomspace": 3.38,
					"enrolment": 1373,
					"ligo": 0.63,
					"location": [
						150.92901328832,
						-33.874422792203
					],
					"name": "Fairvale High School",
					"playspace": 24.54,
					"projections": [
						1380,
						1373,
						1355,
						1315,
						1335,
						1355
					],
					"projections_orig": [
						"1380",
						"1373",
						"1355",
						"1315",
						"1335",
						"1355"
					],
					"projections_percentage": [
						0.51,
						0,
						-1.31,
						-4.22,
						-2.77,
						-1.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8456
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 79
					},
					"classroomspace": 4.43,
					"enrolment": 1176,
					"ligo": 0.72,
					"location": [
						150.956565883741,
						-33.8664855723696
					],
					"name": "Fairfield High School",
					"playspace": 100.69,
					"projections": [
						1024,
						1176,
						1010,
						995,
						1040,
						1120
					],
					"projections_orig": [
						"1024",
						"1176",
						"1010",
						"995",
						"1040",
						"1120"
					],
					"projections_percentage": [
						-12.93,
						0,
						-14.12,
						-15.39,
						-11.56,
						-4.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8550
				}
			],
			"uid": 20023
		},
		{
			"classrooms": {
				"demountable": 51,
				"permanent": 216
			},
			"enrolment": 5057,
			"level": "Secondary",
			"ligo": 0.52,
			"name": "Bonnyrigg Secondary",
			"playspace": 39.56,
			"projections": [
				5058,
				5075,
				4965,
				4940,
				5010
			],
			"projections_percentage": [
				0,
				0.34,
				-1.84,
				-2.33,
				-0.95
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 22,
						"permanent": 47
					},
					"classroomspace": 3.05,
					"enrolment": 1510,
					"ligo": 0.52,
					"location": [
						150.891653639047,
						-33.895012273293
					],
					"name": "Bonnyrigg High School",
					"playspace": 29.6,
					"projections": [
						1038,
						1510,
						1290,
						1260,
						1240,
						1250
					],
					"projections_orig": [
						"1038",
						"1510",
						"1290",
						"1260",
						"1240",
						"1250"
					],
					"projections_percentage": [
						-31.26,
						0,
						-14.57,
						-16.56,
						-17.88,
						-17.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8260
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 56
					},
					"classroomspace": 4.3,
					"enrolment": 849,
					"ligo": 0.49,
					"location": [
						150.890388313377,
						-33.8742038351885
					],
					"name": "St Johns Park High School",
					"playspace": 69.99,
					"projections": [
						1157,
						849,
						945,
						905,
						895,
						905
					],
					"projections_orig": [
						"1157",
						"849",
						"945",
						"905",
						"895",
						"905"
					],
					"projections_percentage": [
						36.28,
						0,
						11.31,
						6.6,
						5.42,
						6.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8531
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 53
					},
					"classroomspace": 2.86,
					"enrolment": 1242,
					"ligo": 0.55,
					"location": [
						150.902610518289,
						-33.8596454896061
					],
					"name": "Prairiewood High School",
					"playspace": 31.04,
					"projections": [
						987,
						1243,
						1235,
						1210,
						1235,
						1260
					],
					"projections_orig": [
						"987",
						"1243",
						"1235",
						"1210",
						"1235",
						"1260"
					],
					"projections_percentage": [
						-20.6,
						0,
						-0.64,
						-2.65,
						-0.64,
						1.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8560
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 60
					},
					"classroomspace": 3.36,
					"enrolment": 1456,
					"ligo": 0.52,
					"location": [
						150.87619653653,
						-33.8698490106274
					],
					"name": "Bossley Park High School",
					"playspace": 27.63,
					"projections": [
						1505,
						1456,
						1605,
						1590,
						1570,
						1595
					],
					"projections_orig": [
						"1505",
						"1456",
						"1605",
						"1590",
						"1570",
						"1595"
					],
					"projections_percentage": [
						3.37,
						0,
						10.23,
						9.2,
						7.83,
						9.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8582
				}
			],
			"uid": 20024
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 250
			},
			"enrolment": 3754,
			"level": "Secondary",
			"ligo": 0.61,
			"name": "Cecil Hills Secondary",
			"playspace": 67.44,
			"projections": [
				3754,
				4050,
				4360,
				4750,
				5340
			],
			"projections_percentage": [
				0,
				7.88,
				16.14,
				26.53,
				42.25
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 57
					},
					"classroomspace": 3.04,
					"enrolment": 1324,
					"ligo": 0.8,
					"location": [
						150.85030115828,
						-33.8960224003344
					],
					"name": "Cecil Hills High School",
					"playspace": 30.87,
					"projections": [
						1191,
						1324,
						1350,
						1435,
						1555,
						1830
					],
					"projections_orig": [
						"1191",
						"1324",
						"1350",
						"1435",
						"1555",
						"1830"
					],
					"projections_percentage": [
						-10.05,
						0,
						1.96,
						8.38,
						17.45,
						38.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8273
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 47
					},
					"classroomspace": 6.45,
					"enrolment": 575,
					"ligo": 0.52,
					"location": [
						150.880110649561,
						-33.922861013213
					],
					"name": "Miller High School",
					"playspace": 74.78,
					"projections": [
						565,
						575,
						590,
						610,
						625,
						670
					],
					"projections_orig": [
						"565",
						"575",
						"590",
						"610",
						"625",
						"670"
					],
					"projections_percentage": [
						-1.74,
						0,
						2.61,
						6.09,
						8.7,
						16.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8394
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 47
					},
					"classroomspace": 5.88,
					"enrolment": 517,
					"ligo": 0.68,
					"location": [
						150.896150571402,
						-33.9194326485562
					],
					"name": "Ashcroft High School",
					"playspace": 85.51,
					"projections": [
						571,
						517,
						560,
						560,
						560,
						590
					],
					"projections_orig": [
						"571",
						"517",
						"560",
						"560",
						"560",
						"590"
					],
					"projections_percentage": [
						10.44,
						0,
						8.32,
						8.32,
						8.32,
						14.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8397
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 55
					},
					"classroomspace": 5.04,
					"enrolment": 693,
					"ligo": 0.44,
					"location": [
						150.874033830301,
						-33.9100140196117
					],
					"name": "James Busby High School",
					"playspace": 50.57,
					"projections": [
						749,
						693,
						725,
						700,
						700,
						700
					],
					"projections_orig": [
						"749",
						"693",
						"725",
						"700",
						"700",
						"700"
					],
					"projections_percentage": [
						8.08,
						0,
						4.62,
						1.01,
						1.01,
						1.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8460
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 4.45,
					"enrolment": 645,
					"ligo": 0.6,
					"location": [
						150.863339248491,
						-33.9188182086242
					],
					"name": "Hoxton Park High School",
					"playspace": 95.47,
					"projections": [
						708,
						645,
						825,
						1055,
						1310,
						1550
					],
					"projections_orig": [
						"708",
						"645",
						"825",
						"1055",
						"1310",
						"1550"
					],
					"projections_percentage": [
						9.77,
						0,
						27.91,
						63.57,
						103.1,
						140.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8485
				}
			],
			"uid": 20025
		},
		{
			"classrooms": {
				"demountable": 19,
				"permanent": 234
			},
			"enrolment": 3935,
			"level": "Secondary",
			"ligo": 0.53,
			"name": "Liverpool Secondary",
			"playspace": 54.25,
			"projections": [
				3935,
				4370,
				4570,
				4760,
				4950
			],
			"projections_percentage": [
				0,
				11.05,
				16.14,
				20.97,
				25.79
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 43
					},
					"classroomspace": 3.6,
					"enrolment": 966,
					"ligo": 0.4,
					"location": [
						150.931676143019,
						-33.9179257867168
					],
					"name": "Liverpool Girls High School",
					"playspace": 23.02,
					"projections": [
						1072,
						966,
						1075,
						1120,
						1165,
						1205
					],
					"projections_orig": [
						"1072",
						"966",
						"1075",
						"1120",
						"1165",
						"1205"
					],
					"projections_percentage": [
						10.97,
						0,
						11.28,
						15.94,
						20.6,
						24.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8176
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 5.53,
					"enrolment": 581,
					"ligo": 0.48,
					"location": [
						150.930644400837,
						-33.917727076059
					],
					"name": "Liverpool Boys High School",
					"playspace": 44.74,
					"projections": [
						590,
						581,
						640,
						670,
						700,
						725
					],
					"projections_orig": [
						"590",
						"581",
						"640",
						"670",
						"700",
						"725"
					],
					"projections_percentage": [
						1.55,
						0,
						10.15,
						15.32,
						20.48,
						24.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8186
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 51
					},
					"classroomspace": 5.01,
					"enrolment": 693,
					"ligo": 0.52,
					"location": [
						150.897173143749,
						-33.9417098745509
					],
					"name": "Lurnea High School",
					"playspace": 65.92,
					"projections": [
						735,
						693,
						810,
						870,
						925,
						975
					],
					"projections_orig": [
						"735",
						"693",
						"810",
						"870",
						"925",
						"975"
					],
					"projections_percentage": [
						6.06,
						0,
						16.88,
						25.54,
						33.48,
						40.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8401
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 56
					},
					"classroomspace": 3.26,
					"enrolment": 1038,
					"ligo": 0.46,
					"location": [
						150.957390645481,
						-33.925892418448
					],
					"name": "Moorebank High School",
					"playspace": 52.82,
					"projections": [
						1026,
						1038,
						1105,
						1150,
						1185,
						1230
					],
					"projections_orig": [
						"1026",
						"1038",
						"1105",
						"1150",
						"1185",
						"1230"
					],
					"projections_percentage": [
						-1.16,
						0,
						6.45,
						10.79,
						14.16,
						18.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8501
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 4.05,
					"enrolment": 657,
					"ligo": 0.78,
					"location": [
						150.951762585051,
						-33.9560056011231
					],
					"name": "Holsworthy High School",
					"playspace": 84.75,
					"projections": [
						681,
						657,
						740,
						760,
						785,
						815
					],
					"projections_orig": [
						"681",
						"657",
						"740",
						"760",
						"785",
						"815"
					],
					"projections_percentage": [
						3.65,
						0,
						12.63,
						15.68,
						19.48,
						24.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8564
				}
			],
			"uid": 20026
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 205
			},
			"enrolment": 2691,
			"level": "Secondary",
			"ligo": 0.68,
			"name": "Leumeah - Raby Road Secondary",
			"playspace": 75.84,
			"projections": [
				2691,
				2880,
				3615,
				4395,
				5115
			],
			"projections_percentage": [
				0,
				7.02,
				34.34,
				63.32,
				90.08
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 4.23,
					"enrolment": 794,
					"ligo": 0.54,
					"location": [
						150.848138652692,
						-34.0544278535283
					],
					"name": "Leumeah High School",
					"playspace": 51.29,
					"projections": [
						861,
						794,
						840,
						905,
						945,
						1005
					],
					"projections_orig": [
						"861",
						"794",
						"840",
						"905",
						"945",
						"1005"
					],
					"projections_percentage": [
						8.44,
						0,
						5.79,
						13.98,
						19.02,
						26.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8532
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 5.15,
					"enrolment": 602,
					"ligo": 0.72,
					"location": [
						150.85033064929,
						-34.0272178563749
					],
					"name": "Sarah Redfern High School",
					"playspace": 114.47,
					"projections": [
						483,
						602,
						600,
						650,
						700,
						750
					],
					"projections_orig": [
						"483",
						"602",
						"600",
						"650",
						"700",
						"750"
					],
					"projections_percentage": [
						-19.77,
						0,
						-0.33,
						7.97,
						16.28,
						24.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8551
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 5.66,
					"enrolment": 518,
					"ligo": 0.8,
					"location": [
						150.804444571289,
						-34.0408179346069
					],
					"name": "Eagle Vale High School",
					"playspace": 77.15,
					"projections": [
						662,
						518,
						525,
						835,
						1185,
						1490
					],
					"projections_orig": [
						"662",
						"518",
						"525",
						"835",
						"1185",
						"1490"
					],
					"projections_percentage": [
						27.8,
						0,
						1.35,
						61.2,
						128.76,
						187.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8569
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 46
					},
					"classroomspace": 4.02,
					"enrolment": 777,
					"ligo": 0.66,
					"location": [
						150.818245674557,
						-34.0155802238061
					],
					"name": "Robert Townson High School",
					"playspace": 60.47,
					"projections": [
						894,
						777,
						915,
						1225,
						1565,
						1870
					],
					"projections_orig": [
						"894",
						"777",
						"915",
						"1225",
						"1565",
						"1870"
					],
					"projections_percentage": [
						15.06,
						0,
						17.76,
						57.66,
						101.42,
						140.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8575
				}
			],
			"uid": 20027
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 265
			},
			"enrolment": 5167,
			"level": "Secondary",
			"ligo": 0.76,
			"name": "Camden Secondary",
			"playspace": 33.78,
			"projections": [
				5167,
				6165,
				8475,
				11105,
				13060
			],
			"projections_percentage": [
				0,
				19.31,
				64.02,
				114.92,
				152.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 50
					},
					"classroomspace": 3.46,
					"enrolment": 1156,
					"ligo": 0.91,
					"location": [
						150.606884250702,
						-34.1946055250096
					],
					"name": "Picton High School",
					"playspace": 22.34,
					"projections": [
						1279,
						1156,
						1330,
						1500,
						1695,
						1870
					],
					"projections_orig": [
						"1279",
						"1156",
						"1330",
						"1500",
						"1695",
						"1870"
					],
					"projections_percentage": [
						10.64,
						0,
						15.05,
						29.76,
						46.63,
						61.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8215
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 58
					},
					"classroomspace": 3.22,
					"enrolment": 1125,
					"ligo": 0.74,
					"location": [
						150.677698288036,
						-34.079394226071
					],
					"name": "Camden High School",
					"playspace": 38.76,
					"projections": [
						1176,
						1125,
						1205,
						1665,
						2175,
						2560
					],
					"projections_orig": [
						"1176",
						"1125",
						"1205",
						"1665",
						"2175",
						"2560"
					],
					"projections_percentage": [
						4.53,
						0,
						7.11,
						48,
						93.33,
						127.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8217
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 4.16,
					"enrolment": 757,
					"ligo": 0.8,
					"location": [
						150.761471714617,
						-34.0584325330353
					],
					"name": "Mount Annan High School",
					"playspace": 54.22,
					"projections": [
						723,
						757,
						920,
						1260,
						1590,
						1845
					],
					"projections_orig": [
						"723",
						"757",
						"920",
						"1260",
						"1590",
						"1845"
					],
					"projections_percentage": [
						-4.49,
						0,
						21.53,
						66.45,
						110.04,
						143.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8286
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 51
					},
					"classroomspace": 3.72,
					"enrolment": 988,
					"ligo": 0.43,
					"location": [
						150.716342648597,
						-34.0529475545397
					],
					"name": "Elderslie High School",
					"playspace": 28.52,
					"projections": [
						975,
						988,
						1255,
						1905,
						2680,
						3315
					],
					"projections_orig": [
						"975",
						"988",
						"1255",
						"1905",
						"2680",
						"3315"
					],
					"projections_percentage": [
						-1.32,
						0,
						27.02,
						92.81,
						171.26,
						235.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8521
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 2.79,
					"enrolment": 1141,
					"ligo": 0.7,
					"location": [
						150.739132082342,
						-34.0568792458214
					],
					"name": "Elizabeth Macarthur High School",
					"playspace": 25.06,
					"projections": [
						954,
						1141,
						1455,
						2145,
						2965,
						3470
					],
					"projections_orig": [
						"954",
						"1141",
						"1455",
						"2145",
						"2965",
						"3470"
					],
					"projections_percentage": [
						-16.39,
						0,
						27.52,
						87.99,
						159.86,
						204.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8584
				}
			],
			"uid": 20028
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 204
			},
			"enrolment": 2837,
			"level": "Secondary",
			"ligo": 0.67,
			"name": "Campbelltown Secondary",
			"playspace": 71.75,
			"projections": [
				2837,
				3235,
				3890,
				4765,
				5710
			],
			"projections_percentage": [
				0,
				14.03,
				37.12,
				67.96,
				101.27
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 52
					},
					"classroomspace": 3.35,
					"enrolment": 1103,
					"ligo": 0.58,
					"location": [
						150.822880380091,
						-34.0616916620086
					],
					"name": "Campbelltown Performing Arts High School",
					"playspace": 44.65,
					"projections": [
						1142,
						1103,
						1285,
						1410,
						1685,
						1965
					],
					"projections_orig": [
						"1142",
						"1103",
						"1285",
						"1410",
						"1685",
						"1965"
					],
					"projections_percentage": [
						3.54,
						0,
						16.5,
						27.83,
						52.77,
						78.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8180
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 7.45,
					"enrolment": 456,
					"ligo": 0.81,
					"location": [
						150.827722958697,
						-34.0878323406195
					],
					"name": "Airds High School",
					"playspace": 100.75,
					"projections": [
						443,
						456,
						515,
						575,
						620,
						670
					],
					"projections_orig": [
						"443",
						"456",
						"515",
						"575",
						"620",
						"670"
					],
					"projections_percentage": [
						-2.85,
						0,
						12.94,
						26.1,
						35.96,
						46.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8493
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 67
					},
					"classroomspace": 5.16,
					"enrolment": 743,
					"ligo": 0.68,
					"location": [
						150.800592689788,
						-34.1005769675329
					],
					"name": "Ambarvale High School",
					"playspace": 65.05,
					"projections": [
						823,
						743,
						800,
						1070,
						1400,
						1775
					],
					"projections_orig": [
						"823",
						"743",
						"800",
						"1070",
						"1400",
						"1775"
					],
					"projections_percentage": [
						10.77,
						0,
						7.67,
						44.01,
						88.43,
						138.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8570
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 32
					},
					"classroomspace": 4.5,
					"enrolment": 535,
					"ligo": 0.61,
					"location": [
						150.803007717226,
						-34.0814208338717
					],
					"name": "Thomas Reddall High School",
					"playspace": 76.57,
					"projections": [
						615,
						535,
						635,
						835,
						1060,
						1300
					],
					"projections_orig": [
						"615",
						"535",
						"635",
						"835",
						"1060",
						"1300"
					],
					"projections_percentage": [
						14.95,
						0,
						18.69,
						56.07,
						98.13,
						142.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8589
				}
			],
			"uid": 20029
		},
		{
			"classrooms": {
				"demountable": 27,
				"permanent": 210
			},
			"enrolment": 3267,
			"level": "Secondary",
			"ligo": 0.68,
			"name": "St Marys Secondary",
			"playspace": 69.13,
			"projections": [
				3267,
				3730,
				4045,
				4325,
				4605
			],
			"projections_percentage": [
				0,
				14.17,
				23.81,
				32.38,
				40.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 61
					},
					"classroomspace": 6.54,
					"enrolment": 661,
					"ligo": 0.63,
					"location": [
						150.7970160334,
						-33.7794073376222
					],
					"name": "Colyton High School",
					"playspace": 124.36,
					"projections": [
						820,
						661,
						785,
						845,
						905,
						955
					],
					"projections_orig": [
						"820",
						"661",
						"785",
						"845",
						"905",
						"955"
					],
					"projections_percentage": [
						24.05,
						0,
						18.76,
						27.84,
						36.91,
						44.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8443
				},
				{
					"classrooms": {
						"demountable": 20,
						"permanent": 53
					},
					"classroomspace": 6.37,
					"enrolment": 691,
					"ligo": 0.59,
					"location": [
						150.787752545245,
						-33.7940221834239
					],
					"name": "St Clair High School",
					"playspace": 53.98,
					"projections": [
						967,
						691,
						785,
						845,
						880,
						920
					],
					"projections_orig": [
						"967",
						"691",
						"785",
						"845",
						"880",
						"920"
					],
					"projections_percentage": [
						39.94,
						0,
						13.6,
						22.29,
						27.35,
						33.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8571
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 43
					},
					"classroomspace": 3.4,
					"enrolment": 997,
					"ligo": 0.52,
					"location": [
						150.803683764521,
						-33.8083566295718
					],
					"name": "Erskine Park High School",
					"playspace": 36.53,
					"projections": [
						1025,
						997,
						1080,
						1155,
						1220,
						1290
					],
					"projections_orig": [
						"1025",
						"997",
						"1080",
						"1155",
						"1220",
						"1290"
					],
					"projections_percentage": [
						2.81,
						0,
						8.32,
						15.85,
						22.37,
						29.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8590
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 3.82,
					"enrolment": 918,
					"ligo": 1,
					"location": [
						150.770744552459,
						-33.7637551344551
					],
					"name": "St Marys Senior High School",
					"playspace": 61.64,
					"projections": [
						919,
						918,
						1080,
						1200,
						1320,
						1440
					],
					"projections_orig": [
						"919",
						"918",
						"1080",
						"1200",
						"1320",
						"1440"
					],
					"projections_percentage": [
						0.11,
						0,
						17.65,
						30.72,
						43.79,
						56.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8870
				}
			],
			"uid": 20030
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 372
			},
			"enrolment": 6220,
			"level": "Secondary",
			"ligo": 0.7,
			"name": "Penrith Secondary",
			"playspace": 54.32,
			"projections": [
				6220,
				6770,
				7380,
				7850,
				8430
			],
			"projections_percentage": [
				0,
				8.84,
				18.65,
				26.21,
				35.53
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.75,
					"enrolment": 931,
					"ligo": 1,
					"location": [
						150.706254495186,
						-33.7556351151721
					],
					"name": "Penrith High School",
					"playspace": 39.7,
					"projections": [
						952,
						931,
						930,
						930,
						930,
						930
					],
					"projections_orig": [
						"952",
						"931",
						"930",
						"930",
						"930",
						"930"
					],
					"projections_percentage": [
						2.26,
						0,
						-0.11,
						-0.11,
						-0.11,
						-0.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8163
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 3.64,
					"enrolment": 849,
					"ligo": 0.8,
					"location": [
						150.671779079625,
						-33.7910714769555
					],
					"name": "Glenmore Park High School",
					"playspace": 49.01,
					"projections": [
						759,
						849,
						1010,
						1250,
						1495,
						1720
					],
					"projections_orig": [
						"759",
						"849",
						"1010",
						"1250",
						"1495",
						"1720"
					],
					"projections_percentage": [
						-10.6,
						0,
						18.96,
						47.23,
						76.09,
						102.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8276
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 51
					},
					"classroomspace": 3.12,
					"enrolment": 1148,
					"ligo": 0.42,
					"location": [
						150.670503353019,
						-33.7485441318525
					],
					"name": "Nepean Creative and Performing Arts High School",
					"playspace": 80.24,
					"projections": [
						834,
						1148,
						1180,
						1195,
						1225,
						1255
					],
					"projections_orig": [
						"834",
						"1148",
						"1180",
						"1195",
						"1225",
						"1255"
					],
					"projections_percentage": [
						-27.35,
						0,
						2.79,
						4.09,
						6.71,
						9.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8383
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.81,
					"enrolment": 730,
					"ligo": 0.65,
					"location": [
						150.715381096358,
						-33.7713884457732
					],
					"name": "Kingswood High School",
					"playspace": 72.74,
					"projections": [
						783,
						730,
						845,
						955,
						1005,
						1065
					],
					"projections_orig": [
						"783",
						"730",
						"845",
						"955",
						"1005",
						"1065"
					],
					"projections_percentage": [
						7.26,
						0,
						15.75,
						30.82,
						37.67,
						45.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8458
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 53
					},
					"classroomspace": 4.75,
					"enrolment": 743,
					"ligo": 0.66,
					"location": [
						150.734317588136,
						-33.75320230802
					],
					"name": "Cambridge Park High School",
					"playspace": 89.68,
					"projections": [
						604,
						743,
						745,
						810,
						840,
						870
					],
					"projections_orig": [
						"604",
						"743",
						"745",
						"810",
						"840",
						"870"
					],
					"projections_percentage": [
						-18.71,
						0,
						0.27,
						9.02,
						13.06,
						17.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8516
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 56
					},
					"classroomspace": 3.25,
					"enrolment": 1050,
					"ligo": 0.56,
					"location": [
						150.697431301359,
						-33.7751589934803
					],
					"name": "Jamison High School",
					"playspace": 29.09,
					"projections": [
						994,
						1050,
						1160,
						1245,
						1280,
						1315
					],
					"projections_orig": [
						"994",
						"1050",
						"1160",
						"1245",
						"1280",
						"1315"
					],
					"projections_percentage": [
						-5.33,
						0,
						10.48,
						18.57,
						21.9,
						25.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8559
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 4.08,
					"enrolment": 769,
					"ligo": 0.82,
					"location": [
						150.711139595325,
						-33.7212737038035
					],
					"name": "Cranebrook High School",
					"playspace": 19.77,
					"projections": [
						867,
						769,
						900,
						995,
						1075,
						1275
					],
					"projections_orig": [
						"867",
						"769",
						"900",
						"995",
						"1075",
						"1275"
					],
					"projections_percentage": [
						12.74,
						0,
						17.04,
						29.39,
						39.79,
						65.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8580
				}
			],
			"uid": 20031
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 203
			},
			"enrolment": 3293,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Blue Mountains Secondary",
			"playspace": 45.63,
			"projections": [
				3294,
				3315,
				3290,
				3270,
				3305
			],
			"projections_percentage": [
				0,
				0.64,
				-0.12,
				-0.73,
				0.33
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.72,
					"enrolment": 730,
					"ligo": 0.91,
					"location": [
						150.313175184361,
						-33.7278511280937
					],
					"name": "Katoomba High School",
					"playspace": 52.82,
					"projections": [
						541,
						730,
						670,
						670,
						670,
						675
					],
					"projections_orig": [
						"541",
						"730",
						"670",
						"670",
						"670",
						"675"
					],
					"projections_percentage": [
						-25.89,
						0,
						-8.22,
						-8.22,
						-8.22,
						-7.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8150
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 4.42,
					"enrolment": 698,
					"ligo": 0.69,
					"location": [
						150.550207009672,
						-33.6864247622996
					],
					"name": "Springwood High School",
					"playspace": 66.33,
					"projections": [
						686,
						698,
						715,
						705,
						700,
						710
					],
					"projections_orig": [
						"686",
						"698",
						"715",
						"705",
						"700",
						"710"
					],
					"projections_percentage": [
						-1.72,
						0,
						2.44,
						1,
						0.29,
						1.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8446
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 3.26,
					"enrolment": 1010,
					"ligo": 0.77,
					"location": [
						150.610209165964,
						-33.7557533207095
					],
					"name": "Blaxland High School",
					"playspace": 29.82,
					"projections": [
						936,
						1011,
						1025,
						1015,
						1005,
						1015
					],
					"projections_orig": [
						"936",
						"1011",
						"1025",
						"1015",
						"1005",
						"1015"
					],
					"projections_percentage": [
						-7.42,
						0,
						1.38,
						0.4,
						-0.59,
						0.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8522
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.28,
					"enrolment": 855,
					"ligo": 0.63,
					"location": [
						150.615636133441,
						-33.674183181584
					],
					"name": "Winmalee High School",
					"playspace": 33.55,
					"projections": [
						1011,
						855,
						905,
						900,
						895,
						905
					],
					"projections_orig": [
						"1011",
						"855",
						"905",
						"900",
						"895",
						"905"
					],
					"projections_percentage": [
						18.25,
						0,
						5.85,
						5.26,
						4.68,
						5.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8573
				}
			],
			"uid": 20032
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 193
			},
			"enrolment": 2494,
			"level": "Secondary",
			"ligo": 0.86,
			"name": "Hawkesbury Secondary",
			"playspace": 93.87,
			"projections": [
				2494,
				2960,
				3235,
				3545,
				3960
			],
			"projections_percentage": [
				0,
				18.68,
				29.71,
				42.14,
				58.78
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 51
					},
					"classroomspace": 5.49,
					"enrolment": 638,
					"ligo": 0.8,
					"location": [
						150.747046506367,
						-33.598842776943
					],
					"name": "Richmond High School",
					"playspace": 109.96,
					"projections": [
						783,
						638,
						820,
						925,
						1020,
						1120
					],
					"projections_orig": [
						"783",
						"638",
						"820",
						"925",
						"1020",
						"1120"
					],
					"projections_percentage": [
						22.73,
						0,
						28.53,
						44.98,
						59.87,
						75.55
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8178
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 55
					},
					"classroomspace": 8.06,
					"enrolment": 444,
					"ligo": 0.81,
					"location": [
						150.831713463101,
						-33.618883804518
					],
					"name": "Windsor High School",
					"playspace": 136.58,
					"projections": [
						498,
						444,
						530,
						610,
						770,
						995
					],
					"projections_orig": [
						"498",
						"444",
						"530",
						"610",
						"770",
						"995"
					],
					"projections_percentage": [
						12.16,
						0,
						19.37,
						37.39,
						73.42,
						124.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8396
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 54
					},
					"classroomspace": 3.76,
					"enrolment": 963,
					"ligo": 0.9,
					"location": [
						150.706168138493,
						-33.5703208855035
					],
					"name": "Colo High School",
					"playspace": 61.47,
					"projections": [
						1054,
						963,
						1085,
						1135,
						1170,
						1230
					],
					"projections_orig": [
						"1054",
						"963",
						"1085",
						"1135",
						"1170",
						"1230"
					],
					"projections_percentage": [
						9.45,
						0,
						12.67,
						17.86,
						21.5,
						27.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8526
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 5.02,
					"enrolment": 449,
					"ligo": 0.79,
					"location": [
						150.796710600277,
						-33.5600007232445
					],
					"name": "Hawkesbury High School",
					"playspace": 67.47,
					"projections": [
						550,
						449,
						525,
						565,
						585,
						615
					],
					"projections_orig": [
						"550",
						"449",
						"525",
						"565",
						"585",
						"615"
					],
					"projections_percentage": [
						22.49,
						0,
						16.93,
						25.84,
						30.29,
						36.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8565
				}
			],
			"uid": 20033
		},
		{
			"classrooms": {
				"demountable": 14,
				"permanent": 186
			},
			"enrolment": 3455,
			"level": "Secondary",
			"ligo": 0.42,
			"name": "East Hills Secondary",
			"playspace": 45.19,
			"projections": [
				3455,
				3600,
				3785,
				4010,
				4235
			],
			"projections_percentage": [
				0,
				4.2,
				9.55,
				16.06,
				22.58
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 41
					},
					"classroomspace": 2.91,
					"enrolment": 1059,
					"ligo": 0.34,
					"location": [
						150.992702878291,
						-33.9571025362659
					],
					"name": "East Hills Girls Technology High School",
					"playspace": 15.12,
					"projections": [
						1004,
						1059,
						1065,
						1105,
						1160,
						1215
					],
					"projections_orig": [
						"1004",
						"1059",
						"1065",
						"1105",
						"1160",
						"1215"
					],
					"projections_percentage": [
						-5.19,
						0,
						0.57,
						4.34,
						9.54,
						14.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8187
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 47
					},
					"classroomspace": 3.68,
					"enrolment": 788,
					"ligo": 0.32,
					"location": [
						150.993003256749,
						-33.9566484741002
					],
					"name": "East Hills Boys High School",
					"playspace": 64.7,
					"projections": [
						821,
						788,
						860,
						890,
						935,
						980
					],
					"projections_orig": [
						"821",
						"788",
						"860",
						"890",
						"935",
						"980"
					],
					"projections_percentage": [
						4.19,
						0,
						9.14,
						12.94,
						18.65,
						24.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8206
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 5.59,
					"enrolment": 565,
					"ligo": 0.61,
					"location": [
						151.020251595255,
						-33.9388400219207
					],
					"name": "Sir Joseph Banks High School",
					"playspace": 73.66,
					"projections": [
						535,
						565,
						590,
						660,
						740,
						805
					],
					"projections_orig": [
						"535",
						"565",
						"590",
						"660",
						"740",
						"805"
					],
					"projections_percentage": [
						-5.31,
						0,
						4.42,
						16.81,
						30.97,
						42.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8250
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 47
					},
					"classroomspace": 3.22,
					"enrolment": 1043,
					"ligo": 0.4,
					"location": [
						151.009008641488,
						-33.9650951243225
					],
					"name": "Picnic Point High School",
					"playspace": 27.26,
					"projections": [
						1025,
						1043,
						1085,
						1130,
						1175,
						1235
					],
					"projections_orig": [
						"1025",
						"1043",
						"1085",
						"1130",
						"1175",
						"1235"
					],
					"projections_percentage": [
						-1.73,
						0,
						4.03,
						8.34,
						12.66,
						18.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8377
				}
			],
			"uid": 20034
		},
		{
			"classrooms": {
				"demountable": 49,
				"permanent": 344
			},
			"enrolment": 5966,
			"level": "Secondary",
			"ligo": 0.62,
			"name": "Bankstown Secondary",
			"playspace": 53.64,
			"projections": [
				5965,
				6275,
				7165,
				7900,
				8420
			],
			"projections_percentage": [
				0,
				5.2,
				20.12,
				32.44,
				41.16
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 7,
					"enrolment": 400,
					"ligo": 0.56,
					"location": [
						151.024528293315,
						-33.8930346451862
					],
					"name": "Birrong Boys High School",
					"playspace": 50.3,
					"projections": [
						390,
						400,
						430,
						500,
						540,
						585
					],
					"projections_orig": [
						"390",
						"400",
						"430",
						"500",
						"540",
						"585"
					],
					"projections_percentage": [
						-2.5,
						0,
						7.5,
						25,
						35,
						46.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8213
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 48
					},
					"classroomspace": 4.96,
					"enrolment": 658,
					"ligo": 0.66,
					"location": [
						150.990812288043,
						-33.8984644636306
					],
					"name": "Bass High School",
					"playspace": 46.31,
					"projections": [
						786,
						657,
						770,
						815,
						855,
						910
					],
					"projections_orig": [
						"786",
						"657",
						"770",
						"815",
						"855",
						"910"
					],
					"projections_percentage": [
						19.63,
						0,
						17.2,
						24.05,
						30.14,
						38.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8223
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 37
					},
					"classroomspace": 4.18,
					"enrolment": 540,
					"ligo": 0.54,
					"location": [
						151.032731058664,
						-33.9204086627191
					],
					"name": "Bankstown Girls High School",
					"playspace": 7.9,
					"projections": [
						629,
						540,
						665,
						745,
						820,
						885
					],
					"projections_orig": [
						"629",
						"540",
						"665",
						"745",
						"820",
						"885"
					],
					"projections_percentage": [
						16.48,
						0,
						23.15,
						37.96,
						51.85,
						63.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8254
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 3.38,
					"enrolment": 1062,
					"ligo": 0.44,
					"location": [
						151.007666024617,
						-33.8793112958571
					],
					"name": "Sefton High School",
					"playspace": 19.79,
					"projections": [
						1035,
						1062,
						1035,
						1285,
						1460,
						1530
					],
					"projections_orig": [
						"1035",
						"1062",
						"1035",
						"1285",
						"1460",
						"1530"
					],
					"projections_percentage": [
						-2.54,
						0,
						-2.54,
						21,
						37.48,
						44.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8265
				},
				{
					"classrooms": {
						"demountable": 21,
						"permanent": 48
					},
					"classroomspace": 3.51,
					"enrolment": 1269,
					"ligo": 0.66,
					"location": [
						150.994638310415,
						-33.8750381902447
					],
					"name": "Chester Hill High School",
					"playspace": 31.79,
					"projections": [
						1088,
						1269,
						1185,
						1370,
						1555,
						1630
					],
					"projections_orig": [
						"1088",
						"1269",
						"1185",
						"1370",
						"1555",
						"1630"
					],
					"projections_percentage": [
						-14.26,
						0,
						-6.62,
						7.96,
						22.54,
						28.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8269
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 34
					},
					"classroomspace": 6.43,
					"enrolment": 431,
					"ligo": 1,
					"location": [
						151.021457036773,
						-33.9309548653418
					],
					"name": "Bankstown Senior College",
					"playspace": 155.11,
					"projections": [
						356,
						431,
						465,
						520,
						585,
						660
					],
					"projections_orig": [
						"356",
						"431",
						"465",
						"520",
						"585",
						"660"
					],
					"projections_percentage": [
						-17.4,
						0,
						7.89,
						20.65,
						35.73,
						53.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8381
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 42
					},
					"classroomspace": 3.48,
					"enrolment": 810,
					"ligo": 0.47,
					"location": [
						151.003203404045,
						-33.9240361704846
					],
					"name": "Condell Park High School",
					"playspace": 67.75,
					"projections": [
						587,
						810,
						770,
						820,
						885,
						935
					],
					"projections_orig": [
						"587",
						"810",
						"770",
						"820",
						"885",
						"935"
					],
					"projections_percentage": [
						-27.53,
						0,
						-4.94,
						1.23,
						9.26,
						15.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8398
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 34
					},
					"classroomspace": 3.51,
					"enrolment": 796,
					"ligo": 0.64,
					"location": [
						151.027131221881,
						-33.8893252291203
					],
					"name": "Birrong Girls High School",
					"playspace": 50.2,
					"projections": [
						852,
						796,
						955,
						1110,
						1200,
						1285
					],
					"projections_orig": [
						"852",
						"796",
						"955",
						"1110",
						"1200",
						"1285"
					],
					"projections_percentage": [
						7.04,
						0,
						19.97,
						39.45,
						50.75,
						61.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8854
				}
			],
			"uid": 20035
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 334
			},
			"enrolment": 6094,
			"level": "Secondary",
			"ligo": 0.51,
			"name": "Parramatta Secondary",
			"playspace": 49.97,
			"projections": [
				6094,
				6490,
				7580,
				8695,
				9640
			],
			"projections_percentage": [
				0,
				6.5,
				24.38,
				42.68,
				58.19
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 3.03,
					"enrolment": 870,
					"ligo": 0.24,
					"location": [
						150.996012855965,
						-33.8183636627729
					],
					"name": "Parramatta High School",
					"playspace": 2.2,
					"projections": [
						839,
						870,
						845,
						970,
						1090,
						1050
					],
					"projections_orig": [
						"839",
						"870",
						"845",
						"970",
						"1090",
						"1050"
					],
					"projections_percentage": [
						-3.56,
						0,
						-2.87,
						11.49,
						25.29,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8135
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 3.5,
					"enrolment": 1036,
					"ligo": 0.36,
					"location": [
						150.999374810974,
						-33.7890178479087
					],
					"name": "Northmead Creative and Performing Arts High School",
					"playspace": 63.87,
					"projections": [
						897,
						1036,
						1115,
						1320,
						1475,
						1560
					],
					"projections_orig": [
						"897",
						"1036",
						"1115",
						"1320",
						"1475",
						"1560"
					],
					"projections_percentage": [
						-13.42,
						0,
						7.63,
						27.41,
						42.37,
						50.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8229
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 3.91,
					"enrolment": 841,
					"ligo": 1,
					"location": [
						151.041647967685,
						-33.7827299668524
					],
					"name": "James Ruse Agricultural High School",
					"playspace": 29.12,
					"projections": [
						855,
						841,
						840,
						840,
						840,
						840
					],
					"projections_orig": [
						"855",
						"841",
						"840",
						"840",
						"840",
						"840"
					],
					"projections_percentage": [
						1.66,
						0,
						-0.12,
						-0.12,
						-0.12,
						-0.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8235
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 8.57,
					"enrolment": 354,
					"ligo": 0.84,
					"location": [
						150.961769652063,
						-33.7946491533639
					],
					"name": "Pendle Hill High School",
					"playspace": 132.94,
					"projections": [
						351,
						354,
						400,
						440,
						480,
						510
					],
					"projections_orig": [
						"351",
						"354",
						"400",
						"440",
						"480",
						"510"
					],
					"projections_percentage": [
						-0.85,
						0,
						12.99,
						24.29,
						35.59,
						44.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8395
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 40
					},
					"classroomspace": 3.27,
					"enrolment": 1022,
					"ligo": 0.3,
					"location": [
						151.011522278904,
						-33.8128624337093
					],
					"name": "Macarthur Girls High School",
					"playspace": 38.34,
					"projections": [
						1049,
						1022,
						1090,
						1310,
						1525,
						1665
					],
					"projections_orig": [
						"1049",
						"1022",
						"1090",
						"1310",
						"1525",
						"1665"
					],
					"projections_percentage": [
						2.64,
						0,
						6.65,
						28.18,
						49.22,
						62.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8822
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 49
					},
					"classroomspace": 2.19,
					"enrolment": 1330,
					"ligo": 0.26,
					"location": [
						151.006683329311,
						-33.8159869188613
					],
					"name": "Arthur Phillip High School",
					"playspace": 10.17,
					"projections": [
						1523,
						1330,
						1505,
						1835,
						2330,
						3015
					],
					"projections_orig": [
						"1523",
						"1330",
						"1505",
						"1835",
						"2330",
						"3015"
					],
					"projections_percentage": [
						14.51,
						0,
						13.16,
						37.97,
						75.19,
						126.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8892
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 4.25,
					"enrolment": 641,
					"ligo": 0.59,
					"location": [
						151.037899152021,
						-33.7849608654777
					],
					"name": "Cumberland High School",
					"playspace": 73.18,
					"projections": [
						609,
						641,
						695,
						865,
						955,
						1000
					],
					"projections_orig": [
						"609",
						"641",
						"695",
						"865",
						"955",
						"1000"
					],
					"projections_percentage": [
						-4.99,
						0,
						8.42,
						34.95,
						48.99,
						56.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8905
				}
			],
			"uid": 20036
		},
		{
			"classrooms": {
				"demountable": 70,
				"permanent": 505
			},
			"enrolment": 10262,
			"level": "Secondary",
			"ligo": 0.71,
			"name": "North East Secondary",
			"playspace": 35.71,
			"projections": [
				10261,
				11695,
				13525,
				15340,
				16970
			],
			"projections_percentage": [
				0,
				13.98,
				31.81,
				49.5,
				65.38
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.52,
					"enrolment": 839,
					"ligo": 0.77,
					"location": [
						150.933314779475,
						-33.6866322354719
					],
					"name": "Rouse Hill High School",
					"playspace": 45.33,
					"projections": [
						575,
						839,
						1045,
						1545,
						2030,
						2520
					],
					"projections_orig": [
						"575",
						"839",
						"1045",
						"1545",
						"2030",
						"2520"
					],
					"projections_percentage": [
						-31.47,
						0,
						24.55,
						84.15,
						141.95,
						200.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8291
				},
				{
					"classrooms": {
						"demountable": 23,
						"permanent": 45
					},
					"classroomspace": 2.9,
					"enrolment": 1595,
					"ligo": 0.69,
					"location": [
						150.998566848898,
						-33.7265584582817
					],
					"name": "Castle Hill High School",
					"playspace": 18.17,
					"projections": [
						1320,
						1595,
						1825,
						2190,
						2545,
						2835
					],
					"projections_orig": [
						"1320",
						"1595",
						"1825",
						"2190",
						"2545",
						"2835"
					],
					"projections_percentage": [
						-17.24,
						0,
						14.42,
						37.3,
						59.56,
						77.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8382
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 58
					},
					"classroomspace": 3.23,
					"enrolment": 1217,
					"ligo": 1,
					"location": [
						150.989727067928,
						-33.7526648531562
					],
					"name": "Baulkham Hills High School",
					"playspace": 30.55,
					"projections": [
						1203,
						1217,
						1215,
						1215,
						1215,
						1215
					],
					"projections_orig": [
						"1203",
						"1217",
						"1215",
						"1215",
						"1215",
						"1215"
					],
					"projections_percentage": [
						-1.15,
						0,
						-0.16,
						-0.16,
						-0.16,
						-0.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8464
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 55
					},
					"classroomspace": 3.52,
					"enrolment": 1072,
					"ligo": 0.72,
					"location": [
						150.968069297275,
						-33.7088210435145
					],
					"name": "Kellyville High School",
					"playspace": 40.15,
					"projections": [
						1006,
						1072,
						1395,
						1710,
						2015,
						2250
					],
					"projections_orig": [
						"1006",
						"1072",
						"1395",
						"1710",
						"2015",
						"2250"
					],
					"projections_percentage": [
						-6.16,
						0,
						30.13,
						59.51,
						87.97,
						109.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8477
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 59
					},
					"classroomspace": 5.7,
					"enrolment": 684,
					"ligo": 0.69,
					"location": [
						151.039526839205,
						-33.6608858823407
					],
					"name": "Galston High School",
					"playspace": 64.55,
					"projections": [
						771,
						684,
						745,
						800,
						835,
						875
					],
					"projections_orig": [
						"771",
						"684",
						"745",
						"800",
						"835",
						"875"
					],
					"projections_percentage": [
						12.72,
						0,
						8.92,
						16.96,
						22.08,
						27.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8481
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 3.92,
					"enrolment": 845,
					"ligo": 0.56,
					"location": [
						151.022244575508,
						-33.7659828459457
					],
					"name": "Muirfield High School",
					"playspace": 49.34,
					"projections": [
						819,
						844,
						885,
						1020,
						1125,
						1190
					],
					"projections_orig": [
						"819",
						"844",
						"885",
						"1020",
						"1125",
						"1190"
					],
					"projections_percentage": [
						-2.96,
						0,
						4.86,
						20.85,
						33.29,
						41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8498
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.32,
					"enrolment": 1103,
					"ligo": 0.66,
					"location": [
						150.970436467644,
						-33.769500095015
					],
					"name": "Model Farms High School",
					"playspace": 37.61,
					"projections": [
						1015,
						1103,
						1185,
						1320,
						1530,
						1675
					],
					"projections_orig": [
						"1015",
						"1103",
						"1185",
						"1320",
						"1530",
						"1675"
					],
					"projections_percentage": [
						-7.98,
						0,
						7.43,
						19.67,
						38.71,
						51.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8499
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 66
					},
					"classroomspace": 3.78,
					"enrolment": 976,
					"ligo": 0.45,
					"location": [
						150.975664562765,
						-33.7446381051969
					],
					"name": "Crestwood High School",
					"playspace": 26.2,
					"projections": [
						1022,
						976,
						1300,
						1530,
						1770,
						2035
					],
					"projections_orig": [
						"1022",
						"976",
						"1300",
						"1530",
						"1770",
						"2035"
					],
					"projections_percentage": [
						4.71,
						0,
						33.2,
						56.76,
						81.35,
						108.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8552
				},
				{
					"classrooms": {
						"demountable": 37,
						"permanent": 61
					},
					"classroomspace": 3.28,
					"enrolment": 1931,
					"ligo": 0.85,
					"location": [
						151.036957435731,
						-33.7201748126674
					],
					"name": "Cherrybrook Technology High School",
					"playspace": 9.46,
					"projections": [
						2050,
						1931,
						2100,
						2195,
						2275,
						2375
					],
					"projections_orig": [
						"2050",
						"1931",
						"2100",
						"2195",
						"2275",
						"2375"
					],
					"projections_percentage": [
						6.16,
						0,
						8.75,
						13.67,
						17.81,
						22.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8592
				}
			],
			"uid": 20037
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 382
			},
			"enrolment": 5520,
			"level": "Secondary",
			"ligo": 0.52,
			"name": "Blacktown Secondary",
			"playspace": 91.75,
			"projections": [
				5520,
				6065,
				6665,
				7265,
				8090
			],
			"projections_percentage": [
				0,
				9.87,
				20.74,
				31.61,
				46.56
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 48
					},
					"classroomspace": 4.57,
					"enrolment": 725,
					"ligo": 0.3,
					"location": [
						150.911313132441,
						-33.7630866341275
					],
					"name": "Blacktown Girls High School",
					"playspace": 35.78,
					"projections": [
						720,
						725,
						800,
						925,
						1055,
						1320
					],
					"projections_orig": [
						"720",
						"725",
						"800",
						"925",
						"1055",
						"1320"
					],
					"projections_percentage": [
						-0.69,
						0,
						10.34,
						27.59,
						45.52,
						82.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8224
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 8.29,
					"enrolment": 314,
					"ligo": 0.36,
					"location": [
						150.943277421801,
						-33.7634933189359
					],
					"name": "Seven Hills High School",
					"playspace": 243.45,
					"projections": [
						363,
						314,
						350,
						385,
						425,
						475
					],
					"projections_orig": [
						"363",
						"314",
						"350",
						"385",
						"425",
						"475"
					],
					"projections_percentage": [
						15.61,
						0,
						11.46,
						22.61,
						35.35,
						51.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8231
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 5.62,
					"enrolment": 511,
					"ligo": 0.33,
					"location": [
						150.911560294149,
						-33.7631412139614
					],
					"name": "Blacktown Boys High School",
					"playspace": 87.19,
					"projections": [
						390,
						511,
						505,
						580,
						655,
						820
					],
					"projections_orig": [
						"390",
						"511",
						"505",
						"580",
						"655",
						"820"
					],
					"projections_percentage": [
						-23.68,
						0,
						-1.17,
						13.5,
						28.18,
						60.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8244
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 47
					},
					"classroomspace": 4.33,
					"enrolment": 671,
					"ligo": 0.58,
					"location": [
						150.873493359692,
						-33.7563201824426
					],
					"name": "Doonside High School",
					"playspace": 92.13,
					"projections": [
						744,
						671,
						795,
						840,
						905,
						980
					],
					"projections_orig": [
						"744",
						"671",
						"795",
						"840",
						"905",
						"980"
					],
					"projections_percentage": [
						10.88,
						0,
						18.48,
						25.19,
						34.87,
						46.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8399
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 45
					},
					"classroomspace": 3.36,
					"enrolment": 1005,
					"ligo": 0.59,
					"location": [
						150.914531707263,
						-33.785848697881
					],
					"name": "Mitchell High School",
					"playspace": 43.77,
					"projections": [
						1063,
						1005,
						1160,
						1285,
						1405,
						1510
					],
					"projections_orig": [
						"1063",
						"1005",
						"1160",
						"1285",
						"1405",
						"1510"
					],
					"projections_percentage": [
						5.77,
						0,
						15.42,
						27.86,
						39.8,
						50.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8403
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 4.26,
					"enrolment": 892,
					"ligo": 0.34,
					"location": [
						150.940333277079,
						-33.7821110568939
					],
					"name": "The Hills Sports High School",
					"playspace": 71.76,
					"projections": [
						927,
						892,
						925,
						1045,
						1140,
						1230
					],
					"projections_orig": [
						"927",
						"892",
						"925",
						"1045",
						"1140",
						"1230"
					],
					"projections_percentage": [
						3.92,
						0,
						3.7,
						17.15,
						27.8,
						37.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8412
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 57
					},
					"classroomspace": 6.45,
					"enrolment": 643,
					"ligo": 0.62,
					"location": [
						150.890933926492,
						-33.7875549842979
					],
					"name": "Evans High School",
					"playspace": 101.98,
					"projections": [
						761,
						643,
						770,
						845,
						920,
						995
					],
					"projections_orig": [
						"761",
						"643",
						"770",
						"845",
						"920",
						"995"
					],
					"projections_percentage": [
						18.35,
						0,
						19.75,
						31.42,
						43.08,
						54.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8420
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 43
					},
					"classroomspace": 3.6,
					"enrolment": 759,
					"ligo": 1,
					"location": [
						150.944266471364,
						-33.7985526568163
					],
					"name": "Girraween High School",
					"playspace": 57.96,
					"projections": [
						754,
						759,
						760,
						760,
						760,
						760
					],
					"projections_orig": [
						"754",
						"759",
						"760",
						"760",
						"760",
						"760"
					],
					"projections_percentage": [
						-0.66,
						0,
						0.13,
						0.13,
						0.13,
						0.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8500
				}
			],
			"uid": 20038
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 354
			},
			"enrolment": 4317,
			"level": "Secondary",
			"ligo": 0.62,
			"name": "Mount Druitt Secondary",
			"playspace": 89.48,
			"projections": [
				4317,
				5010,
				5735,
				6490,
				7320
			],
			"projections_percentage": [
				0,
				16.05,
				32.85,
				50.34,
				69.56
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 7.75,
					"enrolment": 424,
					"ligo": 0.69,
					"location": [
						150.814751448757,
						-33.7447670995116
					],
					"name": "Chifley College Mount Druitt Campus",
					"playspace": 126.11,
					"projections": [
						632,
						424,
						545,
						595,
						640,
						695
					],
					"projections_orig": [
						"632",
						"424",
						"545",
						"595",
						"640",
						"695"
					],
					"projections_percentage": [
						49.06,
						0,
						28.54,
						40.33,
						50.94,
						63.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8459
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 35
					},
					"classroomspace": 3.85,
					"enrolment": 567,
					"ligo": 0.9,
					"location": [
						150.830210016594,
						-33.7707713102231
					],
					"name": "Chifley College Senior Campus",
					"playspace": 51.76,
					"projections": [
						616,
						567,
						610,
						685,
						755,
						830
					],
					"projections_orig": [
						"616",
						"567",
						"610",
						"685",
						"755",
						"830"
					],
					"projections_percentage": [
						8.64,
						0,
						7.58,
						20.81,
						33.16,
						46.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8473
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 10.72,
					"enrolment": 307,
					"ligo": 0.67,
					"location": [
						150.782192038941,
						-33.7507833122642
					],
					"name": "Chifley College Dunheved Campus",
					"playspace": 125.32,
					"projections": [
						290,
						307,
						310,
						350,
						395,
						435
					],
					"projections_orig": [
						"290",
						"307",
						"310",
						"350",
						"395",
						"435"
					],
					"projections_percentage": [
						-5.54,
						0,
						0.98,
						14.01,
						28.66,
						41.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8488
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 9.03,
					"enrolment": 320,
					"ligo": 0.59,
					"location": [
						150.80696730367,
						-33.7297387049822
					],
					"name": "Chifley College Shalvey Campus",
					"playspace": 187.43,
					"projections": [
						410,
						320,
						435,
						510,
						600,
						705
					],
					"projections_orig": [
						"410",
						"320",
						"435",
						"510",
						"600",
						"705"
					],
					"projections_percentage": [
						28.12,
						0,
						35.94,
						59.38,
						87.5,
						120.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8496
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 60
					},
					"classroomspace": 3.87,
					"enrolment": 964,
					"ligo": 0.35,
					"location": [
						150.834161715186,
						-33.7480003963669
					],
					"name": "Plumpton High School",
					"playspace": 41.38,
					"projections": [
						1066,
						964,
						1155,
						1370,
						1605,
						1865
					],
					"projections_orig": [
						"1066",
						"964",
						"1155",
						"1370",
						"1605",
						"1865"
					],
					"projections_percentage": [
						10.58,
						0,
						19.81,
						42.12,
						66.49,
						93.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8514
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 55
					},
					"classroomspace": 5.54,
					"enrolment": 610,
					"ligo": 0.56,
					"location": [
						150.827074259648,
						-33.7328550755504
					],
					"name": "Chifley College Bidwill Campus",
					"playspace": 52.94,
					"projections": [
						638,
						610,
						715,
						875,
						1045,
						1225
					],
					"projections_orig": [
						"638",
						"610",
						"715",
						"875",
						"1045",
						"1225"
					],
					"projections_percentage": [
						4.59,
						0,
						17.21,
						43.44,
						71.31,
						100.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8528
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 50
					},
					"classroomspace": 2.98,
					"enrolment": 1125,
					"ligo": 0.56,
					"location": [
						150.838226733506,
						-33.7721084560741
					],
					"name": "Rooty Hill High School",
					"playspace": 41.43,
					"projections": [
						1090,
						1125,
						1240,
						1350,
						1450,
						1565
					],
					"projections_orig": [
						"1090",
						"1125",
						"1240",
						"1350",
						"1450",
						"1565"
					],
					"projections_percentage": [
						-3.11,
						0,
						10.22,
						20,
						28.89,
						39.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8908
				}
			],
			"uid": 20039
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 244
			},
			"enrolment": 4314,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "North West Secondary",
			"playspace": 85.11,
			"projections": [
				4314,
				5135,
				6785,
				8100,
				9695
			],
			"projections_percentage": [
				0,
				19.03,
				57.28,
				87.76,
				124.73
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 19,
						"permanent": 53
					},
					"classroomspace": 3.18,
					"enrolment": 1481,
					"ligo": 0.86,
					"location": [
						150.937312348133,
						-33.7333193996382
					],
					"name": "Glenwood High School",
					"playspace": 23.61,
					"projections": [
						1475,
						1481,
						1600,
						1730,
						1825,
						1835
					],
					"projections_orig": [
						"1475",
						"1481",
						"1600",
						"1730",
						"1825",
						"1835"
					],
					"projections_percentage": [
						-0.41,
						0,
						8.04,
						16.81,
						23.23,
						23.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8268
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 34
					},
					"classroomspace": 4.11,
					"enrolment": 749,
					"ligo": 1,
					"location": [
						150.879574576527,
						-33.7260892229642
					],
					"name": "Wyndham College",
					"playspace": 45.18,
					"projections": [
						814,
						749,
						690,
						1355,
						1735,
						2130
					],
					"projections_orig": [
						"814",
						"749",
						"690",
						"1355",
						"1735",
						"2130"
					],
					"projections_percentage": [
						8.68,
						0,
						-7.88,
						80.91,
						131.64,
						184.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8277
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 54
					},
					"classroomspace": 3.59,
					"enrolment": 988,
					"ligo": 0.5,
					"location": [
						150.898235102327,
						-33.7284124165411
					],
					"name": "Quakers Hill High School",
					"playspace": 58.43,
					"projections": [
						1046,
						988,
						1225,
						1395,
						1535,
						1615
					],
					"projections_orig": [
						"1046",
						"988",
						"1225",
						"1395",
						"1535",
						"1615"
					],
					"projections_percentage": [
						5.87,
						0,
						23.99,
						41.19,
						55.36,
						63.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8594
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 44
					},
					"classroomspace": 9.75,
					"enrolment": 281,
					"ligo": 0.74,
					"location": [
						150.874495225114,
						-33.6798318610586
					],
					"name": "Riverstone High School",
					"playspace": 248.15,
					"projections": [
						331,
						281,
						400,
						970,
						1555,
						2550
					],
					"projections_orig": [
						"331",
						"281",
						"400",
						"970",
						"1555",
						"2550"
					],
					"projections_percentage": [
						17.79,
						0,
						42.35,
						245.2,
						453.38,
						807.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8907
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 4.42,
					"enrolment": 815,
					"ligo": 0.79,
					"location": [
						150.897293025243,
						-33.7040327249733
					],
					"name": "The Ponds High School",
					"playspace": 50.17,
					"projections": [
						0,
						815,
						1220,
						1335,
						1450,
						1565
					],
					"projections_orig": [
						"0",
						"815",
						"1220",
						"1335",
						"1450",
						"1565"
					],
					"projections_percentage": [
						-100,
						0,
						49.69,
						63.8,
						77.91,
						92.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8911
				}
			],
			"uid": 20040
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 242
			},
			"enrolment": 4693,
			"level": "Secondary",
			"ligo": 0.72,
			"name": "Epping Secondary",
			"playspace": 50.09,
			"projections": [
				4694,
				4810,
				5600,
				6010,
				6165
			],
			"projections_percentage": [
				0,
				2.47,
				19.3,
				28.04,
				31.34
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 65
					},
					"classroomspace": 3.52,
					"enrolment": 1268,
					"ligo": 0.83,
					"location": [
						151.07447675116,
						-33.7570894156359
					],
					"name": "Cheltenham Girls High School",
					"playspace": 32.54,
					"projections": [
						1262,
						1268,
						1355,
						1540,
						1630,
						1640
					],
					"projections_orig": [
						"1262",
						"1268",
						"1355",
						"1540",
						"1630",
						"1640"
					],
					"projections_percentage": [
						-0.47,
						0,
						6.86,
						21.45,
						28.55,
						29.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8208
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 63
					},
					"classroomspace": 4.12,
					"enrolment": 1043,
					"ligo": 0.64,
					"location": [
						151.061413909389,
						-33.7326281636164
					],
					"name": "Pennant Hills High School",
					"playspace": 59.54,
					"projections": [
						1089,
						1044,
						1120,
						1245,
						1320,
						1370
					],
					"projections_orig": [
						"1089",
						"1044",
						"1120",
						"1245",
						"1320",
						"1370"
					],
					"projections_percentage": [
						4.31,
						0,
						7.28,
						19.25,
						26.44,
						31.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8438
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 58
					},
					"classroomspace": 3.05,
					"enrolment": 1228,
					"ligo": 0.5,
					"location": [
						151.051882162942,
						-33.7656746821864
					],
					"name": "Carlingford High School",
					"playspace": 52.65,
					"projections": [
						1161,
						1228,
						1080,
						1285,
						1350,
						1375
					],
					"projections_orig": [
						"1161",
						"1228",
						"1080",
						"1285",
						"1350",
						"1375"
					],
					"projections_percentage": [
						-5.46,
						0,
						-12.05,
						4.64,
						9.93,
						11.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8447
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 56
					},
					"classroomspace": 3.63,
					"enrolment": 1154,
					"ligo": 0.92,
					"location": [
						151.101404455504,
						-33.7716706592085
					],
					"name": "Epping Boys High School",
					"playspace": 55.65,
					"projections": [
						1133,
						1154,
						1255,
						1530,
						1710,
						1780
					],
					"projections_orig": [
						"1133",
						"1154",
						"1255",
						"1530",
						"1710",
						"1780"
					],
					"projections_percentage": [
						-1.82,
						0,
						8.75,
						32.58,
						48.18,
						54.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8884
				}
			],
			"uid": 20041
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 145
			},
			"enrolment": 2329,
			"level": "Secondary",
			"ligo": 0.71,
			"name": "Albury City Secondary",
			"playspace": 67.13,
			"projections": [
				2329,
				2605,
				2660,
				2650,
				2550
			],
			"projections_percentage": [
				0,
				11.85,
				14.21,
				13.78,
				9.49
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.76,
					"enrolment": 974,
					"ligo": 0.68,
					"location": [
						146.916877335582,
						-36.0733838383111
					],
					"name": "Albury High School",
					"playspace": 45.41,
					"projections": [
						1094,
						974,
						1120,
						1135,
						1125,
						1085
					],
					"projections_orig": [
						"1094",
						"974",
						"1120",
						"1135",
						"1125",
						"1085"
					],
					"projections_percentage": [
						12.32,
						0,
						14.99,
						16.53,
						15.5,
						11.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8101
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 4.21,
					"enrolment": 717,
					"ligo": 0.72,
					"location": [
						146.929941755413,
						-36.0608553991017
					],
					"name": "James Fallon High School",
					"playspace": 59.55,
					"projections": [
						737,
						717,
						750,
						770,
						770,
						740
					],
					"projections_orig": [
						"737",
						"717",
						"750",
						"770",
						"770",
						"740"
					],
					"projections_percentage": [
						2.79,
						0,
						4.6,
						7.39,
						7.39,
						3.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8266
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 39
					},
					"classroomspace": 4.34,
					"enrolment": 638,
					"ligo": 0.74,
					"location": [
						146.946260101789,
						-36.0350896207299
					],
					"name": "Murray High School",
					"playspace": 96.44,
					"projections": [
						763,
						638,
						735,
						755,
						755,
						725
					],
					"projections_orig": [
						"763",
						"638",
						"735",
						"755",
						"755",
						"725"
					],
					"projections_percentage": [
						19.59,
						0,
						15.2,
						18.34,
						18.34,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8505
				}
			],
			"uid": 20042
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 171
			},
			"enrolment": 2473,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Wagga City Secondary",
			"playspace": 68.16,
			"projections": [
				2472,
				2940,
				3015,
				2975,
				2850
			],
			"projections_percentage": [
				0,
				18.93,
				21.97,
				20.35,
				15.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.45,
					"enrolment": 1063,
					"ligo": 0.7,
					"location": [
						147.364372422241,
						-35.1236651246579
					],
					"name": "Wagga Wagga High School",
					"playspace": 38.3,
					"projections": [
						1059,
						1063,
						1210,
						1240,
						1220,
						1170
					],
					"projections_orig": [
						"1059",
						"1063",
						"1210",
						"1240",
						"1220",
						"1170"
					],
					"projections_percentage": [
						-0.38,
						0,
						13.83,
						16.65,
						14.77,
						10.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8142
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 52
					},
					"classroomspace": 6.35,
					"enrolment": 497,
					"ligo": 0.92,
					"location": [
						147.353830370895,
						-35.1427892880488
					],
					"name": "Mount Austin High School",
					"playspace": 104.24,
					"projections": [
						577,
						497,
						625,
						640,
						635,
						605
					],
					"projections_orig": [
						"577",
						"497",
						"625",
						"640",
						"635",
						"605"
					],
					"projections_percentage": [
						16.1,
						0,
						25.75,
						28.77,
						27.77,
						21.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8407
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 60
					},
					"classroomspace": 4.41,
					"enrolment": 913,
					"ligo": 0.71,
					"location": [
						147.380037750123,
						-35.1431761959343
					],
					"name": "Kooringal High School",
					"playspace": 61.94,
					"projections": [
						893,
						912,
						1105,
						1135,
						1120,
						1075
					],
					"projections_orig": [
						"893",
						"912",
						"1105",
						"1135",
						"1120",
						"1075"
					],
					"projections_percentage": [
						-2.08,
						0,
						21.16,
						24.45,
						22.81,
						17.87
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8483
				}
			],
			"uid": 20043
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 108
			},
			"enrolment": 2377,
			"level": "Secondary",
			"ligo": 0.81,
			"name": "Queanbeyan Yass Secondary",
			"playspace": 59.16,
			"projections": [
				2377,
				3010,
				3295,
				3405,
				3410
			],
			"projections_percentage": [
				0,
				26.63,
				38.62,
				43.25,
				43.46
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 5.66,
					"enrolment": 561,
					"ligo": 0.78,
					"location": [
						149.221509867627,
						-35.352353850171
					],
					"name": "Queanbeyan High School",
					"playspace": 88.31,
					"projections": [
						479,
						561,
						610,
						685,
						705,
						690
					],
					"projections_orig": [
						"479",
						"561",
						"610",
						"685",
						"705",
						"690"
					],
					"projections_percentage": [
						-14.62,
						0,
						8.73,
						22.1,
						25.67,
						22.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8216
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 25
					},
					"classroomspace": 3.76,
					"enrolment": 506,
					"ligo": 0.93,
					"location": [
						148.910748302293,
						-34.8354514172657
					],
					"name": "Yass High School",
					"playspace": 57.47,
					"projections": [
						490,
						506,
						510,
						535,
						550,
						565
					],
					"projections_orig": [
						"490",
						"506",
						"510",
						"535",
						"550",
						"565"
					],
					"projections_percentage": [
						-3.16,
						0,
						0.79,
						5.73,
						8.7,
						11.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8334
				},
				{
					"classrooms": {
						"demountable": 16,
						"permanent": 37
					},
					"classroomspace": 2.66,
					"enrolment": 1310,
					"ligo": 0.73,
					"location": [
						149.224517275548,
						-35.366122659495
					],
					"name": "Karabar High School",
					"playspace": 31.71,
					"projections": [
						1174,
						1310,
						1890,
						2075,
						2150,
						2155
					],
					"projections_orig": [
						"1174",
						"1310",
						"1890",
						"2075",
						"2150",
						"2155"
					],
					"projections_percentage": [
						-10.38,
						0,
						44.27,
						58.4,
						64.12,
						64.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8524
				}
			],
			"uid": 20044
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 281
			},
			"enrolment": 4141,
			"level": "Secondary",
			"ligo": 0.46,
			"name": "Granville Secondary",
			"playspace": 55.48,
			"projections": [
				4141,
				4650,
				5275,
				5775,
				6180
			],
			"projections_percentage": [
				0,
				12.29,
				27.38,
				39.46,
				49.24
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 45
					},
					"classroomspace": 4.2,
					"enrolment": 752,
					"ligo": 0.42,
					"location": [
						150.967290445333,
						-33.8397500855887
					],
					"name": "Merrylands High School",
					"playspace": 81.9,
					"projections": [
						779,
						752,
						800,
						865,
						930,
						980
					],
					"projections_orig": [
						"779",
						"752",
						"800",
						"865",
						"930",
						"980"
					],
					"projections_percentage": [
						3.59,
						0,
						6.38,
						15.03,
						23.67,
						30.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8227
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 40
					},
					"classroomspace": 3.93,
					"enrolment": 805,
					"ligo": 0.65,
					"location": [
						151.034423928728,
						-33.8434942286421
					],
					"name": "Auburn Girls High School",
					"playspace": 12.81,
					"projections": [
						760,
						805,
						990,
						1180,
						1295,
						1375
					],
					"projections_orig": [
						"760",
						"805",
						"990",
						"1180",
						"1295",
						"1375"
					],
					"projections_percentage": [
						-5.59,
						0,
						22.98,
						46.58,
						60.87,
						70.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8253
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 3.25,
					"enrolment": 988,
					"ligo": 0.51,
					"location": [
						150.941810676985,
						-33.8122654499948
					],
					"name": "Greystanes High School",
					"playspace": 41.6,
					"projections": [
						982,
						988,
						1050,
						1155,
						1240,
						1325
					],
					"projections_orig": [
						"982",
						"988",
						"1050",
						"1155",
						"1240",
						"1325"
					],
					"projections_percentage": [
						-0.61,
						0,
						6.28,
						16.9,
						25.51,
						34.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8385
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 5.97,
					"enrolment": 548,
					"ligo": 0.1,
					"location": [
						150.949610890861,
						-33.8336059360408
					],
					"name": "Holroyd High School",
					"playspace": 92.57,
					"projections": [
						449,
						548,
						605,
						645,
						695,
						735
					],
					"projections_orig": [
						"449",
						"548",
						"605",
						"645",
						"695",
						"735"
					],
					"projections_percentage": [
						-18.07,
						0,
						10.4,
						17.7,
						26.82,
						34.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8424
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 5.18,
					"enrolment": 526,
					"ligo": 0.59,
					"location": [
						150.995955796014,
						-33.8609016502014
					],
					"name": "Granville South Creative and Performing Arts High School",
					"playspace": 71.76,
					"projections": [
						530,
						526,
						580,
						660,
						740,
						795
					],
					"projections_orig": [
						"530",
						"526",
						"580",
						"660",
						"740",
						"795"
					],
					"projections_percentage": [
						0.76,
						0,
						10.27,
						25.48,
						40.68,
						51.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8436
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 5.69,
					"enrolment": 522,
					"ligo": 0.51,
					"location": [
						151.008156138772,
						-33.8341922851812
					],
					"name": "Granville Boys High School",
					"playspace": 32.22,
					"projections": [
						477,
						522,
						625,
						770,
						875,
						970
					],
					"projections_orig": [
						"477",
						"522",
						"625",
						"770",
						"875",
						"970"
					],
					"projections_percentage": [
						-8.62,
						0,
						19.73,
						47.51,
						67.62,
						85.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8811
				}
			],
			"uid": 20045
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 146
			},
			"enrolment": 2619,
			"level": "Secondary",
			"ligo": 0.74,
			"name": "Terrigal Secondary",
			"playspace": 43.97,
			"projections": [
				2619,
				3050,
				3140,
				3155,
				3190
			],
			"projections_percentage": [
				0,
				16.46,
				19.89,
				20.47,
				21.8
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 42
					},
					"classroomspace": 4.08,
					"enrolment": 702,
					"ligo": 0.82,
					"location": [
						151.379514092071,
						-33.4402147162488
					],
					"name": "Erina High School",
					"playspace": 63.91,
					"projections": [
						919,
						702,
						815,
						835,
						840,
						850
					],
					"projections_orig": [
						"919",
						"702",
						"815",
						"835",
						"840",
						"850"
					],
					"projections_percentage": [
						30.91,
						0,
						16.1,
						18.95,
						19.66,
						21.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8405
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 3.27,
					"enrolment": 1021,
					"ligo": 0.67,
					"location": [
						151.428360905897,
						-33.4423396444461
					],
					"name": "Terrigal High School",
					"playspace": 33.42,
					"projections": [
						1264,
						1021,
						1265,
						1305,
						1310,
						1325
					],
					"projections_orig": [
						"1264",
						"1021",
						"1265",
						"1305",
						"1310",
						"1325"
					],
					"projections_percentage": [
						23.8,
						0,
						23.9,
						27.82,
						28.31,
						29.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8533
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 45
					},
					"classroomspace": 4.06,
					"enrolment": 896,
					"ligo": 0.74,
					"location": [
						151.383403209013,
						-33.4647365562456
					],
					"name": "Kincumber High School",
					"playspace": 34.57,
					"projections": [
						886,
						896,
						970,
						1000,
						1005,
						1015
					],
					"projections_orig": [
						"886",
						"896",
						"970",
						"1000",
						"1005",
						"1015"
					],
					"projections_percentage": [
						-1.12,
						0,
						8.26,
						11.61,
						12.17,
						13.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8585
				}
			],
			"uid": 20046
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 228
			},
			"enrolment": 4152,
			"level": "Secondary",
			"ligo": 0.74,
			"name": "Gosford Secondary",
			"playspace": 37.08,
			"projections": [
				4153,
				4505,
				4615,
				4635,
				4680
			],
			"projections_percentage": [
				0,
				8.48,
				11.12,
				11.61,
				12.69
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 3.25,
					"enrolment": 1099,
					"ligo": 1,
					"location": [
						151.341741564743,
						-33.4186833394411
					],
					"name": "Gosford High School",
					"playspace": 30.35,
					"projections": [
						1110,
						1099,
						1100,
						1100,
						1100,
						1100
					],
					"projections_orig": [
						"1110",
						"1099",
						"1100",
						"1100",
						"1100",
						"1100"
					],
					"projections_percentage": [
						1,
						0,
						0.09,
						0.09,
						0.09,
						0.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8115
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 29
					},
					"classroomspace": 3.37,
					"enrolment": 576,
					"ligo": 0.87,
					"location": [
						151.296707077328,
						-33.4310001996405
					],
					"name": "Kariong Mountains High School",
					"playspace": 43.44,
					"projections": [
						440,
						576,
						620,
						640,
						645,
						655
					],
					"projections_orig": [
						"440",
						"576",
						"620",
						"640",
						"645",
						"655"
					],
					"projections_percentage": [
						-23.61,
						0,
						7.64,
						11.11,
						11.98,
						13.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8292
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 47
					},
					"classroomspace": 3.39,
					"enrolment": 769,
					"ligo": 0.5,
					"location": [
						151.335560595914,
						-33.4216037043869
					],
					"name": "Henry Kendall High School",
					"playspace": 23.86,
					"projections": [
						899,
						769,
						785,
						810,
						815,
						825
					],
					"projections_orig": [
						"899",
						"769",
						"785",
						"810",
						"815",
						"825"
					],
					"projections_percentage": [
						16.91,
						0,
						2.08,
						5.33,
						5.98,
						7.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8467
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 3.93,
					"enrolment": 745,
					"ligo": 0.78,
					"location": [
						151.370947574419,
						-33.3853137754174
					],
					"name": "Lisarow High School",
					"playspace": 47.7,
					"projections": [
						906,
						745,
						825,
						850,
						855,
						865
					],
					"projections_orig": [
						"906",
						"745",
						"825",
						"850",
						"855",
						"865"
					],
					"projections_percentage": [
						21.61,
						0,
						10.74,
						14.09,
						14.77,
						16.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8544
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 46
					},
					"classroomspace": 3.63,
					"enrolment": 963,
					"ligo": 0.57,
					"location": [
						151.333520225182,
						-33.3969166994657
					],
					"name": "Narara Valley High School",
					"playspace": 40.04,
					"projections": [
						1217,
						964,
						1175,
						1215,
						1220,
						1235
					],
					"projections_orig": [
						"1217",
						"964",
						"1175",
						"1215",
						"1220",
						"1235"
					],
					"projections_percentage": [
						26.24,
						0,
						21.89,
						26.04,
						26.56,
						28.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8591
				}
			],
			"uid": 20047
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 111
			},
			"enrolment": 1612,
			"level": "Secondary",
			"ligo": 0.95,
			"name": "Woy Woy Secondary",
			"playspace": 50.75,
			"projections": [
				1612,
				1640,
				1690,
				1715,
				1740
			],
			"projections_percentage": [
				0,
				1.74,
				4.84,
				6.39,
				7.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.91,
					"enrolment": 721,
					"ligo": 0.95,
					"location": [
						151.32487641685,
						-33.4927959218405
					],
					"name": "Brisbane Water Secondary College Woy Woy Campus",
					"playspace": 53.68,
					"projections": [
						765,
						721,
						770,
						790,
						795,
						805
					],
					"projections_orig": [
						"765",
						"721",
						"770",
						"790",
						"795",
						"805"
					],
					"projections_percentage": [
						6.1,
						0,
						6.8,
						9.57,
						10.26,
						11.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8374
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 63
					},
					"classroomspace": 4.55,
					"enrolment": 891,
					"ligo": 0.95,
					"location": [
						151.309466633195,
						-33.505763225264
					],
					"name": "Brisbane Water Secondary College Umina Campus",
					"playspace": 47.83,
					"projections": [
						886,
						891,
						870,
						900,
						920,
						935
					],
					"projections_orig": [
						"886",
						"891",
						"870",
						"900",
						"920",
						"935"
					],
					"projections_percentage": [
						-0.56,
						0,
						-2.36,
						1.01,
						3.25,
						4.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8513
				}
			],
			"uid": 20048
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 236
			},
			"enrolment": 3345,
			"level": "Secondary",
			"ligo": 0.77,
			"name": "Wyong Secondary",
			"playspace": 47.95,
			"projections": [
				3344,
				3755,
				3900,
				4005,
				4155
			],
			"projections_percentage": [
				0,
				12.29,
				16.63,
				19.77,
				24.25
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 64
					},
					"classroomspace": 5.32,
					"enrolment": 750,
					"ligo": 0.66,
					"location": [
						151.419746859582,
						-33.2820321678928
					],
					"name": "Wyong High School",
					"playspace": 47.66,
					"projections": [
						767,
						749,
						825,
						860,
						880,
						915
					],
					"projections_orig": [
						"767",
						"749",
						"825",
						"860",
						"880",
						"915"
					],
					"projections_percentage": [
						2.4,
						0,
						10.15,
						14.82,
						17.49,
						22.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8166
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 4.08,
					"enrolment": 733,
					"ligo": 0.87,
					"location": [
						151.575172670951,
						-33.1877943627311
					],
					"name": "Lake Munmorah High School",
					"playspace": 54.96,
					"projections": [
						900,
						733,
						795,
						815,
						825,
						850
					],
					"projections_orig": [
						"900",
						"733",
						"795",
						"815",
						"825",
						"850"
					],
					"projections_percentage": [
						22.78,
						0,
						8.46,
						11.19,
						12.55,
						15.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8279
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 54
					},
					"classroomspace": 3.73,
					"enrolment": 1012,
					"ligo": 0.68,
					"location": [
						151.507256983904,
						-33.241464063846
					],
					"name": "Gorokan High School",
					"playspace": 49.77,
					"projections": [
						1128,
						1012,
						1130,
						1195,
						1255,
						1310
					],
					"projections_orig": [
						"1128",
						"1012",
						"1130",
						"1195",
						"1255",
						"1310"
					],
					"projections_percentage": [
						11.46,
						0,
						11.66,
						18.08,
						24.01,
						29.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8515
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 68
					},
					"classroomspace": 4.92,
					"enrolment": 850,
					"ligo": 0.87,
					"location": [
						151.513681782103,
						-33.2158662791632
					],
					"name": "Northlakes High School",
					"playspace": 39.42,
					"projections": [
						1113,
						850,
						1005,
						1030,
						1045,
						1080
					],
					"projections_orig": [
						"1113",
						"850",
						"1005",
						"1030",
						"1045",
						"1080"
					],
					"projections_percentage": [
						30.94,
						0,
						18.24,
						21.18,
						22.94,
						27.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8547
				}
			],
			"uid": 20049
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 160
			},
			"enrolment": 2681,
			"level": "Secondary",
			"ligo": 0.79,
			"name": "Tuggerah Lakes Secondary",
			"playspace": 44.61,
			"projections": [
				2682,
				2760,
				2895,
				2965,
				2990
			],
			"projections_percentage": [
				0,
				2.91,
				7.94,
				10.55,
				11.48
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 3.17,
					"enrolment": 1064,
					"ligo": 0.76,
					"location": [
						151.45567281554,
						-33.39632602257
					],
					"name": "Tuggerah Lakes Secondary College Tumbi Umbi Campus",
					"playspace": 42.81,
					"projections": [
						1022,
						1064,
						1120,
						1180,
						1220,
						1230
					],
					"projections_orig": [
						"1022",
						"1064",
						"1120",
						"1180",
						"1220",
						"1230"
					],
					"projections_percentage": [
						-3.95,
						0,
						5.26,
						10.9,
						14.66,
						15.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8274
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 56
					},
					"classroomspace": 4.47,
					"enrolment": 865,
					"ligo": 0.87,
					"location": [
						151.475664086348,
						-33.3727883548988
					],
					"name": "Tuggerah Lakes Secondary College The Entrance Campus",
					"playspace": 56.43,
					"projections": [
						886,
						866,
						885,
						925,
						945,
						945
					],
					"projections_orig": [
						"886",
						"866",
						"885",
						"925",
						"945",
						"945"
					],
					"projections_percentage": [
						2.31,
						0,
						2.19,
						6.81,
						9.12,
						9.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8465
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 53
					},
					"classroomspace": 4.3,
					"enrolment": 752,
					"ligo": 0.75,
					"location": [
						151.425852406093,
						-33.3428807476129
					],
					"name": "Tuggerah Lakes Secondary College Berkeley Vale Campus",
					"playspace": 34.6,
					"projections": [
						807,
						752,
						755,
						790,
						800,
						815
					],
					"projections_orig": [
						"807",
						"752",
						"755",
						"790",
						"800",
						"815"
					],
					"projections_percentage": [
						7.31,
						0,
						0.4,
						5.05,
						6.38,
						8.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8563
				}
			],
			"uid": 20050
		},
		{
			"classrooms": {
				"demountable": 30,
				"permanent": 249
			},
			"enrolment": 4590,
			"level": "Secondary",
			"ligo": 0.74,
			"name": "Newcastle West Secondary",
			"playspace": 60.04,
			"projections": [
				4590,
				4610,
				4785,
				4900,
				4930
			],
			"projections_percentage": [
				0,
				0.44,
				4.25,
				6.75,
				7.41
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 43
					},
					"classroomspace": 3.19,
					"enrolment": 1066,
					"ligo": 0.72,
					"location": [
						151.667736658152,
						-32.8925446035538
					],
					"name": "Callaghan College Wallsend Campus",
					"playspace": 59.49,
					"projections": [
						976,
						1066,
						1085,
						1135,
						1175,
						1170
					],
					"projections_orig": [
						"976",
						"1066",
						"1085",
						"1135",
						"1175",
						"1170"
					],
					"projections_percentage": [
						-8.44,
						0,
						1.78,
						6.47,
						10.23,
						9.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8259
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 30
					},
					"classroomspace": 4.79,
					"enrolment": 557,
					"ligo": 0.77,
					"location": [
						151.582405346766,
						-32.911952328648
					],
					"name": "West Wallsend High School",
					"playspace": 116.3,
					"projections": [
						633,
						557,
						610,
						640,
						645,
						655
					],
					"projections_orig": [
						"633",
						"557",
						"610",
						"640",
						"645",
						"655"
					],
					"projections_percentage": [
						13.64,
						0,
						9.52,
						14.9,
						15.8,
						17.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8411
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 39
					},
					"classroomspace": 3.67,
					"enrolment": 801,
					"ligo": 0.68,
					"location": [
						151.640919569757,
						-32.9266354898411
					],
					"name": "Glendale High School",
					"playspace": 50.4,
					"projections": [
						798,
						801,
						800,
						805,
						805,
						810
					],
					"projections_orig": [
						"798",
						"801",
						"800",
						"805",
						"805",
						"810"
					],
					"projections_percentage": [
						-0.37,
						0,
						-0.12,
						0.5,
						0.5,
						1.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8466
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 5.17,
					"enrolment": 614,
					"ligo": 0.82,
					"location": [
						151.728474109456,
						-32.9050709166373
					],
					"name": "Callaghan College Waratah Technology Campus",
					"playspace": 33.97,
					"projections": [
						507,
						614,
						615,
						655,
						690,
						695
					],
					"projections_orig": [
						"507",
						"614",
						"615",
						"655",
						"690",
						"695"
					],
					"projections_percentage": [
						-17.43,
						0,
						0.16,
						6.68,
						12.38,
						13.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8508
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 50
					},
					"classroomspace": 4.59,
					"enrolment": 817,
					"ligo": 0.68,
					"location": [
						151.695996265179,
						-32.9017551154826
					],
					"name": "Callaghan College Jesmond Campus",
					"playspace": 48.93,
					"projections": [
						778,
						817,
						805,
						845,
						880,
						890
					],
					"projections_orig": [
						"778",
						"817",
						"805",
						"845",
						"880",
						"890"
					],
					"projections_percentage": [
						-4.77,
						0,
						-1.47,
						3.43,
						7.71,
						8.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8880
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 37
					},
					"classroomspace": 3.51,
					"enrolment": 735,
					"ligo": 0.75,
					"location": [
						151.670874985685,
						-32.9513042207077
					],
					"name": "Cardiff High School",
					"playspace": 51.13,
					"projections": [
						706,
						735,
						695,
						705,
						705,
						710
					],
					"projections_orig": [
						"706",
						"735",
						"695",
						"705",
						"705",
						"710"
					],
					"projections_percentage": [
						-3.95,
						0,
						-5.44,
						-4.08,
						-4.08,
						-3.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8903
				}
			],
			"uid": 20051
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 241
			},
			"enrolment": 4365,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Newcastle Secondary",
			"playspace": 25.84,
			"projections": [
				4366,
				4380,
				4505,
				4595,
				4660
			],
			"projections_percentage": [
				0,
				0.32,
				3.18,
				5.25,
				6.73
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 53
					},
					"classroomspace": 3.13,
					"enrolment": 1102,
					"ligo": 0.75,
					"location": [
						151.70751687095,
						-32.9488699862183
					],
					"name": "Kotara High School",
					"playspace": 19.09,
					"projections": [
						1044,
						1103,
						1080,
						1110,
						1125,
						1135
					],
					"projections_orig": [
						"1044",
						"1103",
						"1080",
						"1110",
						"1125",
						"1135"
					],
					"projections_percentage": [
						-5.35,
						0,
						-2.09,
						0.63,
						1.99,
						2.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8423
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 3.19,
					"enrolment": 1115,
					"ligo": 0.66,
					"location": [
						151.722382564768,
						-32.9173244107452
					],
					"name": "Lambton High School",
					"playspace": 16.44,
					"projections": [
						1041,
						1115,
						1100,
						1145,
						1185,
						1195
					],
					"projections_orig": [
						"1041",
						"1115",
						"1100",
						"1145",
						"1185",
						"1195"
					],
					"projections_percentage": [
						-6.64,
						0,
						-1.35,
						2.69,
						6.28,
						7.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8482
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 74
					},
					"classroomspace": 4.51,
					"enrolment": 1073,
					"ligo": 0.59,
					"location": [
						151.758030948638,
						-32.9325749251641
					],
					"name": "Newcastle High School",
					"playspace": 29.01,
					"projections": [
						1054,
						1073,
						1125,
						1175,
						1210,
						1255
					],
					"projections_orig": [
						"1054",
						"1073",
						"1125",
						"1175",
						"1210",
						"1255"
					],
					"projections_percentage": [
						-1.77,
						0,
						4.85,
						9.51,
						12.77,
						16.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8509
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 57
					},
					"classroomspace": 3.43,
					"enrolment": 1075,
					"ligo": 1,
					"location": [
						151.736183470305,
						-32.9297900395923
					],
					"name": "Merewether High School",
					"playspace": 38.81,
					"projections": [
						1090,
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"projections_orig": [
						"1090",
						"1075",
						"1075",
						"1075",
						"1075",
						"1075"
					],
					"projections_percentage": [
						1.4,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8510
				}
			],
			"uid": 20052
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 145
			},
			"enrolment": 2390,
			"level": "Secondary",
			"ligo": 0.82,
			"name": "Cessnock-Kurri Secondary",
			"playspace": 42.58,
			"projections": [
				2391,
				2505,
				2615,
				2705,
				2755
			],
			"projections_percentage": [
				0,
				4.77,
				9.37,
				13.13,
				15.22
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 56
					},
					"classroomspace": 5.81,
					"enrolment": 556,
					"ligo": 0.83,
					"location": [
						151.369127015942,
						-32.8419175506586
					],
					"name": "Cessnock High School",
					"playspace": 34.35,
					"projections": [
						595,
						557,
						590,
						615,
						630,
						640
					],
					"projections_orig": [
						"595",
						"557",
						"590",
						"615",
						"630",
						"640"
					],
					"projections_percentage": [
						6.82,
						0,
						5.92,
						10.41,
						13.11,
						14.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8108
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 42
					},
					"classroomspace": 3.58,
					"enrolment": 872,
					"ligo": 0.8,
					"location": [
						151.486876024136,
						-32.8109154171396
					],
					"name": "Kurri Kurri High School",
					"playspace": 35.63,
					"projections": [
						815,
						872,
						865,
						900,
						930,
						950
					],
					"projections_orig": [
						"815",
						"872",
						"865",
						"900",
						"930",
						"950"
					],
					"projections_percentage": [
						-6.54,
						0,
						-0.8,
						3.21,
						6.65,
						8.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8177
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 47
					},
					"classroomspace": 3.62,
					"enrolment": 962,
					"ligo": 0.82,
					"location": [
						151.331428079033,
						-32.8291788676724
					],
					"name": "Mount View High School",
					"playspace": 57.76,
					"projections": [
						1038,
						962,
						1050,
						1100,
						1145,
						1165
					],
					"projections_orig": [
						"1038",
						"962",
						"1050",
						"1100",
						"1145",
						"1165"
					],
					"projections_percentage": [
						7.9,
						0,
						9.15,
						14.35,
						19.02,
						21.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8574
				}
			],
			"uid": 20053
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 167
			},
			"enrolment": 2391,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Tweed Secondary",
			"playspace": 73.75,
			"projections": [
				2391,
				2865,
				3010,
				3070,
				3080
			],
			"projections_percentage": [
				0,
				19.82,
				25.89,
				28.4,
				28.82
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 41
					},
					"classroomspace": 4.01,
					"enrolment": 595,
					"ligo": 0.67,
					"location": [
						153.524851233424,
						-28.2162686697868
					],
					"name": "Banora Point High School",
					"playspace": 65.41,
					"projections": [
						543,
						595,
						600,
						625,
						645,
						660
					],
					"projections_orig": [
						"543",
						"595",
						"600",
						"625",
						"645",
						"660"
					],
					"projections_percentage": [
						-8.74,
						0,
						0.84,
						5.04,
						8.4,
						10.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8282
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 5.2,
					"enrolment": 757,
					"ligo": 0.71,
					"location": [
						153.541435869962,
						-28.1949614856715
					],
					"name": "Tweed River High School",
					"playspace": 106,
					"projections": [
						971,
						757,
						980,
						1020,
						1050,
						1070
					],
					"projections_orig": [
						"971",
						"757",
						"980",
						"1020",
						"1050",
						"1070"
					],
					"projections_percentage": [
						28.27,
						0,
						29.46,
						34.74,
						38.71,
						41.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8370
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 67
					},
					"classroomspace": 3.97,
					"enrolment": 1039,
					"ligo": 0.87,
					"location": [
						153.571345111842,
						-28.2665960032837
					],
					"name": "Kingscliff High School",
					"playspace": 49.84,
					"projections": [
						1254,
						1039,
						1285,
						1365,
						1375,
						1350
					],
					"projections_orig": [
						"1254",
						"1039",
						"1285",
						"1365",
						"1375",
						"1350"
					],
					"projections_percentage": [
						20.69,
						0,
						23.68,
						31.38,
						32.34,
						29.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8579
				}
			],
			"uid": 20054
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 379
			},
			"enrolment": 6725,
			"level": "Secondary",
			"ligo": 0.75,
			"name": "Lake Macquarie Secondary",
			"playspace": 63.18,
			"projections": [
				6725,
				6865,
				6960,
				6950,
				6990
			],
			"projections_percentage": [
				0,
				2.08,
				3.49,
				3.35,
				3.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 42
					},
					"classroomspace": 3.98,
					"enrolment": 921,
					"ligo": 0.77,
					"location": [
						151.660166891785,
						-33.0262683019845
					],
					"name": "Belmont High School",
					"playspace": 33.83,
					"projections": [
						1072,
						921,
						995,
						1000,
						1000,
						1005
					],
					"projections_orig": [
						"1072",
						"921",
						"995",
						"1000",
						"1000",
						"1005"
					],
					"projections_percentage": [
						16.4,
						0,
						8.03,
						8.58,
						8.58,
						9.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8203
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 5.63,
					"enrolment": 398,
					"ligo": 0.78,
					"location": [
						151.614234981758,
						-32.9756273615395
					],
					"name": "Lake Macquarie High School",
					"playspace": 131.5,
					"projections": [
						508,
						398,
						410,
						415,
						410,
						415
					],
					"projections_orig": [
						"508",
						"398",
						"410",
						"415",
						"410",
						"415"
					],
					"projections_percentage": [
						27.64,
						0,
						3.02,
						4.27,
						3.02,
						4.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8210
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 57
					},
					"classroomspace": 4.54,
					"enrolment": 770,
					"ligo": 0.43,
					"location": [
						151.691506500136,
						-32.9856677728013
					],
					"name": "Hunter Sports High School",
					"playspace": 99.26,
					"projections": [
						891,
						770,
						750,
						760,
						755,
						765
					],
					"projections_orig": [
						"891",
						"770",
						"750",
						"760",
						"755",
						"765"
					],
					"projections_percentage": [
						15.71,
						0,
						-2.6,
						-1.3,
						-1.95,
						-0.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8233
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 32
					},
					"classroomspace": 3.27,
					"enrolment": 679,
					"ligo": 0.88,
					"location": [
						151.640929112975,
						-33.1035003056768
					],
					"name": "Swansea High School",
					"playspace": 73.68,
					"projections": [
						650,
						679,
						660,
						665,
						665,
						670
					],
					"projections_orig": [
						"650",
						"679",
						"660",
						"665",
						"665",
						"670"
					],
					"projections_percentage": [
						-4.27,
						0,
						-2.8,
						-2.06,
						-2.06,
						-1.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8389
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 54
					},
					"classroomspace": 3.86,
					"enrolment": 959,
					"ligo": 0.65,
					"location": [
						151.713904528876,
						-32.9719323658965
					],
					"name": "Whitebridge High School",
					"playspace": 40.99,
					"projections": [
						1044,
						959,
						1005,
						1020,
						1020,
						1025
					],
					"projections_orig": [
						"1044",
						"959",
						"1005",
						"1020",
						"1020",
						"1025"
					],
					"projections_percentage": [
						8.86,
						0,
						4.8,
						6.36,
						6.36,
						6.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8390
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.56,
					"enrolment": 734,
					"ligo": 0.89,
					"location": [
						151.487843953477,
						-33.104707144364
					],
					"name": "Morisset High School",
					"playspace": 63.99,
					"projections": [
						836,
						734,
						795,
						815,
						815,
						810
					],
					"projections_orig": [
						"836",
						"734",
						"795",
						"815",
						"815",
						"810"
					],
					"projections_percentage": [
						13.9,
						0,
						8.31,
						11.04,
						11.04,
						10.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8413
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 55
					},
					"classroomspace": 3.24,
					"enrolment": 1301,
					"ligo": 0.83,
					"location": [
						151.652966859827,
						-32.9687051245795
					],
					"name": "Warners Bay High School",
					"playspace": 35.97,
					"projections": [
						1342,
						1301,
						1305,
						1330,
						1330,
						1340
					],
					"projections_orig": [
						"1342",
						"1301",
						"1305",
						"1330",
						"1330",
						"1340"
					],
					"projections_percentage": [
						3.15,
						0,
						0.31,
						2.23,
						2.23,
						3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8440
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 3.24,
					"enrolment": 963,
					"ligo": 0.79,
					"location": [
						151.583749396501,
						-33.0087108965174
					],
					"name": "Toronto High School",
					"playspace": 26.19,
					"projections": [
						891,
						963,
						945,
						955,
						955,
						960
					],
					"projections_orig": [
						"891",
						"963",
						"945",
						"955",
						"955",
						"960"
					],
					"projections_percentage": [
						-7.48,
						0,
						-1.87,
						-0.83,
						-0.83,
						-0.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8909
				}
			],
			"uid": 20055
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 145
			},
			"enrolment": 2745,
			"level": "Secondary",
			"ligo": 0.8,
			"name": "Port Stephens Secondary",
			"playspace": 53.77,
			"projections": [
				2745,
				2880,
				3045,
				3090,
				3110
			],
			"projections_percentage": [
				0,
				4.92,
				10.93,
				12.57,
				13.3
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 47
					},
					"classroomspace": 3.97,
					"enrolment": 792,
					"ligo": 0.63,
					"location": [
						151.733405087367,
						-32.7811706949422
					],
					"name": "Hunter River High School",
					"playspace": 65.93,
					"projections": [
						693,
						792,
						835,
						870,
						880,
						885
					],
					"projections_orig": [
						"693",
						"792",
						"835",
						"870",
						"880",
						"885"
					],
					"projections_percentage": [
						-12.5,
						0,
						5.43,
						9.85,
						11.11,
						11.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8219
				},
				{
					"classrooms": {
						"demountable": 12,
						"permanent": 53
					},
					"classroomspace": 3.88,
					"enrolment": 1206,
					"ligo": 0.92,
					"location": [
						152.112364453151,
						-32.7356385478459
					],
					"name": "Tomaree High School",
					"playspace": 49.46,
					"projections": [
						1266,
						1206,
						1290,
						1380,
						1405,
						1420
					],
					"projections_orig": [
						"1266",
						"1206",
						"1290",
						"1380",
						"1405",
						"1420"
					],
					"projections_percentage": [
						4.98,
						0,
						6.97,
						14.43,
						16.5,
						17.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8502
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 45
					},
					"classroomspace": 3.94,
					"enrolment": 747,
					"ligo": 0.85,
					"location": [
						151.766875625528,
						-32.7632252002387
					],
					"name": "Irrawang High School",
					"playspace": 45.93,
					"projections": [
						887,
						747,
						755,
						795,
						805,
						805
					],
					"projections_orig": [
						"887",
						"747",
						"755",
						"795",
						"805",
						"805"
					],
					"projections_percentage": [
						18.74,
						0,
						1.07,
						6.43,
						7.76,
						7.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8562
				}
			],
			"uid": 20056
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 213
			},
			"enrolment": 3921,
			"level": "Secondary",
			"ligo": 0.78,
			"name": "Maitland Secondary",
			"playspace": 37.27,
			"projections": [
				3921,
				4350,
				4535,
				4620,
				4685
			],
			"projections_percentage": [
				0,
				10.94,
				15.66,
				17.83,
				19.48
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 48
					},
					"classroomspace": 3.26,
					"enrolment": 899,
					"ligo": 0.75,
					"location": [
						151.596998211836,
						-32.7470143856334
					],
					"name": "Maitland High School",
					"playspace": 18.63,
					"projections": [
						856,
						899,
						940,
						960,
						970,
						975
					],
					"projections_orig": [
						"856",
						"899",
						"940",
						"960",
						"970",
						"975"
					],
					"projections_percentage": [
						-4.78,
						0,
						4.56,
						6.79,
						7.9,
						8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8126
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 54
					},
					"classroomspace": 2.95,
					"enrolment": 1274,
					"ligo": 0.61,
					"location": [
						151.591138306447,
						-32.744242443947
					],
					"name": "Maitland Grossmann High School",
					"playspace": 26.31,
					"projections": [
						1254,
						1274,
						1425,
						1495,
						1520,
						1545
					],
					"projections_orig": [
						"1254",
						"1274",
						"1425",
						"1495",
						"1520",
						"1545"
					],
					"projections_percentage": [
						-1.57,
						0,
						11.85,
						17.35,
						19.31,
						21.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8127
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 4.02,
					"enrolment": 713,
					"ligo": 0.87,
					"location": [
						151.660589897752,
						-32.7980756687372
					],
					"name": "Francis Greenway High School",
					"playspace": 57.25,
					"projections": [
						812,
						713,
						810,
						860,
						880,
						895
					],
					"projections_orig": [
						"812",
						"713",
						"810",
						"860",
						"880",
						"895"
					],
					"projections_percentage": [
						13.88,
						0,
						13.6,
						20.62,
						23.42,
						25.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8439
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 65
					},
					"classroomspace": 3.93,
					"enrolment": 1035,
					"ligo": 0.89,
					"location": [
						151.531920558882,
						-32.7111545152755
					],
					"name": "Rutherford High School",
					"playspace": 46.9,
					"projections": [
						1150,
						1035,
						1175,
						1220,
						1250,
						1270
					],
					"projections_orig": [
						"1150",
						"1035",
						"1175",
						"1220",
						"1250",
						"1270"
					],
					"projections_percentage": [
						11.11,
						0,
						13.53,
						17.87,
						20.77,
						22.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8572
				}
			],
			"uid": 20057
		},
		{
			"classrooms": {
				"demountable": 25,
				"permanent": 287
			},
			"enrolment": 5007,
			"level": "Secondary",
			"ligo": 0.77,
			"name": "South West Growth Area (North) Secondary",
			"playspace": 252.35,
			"projections": [
				5007,
				6495,
				8340,
				10650,
				13250
			],
			"projections_percentage": [
				0,
				29.72,
				66.57,
				112.7,
				164.63
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 44
					},
					"classroomspace": 3.36,
					"enrolment": 955,
					"ligo": 1,
					"location": [
						150.892377073846,
						-33.9696727971773
					],
					"name": "Hurlstone Agricultural High School",
					"playspace": 1256.73,
					"projections": [
						986,
						955,
						955,
						950,
						945,
						930
					],
					"projections_orig": [
						"986",
						"955",
						"955",
						"950",
						"945",
						"930"
					],
					"projections_percentage": [
						3.25,
						0,
						0,
						-0.52,
						-1.05,
						-2.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8121
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 43
					},
					"classroomspace": 4.77,
					"enrolment": 662,
					"ligo": 0.66,
					"location": [
						150.87256149969,
						-34.0052146068853
					],
					"name": "Ingleburn High School",
					"playspace": 69.54,
					"projections": [
						795,
						662,
						855,
						1145,
						1445,
						1790
					],
					"projections_orig": [
						"795",
						"662",
						"855",
						"1145",
						"1445",
						"1790"
					],
					"projections_percentage": [
						20.09,
						0,
						29.15,
						72.96,
						118.28,
						170.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8262
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 49
					},
					"classroomspace": 2.96,
					"enrolment": 1194,
					"ligo": 0.8,
					"location": [
						150.843454750446,
						-33.9452281704985
					],
					"name": "John Edmondson High School",
					"playspace": 26.25,
					"projections": [
						1105,
						1194,
						2185,
						3455,
						5220,
						7135
					],
					"projections_orig": [
						"1105",
						"1194",
						"2185",
						"3455",
						"5220",
						"7135"
					],
					"projections_percentage": [
						-7.45,
						0,
						83,
						189.36,
						337.19,
						497.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8290
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 4.51,
					"enrolment": 797,
					"ligo": 0.76,
					"location": [
						150.894608350515,
						-33.9528351557082
					],
					"name": "Casula High School",
					"playspace": 74.98,
					"projections": [
						664,
						797,
						865,
						980,
						1075,
						1220
					],
					"projections_orig": [
						"664",
						"797",
						"865",
						"980",
						"1075",
						"1220"
					],
					"projections_percentage": [
						-16.69,
						0,
						8.53,
						22.96,
						34.88,
						53.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8476
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 11.71,
					"enrolment": 294,
					"ligo": 0.67,
					"location": [
						150.892351050242,
						-33.9874604762047
					],
					"name": "James Meehan High School",
					"playspace": 65.31,
					"projections": [
						334,
						294,
						385,
						400,
						415,
						440
					],
					"projections_orig": [
						"334",
						"294",
						"385",
						"400",
						"415",
						"440"
					],
					"projections_percentage": [
						13.61,
						0,
						30.95,
						36.05,
						41.16,
						49.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8497
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 44
					},
					"classroomspace": 3.04,
					"enrolment": 1105,
					"ligo": 0.47,
					"location": [
						150.886219647293,
						-33.997866060942
					],
					"name": "Macquarie Fields High School",
					"playspace": 21.31,
					"projections": [
						1071,
						1105,
						1250,
						1410,
						1550,
						1735
					],
					"projections_orig": [
						"1071",
						"1105",
						"1250",
						"1410",
						"1550",
						"1735"
					],
					"projections_percentage": [
						-3.08,
						0,
						13.12,
						27.6,
						40.27,
						57.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8553
				}
			],
			"uid": 20058
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 213
			},
			"enrolment": 2025,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Inner Western Plains Network",
			"playspace": 311.03,
			"projections": [
				2026,
				2093,
				2033,
				1983,
				1973
			],
			"projections_percentage": [
				0,
				3.31,
				0.35,
				-2.12,
				-2.62
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 5.9,
					"enrolment": 108,
					"ligo": 1,
					"location": [
						149.069244423571,
						-30.9504523787765
					],
					"name": "Baradine Central School",
					"playspace": 139.94,
					"projections": [
						134,
						109,
						110,
						110,
						105,
						110
					],
					"projections_orig": [
						"134",
						"109",
						"110",
						"110",
						"105",
						"110"
					],
					"projections_percentage": [
						22.94,
						0,
						0.92,
						0.92,
						-3.67,
						0.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1130
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 9.43,
					"enrolment": 67,
					"ligo": 1,
					"location": [
						149.376032333899,
						-31.5532803268171
					],
					"name": "Binnaway Central School",
					"playspace": 273.75,
					"projections": [
						100,
						67,
						75,
						75,
						75,
						75
					],
					"projections_orig": [
						"100",
						"67",
						"75",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						49.25,
						0,
						11.94,
						11.94,
						11.94,
						11.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1237
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.54,
					"enrolment": 304,
					"ligo": 1,
					"location": [
						149.281687122708,
						-31.2794543726138
					],
					"name": "Coonabarabran Public School",
					"playspace": 65.67,
					"projections": [
						309,
						304,
						335,
						310,
						305,
						310
					],
					"projections_orig": [
						"309",
						"304",
						"335",
						"310",
						"305",
						"310"
					],
					"projections_percentage": [
						1.64,
						0,
						10.2,
						1.97,
						0.33,
						1.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1630
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 5.56,
					"enrolment": 195,
					"ligo": 1,
					"location": [
						148.387141157679,
						-30.9594382561554
					],
					"name": "Coonamble Public School",
					"playspace": 258.98,
					"projections": [
						219,
						195,
						215,
						185,
						185,
						185
					],
					"projections_orig": [
						"219",
						"195",
						"215",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						12.31,
						0,
						10.26,
						-5.13,
						-5.13,
						-5.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1631
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.19,
					"enrolment": 201,
					"ligo": 1,
					"location": [
						148.664138785053,
						-31.7075009234984
					],
					"name": "Gilgandra Public School",
					"playspace": 53.83,
					"projections": [
						201,
						201,
						190,
						185,
						185,
						185
					],
					"projections_orig": [
						"201",
						"201",
						"190",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						0,
						0,
						-5.47,
						-7.96,
						-7.96,
						-7.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1979
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 11.72,
					"enrolment": 74,
					"ligo": 0.93,
					"location": [
						148.475802940521,
						-31.3327606788151
					],
					"name": "Gulargambone Central School",
					"playspace": 204.88,
					"projections": [
						66,
						74,
						75,
						75,
						75,
						75
					],
					"projections_orig": [
						"66",
						"74",
						"75",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						-10.81,
						0,
						1.35,
						1.35,
						1.35,
						1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2094
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.62,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						147.871379871191,
						-30.9309645807459
					],
					"name": "Quambone Public School",
					"playspace": 710.49,
					"projections": [
						23,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						53.33,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2919
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 8.67,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						148.910762998736,
						-31.4349109320988
					],
					"name": "Tooraweenah Public School",
					"playspace": 1294.51,
					"projections": [
						35,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"35",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						52.17,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3242
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 11.22,
					"enrolment": 198,
					"ligo": 1,
					"location": [
						147.836595797128,
						-31.7040702841512
					],
					"name": "Warren Central School",
					"playspace": 311.28,
					"projections": [
						247,
						198,
						180,
						175,
						175,
						180
					],
					"projections_orig": [
						"247",
						"198",
						"180",
						"175",
						"175",
						"180"
					],
					"projections_percentage": [
						24.75,
						0,
						-9.09,
						-11.62,
						-11.62,
						-9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3392
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 21
					},
					"classroomspace": 5.14,
					"enrolment": 397,
					"ligo": 1,
					"location": [
						149.283298904734,
						-31.28344767585
					],
					"name": "Coonabarabran High School",
					"playspace": 83.23,
					"projections": [
						424,
						397,
						385,
						380,
						370,
						355
					],
					"projections_orig": [
						"424",
						"397",
						"385",
						"380",
						"370",
						"355"
					],
					"projections_percentage": [
						6.8,
						0,
						-3.02,
						-4.28,
						-6.8,
						-10.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8347
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 33
					},
					"classroomspace": 9.25,
					"enrolment": 240,
					"ligo": 1,
					"location": [
						148.665643838396,
						-31.7052082654448
					],
					"name": "Gilgandra High School",
					"playspace": 229.02,
					"projections": [
						327,
						240,
						295,
						290,
						270,
						270
					],
					"projections_orig": [
						"327",
						"240",
						"295",
						"290",
						"270",
						"270"
					],
					"projections_percentage": [
						36.25,
						0,
						22.92,
						20.83,
						12.5,
						12.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8349
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 26
					},
					"classroomspace": 10.47,
					"enrolment": 203,
					"ligo": 0.96,
					"location": [
						148.391287383533,
						-30.9551865656227
					],
					"name": "Coonamble High School",
					"playspace": 106.76,
					"projections": [
						210,
						203,
						195,
						210,
						200,
						190
					],
					"projections_orig": [
						"210",
						"203",
						"195",
						"210",
						"200",
						"190"
					],
					"projections_percentage": [
						3.45,
						0,
						-3.94,
						3.45,
						-1.48,
						-6.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8451
				}
			],
			"uid": 30008
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 491
			},
			"enrolment": 6620,
			"level": "Combined",
			"ligo": 1,
			"name": "Lachlan Network",
			"playspace": 329.27,
			"projections": [
				6619,
				6668,
				6313,
				5963,
				5653
			],
			"projections_percentage": [
				0,
				0.74,
				-4.62,
				-9.91,
				-14.59
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.31,
					"enrolment": 50,
					"ligo": 1,
					"location": [
						147.678392635967,
						-33.3623139308499
					],
					"name": "Bedgerebong Public School",
					"playspace": 689.27,
					"projections": [
						36,
						50,
						50,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"50",
						"50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-28,
						0,
						0,
						-50,
						-50,
						-50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1164
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 14.5,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						147.798625523471,
						-33.1055259135789
					],
					"name": "Bogan Gate Public School",
					"playspace": 2702.18,
					"projections": [
						26,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						136.36,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1274
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.51,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						147.744499396931,
						-33.8448368721891
					],
					"name": "Caragabal Public School",
					"playspace": 442.46,
					"projections": [
						14,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-48.15,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1503
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.04,
					"enrolment": 281,
					"ligo": 1,
					"location": [
						147.149190252987,
						-33.0846515029126
					],
					"name": "Condobolin Public School",
					"playspace": 85.8,
					"projections": [
						273,
						281,
						265,
						245,
						230,
						215
					],
					"projections_orig": [
						"273",
						"281",
						"265",
						"245",
						"230",
						"215"
					],
					"projections_percentage": [
						-2.85,
						0,
						-5.69,
						-12.81,
						-18.15,
						-23.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1609
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 3.57,
					"enrolment": 391,
					"ligo": 1,
					"location": [
						148.690201114581,
						-33.8364078115025
					],
					"name": "Cowra Public School",
					"playspace": 24.46,
					"projections": [
						327,
						391,
						340,
						310,
						285,
						260
					],
					"projections_orig": [
						"327",
						"391",
						"340",
						"310",
						"285",
						"260"
					],
					"projections_percentage": [
						-16.37,
						0,
						-13.04,
						-20.72,
						-27.11,
						-33.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1671
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 10.61,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						148.368379147457,
						-33.4234041810687
					],
					"name": "Eugowra Public School",
					"playspace": 817.3,
					"projections": [
						27,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1870
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.71,
					"enrolment": 297,
					"ligo": 1,
					"location": [
						148.005849837739,
						-33.3871982665195
					],
					"name": "Forbes Public School",
					"playspace": 97.01,
					"projections": [
						282,
						297,
						285,
						250,
						235,
						220
					],
					"projections_orig": [
						"282",
						"297",
						"285",
						"250",
						"235",
						"220"
					],
					"projections_percentage": [
						-5.05,
						0,
						-4.04,
						-15.82,
						-20.88,
						-25.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1926
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 16.66,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						148.400656896921,
						-33.9976358120619
					],
					"name": "Greenethorpe Public School",
					"playspace": 529.94,
					"projections": [
						25,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						108.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2070
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.41,
					"enrolment": 191,
					"ligo": 1,
					"location": [
						148.167304299736,
						-33.8930922518073
					],
					"name": "Grenfell Public School",
					"playspace": 161.77,
					"projections": [
						188,
						191,
						205,
						180,
						170,
						160
					],
					"projections_orig": [
						"188",
						"191",
						"205",
						"180",
						"170",
						"160"
					],
					"projections_percentage": [
						-1.57,
						0,
						7.33,
						-5.76,
						-10.99,
						-16.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2082
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 5.63,
					"enrolment": 258,
					"ligo": 1,
					"location": [
						146.374498163008,
						-33.2946942000795
					],
					"name": "Lake Cargelligo Central School",
					"playspace": 51.99,
					"projections": [
						263,
						258,
						235,
						215,
						200,
						190
					],
					"projections_orig": [
						"263",
						"258",
						"235",
						"215",
						"200",
						"190"
					],
					"projections_percentage": [
						1.94,
						0,
						-8.91,
						-16.67,
						-22.48,
						-26.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2359
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.31,
					"enrolment": 310,
					"ligo": 1,
					"location": [
						148.243832243582,
						-32.2302282930769
					],
					"name": "Narromine Public School",
					"playspace": 36.62,
					"projections": [
						422,
						310,
						350,
						370,
						380,
						390
					],
					"projections_orig": [
						"422",
						"310",
						"350",
						"370",
						"380",
						"390"
					],
					"projections_percentage": [
						36.13,
						0,
						12.9,
						19.35,
						22.58,
						25.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2713
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.26,
					"enrolment": 132,
					"ligo": 1,
					"location": [
						147.194978320502,
						-31.5685453311989
					],
					"name": "Nyngan Public School",
					"playspace": 320.99,
					"projections": [
						151,
						132,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"151",
						"132",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						14.39,
						0,
						-1.52,
						-1.52,
						-1.52,
						-1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2785
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 21
					},
					"classroomspace": 3.08,
					"enrolment": 410,
					"ligo": 1,
					"location": [
						148.176827745359,
						-33.1333493975608
					],
					"name": "Parkes Public School",
					"playspace": 37.18,
					"projections": [
						476,
						410,
						465,
						430,
						380,
						365
					],
					"projections_orig": [
						"476",
						"410",
						"465",
						"430",
						"380",
						"365"
					],
					"projections_percentage": [
						16.1,
						0,
						13.41,
						4.88,
						-7.32,
						-10.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2835
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 6.58,
					"enrolment": 147,
					"ligo": 1,
					"location": [
						148.191721262054,
						-32.7279243512887
					],
					"name": "Peak Hill Central School",
					"playspace": 85.27,
					"projections": [
						181,
						147,
						145,
						150,
						155,
						155
					],
					"projections_orig": [
						"181",
						"147",
						"145",
						"150",
						"155",
						"155"
					],
					"projections_percentage": [
						23.13,
						0,
						-1.36,
						2.04,
						5.44,
						5.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2848
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 20.72,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						147.791661121654,
						-34.0104119718995
					],
					"name": "Quandialla Public School",
					"playspace": 916.88,
					"projections": [
						0,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"0",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-100,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2920
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 8.97,
					"enrolment": 88,
					"ligo": 1,
					"location": [
						147.353382438171,
						-32.2456096966049
					],
					"name": "Tottenham Central School",
					"playspace": 251.24,
					"projections": [
						109,
						88,
						90,
						80,
						75,
						75
					],
					"projections_orig": [
						"109",
						"88",
						"90",
						"80",
						"75",
						"75"
					],
					"projections_percentage": [
						23.86,
						0,
						2.27,
						-9.09,
						-14.77,
						-14.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3249
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 14
					},
					"classroomspace": 5.36,
					"enrolment": 208,
					"ligo": 1,
					"location": [
						147.979808898831,
						-32.0328107892374
					],
					"name": "Trangie Central School",
					"playspace": 96.69,
					"projections": [
						164,
						207,
						200,
						210,
						215,
						220
					],
					"projections_orig": [
						"164",
						"207",
						"200",
						"210",
						"215",
						"220"
					],
					"projections_percentage": [
						-20.77,
						0,
						-3.38,
						1.45,
						3.86,
						6.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3254
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 6.37,
					"enrolment": 121,
					"ligo": 1,
					"location": [
						147.710497917906,
						-32.9251649601641
					],
					"name": "Trundle Central School",
					"playspace": 209.25,
					"projections": [
						107,
						121,
						100,
						105,
						105,
						110
					],
					"projections_orig": [
						"107",
						"121",
						"100",
						"105",
						"105",
						"110"
					],
					"projections_percentage": [
						-11.57,
						0,
						-17.36,
						-13.22,
						-13.22,
						-9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3259
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 9
					},
					"classroomspace": 9.05,
					"enrolment": 79,
					"ligo": 1,
					"location": [
						147.564732498098,
						-32.6351674319341
					],
					"name": "Tullamore Central School",
					"playspace": 611.16,
					"projections": [
						75,
						79,
						75,
						65,
						65,
						60
					],
					"projections_orig": [
						"75",
						"79",
						"75",
						"65",
						"65",
						"60"
					],
					"projections_percentage": [
						-5.06,
						0,
						-5.06,
						-17.72,
						-17.72,
						-24.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3270
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 9.05,
					"enrolment": 51,
					"ligo": 1,
					"location": [
						146.723438018481,
						-33.4236874249631
					],
					"name": "Tullibigeal Central School",
					"playspace": 536.56,
					"projections": [
						56,
						51,
						60,
						55,
						55,
						55
					],
					"projections_orig": [
						"56",
						"51",
						"60",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						9.8,
						0,
						17.65,
						7.84,
						7.84,
						7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3272
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 2.62,
					"enrolment": 264,
					"ligo": 1,
					"location": [
						148.172623485822,
						-33.1467675991945
					],
					"name": "Middleton Public School",
					"playspace": 69.51,
					"projections": [
						270,
						264,
						240,
						215,
						200,
						190
					],
					"projections_orig": [
						"270",
						"264",
						"240",
						"215",
						"200",
						"190"
					],
					"projections_percentage": [
						2.27,
						0,
						-9.09,
						-18.56,
						-24.24,
						-28.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4089
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.78,
					"enrolment": 285,
					"ligo": 1,
					"location": [
						147.999944107519,
						-33.3701527635083
					],
					"name": "Forbes North Public School",
					"playspace": 120.8,
					"projections": [
						270,
						285,
						280,
						245,
						225,
						210
					],
					"projections_orig": [
						"270",
						"285",
						"280",
						"245",
						"225",
						"210"
					],
					"projections_percentage": [
						-5.26,
						0,
						-1.75,
						-14.04,
						-21.05,
						-26.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4100
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.83,
					"enrolment": 294,
					"ligo": 1,
					"location": [
						148.189484436647,
						-33.1363667730568
					],
					"name": "Parkes East Public School",
					"playspace": 61.54,
					"projections": [
						211,
						294,
						250,
						225,
						215,
						205
					],
					"projections_orig": [
						"211",
						"294",
						"250",
						"225",
						"215",
						"205"
					],
					"projections_percentage": [
						-28.23,
						0,
						-14.97,
						-23.47,
						-26.87,
						-30.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4204
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.95,
					"enrolment": 304,
					"ligo": 1,
					"location": [
						148.688585604444,
						-33.8218127445699
					],
					"name": "Mulyan Public School",
					"playspace": 103.95,
					"projections": [
						349,
						304,
						340,
						310,
						285,
						260
					],
					"projections_orig": [
						"349",
						"304",
						"340",
						"310",
						"285",
						"260"
					],
					"projections_percentage": [
						14.8,
						0,
						11.84,
						1.97,
						-6.25,
						-14.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5242
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 44
					},
					"classroomspace": 5.05,
					"enrolment": 605,
					"ligo": 1,
					"location": [
						148.180824171764,
						-33.138710142537
					],
					"name": "Parkes High School",
					"playspace": 49.93,
					"projections": [
						677,
						605,
						655,
						640,
						590,
						530
					],
					"projections_orig": [
						"677",
						"605",
						"655",
						"640",
						"590",
						"530"
					],
					"projections_percentage": [
						11.9,
						0,
						8.26,
						5.79,
						-2.48,
						-12.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8146
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 41
					},
					"classroomspace": 4.9,
					"enrolment": 569,
					"ligo": 1,
					"location": [
						148.687914058999,
						-33.815530092037
					],
					"name": "Cowra High School",
					"playspace": 121.88,
					"projections": [
						749,
						569,
						675,
						670,
						620,
						545
					],
					"projections_orig": [
						"749",
						"569",
						"675",
						"670",
						"620",
						"545"
					],
					"projections_percentage": [
						31.63,
						0,
						18.63,
						17.75,
						8.96,
						-4.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8148
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 26
					},
					"classroomspace": 5.23,
					"enrolment": 390,
					"ligo": 1,
					"location": [
						148.011925142818,
						-33.3627773463266
					],
					"name": "Forbes High School",
					"playspace": 196.47,
					"projections": [
						390,
						390,
						345,
						315,
						285,
						255
					],
					"projections_orig": [
						"390",
						"390",
						"345",
						"315",
						"285",
						"255"
					],
					"projections_percentage": [
						0,
						0,
						-11.54,
						-19.23,
						-26.92,
						-34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8194
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 6.44,
					"enrolment": 171,
					"ligo": 1,
					"location": [
						148.163756723246,
						-33.9017079461063
					],
					"name": "The Henry Lawson High School",
					"playspace": 296.35,
					"projections": [
						224,
						171,
						165,
						160,
						140,
						130
					],
					"projections_orig": [
						"224",
						"171",
						"165",
						"160",
						"140",
						"130"
					],
					"projections_percentage": [
						30.99,
						0,
						-3.51,
						-6.43,
						-18.13,
						-23.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8314
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 25
					},
					"classroomspace": 7.87,
					"enrolment": 214,
					"ligo": 1,
					"location": [
						147.141615548873,
						-33.091277239563
					],
					"name": "Condobolin High School",
					"playspace": 206.05,
					"projections": [
						252,
						214,
						215,
						185,
						170,
						160
					],
					"projections_orig": [
						"252",
						"214",
						"215",
						"185",
						"170",
						"160"
					],
					"projections_percentage": [
						17.76,
						0,
						0.47,
						-13.55,
						-20.56,
						-25.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8346
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 7.67,
					"enrolment": 177,
					"ligo": 1,
					"location": [
						147.189449692351,
						-31.5611051521307
					],
					"name": "Nyngan High School",
					"playspace": 68.41,
					"projections": [
						183,
						177,
						175,
						160,
						155,
						160
					],
					"projections_orig": [
						"183",
						"177",
						"175",
						"160",
						"155",
						"160"
					],
					"projections_percentage": [
						3.39,
						0,
						-1.13,
						-9.6,
						-12.43,
						-9.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8353
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 8.78,
					"enrolment": 230,
					"ligo": 1,
					"location": [
						148.242892751698,
						-32.2301032379727
					],
					"name": "Narromine High School",
					"playspace": 208.53,
					"projections": [
						253,
						230,
						230,
						240,
						245,
						250
					],
					"projections_orig": [
						"253",
						"230",
						"230",
						"240",
						"245",
						"250"
					],
					"projections_percentage": [
						10,
						0,
						0,
						4.35,
						6.52,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8462
				}
			],
			"uid": 30009
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 126
			},
			"enrolment": 1721,
			"level": "Combined",
			"ligo": 0.55,
			"name": "Lithgow",
			"playspace": 69.78,
			"projections": [
				1721,
				1735,
				1675,
				1610,
				1535
			],
			"projections_percentage": [
				0,
				0.81,
				-2.67,
				-6.45,
				-10.81
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 4.15,
					"enrolment": 348,
					"ligo": 0.74,
					"location": [
						150.141598700548,
						-33.4835722663985
					],
					"name": "Cooerwull Public School",
					"playspace": 40.91,
					"projections": [
						295,
						348,
						300,
						290,
						280,
						270
					],
					"projections_orig": [
						"295",
						"348",
						"300",
						"290",
						"280",
						"270"
					],
					"projections_percentage": [
						-15.23,
						0,
						-13.79,
						-16.67,
						-19.54,
						-22.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1615
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 31
					},
					"classroomspace": 3.26,
					"enrolment": 453,
					"ligo": 0.48,
					"location": [
						150.159429392331,
						-33.4821133418147
					],
					"name": "Lithgow Public School",
					"playspace": 27.76,
					"projections": [
						444,
						453,
						460,
						425,
						410,
						400
					],
					"projections_orig": [
						"444",
						"453",
						"460",
						"425",
						"410",
						"400"
					],
					"projections_percentage": [
						-1.99,
						0,
						1.55,
						-6.18,
						-9.49,
						-11.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2410
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.32,
					"enrolment": 101,
					"ligo": 0.13,
					"location": [
						150.182518502938,
						-33.4654106777803
					],
					"name": "Zig Zag Public School",
					"playspace": 103.53,
					"projections": [
						68,
						101,
						85,
						80,
						80,
						80
					],
					"projections_orig": [
						"68",
						"101",
						"85",
						"80",
						"80",
						"80"
					],
					"projections_percentage": [
						-32.67,
						0,
						-15.84,
						-20.79,
						-20.79,
						-20.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3566
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 64
					},
					"classroomspace": 4.83,
					"enrolment": 819,
					"ligo": 0.86,
					"location": [
						150.163367669013,
						-33.4854183793769
					],
					"name": "Lithgow High School",
					"playspace": 106.91,
					"projections": [
						882,
						819,
						890,
						880,
						840,
						785
					],
					"projections_orig": [
						"882",
						"819",
						"890",
						"880",
						"840",
						"785"
					],
					"projections_percentage": [
						7.69,
						0,
						8.67,
						7.45,
						2.56,
						-4.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8125
				}
			],
			"uid": 30010
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 244
			},
			"enrolment": 4188,
			"level": "Combined",
			"ligo": 0.97,
			"name": "Macquarie Network",
			"playspace": 445.16,
			"projections": [
				4189,
				4400,
				4490,
				4440,
				4420
			],
			"projections_percentage": [
				0,
				5.04,
				7.19,
				5.99,
				5.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.59,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						148.899622472128,
						-32.1935838965433
					],
					"name": "Ballimore Public School",
					"playspace": 912.14,
					"projections": [
						10,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-52.38,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1111
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 5.13,
					"enrolment": 239,
					"ligo": 1,
					"location": [
						149.722298163527,
						-31.8224377866906
					],
					"name": "Coolah Central School",
					"playspace": 189.17,
					"projections": [
						237,
						240,
						225,
						215,
						215,
						215
					],
					"projections_orig": [
						"237",
						"240",
						"225",
						"215",
						"215",
						"215"
					],
					"projections_percentage": [
						-1.25,
						0,
						-6.25,
						-10.42,
						-10.42,
						-10.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1621
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 6.83,
					"enrolment": 192,
					"ligo": 1,
					"location": [
						149.392353409807,
						-32.0174122120399
					],
					"name": "Dunedoo Central School",
					"playspace": 118.74,
					"projections": [
						213,
						192,
						210,
						220,
						230,
						240
					],
					"projections_orig": [
						"213",
						"192",
						"210",
						"220",
						"230",
						"240"
					],
					"projections_percentage": [
						10.94,
						0,
						9.38,
						14.58,
						19.79,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1789
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.35,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						148.621028693746,
						-31.950677770433
					],
					"name": "Eumungerie Public School",
					"playspace": 197.05,
					"projections": [
						15,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-31.82,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1873
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.24,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						148.829112130724,
						-32.3962801771912
					],
					"name": "Geurie Public School",
					"playspace": 234.95,
					"projections": [
						41,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"41",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1972
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 7.48,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						149.268269931195,
						-32.3684495909664
					],
					"name": "Goolma Public School",
					"playspace": 1719.53,
					"projections": [
						5,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"5",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-37.5,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2036
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 10
					},
					"classroomspace": 2.84,
					"enrolment": 307,
					"ligo": 1,
					"location": [
						149.537485417056,
						-32.3602309644135
					],
					"name": "Gulgong Public School",
					"playspace": 36.06,
					"projections": [
						216,
						307,
						275,
						290,
						300,
						310
					],
					"projections_orig": [
						"216",
						"307",
						"275",
						"290",
						"300",
						"310"
					],
					"projections_percentage": [
						-29.64,
						0,
						-10.42,
						-5.54,
						-2.28,
						0.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2097
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 9.46,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						149.462268910244,
						-32.7838643647652
					],
					"name": "Hargraves Public School",
					"playspace": 460.07,
					"projections": [
						25,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						19.05,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2136
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.26,
					"enrolment": 19,
					"ligo": 1,
					"location": [
						149.845123661127,
						-32.6560734565184
					],
					"name": "Lue Public School",
					"playspace": 343.37,
					"projections": [
						23,
						19,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"19",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						21.05,
						0,
						31.58,
						31.58,
						31.58,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2432
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 21
					},
					"classroomspace": 2.87,
					"enrolment": 651,
					"ligo": 0.76,
					"location": [
						149.585148487815,
						-32.5953213052809
					],
					"name": "Mudgee Public School",
					"playspace": 31.66,
					"projections": [
						523,
						651,
						690,
						685,
						640,
						635
					],
					"projections_orig": [
						"523",
						"651",
						"690",
						"685",
						"640",
						"635"
					],
					"projections_percentage": [
						-19.66,
						0,
						5.99,
						5.22,
						-1.69,
						-2.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2656
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.29,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						149.051870425469,
						-32.7224678954576
					],
					"name": "Mumbil Public School",
					"playspace": 745.65,
					"projections": [
						25,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						66.67,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2669
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 10.5,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						149.068926735141,
						-32.8022344625188
					],
					"name": "Stuart Town Public School",
					"playspace": 1356.06,
					"projections": [
						16,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						77.78,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3127
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.96,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						149.742979351594,
						-32.2816610236388
					],
					"name": "Ulan Public School",
					"playspace": 689.43,
					"projections": [
						12,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-20,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3300
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 24
					},
					"classroomspace": 3.46,
					"enrolment": 487,
					"ligo": 1,
					"location": [
						148.943944715375,
						-32.5563300804071
					],
					"name": "Wellington Public School",
					"playspace": 31.8,
					"projections": [
						517,
						487,
						495,
						505,
						525,
						525
					],
					"projections_orig": [
						"517",
						"487",
						"495",
						"505",
						"525",
						"525"
					],
					"projections_percentage": [
						6.16,
						0,
						1.64,
						3.7,
						7.8,
						7.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3420
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 14.97,
					"enrolment": 4,
					"ligo": 1,
					"location": [
						149.949335168013,
						-32.356750213238
					],
					"name": "Wollar Public School",
					"playspace": 1747.68,
					"projections": [
						6,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"6",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						50,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3473
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.07,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						148.759010446267,
						-32.3336827294561
					],
					"name": "Wongarbon Public School",
					"playspace": 179.39,
					"projections": [
						68,
						61,
						60,
						65,
						65,
						65
					],
					"projections_orig": [
						"68",
						"61",
						"60",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						11.48,
						0,
						-1.64,
						6.56,
						6.56,
						6.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3487
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 5.77,
					"enrolment": 122,
					"ligo": 1,
					"location": [
						148.650105050933,
						-32.7540834577182
					],
					"name": "Yeoval Central School",
					"playspace": 106.47,
					"projections": [
						140,
						122,
						130,
						135,
						140,
						145
					],
					"projections_orig": [
						"140",
						"122",
						"130",
						"135",
						"140",
						"145"
					],
					"projections_percentage": [
						14.75,
						0,
						6.56,
						10.66,
						14.75,
						18.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3555
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 20
					},
					"classroomspace": 2.41,
					"enrolment": 563,
					"ligo": 0.88,
					"location": [
						149.584780851368,
						-32.6057480276227
					],
					"name": "Cudgegong Valley Public School",
					"playspace": 55.2,
					"projections": [
						590,
						563,
						580,
						575,
						530,
						525
					],
					"projections_orig": [
						"590",
						"563",
						"580",
						"575",
						"530",
						"525"
					],
					"projections_percentage": [
						4.8,
						0,
						3.02,
						2.13,
						-5.86,
						-6.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4555
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 56
					},
					"classroomspace": 4.5,
					"enrolment": 854,
					"ligo": 0.83,
					"location": [
						149.582538309928,
						-32.5977165592307
					],
					"name": "Mudgee High School",
					"playspace": 30.18,
					"projections": [
						1076,
						854,
						985,
						1025,
						1000,
						950
					],
					"projections_orig": [
						"1076",
						"854",
						"985",
						"1025",
						"1000",
						"950"
					],
					"projections_percentage": [
						26,
						0,
						15.34,
						20.02,
						17.1,
						11.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8128
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 5.9,
					"enrolment": 309,
					"ligo": 1,
					"location": [
						148.947001412446,
						-32.5472185503205
					],
					"name": "Wellington High School",
					"playspace": 108.62,
					"projections": [
						330,
						309,
						330,
						345,
						355,
						365
					],
					"projections_orig": [
						"330",
						"309",
						"330",
						"345",
						"355",
						"365"
					],
					"projections_percentage": [
						6.8,
						0,
						6.8,
						11.65,
						14.89,
						18.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8197
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 5.6,
					"enrolment": 228,
					"ligo": 0.94,
					"location": [
						149.538842738127,
						-32.3601501579611
					],
					"name": "Gulgong High School",
					"playspace": 55.11,
					"projections": [
						289,
						228,
						245,
						255,
						265,
						270
					],
					"projections_orig": [
						"289",
						"228",
						"245",
						"255",
						"265",
						"270"
					],
					"projections_percentage": [
						26.75,
						0,
						7.46,
						11.84,
						16.23,
						18.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8546
				}
			],
			"uid": 30011
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 109
			},
			"enrolment": 1771,
			"level": "Combined",
			"ligo": 1,
			"name": "Orange Network",
			"playspace": 509.85,
			"projections": [
				1771,
				1792,
				1858,
				1921,
				1953
			],
			"projections_percentage": [
				0,
				1.19,
				4.91,
				8.47,
				10.28
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 3.09,
					"enrolment": 107,
					"ligo": 1,
					"location": [
						149.046496941412,
						-33.3067347202423
					],
					"name": "Canobolas Public School",
					"playspace": 124.29,
					"projections": [
						87,
						107,
						115,
						120,
						125,
						125
					],
					"projections_orig": [
						"87",
						"107",
						"115",
						"120",
						"125",
						"125"
					],
					"projections_percentage": [
						-18.69,
						0,
						7.48,
						12.15,
						16.82,
						16.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1495
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.94,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						149.141782587341,
						-33.6118824921832
					],
					"name": "Carcoar Public School",
					"playspace": 551.89,
					"projections": [
						10,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.09,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1504
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.13,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						148.807979095663,
						-33.4274585258254
					],
					"name": "Cargo Public School",
					"playspace": 255.72,
					"projections": [
						20,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.09,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1506
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 4.18,
					"enrolment": 80,
					"ligo": 1,
					"location": [
						148.739587460045,
						-33.2874828446304
					],
					"name": "Cudal Public School",
					"playspace": 74.98,
					"projections": [
						61,
						80,
						85,
						85,
						90,
						90
					],
					"projections_orig": [
						"61",
						"80",
						"85",
						"85",
						"90",
						"90"
					],
					"projections_percentage": [
						-23.75,
						0,
						6.25,
						6.25,
						12.5,
						12.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1695
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3,
					"enrolment": 56,
					"ligo": 1,
					"location": [
						148.749974234705,
						-32.9315133998386
					],
					"name": "Cumnock Public School",
					"playspace": 346.09,
					"projections": [
						59,
						56,
						50,
						50,
						55,
						55
					],
					"projections_orig": [
						"59",
						"56",
						"50",
						"50",
						"55",
						"55"
					],
					"projections_percentage": [
						5.36,
						0,
						-10.71,
						-10.71,
						-1.79,
						-1.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1707
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 12,
					"enrolment": 5,
					"ligo": 1,
					"location": [
						149.091335702436,
						-32.9371450348621
					],
					"name": "Euchareena Public School",
					"playspace": 1234.04,
					"projections": [
						11,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						120,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1869
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.51,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						148.43625171815,
						-33.6175762745576
					],
					"name": "Gooloogong Public School",
					"playspace": 1012.93,
					"projections": [
						29,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						93.33,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2038
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.48,
					"enrolment": 42,
					"ligo": 1,
					"location": [
						148.756365773194,
						-33.8105715079421
					],
					"name": "Holmwood Public School",
					"playspace": 290.89,
					"projections": [
						46,
						42,
						60,
						55,
						55,
						50
					],
					"projections_orig": [
						"46",
						"42",
						"60",
						"55",
						"55",
						"50"
					],
					"projections_percentage": [
						9.52,
						0,
						42.86,
						30.95,
						30.95,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2172
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.36,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						149.04433394794,
						-33.6734546487459
					],
					"name": "Lyndhurst Public School",
					"playspace": 639.84,
					"projections": [
						29,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2436
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 17.6,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						149.069976257905,
						-33.6515664137554
					],
					"name": "Mandurama Public School",
					"playspace": 1339.85,
					"projections": [
						28,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						180,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2460
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.79,
					"enrolment": 44,
					"ligo": 1,
					"location": [
						148.701195973646,
						-33.1839946835656
					],
					"name": "Manildra Public School",
					"playspace": 882.55,
					"projections": [
						36,
						44,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"44",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-18.18,
						0,
						-43.18,
						-43.18,
						-43.18,
						-43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2465
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 28
					},
					"classroomspace": 4.19,
					"enrolment": 482,
					"ligo": 1,
					"location": [
						148.863396640399,
						-33.0990161416206
					],
					"name": "Molong Central School",
					"playspace": 54.3,
					"projections": [
						508,
						482,
						505,
						540,
						555,
						550
					],
					"projections_orig": [
						"508",
						"482",
						"505",
						"540",
						"555",
						"550"
					],
					"projections_percentage": [
						5.39,
						0,
						4.77,
						12.03,
						15.15,
						14.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2590
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.66,
					"enrolment": 54,
					"ligo": 1,
					"location": [
						149.120338630546,
						-33.139329201765
					],
					"name": "Mullion Creek Public School",
					"playspace": 117.31,
					"projections": [
						45,
						54,
						25,
						50,
						50,
						55
					],
					"projections_orig": [
						"45",
						"54",
						"<50",
						"50",
						"50",
						"55"
					],
					"projections_percentage": [
						-16.67,
						0,
						-53.7,
						-7.41,
						-7.41,
						1.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2664
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 3.35,
					"enrolment": 102,
					"ligo": 1,
					"location": [
						149.112892382097,
						-33.1918830233939
					],
					"name": "Clergate Public School",
					"playspace": 58.18,
					"projections": [
						73,
						102,
						100,
						105,
						110,
						115
					],
					"projections_orig": [
						"73",
						"102",
						"100",
						"105",
						"110",
						"115"
					],
					"projections_percentage": [
						-28.43,
						0,
						-1.96,
						2.94,
						7.84,
						12.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2668
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.77,
					"enrolment": 117,
					"ligo": 1,
					"location": [
						149.012710458739,
						-33.2939642030939
					],
					"name": "Nashdale Public School",
					"playspace": 51.61,
					"projections": [
						54,
						117,
						100,
						105,
						110,
						115
					],
					"projections_orig": [
						"54",
						"117",
						"100",
						"105",
						"110",
						"115"
					],
					"projections_percentage": [
						-53.85,
						0,
						-14.53,
						-10.26,
						-5.98,
						-1.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2714
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.75,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						149.151181800089,
						-33.3988390478682
					],
					"name": "Spring Hill Public School",
					"playspace": 506.15,
					"projections": [
						38,
						37,
						25,
						25,
						50,
						50
					],
					"projections_orig": [
						"38",
						"37",
						"<50",
						"<50",
						"50",
						"50"
					],
					"projections_percentage": [
						2.7,
						0,
						-32.43,
						-32.43,
						35.14,
						35.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3089
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.45,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						149.096948758146,
						-33.3941180722129
					],
					"name": "Spring Terrace Public School",
					"playspace": 786.28,
					"projections": [
						37,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						23.33,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3093
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 8.97,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						148.848316482707,
						-33.7463434505117
					],
					"name": "Woodstock Public School",
					"playspace": 1175.77,
					"projections": [
						16,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						6.67,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3499
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.32,
					"enrolment": 43,
					"ligo": 1,
					"location": [
						148.984411395755,
						-33.2504364219233
					],
					"name": "Borenore Public School",
					"playspace": 129.2,
					"projections": [
						47,
						43,
						25,
						25,
						25,
						50
					],
					"projections_orig": [
						"47",
						"43",
						"<50",
						"<50",
						"<50",
						"50"
					],
					"projections_percentage": [
						9.3,
						0,
						-41.86,
						-41.86,
						-41.86,
						16.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3504
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 22.89,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						148.947411208271,
						-33.9672229137613
					],
					"name": "Wyangala Dam Public School",
					"playspace": 1381,
					"projections": [
						10,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						42.86,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3521
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.5,
					"enrolment": 216,
					"ligo": 1,
					"location": [
						148.664882434732,
						-33.56720373076
					],
					"name": "Canowindra Public School",
					"playspace": 64.53,
					"projections": [
						180,
						216,
						215,
						225,
						230,
						240
					],
					"projections_orig": [
						"180",
						"216",
						"215",
						"225",
						"230",
						"240"
					],
					"projections_percentage": [
						-16.67,
						0,
						-0.46,
						4.17,
						6.48,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7301
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 6.22,
					"enrolment": 247,
					"ligo": 1,
					"location": [
						148.670656115608,
						-33.5574101755072
					],
					"name": "Canowindra High School",
					"playspace": 139.37,
					"projections": [
						222,
						247,
						240,
						255,
						260,
						270
					],
					"projections_orig": [
						"222",
						"247",
						"240",
						"255",
						"260",
						"270"
					],
					"projections_percentage": [
						-10.12,
						0,
						-2.83,
						3.24,
						5.26,
						9.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8518
				}
			],
			"uid": 30012
		},
		{
			"classrooms": {
				"demountable": 30,
				"permanent": 155
			},
			"enrolment": 2641,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Rural Bathurst Network",
			"playspace": 323.96,
			"projections": [
				2640,
				2778,
				2908,
				2998,
				3053
			],
			"projections_percentage": [
				0,
				5.23,
				10.15,
				13.56,
				15.64
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 2.9,
					"enrolment": 300,
					"ligo": 1,
					"location": [
						149.251581533113,
						-33.5298941251686
					],
					"name": "Blayney Public School",
					"playspace": 47.39,
					"projections": [
						227,
						300,
						305,
						320,
						330,
						340
					],
					"projections_orig": [
						"227",
						"300",
						"305",
						"320",
						"330",
						"340"
					],
					"projections_percentage": [
						-24.33,
						0,
						1.67,
						6.67,
						10,
						13.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1260
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						149.527980757925,
						-33.9497971810395
					],
					"name": "Burraga Public School",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1437
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.09,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						149.986318256808,
						-33.1470530078321
					],
					"name": "Capertee Public School",
					"playspace": 861.41,
					"projections": [
						8,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-33.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1501
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 6.54,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						150.032658477077,
						-33.3001867792845
					],
					"name": "Cullen Bullen Public School",
					"playspace": 196.19,
					"projections": [
						21,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-27.59,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1700
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 11.98,
					"enrolment": 5,
					"ligo": 1,
					"location": [
						150.048455690144,
						-33.6484708834064
					],
					"name": "Hampton Public School",
					"playspace": 1199.21,
					"projections": [
						28,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						460,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 5.31,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						149.415605332119,
						-33.0344894607959
					],
					"name": "Hill End Public School",
					"playspace": 58.93,
					"projections": [
						5,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"5",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-37.5,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2161
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.43,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						149.855957298595,
						-32.96656012727
					],
					"name": "Ilford Public School",
					"playspace": 490.19,
					"projections": [
						31,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.06,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2201
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.6,
					"enrolment": 146,
					"ligo": 1,
					"location": [
						149.974171494519,
						-32.8562710874638
					],
					"name": "Kandos Public School",
					"playspace": 21.59,
					"projections": [
						173,
						146,
						160,
						170,
						175,
						180
					],
					"projections_orig": [
						"173",
						"146",
						"160",
						"170",
						"175",
						"180"
					],
					"projections_percentage": [
						18.49,
						0,
						9.59,
						16.44,
						19.86,
						23.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2254
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.68,
					"enrolment": 46,
					"ligo": 1,
					"location": [
						149.920729789809,
						-33.4338146352428
					],
					"name": "Meadow Flat Public School",
					"playspace": 224.51,
					"projections": [
						48,
						46,
						55,
						55,
						60,
						60
					],
					"projections_orig": [
						"48",
						"46",
						"55",
						"55",
						"60",
						"60"
					],
					"projections_percentage": [
						4.35,
						0,
						19.57,
						19.57,
						30.43,
						30.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2509
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 4
					},
					"classroomspace": 2.83,
					"enrolment": 288,
					"ligo": 1,
					"location": [
						149.185535764606,
						-33.4456486870839
					],
					"name": "Millthorpe Public School",
					"playspace": 25.24,
					"projections": [
						208,
						288,
						265,
						280,
						290,
						300
					],
					"projections_orig": [
						"208",
						"288",
						"265",
						"280",
						"290",
						"300"
					],
					"projections_percentage": [
						-27.78,
						0,
						-7.99,
						-2.78,
						0.69,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2558
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.16,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						149.217034428911,
						-33.7092505029486
					],
					"name": "Neville Public School",
					"playspace": 1021.93,
					"projections": [
						13,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-23.53,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2732
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.27,
					"enrolment": 241,
					"ligo": 1,
					"location": [
						149.864811791342,
						-33.7037961407204
					],
					"name": "Oberon Public School",
					"playspace": 71.02,
					"projections": [
						240,
						241,
						245,
						255,
						265,
						275
					],
					"projections_orig": [
						"240",
						"241",
						"245",
						"255",
						"265",
						"275"
					],
					"projections_percentage": [
						-0.41,
						0,
						1.66,
						5.81,
						9.96,
						14.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2797
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.77,
					"enrolment": 82,
					"ligo": 1,
					"location": [
						149.719786651342,
						-33.5239173614698
					],
					"name": "O'Connell Public School",
					"playspace": 60.91,
					"projections": [
						69,
						82,
						80,
						85,
						90,
						90
					],
					"projections_orig": [
						"69",
						"82",
						"80",
						"85",
						"90",
						"90"
					],
					"projections_percentage": [
						-15.85,
						0,
						-2.44,
						3.66,
						9.76,
						9.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2798
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 7.71,
					"enrolment": 156,
					"ligo": 0.72,
					"location": [
						149.979749868341,
						-33.3545708580771
					],
					"name": "Portland Central School",
					"playspace": 60.1,
					"projections": [
						181,
						156,
						190,
						200,
						210,
						210
					],
					"projections_orig": [
						"181",
						"156",
						"190",
						"200",
						"210",
						"210"
					],
					"projections_percentage": [
						16.03,
						0,
						21.79,
						28.21,
						34.62,
						34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2897
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.17,
					"enrolment": 89,
					"ligo": 1,
					"location": [
						149.973106317692,
						-32.7959670765477
					],
					"name": "Rylstone Public School",
					"playspace": 93.81,
					"projections": [
						92,
						89,
						90,
						95,
						100,
						100
					],
					"projections_orig": [
						"92",
						"89",
						"90",
						"95",
						"100",
						"100"
					],
					"projections_percentage": [
						3.37,
						0,
						1.12,
						6.74,
						12.36,
						12.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3025
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.1,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						149.695333322702,
						-33.0818330976601
					],
					"name": "Sofala Public School",
					"playspace": 527.72,
					"projections": [
						13,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						30,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3077
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 7.6,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						149.326443779304,
						-33.8166295092179
					],
					"name": "Trunkey Public School",
					"playspace": "NA",
					"projections": [
						16,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						60,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3260
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 10
					},
					"classroomspace": 2.34,
					"enrolment": 300,
					"ligo": 1,
					"location": [
						150.071203565712,
						-33.4187695132892
					],
					"name": "Wallerawang Public School",
					"playspace": 134.26,
					"projections": [
						262,
						300,
						300,
						310,
						315,
						325
					],
					"projections_orig": [
						"262",
						"300",
						"300",
						"310",
						"315",
						"325"
					],
					"projections_percentage": [
						-12.67,
						0,
						0,
						3.33,
						5,
						8.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3354
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.23,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						149.693007817987,
						-33.1418736739584
					],
					"name": "Wattle Flat Public School",
					"playspace": 160.4,
					"projections": [
						18,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-30.77,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3402
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 5.8,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						150.215297356474,
						-33.0405084937572
					],
					"name": "Glen Alice Public School",
					"playspace": 420.55,
					"projections": [
						8,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-11.11,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3903
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 12.16,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						149.742081363505,
						-33.8461256115306
					],
					"name": "Black Springs Public School",
					"playspace": 1122.78,
					"projections": [
						20,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						122.22,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4190
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 27
					},
					"classroomspace": 7.79,
					"enrolment": 235,
					"ligo": 0.92,
					"location": [
						149.974114514213,
						-32.855590142865
					],
					"name": "Kandos High School",
					"playspace": 56.04,
					"projections": [
						257,
						234,
						235,
						250,
						255,
						265
					],
					"projections_orig": [
						"257",
						"234",
						"235",
						"250",
						"255",
						"265"
					],
					"projections_percentage": [
						9.83,
						0,
						0.43,
						6.84,
						8.97,
						13.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8318
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 17
					},
					"classroomspace": 4.83,
					"enrolment": 366,
					"ligo": 0.92,
					"location": [
						149.250917343563,
						-33.5319190956212
					],
					"name": "Blayney High School",
					"playspace": 137.53,
					"projections": [
						397,
						366,
						445,
						465,
						475,
						470
					],
					"projections_orig": [
						"397",
						"366",
						"445",
						"465",
						"475",
						"470"
					],
					"projections_percentage": [
						8.47,
						0,
						21.58,
						27.05,
						29.78,
						28.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8357
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 6.21,
					"enrolment": 224,
					"ligo": 0.88,
					"location": [
						149.859096763671,
						-33.7007422728358
					],
					"name": "Oberon High School",
					"playspace": 135.36,
					"projections": [
						219,
						224,
						240,
						255,
						265,
						270
					],
					"projections_orig": [
						"219",
						"224",
						"240",
						"255",
						"265",
						"270"
					],
					"projections_percentage": [
						-2.23,
						0,
						7.14,
						13.84,
						18.3,
						20.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8598
				}
			],
			"uid": 30013
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 18
			},
			"enrolment": 167,
			"level": "Combined",
			"ligo": 1,
			"name": "Rural Western Plains CWO",
			"playspace": 1460.32,
			"projections": [
				167,
				131,
				131,
				131,
				131
			],
			"projections_percentage": [
				0,
				-21.56,
				-21.56,
				-21.56,
				-21.56
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.34,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						146.908078132511,
						-31.2493858549166
					],
					"name": "Girilambone Public School",
					"playspace": 2182.28,
					"projections": [
						13,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						85.71,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1986
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 10.16,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						146.722928816162,
						-31.551028192104
					],
					"name": "Hermidale Public School",
					"playspace": 762.53,
					"projections": [
						12,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						33.33,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2155
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 6.67,
					"enrolment": 146,
					"ligo": 1,
					"location": [
						149.123610723193,
						-31.8180467819252
					],
					"name": "Mendooran Central School",
					"playspace": 240.35,
					"projections": [
						109,
						146,
						110,
						110,
						110,
						110
					],
					"projections_orig": [
						"109",
						"146",
						"110",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						-25.34,
						0,
						-24.66,
						-24.66,
						-24.66,
						-24.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2522
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 13.35,
					"enrolment": 5,
					"ligo": 1,
					"location": [
						147.374157516447,
						-30.8780819854848
					],
					"name": "Marra Creek Public School",
					"playspace": 2656.11,
					"projections": [
						10,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						100,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4454
				}
			],
			"uid": 30014
		},
		{
			"classrooms": {
				"demountable": 32,
				"permanent": 262
			},
			"enrolment": 4471,
			"level": "Combined",
			"ligo": 0.68,
			"name": "Dubbo Urban",
			"playspace": 67.09,
			"projections": [
				4471,
				4880,
				4930,
				4790,
				4745
			],
			"projections_percentage": [
				0,
				9.15,
				10.27,
				7.13,
				6.13
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 17
					},
					"classroomspace": 2.44,
					"enrolment": 508,
					"ligo": 0.48,
					"location": [
						148.605867412442,
						-32.2487712293379
					],
					"name": "Dubbo Public School",
					"playspace": 15.26,
					"projections": [
						427,
						508,
						555,
						555,
						530,
						535
					],
					"projections_orig": [
						"427",
						"508",
						"555",
						"555",
						"530",
						"535"
					],
					"projections_percentage": [
						-15.94,
						0,
						9.25,
						9.25,
						4.33,
						5.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1775
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 10
					},
					"classroomspace": 3.1,
					"enrolment": 262,
					"ligo": 0.51,
					"location": [
						148.615947889731,
						-32.2406111478334
					],
					"name": "Dubbo North Public School",
					"playspace": 80.04,
					"projections": [
						244,
						262,
						265,
						265,
						265,
						270
					],
					"projections_orig": [
						"244",
						"262",
						"265",
						"265",
						"265",
						"270"
					],
					"projections_percentage": [
						-6.87,
						0,
						1.15,
						1.15,
						1.15,
						3.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1776
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 25
					},
					"classroomspace": 2.8,
					"enrolment": 682,
					"ligo": 0.58,
					"location": [
						148.610456107588,
						-32.2641705313361
					],
					"name": "Dubbo South Public School",
					"playspace": 33.17,
					"projections": [
						682,
						682,
						790,
						790,
						750,
						750
					],
					"projections_orig": [
						"682",
						"682",
						"790",
						"790",
						"750",
						"750"
					],
					"projections_percentage": [
						0,
						0,
						15.84,
						15.84,
						9.97,
						9.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1811
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 23
					},
					"classroomspace": 4.6,
					"enrolment": 334,
					"ligo": 0.79,
					"location": [
						148.588504147196,
						-32.2510935415325
					],
					"name": "Dubbo West Public School",
					"playspace": 91.15,
					"projections": [
						327,
						334,
						330,
						325,
						330,
						330
					],
					"projections_orig": [
						"327",
						"334",
						"330",
						"325",
						"330",
						"330"
					],
					"projections_percentage": [
						-2.1,
						0,
						-1.2,
						-2.69,
						-1.2,
						-1.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3591
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 22
					},
					"classroomspace": 2.94,
					"enrolment": 618,
					"ligo": 0.56,
					"location": [
						148.627778467209,
						-32.2529102009539
					],
					"name": "Orana Heights Public School",
					"playspace": 37.44,
					"projections": [
						537,
						618,
						660,
						660,
						630,
						635
					],
					"projections_orig": [
						"537",
						"618",
						"660",
						"660",
						"630",
						"635"
					],
					"projections_percentage": [
						-13.11,
						0,
						6.8,
						6.8,
						1.94,
						2.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4549
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 13
					},
					"classroomspace": 3.86,
					"enrolment": 328,
					"ligo": 0.67,
					"location": [
						148.639237043302,
						-32.2433736535965
					],
					"name": "Buninyong Public School",
					"playspace": 175.04,
					"projections": [
						269,
						328,
						335,
						325,
						325,
						330
					],
					"projections_orig": [
						"269",
						"328",
						"335",
						"325",
						"325",
						"330"
					],
					"projections_percentage": [
						-17.99,
						0,
						2.13,
						-0.91,
						-0.91,
						0.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4616
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 64
					},
					"classroomspace": 7.28,
					"enrolment": 528,
					"ligo": 0.99,
					"location": [
						148.628559049011,
						-32.2350608789206
					],
					"name": "Dubbo College Senior Campus",
					"playspace": 69.87,
					"projections": [
						532,
						528,
						560,
						580,
						565,
						545
					],
					"projections_orig": [
						"532",
						"528",
						"560",
						"580",
						"565",
						"545"
					],
					"projections_percentage": [
						0.76,
						0,
						6.06,
						9.85,
						7.01,
						3.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8110
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 42
					},
					"classroomspace": 3.58,
					"enrolment": 722,
					"ligo": 0.7,
					"location": [
						148.61144457443,
						-32.2683198648885
					],
					"name": "Dubbo College South Campus",
					"playspace": 35.8,
					"projections": [
						794,
						722,
						875,
						905,
						885,
						855
					],
					"projections_orig": [
						"794",
						"722",
						"875",
						"905",
						"885",
						"855"
					],
					"projections_percentage": [
						9.97,
						0,
						21.19,
						25.35,
						22.58,
						18.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8417
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 5.81,
					"enrolment": 489,
					"ligo": 0.82,
					"location": [
						148.583206230468,
						-32.2505486833623
					],
					"name": "Dubbo College Delroy Campus",
					"playspace": 66,
					"projections": [
						531,
						489,
						510,
						525,
						510,
						495
					],
					"projections_orig": [
						"531",
						"489",
						"510",
						"525",
						"510",
						"495"
					],
					"projections_percentage": [
						8.59,
						0,
						4.29,
						7.36,
						4.29,
						1.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8543
				}
			],
			"uid": 30015
		},
		{
			"classrooms": {
				"demountable": 8,
				"permanent": 234
			},
			"enrolment": 4334,
			"level": "Combined",
			"ligo": 0.64,
			"name": "Orange Urban",
			"playspace": 59.2,
			"projections": [
				4334,
				4705,
				4835,
				4795,
				4800
			],
			"projections_percentage": [
				0,
				8.56,
				11.56,
				10.64,
				10.75
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 11
					},
					"classroomspace": 2.6,
					"enrolment": 269,
					"ligo": 0.33,
					"location": [
						149.114510639803,
						-33.282124818061
					],
					"name": "Orange East Public School",
					"playspace": 42.71,
					"projections": [
						245,
						269,
						240,
						240,
						245,
						245
					],
					"projections_orig": [
						"245",
						"269",
						"240",
						"240",
						"245",
						"245"
					],
					"projections_percentage": [
						-8.92,
						0,
						-10.78,
						-10.78,
						-8.92,
						-8.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2811
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4.82,
					"enrolment": 255,
					"ligo": 0.79,
					"location": [
						149.111656351805,
						-33.2972009971286
					],
					"name": "Glenroi Heights Public School",
					"playspace": 64.34,
					"projections": [
						296,
						255,
						225,
						230,
						230,
						235
					],
					"projections_orig": [
						"296",
						"255",
						"225",
						"230",
						"230",
						"235"
					],
					"projections_percentage": [
						16.08,
						0,
						-11.76,
						-9.8,
						-9.8,
						-7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4020
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 2.75,
					"enrolment": 636,
					"ligo": 0.69,
					"location": [
						149.079434570516,
						-33.2876761575455
					],
					"name": "Calare Public School",
					"playspace": 32.78,
					"projections": [
						626,
						636,
						700,
						720,
						700,
						715
					],
					"projections_orig": [
						"626",
						"636",
						"700",
						"720",
						"700",
						"715"
					],
					"projections_percentage": [
						-1.57,
						0,
						10.06,
						13.21,
						10.06,
						12.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4380
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 4.39,
					"enrolment": 245,
					"ligo": 0.55,
					"location": [
						149.116887470792,
						-33.2811971331768
					],
					"name": "Bowen Public School",
					"playspace": 79.03,
					"projections": [
						167,
						245,
						200,
						210,
						215,
						220
					],
					"projections_orig": [
						"167",
						"245",
						"200",
						"210",
						"215",
						"220"
					],
					"projections_percentage": [
						-31.84,
						0,
						-18.37,
						-14.29,
						-12.24,
						-10.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4538
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 19
					},
					"classroomspace": 2.63,
					"enrolment": 607,
					"ligo": 0.75,
					"location": [
						149.103255644456,
						-33.2695431269362
					],
					"name": "Bletchington Public School",
					"playspace": 48.72,
					"projections": [
						556,
						607,
						650,
						650,
						655,
						670
					],
					"projections_orig": [
						"556",
						"607",
						"650",
						"650",
						"655",
						"670"
					],
					"projections_percentage": [
						-8.4,
						0,
						7.08,
						7.08,
						7.91,
						10.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5265
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 3.03,
					"enrolment": 662,
					"ligo": 0.58,
					"location": [
						149.095896171708,
						-33.2856839638642
					],
					"name": "Orange Public School",
					"playspace": 31.52,
					"projections": [
						638,
						662,
						695,
						705,
						685,
						700
					],
					"projections_orig": [
						"638",
						"662",
						"695",
						"705",
						"685",
						"700"
					],
					"projections_percentage": [
						-3.63,
						0,
						4.98,
						6.5,
						3.47,
						5.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7307
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 54
					},
					"classroomspace": 3.38,
					"enrolment": 1074,
					"ligo": 0.64,
					"location": [
						149.086763033337,
						-33.2798581708923
					],
					"name": "Orange High School",
					"playspace": 52.28,
					"projections": [
						1043,
						1074,
						1215,
						1265,
						1255,
						1225
					],
					"projections_orig": [
						"1043",
						"1074",
						"1215",
						"1265",
						"1255",
						"1225"
					],
					"projections_percentage": [
						-2.89,
						0,
						13.13,
						17.78,
						16.85,
						14.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8134
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 5.23,
					"enrolment": 586,
					"ligo": 0.82,
					"location": [
						149.123117153191,
						-33.2900056868059
					],
					"name": "Canobolas Rural Technology High School",
					"playspace": 122.23,
					"projections": [
						832,
						586,
						780,
						815,
						810,
						790
					],
					"projections_orig": [
						"832",
						"586",
						"780",
						"815",
						"810",
						"790"
					],
					"projections_percentage": [
						41.98,
						0,
						33.11,
						39.08,
						38.23,
						34.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8444
				}
			],
			"uid": 30016
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 104
			},
			"enrolment": 1431,
			"level": "Combined",
			"ligo": 0.65,
			"name": "Broken Hill Primary",
			"playspace": 62.66,
			"projections": [
				1431,
				1540,
				1395,
				1270,
				1180
			],
			"projections_percentage": [
				0,
				7.62,
				-2.52,
				-11.25,
				-17.54
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 5.12,
					"enrolment": 249,
					"ligo": 0.92,
					"location": [
						141.4634527074,
						-31.9826693459389
					],
					"name": "Alma Public School",
					"playspace": 52.56,
					"projections": [
						227,
						249,
						255,
						240,
						220,
						205
					],
					"projections_orig": [
						"227",
						"249",
						"255",
						"240",
						"220",
						"205"
					],
					"projections_percentage": [
						-8.84,
						0,
						2.41,
						-3.61,
						-11.65,
						-17.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1028
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 5.14,
					"enrolment": 170,
					"ligo": 0.56,
					"location": [
						141.456141342345,
						-31.9558135540369
					],
					"name": "Broken Hill Public School",
					"playspace": 74.15,
					"projections": [
						262,
						170,
						195,
						185,
						170,
						155
					],
					"projections_orig": [
						"262",
						"170",
						"195",
						"185",
						"170",
						"155"
					],
					"projections_percentage": [
						54.12,
						0,
						14.71,
						8.82,
						0,
						-8.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1369
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.15,
					"enrolment": 260,
					"ligo": 0.7,
					"location": [
						141.472020128037,
						-31.9439382364838
					],
					"name": "Broken Hill North Public School",
					"playspace": 91.16,
					"projections": [
						295,
						260,
						270,
						240,
						220,
						205
					],
					"projections_orig": [
						"295",
						"260",
						"270",
						"240",
						"220",
						"205"
					],
					"projections_percentage": [
						13.46,
						0,
						3.85,
						-7.69,
						-15.38,
						-21.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1371
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.86,
					"enrolment": 313,
					"ligo": 0.56,
					"location": [
						141.440944275152,
						-31.960973993679
					],
					"name": "Burke Ward Public School",
					"playspace": 46.23,
					"projections": [
						327,
						313,
						345,
						310,
						275,
						255
					],
					"projections_orig": [
						"327",
						"313",
						"345",
						"310",
						"275",
						"255"
					],
					"projections_percentage": [
						4.47,
						0,
						10.22,
						-0.96,
						-12.14,
						-18.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1432
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.08,
					"enrolment": 330,
					"ligo": 0.61,
					"location": [
						141.460987820323,
						-31.9414733263736
					],
					"name": "Morgan Street Public School",
					"playspace": 46.68,
					"projections": [
						343,
						330,
						345,
						300,
						275,
						255
					],
					"projections_orig": [
						"343",
						"330",
						"345",
						"300",
						"275",
						"255"
					],
					"projections_percentage": [
						3.94,
						0,
						4.55,
						-9.09,
						-16.67,
						-22.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4232
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 5.2,
					"enrolment": 109,
					"ligo": 0.53,
					"location": [
						141.439764124043,
						-31.9700664871442
					],
					"name": "Railway Town Public School",
					"playspace": 65.17,
					"projections": [
						152,
						109,
						130,
						120,
						110,
						105
					],
					"projections_orig": [
						"152",
						"109",
						"130",
						"120",
						"110",
						"105"
					],
					"projections_percentage": [
						39.45,
						0,
						19.27,
						10.09,
						0.92,
						-3.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4233
				}
			],
			"uid": 30017
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 19
			},
			"enrolment": 164,
			"level": "Combined",
			"ligo": 1,
			"name": "Deniliquin Network FW",
			"playspace": 554.18,
			"projections": [
				164,
				157,
				147,
				147,
				142
			],
			"projections_percentage": [
				0,
				-4.27,
				-10.37,
				-10.37,
				-13.41
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 6.65,
					"enrolment": 157,
					"ligo": 1,
					"location": [
						143.564473785258,
						-34.6364970378697
					],
					"name": "Balranald Central School",
					"playspace": 160.26,
					"projections": [
						133,
						157,
						150,
						140,
						140,
						135
					],
					"projections_orig": [
						"133",
						"157",
						"150",
						"140",
						"140",
						"135"
					],
					"projections_percentage": [
						-15.29,
						0,
						-4.46,
						-10.83,
						-10.83,
						-14.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1115
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 19.41,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						143.941780767169,
						-33.3984894133797
					],
					"name": "Clare Public School",
					"playspace": 948.1,
					"projections": [
						11,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						57.14,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4565
				}
			],
			"uid": 30018
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 49
			},
			"enrolment": 292,
			"level": "Combined",
			"ligo": 1,
			"name": "Rural Far West Network",
			"playspace": 980.16,
			"projections": [
				292,
				308,
				298,
				288,
				283
			],
			"projections_percentage": [
				0,
				5.48,
				2.05,
				-1.37,
				-3.08
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.77,
					"enrolment": 83,
					"ligo": 1,
					"location": [
						142.744906888411,
						-34.5755435485924
					],
					"name": "Euston Public School",
					"playspace": 99.61,
					"projections": [
						89,
						83,
						70,
						65,
						60,
						60
					],
					"projections_orig": [
						"89",
						"83",
						"70",
						"65",
						"60",
						"60"
					],
					"projections_percentage": [
						7.23,
						0,
						-15.66,
						-21.69,
						-27.71,
						-27.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1885
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 26.81,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						144.301523441855,
						-32.8982505860945
					],
					"name": "Ivanhoe Central School",
					"playspace": 450.91,
					"projections": [
						43,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"43",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						86.96,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2213
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 10.07,
					"enrolment": 96,
					"ligo": 1,
					"location": [
						142.412648538088,
						-32.3947114435595
					],
					"name": "Menindee Central School",
					"playspace": 367.38,
					"projections": [
						126,
						96,
						90,
						90,
						85,
						80
					],
					"projections_orig": [
						"126",
						"96",
						"90",
						"90",
						"85",
						"80"
					],
					"projections_percentage": [
						31.25,
						0,
						-6.25,
						-6.25,
						-11.46,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2523
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 64.5,
					"enrolment": 4,
					"ligo": 1,
					"location": [
						142.01092390967,
						-29.4316463735826
					],
					"name": "Tibooburra Outback Public School",
					"playspace": 4878.04,
					"projections": [
						15,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						275,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3211
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.16,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						143.090106192295,
						-30.8504721560148
					],
					"name": "White Cliffs Public School",
					"playspace": 418.7,
					"projections": [
						9,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"9",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-30.77,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3435
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 12.57,
					"enrolment": 60,
					"ligo": 1,
					"location": [
						143.375821673116,
						-31.5580403860968
					],
					"name": "Wilcannia Central School",
					"playspace": 200.98,
					"projections": [
						142,
						60,
						95,
						90,
						90,
						90
					],
					"projections_orig": [
						"142",
						"60",
						"95",
						"90",
						"90",
						"90"
					],
					"projections_percentage": [
						136.67,
						0,
						58.33,
						50,
						50,
						50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3442
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.6,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						142.012622638144,
						-33.8444746221559
					],
					"name": "Palinyewah Public School",
					"playspace": 445.51,
					"projections": [
						11,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.38,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3912
				}
			],
			"uid": 30019
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 193
			},
			"enrolment": 2015,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Rural Western Plains FW",
			"playspace": 446.5,
			"projections": [
				2015,
				1917,
				1837,
				1777,
				1762
			],
			"projections_percentage": [
				0,
				-4.86,
				-8.83,
				-11.81,
				-12.56
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 13
					},
					"classroomspace": 4.47,
					"enrolment": 226,
					"ligo": 1,
					"location": [
						145.949235037158,
						-30.094326601074
					],
					"name": "Bourke Public School",
					"playspace": 150.88,
					"projections": [
						202,
						226,
						260,
						225,
						225,
						225
					],
					"projections_orig": [
						"202",
						"226",
						"260",
						"225",
						"225",
						"225"
					],
					"projections_percentage": [
						-10.62,
						0,
						15.04,
						-0.44,
						-0.44,
						-0.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1326
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 7.01,
					"enrolment": 154,
					"ligo": 1,
					"location": [
						146.859341578685,
						-29.9644694815919
					],
					"name": "Brewarrina Central School",
					"playspace": 88.81,
					"projections": [
						190,
						154,
						150,
						150,
						150,
						150
					],
					"projections_orig": [
						"190",
						"154",
						"150",
						"150",
						"150",
						"150"
					],
					"projections_percentage": [
						23.38,
						0,
						-2.6,
						-2.6,
						-2.6,
						-2.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1350
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.84,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						148.964841541578,
						-30.1022655195616
					],
					"name": "Burren Junction Public School",
					"playspace": 193.05,
					"projections": [
						45,
						52,
						55,
						55,
						50,
						50
					],
					"projections_orig": [
						"45",
						"52",
						"55",
						"55",
						"50",
						"50"
					],
					"projections_percentage": [
						-13.46,
						0,
						5.77,
						5.77,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1447
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.52,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						147.688115720509,
						-30.4615289906861
					],
					"name": "Carinda Public School",
					"playspace": 1079.9,
					"projections": [
						27,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						68.75,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1507
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 4.84,
					"enrolment": 280,
					"ligo": 1,
					"location": [
						145.837014600059,
						-31.5012676844532
					],
					"name": "Cobar Public School",
					"playspace": 123.64,
					"projections": [
						330,
						280,
						290,
						275,
						275,
						280
					],
					"projections_orig": [
						"330",
						"280",
						"290",
						"275",
						"275",
						"280"
					],
					"projections_percentage": [
						17.86,
						0,
						3.57,
						-1.79,
						-1.79,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1578
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 12
					},
					"classroomspace": 6.98,
					"enrolment": 112,
					"ligo": 0.91,
					"location": [
						148.57854368178,
						-29.5434237240757
					],
					"name": "Collarenebri Central School",
					"playspace": 81.45,
					"projections": [
						85,
						112,
						80,
						80,
						70,
						70
					],
					"projections_orig": [
						"85",
						"112",
						"80",
						"80",
						"70",
						"70"
					],
					"projections_percentage": [
						-24.11,
						0,
						-28.57,
						-28.57,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1589
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.48,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						146.396975568451,
						-33.0553633287201
					],
					"name": "Euabalong West Public School",
					"playspace": 329.68,
					"projections": [
						19,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.52,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1867
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 23.68,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						147.454618488507,
						-29.1162439209619
					],
					"name": "Goodooga Central School",
					"playspace": 826.98,
					"projections": [
						47,
						37,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"47",
						"37",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						27.03,
						0,
						-32.43,
						-32.43,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2033
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 25
					},
					"classroomspace": 4.71,
					"enrolment": 393,
					"ligo": 0.87,
					"location": [
						147.979403810976,
						-29.4260096755276
					],
					"name": "Lightning Ridge Central School",
					"playspace": 78.36,
					"projections": [
						390,
						393,
						345,
						325,
						305,
						290
					],
					"projections_orig": [
						"390",
						"393",
						"345",
						"325",
						"305",
						"290"
					],
					"projections_percentage": [
						-0.76,
						0,
						-12.21,
						-17.3,
						-22.39,
						-26.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2395
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 6.35,
					"enrolment": 135,
					"ligo": 1,
					"location": [
						148.115470873899,
						-30.0194233542571
					],
					"name": "Walgett Community College - Primary School",
					"playspace": 141,
					"projections": [
						125,
						135,
						105,
						100,
						95,
						90
					],
					"projections_orig": [
						"125",
						"135",
						"105",
						"100",
						"95",
						"90"
					],
					"projections_percentage": [
						-7.41,
						0,
						-22.22,
						-25.93,
						-29.63,
						-33.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3342
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 11.16,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						144.144935953638,
						-29.7054433220553
					],
					"name": "Wanaaring Public School",
					"playspace": 1890.61,
					"projections": [
						11,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						10,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3365
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.03,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						148.912127716637,
						-29.8143621839827
					],
					"name": "Rowena Public School",
					"playspace": 303.03,
					"projections": [
						33,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						13.79,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3580
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 26.06,
					"enrolment": 4,
					"ligo": 1,
					"location": [
						145.117425872381,
						-30.5353977385036
					],
					"name": "Louth Public School",
					"playspace": 601.61,
					"projections": [
						4,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"4",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3594
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 9.5,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						145.846137077583,
						-29.3185153775988
					],
					"name": "Enngonia Public School",
					"playspace": 242.64,
					"projections": [
						17,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.73,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3626
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 13.87,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						146.920076841579,
						-29.2399999831596
					],
					"name": "Weilmoringle Public School",
					"playspace": 1171.56,
					"projections": [
						14,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.69,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4305
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 15
					},
					"classroomspace": 7.66,
					"enrolment": 142,
					"ligo": 1,
					"location": [
						145.947164423602,
						-30.0909444879625
					],
					"name": "Bourke High School",
					"playspace": 215.72,
					"projections": [
						154,
						142,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"154",
						"142",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						8.45,
						0,
						-8.45,
						-8.45,
						-8.45,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8355
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 5.86,
					"enrolment": 258,
					"ligo": 1,
					"location": [
						145.826715610342,
						-31.5026801530073
					],
					"name": "Cobar High School",
					"playspace": 238.79,
					"projections": [
						241,
						258,
						260,
						255,
						240,
						245
					],
					"projections_orig": [
						"241",
						"258",
						"260",
						"255",
						"240",
						"245"
					],
					"projections_percentage": [
						-6.59,
						0,
						0.78,
						-1.16,
						-6.98,
						-5.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8356
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 19
					},
					"classroomspace": 12.46,
					"enrolment": 111,
					"ligo": 0.95,
					"location": [
						148.120024372393,
						-30.0270333764265
					],
					"name": "Walgett Community College - High School",
					"playspace": 279.23,
					"projections": [
						117,
						111,
						90,
						90,
						85,
						80
					],
					"projections_orig": [
						"117",
						"111",
						"90",
						"90",
						"85",
						"80"
					],
					"projections_percentage": [
						5.41,
						0,
						-18.92,
						-18.92,
						-23.42,
						-27.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8475
				}
			],
			"uid": 30020
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 61
			},
			"enrolment": 794,
			"level": "Combined",
			"ligo": 0.8,
			"name": "Sunraysia",
			"playspace": 267.39,
			"projections": [
				794,
				771,
				761,
				726,
				691
			],
			"projections_percentage": [
				0,
				-2.9,
				-4.16,
				-8.56,
				-12.97
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.8,
					"enrolment": 113,
					"ligo": 0.76,
					"location": [
						142.181871501105,
						-34.1702866632164
					],
					"name": "Buronga Public School",
					"playspace": 140.09,
					"projections": [
						86,
						113,
						95,
						95,
						90,
						90
					],
					"projections_orig": [
						"86",
						"113",
						"95",
						"95",
						"90",
						"90"
					],
					"projections_percentage": [
						-23.89,
						0,
						-15.93,
						-15.93,
						-20.35,
						-20.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1688
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 9.31,
					"enrolment": 62,
					"ligo": 0.91,
					"location": [
						142.041141744291,
						-34.0916584753109
					],
					"name": "Dareton Public School",
					"playspace": 268.29,
					"projections": [
						63,
						62,
						65,
						65,
						60,
						60
					],
					"projections_orig": [
						"63",
						"62",
						"65",
						"65",
						"60",
						"60"
					],
					"projections_percentage": [
						1.61,
						0,
						4.84,
						4.84,
						-3.23,
						-3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1732
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.98,
					"enrolment": 181,
					"ligo": 0.93,
					"location": [
						142.222713542232,
						-34.1790885974289
					],
					"name": "Gol Gol Public School",
					"playspace": 79.04,
					"projections": [
						192,
						181,
						185,
						180,
						175,
						165
					],
					"projections_orig": [
						"192",
						"181",
						"185",
						"180",
						"175",
						"165"
					],
					"projections_percentage": [
						6.08,
						0,
						2.21,
						-0.55,
						-3.31,
						-8.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2027
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.76,
					"enrolment": 21,
					"ligo": 0.37,
					"location": [
						141.894266641016,
						-34.026039568017
					],
					"name": "Pomona Public School",
					"playspace": 858.92,
					"projections": [
						30,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						42.86,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2893
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.5,
					"enrolment": 143,
					"ligo": 0.8,
					"location": [
						141.918445730567,
						-34.1033942794493
					],
					"name": "Wentworth Public School",
					"playspace": 57.63,
					"projections": [
						142,
						143,
						120,
						115,
						110,
						110
					],
					"projections_orig": [
						"142",
						"143",
						"120",
						"115",
						"110",
						"110"
					],
					"projections_percentage": [
						-0.7,
						0,
						-16.08,
						-19.58,
						-23.08,
						-23.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3421
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 25
					},
					"classroomspace": 6.69,
					"enrolment": 274,
					"ligo": 1,
					"location": [
						142.058701731489,
						-34.0945073210629
					],
					"name": "Coomealla High School",
					"playspace": 200.35,
					"projections": [
						349,
						274,
						285,
						285,
						270,
						245
					],
					"projections_orig": [
						"349",
						"274",
						"285",
						"285",
						"270",
						"245"
					],
					"projections_percentage": [
						27.37,
						0,
						4.01,
						4.01,
						-1.46,
						-10.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8494
				}
			],
			"uid": 30021
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 3
			},
			"enrolment": 33,
			"level": "Combined",
			"ligo": 1,
			"name": "Lord Howe Island",
			"playspace": 109.36,
			"projections": [
				33,
				33,
				33,
				33,
				33
			],
			"projections_percentage": [
				0,
				0,
				0,
				0,
				0
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.32,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						159.068780569961,
						-31.5302180394254
					],
					"name": "Lord Howe Island Central School",
					"playspace": 109.36,
					"projections": [
						22,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"22",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-33.33,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1921
				}
			],
			"uid": 30022
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 130
			},
			"enrolment": 2600,
			"level": "Combined",
			"ligo": 0.83,
			"name": "Barrington",
			"playspace": 188.93,
			"projections": [
				2600,
				2416,
				2346,
				2261,
				2161
			],
			"projections_percentage": [
				0,
				-7.08,
				-9.77,
				-13.04,
				-16.88
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.29,
					"enrolment": 54,
					"ligo": 1,
					"location": [
						151.910966286796,
						-31.9710587492479
					],
					"name": "Barrington Public School",
					"playspace": 98.98,
					"projections": [
						70,
						54,
						60,
						60,
						55,
						50
					],
					"projections_orig": [
						"70",
						"54",
						"60",
						"60",
						"55",
						"50"
					],
					"projections_percentage": [
						29.63,
						0,
						11.11,
						11.11,
						1.85,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1143
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.87,
					"enrolment": 140,
					"ligo": 0.94,
					"location": [
						151.776151232925,
						-32.5890465986167
					],
					"name": "Clarence Town Public School",
					"playspace": 71.58,
					"projections": [
						156,
						140,
						135,
						135,
						130,
						125
					],
					"projections_orig": [
						"156",
						"140",
						"135",
						"135",
						"130",
						"125"
					],
					"projections_percentage": [
						11.43,
						0,
						-3.57,
						-3.57,
						-7.14,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1564
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.83,
					"enrolment": 260,
					"ligo": 0.88,
					"location": [
						151.757378843866,
						-32.4058898125351
					],
					"name": "Dungog Public School",
					"playspace": 25.69,
					"projections": [
						203,
						260,
						260,
						255,
						250,
						240
					],
					"projections_orig": [
						"203",
						"260",
						"260",
						"255",
						"250",
						"240"
					],
					"projections_percentage": [
						-21.92,
						0,
						0,
						-1.92,
						-3.85,
						-7.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1792
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.61,
					"enrolment": 26,
					"ligo": 0.4,
					"location": [
						151.798379908761,
						-32.5257873668052
					],
					"name": "Glen William Public School",
					"playspace": 95.58,
					"projections": [
						29,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						11.54,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2020
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 3.36,
					"enrolment": 84,
					"ligo": 0.77,
					"location": [
						151.538579231935,
						-32.4272316216156
					],
					"name": "Gresford Public School",
					"playspace": 69.22,
					"projections": [
						62,
						84,
						80,
						80,
						75,
						75
					],
					"projections_orig": [
						"62",
						"84",
						"80",
						"80",
						"75",
						"75"
					],
					"projections_percentage": [
						-26.19,
						0,
						-4.76,
						-4.76,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2083
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.52,
					"enrolment": 86,
					"ligo": 0.65,
					"location": [
						151.650300265915,
						-32.7164710762437
					],
					"name": "Hinton Public School",
					"playspace": 72.22,
					"projections": [
						108,
						86,
						90,
						90,
						90,
						85
					],
					"projections_orig": [
						"108",
						"86",
						"90",
						"90",
						"90",
						"85"
					],
					"projections_percentage": [
						25.58,
						0,
						4.65,
						4.65,
						4.65,
						-1.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2167
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.32,
					"enrolment": 12,
					"ligo": 0.5,
					"location": [
						151.623757744235,
						-32.565555680794
					],
					"name": "Martins Creek Public School",
					"playspace": 446.63,
					"projections": [
						16,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						33.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2493
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 3.29,
					"enrolment": 106,
					"ligo": 0.74,
					"location": [
						151.612428295527,
						-32.6030478061266
					],
					"name": "Paterson Public School",
					"playspace": 110.97,
					"projections": [
						98,
						106,
						95,
						90,
						90,
						85
					],
					"projections_orig": [
						"98",
						"106",
						"95",
						"90",
						"90",
						"85"
					],
					"projections_percentage": [
						-7.55,
						0,
						-10.38,
						-15.09,
						-15.09,
						-19.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2844
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.51,
					"enrolment": 198,
					"ligo": 0.81,
					"location": [
						151.730440175033,
						-32.6621749071927
					],
					"name": "Seaham Public School",
					"playspace": 48,
					"projections": [
						217,
						198,
						210,
						205,
						200,
						195
					],
					"projections_orig": [
						"217",
						"198",
						"210",
						"205",
						"200",
						"195"
					],
					"projections_percentage": [
						9.6,
						0,
						6.06,
						3.54,
						1.01,
						-1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3048
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.19,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						151.938580202894,
						-32.1171736385373
					],
					"name": "Stratford Public School",
					"playspace": 1030.37,
					"projections": [
						16,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						23.08,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3119
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.89,
					"enrolment": 91,
					"ligo": 1,
					"location": [
						151.9649892227,
						-32.4027685868078
					],
					"name": "Stroud Public School",
					"playspace": 279.59,
					"projections": [
						90,
						91,
						90,
						90,
						90,
						85
					],
					"projections_orig": [
						"90",
						"91",
						"90",
						"90",
						"90",
						"85"
					],
					"projections_percentage": [
						-1.1,
						0,
						-1.1,
						-1.1,
						-1.1,
						-6.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3125
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.74,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						151.932009902482,
						-32.3478136748864
					],
					"name": "Stroud Road Public School",
					"playspace": 369.32,
					"projections": [
						28,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						86.67,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3126
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 3.19,
					"enrolment": 108,
					"ligo": 0.81,
					"location": [
						151.576986971922,
						-32.5419859190658
					],
					"name": "Vacy Public School",
					"playspace": 45.79,
					"projections": [
						90,
						108,
						100,
						100,
						95,
						95
					],
					"projections_orig": [
						"90",
						"108",
						"100",
						"100",
						"95",
						"95"
					],
					"projections_percentage": [
						-16.67,
						0,
						-7.41,
						-7.41,
						-12.04,
						-12.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3321
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.59,
					"enrolment": 348,
					"ligo": 1,
					"location": [
						151.960760802631,
						-32.0097112632031
					],
					"name": "Gloucester Public School",
					"playspace": 29.34,
					"projections": [
						309,
						348,
						300,
						270,
						255,
						240
					],
					"projections_orig": [
						"309",
						"348",
						"300",
						"270",
						"255",
						"240"
					],
					"projections_percentage": [
						-11.21,
						0,
						-13.79,
						-22.41,
						-26.72,
						-31.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7303
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 18
					},
					"classroomspace": 4.03,
					"enrolment": 363,
					"ligo": 0.85,
					"location": [
						151.960986593641,
						-32.0168579402889
					],
					"name": "Gloucester High School",
					"playspace": 144.3,
					"projections": [
						352,
						363,
						320,
						305,
						285,
						255
					],
					"projections_orig": [
						"352",
						"363",
						"320",
						"305",
						"285",
						"255"
					],
					"projections_percentage": [
						-3.03,
						0,
						-11.85,
						-15.98,
						-21.49,
						-29.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8371
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 3.63,
					"enrolment": 696,
					"ligo": 0.86,
					"location": [
						151.75090828138,
						-32.3980148192262
					],
					"name": "Dungog High School",
					"playspace": 85.23,
					"projections": [
						645,
						696,
						610,
						600,
						580,
						565
					],
					"projections_orig": [
						"645",
						"696",
						"610",
						"600",
						"580",
						"565"
					],
					"projections_percentage": [
						-7.33,
						0,
						-12.36,
						-13.79,
						-16.67,
						-18.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8472
				}
			],
			"uid": 30025
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 220
			},
			"enrolment": 3987,
			"level": "Combined",
			"ligo": 0.92,
			"name": "Great Lakes",
			"playspace": 137.35,
			"projections": [
				3986,
				4321,
				4196,
				3966,
				3706
			],
			"projections_percentage": [
				0,
				8.4,
				5.27,
				-0.5,
				-7.02
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.9,
					"enrolment": 79,
					"ligo": 1,
					"location": [
						151.959730383607,
						-32.4715008384812
					],
					"name": "Booral Public School",
					"playspace": 213.49,
					"projections": [
						71,
						79,
						65,
						65,
						65,
						60
					],
					"projections_orig": [
						"71",
						"79",
						"65",
						"65",
						"65",
						"60"
					],
					"projections_percentage": [
						-10.13,
						0,
						-17.72,
						-17.72,
						-17.72,
						-24.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1311
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 33
					},
					"classroomspace": 6.04,
					"enrolment": 398,
					"ligo": 0.85,
					"location": [
						152.211912692333,
						-32.4124489561469
					],
					"name": "Bulahdelah Central School",
					"playspace": 74.22,
					"projections": [
						498,
						397,
						435,
						435,
						415,
						385
					],
					"projections_orig": [
						"498",
						"397",
						"435",
						"435",
						"415",
						"385"
					],
					"projections_percentage": [
						25.44,
						0,
						9.57,
						9.57,
						4.53,
						-3.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1402
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.95,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						152.448090504452,
						-32.3885665806073
					],
					"name": "Bungwahl Public School",
					"playspace": 230.81,
					"projections": [
						38,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						5.56,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1424
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 8
					},
					"classroomspace": 2.69,
					"enrolment": 328,
					"ligo": 1,
					"location": [
						152.540403564271,
						-32.3414011747002
					],
					"name": "Pacific Palms Public School",
					"playspace": 70.52,
					"projections": [
						268,
						328,
						350,
						315,
						300,
						290
					],
					"projections_orig": [
						"268",
						"328",
						"350",
						"315",
						"300",
						"290"
					],
					"projections_percentage": [
						-18.29,
						0,
						6.71,
						-3.96,
						-8.54,
						-11.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1551
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.67,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						152.318449014228,
						-32.2231130165947
					],
					"name": "Coolongolook Public School",
					"playspace": 565.56,
					"projections": [
						34,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"34",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-2.86,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1627
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 30
					},
					"classroomspace": 2.8,
					"enrolment": 744,
					"ligo": 0.93,
					"location": [
						152.524557712562,
						-32.1813812428563
					],
					"name": "Forster Public School",
					"playspace": 38.29,
					"projections": [
						721,
						744,
						815,
						775,
						715,
						670
					],
					"projections_orig": [
						"721",
						"744",
						"815",
						"775",
						"715",
						"670"
					],
					"projections_percentage": [
						-3.09,
						0,
						9.54,
						4.17,
						-3.9,
						-9.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1936
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 4
					},
					"classroomspace": 2.7,
					"enrolment": 191,
					"ligo": 0.91,
					"location": [
						152.381440541537,
						-32.097215818587
					],
					"name": "Nabiac Public School",
					"playspace": 43.14,
					"projections": [
						192,
						191,
						190,
						185,
						175,
						170
					],
					"projections_orig": [
						"192",
						"191",
						"190",
						"185",
						"175",
						"170"
					],
					"projections_percentage": [
						0.52,
						0,
						-0.52,
						-3.14,
						-8.38,
						-10.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2695
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.3,
					"enrolment": 170,
					"ligo": 1,
					"location": [
						152.158100945364,
						-32.6673872108264
					],
					"name": "Tea Gardens Public School",
					"playspace": 71.02,
					"projections": [
						235,
						170,
						255,
						250,
						240,
						230
					],
					"projections_orig": [
						"235",
						"170",
						"255",
						"250",
						"240",
						"230"
					],
					"projections_percentage": [
						38.24,
						0,
						50,
						47.06,
						41.18,
						35.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3175
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.5,
					"enrolment": 376,
					"ligo": 0.73,
					"location": [
						152.494488126967,
						-32.171894802293
					],
					"name": "Tuncurry Public School",
					"playspace": 43.66,
					"projections": [
						382,
						376,
						415,
						385,
						360,
						340
					],
					"projections_orig": [
						"382",
						"376",
						"415",
						"385",
						"360",
						"340"
					],
					"projections_percentage": [
						1.6,
						0,
						10.37,
						2.39,
						-4.26,
						-9.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4533
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 28
					},
					"classroomspace": 3.58,
					"enrolment": 487,
					"ligo": 0.94,
					"location": [
						152.494870295997,
						-32.1603259847564
					],
					"name": "Great Lakes College Senior Campus",
					"playspace": 87.95,
					"projections": [
						479,
						487,
						490,
						485,
						460,
						420
					],
					"projections_orig": [
						"479",
						"487",
						"490",
						"485",
						"460",
						"420"
					],
					"projections_percentage": [
						-1.64,
						0,
						0.62,
						-0.41,
						-5.54,
						-13.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8281
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 3.07,
					"enrolment": 553,
					"ligo": 0.81,
					"location": [
						152.494870295997,
						-32.1603259847564
					],
					"name": "Great Lakes College Tuncurry Campus",
					"playspace": 81.43,
					"projections": [
						520,
						553,
						570,
						565,
						535,
						490
					],
					"projections_orig": [
						"520",
						"553",
						"570",
						"565",
						"535",
						"490"
					],
					"projections_percentage": [
						-5.97,
						0,
						3.07,
						2.17,
						-3.25,
						-11.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8289
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 55
					},
					"classroomspace": 5.68,
					"enrolment": 590,
					"ligo": 0.93,
					"location": [
						152.528513343253,
						-32.2140846574175
					],
					"name": "Great Lakes College Forster Campus",
					"playspace": 128.09,
					"projections": [
						655,
						590,
						665,
						665,
						630,
						580
					],
					"projections_orig": [
						"655",
						"590",
						"665",
						"665",
						"630",
						"580"
					],
					"projections_percentage": [
						11.02,
						0,
						12.71,
						12.71,
						6.78,
						-1.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8534
				}
			],
			"uid": 30028
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 53
			},
			"enrolment": 1212,
			"level": "Combined",
			"ligo": 0.75,
			"name": "Kurri Kurri",
			"playspace": 93.24,
			"projections": [
				1212,
				1256,
				1310,
				1350,
				1360
			],
			"projections_percentage": [
				0,
				3.63,
				8.09,
				11.39,
				12.21
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.19,
					"enrolment": 41,
					"ligo": 0.84,
					"location": [
						151.479048026107,
						-32.9010509450037
					],
					"name": "Mulbring Public School",
					"playspace": 254.84,
					"projections": [
						65,
						41,
						25,
						50,
						50,
						50
					],
					"projections_orig": [
						"65",
						"41",
						"<50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						58.54,
						0,
						-39.02,
						21.95,
						21.95,
						21.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2658
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 4
					},
					"classroomspace": 2.65,
					"enrolment": 261,
					"ligo": 0.35,
					"location": [
						151.484801566309,
						-32.831515150892
					],
					"name": "Pelaw Main Public School",
					"playspace": 30.67,
					"projections": [
						201,
						261,
						255,
						265,
						275,
						275
					],
					"projections_orig": [
						"201",
						"261",
						"255",
						"265",
						"275",
						"275"
					],
					"projections_percentage": [
						-22.99,
						0,
						-2.3,
						1.53,
						5.36,
						5.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2855
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.11,
					"enrolment": 190,
					"ligo": 0.87,
					"location": [
						151.461035202719,
						-32.8094346245112
					],
					"name": "Weston Public School",
					"playspace": 69.06,
					"projections": [
						193,
						190,
						200,
						210,
						215,
						215
					],
					"projections_orig": [
						"193",
						"190",
						"200",
						"210",
						"215",
						"215"
					],
					"projections_percentage": [
						1.58,
						0,
						5.26,
						10.53,
						13.16,
						13.16
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3431
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.9,
					"enrolment": 72,
					"ligo": 1,
					"location": [
						151.496020431696,
						-32.8231598528091
					],
					"name": "Stanford Merthyr Infants School",
					"playspace": 90.71,
					"projections": [
						68,
						72,
						75,
						75,
						80,
						80
					],
					"projections_orig": [
						"68",
						"72",
						"75",
						"75",
						"80",
						"80"
					],
					"projections_percentage": [
						-5.56,
						0,
						4.17,
						4.17,
						11.11,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5133
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 2.59,
					"enrolment": 648,
					"ligo": 0.71,
					"location": [
						151.477795269895,
						-32.8207055460627
					],
					"name": "Kurri Kurri Public School",
					"playspace": 20.9,
					"projections": [
						620,
						648,
						685,
						710,
						730,
						740
					],
					"projections_orig": [
						"620",
						"648",
						"685",
						"710",
						"730",
						"740"
					],
					"projections_percentage": [
						-4.32,
						0,
						5.71,
						9.57,
						12.65,
						14.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7422
				}
			],
			"uid": 30030
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 103
			},
			"enrolment": 2182,
			"level": "Combined",
			"ligo": 0.93,
			"name": "Muswellbrook",
			"playspace": 212.06,
			"projections": [
				2182,
				2393,
				2483,
				2433,
				2423
			],
			"projections_percentage": [
				0,
				9.67,
				13.79,
				11.5,
				11.04
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.07,
					"enrolment": 163,
					"ligo": 1,
					"location": [
						150.687076776807,
						-32.3858144449494
					],
					"name": "Denman Public School",
					"playspace": 104.85,
					"projections": [
						212,
						163,
						200,
						210,
						210,
						215
					],
					"projections_orig": [
						"212",
						"163",
						"200",
						"210",
						"210",
						"215"
					],
					"projections_percentage": [
						30.06,
						0,
						22.7,
						28.83,
						28.83,
						31.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1749
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.52,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						150.568584097841,
						-32.3356673185689
					],
					"name": "Sandy Hollow Public School",
					"playspace": 573.12,
					"projections": [
						46,
						30,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"46",
						"30",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						53.33,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1974
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.85,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						150.665127235894,
						-32.4588946965625
					],
					"name": "Martindale Public School",
					"playspace": 464.8,
					"projections": [
						17,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						30.77,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2492
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 22
					},
					"classroomspace": 2.52,
					"enrolment": 600,
					"ligo": 0.76,
					"location": [
						150.895016845331,
						-32.2588832317446
					],
					"name": "Muswellbrook Public School",
					"playspace": 30.07,
					"projections": [
						566,
						600,
						675,
						690,
						660,
						670
					],
					"projections_orig": [
						"566",
						"600",
						"675",
						"690",
						"660",
						"670"
					],
					"projections_percentage": [
						-5.67,
						0,
						12.5,
						15,
						10,
						11.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2688
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 20
					},
					"classroomspace": 2.94,
					"enrolment": 548,
					"ligo": 0.88,
					"location": [
						150.88985801063,
						-32.2733268531591
					],
					"name": "Muswellbrook South Public School",
					"playspace": 41.76,
					"projections": [
						396,
						548,
						555,
						565,
						540,
						550
					],
					"projections_orig": [
						"396",
						"548",
						"555",
						"565",
						"540",
						"550"
					],
					"projections_percentage": [
						-27.74,
						0,
						1.28,
						3.1,
						-1.46,
						0.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3876
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 49
					},
					"classroomspace": 4.01,
					"enrolment": 828,
					"ligo": 0.95,
					"location": [
						150.898863471219,
						-32.2681322208235
					],
					"name": "Muswellbrook High School",
					"playspace": 57.79,
					"projections": [
						778,
						828,
						900,
						955,
						960,
						925
					],
					"projections_orig": [
						"778",
						"828",
						"900",
						"955",
						"960",
						"925"
					],
					"projections_percentage": [
						-6.04,
						0,
						8.7,
						15.34,
						15.94,
						11.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8164
				}
			],
			"uid": 30035
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 131
			},
			"enrolment": 2778,
			"level": "Combined",
			"ligo": 0.75,
			"name": "Singleton",
			"playspace": 344.56,
			"projections": [
				2778,
				3015,
				3105,
				3145,
				3188
			],
			"projections_percentage": [
				0,
				8.53,
				11.77,
				13.21,
				14.76
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.1,
					"enrolment": 80,
					"ligo": 0.83,
					"location": [
						151.104381587469,
						-32.7450708879833
					],
					"name": "Broke Public School",
					"playspace": 247.35,
					"projections": [
						58,
						80,
						80,
						85,
						85,
						85
					],
					"projections_orig": [
						"58",
						"80",
						"80",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						-27.5,
						0,
						0,
						6.25,
						6.25,
						6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1367
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.27,
					"enrolment": 42,
					"ligo": 0.91,
					"location": [
						150.906720120335,
						-32.4969765755282
					],
					"name": "Jerrys Plains Public School",
					"playspace": 217.53,
					"projections": [
						26,
						42,
						25,
						25,
						25,
						50
					],
					"projections_orig": [
						"26",
						"42",
						"<50",
						"<50",
						"<50",
						"50"
					],
					"projections_percentage": [
						-38.1,
						0,
						-40.48,
						-40.48,
						-40.48,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2231
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 6.89,
					"enrolment": 37,
					"ligo": 0.67,
					"location": [
						151.290573328184,
						-32.6093925672315
					],
					"name": "Kirkton Public School",
					"playspace": 145.93,
					"projections": [
						64,
						37,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"64",
						"37",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						72.97,
						0,
						48.65,
						48.65,
						48.65,
						48.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2314
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 6.39,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						151.005769897549,
						-32.6959833805048
					],
					"name": "Milbrodale Public School",
					"playspace": 2219.28,
					"projections": [
						8,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2550
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 3.78,
					"enrolment": 59,
					"ligo": 0.54,
					"location": [
						151.189006865063,
						-32.4089298646062
					],
					"name": "Mount Pleasant Public School",
					"playspace": 86.77,
					"projections": [
						59,
						59,
						60,
						60,
						65,
						65
					],
					"projections_orig": [
						"59",
						"59",
						"60",
						"60",
						"65",
						"65"
					],
					"projections_percentage": [
						0,
						0,
						1.69,
						1.69,
						10.17,
						10.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2647
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.6,
					"enrolment": 465,
					"ligo": 0.53,
					"location": [
						151.172379397098,
						-32.56359929729
					],
					"name": "Singleton Public School",
					"playspace": 25.15,
					"projections": [
						423,
						465,
						485,
						495,
						500,
						505
					],
					"projections_orig": [
						"423",
						"465",
						"485",
						"495",
						"500",
						"505"
					],
					"projections_percentage": [
						-9.03,
						0,
						4.3,
						6.45,
						7.53,
						8.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3070
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 2.21,
					"enrolment": 566,
					"ligo": 0.76,
					"location": [
						151.163112747345,
						-32.5488655489661
					],
					"name": "Singleton Heights Public School",
					"playspace": 48.35,
					"projections": [
						622,
						566,
						620,
						635,
						640,
						645
					],
					"projections_orig": [
						"622",
						"566",
						"620",
						"635",
						"640",
						"645"
					],
					"projections_percentage": [
						9.89,
						0,
						9.54,
						12.19,
						13.07,
						13.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4486
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.39,
					"enrolment": 356,
					"ligo": 0.68,
					"location": [
						151.175934121256,
						-32.5687799320255
					],
					"name": "King Street Public School",
					"playspace": 74.26,
					"projections": [
						437,
						356,
						400,
						410,
						415,
						420
					],
					"projections_orig": [
						"437",
						"356",
						"400",
						"410",
						"415",
						"420"
					],
					"projections_percentage": [
						22.75,
						0,
						12.36,
						15.17,
						16.57,
						17.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4514
				},
				{
					"classrooms": {
						"demountable": 8,
						"permanent": 55
					},
					"classroomspace": 3.91,
					"enrolment": 1165,
					"ligo": 0.87,
					"location": [
						151.176819121039,
						-32.5680509320849
					],
					"name": "Singleton High School",
					"playspace": 36.46,
					"projections": [
						1236,
						1165,
						1265,
						1315,
						1335,
						1355
					],
					"projections_orig": [
						"1236",
						"1165",
						"1265",
						"1315",
						"1335",
						"1355"
					],
					"projections_percentage": [
						6.09,
						0,
						8.58,
						12.88,
						14.59,
						16.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8202
				}
			],
			"uid": 30039
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 90
			},
			"enrolment": 1503,
			"level": "Combined",
			"ligo": 0.96,
			"name": "Upper Hunter",
			"playspace": 623.4,
			"projections": [
				1503,
				1654,
				1609,
				1564,
				1519
			],
			"projections_percentage": [
				0,
				10.05,
				7.05,
				4.06,
				1.06
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 9
					},
					"classroomspace": 2.71,
					"enrolment": 231,
					"ligo": 1,
					"location": [
						150.889178092738,
						-32.1660862932814
					],
					"name": "Aberdeen Public School",
					"playspace": 52.5,
					"projections": [
						208,
						231,
						255,
						240,
						240,
						235
					],
					"projections_orig": [
						"208",
						"231",
						"255",
						"240",
						"240",
						"235"
					],
					"projections_percentage": [
						-9.96,
						0,
						10.39,
						3.9,
						3.9,
						1.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1002
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.22,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						151.130342519536,
						-31.9890169144958
					],
					"name": "Belltrees Public School",
					"playspace": 3439.35,
					"projections": [
						13,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1182
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.27,
					"enrolment": 39,
					"ligo": 1,
					"location": [
						150.893214981464,
						-31.778992337093
					],
					"name": "Blandford Public School",
					"playspace": 124.14,
					"projections": [
						40,
						39,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"40",
						"39",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						2.56,
						0,
						-35.9,
						-35.9,
						-35.9,
						-35.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1256
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 10.1,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						149.97771775755,
						-32.0050189114271
					],
					"name": "Cassilis Public School",
					"playspace": 1456.95,
					"projections": [
						21,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						75,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1527
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.34,
					"enrolment": 25,
					"ligo": 1,
					"location": [
						151.304111132462,
						-31.8172848348861
					],
					"name": "Ellerston Public School",
					"playspace": 225.88,
					"projections": [
						22,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"22",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-12,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1830
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 15
					},
					"classroomspace": 4.24,
					"enrolment": 285,
					"ligo": 0.79,
					"location": [
						150.352236418506,
						-32.1453647406722
					],
					"name": "Merriwa Central School",
					"playspace": 79.85,
					"projections": [
						231,
						285,
						245,
						240,
						235,
						225
					],
					"projections_orig": [
						"231",
						"285",
						"245",
						"240",
						"235",
						"225"
					],
					"projections_percentage": [
						-18.95,
						0,
						-14.04,
						-15.79,
						-17.54,
						-21.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2528
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.28,
					"enrolment": 53,
					"ligo": 1,
					"location": [
						150.832540079886,
						-31.7624860170601
					],
					"name": "Murrurundi Public School",
					"playspace": 108.83,
					"projections": [
						58,
						53,
						60,
						55,
						55,
						55
					],
					"projections_orig": [
						"58",
						"53",
						"60",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						9.43,
						0,
						13.21,
						3.77,
						3.77,
						3.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2686
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 19
					},
					"classroomspace": 2.51,
					"enrolment": 451,
					"ligo": 1,
					"location": [
						150.86295071958,
						-32.0495917201343
					],
					"name": "Scone Public School",
					"playspace": 28.79,
					"projections": [
						508,
						451,
						565,
						550,
						520,
						515
					],
					"projections_orig": [
						"508",
						"451",
						"565",
						"550",
						"520",
						"515"
					],
					"projections_percentage": [
						12.64,
						0,
						25.28,
						21.95,
						15.3,
						14.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7311
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 5.38,
					"enrolment": 394,
					"ligo": 0.88,
					"location": [
						150.872617232191,
						-32.0562611035993
					],
					"name": "Scone High School",
					"playspace": 94.32,
					"projections": [
						444,
						394,
						440,
						435,
						425,
						400
					],
					"projections_orig": [
						"444",
						"394",
						"440",
						"435",
						"425",
						"400"
					],
					"projections_percentage": [
						12.69,
						0,
						11.68,
						10.41,
						7.87,
						1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8409
				}
			],
			"uid": 30040
		},
		{
			"classrooms": {
				"demountable": 18,
				"permanent": 107
			},
			"enrolment": 2652,
			"level": "Combined",
			"ligo": 0.88,
			"name": "Ulladulla/Milton",
			"playspace": 37.34,
			"projections": [
				2652,
				2515,
				2505,
				2450,
				2385
			],
			"projections_percentage": [
				0,
				-5.17,
				-5.54,
				-7.62,
				-10.07
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 24
					},
					"classroomspace": 2.88,
					"enrolment": 693,
					"ligo": 0.81,
					"location": [
						150.43627028714,
						-35.3146929490312
					],
					"name": "Milton Public School",
					"playspace": 43.71,
					"projections": [
						558,
						693,
						685,
						680,
						670,
						650
					],
					"projections_orig": [
						"558",
						"693",
						"685",
						"680",
						"670",
						"650"
					],
					"projections_percentage": [
						-19.48,
						0,
						-1.15,
						-1.88,
						-3.32,
						-6.2
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2565
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 22
					},
					"classroomspace": 2.66,
					"enrolment": 725,
					"ligo": 0.87,
					"location": [
						150.46980318167,
						-35.3563661121291
					],
					"name": "Ulladulla Public School",
					"playspace": 32.34,
					"projections": [
						627,
						725,
						685,
						680,
						665,
						645
					],
					"projections_orig": [
						"627",
						"725",
						"685",
						"680",
						"665",
						"645"
					],
					"projections_percentage": [
						-13.52,
						0,
						-5.52,
						-6.21,
						-8.28,
						-11.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3302
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 61
					},
					"classroomspace": 3.41,
					"enrolment": 1234,
					"ligo": 0.96,
					"location": [
						150.47115168817,
						-35.3593094549874
					],
					"name": "Ulladulla High School",
					"playspace": 35.97,
					"projections": [
						1149,
						1234,
						1145,
						1145,
						1115,
						1090
					],
					"projections_orig": [
						"1149",
						"1234",
						"1145",
						"1145",
						"1115",
						"1090"
					],
					"projections_percentage": [
						-6.89,
						0,
						-7.21,
						-7.21,
						-9.64,
						-11.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8495
				}
			],
			"uid": 30043
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 292
			},
			"enrolment": 4359,
			"level": "Combined",
			"ligo": 0.92,
			"name": "Cootamundra Network RM",
			"playspace": 425.54,
			"projections": [
				4360,
				4339,
				4144,
				3904,
				3642
			],
			"projections_percentage": [
				0,
				-0.48,
				-4.95,
				-10.46,
				-16.47
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.66,
					"enrolment": 78,
					"ligo": 1,
					"location": [
						148.063166154964,
						-35.3129504040392
					],
					"name": "Adelong Public School",
					"playspace": 206.87,
					"projections": [
						89,
						78,
						75,
						75,
						75,
						70
					],
					"projections_orig": [
						"89",
						"78",
						"75",
						"75",
						"75",
						"70"
					],
					"projections_percentage": [
						14.1,
						0,
						-3.85,
						-3.85,
						-3.85,
						-10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1009
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 8
					},
					"classroomspace": 5.03,
					"enrolment": 132,
					"ligo": 1,
					"location": [
						147.21793061169,
						-34.3473740756136
					],
					"name": "Ariah Park Central School",
					"playspace": 120.07,
					"projections": [
						119,
						132,
						125,
						115,
						110,
						100
					],
					"projections_orig": [
						"119",
						"132",
						"125",
						"115",
						"110",
						"100"
					],
					"projections_percentage": [
						-9.85,
						0,
						-5.3,
						-12.88,
						-16.67,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1055
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 12.02,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						147.38505653996,
						-34.147363454227
					],
					"name": "Barmedman Public School",
					"playspace": 1303.57,
					"projections": [
						18,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						28.57,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1137
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 4.75,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						148.39988020117,
						-35.0834524157993
					],
					"name": "Bongongo Public School",
					"playspace": 1102.03,
					"projections": [
						11,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-31.25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1293
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 5.34,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						148.232136910646,
						-35.1568357793331
					],
					"name": "Brungle Public School",
					"playspace": 2254.01,
					"projections": [
						24,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"24",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						140,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1387
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.02,
					"enrolment": 323,
					"ligo": 1,
					"location": [
						147.200705633574,
						-34.8118402917545
					],
					"name": "Coolamon Central School",
					"playspace": 35.63,
					"projections": [
						258,
						323,
						305,
						305,
						300,
						280
					],
					"projections_orig": [
						"258",
						"323",
						"305",
						"305",
						"300",
						"280"
					],
					"projections_percentage": [
						-20.12,
						0,
						-5.57,
						-5.57,
						-7.12,
						-13.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1624
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 3.3,
					"enrolment": 295,
					"ligo": 0.59,
					"location": [
						148.026941219618,
						-34.6395023617423
					],
					"name": "Cootamundra Public School",
					"playspace": 36.19,
					"projections": [
						244,
						295,
						255,
						245,
						235,
						220
					],
					"projections_orig": [
						"244",
						"295",
						"255",
						"245",
						"235",
						"220"
					],
					"projections_percentage": [
						-17.29,
						0,
						-13.56,
						-16.95,
						-20.34,
						-25.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1636
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.88,
					"enrolment": 20,
					"ligo": 1,
					"location": [
						147.781487395767,
						-34.9103407024103
					],
					"name": "Eurongilly Public School",
					"playspace": 321.35,
					"projections": [
						17,
						20,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"20",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15,
						0,
						25,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1883
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 10.24,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						147.039279180598,
						-34.79654786838
					],
					"name": "Ganmain Public School",
					"playspace": 896.93,
					"projections": [
						39,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						50,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1954
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.32,
					"enrolment": 154,
					"ligo": 1,
					"location": [
						148.108373648521,
						-35.0516499114088
					],
					"name": "Gundagai Public School",
					"playspace": 293.4,
					"projections": [
						149,
						154,
						135,
						130,
						125,
						115
					],
					"projections_orig": [
						"149",
						"154",
						"135",
						"130",
						"125",
						"115"
					],
					"projections_percentage": [
						-3.25,
						0,
						-12.34,
						-15.58,
						-18.83,
						-25.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2102
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.4,
					"enrolment": 53,
					"ligo": 1,
					"location": [
						148.102553650512,
						-35.0803887964764
					],
					"name": "Gundagai South Public School",
					"playspace": 430.63,
					"projections": [
						85,
						53,
						55,
						55,
						50,
						25
					],
					"projections_orig": [
						"85",
						"53",
						"55",
						"55",
						"50",
						"<50"
					],
					"projections_percentage": [
						60.38,
						0,
						3.77,
						3.77,
						-5.66,
						-52.83
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2103
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.94,
					"enrolment": 28,
					"ligo": 1,
					"location": [
						147.740231833808,
						-34.8139012192777
					],
					"name": "Illabo Public School",
					"playspace": 392.41,
					"projections": [
						28,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2203
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.99,
					"enrolment": 135,
					"ligo": 0.89,
					"location": [
						147.585278960156,
						-34.8739625448868
					],
					"name": "Junee Public School",
					"playspace": 100.71,
					"projections": [
						129,
						135,
						140,
						145,
						140,
						130
					],
					"projections_orig": [
						"129",
						"135",
						"140",
						"145",
						"140",
						"130"
					],
					"projections_percentage": [
						-4.44,
						0,
						3.7,
						7.41,
						3.7,
						-3.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2247
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 4
					},
					"classroomspace": 2.75,
					"enrolment": 162,
					"ligo": 0.56,
					"location": [
						147.584504318211,
						-34.8552936426542
					],
					"name": "Junee North Public School",
					"playspace": 52.93,
					"projections": [
						191,
						162,
						170,
						170,
						165,
						155
					],
					"projections_orig": [
						"191",
						"162",
						"170",
						"170",
						"165",
						"155"
					],
					"projections_percentage": [
						17.9,
						0,
						4.94,
						4.94,
						1.85,
						-4.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2248
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.98,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						147.355144095925,
						-34.8283395019903
					],
					"name": "Marrar Public School",
					"playspace": 777.62,
					"projections": [
						28,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						86.67,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2485
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.38,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						146.92798413654,
						-34.769614988315
					],
					"name": "Matong Public School",
					"playspace": 814.72,
					"projections": [
						44,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						69.23,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2501
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.44,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						147.907969094659,
						-35.0541064314476
					],
					"name": "Nangus Public School",
					"playspace": 779.32,
					"projections": [
						32,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						10.34,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2699
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.38,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						147.883273225633,
						-34.4973220954575
					],
					"name": "Stockinbingal Public School",
					"playspace": 226.35,
					"projections": [
						37,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						42.31,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3109
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.1,
					"enrolment": 279,
					"ligo": 0.74,
					"location": [
						147.534671138143,
						-34.444916446533
					],
					"name": "Temora Public School",
					"playspace": 22.36,
					"projections": [
						209,
						279,
						245,
						225,
						210,
						200
					],
					"projections_orig": [
						"209",
						"279",
						"245",
						"225",
						"210",
						"200"
					],
					"projections_percentage": [
						-25.09,
						0,
						-12.19,
						-19.35,
						-24.73,
						-28.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3178
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 2.97,
					"enrolment": 314,
					"ligo": 0.62,
					"location": [
						148.217621164659,
						-35.3024085084743
					],
					"name": "Tumut Public School",
					"playspace": 44.79,
					"projections": [
						343,
						314,
						350,
						310,
						285,
						265
					],
					"projections_orig": [
						"343",
						"314",
						"350",
						"310",
						"285",
						"265"
					],
					"projections_percentage": [
						9.24,
						0,
						11.46,
						-1.27,
						-9.24,
						-15.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3278
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.37,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						148.159096752089,
						-34.5243442489961
					],
					"name": "Wallendbeen Public School",
					"playspace": 1145.52,
					"projections": [
						16,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						14.29,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3353
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 3.21,
					"enrolment": 146,
					"ligo": 0.74,
					"location": [
						147.523526138967,
						-34.450640393908
					],
					"name": "Temora West Public School",
					"playspace": 205.03,
					"projections": [
						156,
						146,
						145,
						140,
						130,
						125
					],
					"projections_orig": [
						"156",
						"146",
						"145",
						"140",
						"130",
						"125"
					],
					"projections_percentage": [
						6.85,
						0,
						-0.68,
						-4.11,
						-10.96,
						-14.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4209
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 5.81,
					"enrolment": 130,
					"ligo": 0.7,
					"location": [
						148.013920847077,
						-34.6424423153949
					],
					"name": "E A Southee Public School",
					"playspace": 166.61,
					"projections": [
						215,
						130,
						165,
						160,
						150,
						140
					],
					"projections_orig": [
						"215",
						"130",
						"165",
						"160",
						"150",
						"140"
					],
					"projections_percentage": [
						65.38,
						0,
						26.92,
						23.08,
						15.38,
						7.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4383
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 8
					},
					"classroomspace": 3.38,
					"enrolment": 296,
					"ligo": 0.83,
					"location": [
						148.229607621144,
						-35.3149451601717
					],
					"name": "Franklin Public School",
					"playspace": 63.7,
					"projections": [
						295,
						296,
						315,
						265,
						250,
						235
					],
					"projections_orig": [
						"295",
						"296",
						"315",
						"265",
						"250",
						"235"
					],
					"projections_percentage": [
						-0.34,
						0,
						6.42,
						-10.47,
						-15.54,
						-20.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4456
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 4.8,
					"enrolment": 351,
					"ligo": 1,
					"location": [
						147.54092068207,
						-34.4417197653749
					],
					"name": "Temora High School",
					"playspace": 79.41,
					"projections": [
						371,
						351,
						355,
						325,
						290,
						275
					],
					"projections_orig": [
						"371",
						"351",
						"355",
						"325",
						"290",
						"275"
					],
					"projections_percentage": [
						5.7,
						0,
						1.14,
						-7.41,
						-17.38,
						-21.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8168
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 7.48,
					"enrolment": 203,
					"ligo": 1,
					"location": [
						147.590493034036,
						-34.869408946834
					],
					"name": "Junee High School",
					"playspace": 163.61,
					"projections": [
						246,
						204,
						225,
						230,
						220,
						210
					],
					"projections_orig": [
						"246",
						"204",
						"225",
						"230",
						"220",
						"210"
					],
					"projections_percentage": [
						20.59,
						0,
						10.29,
						12.75,
						7.84,
						2.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8179
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 34
					},
					"classroomspace": 6.86,
					"enrolment": 315,
					"ligo": 1,
					"location": [
						148.019332648864,
						-34.6355058261483
					],
					"name": "Cootamundra High School",
					"playspace": 128.05,
					"projections": [
						376,
						315,
						285,
						290,
						270,
						240
					],
					"projections_orig": [
						"376",
						"315",
						"285",
						"290",
						"270",
						"240"
					],
					"projections_percentage": [
						19.37,
						0,
						-9.52,
						-7.94,
						-14.29,
						-23.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8190
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 35
					},
					"classroomspace": 4.21,
					"enrolment": 563,
					"ligo": 1,
					"location": [
						148.220184708587,
						-35.3128378942835
					],
					"name": "Tumut High School",
					"playspace": 53.33,
					"projections": [
						565,
						563,
						565,
						535,
						490,
						430
					],
					"projections_orig": [
						"565",
						"563",
						"565",
						"535",
						"490",
						"430"
					],
					"projections_percentage": [
						0.36,
						0,
						0.36,
						-4.97,
						-12.97,
						-23.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8343
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 16
					},
					"classroomspace": 5.55,
					"enrolment": 206,
					"ligo": 1,
					"location": [
						148.100228354432,
						-35.0579608521979
					],
					"name": "Gundagai High School",
					"playspace": 123.57,
					"projections": [
						222,
						206,
						205,
						200,
						185,
						175
					],
					"projections_orig": [
						"222",
						"206",
						"205",
						"200",
						"185",
						"175"
					],
					"projections_percentage": [
						7.77,
						0,
						-0.49,
						-2.91,
						-10.19,
						-15.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8442
				}
			],
			"uid": 30045
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 312
			},
			"enrolment": 3790,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Deniliquin Network RM",
			"playspace": 462.7,
			"projections": [
				3790,
				3510,
				3400,
				3280,
				3136
			],
			"projections_percentage": [
				0,
				-7.39,
				-10.29,
				-13.46,
				-17.26
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.55,
					"enrolment": 151,
					"ligo": 1,
					"location": [
						144.12848865298,
						-35.6273520080064
					],
					"name": "Barham Public School",
					"playspace": 128.32,
					"projections": [
						165,
						151,
						155,
						145,
						135,
						125
					],
					"projections_orig": [
						"165",
						"151",
						"155",
						"145",
						"135",
						"125"
					],
					"projections_percentage": [
						9.27,
						0,
						2.65,
						-3.97,
						-10.6,
						-17.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1135
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.68,
					"enrolment": 153,
					"ligo": 1,
					"location": [
						145.696508770555,
						-35.9127892742736
					],
					"name": "Barooga Public School",
					"playspace": 114.39,
					"projections": [
						148,
						153,
						160,
						150,
						140,
						130
					],
					"projections_orig": [
						"148",
						"153",
						"160",
						"150",
						"140",
						"130"
					],
					"projections_percentage": [
						-3.27,
						0,
						4.58,
						-1.96,
						-8.5,
						-15.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1139
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.46,
					"enrolment": 81,
					"ligo": 1,
					"location": [
						145.815507649309,
						-35.6587207455738
					],
					"name": "Berrigan Public School",
					"playspace": 208.46,
					"projections": [
						74,
						81,
						75,
						70,
						65,
						60
					],
					"projections_orig": [
						"74",
						"81",
						"75",
						"70",
						"65",
						"60"
					],
					"projections_percentage": [
						-8.64,
						0,
						-7.41,
						-13.58,
						-19.75,
						-25.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1207
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.28,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						145.349870056973,
						-35.579814751989
					],
					"name": "Blighty Public School",
					"playspace": 189.84,
					"projections": [
						30,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-16.67,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1261
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.87,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						144.886334432158,
						-33.8668229141847
					],
					"name": "Booligal Public School",
					"playspace": 667.48,
					"projections": [
						10,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1303
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.07,
					"enrolment": 48,
					"ligo": 1,
					"location": [
						144.597707373558,
						-35.7856431334799
					],
					"name": "Bunnaloo Public School",
					"playspace": 257.06,
					"projections": [
						46,
						48,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"46",
						"48",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-4.17,
						0,
						-47.92,
						-47.92,
						-47.92,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1425
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 11.87,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						145.431843318175,
						-34.4083240213921
					],
					"name": "Carrathool Public School",
					"playspace": 3405.71,
					"projections": [
						12,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						71.43,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1517
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.08,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						145.179373036024,
						-35.3054803023697
					],
					"name": "Conargo Public School",
					"playspace": 765.12,
					"projections": [
						26,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						62.5,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1606
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.78,
					"enrolment": 196,
					"ligo": 1,
					"location": [
						144.844356799559,
						-34.505650761512
					],
					"name": "Hay Public School",
					"playspace": 93.27,
					"projections": [
						212,
						196,
						170,
						160,
						155,
						150
					],
					"projections_orig": [
						"212",
						"196",
						"170",
						"160",
						"155",
						"150"
					],
					"projections_percentage": [
						8.16,
						0,
						-13.27,
						-18.37,
						-20.92,
						-23.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2145
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 7.62,
					"enrolment": 40,
					"ligo": 1,
					"location": [
						145.729760509615,
						-35.3545034872328
					],
					"name": "Jerilderie Public School",
					"playspace": 227.37,
					"projections": [
						43,
						40,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"43",
						"40",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.5,
						0,
						-37.5,
						-37.5,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2226
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.69,
					"enrolment": 64,
					"ligo": 1,
					"location": [
						144.902922467883,
						-35.816052922635
					],
					"name": "Mathoura Public School",
					"playspace": 192.53,
					"projections": [
						58,
						64,
						60,
						55,
						55,
						50
					],
					"projections_orig": [
						"58",
						"64",
						"60",
						"55",
						"55",
						"50"
					],
					"projections_percentage": [
						-9.38,
						0,
						-6.25,
						-14.06,
						-14.06,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2500
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.23,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						145.308663911255,
						-35.4635669988092
					],
					"name": "Mayrung Public School",
					"playspace": 212.81,
					"projections": [
						31,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						6.9,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2508
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 3.45,
					"enrolment": 206,
					"ligo": 1,
					"location": [
						144.763310165609,
						-36.1148683852224
					],
					"name": "Moama Public School",
					"playspace": 67.64,
					"projections": [
						247,
						206,
						195,
						200,
						200,
						195
					],
					"projections_orig": [
						"247",
						"206",
						"195",
						"200",
						"200",
						"195"
					],
					"projections_percentage": [
						19.9,
						0,
						-5.34,
						-2.91,
						-2.91,
						-5.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2584
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 13.38,
					"enrolment": 44,
					"ligo": 1,
					"location": [
						144.033524855089,
						-35.0898035024564
					],
					"name": "Moulamein Public School",
					"playspace": 292.36,
					"projections": [
						42,
						44,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"42",
						"44",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-4.55,
						0,
						-43.18,
						-43.18,
						-43.18,
						-43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2632
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.77,
					"enrolment": 51,
					"ligo": 1,
					"location": [
						146.007065621257,
						-35.9874066482704
					],
					"name": "Mulwala Public School",
					"playspace": 144.05,
					"projections": [
						61,
						51,
						55,
						50,
						50,
						25
					],
					"projections_orig": [
						"61",
						"51",
						"55",
						"50",
						"50",
						"<50"
					],
					"projections_percentage": [
						19.61,
						0,
						7.84,
						-1.96,
						-1.96,
						-50.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2667
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 11.36,
					"enrolment": 67,
					"ligo": 1,
					"location": [
						146.169855945716,
						-35.552306912927
					],
					"name": "Oaklands Central School",
					"playspace": 455,
					"projections": [
						66,
						67,
						85,
						75,
						70,
						65
					],
					"projections_orig": [
						"66",
						"67",
						"85",
						"75",
						"70",
						"65"
					],
					"projections_percentage": [
						-1.49,
						0,
						26.87,
						11.94,
						4.48,
						-2.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2791
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 6.34,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						146.047075973054,
						-35.7315106304148
					],
					"name": "Savernake Public School",
					"playspace": 1972.06,
					"projections": [
						20,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						100,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3041
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 2.66,
					"enrolment": 154,
					"ligo": 1,
					"location": [
						145.568390165788,
						-35.8134183153876
					],
					"name": "Tocumwal Public School",
					"playspace": 94.56,
					"projections": [
						119,
						154,
						110,
						100,
						90,
						80
					],
					"projections_orig": [
						"119",
						"154",
						"110",
						"100",
						"90",
						"80"
					],
					"projections_percentage": [
						-22.73,
						0,
						-28.57,
						-35.06,
						-41.56,
						-48.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3225
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 8.31,
					"enrolment": 121,
					"ligo": 1,
					"location": [
						143.337598015368,
						-35.0276884099083
					],
					"name": "Tooleybuc Central School",
					"playspace": 452.66,
					"projections": [
						115,
						121,
						100,
						90,
						90,
						90
					],
					"projections_orig": [
						"115",
						"121",
						"100",
						"90",
						"90",
						"90"
					],
					"projections_percentage": [
						-4.96,
						0,
						-17.36,
						-25.62,
						-25.62,
						-25.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3235
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 42.11,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						146.26664908217,
						-35.3278051543142
					],
					"name": "Urana Public School",
					"playspace": 650.55,
					"projections": [
						44,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						238.46,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3314
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 16.14,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						144.393209670501,
						-35.4669742205909
					],
					"name": "Wakool Burraboi Public School",
					"playspace": 1992.06,
					"projections": [
						30,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						150,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3336
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 5.55,
					"enrolment": 201,
					"ligo": 1,
					"location": [
						145.575397232516,
						-35.6397280960363
					],
					"name": "Finley Public School",
					"playspace": 75.25,
					"projections": [
						210,
						201,
						185,
						165,
						150,
						140
					],
					"projections_orig": [
						"210",
						"201",
						"185",
						"165",
						"150",
						"140"
					],
					"projections_percentage": [
						4.48,
						0,
						-7.96,
						-17.91,
						-25.37,
						-30.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3945
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.58,
					"enrolment": 282,
					"ligo": 0.75,
					"location": [
						144.957105004307,
						-35.5377751759467
					],
					"name": "Deniliquin South Public School",
					"playspace": 115.93,
					"projections": [
						293,
						282,
						240,
						250,
						255,
						250
					],
					"projections_orig": [
						"293",
						"282",
						"240",
						"250",
						"255",
						"250"
					],
					"projections_percentage": [
						3.9,
						0,
						-14.89,
						-11.35,
						-9.57,
						-11.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4112
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.52,
					"enrolment": 146,
					"ligo": 0.82,
					"location": [
						144.981216055196,
						-35.5251318275518
					],
					"name": "Deniliquin North Public School",
					"playspace": 130.34,
					"projections": [
						151,
						146,
						115,
						120,
						120,
						120
					],
					"projections_orig": [
						"151",
						"146",
						"115",
						"120",
						"120",
						"120"
					],
					"projections_percentage": [
						3.42,
						0,
						-21.23,
						-17.81,
						-17.81,
						-17.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4281
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 6.16,
					"enrolment": 229,
					"ligo": 1,
					"location": [
						145.882655983031,
						-34.8055852806193
					],
					"name": "Coleambally Central School",
					"playspace": 237.96,
					"projections": [
						233,
						229,
						230,
						210,
						200,
						185
					],
					"projections_orig": [
						"233",
						"229",
						"230",
						"210",
						"200",
						"185"
					],
					"projections_percentage": [
						1.75,
						0,
						0.44,
						-8.3,
						-12.66,
						-19.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4348
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.66,
					"enrolment": 164,
					"ligo": 0.81,
					"location": [
						144.951844650974,
						-35.5249025158169
					],
					"name": "Edward Public School",
					"playspace": 176.17,
					"projections": [
						192,
						164,
						135,
						145,
						145,
						145
					],
					"projections_orig": [
						"192",
						"164",
						"135",
						"145",
						"145",
						"145"
					],
					"projections_percentage": [
						17.07,
						0,
						-17.68,
						-11.59,
						-11.59,
						-11.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4418
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 7.03,
					"enrolment": 187,
					"ligo": 1,
					"location": [
						144.841604456615,
						-34.5049603706985
					],
					"name": "Hay War Memorial High School",
					"playspace": 235.96,
					"projections": [
						189,
						187,
						150,
						135,
						130,
						130
					],
					"projections_orig": [
						"189",
						"187",
						"150",
						"135",
						"130",
						"130"
					],
					"projections_percentage": [
						1.07,
						0,
						-19.79,
						-27.81,
						-30.48,
						-30.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8119
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 38
					},
					"classroomspace": 4.75,
					"enrolment": 536,
					"ligo": 1,
					"location": [
						144.960233596785,
						-35.536602401731
					],
					"name": "Deniliquin High School",
					"playspace": 56.56,
					"projections": [
						574,
						536,
						540,
						575,
						570,
						560
					],
					"projections_orig": [
						"574",
						"536",
						"540",
						"575",
						"570",
						"560"
					],
					"projections_percentage": [
						7.09,
						0,
						0.75,
						7.28,
						6.34,
						4.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8218
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 5.71,
					"enrolment": 383,
					"ligo": 1,
					"location": [
						145.573338977903,
						-35.6403164312449
					],
					"name": "Finley High School",
					"playspace": 121.36,
					"projections": [
						428,
						383,
						360,
						325,
						290,
						250
					],
					"projections_orig": [
						"428",
						"383",
						"360",
						"325",
						"290",
						"250"
					],
					"projections_percentage": [
						11.75,
						0,
						-6.01,
						-15.14,
						-24.28,
						-34.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8360
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 9.14,
					"enrolment": 153,
					"ligo": 1,
					"location": [
						144.130962442988,
						-35.6244529392821
					],
					"name": "Barham High School",
					"playspace": 148.09,
					"projections": [
						176,
						153,
						125,
						115,
						105,
						95
					],
					"projections_orig": [
						"176",
						"153",
						"125",
						"115",
						"105",
						"95"
					],
					"projections_percentage": [
						15.03,
						0,
						-18.3,
						-24.84,
						-31.37,
						-37.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8461
				}
			],
			"uid": 30046
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 172
			},
			"enrolment": 2186,
			"level": "Combined",
			"ligo": 1,
			"name": "Griffith Network",
			"playspace": 760.07,
			"projections": [
				2186,
				2242,
				2158,
				2028,
				1878
			],
			"projections_percentage": [
				0,
				2.56,
				-1.28,
				-7.23,
				-14.09
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 13.61,
					"enrolment": 66,
					"ligo": 1,
					"location": [
						146.901709819357,
						-34.3543884858945
					],
					"name": "Ardlethan Central School",
					"playspace": 103.16,
					"projections": [
						109,
						66,
						80,
						75,
						70,
						65
					],
					"projections_orig": [
						"109",
						"66",
						"80",
						"75",
						"70",
						"65"
					],
					"projections_percentage": [
						65.15,
						0,
						21.21,
						13.64,
						6.06,
						-1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1051
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 6
					},
					"classroomspace": 6.74,
					"enrolment": 123,
					"ligo": 1,
					"location": [
						146.572314348131,
						-34.2878318974544
					],
					"name": "Barellan Central School",
					"playspace": 157.1,
					"projections": [
						122,
						123,
						100,
						90,
						85,
						75
					],
					"projections_orig": [
						"122",
						"123",
						"100",
						"90",
						"85",
						"75"
					],
					"projections_percentage": [
						-0.81,
						0,
						-18.7,
						-26.83,
						-30.89,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1131
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.75,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						146.963253344752,
						-34.3267529446107
					],
					"name": "Beckom Public School",
					"playspace": 1128.83,
					"projections": [
						13,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						8.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1160
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.84,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						146.352594256909,
						-34.2285971999365
					],
					"name": "Binya Public School",
					"playspace": 997.67,
					"projections": [
						17,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						54.55,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1238
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.24,
					"enrolment": 96,
					"ligo": 1,
					"location": [
						145.993368453082,
						-34.5720294090203
					],
					"name": "Darlington Point Public School",
					"playspace": 281.66,
					"projections": [
						108,
						96,
						105,
						95,
						90,
						85
					],
					"projections_orig": [
						"108",
						"96",
						"105",
						"95",
						"90",
						"85"
					],
					"projections_percentage": [
						12.5,
						0,
						9.38,
						-1.04,
						-6.25,
						-11.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1736
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 4.57,
					"enrolment": 48,
					"ligo": 1,
					"location": [
						145.708812554572,
						-33.9764825119664
					],
					"name": "Goolgowi Public School",
					"playspace": 412.9,
					"projections": [
						70,
						48,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"70",
						"48",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						45.83,
						0,
						-47.92,
						-47.92,
						-47.92,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2035
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 16
					},
					"classroomspace": 6.92,
					"enrolment": 162,
					"ligo": 1,
					"location": [
						145.539454316774,
						-33.4812182691609
					],
					"name": "Hillston Central School",
					"playspace": 215.24,
					"projections": [
						177,
						162,
						150,
						140,
						130,
						120
					],
					"projections_orig": [
						"177",
						"162",
						"150",
						"140",
						"130",
						"120"
					],
					"projections_percentage": [
						9.26,
						0,
						-7.41,
						-13.58,
						-19.75,
						-25.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2165
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.44,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						146.327500390363,
						-33.6148502222993
					],
					"name": "Naradhan Public School",
					"playspace": 277.54,
					"projections": [
						13,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						8.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2701
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.56,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						146.258677619712,
						-33.8400119033937
					],
					"name": "Rankins Springs Public School",
					"playspace": 930.77,
					"projections": [
						18,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-18.18,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2935
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.15,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						146.877901082243,
						-33.9927036002746
					],
					"name": "Tallimba Public School",
					"playspace": 239.79,
					"projections": [
						26,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3153
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 11
					},
					"classroomspace": 8.19,
					"enrolment": 94,
					"ligo": 1,
					"location": [
						146.977375346761,
						-33.6384663973174
					],
					"name": "Ungarie Central School",
					"playspace": 411.45,
					"projections": [
						97,
						94,
						95,
						85,
						80,
						75
					],
					"projections_orig": [
						"97",
						"94",
						"95",
						"85",
						"80",
						"75"
					],
					"projections_percentage": [
						3.19,
						0,
						1.06,
						-9.57,
						-14.89,
						-20.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3311
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.05,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						146.330427577213,
						-34.525403816546
					],
					"name": "Wamoon Public School",
					"playspace": 207.39,
					"projections": [
						32,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						6.67,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3364
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.72,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						146.619176022767,
						-33.8791970515995
					],
					"name": "Weethalle Public School",
					"playspace": 680.43,
					"projections": [
						29,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						38.1,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3415
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.8,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						146.180434507185,
						-34.5191492333556
					],
					"name": "Whitton-Murrami Public School",
					"playspace": 277.8,
					"projections": [
						0,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"0",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-100,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3438
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.8,
					"enrolment": 56,
					"ligo": 1,
					"location": [
						147.242139910185,
						-33.9234433195497
					],
					"name": "Wyalong Public School",
					"playspace": 324.71,
					"projections": [
						55,
						56,
						50,
						25,
						25,
						25
					],
					"projections_orig": [
						"55",
						"56",
						"50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-1.79,
						0,
						-10.71,
						-55.36,
						-55.36,
						-55.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3518
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.77,
					"enrolment": 293,
					"ligo": 1,
					"location": [
						147.2039706132,
						-33.9188121478431
					],
					"name": "West Wyalong Public School",
					"playspace": 91.54,
					"projections": [
						317,
						293,
						285,
						250,
						235,
						220
					],
					"projections_orig": [
						"317",
						"293",
						"285",
						"250",
						"235",
						"220"
					],
					"projections_percentage": [
						8.19,
						0,
						-2.73,
						-14.68,
						-19.8,
						-24.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3519
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 25
					},
					"classroomspace": 5.37,
					"enrolment": 313,
					"ligo": 1,
					"location": [
						146.381320050514,
						-34.6338279187293
					],
					"name": "Yanco Agricultural High School",
					"playspace": 7355.17,
					"projections": [
						368,
						313,
						365,
						365,
						345,
						305
					],
					"projections_orig": [
						"368",
						"313",
						"365",
						"365",
						"345",
						"305"
					],
					"projections_percentage": [
						17.57,
						0,
						16.61,
						16.61,
						10.22,
						-2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8144
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 4.68,
					"enrolment": 446,
					"ligo": 1,
					"location": [
						146.404309071392,
						-34.546901894756
					],
					"name": "Leeton High School",
					"playspace": 186.95,
					"projections": [
						457,
						446,
						500,
						515,
						490,
						440
					],
					"projections_orig": [
						"457",
						"446",
						"500",
						"515",
						"490",
						"440"
					],
					"projections_percentage": [
						2.47,
						0,
						12.11,
						15.47,
						9.87,
						-1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8156
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 4.94,
					"enrolment": 320,
					"ligo": 1,
					"location": [
						147.202772668496,
						-33.9155667303204
					],
					"name": "West Wyalong High School",
					"playspace": 161.14,
					"projections": [
						340,
						320,
						295,
						270,
						230,
						220
					],
					"projections_orig": [
						"340",
						"320",
						"295",
						"270",
						"230",
						"220"
					],
					"projections_percentage": [
						6.25,
						0,
						-7.81,
						-15.62,
						-28.12,
						-31.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8392
				}
			],
			"uid": 30047
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 66
			},
			"enrolment": 647,
			"level": "Combined",
			"ligo": 1,
			"name": "Rural Albury Network East",
			"playspace": 688.09,
			"projections": [
				647,
				669,
				669,
				659,
				634
			],
			"projections_percentage": [
				0,
				3.4,
				3.4,
				1.85,
				-2.01
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 11.23,
					"enrolment": 117,
					"ligo": 1,
					"location": [
						148.147453752521,
						-35.5220865787403
					],
					"name": "Batlow Technology School",
					"playspace": 163.07,
					"projections": [
						163,
						117,
						150,
						150,
						150,
						140
					],
					"projections_orig": [
						"163",
						"117",
						"150",
						"150",
						"150",
						"140"
					],
					"projections_percentage": [
						39.32,
						0,
						28.21,
						28.21,
						28.21,
						19.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1152
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 4.15,
					"enrolment": 142,
					"ligo": 1,
					"location": [
						147.319826939629,
						-35.7166340251219
					],
					"name": "Holbrook Public School",
					"playspace": 196.78,
					"projections": [
						171,
						142,
						145,
						145,
						150,
						145
					],
					"projections_orig": [
						"171",
						"142",
						"145",
						"145",
						"150",
						"145"
					],
					"projections_percentage": [
						20.42,
						0,
						2.11,
						2.11,
						5.63,
						2.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2170
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.12,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						147.762234668291,
						-35.4833663576347
					],
					"name": "Humula Public School",
					"playspace": 1731.24,
					"projections": [
						12,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-14.29,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2188
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.6,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						147.861982318776,
						-35.670327178576
					],
					"name": "Rosewood Public School",
					"playspace": 733.43,
					"projections": [
						24,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"24",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						33.33,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2996
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.77,
					"enrolment": 157,
					"ligo": 1,
					"location": [
						148.013550565093,
						-35.7755974269371
					],
					"name": "Tumbarumba Public School",
					"playspace": 83.94,
					"projections": [
						188,
						157,
						155,
						155,
						150,
						145
					],
					"projections_orig": [
						"188",
						"157",
						"155",
						"155",
						"150",
						"145"
					],
					"projections_percentage": [
						19.75,
						0,
						-1.27,
						-1.27,
						-4.46,
						-7.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3275
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 17.98,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						148.132203859824,
						-36.2143464986008
					],
					"name": "Khancoban Public School",
					"playspace": 1611.94,
					"projections": [
						26,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						52.94,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4270
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 7.01,
					"enrolment": 182,
					"ligo": 1,
					"location": [
						148.016701061706,
						-35.782539278187
					],
					"name": "Tumbarumba High School",
					"playspace": 296.23,
					"projections": [
						192,
						182,
						170,
						170,
						160,
						155
					],
					"projections_orig": [
						"192",
						"182",
						"170",
						"170",
						"160",
						"155"
					],
					"projections_percentage": [
						5.49,
						0,
						-6.59,
						-6.59,
						-12.09,
						-14.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8450
				}
			],
			"uid": 30048
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 136
			},
			"enrolment": 1685,
			"level": "Combined",
			"ligo": 1,
			"name": "Rural Wagga Network",
			"playspace": 559.38,
			"projections": [
				1685,
				1589,
				1587,
				1529,
				1469
			],
			"projections_percentage": [
				0,
				-5.7,
				-5.82,
				-9.26,
				-12.82
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.89,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						146.605854502317,
						-35.1067270996722
					],
					"name": "Boree Creek Public School",
					"playspace": 580.85,
					"projections": [
						18,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-21.74,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1318
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 6.62,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						147.249647822818,
						-35.1892101706032
					],
					"name": "Uranquinty Public School",
					"playspace": 492.43,
					"projections": [
						55,
						37,
						25,
						50,
						25,
						25
					],
					"projections_orig": [
						"55",
						"37",
						"<50",
						"50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						48.65,
						0,
						-32.43,
						35.14,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1499
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.59,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						147.127129720513,
						-35.0883922898426
					],
					"name": "Collingullie Public School",
					"playspace": 3467.97,
					"projections": [
						28,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						133.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1591
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.51,
					"enrolment": 120,
					"ligo": 1,
					"location": [
						147.039975098262,
						-35.6674980052161
					],
					"name": "Culcairn Public School",
					"playspace": 67.22,
					"projections": [
						116,
						120,
						105,
						105,
						110,
						105
					],
					"projections_orig": [
						"116",
						"120",
						"105",
						"105",
						"110",
						"105"
					],
					"projections_percentage": [
						-3.33,
						0,
						-12.5,
						-12.5,
						-8.33,
						-12.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1698
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.29,
					"enrolment": 134,
					"ligo": 1,
					"location": [
						147.031040172447,
						-35.5168296623665
					],
					"name": "Henty Public School",
					"playspace": 91.57,
					"projections": [
						113,
						134,
						115,
						120,
						120,
						120
					],
					"projections_orig": [
						"113",
						"134",
						"115",
						"120",
						"120",
						"120"
					],
					"projections_percentage": [
						-15.67,
						0,
						-14.18,
						-10.45,
						-10.45,
						-10.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2154
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.27,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						147.511463711291,
						-35.209200745912
					],
					"name": "Ladysmith Public School",
					"playspace": 478.76,
					"projections": [
						39,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						18.18,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2353
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 12.17,
					"enrolment": 86,
					"ligo": 1,
					"location": [
						146.713835973614,
						-35.222515088996
					],
					"name": "Lockhart Central School",
					"playspace": 177.03,
					"projections": [
						94,
						86,
						105,
						110,
						105,
						100
					],
					"projections_orig": [
						"94",
						"86",
						"105",
						"110",
						"105",
						"100"
					],
					"projections_percentage": [
						9.3,
						0,
						22.09,
						27.91,
						22.09,
						16.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2418
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.28,
					"enrolment": 265,
					"ligo": 1,
					"location": [
						146.548250002114,
						-34.7444168295606
					],
					"name": "Narrandera Public School",
					"playspace": 54.03,
					"projections": [
						235,
						265,
						235,
						220,
						205,
						195
					],
					"projections_orig": [
						"235",
						"265",
						"235",
						"220",
						"205",
						"195"
					],
					"projections_percentage": [
						-11.32,
						0,
						-11.32,
						-16.98,
						-22.64,
						-26.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2710
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.95,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						146.798688721424,
						-35.4659970227155
					],
					"name": "Pleasant Hills Public School",
					"playspace": 202.45,
					"projections": [
						14,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-36.36,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2886
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.14,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						146.579880052451,
						-35.5953018237575
					],
					"name": "Rand Public School",
					"playspace": 898.46,
					"projections": [
						17,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.73,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2933
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 5.66,
					"enrolment": 160,
					"ligo": 1,
					"location": [
						147.115167006008,
						-35.2670646989453
					],
					"name": "The Rock Central School",
					"playspace": 39.13,
					"projections": [
						156,
						160,
						160,
						160,
						160,
						150
					],
					"projections_orig": [
						"156",
						"160",
						"160",
						"160",
						"160",
						"150"
					],
					"projections_percentage": [
						-2.5,
						0,
						0,
						0,
						0,
						-6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2976
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.87,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						147.739278384621,
						-35.2783161943192
					],
					"name": "Tarcutta Public School",
					"playspace": 1283.44,
					"projections": [
						15,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.14,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3165
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.44,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						147.06071867591,
						-35.3872057437668
					],
					"name": "Yerong Creek Public School",
					"playspace": 386.3,
					"projections": [
						28,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.69,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3556
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.87,
					"enrolment": 63,
					"ligo": 1,
					"location": [
						146.564219072154,
						-34.749980695398
					],
					"name": "Narrandera East Infants School",
					"playspace": 248.93,
					"projections": [
						53,
						63,
						60,
						55,
						55,
						50
					],
					"projections_orig": [
						"53",
						"63",
						"60",
						"55",
						"55",
						"50"
					],
					"projections_percentage": [
						-15.87,
						0,
						-4.76,
						-12.7,
						-12.7,
						-20.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4214
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 6.75,
					"enrolment": 263,
					"ligo": 1,
					"location": [
						146.565522671196,
						-34.742892233934
					],
					"name": "Narrandera High School",
					"playspace": 295.47,
					"projections": [
						311,
						263,
						280,
						250,
						220,
						210
					],
					"projections_orig": [
						"311",
						"263",
						"280",
						"250",
						"220",
						"210"
					],
					"projections_percentage": [
						18.25,
						0,
						6.46,
						-4.94,
						-16.35,
						-20.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8157
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 23
					},
					"classroomspace": 4.4,
					"enrolment": 405,
					"ligo": 1,
					"location": [
						147.043718622472,
						-35.6622996852362
					],
					"name": "Billabong High School",
					"playspace": 186.04,
					"projections": [
						350,
						405,
						340,
						365,
						365,
						350
					],
					"projections_orig": [
						"350",
						"405",
						"340",
						"365",
						"365",
						"350"
					],
					"projections_percentage": [
						-13.58,
						0,
						-16.05,
						-9.88,
						-9.88,
						-13.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8503
				}
			],
			"uid": 30049
		},
		{
			"classrooms": {
				"demountable": 22,
				"permanent": 177
			},
			"enrolment": 3432,
			"level": "Combined",
			"ligo": 0.75,
			"name": "Griffith Urban",
			"playspace": 184.07,
			"projections": [
				3432,
				3320,
				3152,
				2987,
				2837
			],
			"projections_percentage": [
				0,
				-3.26,
				-8.16,
				-12.97,
				-17.34
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 5
					},
					"classroomspace": 2.56,
					"enrolment": 181,
					"ligo": 0.71,
					"location": [
						146.101454846829,
						-34.2521613845286
					],
					"name": "Beelbangera Public School",
					"playspace": 134.1,
					"projections": [
						164,
						181,
						155,
						150,
						145,
						140
					],
					"projections_orig": [
						"164",
						"181",
						"155",
						"150",
						"145",
						"140"
					],
					"projections_percentage": [
						-9.39,
						0,
						-14.36,
						-17.13,
						-19.89,
						-22.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1167
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.38,
					"enrolment": 363,
					"ligo": 0.83,
					"location": [
						146.036418460723,
						-34.2910690909114
					],
					"name": "Griffith Public School",
					"playspace": 105.74,
					"projections": [
						359,
						363,
						370,
						360,
						335,
						325
					],
					"projections_orig": [
						"359",
						"363",
						"370",
						"360",
						"335",
						"325"
					],
					"projections_percentage": [
						-1.1,
						0,
						1.93,
						-0.83,
						-7.71,
						-10.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2087
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 7
					},
					"classroomspace": 3.06,
					"enrolment": 263,
					"ligo": 0.64,
					"location": [
						146.041713082586,
						-34.3300902465495
					],
					"name": "Hanwood Public School",
					"playspace": 43.74,
					"projections": [
						248,
						263,
						255,
						230,
						215,
						205
					],
					"projections_orig": [
						"248",
						"263",
						"255",
						"230",
						"215",
						"205"
					],
					"projections_percentage": [
						-5.7,
						0,
						-3.04,
						-12.55,
						-18.25,
						-22.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2132
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 2.64,
					"enrolment": 125,
					"ligo": 0.6,
					"location": [
						146.032502998774,
						-34.2480176558549
					],
					"name": "Lake Wyangan Public School",
					"playspace": 137.35,
					"projections": [
						105,
						125,
						115,
						105,
						100,
						95
					],
					"projections_orig": [
						"105",
						"125",
						"115",
						"105",
						"100",
						"95"
					],
					"projections_percentage": [
						-16,
						0,
						-8,
						-16,
						-20,
						-24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2363
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.63,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						145.984121729161,
						-34.260734569058
					],
					"name": "Tharbogang Public School",
					"playspace": 662.08,
					"projections": [
						39,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						11.43,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3195
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 4
					},
					"classroomspace": 3.17,
					"enrolment": 124,
					"ligo": 1,
					"location": [
						146.197779145196,
						-34.2528616174848
					],
					"name": "Yenda Public School",
					"playspace": 143.56,
					"projections": [
						182,
						124,
						130,
						120,
						115,
						105
					],
					"projections_orig": [
						"182",
						"124",
						"130",
						"120",
						"115",
						"105"
					],
					"projections_percentage": [
						46.77,
						0,
						4.84,
						-3.23,
						-7.26,
						-15.32
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3554
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.99,
					"enrolment": 27,
					"ligo": 0.71,
					"location": [
						146.086035922516,
						-34.3002214271824
					],
					"name": "Yoogali Public School",
					"playspace": 584.57,
					"projections": [
						65,
						27,
						50,
						25,
						25,
						25
					],
					"projections_orig": [
						"65",
						"27",
						"50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						140.74,
						0,
						85.19,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3561
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.64,
					"enrolment": 364,
					"ligo": 0.65,
					"location": [
						146.047658307385,
						-34.2800852367475
					],
					"name": "Griffith North Public School",
					"playspace": 30.36,
					"projections": [
						398,
						364,
						335,
						325,
						315,
						305
					],
					"projections_orig": [
						"398",
						"364",
						"335",
						"325",
						"315",
						"305"
					],
					"projections_percentage": [
						9.34,
						0,
						-7.97,
						-10.71,
						-13.46,
						-16.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4027
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 18
					},
					"classroomspace": 2.81,
					"enrolment": 571,
					"ligo": 0.56,
					"location": [
						146.061927451081,
						-34.2870715781754
					],
					"name": "Griffith East Public School",
					"playspace": 23.28,
					"projections": [
						502,
						571,
						525,
						500,
						455,
						435
					],
					"projections_orig": [
						"502",
						"571",
						"525",
						"500",
						"455",
						"435"
					],
					"projections_percentage": [
						-12.08,
						0,
						-8.06,
						-12.43,
						-20.32,
						-23.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4268
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 51
					},
					"classroomspace": 5.91,
					"enrolment": 572,
					"ligo": 0.91,
					"location": [
						146.03950513474,
						-34.2912590732409
					],
					"name": "Griffith High School",
					"playspace": 90.43,
					"projections": [
						492,
						572,
						530,
						510,
						490,
						455
					],
					"projections_orig": [
						"492",
						"572",
						"530",
						"510",
						"490",
						"455"
					],
					"projections_percentage": [
						-13.99,
						0,
						-7.34,
						-10.84,
						-14.34,
						-20.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8118
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 41
					},
					"classroomspace": 3.71,
					"enrolment": 807,
					"ligo": 0.66,
					"location": [
						146.07136397175,
						-34.2810400535969
					],
					"name": "Wade High School",
					"playspace": 69.52,
					"projections": [
						828,
						807,
						820,
						790,
						755,
						710
					],
					"projections_orig": [
						"828",
						"807",
						"820",
						"790",
						"755",
						"710"
					],
					"projections_percentage": [
						2.6,
						0,
						1.61,
						-2.11,
						-6.44,
						-12.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8470
				}
			],
			"uid": 30050
		},
		{
			"classrooms": {
				"demountable": 4,
				"permanent": 96
			},
			"enrolment": 1266,
			"level": "Combined",
			"ligo": 0.97,
			"name": "Rural Albury Network West",
			"playspace": 598.05,
			"projections": [
				1266,
				1386,
				1341,
				1281,
				1216
			],
			"projections_percentage": [
				0,
				9.48,
				5.92,
				1.18,
				-3.95
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.07,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						146.679009127263,
						-35.8236707218937
					],
					"name": "Brocklesby Public School",
					"playspace": 1902.44,
					"projections": [
						31,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						158.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1363
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.87,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						146.800458848776,
						-35.8374943717516
					],
					"name": "Burrumbuttock Public School",
					"playspace": 209.32,
					"projections": [
						27,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.62,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1453
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.51,
					"enrolment": 259,
					"ligo": 0.95,
					"location": [
						146.393776532683,
						-35.9919729806587
					],
					"name": "Corowa Public School",
					"playspace": 134.05,
					"projections": [
						257,
						259,
						250,
						240,
						225,
						215
					],
					"projections_orig": [
						"257",
						"259",
						"250",
						"240",
						"225",
						"215"
					],
					"projections_percentage": [
						-0.77,
						0,
						-3.47,
						-7.34,
						-13.13,
						-16.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1658
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.88,
					"enrolment": 53,
					"ligo": 0.56,
					"location": [
						146.376740761629,
						-36.021571023682
					],
					"name": "Corowa South Public School",
					"playspace": 247.38,
					"projections": [
						85,
						53,
						60,
						60,
						55,
						55
					],
					"projections_orig": [
						"85",
						"53",
						"60",
						"60",
						"55",
						"55"
					],
					"projections_percentage": [
						60.38,
						0,
						13.21,
						13.21,
						3.77,
						3.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1659
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.4,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						146.997840123755,
						-35.8327307950242
					],
					"name": "Gerogery Public School",
					"playspace": 59.46,
					"projections": [
						14,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						40,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1969
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 3.8,
					"enrolment": 206,
					"ligo": 1,
					"location": [
						146.635904535062,
						-35.9807159374404
					],
					"name": "Howlong Public School",
					"playspace": 108.98,
					"projections": [
						172,
						206,
						185,
						165,
						155,
						140
					],
					"projections_orig": [
						"172",
						"206",
						"185",
						"165",
						"155",
						"140"
					],
					"projections_percentage": [
						-16.5,
						0,
						-10.19,
						-19.9,
						-24.76,
						-32.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2186
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 3.45,
					"enrolment": 195,
					"ligo": 1,
					"location": [
						146.885926978431,
						-35.9583883183405
					],
					"name": "Jindera Public School",
					"playspace": 133.66,
					"projections": [
						183,
						195,
						180,
						185,
						185,
						185
					],
					"projections_orig": [
						"183",
						"195",
						"180",
						"185",
						"185",
						"185"
					],
					"projections_percentage": [
						-6.15,
						0,
						-7.69,
						-5.13,
						-5.13,
						-5.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2239
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.44,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						146.368351179426,
						-35.8555245940803
					],
					"name": "Lowesdale Public School",
					"playspace": 750.59,
					"projections": [
						11,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-47.62,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2429
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 15.05,
					"enrolment": 6,
					"ligo": 1,
					"location": [
						147.164395748658,
						-35.9004065276855
					],
					"name": "Mullengandra Public School",
					"playspace": 1129.34,
					"projections": [
						15,
						6,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"6",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						150,
						0,
						316.67,
						316.67,
						316.67,
						316.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2662
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.09,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						146.726836351548,
						-35.6879393542357
					],
					"name": "Walbundrie Public School",
					"playspace": 1130.72,
					"projections": [
						20,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3338
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.01,
					"enrolment": 45,
					"ligo": 1,
					"location": [
						146.901933531975,
						-35.7593234387174
					],
					"name": "Walla Walla Public School",
					"playspace": 497.3,
					"projections": [
						39,
						45,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"45",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-13.33,
						0,
						-44.44,
						-44.44,
						-44.44,
						-44.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3352
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.99,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						147.007262520262,
						-35.968095039886
					],
					"name": "Table Top Public School",
					"playspace": 295.26,
					"projections": [
						67,
						61,
						75,
						75,
						80,
						75
					],
					"projections_orig": [
						"67",
						"61",
						"75",
						"75",
						"80",
						"75"
					],
					"projections_percentage": [
						9.84,
						0,
						22.95,
						22.95,
						31.15,
						22.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3534
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 26.44,
					"enrolment": 4,
					"ligo": 1,
					"location": [
						148.380250390432,
						-35.9334599188892
					],
					"name": "Cabramurra Public School",
					"playspace": 53.69,
					"projections": [
						7,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						75,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3928
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.34,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						148.301002893553,
						-35.5802470335985
					],
					"name": "Talbingo Public School",
					"playspace": 2156.92,
					"projections": [
						11,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						10,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4374
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 36
					},
					"classroomspace": 7.19,
					"enrolment": 336,
					"ligo": 1,
					"location": [
						146.380925474662,
						-35.9934177673172
					],
					"name": "Corowa High School",
					"playspace": 161.58,
					"projections": [
						530,
						336,
						480,
						460,
						425,
						390
					],
					"projections_orig": [
						"530",
						"336",
						"480",
						"460",
						"425",
						"390"
					],
					"projections_percentage": [
						57.74,
						0,
						42.86,
						36.9,
						26.49,
						16.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8308
				}
			],
			"uid": 30051
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 179
			},
			"enrolment": 2829,
			"level": "Combined",
			"ligo": 0.59,
			"name": "Armidale",
			"playspace": 230.54,
			"projections": [
				2830,
				3478,
				3688,
				3738,
				3750
			],
			"projections_percentage": [
				0,
				22.9,
				30.32,
				32.08,
				32.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 29
					},
					"classroomspace": 4.5,
					"enrolment": 436,
					"ligo": 0.46,
					"location": [
						151.66469368021,
						-30.5201346381184
					],
					"name": "Armidale City Public School",
					"playspace": 53.9,
					"projections": [
						444,
						436,
						485,
						490,
						490,
						500
					],
					"projections_orig": [
						"444",
						"436",
						"485",
						"490",
						"490",
						"500"
					],
					"projections_percentage": [
						1.83,
						0,
						11.24,
						12.39,
						12.39,
						14.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1057
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 6.32,
					"enrolment": 127,
					"ligo": 0.68,
					"location": [
						151.650729386814,
						-30.5106722960712
					],
					"name": "Drummond Memorial Public School",
					"playspace": 204.76,
					"projections": [
						138,
						127,
						170,
						180,
						185,
						190
					],
					"projections_orig": [
						"138",
						"127",
						"170",
						"180",
						"185",
						"190"
					],
					"projections_percentage": [
						8.66,
						0,
						33.86,
						41.73,
						45.67,
						49.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1058
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 23
					},
					"classroomspace": 2.7,
					"enrolment": 528,
					"ligo": 0.49,
					"location": [
						151.674189198904,
						-30.5029017055723
					],
					"name": "Ben Venue Public School",
					"playspace": 27.4,
					"projections": [
						579,
						528,
						655,
						680,
						665,
						680
					],
					"projections_orig": [
						"579",
						"528",
						"655",
						"680",
						"665",
						"680"
					],
					"projections_percentage": [
						9.66,
						0,
						24.05,
						28.79,
						25.95,
						28.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1198
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.53,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						151.637821404152,
						-30.5715781335387
					],
					"name": "Kellys Plains Public School",
					"playspace": 1074.4,
					"projections": [
						41,
						38,
						25,
						25,
						25,
						50
					],
					"projections_orig": [
						"41",
						"38",
						"<50",
						"<50",
						"<50",
						"50"
					],
					"projections_percentage": [
						7.89,
						0,
						-34.21,
						-34.21,
						-34.21,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2273
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.83,
					"enrolment": 165,
					"ligo": 0.31,
					"location": [
						151.63740611691,
						-30.5247790496338
					],
					"name": "Martins Gully Public School",
					"playspace": 126.2,
					"projections": [
						166,
						165,
						185,
						195,
						200,
						205
					],
					"projections_orig": [
						"166",
						"165",
						"185",
						"195",
						"200",
						"205"
					],
					"projections_percentage": [
						0.61,
						0,
						12.12,
						18.18,
						21.21,
						24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2494
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 5.61,
					"enrolment": 109,
					"ligo": 0.6,
					"location": [
						151.676240802101,
						-30.523029872741
					],
					"name": "Newling Public School",
					"playspace": 246.07,
					"projections": [
						87,
						109,
						100,
						100,
						105,
						110
					],
					"projections_orig": [
						"87",
						"109",
						"100",
						"100",
						"105",
						"110"
					],
					"projections_percentage": [
						-20.18,
						0,
						-8.26,
						-8.26,
						-3.67,
						0.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4478
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 10
					},
					"classroomspace": 3.01,
					"enrolment": 229,
					"ligo": 0.41,
					"location": [
						151.655938376239,
						-30.4971243612964
					],
					"name": "Sandon Public School",
					"playspace": 94.5,
					"projections": [
						254,
						229,
						250,
						265,
						275,
						280
					],
					"projections_orig": [
						"254",
						"229",
						"250",
						"265",
						"275",
						"280"
					],
					"projections_percentage": [
						10.92,
						0,
						9.17,
						15.72,
						20.09,
						22.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5696
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 48
					},
					"classroomspace": 5.97,
					"enrolment": 571,
					"ligo": 0.73,
					"location": [
						151.653232461072,
						-30.5207110530726
					],
					"name": "Armidale High School",
					"playspace": 170.03,
					"projections": [
						707,
						572,
						875,
						955,
						975,
						950
					],
					"projections_orig": [
						"707",
						"572",
						"875",
						"955",
						"975",
						"950"
					],
					"projections_percentage": [
						23.6,
						0,
						52.97,
						66.96,
						70.45,
						66.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8102
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 38
					},
					"classroomspace": 4.54,
					"enrolment": 626,
					"ligo": 0.63,
					"location": [
						151.664471750333,
						-30.4935303339125
					],
					"name": "Duval High School",
					"playspace": 77.64,
					"projections": [
						628,
						626,
						720,
						785,
						805,
						785
					],
					"projections_orig": [
						"628",
						"626",
						"720",
						"785",
						"805",
						"785"
					],
					"projections_percentage": [
						0.32,
						0,
						15.02,
						25.4,
						28.59,
						25.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8492
				}
			],
			"uid": 30052
		},
		{
			"classrooms": {
				"demountable": 20,
				"permanent": 359
			},
			"enrolment": 4378,
			"level": "Combined",
			"ligo": 0.94,
			"name": "Barwon",
			"playspace": 507.7,
			"projections": [
				4378,
				4568,
				4363,
				4098,
				3888
			],
			"projections_percentage": [
				0,
				4.34,
				-0.34,
				-6.4,
				-11.19
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 4.68,
					"enrolment": 170,
					"ligo": 0.81,
					"location": [
						151.094958812105,
						-29.3209613294088
					],
					"name": "Ashford Central School",
					"playspace": 126.26,
					"projections": [
						175,
						170,
						195,
						195,
						180,
						170
					],
					"projections_orig": [
						"175",
						"170",
						"195",
						"195",
						"180",
						"170"
					],
					"projections_percentage": [
						2.94,
						0,
						14.71,
						14.71,
						5.88,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1066
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						149.795646497729,
						-29.9183546567076
					],
					"name": "Bellata Public School",
					"playspace": 681.68,
					"projections": [
						30,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						42.86,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1175
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 6.29,
					"enrolment": 184,
					"ligo": 0.85,
					"location": [
						150.56835448721,
						-29.866694069516
					],
					"name": "Bingara Central School",
					"playspace": 134.01,
					"projections": [
						211,
						184,
						195,
						195,
						195,
						195
					],
					"projections_orig": [
						"211",
						"184",
						"195",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						14.67,
						0,
						5.98,
						5.98,
						5.98,
						5.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1234
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 16
					},
					"classroomspace": 13.97,
					"enrolment": 68,
					"ligo": 0.98,
					"location": [
						150.361541592546,
						-28.6156983307735
					],
					"name": "Boggabilla Central School",
					"playspace": 2351.85,
					"projections": [
						176,
						68,
						90,
						80,
						80,
						70
					],
					"projections_orig": [
						"176",
						"68",
						"90",
						"80",
						"80",
						"70"
					],
					"projections_percentage": [
						158.82,
						0,
						32.35,
						17.65,
						17.65,
						2.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1275
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.21,
					"enrolment": 115,
					"ligo": 1,
					"location": [
						150.043563944914,
						-30.705945708419
					],
					"name": "Boggabri Public School",
					"playspace": 95.49,
					"projections": [
						103,
						115,
						120,
						120,
						115,
						115
					],
					"projections_orig": [
						"103",
						"115",
						"120",
						"120",
						"115",
						"115"
					],
					"projections_percentage": [
						-10.43,
						0,
						4.35,
						4.35,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1276
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 12.14,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						151.277638884771,
						-29.0462706803323
					],
					"name": "Bonshaw Public School",
					"playspace": 758.3,
					"projections": [
						17,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						41.67,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1296
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						149.577549044387,
						-28.7247616272878
					],
					"name": "Boomi Public School",
					"playspace": 413.64,
					"projections": [
						38,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1307
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 7.95,
					"enrolment": 99,
					"ligo": 0.63,
					"location": [
						151.076176369381,
						-30.1682575387672
					],
					"name": "Bundarra Central School",
					"playspace": 136.06,
					"projections": [
						139,
						99,
						140,
						135,
						130,
						130
					],
					"projections_orig": [
						"139",
						"99",
						"140",
						"135",
						"130",
						"130"
					],
					"projections_percentage": [
						40.4,
						0,
						41.41,
						36.36,
						31.31,
						31.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1415
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.01,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						150.83057877161,
						-29.6513696161863
					],
					"name": "Delungra Public School",
					"playspace": 501.68,
					"projections": [
						27,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1747
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.86,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						150.13154434218,
						-30.4931226889214
					],
					"name": "Fairfax Public School",
					"playspace": 375.04,
					"projections": [
						8,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-42.86,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1894
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.84,
					"enrolment": 19,
					"ligo": 1,
					"location": [
						149.634742538656,
						-29.076260633568
					],
					"name": "Garah Public School",
					"playspace": 966.83,
					"projections": [
						26,
						19,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"19",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						36.84,
						0,
						31.58,
						31.58,
						31.58,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1956
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.91,
					"enrolment": 62,
					"ligo": 1,
					"location": [
						151.11564679111,
						-29.8517752635533
					],
					"name": "Gilgai Public School",
					"playspace": 282.21,
					"projections": [
						60,
						62,
						55,
						55,
						65,
						60
					],
					"projections_orig": [
						"60",
						"62",
						"55",
						"55",
						"65",
						"60"
					],
					"projections_percentage": [
						-3.23,
						0,
						-11.29,
						-11.29,
						4.84,
						-3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1978
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.46,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						150.332842311156,
						-29.5850660328344
					],
					"name": "Gravesend Public School",
					"playspace": 467.17,
					"projections": [
						26,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-25.71,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2068
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.08,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						150.97922832102,
						-29.7793390711955
					],
					"name": "Gum Flat Public School",
					"playspace": 724.12,
					"projections": [
						30,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-14.29,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2100
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 17.97,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						148.974412540968,
						-30.6113219005351
					],
					"name": "Gwabegar Public School",
					"playspace": "NA",
					"projections": [
						8,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						14.29,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2115
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.81,
					"enrolment": 640,
					"ligo": 0.74,
					"location": [
						149.838821984483,
						-29.4655530152074
					],
					"name": "Moree Public School",
					"playspace": 46.07,
					"projections": [
						665,
						640,
						630,
						555,
						485,
						440
					],
					"projections_orig": [
						"665",
						"640",
						"630",
						"555",
						"485",
						"440"
					],
					"projections_percentage": [
						3.91,
						0,
						-1.56,
						-13.28,
						-24.22,
						-31.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2618
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 13
					},
					"classroomspace": 11.51,
					"enrolment": 71,
					"ligo": 0.93,
					"location": [
						148.991365669367,
						-28.9802180525237
					],
					"name": "Mungindi Central School",
					"playspace": 194.67,
					"projections": [
						118,
						71,
						80,
						75,
						70,
						60
					],
					"projections_orig": [
						"118",
						"71",
						"80",
						"75",
						"70",
						"60"
					],
					"projections_percentage": [
						66.2,
						0,
						12.68,
						5.63,
						-1.41,
						-15.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2675
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 2.88,
					"enrolment": 402,
					"ligo": 0.83,
					"location": [
						149.784552266553,
						-30.3247650856087
					],
					"name": "Narrabri Public School",
					"playspace": 27.15,
					"projections": [
						393,
						402,
						415,
						370,
						355,
						340
					],
					"projections_orig": [
						"393",
						"402",
						"415",
						"370",
						"355",
						"340"
					],
					"projections_percentage": [
						-2.24,
						0,
						3.23,
						-7.96,
						-11.69,
						-15.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2708
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 2.75,
					"enrolment": 347,
					"ligo": 0.53,
					"location": [
						149.762748294863,
						-30.3445578571505
					],
					"name": "Narrabri West Public School",
					"playspace": 76.89,
					"projections": [
						259,
						347,
						340,
						305,
						295,
						280
					],
					"projections_orig": [
						"259",
						"347",
						"340",
						"305",
						"295",
						"280"
					],
					"projections_percentage": [
						-25.36,
						0,
						-2.02,
						-12.1,
						-14.99,
						-19.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2709
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.27,
					"enrolment": 40,
					"ligo": 1,
					"location": [
						150.39238367236,
						-28.9265647988465
					],
					"name": "North Star Public School",
					"playspace": 258.44,
					"projections": [
						36,
						40,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"40",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10,
						0,
						-37.5,
						-37.5,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2765
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 11.52,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						150.140248337199,
						-29.4736214062777
					],
					"name": "Pallamallawa Public School",
					"playspace": 1078.69,
					"projections": [
						33,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						57.14,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2827
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.26,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						148.888809524535,
						-30.3519732313293
					],
					"name": "Pilliga Public School",
					"playspace": 230.59,
					"projections": [
						8,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-50,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2870
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 7.61,
					"enrolment": 62,
					"ligo": 1,
					"location": [
						151.213614104623,
						-29.9581593512434
					],
					"name": "Tingha Public School",
					"playspace": 364.02,
					"projections": [
						97,
						62,
						70,
						70,
						65,
						60
					],
					"projections_orig": [
						"97",
						"62",
						"70",
						"70",
						"65",
						"60"
					],
					"projections_percentage": [
						56.45,
						0,
						12.9,
						12.9,
						4.84,
						-3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3218
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 8.04,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						150.479630606928,
						-28.6704238579368
					],
					"name": "Toomelah Public School",
					"playspace": 232.18,
					"projections": [
						59,
						37,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"59",
						"37",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						59.46,
						0,
						-32.43,
						-32.43,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3239
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.86,
					"enrolment": 174,
					"ligo": 1,
					"location": [
						150.574443589046,
						-29.5410228729679
					],
					"name": "Warialda Public School",
					"playspace": 95.05,
					"projections": [
						167,
						174,
						165,
						170,
						170,
						170
					],
					"projections_orig": [
						"167",
						"174",
						"165",
						"170",
						"170",
						"170"
					],
					"projections_percentage": [
						-4.02,
						0,
						-5.17,
						-2.3,
						-2.3,
						-2.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3382
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 7.15,
					"enrolment": 132,
					"ligo": 1,
					"location": [
						149.443096208867,
						-30.2239315698184
					],
					"name": "Wee Waa Public School",
					"playspace": 82.37,
					"projections": [
						151,
						132,
						140,
						140,
						135,
						135
					],
					"projections_orig": [
						"151",
						"132",
						"140",
						"140",
						"135",
						"135"
					],
					"projections_percentage": [
						14.39,
						0,
						6.06,
						6.06,
						2.27,
						2.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3416
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.79,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						150.776549013241,
						-28.9019454859166
					],
					"name": "Yetman Public School",
					"playspace": 366.67,
					"projections": [
						29,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						26.09,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3559
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 17.32,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						150.3084652997,
						-29.1250691386656
					],
					"name": "Croppa Creek Public School",
					"playspace": 2171.72,
					"projections": [
						19,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						58.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3717
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 7.75,
					"enrolment": 118,
					"ligo": 0.76,
					"location": [
						149.840638832374,
						-29.4763032562964
					],
					"name": "Moree East Public School",
					"playspace": 554.24,
					"projections": [
						118,
						118,
						125,
						115,
						105,
						95
					],
					"projections_orig": [
						"118",
						"118",
						"125",
						"115",
						"105",
						"95"
					],
					"projections_percentage": [
						0,
						0,
						5.93,
						-2.54,
						-11.02,
						-19.49
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4118
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.61,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						150.10204243857,
						-28.8686273161017
					],
					"name": "Tulloona Public School",
					"playspace": 744.67,
					"projections": [
						4,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"4",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-63.64,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4225
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 6.65,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						149.229016233393,
						-29.470469350583
					],
					"name": "Bullarah Public School",
					"playspace": 1121.7,
					"projections": [
						8,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-11.11,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4228
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 9.18,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						149.439769723311,
						-29.6455608510889
					],
					"name": "Mallawa Public School",
					"playspace": 1618.09,
					"projections": [
						14,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						75,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4262
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 34
					},
					"classroomspace": 4.38,
					"enrolment": 526,
					"ligo": 0.94,
					"location": [
						149.781069586869,
						-30.3346617972592
					],
					"name": "Narrabri High School",
					"playspace": 70.6,
					"projections": [
						608,
						526,
						595,
						585,
						530,
						490
					],
					"projections_orig": [
						"608",
						"526",
						"595",
						"585",
						"530",
						"490"
					],
					"projections_percentage": [
						15.59,
						0,
						13.12,
						11.22,
						0.76,
						-6.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8170
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 16
					},
					"classroomspace": 6.56,
					"enrolment": 180,
					"ligo": 0.96,
					"location": [
						149.456368213716,
						-30.2191430399067
					],
					"name": "Wee Waa High School",
					"playspace": 364.13,
					"projections": [
						179,
						180,
						170,
						170,
						165,
						160
					],
					"projections_orig": [
						"179",
						"180",
						"170",
						"170",
						"165",
						"160"
					],
					"projections_percentage": [
						-0.56,
						0,
						-5.56,
						-5.56,
						-8.33,
						-11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8270
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 31
					},
					"classroomspace": 7.95,
					"enrolment": 240,
					"ligo": 0.96,
					"location": [
						149.842043428647,
						-29.4655672757332
					],
					"name": "Moree Secondary College Albert St Campus",
					"playspace": 124.58,
					"projections": [
						225,
						240,
						230,
						225,
						190,
						175
					],
					"projections_orig": [
						"225",
						"240",
						"230",
						"225",
						"190",
						"175"
					],
					"projections_percentage": [
						-6.25,
						0,
						-4.17,
						-6.25,
						-20.83,
						-27.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8325
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 9.38,
					"enrolment": 216,
					"ligo": 0.91,
					"location": [
						149.839689003719,
						-29.481234137249
					],
					"name": "Moree Secondary College Carol Ave Campus",
					"playspace": 213.6,
					"projections": [
						304,
						216,
						230,
						220,
						185,
						165
					],
					"projections_orig": [
						"304",
						"216",
						"230",
						"220",
						"185",
						"165"
					],
					"projections_percentage": [
						40.74,
						0,
						6.48,
						1.85,
						-14.35,
						-23.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8471
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 17
					},
					"classroomspace": 7.36,
					"enrolment": 184,
					"ligo": 0.77,
					"location": [
						150.574133599952,
						-29.5481324786475
					],
					"name": "Warialda High School",
					"playspace": 226.66,
					"projections": [
						196,
						184,
						195,
						195,
						195,
						190
					],
					"projections_orig": [
						"196",
						"184",
						"195",
						"195",
						"195",
						"190"
					],
					"projections_percentage": [
						6.52,
						0,
						5.98,
						5.98,
						5.98,
						3.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8519
				}
			],
			"uid": 30053
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 55
			},
			"enrolment": 986,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Glen Innes",
			"playspace": 369.61,
			"projections": [
				986,
				1003,
				978,
				938,
				888
			],
			"projections_percentage": [
				0,
				1.72,
				-0.81,
				-4.87,
				-9.94
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 3.1,
					"enrolment": 377,
					"ligo": 0.97,
					"location": [
						151.738852122545,
						-29.7348499112961
					],
					"name": "Glen Innes Public School",
					"playspace": 162.21,
					"projections": [
						435,
						377,
						395,
						370,
						355,
						340
					],
					"projections_orig": [
						"435",
						"377",
						"395",
						"370",
						"355",
						"340"
					],
					"projections_percentage": [
						15.38,
						0,
						4.77,
						-1.86,
						-5.84,
						-9.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2005
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.88,
					"enrolment": 51,
					"ligo": 1,
					"location": [
						151.896420500494,
						-29.7761449680703
					],
					"name": "Red Range Public School",
					"playspace": 361.89,
					"projections": [
						21,
						51,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"51",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-58.82,
						0,
						-50.98,
						-50.98,
						-50.98,
						-50.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2948
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 0
					},
					"classroomspace": 10.36,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						152.110759861208,
						-29.6917800062728
					],
					"name": "Wytaliba Public School",
					"playspace": 1000.85,
					"projections": [
						6,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"6",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-45.45,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4556
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.45,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						151.724231079582,
						-29.7388675771351
					],
					"name": "Glen Innes West Infants School",
					"playspace": 270.01,
					"projections": [
						42,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"42",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						2.44,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5116
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 4.53,
					"enrolment": 506,
					"ligo": 0.94,
					"location": [
						151.741759236674,
						-29.7437290512253
					],
					"name": "Glen Innes High School",
					"playspace": 53.11,
					"projections": [
						552,
						506,
						505,
						505,
						480,
						445
					],
					"projections_orig": [
						"552",
						"506",
						"505",
						"505",
						"480",
						"445"
					],
					"projections_percentage": [
						9.09,
						0,
						-0.2,
						-0.2,
						-5.14,
						-12.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8114
				}
			],
			"uid": 30054
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 97
			},
			"enrolment": 1277,
			"level": "Combined",
			"ligo": 0.9,
			"name": "Gunnedah",
			"playspace": 707.65,
			"projections": [
				1277,
				1421,
				1421,
				1331,
				1286
			],
			"projections_percentage": [
				0,
				11.28,
				11.28,
				4.23,
				0.7
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.17,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						150.446949775058,
						-30.9855336755368
					],
					"name": "Carroll Public School",
					"playspace": 273.05,
					"projections": [
						13,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-38.1,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1520
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 7.94,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						150.264383626456,
						-31.1169190059109
					],
					"name": "Curlewis Public School",
					"playspace": 442.26,
					"projections": [
						36,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-12.2,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1712
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 6.1,
					"enrolment": 156,
					"ligo": 0.6,
					"location": [
						150.256358866749,
						-30.977103932429
					],
					"name": "Gunnedah Public School",
					"playspace": 57.64,
					"projections": [
						134,
						156,
						135,
						135,
						135,
						130
					],
					"projections_orig": [
						"134",
						"156",
						"135",
						"135",
						"135",
						"130"
					],
					"projections_percentage": [
						-14.1,
						0,
						-13.46,
						-13.46,
						-13.46,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2109
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.15,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						149.906939175661,
						-31.098829422842
					],
					"name": "Mullaley Public School",
					"playspace": 363.79,
					"projections": [
						26,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-36.59,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2660
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 35.6,
					"enrolment": 3,
					"ligo": 1,
					"location": [
						149.828471820183,
						-31.3489245740626
					],
					"name": "Tambar Springs Public School",
					"playspace": 3430.61,
					"projections": [
						10,
						3,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"3",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						233.33,
						0,
						733.33,
						733.33,
						733.33,
						733.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3156
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 20
					},
					"classroomspace": 2.64,
					"enrolment": 628,
					"ligo": 0.73,
					"location": [
						150.251328389812,
						-30.9917330258561
					],
					"name": "Gunnedah South Public School",
					"playspace": 35.64,
					"projections": [
						511,
						628,
						690,
						665,
						615,
						605
					],
					"projections_orig": [
						"511",
						"628",
						"690",
						"665",
						"615",
						"605"
					],
					"projections_percentage": [
						-18.63,
						0,
						9.87,
						5.89,
						-2.07,
						-3.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4018
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 50
					},
					"classroomspace": 7.95,
					"enrolment": 387,
					"ligo": 0.96,
					"location": [
						150.249872114695,
						-30.9829375764588
					],
					"name": "Gunnedah High School",
					"playspace": 350.59,
					"projections": [
						566,
						387,
						490,
						515,
						475,
						445
					],
					"projections_orig": [
						"566",
						"387",
						"490",
						"515",
						"475",
						"445"
					],
					"projections_percentage": [
						46.25,
						0,
						26.61,
						33.07,
						22.74,
						14.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8188
				}
			],
			"uid": 30055
		},
		{
			"classrooms": {
				"demountable": 13,
				"permanent": 125
			},
			"enrolment": 2212,
			"level": "Combined",
			"ligo": 0.65,
			"name": "Inverell",
			"playspace": 60.1,
			"projections": [
				2212,
				2215,
				2180,
				2065,
				1975
			],
			"projections_percentage": [
				0,
				0.14,
				-1.45,
				-6.65,
				-10.71
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 22
					},
					"classroomspace": 2.7,
					"enrolment": 488,
					"ligo": 0.57,
					"location": [
						151.122170875016,
						-29.7736762681945
					],
					"name": "Inverell Public School",
					"playspace": 27.45,
					"projections": [
						404,
						488,
						450,
						430,
						410,
						400
					],
					"projections_orig": [
						"404",
						"488",
						"450",
						"430",
						"410",
						"400"
					],
					"projections_percentage": [
						-17.21,
						0,
						-7.79,
						-11.89,
						-15.98,
						-18.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2209
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 35
					},
					"classroomspace": 2.95,
					"enrolment": 649,
					"ligo": 0.84,
					"location": [
						151.102233303771,
						-29.7702752002161
					],
					"name": "Ross Hill Public School",
					"playspace": 32.09,
					"projections": [
						696,
						649,
						695,
						685,
						645,
						640
					],
					"projections_orig": [
						"696",
						"649",
						"695",
						"685",
						"645",
						"640"
					],
					"projections_percentage": [
						7.24,
						0,
						7.09,
						5.55,
						-0.62,
						-1.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2997
				},
				{
					"classrooms": {
						"demountable": 11,
						"permanent": 29
					},
					"classroomspace": 4.68,
					"enrolment": 582,
					"ligo": 0.76,
					"location": [
						151.109901187757,
						-29.7660095726559
					],
					"name": "Inverell High School",
					"playspace": 24.75,
					"projections": [
						634,
						582,
						600,
						600,
						575,
						530
					],
					"projections_orig": [
						"634",
						"582",
						"600",
						"600",
						"575",
						"530"
					],
					"projections_percentage": [
						8.93,
						0,
						3.09,
						3.09,
						-1.2,
						-8.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8122
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 39
					},
					"classroomspace": 5.39,
					"enrolment": 493,
					"ligo": 0.44,
					"location": [
						151.131242915909,
						-29.7674996547944
					],
					"name": "Macintyre High School",
					"playspace": 156.1,
					"projections": [
						469,
						493,
						470,
						465,
						435,
						405
					],
					"projections_orig": [
						"469",
						"493",
						"470",
						"465",
						"435",
						"405"
					],
					"projections_percentage": [
						-4.87,
						0,
						-4.67,
						-5.68,
						-11.76,
						-17.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8490
				}
			],
			"uid": 30056
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 35
			},
			"enrolment": 412,
			"level": "Combined",
			"ligo": 1,
			"name": "Northern Tablelands",
			"playspace": 450.36,
			"projections": [
				412,
				434,
				449,
				459,
				464
			],
			"projections_percentage": [
				0,
				5.34,
				8.98,
				11.41,
				12.62
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.26,
					"enrolment": 40,
					"ligo": 1,
					"location": [
						151.784060717176,
						-30.2301712752181
					],
					"name": "Bald Blair Public School",
					"playspace": 291.61,
					"projections": [
						27,
						40,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"40",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-32.5,
						0,
						-37.5,
						-37.5,
						-37.5,
						-37.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1098
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 17.81,
					"enrolment": 6,
					"ligo": 1,
					"location": [
						151.661579899497,
						-30.0169807756324
					],
					"name": "Ben Lomond Public School",
					"playspace": 684.91,
					"projections": [
						12,
						6,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"6",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						100,
						0,
						316.67,
						316.67,
						316.67,
						316.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1196
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.98,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						151.657993517424,
						-30.3089537670592
					],
					"name": "Black Mountain Public School",
					"playspace": 232.18,
					"projections": [
						31,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						19.23,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1249
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7,
					"enrolment": 19,
					"ligo": 1,
					"location": [
						152.053182018164,
						-30.5182851400672
					],
					"name": "Chandler Public School",
					"playspace": "NA",
					"projections": [
						7,
						19,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"19",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-63.16,
						0,
						31.58,
						31.58,
						31.58,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1547
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 15.3,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						152.349318871881,
						-30.4030532957888
					],
					"name": "Ebor Public School",
					"playspace": 888.97,
					"projections": [
						4,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"4",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-50,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1814
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 5.13,
					"enrolment": 313,
					"ligo": 0.97,
					"location": [
						151.675962851726,
						-30.2224657824918
					],
					"name": "Guyra Central School",
					"playspace": 154.12,
					"projections": [
						325,
						313,
						335,
						350,
						360,
						365
					],
					"projections_orig": [
						"325",
						"313",
						"335",
						"350",
						"360",
						"365"
					],
					"projections_percentage": [
						3.83,
						0,
						7.03,
						11.82,
						15.02,
						16.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2114
				}
			],
			"uid": 30057
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 89
			},
			"enrolment": 968,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Peel",
			"playspace": 389.19,
			"projections": [
				968,
				1056,
				1066,
				1031,
				1016
			],
			"projections_percentage": [
				0,
				9.09,
				10.12,
				6.51,
				4.96
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 7.43,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						150.846536450395,
						-30.9300536837366
					],
					"name": "Attunga Public School",
					"playspace": 250.38,
					"projections": [
						28,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.15,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1071
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 10.35,
					"enrolment": 185,
					"ligo": 0.91,
					"location": [
						150.600928587019,
						-30.3823600801974
					],
					"name": "Barraba Central School",
					"playspace": 457.19,
					"projections": [
						181,
						185,
						210,
						210,
						205,
						200
					],
					"projections_orig": [
						"181",
						"185",
						"210",
						"210",
						"205",
						"200"
					],
					"projections_percentage": [
						-2.16,
						0,
						13.51,
						13.51,
						10.81,
						8.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1140
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.12,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						151.150884343953,
						-30.8861404951828
					],
					"name": "Bendemeer Public School",
					"playspace": 1198.85,
					"projections": [
						23,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						43.75,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1191
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.6,
					"enrolment": 29,
					"ligo": 1,
					"location": [
						150.735555178402,
						-31.2632193806598
					],
					"name": "Currabubula Public School",
					"playspace": 355.72,
					"projections": [
						37,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						27.59,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1714
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.24,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						151.132326080477,
						-31.2205513635458
					],
					"name": "Dungowan Public School",
					"playspace": 373.72,
					"projections": [
						38,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						171.43,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1793
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.27,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						150.830550861038,
						-31.2206785039636
					],
					"name": "Duri Public School",
					"playspace": 505.31,
					"projections": [
						28,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.22,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1802
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.73,
					"enrolment": 188,
					"ligo": 1,
					"location": [
						151.054516570416,
						-31.0539570526528
					],
					"name": "Kootingal Public School",
					"playspace": 82.03,
					"projections": [
						199,
						188,
						190,
						190,
						185,
						180
					],
					"projections_orig": [
						"199",
						"188",
						"190",
						"190",
						"185",
						"180"
					],
					"projections_percentage": [
						5.85,
						0,
						1.06,
						1.06,
						-1.6,
						-4.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2327
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.9,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						151.075024185375,
						-31.0192505691181
					],
					"name": "Moonbi Public School",
					"playspace": 680.32,
					"projections": [
						53,
						52,
						70,
						70,
						70,
						70
					],
					"projections_orig": [
						"53",
						"52",
						"70",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						1.92,
						0,
						34.62,
						34.62,
						34.62,
						34.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2608
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.12,
					"enrolment": 55,
					"ligo": 1,
					"location": [
						151.127969573364,
						-31.4602584168429
					],
					"name": "Nundle Public School",
					"playspace": 63.04,
					"projections": [
						61,
						55,
						70,
						70,
						65,
						65
					],
					"projections_orig": [
						"61",
						"55",
						"70",
						"70",
						"65",
						"65"
					],
					"projections_percentage": [
						10.91,
						0,
						27.27,
						27.27,
						18.18,
						18.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2781
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.23,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						150.640924241834,
						-30.9384731655004
					],
					"name": "Somerton Public School",
					"playspace": 397.01,
					"projections": [
						11,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-31.25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3079
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.04,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						151.148595592722,
						-31.3021372662287
					],
					"name": "Woolomin Public School",
					"playspace": 169.25,
					"projections": [
						37,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						15.62,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3506
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 31
					},
					"classroomspace": 5.84,
					"enrolment": 312,
					"ligo": 0.94,
					"location": [
						150.728071495625,
						-30.7497762746558
					],
					"name": "Manilla Central School",
					"playspace": 137.43,
					"projections": [
						357,
						312,
						340,
						350,
						330,
						325
					],
					"projections_orig": [
						"357",
						"312",
						"340",
						"350",
						"330",
						"325"
					],
					"projections_percentage": [
						14.42,
						0,
						8.97,
						12.18,
						5.77,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7305
				}
			],
			"uid": 30058
		},
		{
			"classrooms": {
				"demountable": 31,
				"permanent": 328
			},
			"enrolment": 6494,
			"level": "Combined",
			"ligo": 0.73,
			"name": "Tamworth",
			"playspace": 122.64,
			"projections": [
				6494,
				6880,
				6880,
				6720,
				6600
			],
			"projections_percentage": [
				0,
				5.94,
				5.94,
				3.48,
				1.63
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.43,
					"enrolment": 141,
					"ligo": 1,
					"location": [
						150.916561581343,
						-31.2035593273161
					],
					"name": "Timbumburi Public School",
					"playspace": 96.93,
					"projections": [
						127,
						141,
						140,
						140,
						135,
						135
					],
					"projections_orig": [
						"127",
						"141",
						"140",
						"140",
						"135",
						"135"
					],
					"projections_percentage": [
						-9.93,
						0,
						-0.71,
						-0.71,
						-4.26,
						-4.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1016
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 6
					},
					"classroomspace": 2.42,
					"enrolment": 211,
					"ligo": 0.63,
					"location": [
						151.003664443626,
						-31.1274740078931
					],
					"name": "Nemingha Public School",
					"playspace": 127.2,
					"projections": [
						200,
						211,
						210,
						210,
						210,
						205
					],
					"projections_orig": [
						"200",
						"211",
						"210",
						"210",
						"210",
						"205"
					],
					"projections_percentage": [
						-5.21,
						0,
						-0.47,
						-0.47,
						-0.47,
						-2.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2725
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 30
					},
					"classroomspace": 2.21,
					"enrolment": 910,
					"ligo": 0.66,
					"location": [
						150.935909397265,
						-31.0854227404346
					],
					"name": "Tamworth Public School",
					"playspace": 31.1,
					"projections": [
						748,
						910,
						920,
						915,
						885,
						870
					],
					"projections_orig": [
						"748",
						"910",
						"920",
						"915",
						"885",
						"870"
					],
					"projections_percentage": [
						-17.8,
						0,
						1.1,
						0.55,
						-2.75,
						-4.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3157
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 2.87,
					"enrolment": 377,
					"ligo": 0.31,
					"location": [
						150.920023641969,
						-31.0916463360794
					],
					"name": "Tamworth West Public School",
					"playspace": 31.71,
					"projections": [
						209,
						377,
						370,
						360,
						360,
						360
					],
					"projections_orig": [
						"209",
						"377",
						"370",
						"360",
						"360",
						"360"
					],
					"projections_percentage": [
						-44.56,
						0,
						-1.86,
						-4.51,
						-4.51,
						-4.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3158
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 2.78,
					"enrolment": 88,
					"ligo": 1,
					"location": [
						151.009349473319,
						-31.0847945925027
					],
					"name": "Tintinhull Public School",
					"playspace": 415.65,
					"projections": [
						42,
						88,
						80,
						80,
						80,
						80
					],
					"projections_orig": [
						"42",
						"88",
						"80",
						"80",
						"80",
						"80"
					],
					"projections_percentage": [
						-52.27,
						0,
						-9.09,
						-9.09,
						-9.09,
						-9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3221
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 15
					},
					"classroomspace": 2.71,
					"enrolment": 506,
					"ligo": 0.66,
					"location": [
						150.873190348568,
						-31.0936775769253
					],
					"name": "Westdale Public School",
					"playspace": 60.68,
					"projections": [
						453,
						506,
						540,
						535,
						510,
						510
					],
					"projections_orig": [
						"453",
						"506",
						"540",
						"535",
						"510",
						"510"
					],
					"projections_percentage": [
						-10.47,
						0,
						6.72,
						5.73,
						0.79,
						0.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3428
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.77,
					"enrolment": 337,
					"ligo": 0.85,
					"location": [
						150.896208083128,
						-31.0586222888925
					],
					"name": "Oxley Vale Public School",
					"playspace": 87.09,
					"projections": [
						324,
						337,
						330,
						335,
						335,
						330
					],
					"projections_orig": [
						"324",
						"337",
						"330",
						"335",
						"335",
						"330"
					],
					"projections_percentage": [
						-3.86,
						0,
						-2.08,
						-0.59,
						-0.59,
						-2.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3690
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 2.87,
					"enrolment": 673,
					"ligo": 0.53,
					"location": [
						150.913053260926,
						-31.1055467728664
					],
					"name": "Tamworth South Public School",
					"playspace": 80.7,
					"projections": [
						763,
						673,
						775,
						775,
						740,
						740
					],
					"projections_orig": [
						"763",
						"673",
						"775",
						"775",
						"740",
						"740"
					],
					"projections_percentage": [
						13.37,
						0,
						15.16,
						15.16,
						9.96,
						9.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3882
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.71,
					"enrolment": 311,
					"ligo": 0.74,
					"location": [
						150.900908691411,
						-31.1133140140391
					],
					"name": "Hillvue Public School",
					"playspace": 85.94,
					"projections": [
						260,
						311,
						290,
						290,
						290,
						290
					],
					"projections_orig": [
						"260",
						"311",
						"290",
						"290",
						"290",
						"290"
					],
					"projections_percentage": [
						-16.4,
						0,
						-6.75,
						-6.75,
						-6.75,
						-6.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4437
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 41
					},
					"classroomspace": 4.65,
					"enrolment": 616,
					"ligo": 1,
					"location": [
						150.978872171808,
						-31.1431101850885
					],
					"name": "Farrer Memorial Agricultural High School",
					"playspace": 376.96,
					"projections": [
						604,
						616,
						630,
						635,
						640,
						640
					],
					"projections_orig": [
						"604",
						"616",
						"630",
						"635",
						"640",
						"640"
					],
					"projections_percentage": [
						-1.95,
						0,
						2.27,
						3.08,
						3.9,
						3.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8111
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 59
					},
					"classroomspace": 5.34,
					"enrolment": 680,
					"ligo": 0.7,
					"location": [
						150.91566391094,
						-31.1055248709455
					],
					"name": "Tamworth High School",
					"playspace": 89.87,
					"projections": [
						737,
						680,
						780,
						785,
						765,
						735
					],
					"projections_orig": [
						"737",
						"680",
						"780",
						"785",
						"765",
						"735"
					],
					"projections_percentage": [
						8.38,
						0,
						14.71,
						15.44,
						12.5,
						8.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8139
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 47
					},
					"classroomspace": 3.56,
					"enrolment": 960,
					"ligo": 0.73,
					"location": [
						150.939916518273,
						-31.0796874802216
					],
					"name": "Oxley High School",
					"playspace": 33.03,
					"projections": [
						1028,
						960,
						1085,
						1090,
						1065,
						1020
					],
					"projections_orig": [
						"1028",
						"960",
						"1085",
						"1090",
						"1065",
						"1020"
					],
					"projections_percentage": [
						7.08,
						0,
						13.02,
						13.54,
						10.94,
						6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8455
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 36
					},
					"classroomspace": 3.87,
					"enrolment": 684,
					"ligo": 0.68,
					"location": [
						150.893807878993,
						-31.0984714301996
					],
					"name": "Peel High School",
					"playspace": 77.42,
					"projections": [
						516,
						684,
						730,
						730,
						705,
						685
					],
					"projections_orig": [
						"516",
						"684",
						"730",
						"730",
						"705",
						"685"
					],
					"projections_percentage": [
						-24.56,
						0,
						6.73,
						6.73,
						3.07,
						0.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8525
				}
			],
			"uid": 30059
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 57
			},
			"enrolment": 662,
			"level": "Combined",
			"ligo": 0.97,
			"name": "Tenterfield",
			"playspace": 447.8,
			"projections": [
				663,
				659,
				649,
				614,
				594
			],
			"projections_percentage": [
				0,
				-0.6,
				-2.11,
				-7.39,
				-10.41
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 12.31,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						151.848406525011,
						-29.4425920767542
					],
					"name": "Deepwater Public School",
					"playspace": 420.76,
					"projections": [
						30,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						114.29,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1742
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.69,
					"enrolment": 33,
					"ligo": 1,
					"location": [
						152.374430616269,
						-28.9294671380342
					],
					"name": "Drake Public School",
					"playspace": 5.35,
					"projections": [
						28,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.15,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1771
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 7.27,
					"enrolment": 83,
					"ligo": 0.81,
					"location": [
						151.601810024367,
						-29.4472803581213
					],
					"name": "Emmaville Central School",
					"playspace": 284.38,
					"projections": [
						71,
						84,
						70,
						70,
						65,
						65
					],
					"projections_orig": [
						"71",
						"84",
						"70",
						"70",
						"65",
						"65"
					],
					"projections_percentage": [
						-15.48,
						0,
						-16.67,
						-16.67,
						-22.62,
						-22.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1838
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 10.75,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						151.933940826214,
						-28.9275302535882
					],
					"name": "Jennings Public School",
					"playspace": 1648.36,
					"projections": [
						18,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						63.64,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2223
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 3.39,
					"enrolment": 231,
					"ligo": 1,
					"location": [
						152.024708503587,
						-29.0562938302505
					],
					"name": "The Sir Henry Parkes Memorial Public School",
					"playspace": 165.8,
					"projections": [
						268,
						231,
						250,
						245,
						235,
						225
					],
					"projections_orig": [
						"268",
						"231",
						"250",
						"245",
						"235",
						"225"
					],
					"projections_percentage": [
						16.02,
						0,
						8.23,
						6.06,
						1.73,
						-2.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3182
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.87,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						151.54211163129,
						-29.004924454651
					],
					"name": "Mingoola Public School",
					"playspace": 554.3,
					"projections": [
						11,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4115
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 5.94,
					"enrolment": 279,
					"ligo": 0.96,
					"location": [
						152.018038913481,
						-29.0534368265812
					],
					"name": "Tenterfield High School",
					"playspace": 55.64,
					"projections": [
						240,
						279,
						270,
						265,
						245,
						235
					],
					"projections_orig": [
						"240",
						"279",
						"270",
						"265",
						"245",
						"235"
					],
					"projections_percentage": [
						-13.98,
						0,
						-3.23,
						-5.02,
						-12.19,
						-15.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8358
				}
			],
			"uid": 30060
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 35
			},
			"enrolment": 287,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Walcha",
			"playspace": 1401.28,
			"projections": [
				287,
				306,
				321,
				331,
				341
			],
			"projections_percentage": [
				0,
				6.62,
				11.85,
				15.33,
				18.82
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 10.86,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						151.409014634077,
						-31.2980556344433
					],
					"name": "Niangala Public School",
					"playspace": 627.64,
					"projections": [
						22,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"22",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						214.29,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2748
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 18.35,
					"enrolment": 6,
					"ligo": 1,
					"location": [
						151.715752841473,
						-31.4829892090925
					],
					"name": "Nowendoc Public School",
					"playspace": 1688.92,
					"projections": [
						7,
						6,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"6",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						16.67,
						0,
						316.67,
						316.67,
						316.67,
						316.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2768
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 30
					},
					"classroomspace": 7.84,
					"enrolment": 251,
					"ligo": 0.94,
					"location": [
						151.604572059981,
						-30.9806421226294
					],
					"name": "Walcha Central School",
					"playspace": 227.55,
					"projections": [
						324,
						251,
						270,
						285,
						295,
						305
					],
					"projections_orig": [
						"324",
						"251",
						"270",
						"285",
						"295",
						"305"
					],
					"projections_percentage": [
						29.08,
						0,
						7.57,
						13.55,
						17.53,
						21.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3340
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.55,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						151.343498320157,
						-30.9694024070231
					],
					"name": "Woolbrook Public School",
					"playspace": 3410.59,
					"projections": [
						17,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						54.55,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3501
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.52,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						151.948018390997,
						-31.2511799364849
					],
					"name": "Yarrowitch Public School",
					"playspace": 1051.71,
					"projections": [
						13,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						8.33,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3547
				}
			],
			"uid": 30061
		},
		{
			"classrooms": {
				"demountable": 1,
				"permanent": 70
			},
			"enrolment": 997,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Wollemi",
			"playspace": 7190.48,
			"projections": [
				997,
				988,
				978,
				953,
				923
			],
			"projections_percentage": [
				0,
				-0.9,
				-1.91,
				-4.41,
				-7.42
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.22,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						150.238072643118,
						-31.6403017727576
					],
					"name": "Blackville Public School",
					"playspace": 2347.8,
					"projections": [
						11,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"11",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-15.38,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1252
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 15.22,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						149.901631681626,
						-31.453891581533
					],
					"name": "Premer Public School",
					"playspace": 2252.01,
					"projections": [
						21,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						162.5,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2900
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 8.67,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						150.253890259298,
						-31.3923983389639
					],
					"name": "Spring Ridge Public School",
					"playspace": 499.02,
					"projections": [
						33,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						22.22,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3091
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.79,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						150.419316809354,
						-31.3949409852953
					],
					"name": "Walhallow Public School",
					"playspace": 58761.36,
					"projections": [
						19,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						35.71,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3343
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 6.15,
					"enrolment": 31,
					"ligo": 1,
					"location": [
						150.828804274777,
						-31.5406715148223
					],
					"name": "Wallabadah Public School",
					"playspace": 231.88,
					"projections": [
						39,
						31,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"31",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25.81,
						0,
						-19.35,
						-19.35,
						-19.35,
						-19.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3345
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 3.12,
					"enrolment": 117,
					"ligo": 1,
					"location": [
						150.651269511279,
						-31.3488026446629
					],
					"name": "Werris Creek Public School",
					"playspace": 120.52,
					"projections": [
						105,
						117,
						110,
						110,
						105,
						105
					],
					"projections_orig": [
						"105",
						"117",
						"110",
						"110",
						"105",
						"105"
					],
					"projections_percentage": [
						-10.26,
						0,
						-5.98,
						-5.98,
						-10.26,
						-10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3425
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.3,
					"enrolment": 50,
					"ligo": 1,
					"location": [
						150.727970410289,
						-31.6568696648503
					],
					"name": "Willow Tree Public School",
					"playspace": 341.79,
					"projections": [
						56,
						50,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"56",
						"50",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						12,
						0,
						-50,
						-50,
						-50,
						-50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3451
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.72,
					"enrolment": 286,
					"ligo": 1,
					"location": [
						150.678432128028,
						-31.4981863238253
					],
					"name": "Quirindi Public School",
					"playspace": 125.19,
					"projections": [
						376,
						286,
						305,
						290,
						285,
						280
					],
					"projections_orig": [
						"376",
						"286",
						"305",
						"290",
						"285",
						"280"
					],
					"projections_percentage": [
						31.47,
						0,
						6.64,
						1.4,
						-0.35,
						-2.1
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3947
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 4.79,
					"enrolment": 451,
					"ligo": 0.95,
					"location": [
						150.67945623797,
						-31.501197257676
					],
					"name": "Quirindi High School",
					"playspace": 34.75,
					"projections": [
						418,
						451,
						430,
						435,
						420,
						395
					],
					"projections_orig": [
						"418",
						"451",
						"430",
						"435",
						"420",
						"395"
					],
					"projections_percentage": [
						-7.32,
						0,
						-4.66,
						-3.55,
						-6.87,
						-12.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8174
				}
			],
			"uid": 30062
		},
		{
			"classrooms": {
				"demountable": 69,
				"permanent": 344
			},
			"enrolment": 7101,
			"level": "Combined",
			"ligo": 0.87,
			"name": "Ballina-Byron",
			"playspace": 147.41,
			"projections": [
				7101,
				8182,
				8192,
				7917,
				7607
			],
			"projections_percentage": [
				0,
				15.22,
				15.36,
				11.49,
				7.13
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 13
					},
					"classroomspace": 2.65,
					"enrolment": 536,
					"ligo": 0.72,
					"location": [
						153.437723303544,
						-28.8396262563992
					],
					"name": "Alstonville Public School",
					"playspace": 27.22,
					"projections": [
						549,
						536,
						625,
						610,
						570,
						565
					],
					"projections_orig": [
						"549",
						"536",
						"625",
						"610",
						"570",
						"565"
					],
					"projections_percentage": [
						2.43,
						0,
						16.6,
						13.81,
						6.34,
						5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1030
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 5.27,
					"enrolment": 247,
					"ligo": 0.93,
					"location": [
						153.564165104344,
						-28.8694214925114
					],
					"name": "Ballina Public School",
					"playspace": 63.65,
					"projections": [
						276,
						247,
						300,
						285,
						285,
						280
					],
					"projections_orig": [
						"276",
						"247",
						"300",
						"285",
						"285",
						"280"
					],
					"projections_percentage": [
						11.74,
						0,
						21.46,
						15.38,
						15.38,
						13.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1112
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 8
					},
					"classroomspace": 2.65,
					"enrolment": 298,
					"ligo": 0.88,
					"location": [
						153.526183161249,
						-28.6852123409437
					],
					"name": "Bangalow Public School",
					"playspace": 23.56,
					"projections": [
						207,
						298,
						340,
						320,
						305,
						300
					],
					"projections_orig": [
						"207",
						"298",
						"340",
						"320",
						"305",
						"300"
					],
					"projections_percentage": [
						-30.54,
						0,
						14.09,
						7.38,
						2.35,
						0.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1118
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 0
					},
					"classroomspace": 3.55,
					"enrolment": 107,
					"ligo": 1,
					"location": [
						153.345883553902,
						-28.7665269348735
					],
					"name": "Bexhill Public School",
					"playspace": 86.12,
					"projections": [
						105,
						107,
						115,
						120,
						115,
						115
					],
					"projections_orig": [
						"105",
						"107",
						"115",
						"120",
						"115",
						"115"
					],
					"projections_percentage": [
						-1.87,
						0,
						7.48,
						12.15,
						7.48,
						7.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1217
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 2.55,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						153.437010034268,
						-29.0027204161133
					],
					"name": "Broadwater Public School",
					"playspace": 129.67,
					"projections": [
						37,
						52,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"52",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-28.85,
						0,
						-51.92,
						-51.92,
						-51.92,
						-51.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1361
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 20
					},
					"classroomspace": 2.58,
					"enrolment": 662,
					"ligo": 0.84,
					"location": [
						153.614444133224,
						-28.6478717645783
					],
					"name": "Byron Bay Public School",
					"playspace": 20.65,
					"projections": [
						635,
						662,
						785,
						765,
						735,
						700
					],
					"projections_orig": [
						"635",
						"662",
						"785",
						"765",
						"735",
						"700"
					],
					"projections_percentage": [
						-4.08,
						0,
						18.58,
						15.56,
						11.03,
						5.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1470
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 3
					},
					"classroomspace": 12.51,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						153.4579257346,
						-28.9836129421355
					],
					"name": "Cabbage Tree Island Public School",
					"playspace": 363.76,
					"projections": [
						17,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"17",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1471
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.12,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						153.505079149082,
						-28.9148276315703
					],
					"name": "Empire Vale Public School",
					"playspace": 392.43,
					"projections": [
						44,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						22.22,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1840
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 33
					},
					"classroomspace": 4.93,
					"enrolment": 497,
					"ligo": 0.66,
					"location": [
						153.426309533424,
						-29.1137245707767
					],
					"name": "Evans River Community School",
					"playspace": 67.26,
					"projections": [
						482,
						497,
						545,
						555,
						540,
						520
					],
					"projections_orig": [
						"482",
						"497",
						"545",
						"555",
						"540",
						"520"
					],
					"projections_percentage": [
						-3.02,
						0,
						9.66,
						11.67,
						8.65,
						4.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1886
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.7,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						153.498792919802,
						-28.7679743090759
					],
					"name": "Fernleigh Public School",
					"playspace": 259.78,
					"projections": [
						21,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-19.23,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2214
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.9,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						153.532887784508,
						-28.7175088701649
					],
					"name": "Newrybar Public School",
					"playspace": 639.71,
					"projections": [
						30,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						11.11,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2741
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.31,
					"enrolment": 68,
					"ligo": 1,
					"location": [
						153.407551614115,
						-28.8710619345838
					],
					"name": "Rous Public School",
					"playspace": 209.58,
					"projections": [
						69,
						68,
						75,
						75,
						75,
						70
					],
					"projections_orig": [
						"69",
						"68",
						"75",
						"75",
						"75",
						"70"
					],
					"projections_percentage": [
						1.47,
						0,
						10.29,
						10.29,
						10.29,
						2.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3006
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.43,
					"enrolment": 44,
					"ligo": 1,
					"location": [
						153.468515186502,
						-28.9506428623861
					],
					"name": "Wardell Public School",
					"playspace": 174.38,
					"projections": [
						41,
						44,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"41",
						"44",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.82,
						0,
						-43.18,
						-43.18,
						-43.18,
						-43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3378
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 11
					},
					"classroomspace": 2.67,
					"enrolment": 296,
					"ligo": 0.66,
					"location": [
						153.419249026946,
						-28.826281797127
					],
					"name": "Wollongbar Public School",
					"playspace": 69.41,
					"projections": [
						222,
						296,
						310,
						285,
						285,
						280
					],
					"projections_orig": [
						"222",
						"296",
						"310",
						"285",
						"285",
						"280"
					],
					"projections_percentage": [
						-25,
						0,
						4.73,
						-3.72,
						-3.72,
						-5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3475
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.38,
					"enrolment": 131,
					"ligo": 1,
					"location": [
						153.33981071851,
						-29.0751158898731
					],
					"name": "Woodburn Public School",
					"playspace": 125.23,
					"projections": [
						108,
						131,
						115,
						115,
						115,
						115
					],
					"projections_orig": [
						"108",
						"131",
						"115",
						"115",
						"115",
						"115"
					],
					"projections_percentage": [
						-17.56,
						0,
						-12.21,
						-12.21,
						-12.21,
						-12.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3490
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 8
					},
					"classroomspace": 2.79,
					"enrolment": 368,
					"ligo": 0.92,
					"location": [
						153.590310209206,
						-28.7932697711901
					],
					"name": "Lennox Head Public School",
					"playspace": 50.25,
					"projections": [
						343,
						368,
						410,
						390,
						375,
						370
					],
					"projections_orig": [
						"343",
						"368",
						"410",
						"390",
						"375",
						"370"
					],
					"projections_percentage": [
						-6.79,
						0,
						11.41,
						5.98,
						1.9,
						0.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4184
				},
				{
					"classrooms": {
						"demountable": 26,
						"permanent": 64
					},
					"classroomspace": 3.73,
					"enrolment": 1587,
					"ligo": 0.62,
					"location": [
						153.587775486168,
						-28.850809074175
					],
					"name": "Southern Cross School",
					"playspace": 39.61,
					"projections": [
						1386,
						1587,
						1810,
						1835,
						1760,
						1685
					],
					"projections_orig": [
						"1386",
						"1587",
						"1810",
						"1835",
						"1760",
						"1685"
					],
					"projections_percentage": [
						-12.67,
						0,
						14.05,
						15.63,
						10.9,
						6.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4428
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 2.63,
					"enrolment": 168,
					"ligo": 1,
					"location": [
						153.500066325811,
						-28.7955949842741
					],
					"name": "Teven-Tintenbar Public School",
					"playspace": 142.17,
					"projections": [
						139,
						168,
						165,
						165,
						160,
						160
					],
					"projections_orig": [
						"139",
						"168",
						"165",
						"165",
						"160",
						"160"
					],
					"projections_percentage": [
						-17.26,
						0,
						-1.79,
						-1.79,
						-4.76,
						-4.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4578
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 10.24,
					"enrolment": 330,
					"ligo": 0.8,
					"location": [
						153.563978381192,
						-28.8664015229221
					],
					"name": "Ballina High School",
					"playspace": 137.84,
					"projections": [
						503,
						330,
						485,
						500,
						485,
						445
					],
					"projections_orig": [
						"503",
						"330",
						"485",
						"500",
						"485",
						"445"
					],
					"projections_percentage": [
						52.42,
						0,
						46.97,
						51.52,
						46.97,
						34.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8195
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 36
					},
					"classroomspace": 3.27,
					"enrolment": 852,
					"ligo": 0.71,
					"location": [
						153.614828994309,
						-28.6679259645412
					],
					"name": "Byron Bay High School",
					"playspace": 43.67,
					"projections": [
						826,
						852,
						955,
						1000,
						970,
						920
					],
					"projections_orig": [
						"826",
						"852",
						"955",
						"1000",
						"970",
						"920"
					],
					"projections_percentage": [
						-3.05,
						0,
						12.09,
						17.37,
						13.85,
						7.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8577
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 42
					},
					"classroomspace": 3.49,
					"enrolment": 752,
					"ligo": 0.62,
					"location": [
						153.433868873435,
						-28.841142391789
					],
					"name": "Alstonville High School",
					"playspace": 29.63,
					"projections": [
						887,
						752,
						945,
						970,
						940,
						880
					],
					"projections_orig": [
						"887",
						"752",
						"945",
						"970",
						"940",
						"880"
					],
					"projections_percentage": [
						17.95,
						0,
						25.66,
						28.99,
						25,
						17.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8578
				}
			],
			"uid": 30063
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 97
			},
			"enrolment": 1562,
			"level": "Combined",
			"ligo": 0.93,
			"name": "Bellingen",
			"playspace": 342.62,
			"projections": [
				1562,
				1615,
				1605,
				1525,
				1460
			],
			"projections_percentage": [
				0,
				3.39,
				2.75,
				-2.37,
				-6.53
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.81,
					"enrolment": 372,
					"ligo": 1,
					"location": [
						152.892920069978,
						-30.4532501684389
					],
					"name": "Bellingen Public School",
					"playspace": 79.77,
					"projections": [
						319,
						372,
						420,
						385,
						355,
						340
					],
					"projections_orig": [
						"319",
						"372",
						"420",
						"385",
						"355",
						"340"
					],
					"projections_percentage": [
						-14.25,
						0,
						12.9,
						3.49,
						-4.57,
						-8.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1181
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.82,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						152.542261665027,
						-30.1892281440144
					],
					"name": "Dundurrabin Public School",
					"playspace": "NA",
					"projections": [
						27,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						28.57,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1788
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 10.66,
					"enrolment": 5,
					"ligo": 1,
					"location": [
						152.422232462915,
						-30.2945687385232
					],
					"name": "Hernani Public School",
					"playspace": 1631.92,
					"projections": [
						14,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						180,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2156
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.02,
					"enrolment": 32,
					"ligo": 0.76,
					"location": [
						153.012647660171,
						-30.4496226974575
					],
					"name": "Raleigh Public School",
					"playspace": 266.5,
					"projections": [
						34,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"34",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						6.25,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2931
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.48,
					"enrolment": 68,
					"ligo": 1,
					"location": [
						153.028836526363,
						-30.4459948844715
					],
					"name": "Repton Public School",
					"playspace": 104.4,
					"projections": [
						65,
						68,
						65,
						65,
						60,
						60
					],
					"projections_orig": [
						"65",
						"68",
						"65",
						"65",
						"60",
						"60"
					],
					"projections_percentage": [
						-4.41,
						0,
						-4.41,
						-4.41,
						-11.76,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2955
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.55,
					"enrolment": 201,
					"ligo": 0.76,
					"location": [
						153.019924519059,
						-30.4949253505655
					],
					"name": "Urunga Public School",
					"playspace": 41.18,
					"projections": [
						226,
						201,
						185,
						180,
						170,
						165
					],
					"projections_orig": [
						"226",
						"201",
						"185",
						"180",
						"170",
						"165"
					],
					"projections_percentage": [
						12.44,
						0,
						-7.96,
						-10.45,
						-15.42,
						-17.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3318
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.97,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						152.691639760038,
						-30.4320472552653
					],
					"name": "Orama Public School",
					"playspace": 237.39,
					"projections": [
						36,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"36",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						33.33,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4534
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 7.12,
					"enrolment": 95,
					"ligo": 1,
					"location": [
						152.710449727111,
						-30.3436811835301
					],
					"name": "Dorrigo Public School",
					"playspace": 270.87,
					"projections": [
						137,
						95,
						125,
						130,
						135,
						140
					],
					"projections_orig": [
						"137",
						"95",
						"125",
						"130",
						"135",
						"140"
					],
					"projections_percentage": [
						44.21,
						0,
						31.58,
						36.84,
						42.11,
						47.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7316
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 33
					},
					"classroomspace": 3.38,
					"enrolment": 578,
					"ligo": 0.87,
					"location": [
						152.905994898211,
						-30.4548758637841
					],
					"name": "Bellingen High School",
					"playspace": 82.07,
					"projections": [
						609,
						578,
						570,
						585,
						535,
						480
					],
					"projections_orig": [
						"609",
						"578",
						"570",
						"585",
						"535",
						"480"
					],
					"projections_percentage": [
						5.36,
						0,
						-1.38,
						1.21,
						-7.44,
						-16.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8258
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 6.76,
					"enrolment": 163,
					"ligo": 0.93,
					"location": [
						152.70613621372,
						-30.3382108116675
					],
					"name": "Dorrigo High School",
					"playspace": 369.51,
					"projections": [
						187,
						163,
						165,
						175,
						185,
						190
					],
					"projections_orig": [
						"187",
						"163",
						"165",
						"175",
						"185",
						"190"
					],
					"projections_percentage": [
						14.72,
						0,
						1.23,
						7.36,
						13.5,
						16.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8453
				}
			],
			"uid": 30064
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 86
			},
			"enrolment": 1512,
			"level": "Combined",
			"ligo": 0.94,
			"name": "Clarence Valley East",
			"playspace": 157.8,
			"projections": [
				1512,
				1804,
				1839,
				1774,
				1689
			],
			"projections_percentage": [
				0,
				19.31,
				21.63,
				17.33,
				11.71
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.13,
					"enrolment": 59,
					"ligo": 1,
					"location": [
						153.231486233439,
						-29.3875695343611
					],
					"name": "Chatsworth Island Public School",
					"playspace": 95.29,
					"projections": [
						89,
						59,
						70,
						70,
						65,
						65
					],
					"projections_orig": [
						"89",
						"59",
						"70",
						"70",
						"65",
						"65"
					],
					"projections_percentage": [
						50.85,
						0,
						18.64,
						18.64,
						10.17,
						10.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1553
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.32,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						153.078141336062,
						-29.5695976519419
					],
					"name": "Cowper Public School",
					"playspace": 128.61,
					"projections": [
						31,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-18.42,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1670
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 4
					},
					"classroomspace": 2.62,
					"enrolment": 201,
					"ligo": 0.78,
					"location": [
						153.234104471332,
						-29.4888161475803
					],
					"name": "Gulmarrad Public School",
					"playspace": 69.9,
					"projections": [
						194,
						201,
						185,
						185,
						180,
						175
					],
					"projections_orig": [
						"194",
						"201",
						"185",
						"185",
						"180",
						"175"
					],
					"projections_percentage": [
						-3.48,
						0,
						-7.96,
						-7.96,
						-10.45,
						-12.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2099
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.88,
					"enrolment": 63,
					"ligo": 1,
					"location": [
						153.239724545327,
						-29.4258282119201
					],
					"name": "Harwood Island Public School",
					"playspace": 213.17,
					"projections": [
						60,
						63,
						75,
						75,
						75,
						75
					],
					"projections_orig": [
						"60",
						"63",
						"75",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						-4.76,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2142
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.36,
					"enrolment": 69,
					"ligo": 1,
					"location": [
						153.099941480016,
						-29.4909301061852
					],
					"name": "Lawrence Public School",
					"playspace": 154.52,
					"projections": [
						82,
						69,
						80,
						80,
						75,
						75
					],
					"projections_orig": [
						"82",
						"69",
						"80",
						"80",
						"75",
						"75"
					],
					"projections_percentage": [
						18.84,
						0,
						15.94,
						15.94,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2379
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 6.23,
					"enrolment": 36,
					"ligo": 1,
					"location": [
						153.10743183757,
						-29.6672483374038
					],
					"name": "Tucabia Public School",
					"playspace": 445.04,
					"projections": [
						54,
						36,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"54",
						"36",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						50,
						0,
						-30.56,
						-30.56,
						-30.56,
						-30.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3263
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 5.04,
					"enrolment": 166,
					"ligo": 0.75,
					"location": [
						153.200603972719,
						-29.4568686503147
					],
					"name": "Maclean Public School",
					"playspace": 89.11,
					"projections": [
						186,
						166,
						195,
						195,
						190,
						185
					],
					"projections_orig": [
						"186",
						"166",
						"195",
						"195",
						"190",
						"185"
					],
					"projections_percentage": [
						12.05,
						0,
						17.47,
						17.47,
						14.46,
						11.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3946
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 52
					},
					"classroomspace": 3.97,
					"enrolment": 880,
					"ligo": 0.96,
					"location": [
						153.199786633042,
						-29.465678161083
					],
					"name": "Maclean High School",
					"playspace": 66.76,
					"projections": [
						1108,
						880,
						1125,
						1160,
						1115,
						1040
					],
					"projections_orig": [
						"1108",
						"880",
						"1125",
						"1160",
						"1115",
						"1040"
					],
					"projections_percentage": [
						25.91,
						0,
						27.84,
						31.82,
						26.7,
						18.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8362
				}
			],
			"uid": 30065
		},
		{
			"classrooms": {
				"demountable": 31,
				"permanent": 395
			},
			"enrolment": 6070,
			"level": "Combined",
			"ligo": 0.69,
			"name": "Coffs Harbour",
			"playspace": 93.39,
			"projections": [
				6069,
				6780,
				6885,
				6600,
				6400
			],
			"projections_percentage": [
				0,
				11.72,
				13.45,
				8.75,
				5.45
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 8
					},
					"classroomspace": 2.76,
					"enrolment": 442,
					"ligo": 0.59,
					"location": [
						153.076889974113,
						-30.3347628831225
					],
					"name": "Boambee Public School",
					"playspace": 38.83,
					"projections": [
						315,
						442,
						475,
						465,
						440,
						405
					],
					"projections_orig": [
						"315",
						"442",
						"475",
						"465",
						"440",
						"405"
					],
					"projections_percentage": [
						-28.73,
						0,
						7.47,
						5.2,
						-0.45,
						-8.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1266
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 2.91,
					"enrolment": 406,
					"ligo": 0.59,
					"location": [
						153.121242489069,
						-30.3024216861211
					],
					"name": "Coffs Harbour Public School",
					"playspace": 73.99,
					"projections": [
						324,
						406,
						465,
						475,
						460,
						470
					],
					"projections_orig": [
						"324",
						"406",
						"465",
						"475",
						"460",
						"470"
					],
					"projections_percentage": [
						-20.2,
						0,
						14.53,
						17,
						13.3,
						15.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1584
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 18
					},
					"classroomspace": 2.36,
					"enrolment": 676,
					"ligo": 0.77,
					"location": [
						153.131291266221,
						-30.2540670238547
					],
					"name": "Kororo Public School",
					"playspace": 12.57,
					"projections": [
						544,
						676,
						695,
						705,
						675,
						685
					],
					"projections_orig": [
						"544",
						"676",
						"695",
						"705",
						"675",
						"685"
					],
					"projections_percentage": [
						-19.53,
						0,
						2.81,
						4.29,
						-0.15,
						1.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2330
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 11
					},
					"classroomspace": 2.57,
					"enrolment": 356,
					"ligo": 0.62,
					"location": [
						153.097442731499,
						-30.3638397471458
					],
					"name": "Sawtell Public School",
					"playspace": 23.5,
					"projections": [
						256,
						356,
						385,
						375,
						330,
						320
					],
					"projections_orig": [
						"256",
						"356",
						"385",
						"375",
						"330",
						"320"
					],
					"projections_percentage": [
						-28.09,
						0,
						8.15,
						5.34,
						-7.3,
						-10.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3042
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 2.57,
					"enrolment": 623,
					"ligo": 0.62,
					"location": [
						153.103340556724,
						-30.2925947375822
					],
					"name": "Narranga Public School",
					"playspace": 49.59,
					"projections": [
						603,
						623,
						740,
						755,
						730,
						740
					],
					"projections_orig": [
						"603",
						"623",
						"740",
						"755",
						"730",
						"740"
					],
					"projections_percentage": [
						-3.21,
						0,
						18.78,
						21.19,
						17.17,
						18.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4404
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 3.91,
					"enrolment": 312,
					"ligo": 0.67,
					"location": [
						153.111616592213,
						-30.2838923881987
					],
					"name": "Tyalla Public School",
					"playspace": 94.38,
					"projections": [
						380,
						312,
						365,
						375,
						365,
						375
					],
					"projections_orig": [
						"380",
						"312",
						"365",
						"375",
						"365",
						"375"
					],
					"projections_percentage": [
						21.79,
						0,
						16.99,
						20.19,
						16.99,
						20.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4503
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.57,
					"enrolment": 272,
					"ligo": 0.5,
					"location": [
						153.08225117065,
						-30.353350677837
					],
					"name": "Toormina Public School",
					"playspace": 39.82,
					"projections": [
						301,
						272,
						320,
						310,
						275,
						265
					],
					"projections_orig": [
						"301",
						"272",
						"320",
						"310",
						"275",
						"265"
					],
					"projections_percentage": [
						10.66,
						0,
						17.65,
						13.97,
						1.1,
						-2.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4506
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 4.92,
					"enrolment": 210,
					"ligo": 0.62,
					"location": [
						153.078953502328,
						-30.3630542952789
					],
					"name": "William Bayldon Public School",
					"playspace": 152.22,
					"projections": [
						201,
						210,
						220,
						200,
						190,
						185
					],
					"projections_orig": [
						"201",
						"210",
						"220",
						"200",
						"190",
						"185"
					],
					"projections_percentage": [
						-4.29,
						0,
						4.76,
						-4.76,
						-9.52,
						-11.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4602
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 46
					},
					"classroomspace": 3.24,
					"enrolment": 947,
					"ligo": 0.77,
					"location": [
						153.136267596833,
						-30.3049988117123
					],
					"name": "Coffs Harbour High School",
					"playspace": 6.56,
					"projections": [
						905,
						947,
						1010,
						1065,
						1050,
						1005
					],
					"projections_orig": [
						"905",
						"947",
						"1010",
						"1065",
						"1050",
						"1005"
					],
					"projections_percentage": [
						-4.44,
						0,
						6.65,
						12.46,
						10.88,
						6.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8109
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 112
					},
					"classroomspace": 12.76,
					"enrolment": 503,
					"ligo": 1,
					"location": [
						153.102391358028,
						-30.330026920245
					],
					"name": "Coffs Harbour Senior College",
					"playspace": 493.13,
					"projections": [
						498,
						503,
						560,
						560,
						530,
						490
					],
					"projections_orig": [
						"498",
						"503",
						"560",
						"560",
						"530",
						"490"
					],
					"projections_percentage": [
						-0.99,
						0,
						11.33,
						11.33,
						5.37,
						-2.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8272
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 53
					},
					"classroomspace": 6.52,
					"enrolment": 595,
					"ligo": 0.73,
					"location": [
						153.111811070385,
						-30.2828694664838
					],
					"name": "Orara High School",
					"playspace": 76.46,
					"projections": [
						683,
						594,
						720,
						770,
						770,
						745
					],
					"projections_orig": [
						"683",
						"594",
						"720",
						"770",
						"770",
						"745"
					],
					"projections_percentage": [
						14.98,
						0,
						21.21,
						29.63,
						29.63,
						25.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8469
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 44
					},
					"classroomspace": 4.19,
					"enrolment": 728,
					"ligo": 0.84,
					"location": [
						153.085299200771,
						-30.3509533917512
					],
					"name": "Toormina High School",
					"playspace": 59.61,
					"projections": [
						810,
						728,
						825,
						830,
						785,
						715
					],
					"projections_orig": [
						"810",
						"728",
						"825",
						"830",
						"785",
						"715"
					],
					"projections_percentage": [
						11.26,
						0,
						13.32,
						14.01,
						7.83,
						-1.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8527
				}
			],
			"uid": 30066
		},
		{
			"classrooms": {
				"demountable": 16,
				"permanent": 177
			},
			"enrolment": 3520,
			"level": "Combined",
			"ligo": 0.83,
			"name": "Grafton",
			"playspace": 107.12,
			"projections": [
				3519,
				4090,
				4095,
				3880,
				3670
			],
			"projections_percentage": [
				0,
				16.23,
				16.37,
				10.26,
				4.29
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 5.42,
					"enrolment": 84,
					"ligo": 1,
					"location": [
						152.890192427205,
						-29.8320185920293
					],
					"name": "Coutts Crossing Public School",
					"playspace": 235.79,
					"projections": [
						58,
						84,
						80,
						80,
						80,
						80
					],
					"projections_orig": [
						"58",
						"84",
						"80",
						"80",
						"80",
						"80"
					],
					"projections_percentage": [
						-30.95,
						0,
						-4.76,
						-4.76,
						-4.76,
						-4.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1666
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 29
					},
					"classroomspace": 2.66,
					"enrolment": 679,
					"ligo": 0.64,
					"location": [
						152.934004811389,
						-29.6858719811393
					],
					"name": "Grafton Public School",
					"playspace": 52.05,
					"projections": [
						668,
						679,
						755,
						735,
						695,
						665
					],
					"projections_orig": [
						"668",
						"679",
						"755",
						"735",
						"695",
						"665"
					],
					"projections_percentage": [
						-1.62,
						0,
						11.19,
						8.25,
						2.36,
						-2.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2060
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 26
					},
					"classroomspace": 2.75,
					"enrolment": 596,
					"ligo": 0.9,
					"location": [
						152.937832810497,
						-29.7098491251606
					],
					"name": "South Grafton Public School",
					"playspace": 34.48,
					"projections": [
						594,
						596,
						660,
						645,
						595,
						575
					],
					"projections_orig": [
						"594",
						"596",
						"660",
						"645",
						"595",
						"575"
					],
					"projections_percentage": [
						-0.34,
						0,
						10.74,
						8.22,
						-0.17,
						-3.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2061
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 5.43,
					"enrolment": 134,
					"ligo": 1,
					"location": [
						152.932429683562,
						-29.7246565049542
					],
					"name": "Gillwinga Public School",
					"playspace": 266.07,
					"projections": [
						147,
						134,
						130,
						130,
						125,
						125
					],
					"projections_orig": [
						"147",
						"134",
						"130",
						"130",
						"125",
						"125"
					],
					"projections_percentage": [
						9.7,
						0,
						-2.99,
						-2.99,
						-6.72,
						-6.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4421
				},
				{
					"classrooms": {
						"demountable": 9,
						"permanent": 12
					},
					"classroomspace": 2.71,
					"enrolment": 513,
					"ligo": 0.71,
					"location": [
						152.929654171074,
						-29.6700026937435
					],
					"name": "Westlawn Public School",
					"playspace": 36.74,
					"projections": [
						472,
						513,
						575,
						560,
						515,
						500
					],
					"projections_orig": [
						"472",
						"513",
						"575",
						"560",
						"515",
						"500"
					],
					"projections_percentage": [
						-7.99,
						0,
						12.09,
						9.16,
						0.39,
						-2.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5238
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 49
					},
					"classroomspace": 3.24,
					"enrolment": 946,
					"ligo": 0.69,
					"location": [
						152.933000951539,
						-29.6832030643159
					],
					"name": "Grafton High School",
					"playspace": 30.15,
					"projections": [
						929,
						945,
						1055,
						1085,
						1045,
						965
					],
					"projections_orig": [
						"929",
						"945",
						"1055",
						"1085",
						"1045",
						"965"
					],
					"projections_percentage": [
						-1.69,
						0,
						11.64,
						14.81,
						10.58,
						2.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8117
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 42
					},
					"classroomspace": 5.21,
					"enrolment": 568,
					"ligo": 0.85,
					"location": [
						152.931025145768,
						-29.7163694551154
					],
					"name": "South Grafton High School",
					"playspace": 94.59,
					"projections": [
						1002,
						568,
						835,
						860,
						825,
						760
					],
					"projections_orig": [
						"1002",
						"568",
						"835",
						"860",
						"825",
						"760"
					],
					"projections_percentage": [
						76.41,
						0,
						47.01,
						51.41,
						45.25,
						33.8
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8406
				}
			],
			"uid": 30068
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 52
			},
			"enrolment": 1196,
			"level": "Combined",
			"ligo": 0.99,
			"name": "Greater Taree",
			"playspace": 413.17,
			"projections": [
				1196,
				1230,
				1185,
				1120,
				1088
			],
			"projections_percentage": [
				0,
				2.84,
				-0.92,
				-6.35,
				-9.03
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.52,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						152.282799269665,
						-31.71198700389
					],
					"name": "Bobin Public School",
					"playspace": 1046.12,
					"projections": [
						9,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"9",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-47.06,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1269
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.46,
					"enrolment": 49,
					"ligo": 1,
					"location": [
						152.609699249824,
						-31.8273162082654
					],
					"name": "Coopernook Public School",
					"playspace": 690.02,
					"projections": [
						38,
						49,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"49",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.45,
						0,
						-48.98,
						-48.98,
						-48.98,
						-48.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1632
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 8.42,
					"enrolment": 12,
					"ligo": 1,
					"location": [
						152.292074454291,
						-31.618954870861
					],
					"name": "Elands Public School",
					"playspace": 177.31,
					"projections": [
						14,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						16.67,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1824
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.44,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						152.594280055087,
						-31.7126468505732
					],
					"name": "Hannam Vale Public School",
					"playspace": 353.11,
					"projections": [
						21,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-4.55,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2131
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.73,
					"enrolment": 109,
					"ligo": 1,
					"location": [
						152.688471048984,
						-31.8706997789901
					],
					"name": "Harrington Public School",
					"playspace": 52.82,
					"projections": [
						107,
						109,
						105,
						100,
						95,
						90
					],
					"projections_orig": [
						"107",
						"109",
						"105",
						"100",
						"95",
						"90"
					],
					"projections_percentage": [
						-1.83,
						0,
						-3.67,
						-8.26,
						-12.84,
						-17.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2139
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.41,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						152.696243391551,
						-31.7326745680164
					],
					"name": "Johns River Public School",
					"playspace": 579.89,
					"projections": [
						35,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"35",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						169.23,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2243
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.17,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						152.271302764864,
						-32.0464422370226
					],
					"name": "Krambach Public School",
					"playspace": 231.98,
					"projections": [
						28,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-26.32,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2333
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.26,
					"enrolment": 48,
					"ligo": 1,
					"location": [
						152.532993851949,
						-31.7842476419691
					],
					"name": "Lansdowne Public School",
					"playspace": 144.88,
					"projections": [
						73,
						48,
						55,
						55,
						50,
						25
					],
					"projections_orig": [
						"73",
						"48",
						"55",
						"55",
						"50",
						"<50"
					],
					"projections_percentage": [
						52.08,
						0,
						14.58,
						14.58,
						4.17,
						-47.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2370
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 1.93,
					"enrolment": 31,
					"ligo": 1,
					"location": [
						152.467860701715,
						-31.7058410577095
					],
					"name": "Upper Lansdowne Public School",
					"playspace": 279.98,
					"projections": [
						20,
						31,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"31",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-35.48,
						0,
						-19.35,
						-19.35,
						-19.35,
						-19.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2372
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.94,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						152.612945225429,
						-31.8969931508518
					],
					"name": "Mitchells Island Public School",
					"playspace": 943.92,
					"projections": [
						44,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						69.23,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2580
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 4.3,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						152.651697622763,
						-31.7695690527296
					],
					"name": "Moorland Public School",
					"playspace": 122.03,
					"projections": [
						48,
						41,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"48",
						"41",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						17.07,
						0,
						-39.02,
						-39.02,
						-39.02,
						-39.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2616
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.19,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						152.179341147085,
						-31.8819709402143
					],
					"name": "Mount George Public School",
					"playspace": 448.19,
					"projections": [
						31,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						3.33,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2637
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 14
					},
					"classroomspace": 2.68,
					"enrolment": 511,
					"ligo": 1,
					"location": [
						152.589579587965,
						-31.9720106848188
					],
					"name": "Old Bar Public School",
					"playspace": 23.13,
					"projections": [
						361,
						511,
						525,
						505,
						455,
						440
					],
					"projections_orig": [
						"361",
						"511",
						"525",
						"505",
						"455",
						"440"
					],
					"projections_percentage": [
						-29.35,
						0,
						2.74,
						-1.17,
						-10.96,
						-13.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2799
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 16.71,
					"enrolment": 6,
					"ligo": 1,
					"location": [
						152.567564263184,
						-31.912642721882
					],
					"name": "Oxley Island Public School",
					"playspace": 1006.38,
					"projections": [
						46,
						6,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"46",
						"6",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						666.67,
						0,
						316.67,
						316.67,
						316.67,
						316.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2823
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 6
					},
					"classroomspace": 2.87,
					"enrolment": 243,
					"ligo": 0.89,
					"location": [
						152.535866140821,
						-32.0415227808827
					],
					"name": "Hallidays Point Public School",
					"playspace": 97.85,
					"projections": [
						215,
						243,
						260,
						240,
						235,
						225
					],
					"projections_orig": [
						"215",
						"243",
						"260",
						"240",
						"235",
						"225"
					],
					"projections_percentage": [
						-11.52,
						0,
						7,
						-1.23,
						-3.29,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4611
				}
			],
			"uid": 30069
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 81
			},
			"enrolment": 2250,
			"level": "Combined",
			"ligo": 0.93,
			"name": "Hastings",
			"playspace": 270.36,
			"projections": [
				2250,
				2430,
				2420,
				2330,
				2230
			],
			"projections_percentage": [
				0,
				8,
				7.56,
				3.56,
				-0.89
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 5
					},
					"classroomspace": 2.74,
					"enrolment": 140,
					"ligo": 1,
					"location": [
						152.680253217495,
						-31.4363505554266
					],
					"name": "Beechwood Public School",
					"playspace": 118.19,
					"projections": [
						141,
						140,
						140,
						140,
						140,
						140
					],
					"projections_orig": [
						"141",
						"140",
						"140",
						"140",
						"140",
						"140"
					],
					"projections_percentage": [
						0.71,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1165
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.41,
					"enrolment": 28,
					"ligo": 1,
					"location": [
						152.472347389542,
						-31.6056742086577
					],
					"name": "Comboyne Public School",
					"playspace": 675.05,
					"projections": [
						26,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-7.14,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1601
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.33,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						152.730643725237,
						-31.5808497012296
					],
					"name": "Herons Creek Public School",
					"playspace": 87.61,
					"projections": [
						40,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"40",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						5.26,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2157
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.49,
					"enrolment": 57,
					"ligo": 1,
					"location": [
						152.66061840272,
						-31.4780038848408
					],
					"name": "Huntingdon Public School",
					"playspace": 585.72,
					"projections": [
						47,
						57,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"47",
						"57",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						-17.54,
						0,
						-3.51,
						-3.51,
						-3.51,
						-3.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2190
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 4.18,
					"enrolment": 204,
					"ligo": 1,
					"location": [
						152.70039540974,
						-31.627516838426
					],
					"name": "Kendall Public School",
					"playspace": 311.57,
					"projections": [
						202,
						204,
						200,
						200,
						195,
						190
					],
					"projections_orig": [
						"202",
						"204",
						"200",
						"200",
						"195",
						"190"
					],
					"projections_percentage": [
						-0.98,
						0,
						-1.96,
						-1.96,
						-4.41,
						-6.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2280
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.58,
					"enrolment": 203,
					"ligo": 0.86,
					"location": [
						152.796914895151,
						-31.65180480839
					],
					"name": "Laurieton Public School",
					"playspace": 28.49,
					"projections": [
						214,
						203,
						205,
						205,
						200,
						195
					],
					"projections_orig": [
						"214",
						"203",
						"205",
						"205",
						"200",
						"195"
					],
					"projections_percentage": [
						5.42,
						0,
						0.99,
						0.99,
						-1.48,
						-3.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2377
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.36,
					"enrolment": 44,
					"ligo": 1,
					"location": [
						152.486961582381,
						-31.4376395994676
					],
					"name": "Long Flat Public School",
					"playspace": 375.46,
					"projections": [
						31,
						44,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"44",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-29.55,
						0,
						-43.18,
						-43.18,
						-43.18,
						-43.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2423
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.88,
					"enrolment": 25,
					"ligo": 1,
					"location": [
						152.631409750208,
						-31.2388690384102
					],
					"name": "Rollands Plains Upper Public School",
					"playspace": 512.76,
					"projections": [
						28,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						12,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2985
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.63,
					"enrolment": 105,
					"ligo": 1,
					"location": [
						152.794237294311,
						-31.333898447091
					],
					"name": "Telegraph Point Public School",
					"playspace": 152.53,
					"projections": [
						97,
						105,
						100,
						100,
						95,
						95
					],
					"projections_orig": [
						"97",
						"105",
						"100",
						"100",
						"95",
						"95"
					],
					"projections_percentage": [
						-7.62,
						0,
						-4.76,
						-4.76,
						-9.52,
						-9.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3176
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 10
					},
					"classroomspace": 2.89,
					"enrolment": 264,
					"ligo": 0.49,
					"location": [
						152.821437413353,
						-31.6348529553698
					],
					"name": "North Haven Public School",
					"playspace": 77.45,
					"projections": [
						370,
						264,
						370,
						350,
						330,
						320
					],
					"projections_orig": [
						"370",
						"264",
						"370",
						"350",
						"330",
						"320"
					],
					"projections_percentage": [
						40.15,
						0,
						40.15,
						32.58,
						25,
						21.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4149
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 35
					},
					"classroomspace": 2.41,
					"enrolment": 1142,
					"ligo": 0.89,
					"location": [
						152.735653091268,
						-31.6394864403356
					],
					"name": "Camden Haven High School",
					"playspace": 49.12,
					"projections": [
						1093,
						1142,
						1225,
						1235,
						1180,
						1100
					],
					"projections_orig": [
						"1093",
						"1142",
						"1225",
						"1235",
						"1180",
						"1100"
					],
					"projections_percentage": [
						-4.29,
						0,
						7.27,
						8.14,
						3.33,
						-3.68
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8280
				}
			],
			"uid": 30070
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 143
			},
			"enrolment": 2211,
			"level": "Combined",
			"ligo": 0.83,
			"name": "Kempsey",
			"playspace": 81.53,
			"projections": [
				2211,
				2491,
				2526,
				2431,
				2326
			],
			"projections_percentage": [
				0,
				12.66,
				14.25,
				9.95,
				5.2
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.62,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						152.802543122589,
						-31.0594556878004
					],
					"name": "Green Hill Public School",
					"playspace": 153.97,
					"projections": [
						45,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"45",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						73.08,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2071
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.35,
					"enrolment": 222,
					"ligo": 0.6,
					"location": [
						152.846670916257,
						-31.0833187163617
					],
					"name": "Kempsey East Public School",
					"playspace": 39.64,
					"projections": [
						248,
						222,
						225,
						230,
						225,
						220
					],
					"projections_orig": [
						"248",
						"222",
						"225",
						"230",
						"225",
						"220"
					],
					"projections_percentage": [
						11.71,
						0,
						1.35,
						3.6,
						1.35,
						-0.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2278
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 24
					},
					"classroomspace": 4.17,
					"enrolment": 350,
					"ligo": 0.82,
					"location": [
						152.829529621091,
						-31.0777881430211
					],
					"name": "Kempsey West Public School",
					"playspace": 56.53,
					"projections": [
						341,
						350,
						410,
						400,
						365,
						350
					],
					"projections_orig": [
						"341",
						"350",
						"410",
						"400",
						"365",
						"350"
					],
					"projections_percentage": [
						-2.57,
						0,
						17.14,
						14.29,
						4.29,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2279
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 4.76,
					"enrolment": 143,
					"ligo": 0.85,
					"location": [
						152.828842755435,
						-31.0947181116452
					],
					"name": "Kempsey South Public School",
					"playspace": 154.54,
					"projections": [
						130,
						143,
						125,
						125,
						125,
						125
					],
					"projections_orig": [
						"130",
						"143",
						"125",
						"125",
						"125",
						"125"
					],
					"projections_percentage": [
						-9.09,
						0,
						-12.59,
						-12.59,
						-12.59,
						-12.59
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4196
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 11
					},
					"classroomspace": 2.28,
					"enrolment": 321,
					"ligo": 1,
					"location": [
						152.787356378056,
						-31.0545970395402
					],
					"name": "Aldavilla Public School",
					"playspace": 70.02,
					"projections": [
						253,
						321,
						320,
						300,
						290,
						280
					],
					"projections_orig": [
						"253",
						"321",
						"320",
						"300",
						"290",
						"280"
					],
					"projections_percentage": [
						-21.18,
						0,
						-0.31,
						-6.54,
						-9.66,
						-12.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4601
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 44
					},
					"classroomspace": 5.44,
					"enrolment": 469,
					"ligo": 0.86,
					"location": [
						152.825243238773,
						-31.0688867586906
					],
					"name": "Kempsey High School",
					"playspace": 59.39,
					"projections": [
						518,
						469,
						505,
						530,
						505,
						485
					],
					"projections_orig": [
						"518",
						"469",
						"505",
						"530",
						"505",
						"485"
					],
					"projections_percentage": [
						10.45,
						0,
						7.68,
						13.01,
						7.68,
						3.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8123
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 44
					},
					"classroomspace": 4.72,
					"enrolment": 680,
					"ligo": 0.68,
					"location": [
						152.824499958701,
						-31.0904247775374
					],
					"name": "Melville High School",
					"playspace": 36.62,
					"projections": [
						940,
						680,
						880,
						915,
						895,
						840
					],
					"projections_orig": [
						"940",
						"680",
						"880",
						"915",
						"895",
						"840"
					],
					"projections_percentage": [
						38.24,
						0,
						29.41,
						34.56,
						31.62,
						23.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8566
				}
			],
			"uid": 30071
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 107
			},
			"enrolment": 1271,
			"level": "Combined",
			"ligo": 0.98,
			"name": "Kyogle",
			"playspace": 480.02,
			"projections": [
				1271,
				1448,
				1448,
				1383,
				1343
			],
			"projections_percentage": [
				0,
				13.93,
				13.93,
				8.81,
				5.66
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.44,
					"enrolment": 55,
					"ligo": 1,
					"location": [
						153.149057271369,
						-28.5508858926735
					],
					"name": "Barkers Vale Public School",
					"playspace": 663.76,
					"projections": [
						66,
						55,
						60,
						60,
						60,
						60
					],
					"projections_orig": [
						"66",
						"55",
						"60",
						"60",
						"60",
						"60"
					],
					"projections_percentage": [
						20,
						0,
						9.09,
						9.09,
						9.09,
						9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1136
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 8.39,
					"enrolment": 126,
					"ligo": 0.97,
					"location": [
						152.623980666612,
						-28.7357637755539
					],
					"name": "Bonalbo Central School",
					"playspace": 168.91,
					"projections": [
						185,
						126,
						145,
						145,
						145,
						145
					],
					"projections_orig": [
						"185",
						"126",
						"145",
						"145",
						"145",
						"145"
					],
					"projections_percentage": [
						46.83,
						0,
						15.08,
						15.08,
						15.08,
						15.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1290
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.26,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						153.022570154089,
						-28.4889278887629
					],
					"name": "Collins Creek Public School",
					"playspace": 489.58,
					"projections": [
						15,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						7.14,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1593
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.08,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						152.875543128889,
						-28.7246700919684
					],
					"name": "Doubtful Creek Public School",
					"playspace": 414.15,
					"projections": [
						9,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"9",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-43.75,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1769
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.99,
					"enrolment": 295,
					"ligo": 1,
					"location": [
						153.003984298776,
						-28.624873328604
					],
					"name": "Kyogle Public School",
					"playspace": 47.82,
					"projections": [
						294,
						295,
						380,
						360,
						335,
						330
					],
					"projections_orig": [
						"294",
						"295",
						"380",
						"360",
						"335",
						"330"
					],
					"projections_percentage": [
						-0.34,
						0,
						28.81,
						22.03,
						13.56,
						11.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2349
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.03,
					"enrolment": 25,
					"ligo": 1,
					"location": [
						152.801003586722,
						-28.8480496865866
					],
					"name": "Mummulgum Public School",
					"playspace": 681.59,
					"projections": [
						20,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-20,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2671
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.07,
					"enrolment": 21,
					"ligo": 1,
					"location": [
						152.597089395027,
						-28.6541324569092
					],
					"name": "Old Bonalbo Public School",
					"playspace": 458.55,
					"projections": [
						19,
						21,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"21",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-9.52,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2800
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.4,
					"enrolment": 31,
					"ligo": 1,
					"location": [
						152.933260091923,
						-28.4764027908947
					],
					"name": "The Risk Public School",
					"playspace": 422.03,
					"projections": [
						29,
						31,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"31",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.45,
						0,
						-19.35,
						-19.35,
						-19.35,
						-19.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2968
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 11.48,
					"enrolment": 9,
					"ligo": 1,
					"location": [
						152.893956812912,
						-28.4683529968059
					],
					"name": "Rukenvale Public School",
					"playspace": 1238.81,
					"projections": [
						23,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						155.56,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3013
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.51,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						152.936909457291,
						-28.7556528946666
					],
					"name": "Stratheden Public School",
					"playspace": 271.44,
					"projections": [
						33,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						43.48,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3122
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.88,
					"enrolment": 49,
					"ligo": 1,
					"location": [
						152.568113259663,
						-28.8884806117029
					],
					"name": "Tabulam Public School",
					"playspace": 276.38,
					"projections": [
						58,
						49,
						60,
						60,
						55,
						55
					],
					"projections_orig": [
						"58",
						"49",
						"60",
						"60",
						"55",
						"55"
					],
					"projections_percentage": [
						18.37,
						0,
						22.45,
						22.45,
						12.24,
						12.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3145
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 13.22,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						152.546726033472,
						-28.4738846537081
					],
					"name": "Urbenville Public School",
					"playspace": 1742.99,
					"projections": [
						23,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"23",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						64.29,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3316
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.28,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						152.964445352043,
						-28.5114277169669
					],
					"name": "Wiangaree Public School",
					"playspace": 560.48,
					"projections": [
						15,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-44.44,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3439
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 5.98,
					"enrolment": 178,
					"ligo": 0.81,
					"location": [
						152.609674779457,
						-28.3892421597539
					],
					"name": "Woodenbong Central School",
					"playspace": 158.16,
					"projections": [
						214,
						178,
						190,
						190,
						180,
						180
					],
					"projections_orig": [
						"214",
						"178",
						"190",
						"190",
						"180",
						"180"
					],
					"projections_percentage": [
						20.22,
						0,
						6.74,
						6.74,
						1.12,
						1.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3491
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 4.22,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						152.817616204166,
						-28.5820707960685
					],
					"name": "Afterlee Public School",
					"playspace": 31.44,
					"projections": [
						13,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-27.78,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3640
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 27
					},
					"classroomspace": 4.34,
					"enrolment": 370,
					"ligo": 0.86,
					"location": [
						153.000320047723,
						-28.6261077254842
					],
					"name": "Kyogle High School",
					"playspace": 54.17,
					"projections": [
						421,
						370,
						415,
						435,
						410,
						375
					],
					"projections_orig": [
						"421",
						"370",
						"415",
						"435",
						"410",
						"375"
					],
					"projections_percentage": [
						13.78,
						0,
						12.16,
						17.57,
						10.81,
						1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8189
				}
			],
			"uid": 30072
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 242
			},
			"enrolment": 3537,
			"level": "Combined",
			"ligo": 0.68,
			"name": "Lismore",
			"playspace": 104.48,
			"projections": [
				3537,
				3879,
				4004,
				3944,
				3824
			],
			"projections_percentage": [
				0,
				9.67,
				13.2,
				11.51,
				8.11
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 3.82,
					"enrolment": 78,
					"ligo": 0.6,
					"location": [
						153.231133187365,
						-28.8305102163095
					],
					"name": "Caniaba Public School",
					"playspace": 159.24,
					"projections": [
						59,
						78,
						80,
						80,
						80,
						75
					],
					"projections_orig": [
						"59",
						"78",
						"80",
						"80",
						"80",
						"75"
					],
					"projections_percentage": [
						-24.36,
						0,
						2.56,
						2.56,
						2.56,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1492
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 5.2,
					"enrolment": 87,
					"ligo": 1,
					"location": [
						153.282396278641,
						-28.9922994363894
					],
					"name": "Coraki Public School",
					"playspace": 62.99,
					"projections": [
						113,
						87,
						100,
						100,
						100,
						100
					],
					"projections_orig": [
						"113",
						"87",
						"100",
						"100",
						"100",
						"100"
					],
					"projections_percentage": [
						29.89,
						0,
						14.94,
						14.94,
						14.94,
						14.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1644
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 25
					},
					"classroomspace": 3.72,
					"enrolment": 338,
					"ligo": 0.53,
					"location": [
						153.291596717412,
						-28.8139811952973
					],
					"name": "Lismore Public School",
					"playspace": 51.07,
					"projections": [
						332,
						338,
						390,
						395,
						385,
						385
					],
					"projections_orig": [
						"332",
						"338",
						"390",
						"395",
						"385",
						"385"
					],
					"projections_percentage": [
						-1.78,
						0,
						15.38,
						16.86,
						13.91,
						13.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1780
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.98,
					"enrolment": 255,
					"ligo": 0.79,
					"location": [
						153.323163372489,
						-28.8189768069588
					],
					"name": "Goonellabah Public School",
					"playspace": 72.49,
					"projections": [
						207,
						255,
						270,
						275,
						275,
						275
					],
					"projections_orig": [
						"207",
						"255",
						"270",
						"275",
						"275",
						"275"
					],
					"projections_percentage": [
						-18.82,
						0,
						5.88,
						7.84,
						7.84,
						7.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2041
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 2.81,
					"enrolment": 240,
					"ligo": 0.63,
					"location": [
						153.261545516621,
						-28.8092921856462
					],
					"name": "Lismore South Public School",
					"playspace": 64.85,
					"projections": [
						240,
						240,
						230,
						235,
						235,
						235
					],
					"projections_orig": [
						"240",
						"240",
						"230",
						"235",
						"235",
						"235"
					],
					"projections_percentage": [
						0,
						0,
						-4.17,
						-2.08,
						-2.08,
						-2.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2409
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.66,
					"enrolment": 24,
					"ligo": 1,
					"location": [
						153.305760105175,
						-28.8908851909161
					],
					"name": "Wyrallah Public School",
					"playspace": 272.76,
					"projections": [
						19,
						24,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"24",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-20.83,
						0,
						4.17,
						4.17,
						4.17,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3529
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 18
					},
					"classroomspace": 2.4,
					"enrolment": 529,
					"ligo": 0.43,
					"location": [
						153.293093318021,
						-28.8300379640585
					],
					"name": "Wyrallah Road Public School",
					"playspace": 64.95,
					"projections": [
						491,
						529,
						560,
						560,
						535,
						530
					],
					"projections_orig": [
						"491",
						"529",
						"560",
						"560",
						"535",
						"530"
					],
					"projections_percentage": [
						-7.18,
						0,
						5.86,
						5.86,
						1.13,
						0.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3856
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.93,
					"enrolment": 223,
					"ligo": 0.56,
					"location": [
						153.301145941911,
						-28.8069008395779
					],
					"name": "Lismore Heights Public School",
					"playspace": 67.17,
					"projections": [
						241,
						223,
						240,
						245,
						250,
						250
					],
					"projections_orig": [
						"241",
						"223",
						"240",
						"245",
						"250",
						"250"
					],
					"projections_percentage": [
						8.07,
						0,
						7.62,
						9.87,
						12.11,
						12.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4085
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 7.01,
					"enrolment": 73,
					"ligo": 0.53,
					"location": [
						153.271801429361,
						-28.8207024963378
					],
					"name": "Albert Park Public School",
					"playspace": 231.75,
					"projections": [
						52,
						73,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"52",
						"73",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						-28.77,
						0,
						-24.66,
						-24.66,
						-24.66,
						-24.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4177
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 48
					},
					"classroomspace": 8.52,
					"enrolment": 375,
					"ligo": 0.72,
					"location": [
						153.295356700568,
						-28.8217300055923
					],
					"name": "The Rivers Secondary College, Lismore High Campus",
					"playspace": 121.01,
					"projections": [
						0,
						375,
						425,
						450,
						435,
						410
					],
					"projections_orig": [
						"0",
						"375",
						"425",
						"450",
						"435",
						"410"
					],
					"projections_percentage": [
						-100,
						0,
						13.33,
						20,
						16,
						9.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8124
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 42
					},
					"classroomspace": 3.49,
					"enrolment": 811,
					"ligo": 0.62,
					"location": [
						153.278294198478,
						-28.7992664490217
					],
					"name": "The Rivers Secondary College, Richmond River High Campus",
					"playspace": 26.94,
					"projections": [
						0,
						811,
						950,
						990,
						980,
						930
					],
					"projections_orig": [
						"0",
						"811",
						"950",
						"990",
						"980",
						"930"
					],
					"projections_percentage": [
						-100,
						0,
						17.14,
						22.07,
						20.84,
						14.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8214
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 41
					},
					"classroomspace": 5.19,
					"enrolment": 504,
					"ligo": 0.69,
					"location": [
						153.338214119347,
						-28.8170696998836
					],
					"name": "The Rivers Secondary College, Kadina High Campus",
					"playspace": 58.5,
					"projections": [
						0,
						504,
						555,
						595,
						590,
						555
					],
					"projections_orig": [
						"0",
						"504",
						"555",
						"595",
						"590",
						"555"
					],
					"projections_percentage": [
						-100,
						0,
						10.12,
						18.06,
						17.06,
						10.12
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8520
				}
			],
			"uid": 30073
		},
		{
			"classrooms": {
				"demountable": 5,
				"permanent": 45
			},
			"enrolment": 905,
			"level": "Combined",
			"ligo": 1,
			"name": "Macleay",
			"playspace": 161.44,
			"projections": [
				905,
				1004,
				1029,
				1024,
				1029
			],
			"projections_percentage": [
				0,
				10.94,
				13.7,
				13.15,
				13.7
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.17,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						152.50854374498,
						-30.8188089290674
					],
					"name": "Bellbrook Public School",
					"playspace": 203.69,
					"projections": [
						40,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"40",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1178
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 7
					},
					"classroomspace": 2.77,
					"enrolment": 178,
					"ligo": 1,
					"location": [
						152.971183811439,
						-31.1876643869652
					],
					"name": "Crescent Head Public School",
					"playspace": 15.4,
					"projections": [
						174,
						178,
						180,
						195,
						205,
						210
					],
					"projections_orig": [
						"174",
						"178",
						"180",
						"195",
						"205",
						"210"
					],
					"projections_percentage": [
						-2.25,
						0,
						1.12,
						9.55,
						15.17,
						17.98
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1681
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 8
					},
					"classroomspace": 3.25,
					"enrolment": 155,
					"ligo": 1,
					"location": [
						152.879292612713,
						-31.0345084186134
					],
					"name": "Frederickton Public School",
					"playspace": 114.27,
					"projections": [
						181,
						155,
						160,
						165,
						165,
						165
					],
					"projections_orig": [
						"181",
						"155",
						"160",
						"165",
						"165",
						"165"
					],
					"projections_percentage": [
						16.77,
						0,
						3.23,
						6.45,
						6.45,
						6.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1943
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.19,
					"enrolment": 50,
					"ligo": 1,
					"location": [
						152.945989707692,
						-31.0263699373113
					],
					"name": "Gladstone Public School",
					"playspace": 98.1,
					"projections": [
						39,
						50,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"50",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22,
						0,
						-50,
						-50,
						-50,
						-50
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1991
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 7.39,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						152.994309040276,
						-30.9909509957185
					],
					"name": "Kinchela Public School",
					"playspace": 438.13,
					"projections": [
						28,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						3.7,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2303
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						152.635781141336,
						-30.8624732180884
					],
					"name": "Millbank Public School",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2553
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 5.29,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						152.941267774105,
						-31.0174333552852
					],
					"name": "Smithtown Public School",
					"playspace": 150,
					"projections": [
						65,
						61,
						80,
						85,
						90,
						95
					],
					"projections_orig": [
						"65",
						"61",
						"80",
						"85",
						"90",
						"95"
					],
					"projections_percentage": [
						6.56,
						0,
						31.15,
						39.34,
						47.54,
						55.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3075
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 8
					},
					"classroomspace": 2.56,
					"enrolment": 303,
					"ligo": 1,
					"location": [
						153.039092680345,
						-30.8912257027434
					],
					"name": "South West Rocks Public School",
					"playspace": 13.65,
					"projections": [
						328,
						303,
						360,
						355,
						330,
						320
					],
					"projections_orig": [
						"328",
						"303",
						"360",
						"355",
						"330",
						"320"
					],
					"projections_percentage": [
						8.25,
						0,
						18.81,
						17.16,
						8.91,
						5.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3083
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4,
					"enrolment": 43,
					"ligo": 1,
					"location": [
						152.625087257642,
						-30.9261877192086
					],
					"name": "Willawarrin Public School",
					"playspace": 148.94,
					"projections": [
						45,
						43,
						50,
						50,
						55,
						55
					],
					"projections_orig": [
						"45",
						"43",
						"50",
						"50",
						"55",
						"55"
					],
					"projections_percentage": [
						4.65,
						0,
						16.28,
						16.28,
						27.91,
						27.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3445
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 4.96,
					"enrolment": 56,
					"ligo": 1,
					"location": [
						152.992939439664,
						-30.819720635783
					],
					"name": "Stuarts Point Public School",
					"playspace": 270.8,
					"projections": [
						62,
						56,
						65,
						70,
						70,
						75
					],
					"projections_orig": [
						"62",
						"56",
						"65",
						"70",
						"70",
						"75"
					],
					"projections_percentage": [
						10.71,
						0,
						16.07,
						25,
						25,
						33.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3643
				}
			],
			"uid": 30074
		},
		{
			"classrooms": {
				"demountable": 15,
				"permanent": 84
			},
			"enrolment": 1763,
			"level": "Combined",
			"ligo": 0.8,
			"name": "Mullumbimby",
			"playspace": 162.41,
			"projections": [
				1763,
				1957,
				2007,
				2032,
				2032
			],
			"projections_percentage": [
				0,
				11,
				13.84,
				15.26,
				15.26
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 12
					},
					"classroomspace": 2.66,
					"enrolment": 359,
					"ligo": 0.62,
					"location": [
						153.541246754968,
						-28.4907842097361
					],
					"name": "Ocean Shores Public School",
					"playspace": 32.39,
					"projections": [
						346,
						359,
						430,
						415,
						420,
						425
					],
					"projections_orig": [
						"346",
						"359",
						"430",
						"415",
						"420",
						"425"
					],
					"projections_percentage": [
						-3.62,
						0,
						19.78,
						15.6,
						16.99,
						18.38
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1227
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.26,
					"enrolment": 170,
					"ligo": 0.58,
					"location": [
						153.550944618295,
						-28.5407489204601
					],
					"name": "Brunswick Heads Public School",
					"playspace": 35.37,
					"projections": [
						176,
						170,
						160,
						170,
						175,
						180
					],
					"projections_orig": [
						"176",
						"170",
						"160",
						"170",
						"175",
						"180"
					],
					"projections_percentage": [
						3.53,
						0,
						-5.88,
						0,
						2.94,
						5.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1389
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 2
					},
					"classroomspace": 3.12,
					"enrolment": 135,
					"ligo": 0.3,
					"location": [
						153.4878090368,
						-28.6257850267652
					],
					"name": "Coorabell Public School",
					"playspace": 59.08,
					"projections": [
						110,
						135,
						130,
						130,
						130,
						130
					],
					"projections_orig": [
						"110",
						"135",
						"130",
						"130",
						"130",
						"130"
					],
					"projections_percentage": [
						-18.52,
						0,
						-3.7,
						-3.7,
						-3.7,
						-3.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1634
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.15,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						153.445119379674,
						-28.5231653915532
					],
					"name": "Durrumbul Public School",
					"playspace": 783.87,
					"projections": [
						89,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"89",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						178.12,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1803
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.68,
					"enrolment": 35,
					"ligo": 0.77,
					"location": [
						153.43973713168,
						-28.6095031426567
					],
					"name": "Goonengerry Public School",
					"playspace": 187.41,
					"projections": [
						29,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-17.14,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2042
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3.54,
					"enrolment": 189,
					"ligo": 0.83,
					"location": [
						153.504889889698,
						-28.5524452291741
					],
					"name": "Mullumbimby Public School",
					"playspace": 123.54,
					"projections": [
						240,
						189,
						240,
						235,
						240,
						245
					],
					"projections_orig": [
						"240",
						"189",
						"240",
						"235",
						"240",
						"245"
					],
					"projections_percentage": [
						26.98,
						0,
						26.98,
						24.34,
						26.98,
						29.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2665
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.36,
					"enrolment": 58,
					"ligo": 1,
					"location": [
						153.479198329313,
						-28.5050434025133
					],
					"name": "The Pocket Public School",
					"playspace": 106.93,
					"projections": [
						62,
						58,
						55,
						60,
						60,
						65
					],
					"projections_orig": [
						"62",
						"58",
						"55",
						"60",
						"60",
						"65"
					],
					"projections_percentage": [
						6.9,
						0,
						-5.17,
						3.45,
						3.45,
						12.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2890
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 1
					},
					"classroomspace": 3.76,
					"enrolment": 106,
					"ligo": 1,
					"location": [
						153.412598444654,
						-28.4983757491755
					],
					"name": "Main Arm Upper Public School",
					"playspace": 103.7,
					"projections": [
						80,
						106,
						110,
						115,
						120,
						120
					],
					"projections_orig": [
						"80",
						"106",
						"110",
						"115",
						"120",
						"120"
					],
					"projections_percentage": [
						-24.53,
						0,
						3.77,
						8.49,
						13.21,
						13.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3236
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 4.07,
					"enrolment": 53,
					"ligo": 1,
					"location": [
						153.425858689291,
						-28.5715998766882
					],
					"name": "Wilsons Creek Public School",
					"playspace": 157.81,
					"projections": [
						61,
						53,
						55,
						60,
						60,
						65
					],
					"projections_orig": [
						"61",
						"53",
						"55",
						"60",
						"60",
						"65"
					],
					"projections_percentage": [
						15.09,
						0,
						3.77,
						13.21,
						13.21,
						22.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3454
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 43
					},
					"classroomspace": 4.13,
					"enrolment": 626,
					"ligo": 0.87,
					"location": [
						153.494980907017,
						-28.5589681802827
					],
					"name": "Mullumbimby High School",
					"playspace": 33.98,
					"projections": [
						686,
						626,
						710,
						755,
						760,
						735
					],
					"projections_orig": [
						"686",
						"626",
						"710",
						"755",
						"760",
						"735"
					],
					"projections_percentage": [
						9.58,
						0,
						13.42,
						20.61,
						21.41,
						17.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8193
				}
			],
			"uid": 30076
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 161
			},
			"enrolment": 2079,
			"level": "Combined",
			"ligo": 0.87,
			"name": "Murwillumbah",
			"playspace": 145.2,
			"projections": [
				2079,
				2423,
				2523,
				2543,
				2543
			],
			"projections_percentage": [
				0,
				16.55,
				21.36,
				22.32,
				22.32
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.81,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						153.275034982926,
						-28.3120352804755
					],
					"name": "Chillingham Public School",
					"playspace": 108.79,
					"projections": [
						38,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						8.57,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1558
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.88,
					"enrolment": 56,
					"ligo": 1,
					"location": [
						153.434644519518,
						-28.3098109608209
					],
					"name": "Condong Public School",
					"playspace": 44.05,
					"projections": [
						60,
						56,
						70,
						75,
						75,
						80
					],
					"projections_orig": [
						"60",
						"56",
						"70",
						"75",
						"75",
						"80"
					],
					"projections_percentage": [
						7.14,
						0,
						25,
						33.93,
						33.93,
						42.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1611
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.18,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						153.496559241371,
						-28.456307611751
					],
					"name": "Crabbes Creek Public School",
					"playspace": 76.33,
					"projections": [
						34,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"34",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10.53,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1674
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.66,
					"enrolment": 85,
					"ligo": 1,
					"location": [
						153.326205694933,
						-28.3116785355297
					],
					"name": "Crystal Creek Public School",
					"playspace": 108.21,
					"projections": [
						78,
						85,
						85,
						90,
						90,
						95
					],
					"projections_orig": [
						"78",
						"85",
						"85",
						"90",
						"90",
						"95"
					],
					"projections_percentage": [
						-8.24,
						0,
						0,
						5.88,
						5.88,
						11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1690
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.5,
					"enrolment": 53,
					"ligo": 1,
					"location": [
						153.382242939687,
						-28.2885933236657
					],
					"name": "Dungay Public School",
					"playspace": 183.73,
					"projections": [
						58,
						53,
						60,
						65,
						65,
						70
					],
					"projections_orig": [
						"58",
						"53",
						"60",
						"65",
						"65",
						"70"
					],
					"projections_percentage": [
						9.43,
						0,
						13.21,
						22.64,
						22.64,
						32.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1791
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 2.76,
					"enrolment": 301,
					"ligo": 0.88,
					"location": [
						153.391542094593,
						-28.3299688402209
					],
					"name": "Murwillumbah Public School",
					"playspace": 17.43,
					"projections": [
						248,
						301,
						310,
						310,
						320,
						325
					],
					"projections_orig": [
						"248",
						"301",
						"310",
						"310",
						"320",
						"325"
					],
					"projections_percentage": [
						-17.61,
						0,
						2.99,
						2.99,
						6.31,
						7.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2687
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.78,
					"enrolment": 34,
					"ligo": 1,
					"location": [
						153.403964212169,
						-28.3944885832877
					],
					"name": "Stokers Siding Public School",
					"playspace": 221.08,
					"projections": [
						59,
						34,
						55,
						55,
						60,
						60
					],
					"projections_orig": [
						"59",
						"34",
						"55",
						"55",
						"60",
						"60"
					],
					"projections_percentage": [
						73.53,
						0,
						61.76,
						61.76,
						76.47,
						76.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3112
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.51,
					"enrolment": 20,
					"ligo": 0.57,
					"location": [
						153.462790135716,
						-28.2740291087932
					],
					"name": "Tumbulgum Public School",
					"playspace": 502.81,
					"projections": [
						41,
						20,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"41",
						"20",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						105,
						0,
						25,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3277
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.98,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						153.204771533992,
						-28.3548470505313
					],
					"name": "Tyalgum Public School",
					"playspace": 114.79,
					"projections": [
						52,
						52,
						50,
						50,
						55,
						55
					],
					"projections_orig": [
						"52",
						"52",
						"50",
						"50",
						"55",
						"55"
					],
					"projections_percentage": [
						0,
						0,
						-3.85,
						-3.85,
						5.77,
						5.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3293
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.49,
					"enrolment": 145,
					"ligo": 1,
					"location": [
						153.335510651799,
						-28.4140382655708
					],
					"name": "Uki Public School",
					"playspace": 176.99,
					"projections": [
						96,
						145,
						150,
						155,
						160,
						160
					],
					"projections_orig": [
						"96",
						"145",
						"150",
						"155",
						"160",
						"160"
					],
					"projections_percentage": [
						-33.79,
						0,
						3.45,
						6.9,
						10.34,
						10.34
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3298
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 12
					},
					"classroomspace": 3.18,
					"enrolment": 301,
					"ligo": 0.56,
					"location": [
						153.405139493864,
						-28.321807873444
					],
					"name": "Murwillumbah East Public School",
					"playspace": 77.02,
					"projections": [
						316,
						301,
						380,
						380,
						380,
						385
					],
					"projections_orig": [
						"316",
						"301",
						"380",
						"380",
						"380",
						"385"
					],
					"projections_percentage": [
						4.98,
						0,
						26.25,
						26.25,
						26.25,
						27.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4101
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 0
					},
					"classroomspace": "NA",
					"enrolment": "NA",
					"ligo": 1,
					"location": [
						153.399551380114,
						-28.3403189066652
					],
					"name": "Murwillumbah South Infants School",
					"playspace": "NA",
					"projections": [],
					"projections_orig": [],
					"projections_percentage": [],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5172
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 62
					},
					"classroomspace": 8.08,
					"enrolment": 485,
					"ligo": 0.65,
					"location": [
						153.391164319268,
						-28.3337139845843
					],
					"name": "Murwillumbah High School",
					"playspace": 120.54,
					"projections": [
						641,
						485,
						630,
						665,
						670,
						650
					],
					"projections_orig": [
						"641",
						"485",
						"630",
						"665",
						"670",
						"650"
					],
					"projections_percentage": [
						32.16,
						0,
						29.9,
						37.11,
						38.14,
						34.02
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8129
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 35
					},
					"classroomspace": 4.95,
					"enrolment": 474,
					"ligo": 0.56,
					"location": [
						153.362774410156,
						-28.3337247513134
					],
					"name": "Wollumbin High School",
					"playspace": 135.77,
					"projections": [
						464,
						474,
						540,
						585,
						575,
						570
					],
					"projections_orig": [
						"464",
						"474",
						"540",
						"585",
						"575",
						"570"
					],
					"projections_percentage": [
						-2.11,
						0,
						13.92,
						23.42,
						21.31,
						20.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8596
				}
			],
			"uid": 30077
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 141
			},
			"enrolment": 2176,
			"level": "Combined",
			"ligo": 0.84,
			"name": "Nambucca",
			"playspace": 212.97,
			"projections": [
				2175,
				2298,
				2228,
				2148,
				2033
			],
			"projections_percentage": [
				0,
				5.66,
				2.44,
				-1.24,
				-6.53
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 18
					},
					"classroomspace": 4.46,
					"enrolment": 229,
					"ligo": 0.65,
					"location": [
						152.853588059558,
						-30.6440736044768
					],
					"name": "Bowraville Central School",
					"playspace": 45.44,
					"projections": [
						235,
						229,
						225,
						215,
						210,
						200
					],
					"projections_orig": [
						"235",
						"229",
						"225",
						"215",
						"210",
						"200"
					],
					"projections_percentage": [
						2.62,
						0,
						-1.75,
						-6.11,
						-8.3,
						-12.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1336
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.26,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						152.875308315404,
						-30.8326652885316
					],
					"name": "Eungai Public School",
					"playspace": 243.42,
					"projections": [
						70,
						52,
						60,
						60,
						55,
						55
					],
					"projections_orig": [
						"70",
						"52",
						"60",
						"60",
						"55",
						"55"
					],
					"projections_percentage": [
						34.62,
						0,
						15.38,
						15.38,
						5.77,
						5.77
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1874
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 11
					},
					"classroomspace": 2.62,
					"enrolment": 374,
					"ligo": 1,
					"location": [
						152.916589868401,
						-30.7088059485
					],
					"name": "Macksville Public School",
					"playspace": 43.12,
					"projections": [
						398,
						374,
						440,
						415,
						390,
						375
					],
					"projections_orig": [
						"398",
						"374",
						"440",
						"415",
						"390",
						"375"
					],
					"projections_percentage": [
						6.42,
						0,
						17.65,
						10.96,
						4.28,
						0.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2444
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 12.76,
					"enrolment": 8,
					"ligo": 1,
					"location": [
						152.690748451235,
						-30.7792049759742
					],
					"name": "Medlow Public School",
					"playspace": 981.95,
					"projections": [
						19,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						137.5,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2511
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 8
					},
					"classroomspace": 2.42,
					"enrolment": 288,
					"ligo": 0.65,
					"location": [
						153.005772284087,
						-30.6417040278649
					],
					"name": "Nambucca Heads Public School",
					"playspace": 52.19,
					"projections": [
						256,
						288,
						280,
						260,
						255,
						245
					],
					"projections_orig": [
						"256",
						"288",
						"280",
						"260",
						"255",
						"245"
					],
					"projections_percentage": [
						-11.11,
						0,
						-2.78,
						-9.72,
						-11.46,
						-14.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2696
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 2
					},
					"classroomspace": 2.74,
					"enrolment": 101,
					"ligo": 1,
					"location": [
						152.995521391047,
						-30.7493018066275
					],
					"name": "Scotts Head Public School",
					"playspace": 177.36,
					"projections": [
						75,
						101,
						100,
						100,
						105,
						105
					],
					"projections_orig": [
						"75",
						"101",
						"100",
						"100",
						"105",
						"105"
					],
					"projections_percentage": [
						-25.74,
						0,
						-0.99,
						-0.99,
						3.96,
						3.96
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3635
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 4.39,
					"enrolment": 219,
					"ligo": 0.7,
					"location": [
						152.984632841184,
						-30.6423527956123
					],
					"name": "Frank Partridge VC Public School",
					"playspace": 103.54,
					"projections": [
						228,
						219,
						215,
						205,
						200,
						190
					],
					"projections_orig": [
						"228",
						"219",
						"215",
						"205",
						"200",
						"190"
					],
					"projections_percentage": [
						4.11,
						0,
						-1.83,
						-6.39,
						-8.68,
						-13.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4581
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 42
					},
					"classroomspace": 4.97,
					"enrolment": 533,
					"ligo": 0.75,
					"location": [
						152.917430248814,
						-30.7140821042249
					],
					"name": "Macksville High School",
					"playspace": 132.34,
					"projections": [
						632,
						533,
						600,
						605,
						580,
						540
					],
					"projections_orig": [
						"632",
						"533",
						"600",
						"605",
						"580",
						"540"
					],
					"projections_percentage": [
						18.57,
						0,
						12.57,
						13.51,
						8.82,
						1.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8162
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 39
					},
					"classroomspace": 6.84,
					"enrolment": 372,
					"ligo": 0.8,
					"location": [
						152.985192635305,
						-30.6405253311969
					],
					"name": "Nambucca Heads High School",
					"playspace": 137.33,
					"projections": [
						473,
						371,
						370,
						360,
						345,
						315
					],
					"projections_orig": [
						"473",
						"371",
						"370",
						"360",
						"345",
						"315"
					],
					"projections_percentage": [
						27.49,
						0,
						-0.27,
						-2.96,
						-7.01,
						-15.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8595
				}
			],
			"uid": 30078
		},
		{
			"classrooms": {
				"demountable": 11,
				"permanent": 115
			},
			"enrolment": 2515,
			"level": "Combined",
			"ligo": 0.9,
			"name": "Orara",
			"playspace": 154.57,
			"projections": [
				2515,
				2686,
				2711,
				2591,
				2506
			],
			"projections_percentage": [
				0,
				6.8,
				7.79,
				3.02,
				-0.36
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 4
					},
					"classroomspace": 2.43,
					"enrolment": 155,
					"ligo": 0.55,
					"location": [
						153.032242859296,
						-30.3795216482822
					],
					"name": "Bonville Public School",
					"playspace": 65.04,
					"projections": [
						100,
						155,
						145,
						145,
						140,
						135
					],
					"projections_orig": [
						"100",
						"155",
						"145",
						"145",
						"140",
						"135"
					],
					"projections_percentage": [
						-35.48,
						0,
						-6.45,
						-6.45,
						-9.68,
						-12.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1297
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.31,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						153.011949677997,
						-30.2209626475831
					],
					"name": "Coramba Public School",
					"playspace": 232.15,
					"projections": [
						56,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"56",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						47.37,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1647
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 6
					},
					"classroomspace": 2.5,
					"enrolment": 195,
					"ligo": 0.85,
					"location": [
						153.193188086367,
						-30.02179690515
					],
					"name": "Corindi Public School",
					"playspace": 92.01,
					"projections": [
						162,
						195,
						200,
						200,
						195,
						190
					],
					"projections_orig": [
						"162",
						"195",
						"200",
						"200",
						"195",
						"190"
					],
					"projections_percentage": [
						-16.92,
						0,
						2.56,
						2.56,
						0,
						-2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1654
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 6.91,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						152.981499601181,
						-30.3660157571455
					],
					"name": "Crossmaglen Public School",
					"playspace": 412.06,
					"projections": [
						16,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"16",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						45.45,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1685
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 2
					},
					"classroomspace": 2.97,
					"enrolment": 113,
					"ligo": 1,
					"location": [
						153.047576057618,
						-30.2525545442646
					],
					"name": "Karangi Public School",
					"playspace": 45.38,
					"projections": [
						80,
						113,
						130,
						130,
						125,
						120
					],
					"projections_orig": [
						"80",
						"113",
						"130",
						"130",
						"125",
						"120"
					],
					"projections_percentage": [
						-29.2,
						0,
						15.04,
						15.04,
						10.62,
						6.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2260
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.91,
					"enrolment": 23,
					"ligo": 1,
					"location": [
						152.899073660679,
						-30.2072886861121
					],
					"name": "Lowanna Public School",
					"playspace": 429.79,
					"projections": [
						26,
						23,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"23",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						13.04,
						0,
						8.7,
						8.7,
						8.7,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2428
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.7,
					"enrolment": 131,
					"ligo": 1,
					"location": [
						153.005518726207,
						-30.1362649628907
					],
					"name": "Nana Glen Public School",
					"playspace": 164.06,
					"projections": [
						83,
						131,
						115,
						115,
						110,
						110
					],
					"projections_orig": [
						"83",
						"131",
						"115",
						"115",
						"110",
						"110"
					],
					"projections_percentage": [
						-36.64,
						0,
						-12.21,
						-12.21,
						-16.03,
						-16.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2698
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.94,
					"enrolment": 37,
					"ligo": 1,
					"location": [
						153.013751069203,
						-30.2893267693071
					],
					"name": "Orara Upper Public School",
					"playspace": 172.99,
					"projections": [
						33,
						37,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"37",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10.81,
						0,
						-32.43,
						-32.43,
						-32.43,
						-32.43
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2814
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.42,
					"enrolment": 22,
					"ligo": 1,
					"location": [
						152.885263406563,
						-30.2429131764234
					],
					"name": "Ulong Public School",
					"playspace": 181.24,
					"projections": [
						25,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						13.64,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3304
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 3.29,
					"enrolment": 359,
					"ligo": 0.77,
					"location": [
						153.196069659256,
						-30.1129993139422
					],
					"name": "Woolgoolga Public School",
					"playspace": 23.66,
					"projections": [
						346,
						359,
						385,
						380,
						345,
						335
					],
					"projections_orig": [
						"346",
						"359",
						"385",
						"380",
						"345",
						"335"
					],
					"projections_percentage": [
						-3.62,
						0,
						7.24,
						5.85,
						-3.9,
						-6.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3503
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 2.81,
					"enrolment": 353,
					"ligo": 0.89,
					"location": [
						153.185087541003,
						-30.1531499123879
					],
					"name": "Sandy Beach Public School",
					"playspace": 130.61,
					"projections": [
						340,
						353,
						410,
						410,
						380,
						380
					],
					"projections_orig": [
						"340",
						"353",
						"410",
						"410",
						"380",
						"380"
					],
					"projections_percentage": [
						-3.68,
						0,
						16.15,
						16.15,
						7.65,
						7.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4557
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.55,
					"enrolment": 215,
					"ligo": 0.71,
					"location": [
						153.189204901129,
						-30.0780885687448
					],
					"name": "Mullaway Public School",
					"playspace": 40.63,
					"projections": [
						165,
						215,
						205,
						205,
						200,
						195
					],
					"projections_orig": [
						"165",
						"215",
						"205",
						"205",
						"200",
						"195"
					],
					"projections_percentage": [
						-23.26,
						0,
						-4.65,
						-4.65,
						-6.98,
						-9.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4606
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 45
					},
					"classroomspace": 3.08,
					"enrolment": 863,
					"ligo": 0.91,
					"location": [
						153.189755442961,
						-30.1005871968602
					],
					"name": "Woolgoolga High School",
					"playspace": 19.84,
					"projections": [
						918,
						863,
						965,
						995,
						965,
						910
					],
					"projections_orig": [
						"918",
						"863",
						"965",
						"995",
						"965",
						"910"
					],
					"projections_percentage": [
						6.37,
						0,
						11.82,
						15.3,
						11.82,
						5.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8548
				}
			],
			"uid": 30080
		},
		{
			"classrooms": {
				"demountable": 36,
				"permanent": 250
			},
			"enrolment": 5107,
			"level": "Combined",
			"ligo": 0.8,
			"name": "Port Macquarie",
			"playspace": 61.46,
			"projections": [
				5106,
				5965,
				6050,
				5920,
				5790
			],
			"projections_percentage": [
				0,
				16.82,
				18.49,
				15.94,
				13.4
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 26
					},
					"classroomspace": 3.34,
					"enrolment": 427,
					"ligo": 0.63,
					"location": [
						152.913250918274,
						-31.4299540681681
					],
					"name": "Port Macquarie Public School",
					"playspace": 36.73,
					"projections": [
						431,
						427,
						540,
						545,
						520,
						520
					],
					"projections_orig": [
						"431",
						"427",
						"540",
						"545",
						"520",
						"520"
					],
					"projections_percentage": [
						0.94,
						0,
						26.46,
						27.63,
						21.78,
						21.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2899
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 25
					},
					"classroomspace": 2.57,
					"enrolment": 730,
					"ligo": 0.95,
					"location": [
						152.729493064254,
						-31.4551400274998
					],
					"name": "Wauchope Public School",
					"playspace": 28.56,
					"projections": [
						686,
						730,
						775,
						780,
						755,
						750
					],
					"projections_orig": [
						"686",
						"730",
						"775",
						"780",
						"755",
						"750"
					],
					"projections_percentage": [
						-6.03,
						0,
						6.16,
						6.85,
						3.42,
						2.74
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3404
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 4.03,
					"enrolment": 320,
					"ligo": 0.82,
					"location": [
						152.891847562862,
						-31.4371488427259
					],
					"name": "Westport Public School",
					"playspace": 61.61,
					"projections": [
						315,
						320,
						375,
						365,
						360,
						360
					],
					"projections_orig": [
						"315",
						"320",
						"375",
						"365",
						"360",
						"360"
					],
					"projections_percentage": [
						-1.56,
						0,
						17.19,
						14.06,
						12.5,
						12.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4411
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 20
					},
					"classroomspace": 2.48,
					"enrolment": 699,
					"ligo": 0.7,
					"location": [
						152.918358087772,
						-31.4539166474465
					],
					"name": "Hastings Public School",
					"playspace": 32.77,
					"projections": [
						536,
						699,
						760,
						765,
						730,
						735
					],
					"projections_orig": [
						"536",
						"699",
						"760",
						"765",
						"730",
						"735"
					],
					"projections_percentage": [
						-23.32,
						0,
						8.73,
						9.44,
						4.43,
						5.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4524
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 24
					},
					"classroomspace": 2.55,
					"enrolment": 730,
					"ligo": 0.73,
					"location": [
						152.926687320341,
						-31.472872714075
					],
					"name": "Tacking Point Public School",
					"playspace": 26.62,
					"projections": [
						745,
						730,
						855,
						860,
						840,
						830
					],
					"projections_orig": [
						"745",
						"730",
						"855",
						"860",
						"840",
						"830"
					],
					"projections_percentage": [
						2.05,
						0,
						17.12,
						17.81,
						15.07,
						13.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4617
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 1
					},
					"classroomspace": 1.65,
					"enrolment": 183,
					"ligo": 1,
					"location": [
						152.913265754462,
						-31.430142157401
					],
					"name": "North East Public School of Distance Education",
					"playspace": "NA",
					"projections": [
						160,
						183,
						240,
						230,
						235,
						235
					],
					"projections_orig": [
						"160",
						"183",
						"240",
						"230",
						"235",
						"235"
					],
					"projections_percentage": [
						-12.57,
						0,
						31.15,
						25.68,
						28.42,
						28.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4643
				},
				{
					"classrooms": {
						"demountable": 10,
						"permanent": 0
					},
					"classroomspace": 2.65,
					"enrolment": 215,
					"ligo": 0.87,
					"location": [
						152.826744188346,
						-31.5683874665493
					],
					"name": "Lake Cathie Public School",
					"playspace": 120.77,
					"projections": [
						0,
						215,
						280,
						265,
						260,
						250
					],
					"projections_orig": [
						"0",
						"215",
						"280",
						"265",
						"260",
						"250"
					],
					"projections_percentage": [
						-100,
						0,
						30.23,
						23.26,
						20.93,
						16.28
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4654
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 39
					},
					"classroomspace": 4.08,
					"enrolment": 621,
					"ligo": 0.9,
					"location": [
						152.731432323118,
						-31.4519853462824
					],
					"name": "Wauchope High School",
					"playspace": 87.76,
					"projections": [
						662,
						621,
						700,
						725,
						715,
						675
					],
					"projections_orig": [
						"662",
						"621",
						"700",
						"725",
						"715",
						"675"
					],
					"projections_percentage": [
						6.6,
						0,
						12.72,
						16.75,
						15.14,
						8.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8173
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 39
					},
					"classroomspace": 3.93,
					"enrolment": 675,
					"ligo": 0.58,
					"location": [
						152.920051980424,
						-31.4339678893898
					],
					"name": "Hastings Secondary College, Port Macquarie Campus",
					"playspace": 36.14,
					"projections": [
						0,
						674,
						820,
						865,
						860,
						820
					],
					"projections_orig": [
						"0",
						"674",
						"820",
						"865",
						"860",
						"820"
					],
					"projections_percentage": [
						-100,
						0,
						21.66,
						28.34,
						27.6,
						21.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8364
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 55
					},
					"classroomspace": 7.4,
					"enrolment": 507,
					"ligo": 0.79,
					"location": [
						152.892975295612,
						-31.4353586916102
					],
					"name": "Hastings Secondary College, Westport Campus",
					"playspace": 122.14,
					"projections": [
						0,
						507,
						620,
						650,
						645,
						615
					],
					"projections_orig": [
						"0",
						"507",
						"620",
						"650",
						"645",
						"615"
					],
					"projections_percentage": [
						-100,
						0,
						22.29,
						28.21,
						27.22,
						21.3
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8554
				}
			],
			"uid": 30081
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 73
			},
			"enrolment": 1051,
			"level": "Combined",
			"ligo": 0.93,
			"name": "Richmond Valley",
			"playspace": 253.32,
			"projections": [
				1051,
				1087,
				1092,
				1092,
				1067
			],
			"projections_percentage": [
				0,
				3.43,
				3.9,
				3.9,
				1.52
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.42,
					"enrolment": 93,
					"ligo": 1,
					"location": [
						153.230024168693,
						-28.7638281969547
					],
					"name": "Blakebrook Public School",
					"playspace": 116.64,
					"projections": [
						98,
						93,
						90,
						90,
						90,
						90
					],
					"projections_orig": [
						"98",
						"93",
						"90",
						"90",
						"90",
						"90"
					],
					"projections_percentage": [
						5.38,
						0,
						-3.23,
						-3.23,
						-3.23,
						-3.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1254
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 4.07,
					"enrolment": 41,
					"ligo": 1,
					"location": [
						153.280291157813,
						-28.6747397827643
					],
					"name": "The Channon Public School",
					"playspace": 7.32,
					"projections": [
						53,
						41,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"53",
						"41",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						29.27,
						0,
						21.95,
						21.95,
						21.95,
						21.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1548
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.89,
					"enrolment": 91,
					"ligo": 1,
					"location": [
						153.410103893878,
						-28.7243593090029
					],
					"name": "Clunes Public School",
					"playspace": 235.76,
					"projections": [
						110,
						91,
						100,
						100,
						100,
						95
					],
					"projections_orig": [
						"110",
						"91",
						"100",
						"100",
						"100",
						"95"
					],
					"projections_percentage": [
						20.88,
						0,
						9.89,
						9.89,
						9.89,
						4.4
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1574
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.14,
					"enrolment": 54,
					"ligo": 1,
					"location": [
						153.220263361456,
						-28.6628594191432
					],
					"name": "Coffee Camp Public School",
					"playspace": 50,
					"projections": [
						92,
						54,
						65,
						65,
						65,
						65
					],
					"projections_orig": [
						"92",
						"54",
						"65",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						70.37,
						0,
						20.37,
						20.37,
						20.37,
						20.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1583
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.91,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						153.362455484748,
						-28.713620651878
					],
					"name": "Corndale Public School",
					"playspace": 658.87,
					"projections": [
						21,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						40,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1656
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.79,
					"enrolment": 90,
					"ligo": 1,
					"location": [
						153.314912700036,
						-28.6867415891686
					],
					"name": "Dunoon Public School",
					"playspace": 190.09,
					"projections": [
						58,
						90,
						85,
						85,
						85,
						80
					],
					"projections_orig": [
						"58",
						"90",
						"85",
						"85",
						"85",
						"80"
					],
					"projections_percentage": [
						-35.56,
						0,
						-5.56,
						-5.56,
						-5.56,
						-11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1797
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.06,
					"enrolment": 55,
					"ligo": 1,
					"location": [
						153.407950025535,
						-28.763687720417
					],
					"name": "Eltham Public School",
					"playspace": 99.96,
					"projections": [
						50,
						55,
						65,
						65,
						65,
						65
					],
					"projections_orig": [
						"50",
						"55",
						"65",
						"65",
						"65",
						"65"
					],
					"projections_percentage": [
						-9.09,
						0,
						18.18,
						18.18,
						18.18,
						18.18
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1835
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 5.68,
					"enrolment": 43,
					"ligo": 0.94,
					"location": [
						153.438791306418,
						-28.6879881068245
					],
					"name": "Eureka Public School",
					"playspace": 250.8,
					"projections": [
						30,
						43,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"43",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-30.23,
						0,
						-41.86,
						-41.86,
						-41.86,
						-41.86
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1879
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.75,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						153.23214492054,
						-28.7097026366102
					],
					"name": "Goolmangar Public School",
					"playspace": 598.05,
					"projections": [
						29,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						61.11,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2037
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.32,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						153.181891231827,
						-28.6783123355951
					],
					"name": "Jiggi Public School",
					"playspace": 156.73,
					"projections": [
						46,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"46",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						53.33,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2235
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.01,
					"enrolment": 30,
					"ligo": 1,
					"location": [
						153.1139961051,
						-28.6486682137637
					],
					"name": "Larnook Public School",
					"playspace": 488.62,
					"projections": [
						42,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"42",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						40,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2375
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.32,
					"enrolment": 83,
					"ligo": 1,
					"location": [
						153.297252857136,
						-28.7298595967507
					],
					"name": "Modanville Public School",
					"playspace": 171.67,
					"projections": [
						105,
						83,
						80,
						80,
						80,
						75
					],
					"projections_orig": [
						"105",
						"83",
						"80",
						"80",
						"80",
						"75"
					],
					"projections_percentage": [
						26.51,
						0,
						-3.61,
						-3.61,
						-3.61,
						-9.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2585
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 7.22,
					"enrolment": 214,
					"ligo": 0.6,
					"location": [
						153.221118126987,
						-28.5955153751125
					],
					"name": "Nimbin Central School",
					"playspace": 306.9,
					"projections": [
						170,
						214,
						210,
						210,
						210,
						205
					],
					"projections_orig": [
						"170",
						"214",
						"210",
						"210",
						"210",
						"205"
					],
					"projections_percentage": [
						-20.56,
						0,
						-1.87,
						-1.87,
						-1.87,
						-4.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2751
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.4,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						153.314810865486,
						-28.6382773595625
					],
					"name": "Whian Whian Public School",
					"playspace": 246.24,
					"projections": [
						18,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						12.5,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2980
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 4.03,
					"enrolment": 42,
					"ligo": 1,
					"location": [
						153.387890128091,
						-28.6779303541129
					],
					"name": "Rosebank Public School",
					"playspace": 196.17,
					"projections": [
						52,
						42,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"52",
						"42",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						23.81,
						0,
						19.05,
						19.05,
						19.05,
						19.05
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2987
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 2.62,
					"enrolment": 111,
					"ligo": 0.28,
					"location": [
						153.354558517816,
						-28.8544926988083
					],
					"name": "Tregeagle Public School",
					"playspace": 62.87,
					"projections": [
						114,
						111,
						115,
						120,
						120,
						115
					],
					"projections_orig": [
						"114",
						"111",
						"115",
						"120",
						"120",
						"115"
					],
					"projections_percentage": [
						2.7,
						0,
						3.6,
						8.11,
						8.11,
						3.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3255
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.14,
					"enrolment": 15,
					"ligo": 1,
					"location": [
						153.266053920836,
						-28.6313238217729
					],
					"name": "Tuntable Creek Public School",
					"playspace": 202.11,
					"projections": [
						13,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-13.33,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3283
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 5.99,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						153.402267143339,
						-28.6074819214642
					],
					"name": "Upper Coopers Creek Public School",
					"playspace": 520.94,
					"projections": [
						13,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						30,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3760
				}
			],
			"uid": 30082
		},
		{
			"classrooms": {
				"demountable": 12,
				"permanent": 240
			},
			"enrolment": 4026,
			"level": "Combined",
			"ligo": 0.76,
			"name": "Taree",
			"playspace": 84.21,
			"projections": [
				4026,
				4410,
				4320,
				4120,
				3880
			],
			"projections_percentage": [
				0,
				9.54,
				7.3,
				2.33,
				-3.63
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.45,
					"enrolment": 313,
					"ligo": 1,
					"location": [
						152.521993826671,
						-31.9004078054616
					],
					"name": "Cundletown Public School",
					"playspace": 34.4,
					"projections": [
						249,
						313,
						330,
						305,
						295,
						285
					],
					"projections_orig": [
						"249",
						"313",
						"330",
						"305",
						"295",
						"285"
					],
					"projections_percentage": [
						-20.45,
						0,
						5.43,
						-2.56,
						-5.75,
						-8.95
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1708
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 11.68,
					"enrolment": 81,
					"ligo": 0.54,
					"location": [
						152.462660754095,
						-31.9105263954364
					],
					"name": "Taree Public School",
					"playspace": 86.12,
					"projections": [
						66,
						81,
						75,
						75,
						70,
						70
					],
					"projections_orig": [
						"66",
						"81",
						"75",
						"75",
						"70",
						"70"
					],
					"projections_percentage": [
						-18.52,
						0,
						-7.41,
						-7.41,
						-13.58,
						-13.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3167
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 6
					},
					"classroomspace": 2.38,
					"enrolment": 187,
					"ligo": 1,
					"location": [
						152.414184858582,
						-31.9333740764323
					],
					"name": "Tinonee Public School",
					"playspace": 93.89,
					"projections": [
						179,
						187,
						180,
						175,
						170,
						165
					],
					"projections_orig": [
						"179",
						"187",
						"180",
						"175",
						"170",
						"165"
					],
					"projections_percentage": [
						-4.28,
						0,
						-3.74,
						-6.42,
						-9.09,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3219
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 14
					},
					"classroomspace": 2.38,
					"enrolment": 518,
					"ligo": 0.74,
					"location": [
						152.445576027058,
						-31.907557431424
					],
					"name": "Taree West Public School",
					"playspace": 34.65,
					"projections": [
						524,
						518,
						570,
						550,
						505,
						490
					],
					"projections_orig": [
						"524",
						"518",
						"570",
						"550",
						"505",
						"490"
					],
					"projections_percentage": [
						1.16,
						0,
						10.04,
						6.18,
						-2.51,
						-5.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3909
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 10
					},
					"classroomspace": 2.33,
					"enrolment": 270,
					"ligo": 0.62,
					"location": [
						152.482557574602,
						-31.8991265192236
					],
					"name": "Chatham Public School",
					"playspace": 51.57,
					"projections": [
						327,
						270,
						305,
						290,
						280,
						275
					],
					"projections_orig": [
						"327",
						"270",
						"305",
						"290",
						"280",
						"275"
					],
					"projections_percentage": [
						21.11,
						0,
						12.96,
						7.41,
						3.7,
						1.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4014
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 21
					},
					"classroomspace": 10.45,
					"enrolment": 112,
					"ligo": 0.8,
					"location": [
						152.46178071538,
						-31.8924342466449
					],
					"name": "Manning Gardens Public School",
					"playspace": 275.43,
					"projections": [
						184,
						112,
						150,
						150,
						145,
						140
					],
					"projections_orig": [
						"184",
						"112",
						"150",
						"150",
						"145",
						"140"
					],
					"projections_percentage": [
						64.29,
						0,
						33.93,
						33.93,
						29.46,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4552
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 2.86,
					"enrolment": 191,
					"ligo": 0.6,
					"location": [
						152.376669570038,
						-31.8695377475036
					],
					"name": "Wingham Brush Public School",
					"playspace": 108.61,
					"projections": [
						226,
						191,
						210,
						210,
						205,
						195
					],
					"projections_orig": [
						"226",
						"191",
						"210",
						"210",
						"205",
						"195"
					],
					"projections_percentage": [
						18.32,
						0,
						9.95,
						9.95,
						7.33,
						2.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4575
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 14
					},
					"classroomspace": 2.57,
					"enrolment": 327,
					"ligo": 0.74,
					"location": [
						152.34995315051,
						-31.8643774376891
					],
					"name": "Wingham Public School",
					"playspace": 87.38,
					"projections": [
						287,
						327,
						360,
						325,
						315,
						305
					],
					"projections_orig": [
						"287",
						"327",
						"360",
						"325",
						"315",
						"305"
					],
					"projections_percentage": [
						-12.23,
						0,
						10.09,
						-0.61,
						-3.67,
						-6.73
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 7314
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 52
					},
					"classroomspace": 3.93,
					"enrolment": 897,
					"ligo": 0.68,
					"location": [
						152.463435544572,
						-31.9097589665286
					],
					"name": "Taree High School",
					"playspace": 14.69,
					"projections": [
						977,
						897,
						950,
						955,
						910,
						835
					],
					"projections_orig": [
						"977",
						"897",
						"950",
						"955",
						"910",
						"835"
					],
					"projections_percentage": [
						8.92,
						0,
						5.91,
						6.47,
						1.45,
						-6.91
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8140
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 32
					},
					"classroomspace": 3.93,
					"enrolment": 540,
					"ligo": 0.79,
					"location": [
						152.380483269516,
						-31.8676992733965
					],
					"name": "Wingham High School",
					"playspace": 60.04,
					"projections": [
						725,
						540,
						645,
						650,
						620,
						565
					],
					"projections_orig": [
						"725",
						"540",
						"645",
						"650",
						"620",
						"565"
					],
					"projections_percentage": [
						34.26,
						0,
						19.44,
						20.37,
						14.81,
						4.63
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8391
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 53
					},
					"classroomspace": 5.69,
					"enrolment": 590,
					"ligo": 0.82,
					"location": [
						152.480050463205,
						-31.8965649928199
					],
					"name": "Chatham High School",
					"playspace": 79.48,
					"projections": [
						672,
						590,
						635,
						635,
						605,
						555
					],
					"projections_orig": [
						"672",
						"590",
						"635",
						"635",
						"605",
						"555"
					],
					"projections_percentage": [
						13.9,
						0,
						7.63,
						7.63,
						2.54,
						-5.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8414
				}
			],
			"uid": 30083
		},
		{
			"classrooms": {
				"demountable": 2,
				"permanent": 11
			},
			"enrolment": 226,
			"level": "Combined",
			"ligo": 1,
			"name": "Clarence Valley",
			"playspace": 482.32,
			"projections": [
				226,
				225,
				225,
				220,
				215
			],
			"projections_percentage": [
				0,
				-0.44,
				-0.44,
				-2.65,
				-4.87
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 18.07,
					"enrolment": 7,
					"ligo": 1,
					"location": [
						152.605226250185,
						-29.2232096952156
					],
					"name": "Baryulgil Public School",
					"playspace": 1845.46,
					"projections": [
						8,
						7,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"8",
						"7",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						14.29,
						0,
						257.14,
						257.14,
						257.14,
						257.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1146
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 2.68,
					"enrolment": 78,
					"ligo": 1,
					"location": [
						152.776239799694,
						-29.5847320906823
					],
					"name": "Copmanhurst Public School",
					"playspace": 130.52,
					"projections": [
						62,
						78,
						75,
						75,
						70,
						70
					],
					"projections_orig": [
						"62",
						"78",
						"75",
						"75",
						"70",
						"70"
					],
					"projections_percentage": [
						-20.51,
						0,
						-3.85,
						-3.85,
						-10.26,
						-10.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1642
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.06,
					"enrolment": 68,
					"ligo": 1,
					"location": [
						152.976922971966,
						-30.0534180958064
					],
					"name": "Glenreagh Public School",
					"playspace": 172.91,
					"projections": [
						91,
						68,
						75,
						75,
						75,
						70
					],
					"projections_orig": [
						"91",
						"68",
						"75",
						"75",
						"75",
						"70"
					],
					"projections_percentage": [
						33.82,
						0,
						10.29,
						10.29,
						10.29,
						2.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2016
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.33,
					"enrolment": 18,
					"ligo": 1,
					"location": [
						152.727959045988,
						-29.9474923913239
					],
					"name": "Nymboida Public School",
					"playspace": 207.12,
					"projections": [
						13,
						18,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"13",
						"18",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-27.78,
						0,
						38.89,
						38.89,
						38.89,
						38.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2784
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.52,
					"enrolment": 55,
					"ligo": 1,
					"location": [
						153.265548486268,
						-29.8707530411929
					],
					"name": "Wooli Public School",
					"playspace": 55.6,
					"projections": [
						37,
						55,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"37",
						"55",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						-32.73,
						0,
						-9.09,
						-9.09,
						-9.09,
						-9.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2841
				}
			],
			"uid": 30085
		},
		{
			"classrooms": {
				"demountable": 0,
				"permanent": 39
			},
			"enrolment": 364,
			"level": "Combined",
			"ligo": 1,
			"name": "Cootamundra Network ST",
			"playspace": 440.65,
			"projections": [
				364,
				363,
				343,
				328,
				318
			],
			"projections_percentage": [
				0,
				-0.27,
				-5.77,
				-9.89,
				-12.64
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 4.13,
					"enrolment": 26,
					"ligo": 1,
					"location": [
						148.625156517092,
						-34.67015103694
					],
					"name": "Binalong Public School",
					"playspace": 388.46,
					"projections": [
						30,
						26,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"26",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						15.38,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1230
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.44,
					"enrolment": 27,
					"ligo": 1,
					"location": [
						148.334975327458,
						-34.819893932492
					],
					"name": "Jugiong Public School",
					"playspace": 180.75,
					"projections": [
						26,
						27,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"27",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-3.7,
						0,
						-7.41,
						-7.41,
						-7.41,
						-7.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2245
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 6.33,
					"enrolment": 151,
					"ligo": 1,
					"location": [
						148.359163203752,
						-34.5518211723202
					],
					"name": "Murrumburrah Public School",
					"playspace": 259.8,
					"projections": [
						146,
						151,
						145,
						135,
						130,
						125
					],
					"projections_orig": [
						"146",
						"151",
						"145",
						"135",
						"130",
						"125"
					],
					"projections_percentage": [
						-3.31,
						0,
						-3.97,
						-10.6,
						-13.91,
						-17.22
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2685
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.38,
					"enrolment": 25,
					"ligo": 1,
					"location": [
						148.24522127251,
						-34.4268561860091
					],
					"name": "Wombat Public School",
					"playspace": 219.04,
					"projections": [
						39,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						56,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3482
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 6.84,
					"enrolment": 135,
					"ligo": 1,
					"location": [
						148.370087925079,
						-34.5596868277349
					],
					"name": "Murrumburrah High School",
					"playspace": 1155.19,
					"projections": [
						181,
						135,
						140,
						130,
						120,
						115
					],
					"projections_orig": [
						"181",
						"135",
						"140",
						"130",
						"120",
						"115"
					],
					"projections_percentage": [
						34.07,
						0,
						3.7,
						-3.7,
						-11.11,
						-14.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8328
				}
			],
			"uid": 30087
		},
		{
			"classrooms": {
				"demountable": 44,
				"permanent": 379
			},
			"enrolment": 7503,
			"level": "Combined",
			"ligo": 0.79,
			"name": "Far South Coast Network",
			"playspace": 174.29,
			"projections": [
				7503,
				7798,
				7508,
				7118,
				6703
			],
			"projections_percentage": [
				0,
				3.93,
				0.07,
				-5.13,
				-10.66
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 22
					},
					"classroomspace": 2.85,
					"enrolment": 587,
					"ligo": 0.8,
					"location": [
						150.18903514064,
						-35.6998684797424
					],
					"name": "Batemans Bay Public School",
					"playspace": 8.93,
					"projections": [
						523,
						587,
						595,
						560,
						500,
						470
					],
					"projections_orig": [
						"523",
						"587",
						"595",
						"560",
						"500",
						"470"
					],
					"projections_percentage": [
						-10.9,
						0,
						1.36,
						-4.6,
						-14.82,
						-19.93
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1149
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 17
					},
					"classroomspace": 3.05,
					"enrolment": 336,
					"ligo": 0.86,
					"location": [
						149.841134240661,
						-36.6704263692867
					],
					"name": "Bega Valley Public School",
					"playspace": 193.79,
					"projections": [
						344,
						336,
						365,
						350,
						335,
						325
					],
					"projections_orig": [
						"344",
						"336",
						"365",
						"350",
						"335",
						"325"
					],
					"projections_percentage": [
						2.38,
						0,
						8.63,
						4.17,
						-0.3,
						-3.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1168
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.39,
					"enrolment": 52,
					"ligo": 0.63,
					"location": [
						149.571269478582,
						-36.6308163626938
					],
					"name": "Bemboka Public School",
					"playspace": 302.07,
					"projections": [
						49,
						52,
						50,
						50,
						50,
						50
					],
					"projections_orig": [
						"49",
						"52",
						"50",
						"50",
						"50",
						"50"
					],
					"projections_percentage": [
						-5.77,
						0,
						-3.85,
						-3.85,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1189
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.26,
					"enrolment": 179,
					"ligo": 0.88,
					"location": [
						150.06448122225,
						-36.4206126383106
					],
					"name": "Bermagui Public School",
					"playspace": 104.18,
					"projections": [
						161,
						179,
						195,
						195,
						190,
						190
					],
					"projections_orig": [
						"161",
						"179",
						"195",
						"195",
						"190",
						"190"
					],
					"projections_percentage": [
						-10.06,
						0,
						8.94,
						8.94,
						6.15,
						6.15
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1204
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 7.91,
					"enrolment": 74,
					"ligo": 1,
					"location": [
						150.05393912717,
						-36.0971920250806
					],
					"name": "Bodalla Public School",
					"playspace": 444.59,
					"projections": [
						131,
						74,
						90,
						85,
						80,
						75
					],
					"projections_orig": [
						"131",
						"74",
						"90",
						"85",
						"80",
						"75"
					],
					"projections_percentage": [
						77.03,
						0,
						21.62,
						14.86,
						8.11,
						1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1272
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.34,
					"enrolment": 58,
					"ligo": 0.78,
					"location": [
						149.696019754952,
						-36.7686291394147
					],
					"name": "Candelo Public School",
					"playspace": 149.84,
					"projections": [
						80,
						58,
						70,
						70,
						70,
						70
					],
					"projections_orig": [
						"80",
						"58",
						"70",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						37.93,
						0,
						20.69,
						20.69,
						20.69,
						20.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1490
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 5.06,
					"enrolment": 70,
					"ligo": 0.79,
					"location": [
						149.882994378305,
						-36.3873422422581
					],
					"name": "Cobargo Public School",
					"playspace": 272.59,
					"projections": [
						84,
						70,
						80,
						75,
						75,
						75
					],
					"projections_orig": [
						"84",
						"70",
						"80",
						"75",
						"75",
						"75"
					],
					"projections_percentage": [
						20,
						0,
						14.29,
						7.14,
						7.14,
						7.14
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1579
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.78,
					"enrolment": 265,
					"ligo": 0.91,
					"location": [
						149.907606271958,
						-37.0628109834117
					],
					"name": "Eden Public School",
					"playspace": 57.68,
					"projections": [
						275,
						265,
						285,
						270,
						265,
						260
					],
					"projections_orig": [
						"275",
						"265",
						"285",
						"270",
						"265",
						"260"
					],
					"projections_percentage": [
						3.77,
						0,
						7.55,
						1.89,
						0,
						-1.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1816
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 18
					},
					"classroomspace": 2.85,
					"enrolment": 413,
					"ligo": 0.86,
					"location": [
						149.916701271837,
						-36.8872004283635
					],
					"name": "Merimbula Public School",
					"playspace": 26.51,
					"projections": [
						403,
						413,
						435,
						410,
						390,
						380
					],
					"projections_orig": [
						"403",
						"413",
						"435",
						"410",
						"390",
						"380"
					],
					"projections_percentage": [
						-2.42,
						0,
						5.33,
						-0.73,
						-5.57,
						-7.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2526
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.22,
					"enrolment": 38,
					"ligo": 0.29,
					"location": [
						150.140536170272,
						-35.7857104281924
					],
					"name": "Mogo Public School",
					"playspace": 542.67,
					"projections": [
						62,
						38,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"62",
						"38",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						63.16,
						0,
						-34.21,
						-34.21,
						-34.21,
						-34.21
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2586
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 18
					},
					"classroomspace": 3.39,
					"enrolment": 340,
					"ligo": 0.84,
					"location": [
						150.075411514919,
						-35.9126380949165
					],
					"name": "Moruya Public School",
					"playspace": 52.51,
					"projections": [
						368,
						340,
						380,
						360,
						330,
						310
					],
					"projections_orig": [
						"368",
						"340",
						"380",
						"360",
						"330",
						"310"
					],
					"projections_percentage": [
						8.24,
						0,
						11.76,
						5.88,
						-2.94,
						-8.82
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2628
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 11
					},
					"classroomspace": 2.68,
					"enrolment": 422,
					"ligo": 0.91,
					"location": [
						150.137594135546,
						-36.2195029229757
					],
					"name": "Narooma Public School",
					"playspace": 31.26,
					"projections": [
						392,
						422,
						445,
						405,
						400,
						390
					],
					"projections_orig": [
						"392",
						"422",
						"445",
						"405",
						"400",
						"390"
					],
					"projections_percentage": [
						-7.11,
						0,
						5.45,
						-4.03,
						-5.21,
						-7.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2758
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 11
					},
					"classroomspace": 3.11,
					"enrolment": 343,
					"ligo": 0.71,
					"location": [
						149.872484639203,
						-36.9256163392801
					],
					"name": "Pambula Public School",
					"playspace": 53.53,
					"projections": [
						303,
						343,
						330,
						310,
						305,
						300
					],
					"projections_orig": [
						"303",
						"343",
						"330",
						"310",
						"305",
						"300"
					],
					"projections_percentage": [
						-11.66,
						0,
						-3.79,
						-9.62,
						-11.08,
						-12.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2831
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 3.92,
					"enrolment": 61,
					"ligo": 0.88,
					"location": [
						149.867710454467,
						-36.4647158852232
					],
					"name": "Quaama Public School",
					"playspace": 438.81,
					"projections": [
						61,
						61,
						55,
						55,
						55,
						50
					],
					"projections_orig": [
						"61",
						"61",
						"55",
						"55",
						"55",
						"50"
					],
					"projections_percentage": [
						0,
						0,
						-9.84,
						-9.84,
						-9.84,
						-18.03
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2917
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 3.8,
					"enrolment": 20,
					"ligo": 0.69,
					"location": [
						149.975518933694,
						-36.6405220981141
					],
					"name": "Tanja Public School",
					"playspace": 307.15,
					"projections": [
						25,
						20,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"20",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25,
						0,
						25,
						25,
						25,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3159
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 8
					},
					"classroomspace": 2.43,
					"enrolment": 212,
					"ligo": 0.83,
					"location": [
						149.979496359978,
						-36.7331292636724
					],
					"name": "Tathra Public School",
					"playspace": 76.92,
					"projections": [
						161,
						212,
						190,
						185,
						185,
						180
					],
					"projections_orig": [
						"161",
						"212",
						"190",
						"185",
						"185",
						"180"
					],
					"projections_percentage": [
						-24.06,
						0,
						-10.38,
						-12.74,
						-12.74,
						-15.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3173
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.53,
					"enrolment": 42,
					"ligo": 0.27,
					"location": [
						150.072503539423,
						-36.3152447536411
					],
					"name": "Central Tilba Public School",
					"playspace": 194.45,
					"projections": [
						37,
						42,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"37",
						"42",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-11.9,
						0,
						-40.48,
						-40.48,
						-40.48,
						-40.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3214
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 4.18,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						149.694775980747,
						-37.0848366843216
					],
					"name": "Towamba Public School",
					"playspace": 681.56,
					"projections": [
						29,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"29",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						81.25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3252
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 2.71,
					"enrolment": 63,
					"ligo": 0.59,
					"location": [
						149.811356866831,
						-36.8322295878387
					],
					"name": "Wolumla Public School",
					"playspace": 174.09,
					"projections": [
						54,
						63,
						60,
						60,
						60,
						55
					],
					"projections_orig": [
						"54",
						"63",
						"60",
						"60",
						"60",
						"55"
					],
					"projections_percentage": [
						-14.29,
						0,
						-4.76,
						-4.76,
						-4.76,
						-12.7
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3479
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 5.45,
					"enrolment": 22,
					"ligo": 0.91,
					"location": [
						149.646762347447,
						-36.9291952606736
					],
					"name": "Wyndham Public School",
					"playspace": 263.77,
					"projections": [
						26,
						22,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"22",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						18.18,
						0,
						13.64,
						13.64,
						13.64,
						13.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3525
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 16
					},
					"classroomspace": 3.15,
					"enrolment": 306,
					"ligo": 0.75,
					"location": [
						150.209082719013,
						-35.7414035036223
					],
					"name": "Sunshine Bay Public School",
					"playspace": 64.43,
					"projections": [
						335,
						306,
						335,
						305,
						290,
						270
					],
					"projections_orig": [
						"335",
						"306",
						"335",
						"305",
						"290",
						"270"
					],
					"projections_percentage": [
						9.48,
						0,
						9.48,
						-0.33,
						-5.23,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4562
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 13
					},
					"classroomspace": 2.36,
					"enrolment": 372,
					"ligo": 0.7,
					"location": [
						150.171287821221,
						-35.8449065928245
					],
					"name": "Broulee Public School",
					"playspace": 21.78,
					"projections": [
						277,
						372,
						330,
						300,
						285,
						265
					],
					"projections_orig": [
						"277",
						"372",
						"330",
						"300",
						"285",
						"265"
					],
					"projections_percentage": [
						-25.54,
						0,
						-11.29,
						-19.35,
						-23.39,
						-28.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4612
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.13,
					"enrolment": 780,
					"ligo": 0.92,
					"location": [
						149.839550057902,
						-36.6785006360218
					],
					"name": "Bega High School",
					"playspace": 22.64,
					"projections": [
						931,
						780,
						805,
						800,
						765,
						710
					],
					"projections_orig": [
						"931",
						"780",
						"805",
						"800",
						"765",
						"710"
					],
					"projections_percentage": [
						19.36,
						0,
						3.21,
						2.56,
						-1.92,
						-8.97
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8165
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 36
					},
					"classroomspace": 4.57,
					"enrolment": 648,
					"ligo": 0.73,
					"location": [
						150.08098382885,
						-35.9193780666272
					],
					"name": "Moruya High School",
					"playspace": 80.76,
					"projections": [
						714,
						648,
						700,
						685,
						635,
						560
					],
					"projections_orig": [
						"714",
						"648",
						"700",
						"685",
						"635",
						"560"
					],
					"projections_percentage": [
						10.19,
						0,
						8.02,
						5.71,
						-2.01,
						-13.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8368
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 29
					},
					"classroomspace": 3.74,
					"enrolment": 651,
					"ligo": 0.9,
					"location": [
						149.905842271621,
						-37.0560688610777
					],
					"name": "Eden Marine High School",
					"playspace": 44.47,
					"projections": [
						718,
						651,
						710,
						705,
						670,
						625
					],
					"projections_orig": [
						"718",
						"651",
						"710",
						"705",
						"670",
						"625"
					],
					"projections_percentage": [
						10.29,
						0,
						9.06,
						8.29,
						2.92,
						-3.99
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8487
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 34
					},
					"classroomspace": 4.59,
					"enrolment": 458,
					"ligo": 0.91,
					"location": [
						150.127041064939,
						-36.2356151740259
					],
					"name": "Narooma High School",
					"playspace": 61.41,
					"projections": [
						461,
						458,
						470,
						475,
						440,
						410
					],
					"projections_orig": [
						"461",
						"458",
						"470",
						"475",
						"440",
						"410"
					],
					"projections_percentage": [
						0.66,
						0,
						2.62,
						3.71,
						-3.93,
						-10.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8536
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 34
					},
					"classroomspace": 4.1,
					"enrolment": 675,
					"ligo": 0.96,
					"location": [
						150.195549218759,
						-35.7299340080396
					],
					"name": "Batemans Bay High School",
					"playspace": 33.43,
					"projections": [
						688,
						675,
						685,
						660,
						605,
						545
					],
					"projections_orig": [
						"688",
						"675",
						"685",
						"660",
						"605",
						"545"
					],
					"projections_percentage": [
						1.93,
						0,
						1.48,
						-2.22,
						-10.37,
						-19.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8581
				}
			],
			"uid": 30088
		},
		{
			"classrooms": {
				"demountable": 29,
				"permanent": 172
			},
			"enrolment": 2794,
			"level": "Combined",
			"ligo": 0.84,
			"name": "Rural Queanbeyan Network",
			"playspace": 355.82,
			"projections": [
				2794,
				2957,
				2907,
				2777,
				2612
			],
			"projections_percentage": [
				0,
				5.83,
				4.04,
				-0.61,
				-6.51
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.47,
					"enrolment": 16,
					"ligo": 1,
					"location": [
						148.776089045557,
						-35.9936970692004
					],
					"name": "Adaminaby Public School",
					"playspace": 1119.75,
					"projections": [
						19,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						18.75,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1007
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.22,
					"enrolment": 63,
					"ligo": 0.92,
					"location": [
						148.828574940849,
						-36.3717149604943
					],
					"name": "Berridale Public School",
					"playspace": 298.65,
					"projections": [
						97,
						63,
						80,
						75,
						75,
						70
					],
					"projections_orig": [
						"97",
						"63",
						"80",
						"75",
						"75",
						"70"
					],
					"projections_percentage": [
						53.97,
						0,
						26.98,
						19.05,
						19.05,
						11.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1206
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.05,
					"enrolment": 113,
					"ligo": 0.94,
					"location": [
						149.233934032893,
						-36.9180921734943
					],
					"name": "Bombala Public School",
					"playspace": 159.93,
					"projections": [
						130,
						113,
						110,
						110,
						105,
						105
					],
					"projections_orig": [
						"130",
						"113",
						"110",
						"110",
						"105",
						"105"
					],
					"projections_percentage": [
						15.04,
						0,
						-2.65,
						-2.65,
						-7.08,
						-7.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1288
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 21
					},
					"classroomspace": 4.46,
					"enrolment": 371,
					"ligo": 0.7,
					"location": [
						149.798487827143,
						-35.4396456452642
					],
					"name": "Braidwood Central School",
					"playspace": 36.47,
					"projections": [
						431,
						371,
						440,
						430,
						395,
						365
					],
					"projections_orig": [
						"431",
						"371",
						"440",
						"430",
						"395",
						"365"
					],
					"projections_percentage": [
						16.17,
						0,
						18.6,
						15.9,
						6.47,
						-1.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1340
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 7.6,
					"enrolment": 10,
					"ligo": 1,
					"location": [
						149.147182108564,
						-35.9539397987998
					],
					"name": "Bredbo Public School",
					"playspace": 1370.64,
					"projections": [
						25,
						10,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"25",
						"10",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						150,
						0,
						150,
						150,
						150,
						150
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1347
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.68,
					"enrolment": 39,
					"ligo": 0.95,
					"location": [
						149.449600802382,
						-35.5879124526632
					],
					"name": "Captains Flat Public School",
					"playspace": 180.23,
					"projections": [
						38,
						39,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"39",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-2.56,
						0,
						-35.9,
						-35.9,
						-35.9,
						-35.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1502
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.01,
					"enrolment": 30,
					"ligo": 0.83,
					"location": [
						149.433340596072,
						-34.9141193962539
					],
					"name": "Collector Public School",
					"playspace": 89.68,
					"projections": [
						28,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.67,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1590
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 19
					},
					"classroomspace": 4.49,
					"enrolment": 249,
					"ligo": 0.8,
					"location": [
						149.125051940578,
						-36.236921993705
					],
					"name": "Cooma Public School",
					"playspace": 32.21,
					"projections": [
						165,
						249,
						240,
						235,
						230,
						220
					],
					"projections_orig": [
						"165",
						"249",
						"240",
						"235",
						"230",
						"220"
					],
					"projections_percentage": [
						-33.73,
						0,
						-3.61,
						-5.62,
						-7.63,
						-11.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1628
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 5.18,
					"enrolment": 25,
					"ligo": 0.8,
					"location": [
						148.836287431852,
						-36.5032472179435
					],
					"name": "Dalgety Public School",
					"playspace": 275.75,
					"projections": [
						10,
						25,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"10",
						"25",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-60,
						0,
						0,
						0,
						0,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1722
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.97,
					"enrolment": 34,
					"ligo": 1,
					"location": [
						148.938376214018,
						-37.0419723902224
					],
					"name": "Delegate Public School",
					"playspace": 663.36,
					"projections": [
						38,
						34,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"38",
						"34",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						11.76,
						0,
						-26.47,
						-26.47,
						-26.47,
						-26.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1745
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 7.66,
					"enrolment": 8,
					"ligo": 0.73,
					"location": [
						149.364185694272,
						-35.8704892465434
					],
					"name": "Jerangle Public School",
					"playspace": 878.95,
					"projections": [
						14,
						8,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"8",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						75,
						0,
						212.5,
						212.5,
						212.5,
						212.5
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2225
				},
				{
					"classrooms": {
						"demountable": 17,
						"permanent": 24
					},
					"classroomspace": 3.4,
					"enrolment": 770,
					"ligo": 0.96,
					"location": [
						148.618826693655,
						-36.4158974569464
					],
					"name": "Jindabyne Central School",
					"playspace": 17.87,
					"projections": [
						603,
						770,
						740,
						710,
						690,
						635
					],
					"projections_orig": [
						"603",
						"770",
						"740",
						"710",
						"690",
						"635"
					],
					"projections_percentage": [
						-21.69,
						0,
						-3.9,
						-7.79,
						-10.39,
						-17.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2237
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 0
					},
					"classroomspace": 3.9,
					"enrolment": 39,
					"ligo": 0.65,
					"location": [
						149.161826203225,
						-35.7054790376383
					],
					"name": "Michelago Public School",
					"playspace": 149.04,
					"projections": [
						21,
						39,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"39",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-46.15,
						0,
						-35.9,
						-35.9,
						-35.9,
						-35.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2540
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 5.77,
					"enrolment": 30,
					"ligo": 0.96,
					"location": [
						149.289097708343,
						-36.5106601106226
					],
					"name": "Nimmitabel Public School",
					"playspace": 645.35,
					"projections": [
						27,
						30,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"30",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-10,
						0,
						-16.67,
						-16.67,
						-16.67,
						-16.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2752
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.39,
					"enrolment": 42,
					"ligo": 0.81,
					"location": [
						149.655419891606,
						-35.0673603811582
					],
					"name": "Tarago Public School",
					"playspace": 292.37,
					"projections": [
						32,
						42,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"32",
						"42",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-23.81,
						0,
						-40.48,
						-40.48,
						-40.48,
						-40.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3162
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 6.8,
					"enrolment": 19,
					"ligo": 0.52,
					"location": [
						149.834060433516,
						-35.0097520864694
					],
					"name": "Windellama Public School",
					"playspace": 137.22,
					"projections": [
						28,
						19,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"19",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						47.37,
						0,
						31.58,
						31.58,
						31.58,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3457
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 2.26,
					"enrolment": 330,
					"ligo": 0.54,
					"location": [
						149.13040796229,
						-36.217554226975
					],
					"name": "Cooma North Public School",
					"playspace": 38.6,
					"projections": [
						296,
						330,
						345,
						335,
						315,
						305
					],
					"projections_orig": [
						"296",
						"330",
						"345",
						"335",
						"315",
						"305"
					],
					"projections_percentage": [
						-10.3,
						0,
						4.55,
						1.52,
						-4.55,
						-7.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3890
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 51
					},
					"classroomspace": 6.65,
					"enrolment": 486,
					"ligo": 0.91,
					"location": [
						149.133964128803,
						-36.2159750892186
					],
					"name": "Monaro High School",
					"playspace": 94.27,
					"projections": [
						582,
						486,
						580,
						590,
						550,
						500
					],
					"projections_orig": [
						"582",
						"486",
						"580",
						"590",
						"550",
						"500"
					],
					"projections_percentage": [
						19.75,
						0,
						19.34,
						21.4,
						13.17,
						2.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8196
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 15
					},
					"classroomspace": 9.1,
					"enrolment": 120,
					"ligo": 0.93,
					"location": [
						149.232718483294,
						-36.9169350038638
					],
					"name": "Bombala High School",
					"playspace": 280.23,
					"projections": [
						172,
						120,
						130,
						130,
						125,
						120
					],
					"projections_orig": [
						"172",
						"120",
						"130",
						"130",
						"125",
						"120"
					],
					"projections_percentage": [
						43.33,
						0,
						8.33,
						8.33,
						4.17,
						0
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8486
				}
			],
			"uid": 30089
		},
		{
			"classrooms": {
				"demountable": 6,
				"permanent": 174
			},
			"enrolment": 2499,
			"level": "Combined",
			"ligo": 0.83,
			"name": "Rural Southern Tablelands Network",
			"playspace": 703.3,
			"projections": [
				2500,
				2506,
				2486,
				2441,
				2396
			],
			"projections_percentage": [
				0,
				0.24,
				-0.56,
				-2.36,
				-4.16
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.48,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						149.144492089331,
						-34.0863214147169
					],
					"name": "Bigga Public School",
					"playspace": 3320.15,
					"projections": [
						7,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-46.15,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1223
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.79,
					"enrolment": 12,
					"ligo": 0.67,
					"location": [
						149.367252486068,
						-34.3315192568867
					],
					"name": "Binda Public School",
					"playspace": 863.91,
					"projections": [
						15,
						12,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"15",
						"12",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						25,
						0,
						108.33,
						108.33,
						108.33,
						108.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1231
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 28
					},
					"classroomspace": 7.97,
					"enrolment": 216,
					"ligo": 0.97,
					"location": [
						148.7249605436,
						-34.4367942526277
					],
					"name": "Boorowa Central School",
					"playspace": 125.88,
					"projections": [
						252,
						216,
						240,
						225,
						215,
						205
					],
					"projections_orig": [
						"252",
						"216",
						"240",
						"225",
						"215",
						"205"
					],
					"projections_percentage": [
						16.67,
						0,
						11.11,
						4.17,
						-0.46,
						-5.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1313
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.81,
					"enrolment": 29,
					"ligo": 0.93,
					"location": [
						148.812565473573,
						-34.7697206494024
					],
					"name": "Bowning Public School",
					"playspace": 661.17,
					"projections": [
						48,
						29,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"48",
						"29",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						65.52,
						0,
						-13.79,
						-13.79,
						-13.79,
						-13.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1334
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 12.57,
					"enrolment": 9,
					"ligo": 0.78,
					"location": [
						149.487480021133,
						-34.7902957182474
					],
					"name": "Breadalbane Public School",
					"playspace": 710.22,
					"projections": [
						7,
						9,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"7",
						"9",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.22,
						0,
						177.78,
						177.78,
						177.78,
						177.78
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1345
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 12.59,
					"enrolment": 13,
					"ligo": 1,
					"location": [
						147.874627216799,
						-34.1197177484418
					],
					"name": "Bribbaree Public School",
					"playspace": 1504.57,
					"projections": [
						18,
						13,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"18",
						"13",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						38.46,
						0,
						92.31,
						92.31,
						92.31,
						92.31
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1354
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 2.2,
					"enrolment": 217,
					"ligo": 0.8,
					"location": [
						149.469431194679,
						-34.4599560212233
					],
					"name": "Crookwell Public School",
					"playspace": 29.34,
					"projections": [
						178,
						217,
						220,
						235,
						245,
						255
					],
					"projections_orig": [
						"178",
						"217",
						"220",
						"235",
						"245",
						"255"
					],
					"projections_percentage": [
						-17.97,
						0,
						1.38,
						8.29,
						12.9,
						17.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1684
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 6.72,
					"enrolment": 17,
					"ligo": 1,
					"location": [
						149.179504678734,
						-34.719706345596
					],
					"name": "Dalton Public School",
					"playspace": 1264.39,
					"projections": [
						14,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-17.65,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1723
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 4.42,
					"enrolment": 78,
					"ligo": 0.88,
					"location": [
						149.265609858917,
						-34.7830366533832
					],
					"name": "Gunning Public School",
					"playspace": 141.96,
					"projections": [
						45,
						78,
						75,
						75,
						80,
						80
					],
					"projections_orig": [
						"45",
						"78",
						"75",
						"75",
						"80",
						"80"
					],
					"projections_percentage": [
						-42.31,
						0,
						-3.85,
						-3.85,
						2.56,
						2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2111
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 3.69,
					"enrolment": 32,
					"ligo": 1,
					"location": [
						148.558863031609,
						-34.0355220950605
					],
					"name": "Koorawatha Public School",
					"playspace": 554.28,
					"projections": [
						19,
						32,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"19",
						"32",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-40.62,
						0,
						-21.88,
						-21.88,
						-21.88,
						-21.88
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2326
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 10.94,
					"enrolment": 15,
					"ligo": 0.5,
					"location": [
						149.526915228793,
						-34.4064005353545
					],
					"name": "Laggan Public School",
					"playspace": 481.59,
					"projections": [
						21,
						15,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"21",
						"15",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						40,
						0,
						66.67,
						66.67,
						66.67,
						66.67
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2354
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 2.7,
					"enrolment": 14,
					"ligo": 1,
					"location": [
						148.214811616399,
						-34.243586918281
					],
					"name": "Maimuru Public School",
					"playspace": 983.38,
					"projections": [
						26,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"26",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						85.71,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2448
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 3
					},
					"classroomspace": 3.49,
					"enrolment": 100,
					"ligo": 0.87,
					"location": [
						150.005512173949,
						-34.7126669149111
					],
					"name": "Marulan Public School",
					"playspace": 68.45,
					"projections": [
						130,
						100,
						110,
						115,
						120,
						125
					],
					"projections_orig": [
						"130",
						"100",
						"110",
						"115",
						"120",
						"125"
					],
					"projections_percentage": [
						30,
						0,
						10,
						15,
						20,
						25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2496
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 7.78,
					"enrolment": 24,
					"ligo": 1,
					"location": [
						148.347646037548,
						-34.1933289600946
					],
					"name": "Monteagle Public School",
					"playspace": 1812.86,
					"projections": [
						44,
						24,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"44",
						"24",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						83.33,
						0,
						4.17,
						4.17,
						4.17,
						4.17
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2599
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.79,
					"enrolment": 35,
					"ligo": 1,
					"location": [
						148.516075949554,
						-34.2976949305444
					],
					"name": "Murringo Public School",
					"playspace": 340.1,
					"projections": [
						27,
						35,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"27",
						"35",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-22.86,
						0,
						-28.57,
						-28.57,
						-28.57,
						-28.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2681
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 13.73,
					"enrolment": 4,
					"ligo": 0.4,
					"location": [
						148.992593414996,
						-34.391981018994
					],
					"name": "Rugby Public School",
					"playspace": 1173.23,
					"projections": [
						14,
						4,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"4",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						250,
						0,
						525,
						525,
						525,
						525
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3012
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.61,
					"enrolment": 11,
					"ligo": 0.56,
					"location": [
						148.906501780881,
						-34.522064267751
					],
					"name": "Rye Park Public School",
					"playspace": 922.23,
					"projections": [
						28,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"28",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						154.55,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3024
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 5.29,
					"enrolment": 34,
					"ligo": 0.97,
					"location": [
						149.820420477926,
						-34.3980913491752
					],
					"name": "Taralga Public School",
					"playspace": 218.55,
					"projections": [
						53,
						34,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"53",
						"34",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						55.88,
						0,
						-26.47,
						-26.47,
						-26.47,
						-26.47
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3163
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 7.54,
					"enrolment": 14,
					"ligo": 0.5,
					"location": [
						149.681663362389,
						-34.8211337246337
					],
					"name": "Tirranna Public School",
					"playspace": 222.17,
					"projections": [
						14,
						14,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"14",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						78.57,
						78.57,
						78.57,
						78.57
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3222
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 0
					},
					"classroomspace": 15.2,
					"enrolment": 5,
					"ligo": 0.67,
					"location": [
						148.673545918381,
						-35.1097987499635
					],
					"name": "Wee Jasper Public School",
					"playspace": 1101.67,
					"projections": [
						14,
						5,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"14",
						"5",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						180,
						0,
						400,
						400,
						400,
						400
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3412
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 22
					},
					"classroomspace": 2.72,
					"enrolment": 534,
					"ligo": 0.59,
					"location": [
						148.290079068179,
						-34.3213246635125
					],
					"name": "Young Public School",
					"playspace": 41.51,
					"projections": [
						566,
						534,
						550,
						530,
						505,
						480
					],
					"projections_orig": [
						"566",
						"534",
						"550",
						"530",
						"505",
						"480"
					],
					"projections_percentage": [
						5.99,
						0,
						3,
						-0.75,
						-5.43,
						-10.11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3563
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.06,
					"enrolment": 255,
					"ligo": 0.84,
					"location": [
						148.304912086095,
						-34.3097576807123
					],
					"name": "Young North Public School",
					"playspace": 126.01,
					"projections": [
						228,
						255,
						255,
						250,
						235,
						225
					],
					"projections_orig": [
						"228",
						"255",
						"255",
						"250",
						"235",
						"225"
					],
					"projections_percentage": [
						-10.59,
						0,
						0,
						-1.96,
						-7.84,
						-11.76
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4131
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 40
					},
					"classroomspace": 4.55,
					"enrolment": 578,
					"ligo": 1,
					"location": [
						148.293086372555,
						-34.3170781731505
					],
					"name": "Young High School",
					"playspace": 45.04,
					"projections": [
						612,
						578,
						525,
						510,
						485,
						460
					],
					"projections_orig": [
						"612",
						"578",
						"525",
						"510",
						"485",
						"460"
					],
					"projections_percentage": [
						5.88,
						0,
						-9.17,
						-11.76,
						-16.09,
						-20.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8155
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 22
					},
					"classroomspace": 6.44,
					"enrolment": 240,
					"ligo": 0.94,
					"location": [
						149.465627476665,
						-34.4523493107898
					],
					"name": "Crookwell High School",
					"playspace": 166.5,
					"projections": [
						292,
						241,
						250,
						265,
						275,
						285
					],
					"projections_orig": [
						"292",
						"241",
						"250",
						"265",
						"275",
						"285"
					],
					"projections_percentage": [
						21.16,
						0,
						3.73,
						9.96,
						14.11,
						18.26
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8452
				}
			],
			"uid": 30090
		},
		{
			"classrooms": {
				"demountable": 21,
				"permanent": 201
			},
			"enrolment": 4344,
			"level": "Combined",
			"ligo": 0.68,
			"name": "Rural Wolondilly Network",
			"playspace": 212.61,
			"projections": [
				4344,
				4360,
				4385,
				4355,
				4295
			],
			"projections_percentage": [
				0,
				0.37,
				0.94,
				0.25,
				-1.13
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 8.05,
					"enrolment": 17,
					"ligo": 0.43,
					"location": [
						150.479171590715,
						-34.612631224134
					],
					"name": "Avoca Public School",
					"playspace": 329.66,
					"projections": [
						30,
						17,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"30",
						"17",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						76.47,
						0,
						47.06,
						47.06,
						47.06,
						47.06
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1081
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 3.29,
					"enrolment": 222,
					"ligo": 0.73,
					"location": [
						150.476171495419,
						-34.4004140553949
					],
					"name": "Colo Vale Public School",
					"playspace": 46.31,
					"projections": [
						243,
						222,
						230,
						230,
						230,
						225
					],
					"projections_orig": [
						"243",
						"222",
						"230",
						"230",
						"230",
						"225"
					],
					"projections_percentage": [
						9.46,
						0,
						3.6,
						3.6,
						3.6,
						1.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1085
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 3
					},
					"classroomspace": 3.05,
					"enrolment": 141,
					"ligo": 0.55,
					"location": [
						150.341281870546,
						-34.4862144029113
					],
					"name": "Berrima Public School",
					"playspace": 73.72,
					"projections": [
						100,
						141,
						125,
						130,
						130,
						125
					],
					"projections_orig": [
						"100",
						"141",
						"125",
						"130",
						"130",
						"125"
					],
					"projections_percentage": [
						-29.08,
						0,
						-11.35,
						-7.8,
						-7.8,
						-11.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1209
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 14
					},
					"classroomspace": 1.7,
					"enrolment": 590,
					"ligo": 0.82,
					"location": [
						150.419643907276,
						-34.4815442733276
					],
					"name": "Bowral Public School",
					"playspace": 18.74,
					"projections": [
						520,
						590,
						595,
						595,
						590,
						580
					],
					"projections_orig": [
						"520",
						"590",
						"595",
						"595",
						"590",
						"580"
					],
					"projections_percentage": [
						-11.86,
						0,
						0.85,
						0.85,
						0,
						-1.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1335
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 5
					},
					"classroomspace": 2.88,
					"enrolment": 180,
					"ligo": 0.84,
					"location": [
						150.299322099299,
						-34.6580079923616
					],
					"name": "Bundanoon Public School",
					"playspace": 77.91,
					"projections": [
						193,
						180,
						190,
						195,
						195,
						195
					],
					"projections_orig": [
						"193",
						"180",
						"190",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						7.22,
						0,
						5.56,
						8.33,
						8.33,
						8.33
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1414
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 7.32,
					"enrolment": 28,
					"ligo": 0.68,
					"location": [
						150.516136653065,
						-34.5929375544635
					],
					"name": "Burrawang Public School",
					"playspace": 534.75,
					"projections": [
						33,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						17.86,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1445
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 4
					},
					"classroomspace": 2.36,
					"enrolment": 133,
					"ligo": 0.61,
					"location": [
						150.321600842172,
						-34.6168853498846
					],
					"name": "Exeter Public School",
					"playspace": 86.02,
					"projections": [
						72,
						133,
						95,
						100,
						100,
						100
					],
					"projections_orig": [
						"72",
						"133",
						"95",
						"100",
						"100",
						"100"
					],
					"projections_percentage": [
						-45.86,
						0,
						-28.57,
						-24.81,
						-24.81,
						-24.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1891
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 4.8,
					"enrolment": 28,
					"ligo": 0.08,
					"location": [
						150.483769444151,
						-34.5226874160461
					],
					"name": "Glenquarry Public School",
					"playspace": 455.02,
					"projections": [
						24,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"24",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-14.29,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2015
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 4.49,
					"enrolment": 146,
					"ligo": 0.91,
					"location": [
						150.491242184952,
						-34.3540371180264
					],
					"name": "Hill Top Public School",
					"playspace": 84.98,
					"projections": [
						213,
						146,
						185,
						185,
						185,
						180
					],
					"projections_orig": [
						"213",
						"146",
						"185",
						"185",
						"185",
						"180"
					],
					"projections_percentage": [
						45.89,
						0,
						26.71,
						26.71,
						26.71,
						23.29
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2166
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 4.94,
					"enrolment": 33,
					"ligo": 0.31,
					"location": [
						150.529757614832,
						-34.5523810012052
					],
					"name": "Kangaloon Public School",
					"playspace": 167.38,
					"projections": [
						33,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"33",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						0,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2255
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 18
					},
					"classroomspace": 2.75,
					"enrolment": 500,
					"ligo": 0.78,
					"location": [
						150.445196486573,
						-34.4483662401899
					],
					"name": "Mittagong Public School",
					"playspace": 51.38,
					"projections": [
						378,
						500,
						450,
						455,
						450,
						445
					],
					"projections_orig": [
						"378",
						"500",
						"450",
						"455",
						"450",
						"445"
					],
					"projections_percentage": [
						-24.4,
						0,
						-10,
						-9,
						-10,
						-11
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2581
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 25
					},
					"classroomspace": 3.28,
					"enrolment": 536,
					"ligo": 0.8,
					"location": [
						150.365721481795,
						-34.5501106917422
					],
					"name": "Moss Vale Public School",
					"playspace": 36.39,
					"projections": [
						542,
						536,
						495,
						495,
						490,
						480
					],
					"projections_orig": [
						"542",
						"536",
						"495",
						"495",
						"490",
						"480"
					],
					"projections_percentage": [
						1.12,
						0,
						-7.65,
						-7.65,
						-8.58,
						-10.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2631
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 1
					},
					"classroomspace": 3.65,
					"enrolment": 16,
					"ligo": 0.56,
					"location": [
						150.221652981628,
						-34.6689002416012
					],
					"name": "Penrose Public School",
					"playspace": 279.1,
					"projections": [
						12,
						16,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"12",
						"16",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-25,
						0,
						56.25,
						56.25,
						56.25,
						56.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2860
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 7
					},
					"classroomspace": 2.76,
					"enrolment": 154,
					"ligo": 0.88,
					"location": [
						150.591839761337,
						-34.5887040456456
					],
					"name": "Robertson Public School",
					"playspace": 161.78,
					"projections": [
						197,
						154,
						155,
						155,
						155,
						155
					],
					"projections_orig": [
						"197",
						"154",
						"155",
						"155",
						"155",
						"155"
					],
					"projections_percentage": [
						27.92,
						0,
						0.65,
						0.65,
						0.65,
						0.65
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2971
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 1
					},
					"classroomspace": 3.05,
					"enrolment": 62,
					"ligo": 0.72,
					"location": [
						150.083438995629,
						-34.7211419671575
					],
					"name": "Tallong Public School",
					"playspace": 117.64,
					"projections": [
						26,
						62,
						60,
						60,
						65,
						65
					],
					"projections_orig": [
						"26",
						"62",
						"60",
						"60",
						"65",
						"65"
					],
					"projections_percentage": [
						-58.06,
						0,
						-3.23,
						-3.23,
						4.84,
						4.84
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3154
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 1
					},
					"classroomspace": 3.88,
					"enrolment": 33,
					"ligo": 0.81,
					"location": [
						150.152545954417,
						-34.6886023319484
					],
					"name": "Wingello Public School",
					"playspace": 1215.92,
					"projections": [
						31,
						33,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"31",
						"33",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-6.06,
						0,
						-24.24,
						-24.24,
						-24.24,
						-24.24
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3461
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 54
					},
					"classroomspace": 3.92,
					"enrolment": 865,
					"ligo": 0.85,
					"location": [
						150.424784005116,
						-34.4890264090405
					],
					"name": "Bowral High School",
					"playspace": 36.03,
					"projections": [
						917,
						865,
						950,
						950,
						935,
						920
					],
					"projections_orig": [
						"917",
						"865",
						"950",
						"950",
						"935",
						"920"
					],
					"projections_percentage": [
						6.01,
						0,
						9.83,
						9.83,
						8.09,
						6.36
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8104
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 37
					},
					"classroomspace": 3.9,
					"enrolment": 660,
					"ligo": 0.85,
					"location": [
						150.384851904144,
						-34.5534984645849
					],
					"name": "Moss Vale High School",
					"playspace": 54.18,
					"projections": [
						608,
						660,
						675,
						680,
						675,
						670
					],
					"projections_orig": [
						"608",
						"660",
						"675",
						"680",
						"675",
						"670"
					],
					"projections_percentage": [
						-7.88,
						0,
						2.27,
						3.03,
						2.27,
						1.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8388
				}
			],
			"uid": 30091
		},
		{
			"classrooms": {
				"demountable": 17,
				"permanent": 171
			},
			"enrolment": 3376,
			"level": "Combined",
			"ligo": 0.56,
			"name": "Goulburn Urban",
			"playspace": 80.8,
			"projections": [
				3376,
				3270,
				3360,
				3410,
				3440
			],
			"projections_percentage": [
				0,
				-3.14,
				-0.47,
				1.01,
				1.9
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 11
					},
					"classroomspace": 3,
					"enrolment": 185,
					"ligo": 0.57,
					"location": [
						149.718340993456,
						-34.7507575015929
					],
					"name": "Goulburn Public School",
					"playspace": 94.78,
					"projections": [
						162,
						185,
						155,
						160,
						160,
						165
					],
					"projections_orig": [
						"162",
						"185",
						"155",
						"160",
						"160",
						"165"
					],
					"projections_percentage": [
						-12.43,
						0,
						-16.22,
						-13.51,
						-13.51,
						-10.81
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2053
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 3
					},
					"classroomspace": 3.56,
					"enrolment": 164,
					"ligo": 0.56,
					"location": [
						149.729817271454,
						-34.7626047171658
					],
					"name": "Goulburn East Public School",
					"playspace": 37.64,
					"projections": [
						98,
						164,
						140,
						145,
						150,
						150
					],
					"projections_orig": [
						"98",
						"164",
						"140",
						"145",
						"150",
						"150"
					],
					"projections_percentage": [
						-40.24,
						0,
						-14.63,
						-11.59,
						-8.54,
						-8.54
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2054
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.71,
					"enrolment": 313,
					"ligo": 0.45,
					"location": [
						149.734626456155,
						-34.7450462861994
					],
					"name": "Goulburn North Public School",
					"playspace": 52.49,
					"projections": [
						266,
						313,
						285,
						295,
						300,
						305
					],
					"projections_orig": [
						"266",
						"313",
						"285",
						"295",
						"300",
						"305"
					],
					"projections_percentage": [
						-15.02,
						0,
						-8.95,
						-5.75,
						-4.15,
						-2.56
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2055
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 9
					},
					"classroomspace": 3.56,
					"enrolment": 156,
					"ligo": 0.37,
					"location": [
						149.712533827106,
						-34.7597238420738
					],
					"name": "Goulburn South Public School",
					"playspace": 76.37,
					"projections": [
						148,
						156,
						145,
						150,
						155,
						155
					],
					"projections_orig": [
						"148",
						"156",
						"145",
						"150",
						"155",
						"155"
					],
					"projections_percentage": [
						-5.13,
						0,
						-7.05,
						-3.85,
						-0.64,
						-0.64
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2056
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 14
					},
					"classroomspace": 2.31,
					"enrolment": 428,
					"ligo": 0.51,
					"location": [
						149.700872913887,
						-34.7587522353529
					],
					"name": "Goulburn West Public School",
					"playspace": 42.98,
					"projections": [
						368,
						428,
						390,
						405,
						410,
						415
					],
					"projections_orig": [
						"368",
						"428",
						"390",
						"405",
						"410",
						"415"
					],
					"projections_percentage": [
						-14.02,
						0,
						-8.88,
						-5.37,
						-4.21,
						-3.04
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3741
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 9
					},
					"classroomspace": 3.11,
					"enrolment": 253,
					"ligo": 0.73,
					"location": [
						149.74001841799,
						-34.7237271563547
					],
					"name": "Bradfordville Public School",
					"playspace": 90.73,
					"projections": [
						229,
						253,
						255,
						260,
						265,
						270
					],
					"projections_orig": [
						"229",
						"253",
						"255",
						"260",
						"265",
						"270"
					],
					"projections_percentage": [
						-9.49,
						0,
						0.79,
						2.77,
						4.74,
						6.72
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4406
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 20
					},
					"classroomspace": 4.57,
					"enrolment": 319,
					"ligo": 0.48,
					"location": [
						149.710307836977,
						-34.7423400445116
					],
					"name": "Wollondilly Public School",
					"playspace": 203.41,
					"projections": [
						371,
						319,
						345,
						355,
						365,
						365
					],
					"projections_orig": [
						"371",
						"319",
						"345",
						"355",
						"365",
						"365"
					],
					"projections_percentage": [
						16.3,
						0,
						8.15,
						11.29,
						14.42,
						14.42
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4438
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 53
					},
					"classroomspace": 4.71,
					"enrolment": 680,
					"ligo": 0.66,
					"location": [
						149.710362583441,
						-34.746530942171
					],
					"name": "Goulburn High School",
					"playspace": 28.54,
					"projections": [
						645,
						680,
						715,
						725,
						725,
						725
					],
					"projections_orig": [
						"645",
						"680",
						"715",
						"725",
						"725",
						"725"
					],
					"projections_percentage": [
						-5.15,
						0,
						5.15,
						6.62,
						6.62,
						6.62
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8116
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 43
					},
					"classroomspace": 3.66,
					"enrolment": 878,
					"ligo": 0.72,
					"location": [
						149.728916419231,
						-34.7311524230005
					],
					"name": "Mulwaree High School",
					"playspace": 100.24,
					"projections": [
						843,
						878,
						840,
						865,
						880,
						890
					],
					"projections_orig": [
						"843",
						"878",
						"840",
						"865",
						"880",
						"890"
					],
					"projections_percentage": [
						-3.99,
						0,
						-4.33,
						-1.48,
						0.23,
						1.37
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8468
				}
			],
			"uid": 30092
		},
		{
			"classrooms": {
				"demountable": 10,
				"permanent": 90
			},
			"enrolment": 2158,
			"level": "Combined",
			"ligo": 0.85,
			"name": "Kiama",
			"playspace": 55.92,
			"projections": [
				2158,
				2125,
				2170,
				2150,
				2175
			],
			"projections_percentage": [
				0,
				-1.53,
				0.56,
				-0.37,
				0.79
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 14
					},
					"classroomspace": 2.15,
					"enrolment": 453,
					"ligo": 0.97,
					"location": [
						150.821822717439,
						-34.7499852196086
					],
					"name": "Gerringong Public School",
					"playspace": 48.06,
					"projections": [
						395,
						453,
						465,
						470,
						470,
						470
					],
					"projections_orig": [
						"395",
						"453",
						"465",
						"470",
						"470",
						"470"
					],
					"projections_percentage": [
						-12.8,
						0,
						2.65,
						3.75,
						3.75,
						3.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1971
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 3.48,
					"enrolment": 114,
					"ligo": 0.76,
					"location": [
						150.773884043084,
						-34.6440992263525
					],
					"name": "Jamberoo Public School",
					"playspace": 115.19,
					"projections": [
						126,
						114,
						110,
						110,
						110,
						110
					],
					"projections_orig": [
						"126",
						"114",
						"110",
						"110",
						"110",
						"110"
					],
					"projections_percentage": [
						10.53,
						0,
						-3.51,
						-3.51,
						-3.51,
						-3.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2218
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 17
					},
					"classroomspace": 2.01,
					"enrolment": 502,
					"ligo": 0.79,
					"location": [
						150.851653966916,
						-34.6701200985339
					],
					"name": "Kiama Public School",
					"playspace": 33.03,
					"projections": [
						366,
						502,
						440,
						450,
						445,
						445
					],
					"projections_orig": [
						"366",
						"502",
						"440",
						"450",
						"445",
						"445"
					],
					"projections_percentage": [
						-27.09,
						0,
						-12.35,
						-10.36,
						-11.35,
						-11.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2293
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 53
					},
					"classroomspace": 3.58,
					"enrolment": 1089,
					"ligo": 0.88,
					"location": [
						150.846199167135,
						-34.6810659907353
					],
					"name": "Kiama High School",
					"playspace": 27.42,
					"projections": [
						1211,
						1089,
						1110,
						1140,
						1125,
						1150
					],
					"projections_orig": [
						"1211",
						"1089",
						"1110",
						"1140",
						"1125",
						"1150"
					],
					"projections_percentage": [
						11.2,
						0,
						1.93,
						4.68,
						3.31,
						5.6
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8171
				}
			],
			"uid": 30097
		},
		{
			"classrooms": {
				"demountable": 35,
				"permanent": 329
			},
			"enrolment": 6248,
			"level": "Combined",
			"ligo": 0.63,
			"name": "Nowra",
			"playspace": 108.54,
			"projections": [
				6248,
				6455,
				6495,
				6425,
				6325
			],
			"projections_percentage": [
				0,
				3.31,
				3.95,
				2.83,
				1.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 10
					},
					"classroomspace": 2.84,
					"enrolment": 342,
					"ligo": 0.82,
					"location": [
						150.690660501567,
						-34.7776347928421
					],
					"name": "Berry Public School",
					"playspace": 112.17,
					"projections": [
						285,
						342,
						330,
						335,
						330,
						330
					],
					"projections_orig": [
						"285",
						"342",
						"330",
						"335",
						"330",
						"330"
					],
					"projections_percentage": [
						-16.67,
						0,
						-3.51,
						-2.05,
						-3.51,
						-3.51
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1211
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 23
					},
					"classroomspace": 4.06,
					"enrolment": 347,
					"ligo": 0.76,
					"location": [
						150.607974834102,
						-34.8486069430738
					],
					"name": "Bomaderry Public School",
					"playspace": 62.73,
					"projections": [
						300,
						347,
						315,
						320,
						315,
						310
					],
					"projections_orig": [
						"300",
						"347",
						"315",
						"320",
						"315",
						"310"
					],
					"projections_percentage": [
						-13.54,
						0,
						-9.22,
						-7.78,
						-9.22,
						-10.66
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1287
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 9
					},
					"classroomspace": 2.76,
					"enrolment": 307,
					"ligo": 0.37,
					"location": [
						150.557060242185,
						-34.8210920691647
					],
					"name": "Cambewarra Public School",
					"playspace": 85.11,
					"projections": [
						316,
						307,
						320,
						325,
						320,
						315
					],
					"projections_orig": [
						"316",
						"307",
						"320",
						"325",
						"320",
						"315"
					],
					"projections_percentage": [
						2.93,
						0,
						4.23,
						5.86,
						4.23,
						2.61
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1481
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 6
					},
					"classroomspace": 2.67,
					"enrolment": 203,
					"ligo": 0.93,
					"location": [
						150.740099260361,
						-34.8538984270682
					],
					"name": "Shoalhaven Heads Public School",
					"playspace": 85.83,
					"projections": [
						162,
						203,
						190,
						195,
						195,
						195
					],
					"projections_orig": [
						"162",
						"203",
						"190",
						"195",
						"195",
						"195"
					],
					"projections_percentage": [
						-20.2,
						0,
						-6.4,
						-3.94,
						-3.94,
						-3.94
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1625
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 4.22,
					"enrolment": 56,
					"ligo": 0.47,
					"location": [
						150.594176506642,
						-34.9663193678722
					],
					"name": "Falls Creek Public School",
					"playspace": 577.33,
					"projections": [
						63,
						56,
						55,
						55,
						55,
						55
					],
					"projections_orig": [
						"63",
						"56",
						"55",
						"55",
						"55",
						"55"
					],
					"projections_percentage": [
						12.5,
						0,
						-1.79,
						-1.79,
						-1.79,
						-1.79
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1901
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.61,
					"enrolment": 80,
					"ligo": 0.97,
					"location": [
						150.531836372958,
						-34.7356707190899
					],
					"name": "Kangaroo Valley Public School",
					"playspace": 72.04,
					"projections": [
						98,
						80,
						85,
						85,
						85,
						85
					],
					"projections_orig": [
						"98",
						"80",
						"85",
						"85",
						"85",
						"85"
					],
					"projections_percentage": [
						22.5,
						0,
						6.25,
						6.25,
						6.25,
						6.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2256
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 27
					},
					"classroomspace": 2.79,
					"enrolment": 618,
					"ligo": 0.5,
					"location": [
						150.599828567022,
						-34.8788180039002
					],
					"name": "Nowra Public School",
					"playspace": 63.45,
					"projections": [
						630,
						618,
						645,
						650,
						640,
						625
					],
					"projections_orig": [
						"630",
						"618",
						"645",
						"650",
						"640",
						"625"
					],
					"projections_percentage": [
						1.94,
						0,
						4.37,
						5.18,
						3.56,
						1.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2769
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 1
					},
					"classroomspace": 3.52,
					"enrolment": 88,
					"ligo": 0.19,
					"location": [
						150.630921655707,
						-34.8668529931848
					],
					"name": "Terara Public School",
					"playspace": 59.2,
					"projections": [
						87,
						88,
						90,
						90,
						90,
						85
					],
					"projections_orig": [
						"87",
						"88",
						"90",
						"90",
						"90",
						"85"
					],
					"projections_percentage": [
						-1.14,
						0,
						2.27,
						2.27,
						2.27,
						-3.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3185
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 4
					},
					"classroomspace": 2.79,
					"enrolment": 91,
					"ligo": 0.39,
					"location": [
						150.730873411984,
						-34.9075097883423
					],
					"name": "Greenwell Point Public School",
					"playspace": 78.18,
					"projections": [
						50,
						91,
						75,
						75,
						70,
						70
					],
					"projections_orig": [
						"50",
						"91",
						"75",
						"75",
						"70",
						"70"
					],
					"projections_percentage": [
						-45.05,
						0,
						-17.58,
						-17.58,
						-23.08,
						-23.08
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3872
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 3
					},
					"classroomspace": 2.86,
					"enrolment": 166,
					"ligo": 0.36,
					"location": [
						150.566322664623,
						-34.9364236093918
					],
					"name": "Nowra Hill Public School",
					"playspace": 100.28,
					"projections": [
						107,
						166,
						135,
						135,
						135,
						130
					],
					"projections_orig": [
						"107",
						"166",
						"135",
						"135",
						"135",
						"130"
					],
					"projections_percentage": [
						-35.54,
						0,
						-18.67,
						-18.67,
						-18.67,
						-21.69
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4106
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 20
					},
					"classroomspace": 2.68,
					"enrolment": 538,
					"ligo": 0.42,
					"location": [
						150.590079146408,
						-34.8601540285192
					],
					"name": "Illaroo Road Public School",
					"playspace": 47.76,
					"projections": [
						542,
						538,
						565,
						570,
						565,
						550
					],
					"projections_orig": [
						"542",
						"538",
						"565",
						"570",
						"565",
						"550"
					],
					"projections_percentage": [
						0.74,
						0,
						5.02,
						5.95,
						5.02,
						2.23
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4246
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 18
					},
					"classroomspace": 3.96,
					"enrolment": 349,
					"ligo": 0.9,
					"location": [
						150.608816374142,
						-34.8822975982108
					],
					"name": "Nowra East Public School",
					"playspace": 56.67,
					"projections": [
						322,
						349,
						340,
						340,
						335,
						330
					],
					"projections_orig": [
						"322",
						"349",
						"340",
						"340",
						"335",
						"330"
					],
					"projections_percentage": [
						-7.74,
						0,
						-2.58,
						-2.58,
						-4.01,
						-5.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4256
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 10
					},
					"classroomspace": 2.84,
					"enrolment": 213,
					"ligo": 0.83,
					"location": [
						150.761223347329,
						-34.9329583702412
					],
					"name": "Culburra Public School",
					"playspace": 116.1,
					"projections": [
						215,
						213,
						200,
						205,
						200,
						195
					],
					"projections_orig": [
						"215",
						"213",
						"200",
						"205",
						"200",
						"195"
					],
					"projections_percentage": [
						0.94,
						0,
						-6.1,
						-3.76,
						-6.1,
						-8.45
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4485
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 12
					},
					"classroomspace": 3.21,
					"enrolment": 227,
					"ligo": 0.57,
					"location": [
						150.577220410341,
						-34.8554446141487
					],
					"name": "North Nowra Public School",
					"playspace": 84.19,
					"projections": [
						267,
						227,
						245,
						245,
						240,
						235
					],
					"projections_orig": [
						"267",
						"227",
						"245",
						"245",
						"240",
						"235"
					],
					"projections_percentage": [
						17.62,
						0,
						7.93,
						7.93,
						5.73,
						3.52
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4618
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.66,
					"enrolment": 208,
					"ligo": 0.88,
					"location": [
						150.715362231713,
						-34.9953200216291
					],
					"name": "Callala Public School",
					"playspace": 55.92,
					"projections": [
						277,
						208,
						255,
						255,
						255,
						250
					],
					"projections_orig": [
						"277",
						"208",
						"255",
						"255",
						"255",
						"250"
					],
					"projections_percentage": [
						33.17,
						0,
						22.6,
						22.6,
						22.6,
						20.19
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4626
				},
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 55
					},
					"classroomspace": 3.82,
					"enrolment": 996,
					"ligo": 0.45,
					"location": [
						150.610009520451,
						-34.8713559404314
					],
					"name": "Nowra High School",
					"playspace": 99.81,
					"projections": [
						1076,
						996,
						1050,
						1050,
						1050,
						1030
					],
					"projections_orig": [
						"1076",
						"996",
						"1050",
						"1050",
						"1050",
						"1030"
					],
					"projections_percentage": [
						8.03,
						0,
						5.42,
						5.42,
						5.42,
						3.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8201
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 56
					},
					"classroomspace": 4.68,
					"enrolment": 756,
					"ligo": 0.81,
					"location": [
						150.602161048127,
						-34.8436623648324
					],
					"name": "Bomaderry High School",
					"playspace": 104.17,
					"projections": [
						918,
						756,
						825,
						830,
						820,
						825
					],
					"projections_orig": [
						"918",
						"756",
						"825",
						"830",
						"820",
						"825"
					],
					"projections_percentage": [
						21.43,
						0,
						9.13,
						9.79,
						8.47,
						9.13
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8448
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 53
					},
					"classroomspace": 5.08,
					"enrolment": 663,
					"ligo": 0.78,
					"location": [
						150.610523709208,
						-34.8959032084583
					],
					"name": "Shoalhaven High School",
					"playspace": 92.74,
					"projections": [
						803,
						663,
						735,
						735,
						725,
						710
					],
					"projections_orig": [
						"803",
						"663",
						"735",
						"735",
						"725",
						"710"
					],
					"projections_percentage": [
						21.12,
						0,
						10.86,
						10.86,
						9.35,
						7.09
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8561
				}
			],
			"uid": 30098
		},
		{
			"classrooms": {
				"demountable": 31,
				"permanent": 115
			},
			"enrolment": 2936,
			"level": "Combined",
			"ligo": 0.71,
			"name": "Jervis Bay",
			"playspace": 42.96,
			"projections": [
				2936,
				2880,
				2890,
				2850,
				2795
			],
			"projections_percentage": [
				0,
				-1.91,
				-1.57,
				-2.93,
				-4.8
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 4
					},
					"classroomspace": 2.99,
					"enrolment": 180,
					"ligo": 0.24,
					"location": [
						150.668017574806,
						-35.0373558439013
					],
					"name": "Huskisson Public School",
					"playspace": 31.26,
					"projections": [
						107,
						180,
						135,
						140,
						135,
						135
					],
					"projections_orig": [
						"107",
						"180",
						"135",
						"140",
						"135",
						"135"
					],
					"projections_percentage": [
						-40.56,
						0,
						-25,
						-22.22,
						-25,
						-25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2199
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 6
					},
					"classroomspace": 2.19,
					"enrolment": 148,
					"ligo": 0.55,
					"location": [
						150.586516189471,
						-35.0546448735959
					],
					"name": "Tomerong Public School",
					"playspace": 76.64,
					"projections": [
						116,
						148,
						125,
						125,
						125,
						120
					],
					"projections_orig": [
						"116",
						"148",
						"125",
						"125",
						"125",
						"120"
					],
					"projections_percentage": [
						-21.62,
						0,
						-15.54,
						-15.54,
						-15.54,
						-18.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3226
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 12
					},
					"classroomspace": 2.9,
					"enrolment": 230,
					"ligo": 0.92,
					"location": [
						150.584538978322,
						-35.1671035492109
					],
					"name": "Sussex Inlet Public School",
					"playspace": 55.07,
					"projections": [
						218,
						230,
						250,
						250,
						245,
						240
					],
					"projections_orig": [
						"218",
						"230",
						"250",
						"250",
						"245",
						"240"
					],
					"projections_percentage": [
						-5.22,
						0,
						8.7,
						8.7,
						6.52,
						4.35
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3659
				},
				{
					"classrooms": {
						"demountable": 6,
						"permanent": 13
					},
					"classroomspace": 2.66,
					"enrolment": 432,
					"ligo": 0.74,
					"location": [
						150.563431823632,
						-35.091350963966
					],
					"name": "St Georges Basin Public School",
					"playspace": 34.09,
					"projections": [
						421,
						432,
						440,
						445,
						440,
						430
					],
					"projections_orig": [
						"421",
						"432",
						"440",
						"445",
						"440",
						"430"
					],
					"projections_percentage": [
						-2.55,
						0,
						1.85,
						3.01,
						1.85,
						-0.46
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3673
				},
				{
					"classrooms": {
						"demountable": 7,
						"permanent": 18
					},
					"classroomspace": 3.22,
					"enrolment": 494,
					"ligo": 0.77,
					"location": [
						150.629467456082,
						-35.105933387751
					],
					"name": "Sanctuary Point Public School",
					"playspace": 40.73,
					"projections": [
						480,
						494,
						530,
						530,
						525,
						515
					],
					"projections_orig": [
						"480",
						"494",
						"530",
						"530",
						"525",
						"515"
					],
					"projections_percentage": [
						-2.83,
						0,
						7.29,
						7.29,
						6.28,
						4.25
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4464
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 13
					},
					"classroomspace": 2.5,
					"enrolment": 327,
					"ligo": 0.79,
					"location": [
						150.670321368764,
						-35.0729844927443
					],
					"name": "Vincentia Public School",
					"playspace": 40.58,
					"projections": [
						330,
						327,
						340,
						345,
						340,
						330
					],
					"projections_orig": [
						"330",
						"327",
						"340",
						"345",
						"340",
						"330"
					],
					"projections_percentage": [
						0.92,
						0,
						3.98,
						5.5,
						3.98,
						0.92
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 4592
				},
				{
					"classrooms": {
						"demountable": 13,
						"permanent": 49
					},
					"classroomspace": 3.69,
					"enrolment": 1125,
					"ligo": 0.96,
					"location": [
						150.663588999367,
						-35.0771364223198
					],
					"name": "Vincentia High School",
					"playspace": 22.38,
					"projections": [
						1156,
						1125,
						1060,
						1055,
						1040,
						1025
					],
					"projections_orig": [
						"1156",
						"1125",
						"1060",
						"1055",
						"1040",
						"1025"
					],
					"projections_percentage": [
						2.76,
						0,
						-5.78,
						-6.22,
						-7.56,
						-8.89
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8593
				}
			],
			"uid": 30099
		},
		{
			"classrooms": {
				"demountable": 3,
				"permanent": 31
			},
			"enrolment": 421,
			"level": "Combined",
			"ligo": 1,
			"name": "Uralla",
			"playspace": 238.98,
			"projections": [
				421,
				481,
				506,
				521,
				553
			],
			"projections_percentage": [
				0,
				14.25,
				20.19,
				23.75,
				31.35
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.97,
					"enrolment": 43,
					"ligo": 1,
					"location": [
						151.450383963504,
						-30.7593430932681
					],
					"name": "Kentucky Public School",
					"playspace": 279.4,
					"projections": [
						29,
						43,
						50,
						55,
						55,
						60
					],
					"projections_orig": [
						"29",
						"43",
						"50",
						"55",
						"55",
						"60"
					],
					"projections_percentage": [
						-32.56,
						0,
						16.28,
						27.91,
						27.91,
						39.53
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2286
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 6.33,
					"enrolment": 28,
					"ligo": 1,
					"location": [
						151.116056224399,
						-30.5066337746623
					],
					"name": "Kingstown Public School",
					"playspace": 209.76,
					"projections": [
						39,
						28,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"39",
						"28",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						39.29,
						0,
						-10.71,
						-10.71,
						-10.71,
						-10.71
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2310
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.12,
					"enrolment": 38,
					"ligo": 1,
					"location": [
						151.491799168465,
						-30.6134427564557
					],
					"name": "Rocky River Public School",
					"playspace": 394.41,
					"projections": [
						43,
						38,
						25,
						25,
						25,
						50
					],
					"projections_orig": [
						"43",
						"38",
						"<50",
						"<50",
						"<50",
						"50"
					],
					"projections_percentage": [
						13.16,
						0,
						-34.21,
						-34.21,
						-34.21,
						31.58
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2983
				},
				{
					"classrooms": {
						"demountable": 2,
						"permanent": 24
					},
					"classroomspace": 5.19,
					"enrolment": 312,
					"ligo": 1,
					"location": [
						151.493599997438,
						-30.6408680353554
					],
					"name": "Uralla Central School",
					"playspace": 72.34,
					"projections": [
						340,
						312,
						365,
						385,
						400,
						415
					],
					"projections_orig": [
						"340",
						"312",
						"365",
						"385",
						"400",
						"415"
					],
					"projections_percentage": [
						8.97,
						0,
						16.99,
						23.4,
						28.21,
						33.01
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3864
				}
			],
			"uid": 30100
		},
		{
			"classrooms": {
				"demountable": 7,
				"permanent": 23
			},
			"enrolment": 627,
			"level": "Combined",
			"ligo": 1,
			"name": "Maclean",
			"playspace": 155.79,
			"projections": [
				627,
				710,
				685,
				660,
				640
			],
			"projections_percentage": [
				0,
				13.24,
				9.25,
				5.26,
				2.07
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 3
					},
					"classroomspace": 3.07,
					"enrolment": 136,
					"ligo": 1,
					"location": [
						153.348587621943,
						-29.4052467503885
					],
					"name": "Iluka Public School",
					"playspace": 69.07,
					"projections": [
						142,
						136,
						140,
						140,
						135,
						130
					],
					"projections_orig": [
						"142",
						"136",
						"140",
						"140",
						"135",
						"130"
					],
					"projections_percentage": [
						4.41,
						0,
						2.94,
						2.94,
						-0.74,
						-4.41
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2204
				},
				{
					"classrooms": {
						"demountable": 1,
						"permanent": 2
					},
					"classroomspace": 3.61,
					"enrolment": 54,
					"ligo": 1,
					"location": [
						153.288689564034,
						-29.419777033976
					],
					"name": "Palmers Island Public School",
					"playspace": 172.2,
					"projections": [
						61,
						54,
						60,
						60,
						60,
						55
					],
					"projections_orig": [
						"61",
						"54",
						"60",
						"60",
						"60",
						"55"
					],
					"projections_percentage": [
						12.96,
						0,
						11.11,
						11.11,
						11.11,
						1.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2829
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 5
					},
					"classroomspace": 3.77,
					"enrolment": 61,
					"ligo": 1,
					"location": [
						153.030189655078,
						-29.6289849502458
					],
					"name": "Ulmarra Public School",
					"playspace": 181.5,
					"projections": [
						82,
						61,
						70,
						70,
						70,
						70
					],
					"projections_orig": [
						"82",
						"61",
						"70",
						"70",
						"70",
						"70"
					],
					"projections_percentage": [
						34.43,
						0,
						14.75,
						14.75,
						14.75,
						14.75
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3303
				},
				{
					"classrooms": {
						"demountable": 3,
						"permanent": 13
					},
					"classroomspace": 2.68,
					"enrolment": 376,
					"ligo": 1,
					"location": [
						153.352080575946,
						-29.4409001902375
					],
					"name": "Yamba Public School",
					"playspace": 200.38,
					"projections": [
						384,
						376,
						440,
						415,
						395,
						385
					],
					"projections_orig": [
						"384",
						"376",
						"440",
						"415",
						"395",
						"385"
					],
					"projections_percentage": [
						2.13,
						0,
						17.02,
						10.37,
						5.05,
						2.39
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 3533
				}
			],
			"uid": 30101
		},
		{
			"classrooms": {
				"demountable": 9,
				"permanent": 88
			},
			"enrolment": 1712,
			"level": "Combined",
			"ligo": 0.88,
			"name": "Casino",
			"playspace": 303.12,
			"projections": [
				1712,
				1838,
				1858,
				1773,
				1708
			],
			"projections_percentage": [
				0,
				7.36,
				8.53,
				3.56,
				-0.23
			],
			"schools": [
				{
					"classrooms": {
						"demountable": 4,
						"permanent": 28
					},
					"classroomspace": 2.79,
					"enrolment": 718,
					"ligo": 0.67,
					"location": [
						153.047678266783,
						-28.8670508197798
					],
					"name": "Casino Public School",
					"playspace": 26.65,
					"projections": [
						548,
						718,
						760,
						750,
						700,
						690
					],
					"projections_orig": [
						"548",
						"718",
						"760",
						"750",
						"700",
						"690"
					],
					"projections_percentage": [
						-23.68,
						0,
						5.85,
						4.46,
						-2.51,
						-3.9
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1526
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 3
					},
					"classroomspace": 3.32,
					"enrolment": 52,
					"ligo": 1,
					"location": [
						153.00390230931,
						-28.9308386857661
					],
					"name": "Leeville Public School",
					"playspace": 652.85,
					"projections": [
						55,
						52,
						55,
						55,
						50,
						50
					],
					"projections_orig": [
						"55",
						"52",
						"55",
						"55",
						"50",
						"50"
					],
					"projections_percentage": [
						5.77,
						0,
						5.77,
						5.77,
						-3.85,
						-3.85
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 1740
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 2.73,
					"enrolment": 42,
					"ligo": 1,
					"location": [
						153.077086762054,
						-28.7496139151956
					],
					"name": "Manifold Public School",
					"playspace": 123.35,
					"projections": [
						22,
						42,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"22",
						"42",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						-47.62,
						0,
						-40.48,
						-40.48,
						-40.48,
						-40.48
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2464
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 2
					},
					"classroomspace": 9.56,
					"enrolment": 11,
					"ligo": 1,
					"location": [
						152.955017437556,
						-29.0864292816282
					],
					"name": "Rappville Public School",
					"playspace": 828.8,
					"projections": [
						20,
						11,
						25,
						25,
						25,
						25
					],
					"projections_orig": [
						"20",
						"11",
						"<50",
						"<50",
						"<50",
						"<50"
					],
					"projections_percentage": [
						81.82,
						0,
						127.27,
						127.27,
						127.27,
						127.27
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 2937
				},
				{
					"classrooms": {
						"demountable": 0,
						"permanent": 13
					},
					"classroomspace": 3.08,
					"enrolment": 226,
					"ligo": 0.67,
					"location": [
						153.037678733745,
						-28.8556073884968
					],
					"name": "Casino West Public School",
					"playspace": 102.26,
					"projections": [
						294,
						226,
						230,
						235,
						230,
						225
					],
					"projections_orig": [
						"294",
						"226",
						"230",
						"235",
						"230",
						"225"
					],
					"projections_percentage": [
						30.09,
						0,
						1.77,
						3.98,
						1.77,
						-0.44
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 5166
				},
				{
					"classrooms": {
						"demountable": 5,
						"permanent": 40
					},
					"classroomspace": 4.37,
					"enrolment": 663,
					"ligo": 0.95,
					"location": [
						153.043067796707,
						-28.843919733525
					],
					"name": "Casino High School",
					"playspace": 84.79,
					"projections": [
						756,
						663,
						740,
						765,
						740,
						690
					],
					"projections_orig": [
						"756",
						"663",
						"740",
						"765",
						"740",
						"690"
					],
					"projections_percentage": [
						14.03,
						0,
						11.61,
						15.38,
						11.61,
						4.07
					],
					"projections_years": [
						2012,
						2017,
						2021,
						2026,
						2031,
						2036
					],
					"uid": 8154
				}
			],
			"uid": 30102
		}
	],
	"projections": {
		"average": [
			7.79,
			15.29,
			20.85,
			25.98
		],
		"maximum": [
			13.98,
			31.81,
			49.5,
			65.38
		],
		"minimum": [
			0,
			0,
			0,
			0
		]
	},
	"total_student_population": 4533045
};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = [
	10060,
	10085,
	10086,
	10011,
	10030,
	10037,
	10105,
	10096,
	10038,
	10076,
	10075,
	10074,
	10073,
	10059,
	10058,
	10014,
	10022,
	10069,
	10056,
	10068,
	10055,
	10024,
	10095,
	10067,
	10027,
	10099,
	10065,
	10043,
	10023,
	10084,
	10045,
	10032,
	10019,
	10090,
	10063,
	10049,
	10091,
	10057,
	10054,
	10072,
	10103,
	10015,
	10104,
	10110,
	10078,
	10033,
	10039,
	10016,
	10021,
	10109,
	10036,
	10077,
	10040,
	10026,
	10097,
	10046,
	10062,
	10052,
	10034,
	10013,
	10020,
	10050,
	10100,
	10025,
	10053,
	10047,
	10098,
	10051,
	10017,
	10018,
	10088,
	10102,
	10092,
	10089,
	10042,
	10101,
	10106,
	10081,
	10082,
	10066,
	10093,
	10070,
	10012,
	10079,
	10041,
	10064,
	10028,
	10107,
	10087,
	10094,
	10083,
	10031,
	10111,
	10048,
	10044,
	10035,
	10108,
	10071,
	10061,
	10029,
	10080
];

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__custom_map_marker__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_get_url__ = __webpack_require__(45);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function makeMap(data){var container=document.createElement('div');var key=document.createElement('div');var minimap=document.createElement('img');var markers=[];var clusterBounds=new window.google.maps.LatLngBounds();var map=void 0;function addMap(id,container,opts){var elm=document.createElement('div');var mapOptions=Object.assign({},{center:new window.google.maps.LatLng(-33.806431,151.276418),zoom:13,zoomControl:true,fullscreenControl:false,zoomControlOptions:{style:window.google.maps.ZoomControlStyle.DEFAULT,position:window.google.maps.ControlPosition.LEFT_TOP},disableDoubleClickZoom:true,mapTypeControl:false,scaleControl:false,scrollwheel:false,panControl:true,streetViewControl:false,draggable:true,overviewMapControl:false,mapTypeId:window.google.maps.MapTypeId.ROADMAP},opts);var map=new window.google.maps.Map(elm,mapOptions);elm.id=id;container.appendChild(elm);return map;}function addSchoolMarkers(){var infoWindow=new __WEBPACK_IMPORTED_MODULE_3__custom_map_marker__["a" /* default */]();var activeIcon='/img/icon-mapmarker-active.svg';var inactiveIcon='/img/icon-mapmarker-inactive.svg';var activeIconMobile='/img/icon-mapmarker-active-mobile.png';var inactiveIconMobile='/img/icon-mapmarker-inactive-mobile.png';var inactiveSelectedMobile='/img/icon-mapmarker-inactive-mobile-selected.png';data.schools.forEach(function(d,i){var classnames=d.isActive?'tooltip-active':'tooltip-arrow';var url=Object(__WEBPACK_IMPORTED_MODULE_4__modules_get_url__["a" /* default */])(d);var content='<a href="'+url+'" target="_parent" class="tooltip '+classnames+' tooltip-infowindow">\n        <div class="tooltip-content-wrapper">\n            <div class="tooltip-content">\n            <div>\n              <p class="tooltip-title">'+d.name+'</p>\n            </div>\n            </div>\n          </div>\n        </a>';var iconsrc=d.isActive?activeIcon:inactiveIcon;if(!window.matchMedia('(min-width: 600px)').matches){iconsrc=d.isActive?activeIconMobile:inactiveIconMobile;}var icon={url:iconsrc,size:new window.google.maps.Size(20,20),origin:new window.google.maps.Point(0,0),anchor:new window.google.maps.Point(10,10),scaledSize:new window.google.maps.Size(20,20)};var marker=new window.google.maps.Marker({icon:icon,position:new window.google.maps.LatLng(d.location[1],d.location[0]),map:map,title:d.name,desc:'content'});// Store original
marker._icon=Object.assign({},icon);markers.push(marker);marker.addListener('click',function(){return function(_marker){infoWindow.setContent(content);infoWindow.open(_marker.map,_marker);// Set all icons to original
if(_marker.icon.url===inactiveIconMobile){markers.forEach(function(m){if(m.icon.url===inactiveSelectedMobile){m.setIcon(m._icon);}});// Set clicked to clicked
_marker.setIcon(Object.assign({},_marker._icon,{url:inactiveSelectedMobile}));}}(marker);});map.addListener('zoom_changed',function(){infoWindow.close();});});}function loadClusterGeo(){return new Promise(function(resolve,reject){map.data.addListener('addfeature',function(e){Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["f" /* processGeoJSON */])(e.feature.getGeometry(),clusterBounds.extend,clusterBounds);map.setCenter(clusterBounds.getCenter());map.fitBounds(clusterBounds);resolve();});map.data.loadGeoJson('/data/clusters/'+data.uid+'.geojson');map.data.setStyle({fillColor:'#ceebeb',strokeColor:'#00517D',strokeWeight:2});});}function drawMinimap(){var minimapstyles='style=feature:all|visibility:off&style=feature:landscape|visibility:on|color:0xEAEAEA&style=feature:water|visibility:on|color:0xEAEAEA';var minimapsize='size=200x150';// http://www.freeformatter.com/javascript-escape.html
var minimappath='path=fillcolor:0xFFFFFFFF%7Ccolor:0xFFFFFF00%7Cenc:nzenE_d~y[ne`@nh\\~zm@~f^~lVnqPne`@n}@~`f@ntLn_eDninB~olG~qy@n|k@_|BnqPnbd@_etB~nwH_db@_mV_hpBn|k@_mVnsw@nbd@~lsCosw@nldJ~xFnh\\n_h@_|B?nggAoylD~gmFodkA~xFoyo@~jlBn_h@nvs@_`qAnkX_{m@~heA~lVnofB_db@~s`B_kw]n}@?_uqo@_`qAoljB_yFohyCn_h@_skCn~rA_fiA_ry@op{@nzD_ry@odkAnwH_xq@orbB~oR__|BonTotL?obd@oqPonTn}@_sN~xcCowHn{vA~wq@~jiFnp{@~k~D~oR~jlBndkAnaoA?nqPn_h@ne`@nkX~}i@~_qA~f^~lVn|hD~|tA';var clustercenter=clusterBounds.getCenter();var minimapapikey='key=AIzaSyAwRAI9ybH41VklsZdSJgye2sDAPj1-myI';var ne=[clustercenter.lat()+0.5,clustercenter.lng()+1];var se=[clustercenter.lat()-0.5,clustercenter.lng()+1];var sw=[clustercenter.lat()-0.5,clustercenter.lng()-1];var nw=[clustercenter.lat()+0.5,clustercenter.lng()-1];var minimapsq='path=color:0x003E52ff|fillcolor:0xceebeb55|weight:1|'+ne+'|'+se+'|'+sw+'|'+nw+'|'+ne;minimap.src='https://maps.googleapis.com/maps/api/staticmap?'+minimapstyles+'&'+minimapsize+'&'+minimappath+'&'+minimapsq+'&'+minimapapikey;minimap.alt='Minimap showing schools group location in NSW';minimapapikey;container.classList.add('map-container');minimap.id='mini-map';container.appendChild(minimap);}function clearMarkers(){for(var i=0;i<markers.length;i++){markers[i].setMap(null);}markers=[];}function drawKey(){key.classList.add('map-key');var activeSchool=data.schools.filter(function(d){return d.isActive;})[0];var keyactiveschool=activeSchool?'<div class="map-key-point-active">'+activeSchool.name+'</div>':'';var keyOtherSchools=activeSchool?'Other schools':'Schools';key.innerHTML='<div class="map-key-poly">'+data.name+' schools group</div> <div class="map-key-point">'+keyOtherSchools+'</div> '+keyactiveschool;container.appendChild(key);}// start
map=addMap('cluster-map',container,{styles:__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["e" /* googleMapStyles */]});loadClusterGeo().then(function(){drawKey();drawMinimap();addSchoolMarkers();});window.addEventListener('resize',function(){clearMarkers();addSchoolMarkers();window.google.maps.event.addListenerOnce(map,'idle',function(){map.fitBounds(clusterBounds);});});return{el:container,map:map};}var ClusterMap=function(_Component){_inherits(ClusterMap,_Component);function ClusterMap(){_classCallCheck(this,ClusterMap);return _possibleConstructorReturn(this,(ClusterMap.__proto__||Object.getPrototypeOf(ClusterMap)).apply(this,arguments));}_createClass(ClusterMap,[{key:'wrapChart',value:function wrapChart(){this.container=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);while(this.container.firstChild){this.container.removeChild(this.container.firstChild);}var data=this.props.data;var chart=makeMap(data);this.container.appendChild(chart.el);}},{key:'componentDidMount',value:function componentDidMount(){this.wrapChart();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.wrapChart();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return ClusterMap;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ClusterMap);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Create a custom overlay for our window marker display, extending google.maps.OverlayView.
 * This is somewhat complicated by needing to async load the google.maps api first - thus, we
 * wrap customInfoWindow into a closure, and when instantiating CustomNativeWindow, we first execute the closure
 * (to create our CustomNativeWindow function, now properly extending the newly loaded google.maps.OverlayView),
 * and then instantiate said function.
 * @type {Function}
 * @see _mapView.onRender
 * From: https://artandlogic.com/2014/02/custom-google-maps-info-windows/
 */var customInfoWindow=function customInfoWindow(){this.container=document.createElement('div');this.container.classList.add('map-info-window');this.layer=null;this.marker=null;this.position=null;};/**
 * Inherit from OverlayView
 * @type {google.maps.OverlayView}
 */customInfoWindow.prototype=new window.google.maps.OverlayView();/**
 * Called when this overlay is set to a map via this.setMap. Get the appropriate map pane
 * to add the window to, append the container, bind to close element.
 * @see customInfoWindow.open
 */customInfoWindow.prototype.onAdd=function(){this.layer=this.getPanes().floatPane;this.layer.appendChild(this.container);if(this.container.querySelector('.infowindow-close')){this.container.querySelector('.infowindow-close').addEventListener('click',function(){// Close info window on click
this.close();}.bind(this),false);}};/**
 * Called after onAdd, and every time the map is moved, zoomed, or anything else that
 * would effect positions, to redraw this overlay.
 */customInfoWindow.prototype.draw=function(){this.container.style.position='relative';this.container.style.display='inline-block';var markerIcon=this.marker.getIcon();var cBounds=this.container.getBoundingClientRect();var cHeight=cBounds.height+markerIcon.scaledSize.height/2+10;var cWidth=cBounds.width/2;this.position=this.getProjection().fromLatLngToDivPixel(this.marker.getPosition());this.container.style.top=this.position.y-cHeight+'px';this.container.style.left=this.position.x-cWidth+'px';};/**
 * Called when this overlay has its map set to null.
 * @see customInfoWindow.close
 */customInfoWindow.prototype.onRemove=function(){this.layer.removeChild(this.container);};/**
 * Sets the contents of this overlay.
 * @param {string} html
 */customInfoWindow.prototype.setContent=function(html){this.container.innerHTML=html;};/**
 * Sets the map and relevant marker for this overlay.
 * @param {google.maps.Map} map
 * @param {google.maps.Marker} marker
 */customInfoWindow.prototype.open=function(map,marker){this.marker=marker;this.setMap(map);};/**
 * Close this overlay by setting its map to null.
 */customInfoWindow.prototype.close=function(){this.setMap(null);};/* harmony default export */ __webpack_exports__["a"] = (customInfoWindow);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__singleClusterProjectionsTable__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__singleClusterProjectionsLineGraph__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_tabs__ = __webpack_require__(374);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClusterProjections=function(_Component){_inherits(ClusterProjections,_Component);function ClusterProjections(){_classCallCheck(this,ClusterProjections);return _possibleConstructorReturn(this,(ClusterProjections.__proto__||Object.getPrototypeOf(ClusterProjections)).apply(this,arguments));}_createClass(ClusterProjections,[{key:'render',value:function render(){var _props=this.props,data=_props.data,school=_props.school,isMetro=_props.isMetro,chartName=_props.chartName;var tabContent=[{label:'Chart',content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__singleClusterProjectionsLineGraph__["a" /* default */],{data:data,school:school,chartName:chartName})},{label:'Table',content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__singleClusterProjectionsTable__["a" /* default */],{data:data,school:school,isMetro:isMetro})}];var initialSelectedIndex=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_tabs__["a" /* default */],{data:tabContent,initialSelectedIndex:initialSelectedIndex});}}]);return ClusterProjections;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ClusterProjections);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__singleClusterProjectionsLineGraph_clusterAggregate__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__singleClusterProjectionsLineGraph_isSmallProjectedNode__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function makeTableRow(data,colcb){var tr=document.createElement('tr');data.forEach(function(d,i){colcb(tr,d,i);});return tr;}function makeInactiveSchoolsTable(unsortedData){var data=unsortedData.sort(function(a,b){return a.name<b.name?-1:1;});var inactiveSchools=data.filter(function(d){return!d.isActive;});var activeSchool=data.find(function(d){return d.isActive;});var firstLabel=activeSchool?'Percentage change in other schools':'Percentage change per school';var colLabels=[firstLabel].concat(_toConsumableArray(inactiveSchools[0].projections_years));// The 3rd column is always the "baseline" for enrolment variance
colLabels[2]=colLabels[2]+' (baseline)';var table=document.createElement('table');var tablehead=document.createElement('thead');var tablebody=document.createElement('tbody');table.setAttribute('summary','A table of figures showing projected % change in student population for all clusters. Shows percentage schools group name on left and time in 5 year increments across the top.');var tr=makeTableRow(colLabels,function(tr,d,i){var th=document.createElement('th');th.innerHTML=d;tr.appendChild(th);});tablehead.appendChild(tr);table.append(tablehead);inactiveSchools.forEach(function(school){var isThisSchoolSmall=Object(__WEBPACK_IMPORTED_MODULE_5__singleClusterProjectionsLineGraph_isSmallProjectedNode__["b" /* isSchoolSmall */])(school);var rowdata=[];rowdata.push( false?'<a href="?school='+school.uid+'">'+school.name+'</a>':school.name);for(var i=0;i<school.projections_percentage.length;i++){if(isThisSchoolSmall){rowdata.push('<50');}else{var percentage=school.projections_percentage[i];var count=school.projections[i];var prefix=percentage>0?'+':'';// First two years we want to show the raw number.
var d=i<=1?count:prefix+Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["b" /* format */])(percentage,0)+'%';rowdata.push(d);}}var tr=makeTableRow(rowdata,function(tr,d,i){var td=document.createElement('td');if(i===0){td=document.createElement('th');}td.innerHTML=d;tr.appendChild(td);});tablebody.appendChild(tr);});table.appendChild(tablebody);table.classList.add('summary-table');return table;}function makeActiveSchoolTable(schools,isMetro,activeCluster){var activeSchool=schools.find(function(d){return d.isActive;});if(!activeSchool){// Just return nothing for now. Later we should probably return a cluster summary
// return document.createElement('div');
activeSchool=Object(__WEBPACK_IMPORTED_MODULE_4__singleClusterProjectionsLineGraph_clusterAggregate__["a" /* default */])(schools,activeCluster);activeSchool.name='Schools Group Total';// Rather than 'Cluster Average'
}var isThisSchoolSmall=Object(__WEBPACK_IMPORTED_MODULE_5__singleClusterProjectionsLineGraph_isSmallProjectedNode__["b" /* isSchoolSmall */])(activeSchool);var colLabels=[activeSchool.name].concat(_toConsumableArray(activeSchool.projections_years));// The 3rd column is always the "baseline" for enrolment variance
colLabels[2]=colLabels[2]+' (baseline)';var table=document.createElement('table');var tablehead=document.createElement('thead');var tablebody=document.createElement('tbody');table.setAttribute('summary','A table of figures showing projected change in student population for '+activeSchool.name+'. Shows percentage change and student population on the left and time in 5 year increments across the top.');var tr=makeTableRow(colLabels,function(tr,d,i){var th=document.createElement('th');th.innerHTML=d;tr.appendChild(th);});tablehead.appendChild(tr);table.append(tablehead);var rowdata=[];rowdata.push('Percentage change');for(var i=0;i<activeSchool.projections_years.length;i++){if(isThisSchoolSmall){rowdata.push('-');}else{var percentage=activeSchool.projections_percentage[i];var prefix=percentage>0?'+':'';var d=i<=1?'-':prefix+Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["b" /* format */])(percentage,0)+'%';rowdata.push(d);}}tr=makeTableRow(rowdata,function(tr,d,i){var td=document.createElement('td');if(i===0){td=document.createElement('th');}td.innerHTML=d;tr.appendChild(td);});tablebody.appendChild(tr);rowdata=[];if(isMetro){rowdata.push('Student population');}else{rowdata.push('Enrolments');}for(var _i=0;_i<activeSchool.projections_years.length;_i++){if(isThisSchoolSmall){rowdata.push('<50');}else{var _percentage=activeSchool.projections[_i];rowdata.push(Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["b" /* format */])(_percentage,0));}}tr=makeTableRow(rowdata,function(tr,d,i){var td=document.createElement('td');if(i===0){td=document.createElement('th');}td.innerHTML=d;tr.appendChild(td);});tablebody.appendChild(tr);table.appendChild(tablebody);table.classList.add('summary-table');table.classList.add('current-cluster');return table;}function makeProjectionsTable(activeSchool,activeCluster,isMetro){var schools=activeCluster.schools.filter(function(d){return Array.isArray(d.projections);});var clusterTable=makeInactiveSchoolsTable(schools);var summaryTable=makeActiveSchoolTable(schools,isMetro,activeCluster);var container=document.createElement('div');container.appendChild(summaryTable);container.appendChild(clusterTable);container.classList.add('scroll-container');var pane=document.createElement('div');pane.appendChild(container);__WEBPACK_IMPORTED_MODULE_3_d3__["select"](pane).append('div').style('font-size','11px').text('Data subject to change.*');return pane;}var ClusterProjections=function(_Component){_inherits(ClusterProjections,_Component);function ClusterProjections(){_classCallCheck(this,ClusterProjections);return _possibleConstructorReturn(this,(ClusterProjections.__proto__||Object.getPrototypeOf(ClusterProjections)).apply(this,arguments));}_createClass(ClusterProjections,[{key:'wrapChart',value:function wrapChart(){this.container=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);while(this.container.firstChild){this.container.removeChild(this.container.firstChild);}var _props=this.props,data=_props.data,school=_props.school,isMetro=_props.isMetro;var chart=makeProjectionsTable(school,data,isMetro);this.container.appendChild(chart);}},{key:'componentDidMount',value:function componentDidMount(){this.wrapChart();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.wrapChart();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return ClusterProjections;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ClusterProjections);

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(132),
    baseMean = __webpack_require__(363);

/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */
function meanBy(array, iteratee) {
  return baseMean(array, baseIteratee(iteratee, 2));
}

module.exports = meanBy;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(285),
    getMatchData = __webpack_require__(348),
    matchesStrictComparable = __webpack_require__(146);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(133),
    baseIsEqual = __webpack_require__(138);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(47);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(47);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(47);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(47);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(46);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(46),
    Map = __webpack_require__(86),
    MapCache = __webpack_require__(88);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(135),
    isMasked = __webpack_require__(299),
    isObject = __webpack_require__(87),
    toSource = __webpack_require__(137);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(48);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(300);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(303),
    ListCache = __webpack_require__(46),
    Map = __webpack_require__(86);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(304),
    hashDelete = __webpack_require__(305),
    hashGet = __webpack_require__(306),
    hashHas = __webpack_require__(307),
    hashSet = __webpack_require__(308);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(49);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(49);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(49);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(49);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(50);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(50);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(50);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(50);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(133),
    equalArrays = __webpack_require__(139),
    equalByTag = __webpack_require__(320),
    equalObjects = __webpack_require__(324),
    getTag = __webpack_require__(343),
    isArray = __webpack_require__(17),
    isBuffer = __webpack_require__(142),
    isTypedArray = __webpack_require__(144);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(88),
    setCacheAdd = __webpack_require__(316),
    setCacheHas = __webpack_require__(317);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(48),
    Uint8Array = __webpack_require__(321),
    eq = __webpack_require__(134),
    equalArrays = __webpack_require__(139),
    mapToArray = __webpack_require__(322),
    setToArray = __webpack_require__(323);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(325);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(326),
    getSymbols = __webpack_require__(328),
    keys = __webpack_require__(140);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(327),
    isArray = __webpack_require__(17);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(329),
    stubArray = __webpack_require__(330);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(332),
    isArguments = __webpack_require__(141),
    isArray = __webpack_require__(17),
    isBuffer = __webpack_require__(142),
    isIndex = __webpack_require__(143),
    isTypedArray = __webpack_require__(144);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(35);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isLength = __webpack_require__(89),
    isObjectLike = __webpack_require__(35);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(136);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)(module)))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(339),
    nativeKeys = __webpack_require__(340);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(341);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(135),
    isLength = __webpack_require__(89);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(344),
    Map = __webpack_require__(86),
    Promise = __webpack_require__(345),
    Set = __webpack_require__(346),
    WeakMap = __webpack_require__(347),
    baseGetTag = __webpack_require__(34),
    toSource = __webpack_require__(137);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(27),
    root = __webpack_require__(15);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(145),
    keys = __webpack_require__(140);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(138),
    get = __webpack_require__(147),
    hasIn = __webpack_require__(356),
    isKey = __webpack_require__(90),
    isStrictComparable = __webpack_require__(145),
    matchesStrictComparable = __webpack_require__(146),
    toKey = __webpack_require__(51);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(351);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(352);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(88);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(354);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(48),
    arrayMap = __webpack_require__(355),
    isArray = __webpack_require__(17),
    isSymbol = __webpack_require__(91);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 355 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(357),
    hasPath = __webpack_require__(358);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(149),
    isArguments = __webpack_require__(141),
    isArray = __webpack_require__(17),
    isIndex = __webpack_require__(143),
    isLength = __webpack_require__(89),
    toKey = __webpack_require__(51);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(361),
    basePropertyDeep = __webpack_require__(362),
    isKey = __webpack_require__(90),
    toKey = __webpack_require__(51);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(148);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseSum = __webpack_require__(150);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */
function baseMean(array, iteratee) {
  var length = array == null ? 0 : array.length;
  return length ? (baseSum(array, iteratee) / length) : NAN;
}

module.exports = baseMean;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(132),
    baseSum = __webpack_require__(150);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__drawKey__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getYDomain__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getCustomAxis__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addNodes__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__addXAxisLabels__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enrolmentPercentLabel__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actualAndProjectedGrowth__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__clusterAggregate__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__getSchoolColor__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isSmallProjectedNode__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var schoolWithLineNodes=void 0;function makeProjectionsLineGraph(activeSchool,activeCluster){var SVGwidth=1000;var SVGheight=500;var axisPadding=40;var domainPadding=40;var tooltip=void 0;var svg=void 0;var data=activeCluster.schools.map(function(d){return d;}).filter(function(d){return Array.isArray(d.projections_percentage);});// Add the cluster aggregate as "another school"
var cluster=Object(__WEBPACK_IMPORTED_MODULE_14__clusterAggregate__["a" /* default */])(data,activeCluster);// The activeSchool is the one that's locally active - ie, that'll have
// node points with percentages above shown on it's line
// We set defaults here, but you can change it with the prev/next slider.
if(activeSchool){schoolWithLineNodes=activeSchool;}else{schoolWithLineNodes=cluster;}data.push(cluster);var margin={top:50,right:domainPadding,bottom:40+axisPadding,left:10+axisPadding+domainPadding};var width=SVGwidth-margin.left-margin.right;var height=SVGheight-margin.bottom-margin.top;var elm=document.createElement('div');var projectionStartDate=new Date();// This should be projections start date
var isLimited=true;var isThisSchoolSmall=Object(__WEBPACK_IMPORTED_MODULE_16__isSmallProjectedNode__["b" /* isSchoolSmall */])(schoolWithLineNodes);function setupToolTip(){var content='<div class="tooltip-content-wrapper">\n        <div class="tooltip-content">\n        <div>\n          <p class="tooltip-title"></p>\n          <p class="tooltip-baseline"></p>\n          <p class="tooltip-projection"></p>\n        </div>\n        </div>\n      </div>';tooltip=new __WEBPACK_IMPORTED_MODULE_6__tooltip__["a" /* default */](content);elm.appendChild(tooltip.elm);}var hideTimeout=void 0;var handleLineNodeClick=function handleLineNodeClick(d,i){__WEBPACK_IMPORTED_MODULE_5_d3__["event"].stopPropagation();var yearsLater=(i-1)*5;tooltip.show();var inc=schoolWithLineNodes.projections_percentage[Math.max(0,i)];var titleText=void 0;var projectionText=void 0;var baselineText=void 0;if(yearsLater<0){titleText='In '+schoolWithLineNodes.projections_years[0];baselineText=Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["b" /* format */])(schoolWithLineNodes.projections[0])+' students';var growth=schoolWithLineNodes.projections[0]-schoolWithLineNodes.projections[1];var lessOrMore=growth>=0?'more':'less';projectionText=Math.abs(growth)+' '+lessOrMore+' than '+schoolWithLineNodes.projections_years[1];}else if(yearsLater===0){titleText='Baseline';baselineText=Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["b" /* format */])(schoolWithLineNodes.projections[1])+' students';var _growth=schoolWithLineNodes.projections[1]-schoolWithLineNodes.projections[0];var sign=_growth>=0?'+':'';projectionText=''+sign+_growth+' since '+schoolWithLineNodes.projections_years[0];}else{yearsLater-=1;if(isThisSchoolSmall&&yearsLater>0){titleText='';projectionText=yearsLater+' years later: <50';}else{titleText=(inc<0?'':'+')+Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["b" /* format */])(inc,0)+'% students';projectionText=yearsLater+' years later: '+Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["b" /* format */])(schoolWithLineNodes.projections[i],0);}baselineText='Baseline: '+Object(__WEBPACK_IMPORTED_MODULE_4__modules_helpers__["b" /* format */])(schoolWithLineNodes.projections[1]);}tooltip.elm.querySelector('.tooltip-title').innerHTML=titleText;tooltip.elm.querySelector('.tooltip-baseline').innerHTML=baselineText;tooltip.elm.querySelector('.tooltip-projection').innerHTML=projectionText;var bb=this.getBoundingClientRect();var scrollX=window.scrollX||document.documentElement.scrollLeft;var scrollY=window.scrollY||document.documentElement.scrollTop;var top=(bb.top+scrollY+(bb.top+scrollY))/2-tooltip.elm.clientHeight-10;var left=bb.left+bb.width/2+scrollX-tooltip.elm.clientWidth/2;tooltip.move(top,left);if(__WEBPACK_IMPORTED_MODULE_5_d3__["event"].type==='mouseover'){clearTimeout(hideTimeout);__WEBPACK_IMPORTED_MODULE_5_d3__["event"].target.addEventListener('mouseout',function(){clearTimeout(hideTimeout);hideTimeout=setTimeout(function(){tooltip.hide();},2000);});}};setupToolTip();function getDateFromIndex(i){var addYears=new Date(projectionStartDate.getTime());addYears.setYear(projectionStartDate.getFullYear()+i);return addYears;}__WEBPACK_IMPORTED_MODULE_5_d3__["selection"].prototype.moveToFront=function(){return this.each(function(){this.parentNode.appendChild(this);});};svg=__WEBPACK_IMPORTED_MODULE_5_d3__["select"](elm).append('svg').attr('viewBox','0 0 '+SVGwidth+' '+SVGheight);svg.attr('class','cluster-chart');var svgContainer=svg.append('g').attr('class','stage').attr('transform','translate('+margin.left+','+margin.top+')');// set the ranges
var x=__WEBPACK_IMPORTED_MODULE_5_d3__["scaleTime"]().range([0,width]);var y=__WEBPACK_IMPORTED_MODULE_5_d3__["scaleLinear"]().range([height,0]);// Scale the range of the data
var maxX=__WEBPACK_IMPORTED_MODULE_5_d3__["max"](data,function(d){return __WEBPACK_IMPORTED_MODULE_5_d3__["max"](d.projections,function(p,i){return getDateFromIndex(i);});});var minX=projectionStartDate;x.domain([minX,maxX]);y.domain(Object(__WEBPACK_IMPORTED_MODULE_8__getYDomain__["a" /* default */])(data,activeSchool,isLimited));__WEBPACK_IMPORTED_MODULE_13__actualAndProjectedGrowth__["a" /* default */].drawRectangle(svgContainer,getDateFromIndex,x,y);var yAxis=svgContainer.append('g').attr('class','yAxis').attr('transform','translate(-'+domainPadding+', 0)');// define the line
var regularLine=__WEBPACK_IMPORTED_MODULE_5_d3__["line"]().x(function(d,i){return x(getDateFromIndex(i));}).y(function(d){return y(d);});var schoolLine=__WEBPACK_IMPORTED_MODULE_5_d3__["line"]().x(function(d,i){return x(getDateFromIndex(i));}).y(function(d,i,e){if(Object(__WEBPACK_IMPORTED_MODULE_16__isSmallProjectedNode__["a" /* default */])(i)){var currentYear=e[1];return y(currentYear);}return y(d);});// Add the projectionsLine path.
var schools=svgContainer.selectAll('.school').data(data).enter().append('g').attr('class',function(d){var className='school';if(d.isActive)className+=' this-school';if(schoolWithLineNodes&&d.uid===schoolWithLineNodes.uid)className+=' locally-active-school';return className;});schools.selectAll('path').data(function(d){return[d];}).enter().append('path').attr('class','line').attr('fill','none').style('stroke-dasharray',function(d){return d.isClusterAggregate?'6, 3':'3, 0';}).attr('d',function(d){var isThisLineSmall=Object(__WEBPACK_IMPORTED_MODULE_16__isSmallProjectedNode__["b" /* isSchoolSmall */])(d);if(isThisLineSmall){return schoolLine(d.projections_percentage);}return regularLine(d.projections_percentage);});var legendKeyWrapper=__WEBPACK_IMPORTED_MODULE_5_d3__["select"](elm).append('div').attr('class','projections-key-legend');var keyWrapper=legendKeyWrapper.append('div').attr('class','projections-key');__WEBPACK_IMPORTED_MODULE_13__actualAndProjectedGrowth__["a" /* default */].drawLabels(svgContainer,getDateFromIndex,x,y);__WEBPACK_IMPORTED_MODULE_12__enrolmentPercentLabel__["a" /* default */].draw(svgContainer,domainPadding,y);function updateChart(){Object(__WEBPACK_IMPORTED_MODULE_7__drawKey__["a" /* default */])(keyWrapper,activeCluster,activeSchool,schoolWithLineNodes);__WEBPACK_IMPORTED_MODULE_12__enrolmentPercentLabel__["a" /* default */].update();svgContainer.selectAll('.school path').attr('stroke',Object(__WEBPACK_IMPORTED_MODULE_15__getSchoolColor__["a" /* default */])(schoolWithLineNodes)).attr('stroke-width',function(d){if(d.isActive)return 3;if(d.isClusterAggregate)return 3;if(d.uid===schoolWithLineNodes.uid)return 3;return 1;});var nodesData=schoolWithLineNodes.projections_percentage;__WEBPACK_IMPORTED_MODULE_13__actualAndProjectedGrowth__["a" /* default */].update(svgContainer,getDateFromIndex,x,y);var multiplier=2.5;var ticks=5;if(window.matchMedia('(min-width: 600px)').matches){multiplier=1;ticks=null;}yAxis.call(__WEBPACK_IMPORTED_MODULE_5_d3__["axisLeft"](y).ticks(ticks).tickFormat(function(d){// Don't show the top most axis tick - the y-axis label would cover it.
if(d===y.domain()[1])return'';// Don't show ticks below 0%. It should almost never happen that a
// cluster goes down in enrolments. So negative values would only come
// into play for the "actual growth" segment of the line, which DoE
// prefers to indicate in actual number of extra students, not percent
if(d<0)return'';return d;}));var customAxis=Object(__WEBPACK_IMPORTED_MODULE_9__getCustomAxis__["a" /* default */])(width,domainPadding);yAxis.call(customAxis);schools.attr('class',function(d){var className='school';if(d.isActive)className+=' this-school';if(schoolWithLineNodes&&d.uid===schoolWithLineNodes.uid){className+=' locally-active-school';}return className;});svg.select('.circle-group').remove();var nodesGroup=svg.select('.locally-active-school').append('g').attr('class','circle-group');svg.select('.locally-active-school').moveToFront();var isLocallyActiveSchoolSmall=Object(__WEBPACK_IMPORTED_MODULE_16__isSmallProjectedNode__["b" /* isSchoolSmall */])(schoolWithLineNodes);Object(__WEBPACK_IMPORTED_MODULE_10__addNodes__["a" /* default */])(nodesGroup,nodesData,schoolWithLineNodes,getDateFromIndex,handleLineNodeClick,multiplier,x,y,isLocallyActiveSchoolSmall);Object(__WEBPACK_IMPORTED_MODULE_11__addXAxisLabels__["a" /* default */])(nodesGroup,nodesData,schoolWithLineNodes,getDateFromIndex,x,height,axisPadding);}window.addEventListener('resize',updateChart);updateChart();return{updateChart:updateChart,elm:elm};}var ClusterProjections=function(_Component){_inherits(ClusterProjections,_Component);function ClusterProjections(){_classCallCheck(this,ClusterProjections);return _possibleConstructorReturn(this,(ClusterProjections.__proto__||Object.getPrototypeOf(ClusterProjections)).apply(this,arguments));}_createClass(ClusterProjections,[{key:'wrapChart',value:function wrapChart(){this.container=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);while(this.container.firstChild){this.container.removeChild(this.container.firstChild);}var _props=this.props,data=_props.data,school=_props.school;this.chart=makeProjectionsLineGraph(school,data);this.container.appendChild(this.chart.elm);}},{key:'componentDidMount',value:function componentDidMount(){this.wrapChart();}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(__WEBPACK_IMPORTED_MODULE_5_d3__["event"])__WEBPACK_IMPORTED_MODULE_5_d3__["event"].stopPropagation();schoolWithLineNodes=this.props.ui.selectedSchool?this.props.ui.selectedSchool:null;if(schoolWithLineNodes){this.chart.updateChart();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return ClusterProjections;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){return{ui:state.ui[ownProps.chartName]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectSchool:function selectSchool(p){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])(p));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ClusterProjections));

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
function drawKey(keyWrapper,activeCluster,activeSchool,schoolWithLineNodes){keyWrapper.html('');if(activeSchool){var key1=keyWrapper.append('div');key1.append('div').style('width','30px').style('height','3px').style('background',function(d){return'#05E2FC';});key1.append('div').text(activeSchool.name);}var key2=keyWrapper.append('div');key2.append('div').style('width','30px').style('height','1px').style('background','#7A96A5');var key2Text=activeSchool?'Other schools in '+activeCluster.name+' schools group':'Schools in '+activeCluster.name+' schools group';key2.append('div').text(key2Text);var key3=keyWrapper.append('div');key3.append('svg').attr('width',30).attr('height',3).attr('viewBox','0, 0, 30, 3').html('\n    <line x1="0" y1="0" x2="200" y2="0" style="stroke:#007C98;stroke-width:10;stroke-dasharray:6,3;stroke-dashoffset:1;" />\n  ');key3.append('div').text('Average of '+activeCluster.name+' schools group');if(schoolWithLineNodes&&schoolWithLineNodes.uid!==__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(activeSchool,'uid','')&&!schoolWithLineNodes.isClusterAggregate){var _key=keyWrapper.append('div');_key.append('div').style('width','30px').style('height','3px').style('background',function(d){return'#404040';});_key.append('div').text(schoolWithLineNodes.name);}keyWrapper.append('div').style('width','100%').text('Data subject to change.*');}/* harmony default export */ __webpack_exports__["a"] = (drawKey);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__roundNumber__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isSmallProjectedNode__ = __webpack_require__(52);
function getYDomain(data){var activeSchool=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;// We could directly return the limit we calculated, however this might (depending on the calculation)
// leave a lot of empty space at the top of the graph, so, provided the point is within this limit, we calculate
// the extents (relatively) normally.
var max=35;var min=-10;data.forEach(function(school){var yearExtents=__WEBPACK_IMPORTED_MODULE_0_d3__["extent"](school.projections_percentage);if(Object(__WEBPACK_IMPORTED_MODULE_2__isSmallProjectedNode__["b" /* isSchoolSmall */])(school)){yearExtents[1]=Math.max(school.projections_percentage[0],school.projections_percentage[1]);}if(yearExtents[1]>max){// If we're not limiting our extents or if we're under the threshold
max=yearExtents[1];}if(yearExtents[0]<min){min=yearExtents[0];}});// Default: take the max of the active school and then add 20% padding,
// so we have breathing room for the node labels
if(activeSchool){var activeMax=__WEBPACK_IMPORTED_MODULE_0_d3__["max"](activeSchool.projections_percentage);var maxThreshold=activeMax*1.2;if(max<maxThreshold){max=maxThreshold;}}else{max*=1.2;min*=1.2;}// We round up/down to 10 because it'll mean the axis ticks look nice
// and there's a full-increment tick at the start/end of the y axis
return[__WEBPACK_IMPORTED_MODULE_1__roundNumber__["a" /* default */].downTo10(min),__WEBPACK_IMPORTED_MODULE_1__roundNumber__["a" /* default */].upTo10(max)];}/* harmony default export */ __webpack_exports__["a"] = (getYDomain);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// eg. 19 -> 20; -25 -> -20
function upTo10(i){return Math.ceil(i/10)*10;}// eg. 19 -> 10; -25 -> -30
function downTo10(i){return Math.floor(i/10)*10;}/* harmony default export */ __webpack_exports__["a"] = ({upTo10:upTo10,downTo10:downTo10});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getCustomAxis(width,domainPadding){return function customAxis(g){g.attr('font-family',null);g.selectAll('.domain').remove();g.selectAll('g:last-of-type').remove();g.selectAll('line').attr('x1',width+domainPadding*2).attr('stroke-dasharray','2 4').attr('stroke','#CCC');g.selectAll('text').style('font-size',function(d){if(window.matchMedia('(min-width: 600px)').matches){return'0.75rem';}return'1.5rem';}).style('fill','#404040').attr('class','y-label').attr('text-anchor','start').attr('dx',-5).attr('x',0);};}/* harmony default export */ __webpack_exports__["a"] = (getCustomAxis);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_helpers_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSchoolColor__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSmallProjectedNode__ = __webpack_require__(52);
function addNodes(nodesGroup,nodesData,schoolWithLineNodes,getDateFromIndex,handleClick,multiplier,x,y,isActiveSchoolSmall){var nodes=nodesGroup.selectAll('.circle').data(nodesData);nodes.enter().filter(function(d){return!isNaN(d);}).append('circle').attr('class','circle').style('fill',function(d,i){if(i===0)return'white';return Object(__WEBPACK_IMPORTED_MODULE_1__getSchoolColor__["a" /* default */])(schoolWithLineNodes)(schoolWithLineNodes);}).style('stroke',function(d,i){if(i>0)return'white';return Object(__WEBPACK_IMPORTED_MODULE_1__getSchoolColor__["a" /* default */])(schoolWithLineNodes)(schoolWithLineNodes);}).style('cursor','pointer').attr('tabindex',0).attr('cx',function(d,i){return x(getDateFromIndex(i));}).attr('cy',function(d,i,e){if(Object(__WEBPACK_IMPORTED_MODULE_3__isSmallProjectedNode__["a" /* default */])(i)){var currentYear=e[1].__data__;return y(currentYear);}return y(d);}).on('mouseover',handleClick).on('click',function(d,i){var e=__WEBPACK_IMPORTED_MODULE_2_d3__["event"];e.stopPropagation();}).on('keydown',function(d,i){var e=__WEBPACK_IMPORTED_MODULE_2_d3__["event"];var keys={SPACE:32,ENTER:13};if(e.type==='click'||e.keyCode===keys.SPACE||e.keyCode===keys.ENTER){handleClick.call(this,d,i);}}).merge(nodes).style('stroke-width',function(){return 3*multiplier+'px';}).transition().attr('r',function(){return 6*multiplier;}).attr('cx',function(d,i){return x(getDateFromIndex(i));}).attr('cy',function(d,i,e){if(Object(__WEBPACK_IMPORTED_MODULE_3__isSmallProjectedNode__["a" /* default */])(i)&&isActiveSchoolSmall){var currentYear=e[1].__data__;return y(currentYear);}return y(d);});var textLabels=nodesGroup.selectAll('.text-label').data(nodesData);textLabels.enter().filter(function(d){return!isNaN(d);}).append('text').attr('class','text-label').text(function(d,i,e){if(i===0)return'';if(i===1)return'';if(Object(__WEBPACK_IMPORTED_MODULE_3__isSmallProjectedNode__["a" /* default */])(i)&&isActiveSchoolSmall){var currentYear=e[1].__data__;d=currentYear;}return(d<0?'':'+')+Object(__WEBPACK_IMPORTED_MODULE_0__modules_helpers_js__["b" /* format */])(d,0)+'%';}).attr('x',function(d,i){return x(getDateFromIndex(i));}).merge(textLabels).attr('text-anchor','middle').attr('y',function(d,i,e){if(Object(__WEBPACK_IMPORTED_MODULE_3__isSmallProjectedNode__["a" /* default */])(i)&&isActiveSchoolSmall){var currentYear=e[1].__data__;return y(currentYear)-15*multiplier;}return y(d)-15*multiplier;});nodesGroup.moveToFront();}/* harmony default export */ __webpack_exports__["a"] = (addNodes);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function addXAxisLabels(nodesGroup,nodesData,schoolWithLineNodes,getDateFromIndex,x,height,axisPadding){var axisLabels=nodesGroup.selectAll('.x-label').data(nodesData);var baselineText=window.matchMedia('(min-width: 600px)').matches?'used as baseline':'baseline';var XAxisLables=schoolWithLineNodes.projections_years;axisLabels.enter().append('text').html(function(d,i){if(i===1){return'\n          <tspan dy="0">'+XAxisLables[i]+'</tspan>\n          <tspan x='+x(getDateFromIndex(i))+' dy="1.3em">('+baselineText+')</tspan>\n        ';}return XAxisLables[i];}).style('font-size',function(d){if(window.matchMedia('(min-width: 600px)').matches){return'0.75rem';}return'1.5rem';}).style('fill','#404040').attr('class','x-label').attr('text-anchor','middle').attr('x',function(d,i){return x(getDateFromIndex(i));}).attr('y',function(d){return height+axisPadding;});}/* harmony default export */ __webpack_exports__["a"] = (addXAxisLabels);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_d3__);
var enrolmentLabel=void 0;function draw(svgContainer,domainPadding,y){var axisPos=-domainPadding-50;__WEBPACK_IMPORTED_MODULE_0_d3__["select"]('.enrolment-percent-label').remove();enrolmentLabel=svgContainer.append('text').attr('class','enrolment-percent-label').style('fill','#404040').style('font-size','0.75rem').attr('text-anchor','left').attr('y',y(y.domain()[1]));enrolmentLabel.append('tspan').attr('x',axisPos).attr('dy',0).text('Enrolment');enrolmentLabel.append('tspan').attr('x',axisPos).attr('dy','1.2em').text('change (%)');update();}function update(){enrolmentLabel.style('display',function(d){if(window.matchMedia('(min-width: 600px)').matches){return'';}return'none';});}/* harmony default export */ __webpack_exports__["a"] = ({draw:draw,update:update});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var leftArrow='\n  <?xml version="1.0" encoding="utf-8"?>\n  <svg viewBox="-1.0095806121826172 -1.0289530754089355 14.483792304992676 10.08852481842041" width="13px" height="9px" xmlns="http://www.w3.org/2000/svg">\n    <g fill="none" stroke-linecap="round" stroke="#404040">\n      <path d="M1.44117647,3.88235294 L12.4411765,3.88235294" stroke-width="2"/>\n      <polyline stroke-width="2" stroke-linejoin="round" points="4 0 0 4 4 8.02057087"/>\n    </g>\n  </svg>\n';var rightArrow='\n  <?xml version="1.0" encoding="utf-8"?>\n  <svg viewBox="-1.0095806121826172 -1.0289530754089355 14.483792304992676 10.08852481842041" width="13px" height="9px" xmlns="http://www.w3.org/2000/svg">\n    <g fill="none" stroke-linecap="round" stroke="#404040" transform="matrix(-1, 0, 0, 1, 12.441176, 0)">\n      <path d="M1.44117647,3.88235294 L12.4411765,3.88235294" stroke-width="2"/>\n      <polyline stroke-width="2" stroke-linejoin="round" points="4 0 0 4 4 8.02057087"/>\n    </g>\n  </svg>\n';// The second data point (zero-indexed) is always the baseline
var baselineIndex=1;var actualLabel=void 0;var projectedLabel=void 0;var leftArrowNode=void 0;var rightArrowNode=void 0;var xOffset=20;var yOffset=void 0;var yMargin=36;var yPadding=8;function drawRectangle(svgContainer,getDateFromIndex,x,y){var rectY=y.range()[1]-yMargin-yPadding;var height=Math.abs(y.range()[1]-y.range()[0])+yMargin+yPadding;var left=0;var xPos=x(getDateFromIndex(baselineIndex));svgContainer.append('rect').attr('x',left).attr('y',rectY).attr('width',xPos).attr('height',height).style('fill','#F3F3F3');}function drawLabels(svgContainer,getDateFromIndex,x,y){var xPos=x(getDateFromIndex(baselineIndex));var ticks=y.ticks();var midpointOfLast2Ticks=(ticks[ticks.length-1]+ticks[ticks.length-2])/2;yOffset=y(midpointOfLast2Ticks)-yMargin;actualLabel=svgContainer.append('text').attr('text-anchor','end').attr('dx',-xOffset);projectedLabel=svgContainer.append('text').attr('text-anchor','start').attr('dx',xOffset);// Apply shared properties
[actualLabel,projectedLabel].forEach(function(el){el.style('fill','#404040').attr('alignment-baseline','central').attr('y',yOffset).attr('x',xPos);});leftArrowNode=svgContainer.append('g').html(leftArrow);rightArrowNode=svgContainer.append('g').html(rightArrow);}var firstUpdate=true;function update(svgContainer,getDateFromIndex,x,y){var desktop=window.matchMedia('(min-width: 600px)').matches;var arrowWidth=void 0;var arrowHeight=void 0;var xSpacing=void 0;var yDelta=void 0;if(desktop){projectedLabel.text('Projected growth');actualLabel.text('Actual growth');arrowWidth=13;arrowHeight=9;xSpacing=20;yDelta=3;}else{// Shorter labels for mobile
projectedLabel.text('Projected');actualLabel.text('Actual');arrowWidth=26;arrowHeight=18;xSpacing=40;yDelta=7;}[actualLabel,projectedLabel].forEach(function(el){el.style('font-size',function(d){return desktop?'0.75rem':'1.5rem';});});[rightArrowNode,leftArrowNode].forEach(function(el){el.select('svg').attr('width',arrowWidth).attr('height',arrowHeight);});// Firefox can't compute the BBox of a node that hasn't rendered yet.
// https://bugzilla.mozilla.org/show_bug.cgi?id=612118
// Reported:	7 years ago :)
// We need to return early.
if(firstUpdate){firstUpdate=false;return;}// Resize left arrow
var bboxLeft=actualLabel.node().getBBox();leftArrowNode.attr('transform','translate('+(bboxLeft.x-xSpacing)+','+(yOffset-yDelta)+')');// Resize right arrow
var bboxRight=projectedLabel.node().getBBox();rightArrowNode.attr('transform','translate('+(bboxRight.x+bboxRight.width+xSpacing-arrowWidth)+','+(yOffset-yDelta)+')');}/* harmony default export */ __webpack_exports__["a"] = ({drawRectangle:drawRectangle,drawLabels:drawLabels,update:update});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tabs__ = __webpack_require__(375);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_Tabs__["a" /* default */]);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabList__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Panels__ = __webpack_require__(378);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Tabs = function (_Component) {
    _inherits(Tabs, _Component);

    function Tabs(props) {
        _classCallCheck(this, Tabs);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleClick = function (e, index) {
            e.preventDefault();

            if (_this.state.selectedIndex === index) {
                return;
            }

            _this.setState({
                userInvokedSelection: true,
                selectedIndex: index
            });
        };

        _this.handleKeyDown = function (e) {
            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                e.preventDefault();
            } else {
                return;
            }

            var targetIndex = void 0;

            if (e.key === 'ArrowLeft' && _this.state.selectedIndex > 0) {
                targetIndex = _this.state.selectedIndex - 1;
            } else if (e.key === 'ArrowRight' && _this.state.selectedIndex < _this.tabTriggersLength - 1) {
                targetIndex = _this.state.selectedIndex + 1;
            } else {
                return;
            }

            _this.setState({
                userInvokedSelection: true,
                selectedIndex: targetIndex
            });
        };

        _this.resetUserInvokedSelection = function () {
            _this.setState({
                userInvokedSelection: false
            });
        };

        _this.tabTriggersLength = _this.props.data.length;

        _this.state = {
            userInvokedSelection: false,
            selectedIndex: _this.props.initialSelectedIndex < 0 || _this.props.initialSelectedIndex > _this.tabTriggersLength - 1 ? 0 : _this.props.initialSelectedIndex
        };
        return _this;
    }

    Tabs.prototype.render = function render() {
        if (!this.tabTriggersLength) {
            return null;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'tabs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TabList__["a" /* default */], _extends({}, this.props, {
                userInvokedSelection: this.state.userInvokedSelection,
                selectedIndex: this.state.selectedIndex,
                onClick: this.handleClick,
                onKeyDown: this.handleKeyDown,
                resetUserInvokedSelection: this.resetUserInvokedSelection
            })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Panels__["a" /* default */], _extends({}, this.props, { selectedIndex: this.state.selectedIndex }))
        );
    };

    return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Tabs.defaultProps = {
    data: [],
    initialSelectedIndex: 0
};

 false ? Tabs.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        content: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.string]))])
    })),
    selectedIndex: PropTypes.number,
    initialSelectedIndex: PropTypes.number
} : void 0;

/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tab__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_idSafeName__ = __webpack_require__(153);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TabList = function (_Component) {
    _inherits(TabList, _Component);

    function TabList() {
        _classCallCheck(this, TabList);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    TabList.prototype.render = function render() {
        var _props = this.props;
        var data = _props.data;
        var userInvokedSelection = _props.userInvokedSelection;
        var selectedIndex = _props.selectedIndex;
        var onClick = _props.onClick;
        var onKeyDown = _props.onKeyDown;
        var resetUserInvokedSelection = _props.resetUserInvokedSelection;


        if (!data.length) {
            return null;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            { role: 'tablist', className: 'tabs__tab-list' },
            data.map(function (tab, index) {
                var id = Object(__WEBPACK_IMPORTED_MODULE_3__helpers_idSafeName__["a" /* default */])(tab.label, index);

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Tab__["a" /* default */], {
                    key: id,
                    id: id,
                    index: index,
                    label: tab.label,
                    userInvokedSelection: userInvokedSelection,
                    selectedIndex: selectedIndex,
                    onClick: onClick,
                    onKeyDown: onKeyDown,
                    resetUserInvokedSelection: resetUserInvokedSelection
                });
            })
        );
    };

    return TabList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

 false ? TabList.propTypes = {
    data: PropTypes.array,
    selectedIndex: PropTypes.number,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func
} : void 0;

/* harmony default export */ __webpack_exports__["a"] = (TabList);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Tab = function (_Component) {
    _inherits(Tab, _Component);

    function Tab() {
        _classCallCheck(this, Tab);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Tab.prototype.componentDidUpdate = function componentDidUpdate() {
        var _props = this.props;
        var id = _props.id;
        var index = _props.index;
        var userInvokedSelection = _props.userInvokedSelection;
        var selectedIndex = _props.selectedIndex;
        var resetUserInvokedSelection = _props.resetUserInvokedSelection;

        var isSelected = index === selectedIndex;

        if (userInvokedSelection && isSelected && this.refs[id]) {
            this.refs[id].focus();
            resetUserInvokedSelection();
        }
    };

    Tab.prototype.render = function render() {
        var _props2 = this.props;
        var id = _props2.id;
        var index = _props2.index;
        var label = _props2.label;
        var selectedIndex = _props2.selectedIndex;
        var _onClick = _props2.onClick;
        var _onKeyDown = _props2.onKeyDown;

        var isSelected = index === selectedIndex;
        var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('tabs__trigger', { 'is-selected': isSelected });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: 'tabs__tab-list-item', role: 'presentation' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                    ref: id,
                    'aria-controls': id,
                    'aria-selected': isSelected,
                    className: className,
                    href: '#' + id,
                    role: 'tab',
                    tabIndex: isSelected ? 0 : -1,
                    onClick: function onClick(e) {
                        return _onClick(e, index);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return _onKeyDown(e);
                    }
                },
                label
            )
        );
    };

    return Tab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

 false ? Tab.propTypes = {
    id: PropTypes.string,
    index: PropTypes.number,
    label: PropTypes.string,
    selectedIndex: PropTypes.number,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func
} : void 0;

/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_addons_create_fragment__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_addons_create_fragment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_addons_create_fragment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Panel__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_idSafeName__ = __webpack_require__(153);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Panels = function (_Component) {
    _inherits(Panels, _Component);

    function Panels() {
        _classCallCheck(this, Panels);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Panels.prototype.render = function render() {
        var _props = this.props;
        var data = _props.data;
        var selectedIndex = _props.selectedIndex;


        if (!data.length) {
            return null;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'tabs__panels' },
            data.map(function (panel, index) {
                var id = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_idSafeName__["a" /* default */])(panel.label, index);
                var o = {};

                o[id] = panel.content;
                var children = __WEBPACK_IMPORTED_MODULE_2_react_addons_create_fragment___default()(o);

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_3__Panel__["a" /* default */],
                    {
                        key: id,
                        id: id,
                        index: index,
                        selectedIndex: selectedIndex },
                    children
                );
            })
        );
    };

    return Panels;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

 false ? Panels.propTypes = {
    data: PropTypes.array,
    selectedIndex: PropTypes.number
} : void 0;

/* harmony default export */ __webpack_exports__["a"] = (Panels);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var React = __webpack_require__(4);

var REACT_ELEMENT_TYPE =
  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
  0xeac7;

var emptyFunction = __webpack_require__(7);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(1);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

var didWarnAboutMaps = false;

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

function getIteratorFn(maybeIterable) {
  var iteratorFn =
    maybeIterable &&
    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
      maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function(match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

function traverseAllChildrenImpl(
  children,
  nameSoFar,
  callback,
  traverseContext
) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (
    children === null ||
    type === 'string' ||
    type === 'number' ||
    // The following is inlined from ReactElement. This means we can optimize
    // some checks. React Fiber also inlines this logic for similar purposes.
    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
  ) {
    callback(
      traverseContext,
      children,
      // If it's the only child, treat the name as if it was wrapped in an array
      // so that it's consistent if the number of children grows.
      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
    );
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(
        child,
        nextName,
        callback,
        traverseContext
      );
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      if (false) {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          warning(
            didWarnAboutMaps,
            'Using Maps as children is unsupported and will likely yield ' +
              'unexpected results. Convert it to a sequence/iterable of keyed ' +
              'ReactElements instead.'
          );
          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step;
      var ii = 0;
      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(
          child,
          nextName,
          callback,
          traverseContext
        );
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum =
          ' If you meant to render a collection of children, use an array ' +
          'instead or wrap the object using createFragment(object) from the ' +
          'React add-ons.';
      }
      var childrenString = '' + children;
      invariant(
        false,
        'Objects are not valid as a React child (found: %s).%s',
        childrenString === '[object Object]'
          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
          : childrenString,
        addendum
      );
    }
  }

  return subtreeCount;
}

function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

function cloneAndReplaceKey(oldElement, newKey) {
  return React.cloneElement(
    oldElement,
    {key: newKey},
    oldElement.props !== undefined ? oldElement.props.children : undefined
  );
}

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

var oneArgumentPooler = function(copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  invariant(
    instance instanceof Klass,
    'Trying to release an instance into a pool of a different type.'
  );
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function() {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(
      mappedChild,
      result,
      childKey,
      emptyFunction.thatReturnsArgument
    );
  } else if (mappedChild != null) {
    if (React.isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(
        mappedChild,
        // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        keyPrefix +
          (mappedChild.key && (!child || child.key !== mappedChild.key)
            ? escapeUserProvidedKey(mappedChild.key) + '/'
            : '') +
          childKey
      );
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(
    array,
    escapedPrefix,
    func,
    context
  );
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

var numericPropertyRegex = /^\d+$/;

var warnedAboutNumeric = false;

function createReactFragment(object) {
  if (typeof object !== 'object' || !object || Array.isArray(object)) {
    warning(
      false,
      'React.addons.createFragment only accepts a single object. Got: %s',
      object
    );
    return object;
  }
  if (React.isValidElement(object)) {
    warning(
      false,
      'React.addons.createFragment does not accept a ReactElement ' +
        'without a wrapper object.'
    );
    return object;
  }

  invariant(
    object.nodeType !== 1,
    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
      'elements are not valid children of React components.'
  );

  var result = [];

  for (var key in object) {
    if (false) {
      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
        warning(
          false,
          'React.addons.createFragment(...): Child objects should have ' +
            'non-numeric keys so ordering is preserved.'
        );
        warnedAboutNumeric = true;
      }
    }
    mapIntoWithKeyPrefixInternal(
      object[key],
      result,
      key,
      emptyFunction.thatReturnsArgument
    );
  }

  return result;
}

module.exports = createReactFragment;


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Panel = function (_Component) {
    _inherits(Panel, _Component);

    function Panel() {
        _classCallCheck(this, Panel);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Panel.prototype.createMarkup = function createMarkup(str) {
        return { __html: str };
    };

    Panel.prototype.renderContents = function renderContents(child) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child) ? child : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: this.createMarkup(child) });
    };

    Panel.prototype.render = function render() {
        var _props = this.props;
        var children = _props.children;
        var id = _props.id;
        var index = _props.index;
        var selectedIndex = _props.selectedIndex;

        var isSelected = index === selectedIndex;
        var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('tabs__panel', { 'is-hidden': !isSelected });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'section',
            {
                'aria-hidden': !isSelected,
                className: className,
                id: id,
                role: 'tabpanel',
                tabIndex: isSelected ? 0 : -1 },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, this.renderContents, this)
        );
    };

    return Panel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

 false ? Panel.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.string]))]),
    id: PropTypes.string,
    index: PropTypes.number,
    selectedIndex: PropTypes.number
} : void 0;

/* harmony default export */ __webpack_exports__["a"] = (Panel);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_filter_data__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tooltip__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_d3__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var svg=void 0;var tooltip=void 0;function makeEnrolment(data,cluster,chartName){// Quick helper to update the totals when changing test data
// SVG dimensions
var width=1000;var height=500;var minHeight=256;var padding={top:10,right:10,bottom:50,left:10};var numCols=25;var numRows=8;var xGutter=0;var yGutter=10;var activeSchool=void 0;var scaleFactor=void 0;var totalIcons=0;// SVG padding
// Horizontal and vertical spacing between the icons
var offset=0;// Top level elements
var elm=void 0;var aside=void 0;var main=void 0;var key=void 0;var pictoGrid=void 0;// Final gid dimensions
var xSize=(width-(padding.left+padding.right)-xGutter*(numCols-1))/numCols;var ySize=(height-(padding.top+padding.bottom)-yGutter*(numRows-1))/numRows;var student_data=__WEBPACK_IMPORTED_MODULE_6__modules_filter_data__["a" /* default */].studentEnrolment(data.schools);function initialiseElements(){elm=document.createElement('div');aside=__WEBPACK_IMPORTED_MODULE_8_d3__["select"](elm).append('div').attr('class','aside');main=__WEBPACK_IMPORTED_MODULE_8_d3__["select"](elm).append('div').attr('class','main').attr('aria-hidden','true');svg=main.append('svg').attr('viewBox','0 0 '+width+' '+height);}function setupToolTip(){var content='<div class="tooltip-content-wrapper">\n      <div class="tooltip-content">\n      <div>\n        <p class="tooltip-title"></p>\n        <p class="tooltip-number"></p>\n        <p class="tooltip-percent"></p>\n        <p class="a11y">Press enter to navigate to this school\'s page or tab to select another school.</p>\n      </div>\n      </div>\n    </div>';tooltip=new __WEBPACK_IMPORTED_MODULE_7__tooltip__["a" /* default */](content,'tooltip-arrow');main.node().appendChild(tooltip.elm);}var handleClick=function handleClick(d){if(__WEBPACK_IMPORTED_MODULE_8_d3__["event"])__WEBPACK_IMPORTED_MODULE_8_d3__["event"].stopPropagation();__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])(_defineProperty({},chartName,{selectedSchool:d,showTooltip:true})));};function calculateTotalEnrolment(){student_data.forEach(function(obj){if(obj.isActive){activeSchool=obj;}});}function calculateScaleFactor(){scaleFactor=Math.ceil(data.enrolment/(numCols*numRows));// Determine if edgecase where rounding per group causes number of icons to be
// greater than grid space available
student_data.forEach(function(obj){totalIcons+=Math.max(Math.round(obj.enrolment/scaleFactor),1);});// If edgecase adjust scale factor
if(totalIcons>numCols*numRows){scaleFactor=Math.ceil(totalIcons*scaleFactor/(numCols*numRows));}}function drawAside(){var card=void 0;if(activeSchool){card=aside.append('div').attr('class','card--highlight');card.append('p').attr('class','card-title').text(activeSchool.name);card.append('p').attr('class','big-number').text(Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["b" /* format */])(activeSchool.enrolment));}card=aside.append('div').attr('class','card--highlight-alt');card.append('p').attr('class','card-title').text(function(){if(activeSchool){return cluster+' schools group*';}return cluster+' schools group';});card.append('p').attr('class','big-number').text(Object(__WEBPACK_IMPORTED_MODULE_5__modules_helpers__["b" /* format */])(data.enrolment));if(activeSchool){aside.append('p').text('*inc. '+activeSchool.name);}}function drawPictograph(){svg.attr('class','cluster-chart');// define an icon store it in svg <defs> elements as a reusable component - this geometry can be generated from Inkscape, Illustrator or similar
var defs=svg.append('defs');defs.append('symbol').attr('viewBox','0 0 24 37').attr('id','student-icon').append('path').attr('stroke','none').attr('d','M9.14285714,32 L9.14285714,23.3846154 L7,23.3846154 L7,15.4871795 C7,13.9076923 8.28571429,12.6153846 9.85714286,12.6153846 L14.1428571,12.6153846 C15.7142857,12.6153846 17,13.9076923 17,15.4871795 L17,23.3846154 L14.8571429,23.3846154 L14.8571429,32 L9.14285714,32 Z M12,11.1794872 C13.9821429,11.1794872 15.5714286,9.58205128 15.5714286,7.58974359 C15.5714286,5.5974359 13.9821429,4 12,4 C10.0178571,4 8.42857143,5.5974359 8.42857143,7.58974359 C8.42857143,9.58205128 10.0178571,11.1794872 12,11.1794872 Z');var studentInAreaDef=defs.append('symbol').attr('viewBox','0 0 24 37').attr('id','student-in-area-icon');studentInAreaDef.append('path').attr('stroke','none').attr('d','M9.14285714,32 L9.14285714,23.3846154 L7,23.3846154 L7,15.4871795 C7,13.9076923 8.28571429,12.6153846 9.85714286,12.6153846 L14.1428571,12.6153846 C15.7142857,12.6153846 17,13.9076923 17,15.4871795 L17,23.3846154 L14.8571429,23.3846154 L14.8571429,32 L9.14285714,32 Z M12,11.1794872 C13.9821429,11.1794872 15.5714286,9.58205128 15.5714286,7.58974359 C15.5714286,5.5974359 13.9821429,4 12,4 C10.0178571,4 8.42857143,5.5974359 8.42857143,7.58974359 C8.42857143,9.58205128 10.0178571,11.1794872 12,11.1794872 Z');studentInAreaDef.append('ellipse').attr('cx',12).attr('cy',31.5).attr('rx',7).attr('ry',4).attr('fill','none').attr('stroke-width',2).attr('stroke','inherit');// create group element and create an svg <use> element for each icon
pictoGrid=svg.append('g').attr('id','pictoGrid').attr('transform','translate('+padding.left+' '+padding.top+')');// ligo (LIve and GO to) refers to the percentage of the school's students
// who actually live in that school's catchment. (Decimal, 0.0 -> 1.0)
var addSchools=function addSchools(group,range,iconName,ligoPercent){var schoolGroup=group.selectAll('.'+iconName);schoolGroup.data(range).enter().append('use').attr('class',iconName).attr('xlink:href',function(d,i){var totalIcons=range.length;var ligoIcons=Math.round(totalIcons*ligoPercent);if(i+1<=ligoIcons){// Students living inside the catchment boundary
return'#student-in-area-icon';}// Students living outside the catchment boundary
return'#student-icon';}).attr('width',xSize).attr('height',ySize).attr('id',function(d){return'icon-'+d;}).attr('x',function(d){var col=d%numCols;// calculates the x position (column number) using modulus
return col*xGutter+col*xSize;// apply the buffer and return value
}).attr('y',function(d){var whole=Math.floor(d/numCols);// calculates the y position (row number)
return whole*yGutter+whole*ySize;// apply the buffer and return the value
});// This is a bit of a hack to make the whole group focusable
schoolGroup.data(range).enter().append('rect').attr('width',xSize+xGutter).attr('height',ySize+yGutter).attr('fill','transparent').attr('id',function(d){return'icon-'+d;}).attr('x',function(d){var col=d%numCols;// calculates the x position (column number) using modulus
return col*xGutter+col*xSize;// apply the buffer and return value
}).attr('y',function(d){var whole=Math.floor(d/numCols);// calculates the y position (row number)
return whole*yGutter+whole*ySize;// apply the buffer and return the value
});return schoolGroup;};var addSchoolGroup=function addSchoolGroup(data){var groupStart=offset;var groupEnd=offset+Math.max(Math.round(data.enrolment/scaleFactor),1);var students=__WEBPACK_IMPORTED_MODULE_8_d3__["range"](groupStart,groupEnd);offset=groupEnd;var schoolGroup=pictoGrid.append('g').attr('tabindex',0).attr('id','students-'+data.uid).attr('class',function(){var classnames=[];classnames.push('school-group');if(data.isActive)classnames.push('active-group');return classnames.join(' ');}).on('click',function(){handleClick.call(this,data);}).on('keydown',function(){var e=__WEBPACK_IMPORTED_MODULE_8_d3__["event"];var keys={SPACE:32,ENTER:13};if(e.type==='click'||e.keyCode===keys.SPACE||e.keyCode===keys.ENTER){handleClick.call(this,data);}});addSchools(schoolGroup,students,'student-icon',data.ligo);// No line at start!
if(groupStart!==0){var col=groupStart%numCols;var row=Math.floor(groupStart/numCols);// If the new group starts on a new line move the
// line to the last col of the previous row
if(col===0){col=numCols;row=row-1;}var xPos=col*xGutter+col*xSize;var yPos=row*yGutter+row*ySize;schoolGroup.append('line').attr('x1',xPos-1).attr('y1',yPos+4).attr('x2',xPos-1).attr('y2',yPos+ySize).attr('stroke-width',2).attr('stroke','#333');}};// Main data loop
student_data.forEach(function(obj,i){addSchoolGroup(obj);});}function drawKey(){key=main.append('div').attr('class','pictograph-key');var container=key.append('div');var key1=container.append('div');key1.append('svg').attr('class','student-icon in-area').append('use').attr('xlink:href','#student-in-area-icon').attr('stroke','#000');key1.append('div').text(scaleFactor+' students living in their school area');var key2=container.append('div');key2.append('svg').attr('class','student-icon').append('use').attr('xlink:href','#student-icon');key2.append('div').text(scaleFactor+' students living outside their school area');}function resizeViewbox(){var totalRows=Math.ceil(totalIcons/numCols);var viewboxHeight=Math.max(totalRows*(ySize+yGutter),minHeight);svg.attr('viewBox','0 0 '+width+' '+viewboxHeight);}initialiseElements();setupToolTip();calculateScaleFactor();resizeViewbox();drawKey();key.append('div').style('padding','8px 0 0 0').style('width','100%').text('Data subject to change.*');calculateTotalEnrolment();drawAside();drawPictograph();elm.classList.add('chart');return elm;}var StudentEnrolment=function(_Component){_inherits(StudentEnrolment,_Component);function StudentEnrolment(){_classCallCheck(this,StudentEnrolment);return _possibleConstructorReturn(this,(StudentEnrolment.__proto__||Object.getPrototypeOf(StudentEnrolment)).apply(this,arguments));}_createClass(StudentEnrolment,[{key:'wrapChart',value:function wrapChart(){this.container=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);while(this.container.firstChild){this.container.removeChild(this.container.firstChild);}var data=this.props.data;var chart=makeEnrolment(data,data.name,this.props.chartName);this.container.appendChild(chart);}},{key:'componentDidMount',value:function componentDidMount(){this.wrapChart();}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(__WEBPACK_IMPORTED_MODULE_8_d3__["event"])__WEBPACK_IMPORTED_MODULE_8_d3__["event"].stopPropagation();var _props$ui=this.props.ui,selectedSchool=_props$ui.selectedSchool,showTooltip=_props$ui.showTooltip;if(showTooltip&&selectedSchool){svg.selectAll('.selected-group').classed('selected-group',false);svg.select('#students-'+selectedSchool.uid).classed('selected-group',true);tooltip.onClick(function(){if(window.parentIFrame){window.parentIFrame.sendMessage({type:'change:school',school:selectedSchool.uid});}else{window.location.search='school='+selectedSchool.uid;}});tooltip.elm.classList.add('tooltip-arrow');tooltip.elm.classList.remove('tooltip-active');if(selectedSchool.isActive){tooltip.elm.classList.remove('tooltip-arrow');tooltip.elm.classList.add('tooltip-active');}tooltip.show();// Custom Select
tooltip.elm.querySelector('.tooltip-title').innerHTML=selectedSchool.name;tooltip.elm.querySelector('.tooltip-number').innerHTML=selectedSchool.enrolment+' enrolled students';var percentText=isNaN(parseInt(selectedSchool.ligo*100,10))?'live in school area: unknown':parseInt(selectedSchool.ligo*100,10)+'% live in school area';tooltip.elm.querySelector('.tooltip-percent').innerHTML=percentText;// Custom BB
var bb=svg.select('#students-'+selectedSchool.uid).node().getBoundingClientRect();var scrollY=window.scrollY||document.documentElement.scrollTop;var top=bb.top+scrollY-tooltip.elm.clientHeight-10;var scrollX=window.scrollX||document.documentElement.scrollLeft;var left=bb.left+bb.width/2+scrollX-tooltip.elm.clientWidth/2;tooltip.move(top,left);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chart-wrapper'});}}]);return StudentEnrolment;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){return{ui:state.ui[ownProps.chartName]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectSchool:function selectSchool(p){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])(p));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(StudentEnrolment));

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ui */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(76);
var ui=function ui(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{windowWidth:window.innerWidth,isMobile:matchMedia('(max-width: 800px)').matches};var action=arguments[1];switch(action.type){case'SELECTED_SCHOOL:SET':return Object.assign({},state,action.payload);case'APP:WINDOW_RESIZE':return Object.assign({},state,{windowWidth:window.innerWidth,isMobile:matchMedia('(max-width: 800px)').matches});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({ui:ui}));

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tooltip__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_filter_data__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var tooltip=void 0;var svg=void 0;function makeClassrooms(data,cluster){// Quick helper to update the totals when changing test data
var activeSchool=void 0;// SVG dimensions
var width=1000;var height=500;var minHeight=256;var scaleFactor=void 0;var totalIcons=0;// SVG padding
var padding={top:10,right:10,bottom:50,left:10};// Horizontal and vertical spacing between the icons
var numCols=20;var numRows=9;var xGutter=15;var yGutter=15;var offset=0;// Top level elements
var elm=void 0;var aside=void 0;var main=void 0;var key=void 0;var pictoGrid=void 0;var schools_data=__WEBPACK_IMPORTED_MODULE_8__modules_filter_data__["a" /* default */].studentClassrooms(data.schools);// Final gid dimensions
var xSize=(width-(padding.left+padding.right)-xGutter*(numCols-1))/numCols;var ySize=(height-(padding.top+padding.bottom)-yGutter*(numRows-1))/numRows;function initialiseElements(){elm=document.createElement('div');aside=__WEBPACK_IMPORTED_MODULE_5_d3__["select"](elm).append('div').attr('class','aside');main=__WEBPACK_IMPORTED_MODULE_5_d3__["select"](elm).append('div').attr('class','main');svg=main.append('svg').attr('viewBox','0 0 '+width+' '+height);}function setupToolTip(){var content='<div class="tooltip-content-wrapper">\n      <div class="tooltip-content">\n      <div>\n        <p class="tooltip-title"></p>\n        <p class="tooltip-split"></p>\n        <p class="a11y">Press enter to navigate to this school\'s page or tab to select another school.</p>\n      </div>\n      </div>\n    </div>';tooltip=new __WEBPACK_IMPORTED_MODULE_6__tooltip__["a" /* default */](content,'tooltip-arrow');main.node().appendChild(tooltip.elm);}var handleClick=function handleClick(d){__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])({classrooms:{selectedSchool:d,showTooltip:true}}));};function calculateTotalClassrooms(){schools_data.forEach(function(obj){if(obj.isActive){activeSchool=obj;}});}function calculateScaleFactor(){scaleFactor=Math.ceil((data.classrooms.permanent+data.classrooms.demountable)/(numCols*numRows));// Determine if edgecase where rounding per group causes number of icons to be
// greater than grid space available
schools_data.forEach(function(obj){totalIcons+=Math.ceil(obj.classrooms.permanent/scaleFactor);totalIcons+=Math.ceil(obj.classrooms.demountable/scaleFactor);});// If edgecase adjust scale factor
if(totalIcons>numCols*numRows){scaleFactor=Math.ceil(totalIcons*scaleFactor/(numCols*numRows));}}// This is a really quick and dirty helper pluralise function, it just adds 's'
function pluralise(number,word){return number<=1?word:word+'s';}function drawAside(){var breakdown=void 0;var card=void 0;if(activeSchool){card=aside.append('div').attr('class','card--highlight');card.append('p').attr('class','card-title').text(activeSchool.name);card.append('p').attr('class','big-number').text(Object(__WEBPACK_IMPORTED_MODULE_7__modules_helpers__["b" /* format */])(activeSchool.classrooms.permanent+activeSchool.classrooms.demountable));breakdown=card.append('p').attr('class','card-breakdown');breakdown.append('span').html(Object(__WEBPACK_IMPORTED_MODULE_7__modules_helpers__["b" /* format */])(activeSchool.classrooms.permanent)+' <br>permanent');breakdown.append('span').text('+');breakdown.append('span').html(Object(__WEBPACK_IMPORTED_MODULE_7__modules_helpers__["b" /* format */])(activeSchool.classrooms.demountable)+' <br>demountable');}card=aside.append('div').attr('class','card--highlight-alt');card.append('p').attr('class','card-title').text(function(){if(activeSchool){return cluster+' schools group*';}return cluster+' schools group';});card.append('p').attr('class','big-number').text(Object(__WEBPACK_IMPORTED_MODULE_7__modules_helpers__["b" /* format */])(data.classrooms.permanent+data.classrooms.demountable));breakdown=card.append('p').attr('class','card-breakdown');breakdown.append('span').html(Object(__WEBPACK_IMPORTED_MODULE_7__modules_helpers__["b" /* format */])(data.classrooms.permanent)+' <br>permanent');breakdown.append('span').text('+');breakdown.append('span').html(Object(__WEBPACK_IMPORTED_MODULE_7__modules_helpers__["b" /* format */])(data.classrooms.demountable)+' <br>demountable');if(activeSchool){aside.append('p').text('*inc. '+activeSchool.name);}}function drawPictograph(){svg.attr('class','cluster-chart');// define an icon store it in svg <defs> elements as a reusable component - this geometry can be generated from Inkscape, Illustrator or similar
var defs=svg.append('defs');defs.append('symbol').attr('viewBox','0 0 20 20').attr('id','classroom-icon').append('polygon').attr('points','9,0 0,5 0,17 7,17 7,11 11,11 11,17 18,17 18,5');defs.append('symbol').attr('viewBox','0 0 20 20').attr('id','classroom-icon-demountable').append('path').attr('d','M9,2.3l7,3.9V15h-3v-4V9h-2H7H5v2v4H2V6.2L9,2.3 M9,0L0,5v12h7v-6h4v6h7V5L9,0L9,0z');// create group element and create an svg <use> element for each icon
pictoGrid=svg.append('g').attr('id','pictoGrid').attr('transform','translate('+padding.left+' '+padding.top+')');var addSchools=function addSchools(group,range,iconName){var schoolGroup=group.selectAll('.'+iconName);schoolGroup.data(range).enter().append('use').attr('class',iconName).attr('xlink:href','#'+iconName).attr('width',xSize).attr('height',ySize).attr('id',function(d){return'icon-'+d;}).attr('x',function(d){var col=d%numCols;// calculates the x position (column number) using modulus
return col*xGutter+col*xSize;// apply the buffer and return value
}).attr('y',function(d){var whole=Math.floor(d/numCols);// calculates the y position (row number)
return whole*yGutter+whole*ySize;// apply the buffer and return the value
});// This is a bit of a hack to make the whole group focusable
schoolGroup.data(range).enter().append('rect').attr('width',xSize+xGutter).attr('height',ySize+yGutter).attr('fill','transparent').attr('id',function(d){return'icon-'+d;}).attr('x',function(d){var col=d%numCols;// calculates the x position (column number) using modulus
return col*xGutter+col*xSize;// apply the buffer and return value
}).attr('y',function(d){var whole=Math.floor(d/numCols);// calculates the y position (row number)
return whole*yGutter+whole*ySize;// apply the buffer and return the value
});return schoolGroup;};var addSchoolGroup=function addSchoolGroup(data){var permanentStart=offset;var permanentEnd=offset+Math.ceil(data.classrooms.permanent/scaleFactor);var demountableStart=permanentEnd;var demountableEnd=permanentEnd+Math.ceil(data.classrooms.demountable/scaleFactor);var permanent=__WEBPACK_IMPORTED_MODULE_5_d3__["range"](permanentStart,permanentEnd);var demountable=__WEBPACK_IMPORTED_MODULE_5_d3__["range"](demountableStart,demountableEnd);offset=demountableEnd;var classroomGroup=pictoGrid.append('g').attr('tabindex',0).attr('id','classroom-'+data.uid).attr('class',function(){return data.isActive?'active-group class-group':'class-group';}).on('click',function(){handleClick(data);}).on('keydown',function(){var e=__WEBPACK_IMPORTED_MODULE_5_d3__["event"];var keys={SPACE:32,ENTER:13};if(e.type==='click'||e.keyCode===keys.SPACE||e.keyCode===keys.ENTER){handleClick(data);}});addSchools(classroomGroup,permanent,'classroom-icon');addSchools(classroomGroup,demountable,'classroom-icon-demountable');// No line at start!
if(permanentStart!==0){var lineMargins=ySize*0.1;var col=permanentStart%numCols;var row=Math.floor(permanentStart/numCols);// If the new group starts on a new line move the
// line to the last col of the previous row
if(col===0){col=numCols;row=row-1;}var xPos=col*xGutter+col*xSize;var yPos=row*yGutter+row*ySize;classroomGroup.append('line').attr('x1',xPos-8).attr('y1',yPos+lineMargins-3).attr('x2',xPos-8).attr('y2',yPos+ySize-lineMargins).attr('stroke-width',2).attr('stroke','#333');}};// Main data loop
schools_data.forEach(function(obj,i){addSchoolGroup(obj);});}function drawKey(){key=main.append('div').attr('class','pictograph-key');var container=key.append('div');var key1=container.append('div');key1.append('svg').attr('class','classroom-icon').append('use').attr('xlink:href','#classroom-icon');key1.append('div').text(scaleFactor+' permanent '+pluralise(scaleFactor,'classroom'));var key2=container.append('div');key2.append('svg').attr('class','classroom-icon').append('use').attr('xlink:href','#classroom-icon-demountable');key2.append('div').text(scaleFactor+' demountable '+pluralise(scaleFactor,'classroom'));}function resizeViewbox(){var totalRows=Math.ceil(totalIcons/numCols);var viewboxHeight=Math.max(totalRows*(ySize+yGutter),minHeight);svg.attr('viewBox','0 0 '+width+' '+viewboxHeight);}initialiseElements();setupToolTip();calculateScaleFactor();resizeViewbox();drawKey();key.append('div').style('padding','8px 0 0 0').style('width','100%').text('Data subject to change.*');calculateTotalClassrooms();drawAside();drawPictograph();elm.classList.add('chart');return elm;}var ClassroomTypes=function(_Component){_inherits(ClassroomTypes,_Component);function ClassroomTypes(){_classCallCheck(this,ClassroomTypes);return _possibleConstructorReturn(this,(ClassroomTypes.__proto__||Object.getPrototypeOf(ClassroomTypes)).apply(this,arguments));}_createClass(ClassroomTypes,[{key:'wrapChart',value:function wrapChart(){this.container=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);while(this.container.firstChild){this.container.removeChild(this.container.firstChild);}var data=this.props.data;var chart=makeClassrooms(data,data.name);this.container.appendChild(chart);}},{key:'componentDidMount',value:function componentDidMount(){this.wrapChart();}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(__WEBPACK_IMPORTED_MODULE_5_d3__["event"])__WEBPACK_IMPORTED_MODULE_5_d3__["event"].stopPropagation();var _props$ui=this.props.ui,selectedSchool=_props$ui.selectedSchool,showTooltip=_props$ui.showTooltip;if(showTooltip&&selectedSchool){svg.selectAll('.selected-group').classed('selected-group',false);svg.select('#classroom-'+selectedSchool.uid).classed('selected-group',true);tooltip.onClick(function(){if(window.parentIFrame){window.parentIFrame.sendMessage({type:'change:school',school:selectedSchool.uid});}else{window.location.search='school='+selectedSchool.uid;}});tooltip.elm.classList.add('tooltip-arrow');tooltip.elm.classList.remove('tooltip-active');if(selectedSchool.isActive){tooltip.elm.classList.remove('tooltip-arrow');tooltip.elm.classList.add('tooltip-active');}tooltip.show();// Custom Select
tooltip.elm.querySelector('.tooltip-title').innerHTML=selectedSchool.name;tooltip.elm.querySelector('.tooltip-split').innerHTML=selectedSchool.classrooms.permanent+' Perm / '+selectedSchool.classrooms.demountable+' Demo';// Custom BB
var bb=svg.select('#classroom-'+selectedSchool.uid).node().getBoundingClientRect();var scrollY=window.scrollY||document.documentElement.scrollTop;var top=bb.top+scrollY-tooltip.elm.clientHeight-10;var scrollX=window.scrollX||document.documentElement.scrollLeft;var left=bb.left+bb.width/2+scrollX-tooltip.elm.clientWidth/2;tooltip.move(top,left);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return ClassroomTypes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,ownProps){return{ui:state.ui[ownProps.chartName]};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectSchool:function selectSchool(p){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* selectSchool */])(p));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ClassroomTypes));

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__playspace__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classroom_space__ = __webpack_require__(155);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AvgSpaceComparison=function(_Component){_inherits(AvgSpaceComparison,_Component);function AvgSpaceComparison(){_classCallCheck(this,AvgSpaceComparison);return _possibleConstructorReturn(this,(AvgSpaceComparison.__proto__||Object.getPrototypeOf(AvgSpaceComparison)).apply(this,arguments));}_createClass(AvgSpaceComparison,[{key:'render',value:function render(){var _props=this.props,data=_props.data,chartName=_props.chartName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'playspace-classroom-comparison'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col',style:{marginRight:'4px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'mbm'},'Classroom space per student'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__classroom_space__["a" /* default */],{data:data,chartName:chartName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col',style:{marginLeft:'4px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'mbm'},'Play space per student'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__playspace__["a" /* default */],{data:data,chartName:chartName}))));}}]);return AvgSpaceComparison;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AvgSpaceComparison);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_helpers__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_get_url__ = __webpack_require__(45);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function makeSchoolsTable(data,school){var elm=document.createElement('div');var map=void 0;var mapContainer=document.createElement('div');var allSchoolsMap=document.createElement('div');mapContainer.id='all-schools-container';allSchoolsMap.id='all-schools-map';function tableRowNavigation(e){var keys={SPACE:32,ENTER:13};var iskeyPress=e.keyCode===keys.SPACE||e.keyCode===keys.ENTER;var isClick=e.type==='click';var isFocusedTouch=e.type==='touchend'&&this===document.activeElement;if(iskeyPress||isClick||isFocusedTouch){e.preventDefault();var ref=e.target!=null?e.target:e.srcElement;if(!ref)return;if(window.parentIFrame){window.parentIFrame.sendMessage({type:'navigate:to',url:this.getAttribute('href')});}else{window.location.search=this.getAttribute('href');}}else if(e.type==='touchend'){e.preventDefault();this.focus();}}var mapOptions={center:new window.google.maps.LatLng(-33.806431,151.276418),zoom:14,zoomControl:false,disableDoubleClickZoom:true,mapTypeControl:false,scaleControl:false,scrollwheel:false,panControl:true,streetViewControl:false,draggable:true,overviewMapControl:false,mapTypeId:'satellite',fullscreenControl:false};map=new window.google.maps.Map(allSchoolsMap,mapOptions);map.data.addListener('addfeature',function(e){var bounds=new window.google.maps.LatLngBounds();Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["f" /* processGeoJSON */])(e.feature.getGeometry(),bounds.extend,bounds);map.setCenter(bounds.getCenter());map.fitBounds(bounds);});if(!school){map.data.loadGeoJson('/data/clusters/'+data.uid+'.geojson');map.data.setStyle({fillColor:'rgba(225, 255, 255, 0.5)',strokeColor:'rgba(225, 255, 255, 1)'});}else{map.data.loadGeoJson('/data/schools/'+school.uid+'.geojson');map.data.setStyle({fillColor:'transpatent',strokeColor:'#05E2FC'});}var sorted_schools=data.schools.sort(function(a,b){if(a.isActive){return-1;}if(b.isActive){return 1;}if(a.enrolment>b.enrolment){return-1;}if(a.enrolment<b.enrolment){return 1;}return 0;});var table=document.createElement('table');table.classList.add('all-schools-table');table.id='summary-table';var tbody=document.createElement('tbody');var thead=document.createElement('thead');table.setAttribute('summary','A table of figures showing enrolment, classrooms and average playspace per child for all schools in the '+data.name+' schools group. '+data.name+' has '+data.enrolment+' students. Clicking table rows, will navigate to the selected schools page.');var iconStudent='<svg class="icon-school-table icon-school-table-student" viewBox="4 0 20 38" id="student-icon"><path d="M9.14285714,32 L9.14285714,23.3846154 L7,23.3846154 L7,15.4871795 C7,13.9076923 8.28571429,12.6153846 9.85714286,12.6153846 L14.1428571,12.6153846 C15.7142857,12.6153846 17,13.9076923 17,15.4871795 L17,23.3846154 L14.8571429,23.3846154 L14.8571429,32 L9.14285714,32 Z M12,11.1794872 C13.9821429,11.1794872 15.5714286,9.58205128 15.5714286,7.58974359 C15.5714286,5.5974359 13.9821429,4 12,4 C10.0178571,4 8.42857143,5.5974359 8.42857143,7.58974359 C8.42857143,9.58205128 10.0178571,11.1794872 12,11.1794872 Z"></path></svg>';var iconStudentInCircle='<svg class="icon-school-table icon-school-table-student" viewBox="4 0 20 38" id="student-icon"><path d="M9.14285714,32 L9.14285714,23.3846154 L7,23.3846154 L7,15.4871795 C7,13.9076923 8.28571429,12.6153846 9.85714286,12.6153846 L14.1428571,12.6153846 C15.7142857,12.6153846 17,13.9076923 17,15.4871795 L17,23.3846154 L14.8571429,23.3846154 L14.8571429,32 L9.14285714,32 Z M12,11.1794872 C13.9821429,11.1794872 15.5714286,9.58205128 15.5714286,7.58974359 C15.5714286,5.5974359 13.9821429,4 12,4 C10.0178571,4 8.42857143,5.5974359 8.42857143,7.58974359 C8.42857143,9.58205128 10.0178571,11.1794872 12,11.1794872 Z"></path><ellipse cx="12" cy="31.5" rx="7" ry="4" fill="none" stroke-width="2" stroke="inherit"></ellipse></svg>';var iconClassroom='<svg class="icon-school-table icon-school-table-classroom" viewBox="0 0 24 24" id="classroom-icon"><polygon points="9,0 0,5 0,17 7,17 7,11 11,11 11,17 18,17 18,5"></polygon></svg>';var iconSlice='<svg class="icon-school-table icon-school-table-playspace" viewBox="0 0 40 40"><g transform="translate(20 0)"><g transform="matrix(0.866, 0.5, -0.866, 0.5, 0, 0)"><rect class="rect" width="22.360679774997898" height="22.360679774997898"></rect><rect class="left-side" width="22.360679774997898" height="2" transform="skewX(45) rotate(180 0 0) translate(0 -24.360679774997898)"></rect><rect class="right-side" height="22.360679774997898" width="2" transform="skewY(45) rotate(0 0 22.360679774997898)  translate(22.360679774997898 -22.360679774997898)"></rect></g></g></svg>';var headerCols=[{icon:iconStudent,text:'Student<br/>enrolment'},{icon:iconStudentInCircle,text:'Live in<br/>school area'},{icon:iconClassroom,text:'Classrooms total<br/>(demountables)'},{icon:iconSlice,text:'Play space per<br/>student (m&sup2)'}];var tableHeadTr=document.createElement('tr');var a11yth=document.createElement('th');a11yth.innerHTML='<div class="all-schools-table-header a11y">School name</div>';tableHeadTr.appendChild(a11yth);headerCols.forEach(function(hcol){var el=document.createElement('th');el.innerHTML='<div class="all-schools-table-header">'+hcol.icon+'<div>'+hcol.text+'</div></div>';tableHeadTr.appendChild(el);});var allyth2=document.createElement('th');allyth2.innerHTML='<div class="all-schools-table-header a11y">Navigate to school</div>';tableHeadTr.appendChild(allyth2);thead.appendChild(tableHeadTr);sorted_schools.forEach(function(d,i){var tr=document.createElement('tr');var url=Object(__WEBPACK_IMPORTED_MODULE_4__modules_get_url__["a" /* default */])(d);tr.setAttribute('role','link');tr.setAttribute('href',url);tr.setAttribute('tabIndex','0');tr.addEventListener('mouseenter',function(e){var lastFocused=this.parentNode.querySelector('.is-focused');if(lastFocused)lastFocused.classList.remove('is-focused');tr.addEventListener('click',tableRowNavigation,false);tr.focus();},false);tr.addEventListener('mouseleave',function(e){tr.removeEventListener('click',tableRowNavigation,false);},false);tr.addEventListener('touchend',tableRowNavigation,false);tr.addEventListener('keydown',tableRowNavigation,false);if(d.isActive){tr.classList.add('is-selected');}var gotoTd=document.createElement('td');gotoTd.className='col-name';gotoTd.innerHTML='<span class="go-to">Go to </span>'+d.name;tr.appendChild(gotoTd);var enrolmentTd=document.createElement('td');enrolmentTd.className='col-enrolment';enrolmentTd.innerHTML=''+Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["b" /* format */])(d.enrolment);tr.appendChild(enrolmentTd);var ligoTd=document.createElement('td');ligoTd.className='col-ligo';ligoTd.innerHTML=isNaN(d.ligo)?'(unknown)':Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["b" /* format */])(d.ligo*100,0)+'%';tr.appendChild(ligoTd);var classroomTd=document.createElement('td');classroomTd.className='col-classrooms';classroomTd.innerHTML=Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["b" /* format */])(d.classrooms.permanent+d.classrooms.demountable)+'<span>('+Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["b" /* format */])(d.classrooms.demountable)+')</span>';tr.appendChild(classroomTd);var playspaceTd=document.createElement('td');playspaceTd.className='col-space';playspaceTd.innerHTML=''+Object(__WEBPACK_IMPORTED_MODULE_2__modules_helpers__["b" /* format */])(d.playspace,2);tr.appendChild(playspaceTd);var chevron=document.createElement('td');chevron.className='col-link';chevron.innerHTML='<div class="col-link-icon-container"><img src="img/chevron-right.svg" alt="" /></div>';tr.appendChild(chevron);tbody.appendChild(tr);});table.appendChild(thead);table.appendChild(tbody);mapContainer.appendChild(allSchoolsMap);elm.appendChild(mapContainer);elm.appendChild(table);__WEBPACK_IMPORTED_MODULE_3_d3__["select"](elm).append('div').style('margin-top','11px').style('font-size','11px').text('Data subject to change.*');return{el:elm,map:map};}var AllSchoolsTable=function(_Component){_inherits(AllSchoolsTable,_Component);function AllSchoolsTable(){_classCallCheck(this,AllSchoolsTable);return _possibleConstructorReturn(this,(AllSchoolsTable.__proto__||Object.getPrototypeOf(AllSchoolsTable)).apply(this,arguments));}_createClass(AllSchoolsTable,[{key:'wrapChart',value:function wrapChart(){this.container=Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);while(this.container.firstChild){this.container.removeChild(this.container.firstChild);}var _props=this.props,data=_props.data,school=_props.school;var chart=makeSchoolsTable(data,school);this.container.appendChild(chart.el);}},{key:'componentDidMount',value:function componentDidMount(){this.wrapChart();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.wrapChart();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return AllSchoolsTable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AllSchoolsTable);

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports=function throttle(callback,limit){var wait=false;return function(){if(!wait){callback.apply(null,arguments);wait=true;setTimeout(function(){callback.apply(null,arguments);wait=false;},limit);}};};

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrevNext=function(_Component){_inherits(PrevNext,_Component);function PrevNext(props){_classCallCheck(this,PrevNext);var _this=_possibleConstructorReturn(this,(PrevNext.__proto__||Object.getPrototypeOf(PrevNext)).call(this,props));_this.chart=props.chart;_this.schools=props.schools;_this.state={selected:null};return _this;}_createClass(PrevNext,[{key:'next',value:function next(e){if(e)e.stopPropagation();var selectedIndex=0;if(this.state.selected===null){selectedIndex=0;}else{selectedIndex=this.state.selected+1<this.schools.length?this.state.selected+1:0;}this.setState({selected:selectedIndex});this.select(selectedIndex);}},{key:'prev',value:function prev(e){if(e)e.stopPropagation();var selectedIndex=0;if(this.state.selected===null){selectedIndex=this.schools.length-1;}else{selectedIndex=this.state.selected-1>=0?this.state.selected-1:this.schools.length-1;}this.setState({selected:selectedIndex});this.select(selectedIndex);}},{key:'select',value:function select(selectedIndex){this.props.selectSchool(_defineProperty({},this.chart,{selectedSchool:this.schools[selectedIndex],showTooltip:true}));}},{key:'render',value:function render(){var selectedSchool=this.props.selectedSchool;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prev-next'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{dialogCall:'select previous school',onClick:this.prev.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'a11y'},'highlight previous school'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'chev-left',alt:'',src:'/img/chevron-left-blue.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'highlight-school'},selectedSchool?selectedSchool.name:'Highlight school'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{dialogCall:'select next school',onClick:this.next.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'a11y'},'highlight next school'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'chev-right',alt:'',src:'/img/chevron-right-blue.svg'})));}}]);return PrevNext;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state,props){return{selectedSchool:state.ui[props.chart]?state.ui[props.chart].selectedSchool:null};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectSchool:function selectSchool(p){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* selectSchool */])(p));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(PrevNext));

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/bundle.7cb1f0e8.js